/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ 5787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isPrototypeOf = __webpack_require__(7976);

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ 4019:
/***/ (function(module) {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(4019);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var hasOwn = __webpack_require__(2597);
var classof = __webpack_require__(648);
var tryToString = __webpack_require__(6330);
var createNonEnumerableProperty = __webpack_require__(8880);
var redefine = __webpack_require__(1320);
var defineProperty = (__webpack_require__(3070).f);
var isPrototypeOf = __webpack_require__(7976);
var getPrototypeOf = __webpack_require__(9518);
var setPrototypeOf = __webpack_require__(7674);
var wellKnownSymbol = __webpack_require__(5112);
var uid = __webpack_require__(9711);

var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 7741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string') {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 3678:
/***/ (function(module) {

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ 8113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var redefine = __webpack_require__(1320);
var setGlobal = __webpack_require__(3505);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 2104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(9662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 9587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(8536);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 614:
/***/ (function(module) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 8536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);
var inspectSource = __webpack_require__(2788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 6277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(1340);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var global = __webpack_require__(7854);
var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 9518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var toObject = __webpack_require__(7908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 7674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__(1702);
var anObject = __webpack_require__(9670);
var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 1320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var createNonEnumerableProperty = __webpack_require__(8880);
var setGlobal = __webpack_require__(3505);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 3505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var setGlobal = __webpack_require__(3505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.21.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var requireObjectCoercible = __webpack_require__(4488);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 4590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var toPositiveInteger = __webpack_require__(3002);

var RangeError = global.RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 3002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var toIntegerOrInfinity = __webpack_require__(9303);

var RangeError = global.RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var classof = __webpack_require__(648);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 6330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(133);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 9191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var createNonEnumerableProperty = __webpack_require__(8880);
var isPrototypeOf = __webpack_require__(7976);
var setPrototypeOf = __webpack_require__(7674);
var copyConstructorProperties = __webpack_require__(9920);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var installErrorCause = __webpack_require__(8340);
var clearErrorStack = __webpack_require__(7741);
var ERROR_STACK_INSTALLABLE = __webpack_require__(2914);
var IS_PURE = __webpack_require__(1913);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 1703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var wrapErrorConstructorWithCause = __webpack_require__(9191);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 3462:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var ArrayBufferViewCore = __webpack_require__(260);
var lengthOfArrayLike = __webpack_require__(6244);
var toOffset = __webpack_require__(4590);
var toIndexedObject = __webpack_require__(7908);
var fails = __webpack_require__(7293);

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ 2801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var createPropertyDescriptor = __webpack_require__(9114);
var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var anInstance = __webpack_require__(5787);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var DOMExceptionConstants = __webpack_require__(3678);
var clearErrorStack = __webpack_require__(7741);
var IS_PURE = __webpack_require__(1913);

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);
var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ 5334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-icon-wrapper[data-v-11fa9137]{position:relative;cursor:pointer;display:flex;align-items:center}.cart-icon-wrapper:hover>svg[data-v-11fa9137]{opacity:.6}.cart-icon-wrapper>svg[data-v-11fa9137]{transition:opacity .1s ease-in-out}.cart-icon-wrapper__badge[data-v-11fa9137]{position:absolute;left:12px;top:-6px;min-width:22px;height:22px;padding:3px 4px;background-color:#eb8989;border-radius:48px;color:#fff;font-size:14px;font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700;line-height:16px;display:flex;align-items:center;justify-content:center}@media(max-width:600px){.cart-icon-wrapper[data-v-11fa9137]{margin-right:8px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-search[data-v-52e0e9c6]{height:40px;max-height:40px;border:1px solid #62646a;background-color:#f4f4f4;display:flex;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;border-radius:34px;padding:0 8px;flex:0 1 944px;transition:all .24s ease-in-out}.the-header-search input[data-v-52e0e9c6]{flex:1 0 auto;height:calc(100% - 2px);padding:4px 8px;background:inherit;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-size:15px!important;line-height:18px!important;font-weight:400!important;border:none;font:inherit;border-radius:inherit}.the-header-search input[data-v-52e0e9c6]:focus{outline-width:0}.the-header-search input[data-v-52e0e9c6]:focus::-moz-placeholder{color:transparent}.the-header-search input[data-v-52e0e9c6]:focus::placeholder{color:transparent}.the-header-search__icon[data-v-52e0e9c6]{flex:0 1 24px;display:flex;align-items:center;justify-content:center;border-radius:50%;height:24px;width:24px;transition:all .14s ease-in-out}.the-header-search__icon--black[data-v-52e0e9c6]{background-color:#000}.the-header-search__icon--clear[data-v-52e0e9c6]{cursor:pointer;margin-right:8px}.the-header-search--focused[data-v-52e0e9c6]{background-color:#fff;border-color:#222325}@media(min-width:600px)and (max-width:960px){.the-header-search[data-v-52e0e9c6]{flex-basis:240px;margin-left:auto}}.ais-InstantSearch[data-v-52e0e9c6]{flex:0 1 944px}@media(min-width:600px)and (max-width:960px){.ais-InstantSearch[data-v-52e0e9c6]{flex-basis:240px;margin-left:auto}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_1_node_modules_vue_vue_loader_v15_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_3_styles_reset_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5163);
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_1_node_modules_vue_vue_loader_v15_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_22_0_rules_0_use_3_styles_reset_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-tooltip{z-index:calc(var(--header-z-index) + 1)!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cg-header[data-v-46832b98]{max-width:100%;top:0;left:0;right:0;z-index:var(--header-z-index);position:sticky;transition:transform .2s cubic-bezier(.4,0,.2,1),left .2s cubic-bezier(.4,0,.2,1),right .2s cubic-bezier(.4,0,.2,1),max-width .25s cubic-bezier(.4,0,.2,1),width .25s cubic-bezier(.4,0,.2,1)}.cg-header--is-fixed[data-v-46832b98]{position:fixed;height:0}.cg-header>header[data-v-46832b98]{flex:1 1 auto;width:100%;margin-inline:auto;background-color:#fff;transform:translateY(0);border-bottom:1px solid #dbdbdb;transition:transform .2s cubic-bezier(.4,0,.2,1)}.cg-header>header.header--is-hidden[data-v-46832b98]{transform:translateY(var(--header-height,-188px))}.cg-header>header.header--is-hidden[data-v-46832b98] .menu-dropdown__content{visibility:hidden!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-free-trail-alert[data-v-02fb0f56]{padding:12px 0;width:100%;background-color:#e5dfff}.header-free-trail-alert__content[data-v-02fb0f56]{margin-inline:auto;width:-moz-fit-content;width:fit-content;color:#222325}.header-free-trail-alert__content[data-v-02fb0f56],.header-free-trail-alert__link[data-v-02fb0f56]{font-family:Lato,Lato-Bold,sans-serif;font-weight:700;font-size:15px;line-height:normal;font-style:normal}.header-free-trail-alert__link[data-v-02fb0f56]{color:#222325!important;text-decoration:underline!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-info[data-v-489e83c8]{gap:20px;padding:16px 64px;margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;background-color:#222325;color:#fff}.the-header-info__message[data-v-489e83c8]{color:#fff;flex:1 1 auto;flex-wrap:wrap;display:flex;gap:8px;line-height:18px;font-family:Lato-Regular,Lato Regular,Lato,sans-serif;font-weight:400;align-items:center;font-size:15px}.the-header-info__message>span[data-v-489e83c8]{font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;color:inherit}.the-header-info__message>span[data-v-489e83c8]>b,.the-header-info__message>span[data-v-489e83c8]>strong{font-family:Lato-Bold,Lato Bold,Lato,sans-serif;font-size:inherit;color:inherit;line-height:inherit;font-weight:700}.the-header-info__message>span[data-v-489e83c8]>a{font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;text-decoration:underline!important;color:#fff!important}.the-header-info__message .message-dismiss[data-v-489e83c8]{cursor:pointer;text-decoration:underline}.the-header-info__cta-button[data-v-489e83c8]{padding:8px 24px;display:flex;flex:0 1 auto;white-space:nowrap;align-items:center;justify-content:center;background-color:#69cd99;color:#fff!important;border-radius:26px;text-decoration:none;font-family:Lat-Regular,Lato Regular,Lato,sans-serif;font-size:16px;font-style:normal;font-weight:500;line-height:20px;transition:background-color .16s ease-in-out}.the-header-info__cta-button[data-v-489e83c8]:hover{background-color:#219358}@media(min-width:600px)and (max-width:960px){.the-header-info[data-v-489e83c8]{padding:12px 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-menus[data-v-32e54ce2]{padding:0 64px;display:flex;gap:30px}.the-header-menus__content[data-v-32e54ce2]{display:flex;gap:24px;flex-wrap:wrap;max-height:50px}@media(min-width:600px)and (max-width:960px){.the-header-menus[data-v-32e54ce2]{padding:12px 24px;gap:16px;align-items:center;display:block}.the-header-menus__content[data-v-32e54ce2]{gap:16px;max-height:60px;overflow:hidden;max-height:135px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation[data-v-1dd687dc]{position:absolute;height:calc(100vh - 59px);width:100vw;z-index:90;top:59px;left:0;background-color:#fff;box-shadow:6px 6px 12px rgba(0,0,0,.1);padding:20px 0;overflow-y:auto}.header-mobile-navigation>.header-mobile-navigation__button[data-v-1dd687dc]:nth-child(n+3){border-top:none}.header-mobile-navigation__search-wrapper[data-v-1dd687dc]{padding:0 14px 18px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation__button[data-v-25237f92]{background:#fff;padding:16px 20px;display:flex;justify-content:space-between;align-items:center;border-top:1px solid #d3d2d2;border-bottom:1px solid #d3d2d2}.header-mobile-navigation__button .button__content[data-v-25237f92]{color:#222325;font-size:15px;line-height:23px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;display:flex;align-items:center;gap:10px}.header-mobile-navigation__button .button__icon[data-v-25237f92]{display:flex}.header-mobile-navigation__button .button__icon--left svg[data-v-25237f92]{transform:rotate(90deg)}.header-mobile-navigation__button .button__icon--right[data-v-25237f92]{min-width:11px}.header-mobile-navigation__button .button__icon--right svg[data-v-25237f92]{transform:rotate(-90deg)}.header-mobile-navigation__button--active>.button__content[data-v-25237f92]{font-family:Lato-Bold,Lato Bold,Lato,sans-serif!important;font-weight:700}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation__panel[data-v-285936be]{position:absolute;height:100vh;width:100vw;z-index:100;top:0;left:0;background-color:#fff;box-shadow:6px 0 12px rgba(0,0,0,.1);overflow-y:hidden}.panel__content[data-v-285936be]{height:calc(100vh - 57px);overflow-y:auto;overscroll-behavior:contain}@supports(height:100dvh){.panel__content[data-v-285936be]{height:calc(100dvh - 57px)}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-search-algolia-content[data-v-7d3ee84b]{background:#fff;color:#000;width:100%;display:flex;min-width:702px;max-width:var(--width);border:1px solid #e4e4e4;box-shadow:0 2px 10px rgba(0,0,0,.08)}.the-header-search-algolia-content__products[data-v-7d3ee84b]{padding:24px;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;width:100%;row-gap:24px;-moz-column-gap:12px;column-gap:12px;background-color:#fff}.the-header-search-algolia-content__suggestions[data-v-7d3ee84b]{padding:24px 20px;display:flex;min-width:180px;background-color:#f4f4f4}.the-header-search-algolia-content__all-results[data-v-7d3ee84b]{font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400;color:#000;font-size:14px;line-height:17px;margin-top:auto;width:100%}.the-header-search-algolia-content__all-results a[data-v-7d3ee84b]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700!important;color:#42b77a!important;text-decoration:none}@media(max-width:960px){.the-header-search-algolia-content[data-v-7d3ee84b]{min-width:var(--width)}.the-header-search-algolia-content__products[data-v-7d3ee84b]{padding:18px 12px}.the-header-search-algolia-content__suggestions[data-v-7d3ee84b]{display:none}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".algolia-suggestions[data-v-77c670a9]{display:flex;flex-direction:column;gap:24px}.algolia-suggestions__title[data-v-77c670a9]{font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700;font-size:12px;color:#979797;text-transform:uppercase}.algolia-suggestions__hint[data-v-77c670a9]{font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400;font-size:14px;color:#000;cursor:pointer}.algolia-suggestions .ais-Hits[data-v-77c670a9]{display:flex;flex-direction:column;gap:8px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".algolia-product[data-v-55ae8088]{width:230px;border-bottom:1px solid #d8d8d8;display:flex}.algolia-product>a[data-v-55ae8088]{text-decoration:none;width:100%;color:#000;font-size:14px;line-height:17px;font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400;display:flex;flex-direction:column;gap:8px}.algolia-product>a>img[data-v-55ae8088]{-o-object-fit:contain;object-fit:contain;width:auto;height:180px}.algolia-product>a>.algolia-product__info[data-v-55ae8088]{display:flex;flex-direction:column;height:100%;gap:8px}.algolia-product>a>.algolia-product__info>.algolia-product__price[data-v-55ae8088]{display:flex;width:100%;margin-top:auto;padding-bottom:8px;gap:8px;justify-content:space-between;font-family:Lato-Regular,Lato Regular,sans-serif;color:#979797;line-height:17px;font-size:14px}.algolia-product>a>.algolia-product__info>.algolia-product__price>span[data-v-55ae8088]:nth-child(2){font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700;color:#000}@media(max-width:960px){.algolia-product[data-v-55ae8088]{width:100%;min-height:98px}.algolia-product>a[data-v-55ae8088]{flex-direction:row}.algolia-product>a>img[data-v-55ae8088]{height:90px;width:90px}.algolia-product>a>.algolia-product__info>.algolia-product__price[data-v-55ae8088]{flex-direction:column}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-user-area[data-v-e443521a]{flex:1 1 auto;display:flex;justify-content:space-between;align-items:center;gap:50px;padding:15px 64px}.the-header-user-area span[data-v-e443521a]{display:flex}@media(min-width:600px)and (max-width:960px){.the-header-user-area[data-v-e443521a]{padding:12px 24px}}@media(max-width:600px){.the-header-user-area[data-v-e443521a]{padding:8px 16px}.the-header-user-area__phone-icons-area[data-v-e443521a]{gap:20px;display:flex;align-items:flex-end}.the-header-user-area__phone-icons-area>a[data-v-e443521a]{display:flex;font-family:inherit}}.icon-wrapper[data-v-e443521a]{display:flex;margin-right:40px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-user-area__tooltip{max-width:200px;position:relative;background-color:#222325;box-shadow:0 0 30px rgba(0,0,0,.15);border-radius:4px;padding:6px 10px;font-size:13px;line-height:16px;font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400;color:#fff;z-index:calc(var(--header-z-index) + 1)!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-user-area__menus[data-v-76769543]{display:flex;align-items:center;gap:32px}.the-header-user-area__menus .icon-wrapper[data-v-76769543]{position:relative;cursor:pointer;display:flex;align-items:center}.the-header-user-area__menus .icon-wrapper:hover>svg[data-v-76769543]{opacity:.6}.the-header-user-area__menus .icon-wrapper>svg[data-v-76769543]{transition:opacity .1s ease-in-out}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-user-info[data-v-aca20a9a]{display:flex;align-items:center;white-space:nowrap;gap:8px;cursor:pointer}.the-user-info__user-name-first-letter[data-v-aca20a9a]{display:flex;justify-content:center;align-items:center;background-color:var(--background-color);border-radius:50%;width:30px;height:30px;color:#fff;font-size:16px;font-weight:700;font-family:Lato-Bold,Lato Bold,sans-serif;line-height:18px}.the-user-info__button-wrapper[data-v-aca20a9a]{display:flex;align-items:center;white-space:nowrap;gap:8px;cursor:pointer;transition:opacity .1s ease-in-out}.the-user-info__button-wrapper[data-v-aca20a9a]:hover{opacity:.6}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trigger{display:flex!important;align-items:center;white-space:nowrap;gap:8px;cursor:pointer}.tooltip{z-index:calc(var(--header-z-index) + 1)!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-user-area__logos[data-v-26a9ad10]{display:flex}.the-header-user-area__logos .logos__divider[data-v-26a9ad10]{width:1px;height:inherit;min-height:100%;max-height:100%;background:#a7a9ac;margin:0 28px}.the-header-user-area__logos .logos__logo[data-v-26a9ad10]{max-width:200px;max-height:36px;min-height:15px;-o-object-fit:contain;object-fit:contain}.the-header-user-area__logos .logos__external-logo[data-v-26a9ad10]{max-height:40px;-o-object-fit:contain;object-fit:contain;max-width:300px}@media(max-width:430px){.the-header-user-area__logos .logos__external-logo[data-v-26a9ad10]{max-width:160px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".desktop-user-menu[data-v-a60cb1f0]{background-color:#fff;box-shadow:0 0 30px rgba(0,0,0,.15);padding:20px 30px;margin-top:10px;min-width:260px;display:flex;flex-direction:column;justify-content:center;align-items:flex-start}.desktop-user-menu__user-name[data-v-a60cb1f0]{color:#000;font-size:18px;font-weight:700;font-family:Lato-Bold,Lato Bold,sans-serif!important;line-height:28px;white-space:nowrap}.desktop-user-menu__profile-link[data-v-a60cb1f0]{color:#42b77a;font-size:14px;line-height:18px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;padding-bottom:12px}.desktop-user-menu__profile-link>a[data-v-a60cb1f0]{color:inherit!important;text-decoration:none!important;font-family:inherit;cursor:pointer}.desktop-user-menu__links[data-v-a60cb1f0]{width:100%;-moz-columns:1 auto;columns:1 auto}.desktop-user-menu ul[data-v-a60cb1f0]{list-style:none;margin:0;border-top:1px solid #d3d2d2;width:100%;padding:20px 0}.desktop-user-menu ul[data-v-a60cb1f0]:last-child{padding-bottom:0}.desktop-user-menu ul li[data-v-a60cb1f0]{display:flex;align-items:center;gap:8px;color:#222325;font-size:14px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;line-height:38px}.desktop-user-menu ul li:hover>a[data-v-a60cb1f0]{opacity:.6}.desktop-user-menu ul li>a[data-v-a60cb1f0]{color:inherit!important;text-decoration:none!important;transition:opacity .1s ease-in-out;font-family:inherit;display:flex;align-items:center;cursor:pointer;gap:8px;flex:1 1 100%}.desktop-user-menu ul li>a[disabled][data-v-a60cb1f0]{cursor:default;color:#95979d!important;pointer-events:none;flex:0 1 auto;opacity:1}@media(max-width:600px){.desktop-user-menu[data-v-a60cb1f0]{margin-top:0;box-shadow:none;padding:20px}}@media(min-width:600px)and (max-height:960px){.desktop-user-menu__links[data-v-a60cb1f0]{-moz-columns:2 auto;columns:2 auto;-moz-column-gap:80px;column-gap:80px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".desktop-user-menu-tooltip__activator{cursor:pointer;color:#95979d}.desktop-user-menu-tooltip__content{max-width:200px;position:relative;background-color:#222325;box-shadow:0 0 30px rgba(0,0,0,.15);padding:15px;color:#f4f4f4;font-size:14px;line-height:17px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;opacity:1!important}.desktop-user-menu-tooltip__content>.tooltip-arrow{width:10px;height:10px;position:absolute;transform:rotate(45deg);background-color:#222325;bottom:-5px}.desktop-user-menu-tooltip__content>.tooltip-inner{max-width:unset!important;padding:unset!important;text-align:unset!important;border-radius:unset!important;color:unset!important;background-color:unset!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel[data-v-0b9f4ff8]{position:fixed;height:100vh;max-width:500px;width:100vw;z-index:101;top:0;right:0;background-color:#fff;box-shadow:6px 0 12px rgba(0,0,0,.8);overflow-y:hidden;cursor:default;transition:max-width .25s cubic-bezier(.4,0,.2,1),width .25s cubic-bezier(.4,0,.2,1)}.the-cart-panel--expanded[data-v-0b9f4ff8]{max-width:1000px}.the-cart-panel__title[data-v-0b9f4ff8]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700;font-size:18px;line-height:22px;color:#000;padding:40px 0 28px;margin:0 48px;display:flex;justify-content:space-between;border-bottom:1px solid #e4e4e4}.the-cart-panel__title .title__wrapper[data-v-0b9f4ff8]{display:flex;gap:8px;align-items:center}.the-cart-panel__title .title__wrapper--badge[data-v-0b9f4ff8]{font-size:14px;line-height:16px;background:#42b77a;border-radius:40px;height:24px;padding:4px 8px;color:#fff}.the-cart-panel__title--icon[data-v-0b9f4ff8]{cursor:pointer;display:flex}.the-cart-panel__content[data-v-0b9f4ff8]{display:flex;flex-direction:row;flex-grow:1;height:100%;width:100%}.the-cart-panel__content-item[data-v-0b9f4ff8]{max-width:500px;width:100vw;height:100%}.the-cart-panel__products[data-v-0b9f4ff8]{overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;display:flex;flex-direction:column;height:calc(100vh - 245px);max-height:calc(100vh - 245px)}.the-cart-panel__products[data-v-0b9f4ff8]::-webkit-scrollbar{width:12px}.the-cart-panel__products[data-v-0b9f4ff8]::-webkit-scrollbar-track{background-color:transparent}.the-cart-panel__products[data-v-0b9f4ff8]::-webkit-scrollbar-thumb{border:4px solid transparent;background-clip:padding-box;border-radius:14px;background-color:#c4c4c4}.the-cart-panel__products--empty[data-v-0b9f4ff8]{display:flex;height:100%;align-items:center;justify-content:center;flex-direction:column;gap:26px;font-family:Lato-Italic,Lato Italic,sans-serif!important;font-size:15px;line-height:18px;color:#95979d;font-weight:400;margin:0 48px}@media(max-width:600px){.the-cart-panel[data-v-0b9f4ff8]{max-width:500px!important}.the-cart-panel__title[data-v-0b9f4ff8]{padding:20px 0 28px;margin:0 24px}.the-cart-panel__products[data-v-0b9f4ff8]{height:calc(100vh - 225px);max-height:calc(100vh - 225px)}.the-cart-panel__content-item[data-v-0b9f4ff8]:nth-child(2){position:absolute;top:0;left:0}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel-actions[data-v-6a177ce2]{display:flex;flex-direction:column;gap:20px;background:#fff;padding:28px 48px}.the-cart-panel-actions__est-cost[data-v-6a177ce2]{display:flex;justify-content:space-between;align-items:center}.the-cart-panel-actions__est-cost--total[data-v-6a177ce2]{font-size:27px!important;line-height:32px!important}.the-cart-panel-actions__buttons[data-v-6a177ce2]{display:flex;justify-content:space-between;gap:12px}.the-cart-panel-actions__buttons>button[data-v-6a177ce2]{background:none;text-transform:uppercase;display:flex;flex:1 0 calc(48% - 6px);padding:10px 18px;justify-content:center;align-items:center;gap:8px;border:2px solid #000;background:#000;color:#fff;font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700;font-size:15px;line-height:18px;cursor:pointer}.the-cart-panel-actions__buttons>button.outlined[data-v-6a177ce2]{color:#000;background:#fff}.the-cart-panel-actions__buttons>button[data-v-6a177ce2]:not(.outlined):hover{background:#919191!important;border-color:#919191!important}.the-cart-panel-actions__buttons>button[data-v-6a177ce2]:is(.outlined):hover{color:#919191!important;border-color:#919191!important}.the-cart-panel-actions--elevation[data-v-6a177ce2]{box-shadow:0 0 30px rgba(0,0,0,.15)}.the-cart-panel-actions .price[data-v-6a177ce2],.the-cart-panel-actions b[data-v-6a177ce2]{color:#000;font-size:15px;line-height:18px}.the-cart-panel-actions .price b[data-v-6a177ce2],.the-cart-panel-actions .price--bold[data-v-6a177ce2],.the-cart-panel-actions b b[data-v-6a177ce2],.the-cart-panel-actions b--bold[data-v-6a177ce2]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700}.the-cart-panel-actions .price--normal[data-v-6a177ce2],.the-cart-panel-actions b--normal[data-v-6a177ce2]{font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400}@media(max-width:600px){.the-cart-panel-actions[data-v-6a177ce2]{padding:28px 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel-customization[data-v-050440f3]{background:#fafafa;height:100%;max-width:452px}.the-cart-panel-customization__actions[data-v-050440f3]{padding:20px 28px;display:flex;justify-content:space-between}.the-cart-panel-customization__actions>a[data-v-050440f3]{color:#42b77a!important;font-size:15px;line-height:18px;font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400;cursor:pointer;text-decoration:none!important}.the-cart-panel-customization__title[data-v-050440f3]{margin:0 28px;padding-bottom:20px;border-bottom:1px solid #e4e4e4;font-size:18px;line-height:22px;color:#000;font-family:Lato-Regular,Lato Regular,sans-serif;font-weight:400}.the-cart-panel-customization__title>b[data-v-050440f3]{font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700}.the-cart-panel-customization__content[data-v-050440f3]{display:flex;flex-direction:column;height:calc(100% - 216px);overflow-y:auto;overscroll-behavior:contain}.the-cart-panel-customization__content[data-v-050440f3]::-webkit-scrollbar{width:12px}.the-cart-panel-customization__content[data-v-050440f3]::-webkit-scrollbar-track{background-color:transparent}.the-cart-panel-customization__content[data-v-050440f3]::-webkit-scrollbar-thumb{border:4px solid transparent;background-clip:padding-box;border-radius:14px;background-color:#c4c4c4}@media(max-width:600px){.the-cart-panel-customization[data-v-050440f3]{background:#fff}.the-cart-panel-customization__content[data-v-050440f3]{height:calc(100% - 123px)}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel-customization-item[data-v-c6fdacee]{display:flex;flex-direction:row;flex-wrap:nowrap;gap:12px;padding:24px 0;margin:0 28px;border-bottom:1px solid #e4e4e4}.the-cart-panel-customization-item__images[data-v-c6fdacee]{display:flex;flex-direction:row;flex-wrap:wrap;gap:8px;max-width:188px}.the-cart-panel-customization-item__images>embed[data-v-c6fdacee],.the-cart-panel-customization-item__images>img[data-v-c6fdacee]{width:90px;height:90px;max-width:90px;max-height:90px;-o-object-fit:contain;object-fit:contain}.the-cart-panel-customization-item__info[data-v-c6fdacee]{display:flex;flex-direction:column;gap:8px;flex-grow:1;color:#000;word-break:break-word;font-size:15px;line-height:20px;flex-basis:96px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400}.the-cart-panel-customization-item__info--subtext[data-v-c6fdacee]{font-size:14px;line-height:17px;color:#979797}.the-cart-panel-customization-item__price[data-v-c6fdacee]{display:flex;justify-content:flex-end;align-items:flex-end;flex-shrink:1;margin-left:auto;color:#000;font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700;font-size:15px;line-height:18px}@media(max-width:600px){.the-cart-panel-customization-item[data-v-c6fdacee]{margin:0 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel-item[data-v-c98208f0]{padding:24px 0;margin:0 48px;display:flex;gap:14px;border-bottom:1px solid #e4e4e4;position:relative}.the-cart-panel-item--show-arrow[data-v-c98208f0]:after{content:\"\";position:absolute;right:-58px;top:50%;transform:rotate(45deg);z-index:500;background:#fafafa;height:20px;width:20px;border:1px solid hsla(0,0%,89%,.3)}.the-cart-panel-item__image[data-v-c98208f0]{display:flex;flex-direction:column;justify-content:space-between;gap:8px}.the-cart-panel-item__image>a[data-v-c98208f0]{color:#42b77a!important;font-size:15px;line-height:18px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;cursor:pointer;text-decoration:none!important}.the-cart-panel-item__image>a>img[data-v-c98208f0]{width:90px;height:90px;max-width:90px;max-height:90px;z-index:-1;-o-object-fit:contain;object-fit:contain}.the-cart-panel-item__content[data-v-c98208f0]{flex-grow:1;width:100%;flex-direction:column}.the-cart-panel-item__content[data-v-c98208f0],.the-cart-panel-item__content>.content__title[data-v-c98208f0]{display:flex;gap:8px;justify-content:space-between}.the-cart-panel-item__content>.content__title>h5>a[data-v-c98208f0]{color:#000;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;font-size:15px;line-height:20px;text-decoration:none}.the-cart-panel-item__content>.content__title>h5>a[href][data-v-c98208f0]{cursor:pointer}.the-cart-panel-item__content>.content__title>div[data-v-c98208f0]{display:flex;align-content:center;cursor:pointer}.the-cart-panel-item__content>.content__attributes[data-v-c98208f0]{display:flex;flex-direction:column;gap:8px}.the-cart-panel-item__content>.content__attributes>span[data-v-c98208f0]{color:#979797;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;font-size:14px;line-height:17px;word-break:break-all}.the-cart-panel-item__content>.content__actions[data-v-c98208f0]{display:flex;align-items:center;justify-content:space-between}.the-cart-panel-item__content>.content__actions>.input-wrapper[data-v-c98208f0]{display:flex;width:104px;min-height:30px;border-radius:19px;border:1px solid #d8d8d8;padding:4px 0}.the-cart-panel-item__content>.content__actions>.input-wrapper>button[data-v-c98208f0]{display:flex;flex:1 0 auto;color:#000;align-items:center;justify-content:center;background:inherit;border:none;cursor:pointer;padding:0 4px}.the-cart-panel-item__content>.content__actions>.input-wrapper>button[disabled][data-v-c98208f0]{color:#d3d2d2!important;cursor:default}.the-cart-panel-item__content>.content__actions>.input-wrapper>input[data-v-c98208f0]{border:none;font:inherit;flex:1 0 auto;max-width:60px;text-align:center;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;font-size:15px;line-height:20px}.the-cart-panel-item__content>.content__actions>.input-wrapper>input[data-v-c98208f0]:focus{outline-width:0}.the-cart-panel-item__content>.content__actions>.input-wrapper>input[data-v-c98208f0]::-webkit-inner-spin-button,.the-cart-panel-item__content>.content__actions>.input-wrapper>input[data-v-c98208f0]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.the-cart-panel-item__content>.content__actions>.input-wrapper>input[type=number][data-v-c98208f0]{-moz-appearance:textfield;-webkit-appearance:textfield;appearance:textfield}.the-cart-panel-item__content>.content__actions>.input-wrapper>input[data-v-c98208f0]:disabled{background-color:transparent}.the-cart-panel-item__content>.content__actions>.input-wrapper--disabled[data-v-c98208f0]{pointer-events:none;background-color:#fafafa;border-radius:19px}.the-cart-panel-item__content>.content__actions>.input-wrapper--disabled>button[data-v-c98208f0]{color:#d3d2d2!important;cursor:default;pointer-events:inherit;background:transparent}.the-cart-panel-item__content>.content__actions>.input-wrapper--disabled>input[data-v-c98208f0]{pointer-events:inherit;background-color:transparent}.the-cart-panel-item__content>.content__actions>.price-wrapper[data-v-c98208f0]{display:flex;flex-direction:column;align-items:flex-end;gap:4px}.the-cart-panel-item__content>.content__actions>.price-wrapper>.price-info[data-v-c98208f0]{font-size:15px;line-height:18px;color:#000}.the-cart-panel-item__content>.content__actions>.price-wrapper>.price-info--active[data-v-c98208f0]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700}.the-cart-panel-item__content>.content__actions>.price-wrapper>.price-info--disabled[data-v-c98208f0]{font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;color:#62646a!important;text-decoration:line-through}.the-cart-panel-item__min-qty-warning[data-v-c98208f0]{color:#fa5e5e}.the-cart-panel-item__min-qty-warning[data-v-c98208f0],.the-cart-panel-item__pack-size-info[data-v-c98208f0]{font-family:Lato,Lato-Regular,sans-serif;font-weight:400;font-size:14px;line-height:17px}.the-cart-panel-item__pack-size-info[data-v-c98208f0]{color:#95979d}@media(max-width:600px){.the-cart-panel-item[data-v-c98208f0]{margin:0 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-cart-panel-subtotal[data-v-68272c70]{display:flex;flex-direction:column;gap:20px;margin:auto 48px 0;border-top:6px solid #e4e4e4}.the-cart-panel-subtotal__prices[data-v-68272c70]{display:flex;flex-direction:column;gap:20px;padding:20px 0;border-bottom:1px solid #e4e4e4}.the-cart-panel-subtotal__prices--row[data-v-68272c70]{display:flex;justify-content:space-between}.the-cart-panel-subtotal .price[data-v-68272c70],.the-cart-panel-subtotal b[data-v-68272c70]{color:#000;font-size:15px;line-height:18px}.the-cart-panel-subtotal .price b[data-v-68272c70],.the-cart-panel-subtotal .price--bold[data-v-68272c70],.the-cart-panel-subtotal b b[data-v-68272c70],.the-cart-panel-subtotal b--bold[data-v-68272c70]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700}.the-cart-panel-subtotal .price--normal[data-v-68272c70],.the-cart-panel-subtotal b--normal[data-v-68272c70]{font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400}@media(max-width:600px){.the-cart-panel-subtotal[data-v-68272c70]{margin:0 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customer-stories[data-v-a2dbd860]{display:flex;flex-direction:column;gap:25px;width:100%}.customer-stories__title[data-v-a2dbd860]{flex:0 1 auto;flex-wrap:nowrap;justify-content:space-between;font-family:Lato-Bold,Lato,sans-serif;font-weight:700;line-height:normal;letter-spacing:1.3px;text-transform:uppercase}.customer-stories__title[data-v-a2dbd860],.customer-stories__title>a[data-v-a2dbd860]{display:flex;flex-direction:row;align-items:center;font-size:16px;font-style:normal}.customer-stories__title>a[data-v-a2dbd860]{font-family:Lato-Regular,Lato,sans-serif;font-weight:400;line-height:24px;text-decoration:none;text-transform:none;letter-spacing:normal;gap:8px;color:#000}.customer-stories__title>a>svg[data-v-a2dbd860]{transition-property:fill,stroke;transition-duration:.26s;transition-timing-function:ease-in-out}.customer-stories__title>a>svg[data-v-a2dbd860] path{transition:inherit}.customer-stories__title>a:hover>svg[data-v-a2dbd860]{fill:#000}.customer-stories__title>a:hover>svg[data-v-a2dbd860] #arrow{fill:#fff;stroke:#fff}.customer-stories__story[data-v-a2dbd860]{display:flex;flex-direction:row;flex-wrap:nowrap;gap:24px;align-items:center;padding-right:20px;width:100%;color:#84868c;font-size:15px;font-family:Lato-Regular,Lato,sans-serif;cursor:pointer;font-style:normal;font-weight:400;line-height:22px;border-radius:27px;border-top-left-radius:0;transition-property:color,background-color,box-shadow;transition-duration:.16s;text-decoration:none;background-color:#f4f4f4d9;transition-timing-function:ease-in-out;height:100px}.customer-stories__story>div[data-v-a2dbd860]{min-width:100px;display:flex;align-items:center;justify-content:center;flex:0 1 100px;aspect-ratio:1/1;border-radius:inherit;background-color:#ffe6ce}.customer-stories__story>div>img[data-v-a2dbd860]{border-radius:inherit;min-width:100px;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;aspect-ratio:1/1}.customer-stories__story[data-v-a2dbd860]:hover{color:#42b77a;background-color:#fff;box-shadow:0 2px 10px 0 rgba(0,0,0,.08)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".latest-article[data-v-88f5c60c]{max-width:342px;margin-right:auto;display:flex;flex-direction:column;gap:24px}.latest-article__title[data-v-88f5c60c]{height:26px;align-items:center;font-weight:700;line-height:19px;color:#000;letter-spacing:1.3px;text-transform:capitalize}.latest-article__article-info[data-v-88f5c60c],.latest-article__title[data-v-88f5c60c]{display:flex;font-family:Lato,sans-serif;font-size:16px;font-style:normal}.latest-article__article-info[data-v-88f5c60c]{flex-direction:column;gap:16px;color:#222325;font-weight:600;line-height:30px;text-decoration:none}.latest-article__article-info>img[data-v-88f5c60c]{width:100%;max-height:212px;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;border-radius:0 40px 40px 40px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-dropdown:focus-within .menu-dropdown__text[data-v-ec557bcc],.menu-dropdown:hover .menu-dropdown__text[data-v-ec557bcc]{font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700}.menu-dropdown:focus-within .menu-dropdown__content[data-v-ec557bcc],.menu-dropdown:hover .menu-dropdown__content[data-v-ec557bcc]{visibility:visible;max-height:1600px}.menu-dropdown__text[data-v-ec557bcc]{font-family:Lato-Regular,Lato Regular,sans-serif;line-height:19px;cursor:pointer;font-size:16px;white-space:nowrap;color:#000;padding:8px 0 14px}.menu-dropdown__content[data-v-ec557bcc]{cursor:default;z-index:100;visibility:hidden;background-color:#fff;position:absolute;padding:16px 64px;left:0;right:0;top:100%;overflow:hidden;width:100%;max-height:0;transition:max-height .5s ease-in-out;border-top:1px solid #dbdbdb;box-shadow:0 5px 10px 0 rgba(0,0,0,.08)}@media(min-width:600px)and (max-width:960px){.menu-dropdown__text[data-v-ec557bcc]{margin-top:20px}.menu-dropdown__content[data-v-ec557bcc]{padding:12px 24px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-height:900px),(max-width:820px)and (orientation:portrait){.header-menu-shop-by-dropdown[data-v-c4968fb6]>.menu-dropdown__content{height:640px!important;overflow-y:auto}}@media(max-height:900px),(max-width:820px)and (orientation:landscape){.header-menu-shop-by-dropdown[data-v-c4968fb6]>.menu-dropdown__content{height:640px!important;overflow-y:auto}}@media screen and (min-width:900px)and (max-width:1520px){.header-menu-shop-by-dropdown[data-v-c4968fb6]>.menu-dropdown__content{height:410px!important;overflow-y:auto}}@media screen and (min-width:1521px){.header-menu-shop-by-dropdown[data-v-c4968fb6]>.menu-dropdown__content{height:420px!important;overflow-y:auto}}@media screen and (min-width:2100px){.header-menu-shop-by-dropdown[data-v-c4968fb6]>.menu-dropdown__content{height:440px!important;overflow-y:auto}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".let-them-block[data-v-3b4f149e]{padding-top:1%}.let-them-block__headline[data-v-3b4f149e]{font-weight:700;font-size:21px;color:#000}@media(min-width:600px)and (max-width:960px){.let-them-block__headline[data-v-3b4f149e]{font-size:26px}}.let-them-block__text[data-v-3b4f149e]{color:#62646a;font-size:18px;margin-top:4px}@media(min-width:600px)and (max-width:960px){.let-them-block__text[data-v-3b4f149e]{font-size:20px}}.let-them-block__main-block[data-v-3b4f149e]{padding-top:2.5%;display:flex;justify-content:space-between}.let-them-block__main-block ul[data-v-3b4f149e]{display:flex;list-style:none;width:70%;max-width:1000px;text-align:center}.let-them-block__main-block ul li[data-v-3b4f149e]{width:33.3333%;display:flex}.let-them-block__main-block ul li img[data-v-3b4f149e]{width:auto;height:98px;display:inline-block;margin-bottom:0;max-width:93px}.let-them-block__main-block ul li:last-of-type img[data-v-3b4f149e]{max-width:102px}.let-them-block__main-block ul li:nth-last-of-type(2) img[data-v-3b4f149e]{max-width:111px}.let-them-block__main-block ul li:nth-last-of-type(3) img[data-v-3b4f149e]{max-width:90px}.let-them-block__main-block ul li h3[data-v-3b4f149e]{font-size:20px;font-weight:700;margin-top:2%;margin-bottom:2%;word-spacing:3px}.let-them-block__main-block ul li span[data-v-3b4f149e]{display:inline-block;color:#62646a;font-size:15px;font-style:italic}.let-them-block__main-block ul li>div[data-v-3b4f149e]{width:100%;height:215px;max-width:302px;cursor:pointer;border-radius:16px;padding:5%}.let-them-block__main-block ul li>div[data-v-3b4f149e]:hover{box-shadow:0 2px 10px 0 rgba(0,0,0,.08)}.let-them-block__main-block ul li>div:hover h3[data-v-3b4f149e]{color:#6e50ff}@media(min-width:2030px){.let-them-block__main-block ul li>div[data-v-3b4f149e]{min-height:230px}}@media(min-width:600px)and (max-width:960px){.let-them-block__main-block ul[data-v-3b4f149e]{width:100%}}.let-them-block__main-block>div[data-v-3b4f149e]{width:30%;height:216px;display:flex;justify-content:center}@media(min-width:600px)and (max-width:960px){.let-them-block__main-block>div[data-v-3b4f149e]{width:100%}}.let-them-block__main-block hr[data-v-3b4f149e]{height:1px;background-color:#f4f4f4;display:none;margin-top:2%;margin-bottom:3%;border:none}@media(min-width:600px)and (max-width:960px){.let-them-block__main-block hr[data-v-3b4f149e]{display:block}.let-them-block__main-block[data-v-3b4f149e]{display:block;padding-top:4.5%}}.how-works-block[data-v-3b4f149e]{width:290px;background:#ece9fc;text-align:center;border-radius:0 45px 45px 45px;padding:5%;padding-top:3%;cursor:pointer}.how-works-block h6[data-v-3b4f149e]{font-size:13px;margin-bottom:4%}.how-works-block img[data-v-3b4f149e]{width:auto;height:150px}@media(min-width:600px)and (max-width:960px){.how-works-block img[data-v-3b4f149e]{height:136px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-5e1a33fc]{font-family:Lato-Regular,Lato Regular,Lato,sans-serif;font-weight:var(--font-weight);cursor:pointer;text-decoration:none!important;white-space:nowrap;display:flex;flex-direction:row;gap:6px;height:41px;align-items:center;font-size:16px;line-height:19px;padding:6px 0 14px;color:var(--text-color)!important}a[data-v-5e1a33fc]:focus-within,a[data-v-5e1a33fc]:hover{font-family:Lato-Regular,Lato Regular,Lato,sans-serif;font-weight:700;color:var(--hover-color,--text-color,#000)!important}a.active-page[data-v-5e1a33fc]{font-weight:700;color:var(--active-color,#000)!important}a.active-page[data-v-5e1a33fc],a.alternative-hover[data-v-5e1a33fc]{font-family:Lato-Regular,Lato Regular,Lato,sans-serif}a.alternative-hover[data-v-5e1a33fc]:focus-within,a.alternative-hover[data-v-5e1a33fc]:hover{color:var(--hover-color)!important}@media(min-width:600px)and (max-width:960px){a[data-v-5e1a33fc]{margin-top:20px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-menu-resources-dropdown[data-v-4769c506]>.menu-dropdown__content{padding:0}@media(max-height:900px),(max-width:820px){.header-menu-resources-dropdown[data-v-4769c506]>.menu-dropdown__content{height:540px;overflow-y:auto}}.header-menu-resources[data-v-4769c506]{width:100%;margin:auto;display:flex;flex-direction:row;flex-wrap:nowrap}.header-menu-resources__stories-and-articles[data-v-4769c506]{display:flex;padding:54px 60px;flex:1 1 1018px}.header-menu-resources__stories-and-articles>div[data-v-4769c506]{max-width:1018px;margin-left:auto;gap:20px;flex-direction:row;display:flex;justify-content:space-between;flex-wrap:nowrap;flex:1 1 auto}.header-menu-resources__stories-and-articles>div>.customer-stories[data-v-4769c506]{max-width:345px}.header-menu-resources__stories-and-articles>div>.customer-stories[data-v-4769c506] .customer-stories__story{background-color:#fff}@media(min-width:1600px){.header-menu-resources__stories-and-articles>div[data-v-4769c506]{gap:60px;justify-content:unset;flex:0 1 auto}}.header-menu-resources__latest-article[data-v-4769c506]{flex:1 1 462px;box-sizing:border-box;padding:54px 60px 42px;background-color:#f4f4f4d9}.header-menu-resources__divider[data-v-4769c506]{height:100%;width:1px;background-color:#d3d2d2}.header-menu-resources__articles-column[data-v-4769c506]{max-width:406px;display:flex;flex-direction:column;flex:0 1 auto;gap:40px}.header-menu-resources__articles-column>.what-we-offer-item[data-v-4769c506]{flex:0}@media(max-width:1600px){.header-menu-resources__latest-article[data-v-4769c506]{flex-grow:0}}@media(max-width:960px){.header-menu-resources[data-v-4769c506]{flex-direction:column}.header-menu-resources__stories-and-articles[data-v-4769c506]{flex-basis:auto}.header-menu-resources__stories-and-articles>div[data-v-4769c506]{max-width:unset}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-height:900px),(max-width:820px){.header-menu-shop-by-dropdown[data-v-191fd462]>.menu-dropdown__content{height:540px;overflow-y:auto}}.header-menu-shop-by[data-v-191fd462]{-moz-columns:180px 6;columns:180px 6;-moz-column-gap:12px;column-gap:12px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-list[data-v-7e808742]{-webkit-column-break-inside:avoid;padding-bottom:20px;list-style:none;margin:0;padding-left:0!important}.category-list li[data-v-7e808742]{line-height:27px}.category-list li[data-v-7e808742]:first-child{margin-bottom:12px;line-height:20px}.category-list a[data-v-7e808742]{text-decoration:none!important;color:inherit!important;font-family:inherit;cursor:pointer}.category-list a[data-v-7e808742]:hover{opacity:.7}.category-list__main[data-v-7e808742]{font-family:Lato-Bold,Lato Bold,sans-serif;font-size:13px;color:#000!important;font-weight:700;position:relative;text-transform:uppercase}.category-list__sub[data-v-7e808742]{font-family:Lato-Regular,Lato Regular,sans-serif;font-size:14px;color:#4a4a4a!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-list[data-v-17da9ad8]{-webkit-column-break-inside:avoid;padding-bottom:20px;list-style:none;margin:0;padding-left:0!important}.category-list li[data-v-17da9ad8]{line-height:27px}.category-list li[data-v-17da9ad8]:first-child{margin-bottom:12px;line-height:20px}.category-list a[data-v-17da9ad8]{text-decoration:none!important;color:inherit!important;font-family:inherit;cursor:pointer}.category-list a[data-v-17da9ad8]:hover{opacity:.7}.category-list__main[data-v-17da9ad8]{font-family:Lato-Bold,Lato Bold,sans-serif;font-size:13px;color:#000!important;font-weight:700;position:relative;text-transform:uppercase}.category-list__main[data-v-17da9ad8]:hover:after{content:\" \";border-top:2px solid #000;border-right:2px solid #000;position:absolute;width:8px;height:8px;bottom:4px;margin-left:8px;transform:rotate(45deg)}.category-list__sub[data-v-17da9ad8]{font-family:Lato-Regular,Lato Regular,sans-serif;font-size:14px;color:#4a4a4a!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-menu-shop-products-dropdown[data-v-8011836a]{margin-left:30px}.header-menu-shop-products-dropdown--cg-elite[data-v-8011836a]{margin:0}@media(max-height:900px),(max-width:820px){.header-menu-shop-products-dropdown[data-v-8011836a]>.menu-dropdown__content{height:540px;overflow-y:auto}}.header-menu-shop-products[data-v-8011836a]{display:flex;justify-content:space-between}.header-menu-shop-products__activator[data-v-8011836a]{display:flex;flex-direction:row;gap:8px}.header-menu-shop-products__products[data-v-8011836a]{-moz-columns:200px 6;columns:200px 6;-moz-column-gap:12px;column-gap:12px;max-width:70%;max-height:100%}.header-menu-shop-products__category-photo[data-v-8011836a]{max-width:30%;display:flex;justify-content:center;width:100%}.header-menu-shop-products__category-photo img[data-v-8011836a]{-o-object-fit:contain;object-fit:contain;max-width:400px;width:100%;max-height:450px}@media(min-width:960px)and (max-width:1520px){.header-menu-shop-products__products[data-v-8011836a]{max-width:85%}.header-menu-shop-products__category-photo[data-v-8011836a]{max-width:15%}}@media(min-width:600px)and (max-width:960px){.header-menu-shop-products__products[data-v-8011836a]{max-width:100%}.header-menu-shop-products__category-photo[data-v-8011836a]{display:none}}@media(max-height:900px),(max-width:820px){.header-menu-shop-products[data-v-8011836a]{max-height:100%}.header-menu-shop-products__products[data-v-8011836a]{max-width:100%}.header-menu-shop-products__category-photo[data-v-8011836a]{display:none}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-menu-what-we-offer-dropdown[data-v-1ba7cacc]>.menu-dropdown__content{padding:0}@media(max-height:900px),(max-width:820px){.header-menu-what-we-offer-dropdown[data-v-1ba7cacc]>.menu-dropdown__content{height:600px;overflow-y:auto}}.header-menus-what-we-offer__wrapper[data-v-1ba7cacc]{display:flex;gap:40px;justify-content:space-between;flex-wrap:nowrap;flex-direction:row;max-width:1600px;padding:60px 36px 40px;margin-inline:auto}.header-menus-what-we-offer__column[data-v-1ba7cacc]{flex:1 1 0px;max-width:420px;display:flex;flex-direction:column;gap:80px;align-self:flex-start}.header-menus-what-we-offer__column[data-v-1ba7cacc] .what-we-offer-item{padding-bottom:0}.header-menus-what-we-offer__latest-article-wrapper[data-v-1ba7cacc]{padding:24px 40px;border-radius:24px;background-color:#fafafa}.header-menus-what-we-offer__latest-article-wrapper[data-v-1ba7cacc] .latest-article{margin:0;max-width:100%}@media(max-width:1440px){.header-menus-what-we-offer__wrapper[data-v-1ba7cacc]{gap:30px;padding:60px 60px 40px}}@media(max-width:1024px){.header-menus-what-we-offer__wrapper[data-v-1ba7cacc]{padding:30px 40px}.header-menus-what-we-offer__column[data-v-1ba7cacc]{gap:40px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-user-company-menu[data-v-5702c6c8]{position:relative}.the-user-company-menu:focus-within .the-user-company-menu__text[data-v-5702c6c8],.the-user-company-menu:hover .the-user-company-menu__text[data-v-5702c6c8]{font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700}.the-user-company-menu:focus-within .the-user-company-menu__content[data-v-5702c6c8],.the-user-company-menu:hover .the-user-company-menu__content[data-v-5702c6c8]{visibility:visible;max-height:1000px;width:auto}.the-user-company-menu__text[data-v-5702c6c8]{font-family:Lato-Regular,Lato Regular,sans-serif;line-height:19px;cursor:pointer;font-size:16px;color:#000;padding:8px 0 14px;white-space:nowrap}.the-user-company-menu__content[data-v-5702c6c8]{cursor:default;z-index:10000;visibility:hidden;background-color:#fff;position:absolute;top:100%;left:0;overflow:hidden;width:100%;max-height:0;padding:8px 12px;transition:max-height .5s ease-in-out;border-top:1px solid #dbdbdb;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.the-user-company-menu__content>ul[data-v-5702c6c8]{list-style:none;margin:0;padding-left:0!important}.the-user-company-menu__content>ul>li[data-v-5702c6c8]{min-height:34px;display:flex;align-items:center}.the-user-company-menu__content>ul>li>a[data-v-5702c6c8]{font-family:Lato-Regular,Lato Regular,sans-serif;color:#4a4a4a!important;text-decoration:none!important;font-family:inherit;white-space:nowrap;cursor:pointer;font-size:16px}.the-user-company-menu__content>ul>li>a[data-v-5702c6c8]:hover{opacity:.7}@media(min-width:600px)and (max-width:960px){.the-user-company-menu__text[data-v-5702c6c8]{margin-top:20px}.the-user-company-menu__content[data-v-5702c6c8]{top:calc(100% + 12px)}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".what-we-offer-item[data-v-7aaaae25]{display:flex;flex-direction:column;gap:16px;position:relative;height:100%;padding:0 20px 20px 60px}.what-we-offer-item__title[data-v-7aaaae25]{font-size:16px;font-family:Lato,sans-serif;font-weight:700;line-height:19px;letter-spacing:1.3px;text-transform:uppercase;color:#000}.what-we-offer-item__icon[data-v-7aaaae25]{position:absolute;top:0;left:10px;width:35px;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-end}.what-we-offer-item ul[data-v-7aaaae25]{list-style:none;display:flex;flex-direction:column;gap:16px;padding:0}.what-we-offer-item ul>li[data-v-7aaaae25]{width:-moz-fit-content;width:fit-content;cursor:pointer}.what-we-offer-item ul>li>a[data-v-7aaaae25]{text-decoration:none;color:#62646a;font-family:Lato,sans-serif}.what-we-offer-item ul>li>a:hover>div[data-v-7aaaae25]:first-child{color:#42b77a}.what-we-offer-item ul>li>a>div[data-v-7aaaae25]:first-child{font-family:Lato,sans-serif;color:#222325;font-size:16px;font-weight:600;line-height:30px}.what-we-offer-item ul>li>a>div[data-v-7aaaae25]:nth-child(2){font-family:Lato,sans-serif;color:#62646a;font-size:14px;font-weight:400;line-height:22px}@media(max-width:960px){.what-we-offer-item[data-v-7aaaae25]{padding:5px 0 20px 60px}}@media screen and (max-width:600px){.what-we-offer-item[data-v-7aaaae25]{padding:30px 20px 30px 60px}.what-we-offer-item__icon[data-v-7aaaae25]{top:30px}.what-we-offer-item ul>li>a>div[data-v-7aaaae25]:first-child{line-height:22px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-8b724518]{list-style:none;margin:0;padding:20px 0;display:flex;flex-direction:column;gap:14px}ul>li[data-v-8b724518]{padding:0 20px}ul>li[data-v-8b724518],ul>li>a[data-v-8b724518]{display:flex;align-items:center}ul>li>a[data-v-8b724518]{flex-direction:row;min-height:34px;gap:8px;font-family:Lato,Lato-Regular,sans-serif;font-weight:400;width:100%;color:#62646a!important;text-decoration:none!important;text-transform:uppercase;cursor:pointer;font-size:13px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".let-them-block[data-v-741fc334]{padding:3%;padding-top:2%}.let-them-block__headline[data-v-741fc334]{margin-top:3%;font-weight:700;font-size:20px;color:#000}.let-them-block__text[data-v-741fc334]{color:#62646a;font-size:15px;margin-bottom:5%;margin-top:5px}.let-them-block__main-block[data-v-741fc334]{padding-top:1.5%}.let-them-block__main-block ul[data-v-741fc334]{list-style:none;width:100%;text-align:center;display:flex;flex-wrap:wrap;justify-content:center}.let-them-block__main-block ul li[data-v-741fc334]{width:100%;display:flex;justify-content:center;margin-bottom:4%}.let-them-block__main-block ul li img[data-v-741fc334]{width:auto;height:95px;display:inline-block;margin-bottom:3%}.let-them-block__main-block ul li h3[data-v-741fc334]{font-size:16px;font-weight:700;margin-top:2%;margin-bottom:2%;word-spacing:3px}.let-them-block__main-block ul li span[data-v-741fc334]{display:inline-block;color:#62646a;font-size:13px;font-style:italic}.let-them-block__main-block ul li>div[data-v-741fc334]{width:100%;max-width:350px;height:205px;cursor:pointer;border-radius:16px;padding:3%}.let-them-block__main-block ul li>div[data-v-741fc334]:hover{box-shadow:0 2px 10px 0 rgba(0,0,0,.08)}.let-them-block__main-block ul li>div:hover h3[data-v-741fc334]{color:#6e50ff}.let-them-block__main-block>div[data-v-741fc334]{width:100%;height:216px;display:flex;margin-top:5%;justify-content:center}.how-works-block[data-v-741fc334]{width:290px;background:#ece9fc;text-align:center;border-radius:0 45px 45px 45px;padding:5%;padding-top:3%}.how-works-block h6[data-v-741fc334]{font-size:13px;margin-bottom:4%}.how-works-block img[data-v-741fc334]{width:auto;height:150px}@media(min-width:600px)and (max-width:960px){.how-works-block img[data-v-741fc334]{height:136px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation-resources[data-v-48c7f2ff]{display:flex;flex-direction:column}.header-mobile-navigation-resources>.customer-stories[data-v-48c7f2ff]{padding:30px 20px}.header-mobile-navigation-resources>.customer-stories[data-v-48c7f2ff]>.customer-stories__story{background-color:#fff}.header-mobile-navigation-resources__bottom[data-v-48c7f2ff]{background-color:#f4f4f4d9;padding:30px 20px;display:flex;flex-direction:column}.header-mobile-navigation-resources__bottom>.latest-article[data-v-48c7f2ff]{max-width:unset}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation-shop-by[data-v-17d0a2c6]{padding:20px;display:flex;flex-direction:column;gap:20px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-31c0f6ff]{list-style:none;margin:0;padding-left:0!important}ul li[data-v-31c0f6ff]:first-child{text-transform:uppercase;padding-bottom:12px;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;line-height:35px;font-size:12px;color:#9b9b9b}ul li[data-v-31c0f6ff]:not(:first-child){padding-left:8px;font-weight:700;font-family:Lato-Bold,Lato Bold,sans-serif!important;line-height:27px;padding-bottom:12px;font-size:14px;color:#000}ul li>a[data-v-31c0f6ff]{text-decoration:none!important;color:inherit!important;font-family:inherit;cursor:pointer}ul li>a[data-v-31c0f6ff]:hover{opacity:.7}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation-shop-products[data-v-45b34240]{padding:20px;display:flex;flex-direction:column;gap:20px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation-shop-products-item__main[data-v-552ac44e]{font-family:Lato-Bold,Lato Bold,sans-serif!important;font-weight:700;text-transform:uppercase;text-decoration:none!important;font-size:13px;color:#000;padding-bottom:12px}.header-mobile-navigation-shop-products-item__main[data-v-552ac44e]:is(a){display:flex;align-items:center;gap:8px}.header-mobile-navigation-shop-products-item__main[data-v-552ac44e]:is(a):after{content:\"\";width:8px;height:8px;border-top:2px solid #000;border-right:2px solid #000;transform:rotate(45deg)}.header-mobile-navigation-shop-products-item ul[data-v-552ac44e]{margin-left:8px;margin-bottom:0;list-style:none;padding-left:0!important}.header-mobile-navigation-shop-products-item ul>li[data-v-552ac44e]{line-height:27px;text-transform:capitalize;font-family:Lato-Regular,Lato Regular,sans-serif!important;font-weight:400;font-size:14px;color:#4a4a4a;padding:8px 0}.header-mobile-navigation-shop-products-item ul>li>a[data-v-552ac44e]{text-decoration:none!important;color:inherit!important;font-family:inherit;cursor:pointer}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-3c72815b]{list-style:none;margin:0;padding:20px}ul>li[data-v-3c72815b]{min-height:38px;display:flex;align-items:center}ul>li>a[data-v-3c72815b]{font-family:Lato-Bold,Lato Bold,sans-serif;font-weight:700;color:#000!important;text-decoration:none!important;text-transform:uppercase;cursor:pointer;font-size:13px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-mobile-navigation-what-we-offer[data-v-868973cc]{display:flex;flex-direction:column}.header-mobile-navigation-what-we-offer__bottom[data-v-868973cc]{display:flex;flex-direction:column;padding:0 16px 30px}.header-mobile-navigation-what-we-offer__bottom[data-v-868973cc] .latest-article{padding:24px;border-radius:24px;background-color:#fafafa;margin:0;max-width:100%}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-left-enter-active[data-v-1600fbde]{animation:coming-data-v-1600fbde .46s;animation-delay:0s}.dialog-left-leave-active[data-v-1600fbde]{animation:going-data-v-1600fbde .46s}@keyframes going-data-v-1600fbde{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0);visibility:hidden}}@keyframes coming-data-v-1600fbde{0%{transform:translate3d(100%,0,0);visibility:hidden}to{transform:translateZ(0);visibility:visible}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-right-enter-active[data-v-17d54095]{animation:coming-data-v-17d54095 .46s;animation-delay:0s}.dialog-right-leave-active[data-v-17d54095]{animation:going-data-v-17d54095 .46s}@keyframes going-data-v-17d54095{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0);visibility:hidden}}@keyframes coming-data-v-17d54095{0%{transform:translate3d(-100%,0,0);visibility:hidden}to{transform:translateZ(0);visibility:visible}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-e79dfc6c]{will-change:height;transform:translateZ(0);backface-visibility:hidden}.expand-enter-active[data-v-e79dfc6c],.expand-leave-active[data-v-e79dfc6c]{transition:height .6s ease-in-out;overflow:hidden}.expand-enter[data-v-e79dfc6c],.expand-leave-to[data-v-e79dfc6c]{height:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{box-sizing:border-box;-webkit-text-size-adjust:100%;word-break:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4}*,:after,:before{background-repeat:no-repeat;box-sizing:inherit}:after,:before{text-decoration:inherit;vertical-align:inherit}*{padding:0;margin:0}hr{overflow:visible;height:0;color:inherit}details,main{display:block}summary{display:list-item}small{font-size:80%}[hidden]{display:none}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}a{background-color:transparent}a:active,a:hover{outline-width:0}code,kbd,pre,samp{font-family:monospace,monospace}pre{font-size:1em}b,strong{font-weight:bolder}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{border-color:inherit;text-indent:0}img{border-style:none}progress{vertical-align:baseline}[aria-busy=true]{cursor:progress}[aria-controls]{cursor:pointer}[aria-disabled=true]{cursor:default}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3645:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";

      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }

      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }

      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }

      content += cssWithMappingToString(item);

      if (needLayer) {
        content += "}";
      }

      if (item[2]) {
        content += "}";
      }

      if (item[4]) {
        content += "}";
      }

      return content;
    }).join("");
  }; // import a list of modules into the list


  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }

      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }

      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }

      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ 8081:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 8878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(1703);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}

module.exports = EventEmitter; // Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.

EventEmitter.defaultMaxListeners = 10; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.

EventEmitter.prototype.setMaxListeners = function (n) {
  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function (type) {
  var er, handler, len, args, i, listeners;
  if (!this._events) this._events = {}; // If there is no 'error' event listener then throw.

  if (type === 'error') {
    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
      er = arguments[1];

      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];
  if (isUndefined(handler)) return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;

      case 2:
        handler.call(this, arguments[1]);
        break;

      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower

      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;

    for (i = 0; i < len; i++) listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function (type, listener) {
  var m;
  if (!isFunction(listener)) throw TypeError('listener must be a function');
  if (!this._events) this._events = {}; // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".

  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
  if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;else if (isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);else // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener]; // Check for listener leak

  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);

      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function (type, listener) {
  if (!isFunction(listener)) throw TypeError('listener must be a function');
  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);
  return this;
}; // emits a 'removeListener' event iff the listener was removed


EventEmitter.prototype.removeListener = function (type, listener) {
  var list, position, length, i;
  if (!isFunction(listener)) throw TypeError('listener must be a function');
  if (!this._events || !this._events[type]) return this;
  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener || isFunction(list.listener) && list.listener === listener) {
    delete this._events[type];
    if (this._events.removeListener) this.emit('removeListener', type, listener);
  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener) this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function (type) {
  var key, listeners;
  if (!this._events) return this; // not listening for removeListener, no need to emit

  if (!this._events.removeListener) {
    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
    return this;
  } // emit removeListener for all listeners on all events


  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }

    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length) this.removeListener(type, listeners[listeners.length - 1]);
  }

  delete this._events[type];
  return this;
};

EventEmitter.prototype.listeners = function (type) {
  var ret;
  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function (type) {
  if (this._events) {
    var evlistener = this._events[type];
    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
  }

  return 0;
};

EventEmitter.listenerCount = function (emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

/***/ }),

/***/ 5731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AlgoliaSearchHelper = __webpack_require__(410);

var SearchParameters = __webpack_require__(5527);

var SearchResults = __webpack_require__(2454);
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper}
 */


function algoliasearchHelper(client, index, opts) {
  return new AlgoliaSearchHelper(client, index, opts);
}
/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */


algoliasearchHelper.version = __webpack_require__(8147);
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */

algoliasearchHelper.AlgoliaSearchHelper = AlgoliaSearchHelper;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */

algoliasearchHelper.SearchParameters = SearchParameters;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */

algoliasearchHelper.SearchResults = SearchResults;
module.exports = algoliasearchHelper;

/***/ }),

/***/ 9717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(8878);

var inherits = __webpack_require__(7306);
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 */


function DerivedHelper(mainHelper, fn) {
  this.main = mainHelper;
  this.fn = fn;
  this.lastResults = null;
}

inherits(DerivedHelper, EventEmitter);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */

DerivedHelper.prototype.detach = function () {
  this.removeAllListeners();
  this.main.detachDerivedHelper(this);
};

DerivedHelper.prototype.getModifiedState = function (parameters) {
  return this.fn(parameters);
};

module.exports = DerivedHelper;

/***/ }),

/***/ 958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/**
 * Functions to manipulate refinement lists
 *
 * The RefinementList is not formally defined through a prototype but is based
 * on a specific structure.
 *
 * @module SearchParameters.refinementList
 *
 * @typedef {string[]} SearchParameters.refinementList.Refinements
 * @typedef {Object.<string, SearchParameters.refinementList.Refinements>} SearchParameters.refinementList.RefinementList
 */

__webpack_require__(1703);

var defaultsPure = __webpack_require__(6847);

var omit = __webpack_require__(1845);

var objectHasKeys = __webpack_require__(8067);

var lib = {
  /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */
  addRefinement: function addRefinement(refinementList, attribute, value) {
    if (lib.isRefined(refinementList, attribute, value)) {
      return refinementList;
    }

    var valueAsString = '' + value;
    var facetRefinement = !refinementList[attribute] ? [valueAsString] : refinementList[attribute].concat(valueAsString);
    var mod = {};
    mod[attribute] = facetRefinement;
    return defaultsPure({}, mod, refinementList);
  },

  /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */
  removeRefinement: function removeRefinement(refinementList, attribute, value) {
    if (value === undefined) {
      // we use the "filter" form of clearRefinement, since it leaves empty values as-is
      // the form with a string will remove the attribute completely
      return lib.clearRefinement(refinementList, function (v, f) {
        return attribute === f;
      });
    }

    var valueAsString = '' + value;
    return lib.clearRefinement(refinementList, function (v, f) {
      return attribute === f && valueAsString === v;
    });
  },

  /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */
  toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
    if (value === undefined) throw new Error('toggleRefinement should be used with a value');

    if (lib.isRefined(refinementList, attribute, value)) {
      return lib.removeRefinement(refinementList, attribute, value);
    }

    return lib.addRefinement(refinementList, attribute, value);
  },

  /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */
  clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
    if (attribute === undefined) {
      if (!objectHasKeys(refinementList)) {
        return refinementList;
      }

      return {};
    } else if (typeof attribute === 'string') {
      return omit(refinementList, [attribute]);
    } else if (typeof attribute === 'function') {
      var hasChanged = false;
      var newRefinementList = Object.keys(refinementList).reduce(function (memo, key) {
        var values = refinementList[key] || [];
        var facetList = values.filter(function (value) {
          return !attribute(value, key, refinementType);
        });

        if (facetList.length !== values.length) {
          hasChanged = true;
        }

        memo[key] = facetList;
        return memo;
      }, {});
      if (hasChanged) return newRefinementList;
      return refinementList;
    }
  },

  /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean}
   */
  isRefined: function isRefined(refinementList, attribute, refinementValue) {
    var containsRefinements = !!refinementList[attribute] && refinementList[attribute].length > 0;

    if (refinementValue === undefined || !containsRefinements) {
      return containsRefinements;
    }

    var refinementValueAsString = '' + refinementValue;
    return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
  }
};
module.exports = lib;

/***/ }),

/***/ 5527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

var merge = __webpack_require__(4532);

var defaultsPure = __webpack_require__(6847);

var intersection = __webpack_require__(839);

var find = __webpack_require__(8671);

var valToNumber = __webpack_require__(2660);

var omit = __webpack_require__(1845);

var objectHasKeys = __webpack_require__(8067);

var isValidUserToken = __webpack_require__(3665);

var RefinementList = __webpack_require__(958);
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 */


function isEqualNumericRefinement(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every(function (el, i) {
      return isEqualNumericRefinement(b[i], el);
    });
  }

  return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */


function findArray(array, searchedValue) {
  return find(array, function (currentValue) {
    return isEqualNumericRefinement(currentValue, searchedValue);
  });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */

/**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */

/**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */


function SearchParameters(newParameters) {
  var params = newParameters ? SearchParameters._parseNumbers(newParameters) : {};

  if (params.userToken !== undefined && !isValidUserToken(params.userToken)) {
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
  }
  /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */


  this.facets = params.facets || [];
  /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */

  this.disjunctiveFacets = params.disjunctiveFacets || [];
  /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */

  this.hierarchicalFacets = params.hierarchicalFacets || []; // Refinements

  /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */

  this.facetsRefinements = params.facetsRefinements || {};
  /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */

  this.facetsExcludes = params.facetsExcludes || {};
  /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */

  this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
  /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */

  this.numericRefinements = params.numericRefinements || {};
  /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */

  this.tagRefinements = params.tagRefinements || [];
  /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */

  this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
  var self = this;
  Object.keys(params).forEach(function (paramName) {
    var isKeyKnown = SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
    var isValueDefined = params[paramName] !== undefined;

    if (!isKeyKnown && isValueDefined) {
      self[paramName] = params[paramName];
    }
  });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */


SearchParameters.PARAMETERS = Object.keys(new SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */

SearchParameters._parseNumbers = function (partialState) {
  // Do not reparse numbers in SearchParameters, they ought to be parsed already
  if (partialState instanceof SearchParameters) return partialState;
  var numbers = {};
  var numberKeys = ['aroundPrecision', 'aroundRadius', 'getRankingInfo', 'minWordSizefor2Typos', 'minWordSizefor1Typo', 'page', 'maxValuesPerFacet', 'distinct', 'minimumAroundRadius', 'hitsPerPage', 'minProximity'];
  numberKeys.forEach(function (k) {
    var value = partialState[k];

    if (typeof value === 'string') {
      var parsedValue = parseFloat(value); // global isNaN is ok to use here, value is only number or NaN

      numbers[k] = isNaN(parsedValue) ? value : parsedValue;
    }
  }); // there's two formats of insideBoundingBox, we need to parse
  // the one which is an array of float geo rectangles

  if (Array.isArray(partialState.insideBoundingBox)) {
    numbers.insideBoundingBox = partialState.insideBoundingBox.map(function (geoRect) {
      if (Array.isArray(geoRect)) {
        return geoRect.map(function (value) {
          return parseFloat(value);
        });
      }

      return geoRect;
    });
  }

  if (partialState.numericRefinements) {
    var numericRefinements = {};
    Object.keys(partialState.numericRefinements).forEach(function (attribute) {
      var operators = partialState.numericRefinements[attribute] || {};
      numericRefinements[attribute] = {};
      Object.keys(operators).forEach(function (operator) {
        var values = operators[operator];
        var parsedValues = values.map(function (v) {
          if (Array.isArray(v)) {
            return v.map(function (vPrime) {
              if (typeof vPrime === 'string') {
                return parseFloat(vPrime);
              }

              return vPrime;
            });
          } else if (typeof v === 'string') {
            return parseFloat(v);
          }

          return v;
        });
        numericRefinements[attribute][operator] = parsedValues;
      });
    });
    numbers.numericRefinements = numericRefinements;
  }

  return merge({}, partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */


SearchParameters.make = function makeSearchParameters(newParameters) {
  var instance = new SearchParameters(newParameters);
  var hierarchicalFacets = newParameters.hierarchicalFacets || [];
  hierarchicalFacets.forEach(function (facet) {
    if (facet.rootPath) {
      var currentRefinement = instance.getHierarchicalRefinement(facet.name);

      if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) {
        instance = instance.clearRefinements(facet.name);
      } // get it again in case it has been cleared


      currentRefinement = instance.getHierarchicalRefinement(facet.name);

      if (currentRefinement.length === 0) {
        instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
      }
    }
  });
  return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */


SearchParameters.validate = function (currentState, parameters) {
  var params = parameters || {};

  if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) {
    return new Error('[Tags] Cannot switch from the managed tag API to the advanced API. It is probably ' + 'an error, if it is really what you want, you should first clear the tags with clearTags method.');
  }

  if (currentState.tagRefinements.length > 0 && params.tagFilters) {
    return new Error('[Tags] Cannot switch from the advanced tag API to the managed API. It is probably ' + 'an error, if it is not, you should first clear the tags with clearTags method.');
  }

  if (currentState.numericFilters && params.numericRefinements && objectHasKeys(params.numericRefinements)) {
    return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It" + ' is probably an error, if this is really what you want, you have to first' + ' clear the numeric filters.');
  }

  if (objectHasKeys(currentState.numericRefinements) && params.numericFilters) {
    return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It" + ' is probably an error, if this is really what you want, you have to first' + ' clear the numeric filters.');
  }

  return null;
};

SearchParameters.prototype = {
  constructor: SearchParameters,

  /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters}
   */
  clearRefinements: function clearRefinements(attribute) {
    var patch = {
      numericRefinements: this._clearNumericRefinements(attribute),
      facetsRefinements: RefinementList.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
      facetsExcludes: RefinementList.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
      disjunctiveFacetsRefinements: RefinementList.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
      hierarchicalFacetsRefinements: RefinementList.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
    };

    if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) {
      return this;
    }

    return this.setQueryParameters(patch);
  },

  /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters}
   */
  clearTags: function clearTags() {
    if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
    return this.setQueryParameters({
      tagFilters: undefined,
      tagRefinements: []
    });
  },

  /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters}
   */
  setIndex: function setIndex(index) {
    if (index === this.index) return this;
    return this.setQueryParameters({
      index: index
    });
  },

  /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters}
   */
  setQuery: function setQuery(newQuery) {
    if (newQuery === this.query) return this;
    return this.setQueryParameters({
      query: newQuery
    });
  },

  /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters}
   */
  setPage: function setPage(newPage) {
    if (newPage === this.page) return this;
    return this.setQueryParameters({
      page: newPage
    });
  },

  /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters}
   */
  setFacets: function setFacets(facets) {
    return this.setQueryParameters({
      facets: facets
    });
  },

  /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters}
   */
  setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
    return this.setQueryParameters({
      disjunctiveFacets: facets
    });
  },

  /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters}
   */
  setHitsPerPage: function setHitsPerPage(n) {
    if (this.hitsPerPage === n) return this;
    return this.setQueryParameters({
      hitsPerPage: n
    });
  },

  /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters}
   */
  setTypoTolerance: function setTypoTolerance(typoTolerance) {
    if (this.typoTolerance === typoTolerance) return this;
    return this.setQueryParameters({
      typoTolerance: typoTolerance
    });
  },

  /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters}
   * @example
   * // for price = 50 or 40
   * searchparameter.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * searchparameter.addNumericRefinement('size', '=', 38);
   * searchparameter.addNumericRefinement('size', '=', 40);
   */
  addNumericRefinement: function (attribute, operator, v) {
    var value = valToNumber(v);
    if (this.isNumericRefined(attribute, operator, value)) return this;
    var mod = merge({}, this.numericRefinements);
    mod[attribute] = merge({}, mod[attribute]);

    if (mod[attribute][operator]) {
      // Array copy
      mod[attribute][operator] = mod[attribute][operator].slice(); // Add the element. Concat can't be used here because value can be an array.

      mod[attribute][operator].push(value);
    } else {
      mod[attribute][operator] = [value];
    }

    return this.setQueryParameters({
      numericRefinements: mod
    });
  },

  /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getConjunctiveRefinements: function (facetName) {
    if (!this.isConjunctiveFacet(facetName)) {
      return [];
    }

    return this.facetsRefinements[facetName] || [];
  },

  /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getDisjunctiveRefinements: function (facetName) {
    if (!this.isDisjunctiveFacet(facetName)) {
      return [];
    }

    return this.disjunctiveFacetsRefinements[facetName] || [];
  },

  /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getHierarchicalRefinement: function (facetName) {
    // we send an array but we currently do not support multiple
    // hierarchicalRefinements for a hierarchicalFacet
    return this.hierarchicalFacetsRefinements[facetName] || [];
  },

  /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getExcludeRefinements: function (facetName) {
    if (!this.isConjunctiveFacet(facetName)) {
      return [];
    }

    return this.facetsExcludes[facetName] || [];
  },

  /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters}
   */
  removeNumericRefinement: function (attribute, operator, paramValue) {
    if (paramValue !== undefined) {
      if (!this.isNumericRefined(attribute, operator, paramValue)) {
        return this;
      }

      return this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function (value, key) {
          return key === attribute && value.op === operator && isEqualNumericRefinement(value.val, valToNumber(paramValue));
        })
      });
    } else if (operator !== undefined) {
      if (!this.isNumericRefined(attribute, operator)) return this;
      return this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function (value, key) {
          return key === attribute && value.op === operator;
        })
      });
    }

    if (!this.isNumericRefined(attribute)) return this;
    return this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function (value, key) {
        return key === attribute;
      })
    });
  },

  /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */
  getNumericRefinements: function (facetName) {
    return this.numericRefinements[facetName] || {};
  },

  /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */
  getNumericRefinement: function (attribute, operator) {
    return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
  },

  /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>}
   */
  _clearNumericRefinements: function _clearNumericRefinements(attribute) {
    if (attribute === undefined) {
      if (!objectHasKeys(this.numericRefinements)) {
        return this.numericRefinements;
      }

      return {};
    } else if (typeof attribute === 'string') {
      return omit(this.numericRefinements, [attribute]);
    } else if (typeof attribute === 'function') {
      var hasChanged = false;
      var numericRefinements = this.numericRefinements;
      var newNumericRefinements = Object.keys(numericRefinements).reduce(function (memo, key) {
        var operators = numericRefinements[key];
        var operatorList = {};
        operators = operators || {};
        Object.keys(operators).forEach(function (operator) {
          var values = operators[operator] || [];
          var outValues = [];
          values.forEach(function (value) {
            var predicateResult = attribute({
              val: value,
              op: operator
            }, key, 'numeric');
            if (!predicateResult) outValues.push(value);
          });

          if (outValues.length !== values.length) {
            hasChanged = true;
          }

          operatorList[operator] = outValues;
        });
        memo[key] = operatorList;
        return memo;
      }, {});
      if (hasChanged) return newNumericRefinements;
      return this.numericRefinements;
    }
  },

  /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters}
   */
  addFacet: function addFacet(facet) {
    if (this.isConjunctiveFacet(facet)) {
      return this;
    }

    return this.setQueryParameters({
      facets: this.facets.concat([facet])
    });
  },

  /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters}
   */
  addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
    if (this.isDisjunctiveFacet(facet)) {
      return this;
    }

    return this.setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.concat([facet])
    });
  },

  /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters}
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */
  addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
    if (this.isHierarchicalFacet(hierarchicalFacet.name)) {
      throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
    }

    return this.setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.concat([hierarchicalFacet])
    });
  },

  /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addFacetRefinement: function addFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    if (RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;
    return this.setQueryParameters({
      facetsRefinements: RefinementList.addRefinement(this.facetsRefinements, facet, value)
    });
  },

  /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addExcludeRefinement: function addExcludeRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    if (RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;
    return this.setQueryParameters({
      facetsExcludes: RefinementList.addRefinement(this.facetsExcludes, facet, value)
    });
  },

  /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }

    if (RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
    });
  },

  /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters}
   */
  addTagRefinement: function addTagRefinement(tag) {
    if (this.isTagRefined(tag)) return this;
    var modification = {
      tagRefinements: this.tagRefinements.concat(tag)
    };
    return this.setQueryParameters(modification);
  },

  /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters}
   */
  removeFacet: function removeFacet(facet) {
    if (!this.isConjunctiveFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      facets: this.facets.filter(function (f) {
        return f !== facet;
      })
    });
  },

  /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters}
   */
  removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
    if (!this.isDisjunctiveFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.filter(function (f) {
        return f !== facet;
      })
    });
  },

  /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters}
   */
  removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
    if (!this.isHierarchicalFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.filter(function (f) {
        return f.name !== facet;
      })
    });
  },

  /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters}
   */
  removeFacetRefinement: function removeFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    if (!RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;
    return this.setQueryParameters({
      facetsRefinements: RefinementList.removeRefinement(this.facetsRefinements, facet, value)
    });
  },

  /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */
  removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    if (!RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;
    return this.setQueryParameters({
      facetsExcludes: RefinementList.removeRefinement(this.facetsExcludes, facet, value)
    });
  },

  /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */
  removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }

    if (!RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
    });
  },

  /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters}
   */
  removeTagRefinement: function removeTagRefinement(tag) {
    if (!this.isTagRefined(tag)) return this;
    var modification = {
      tagRefinements: this.tagRefinements.filter(function (t) {
        return t !== tag;
      })
    };
    return this.setQueryParameters(modification);
  },

  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */
  toggleRefinement: function toggleRefinement(facet, value) {
    return this.toggleFacetRefinement(facet, value);
  },

  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */
  toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
    if (this.isHierarchicalFacet(facet)) {
      return this.toggleHierarchicalFacetRefinement(facet, value);
    } else if (this.isConjunctiveFacet(facet)) {
      return this.toggleConjunctiveFacetRefinement(facet, value);
    } else if (this.isDisjunctiveFacet(facet)) {
      return this.toggleDisjunctiveFacetRefinement(facet, value);
    }

    throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
  },

  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      facetsRefinements: RefinementList.toggleRefinement(this.facetsRefinements, facet, value)
    });
  },

  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      facetsExcludes: RefinementList.toggleRefinement(this.facetsExcludes, facet, value)
    });
  },

  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
    });
  },

  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
    if (!this.isHierarchicalFacet(facet)) {
      throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
    }

    var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));

    var mod = {};
    var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && ( // remove current refinement:
    // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
    this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
    //  - refinement was 'beer > IPA > Flying dog'
    //  - call is toggleRefine('beer > IPA')
    //  - refinement should be `beer`
    this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);

    if (upOneOrMultipleLevel) {
      if (value.indexOf(separator) === -1) {
        // go back to root level
        mod[facet] = [];
      } else {
        mod[facet] = [value.slice(0, value.lastIndexOf(separator))];
      }
    } else {
      mod[facet] = [value];
    }

    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },

  /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */
  addHierarchicalFacetRefinement: function (facet, path) {
    if (this.isHierarchicalFacetRefined(facet)) {
      throw new Error(facet + ' is already refined.');
    }

    if (!this.isHierarchicalFacet(facet)) {
      throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
    }

    var mod = {};
    mod[facet] = [path];
    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },

  /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */
  removeHierarchicalFacetRefinement: function (facet) {
    if (!this.isHierarchicalFacetRefined(facet)) {
      return this;
    }

    var mod = {};
    mod[facet] = [];
    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },

  /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters}
   */
  toggleTagRefinement: function toggleTagRefinement(tag) {
    if (this.isTagRefined(tag)) {
      return this.removeTagRefinement(tag);
    }

    return this.addTagRefinement(tag);
  },

  /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */
  isDisjunctiveFacet: function (facet) {
    return this.disjunctiveFacets.indexOf(facet) > -1;
  },

  /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean}
   */
  isHierarchicalFacet: function (facetName) {
    return this.getHierarchicalFacetByName(facetName) !== undefined;
  },

  /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */
  isConjunctiveFacet: function (facet) {
    return this.facets.indexOf(facet) > -1;
  },

  /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isFacetRefined: function isFacetRefined(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      return false;
    }

    return RefinementList.isRefined(this.facetsRefinements, facet, value);
  },

  /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isExcludeRefined: function isExcludeRefined(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      return false;
    }

    return RefinementList.isRefined(this.facetsExcludes, facet, value);
  },

  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */
  isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      return false;
    }

    return RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value);
  },

  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */
  isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
    if (!this.isHierarchicalFacet(facet)) {
      return false;
    }

    var refinements = this.getHierarchicalRefinement(facet);

    if (!value) {
      return refinements.length > 0;
    }

    return refinements.indexOf(value) !== -1;
  },

  /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */
  isNumericRefined: function isNumericRefined(attribute, operator, value) {
    if (value === undefined && operator === undefined) {
      return !!this.numericRefinements[attribute];
    }

    var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;

    if (value === undefined || !isOperatorDefined) {
      return isOperatorDefined;
    }

    var parsedValue = valToNumber(value);
    var isAttributeValueDefined = findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
    return isOperatorDefined && isAttributeValueDefined;
  },

  /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean}
   */
  isTagRefined: function isTagRefined(tag) {
    return this.tagRefinements.indexOf(tag) !== -1;
  },

  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */
  getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
    var self = this; // attributes used for numeric filter can also be disjunctive

    var disjunctiveNumericRefinedFacets = intersection(Object.keys(this.numericRefinements).filter(function (facet) {
      return Object.keys(self.numericRefinements[facet]).length > 0;
    }), this.disjunctiveFacets);
    return Object.keys(this.disjunctiveFacetsRefinements).filter(function (facet) {
      return self.disjunctiveFacetsRefinements[facet].length > 0;
    }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets());
  },

  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */
  getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
    var self = this;
    return intersection( // enforce the order between the two arrays,
    // so that refinement name index === hierarchical facet index
    this.hierarchicalFacets.map(function (facet) {
      return facet.name;
    }), Object.keys(this.hierarchicalFacetsRefinements).filter(function (facet) {
      return self.hierarchicalFacetsRefinements[facet].length > 0;
    }));
  },

  /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]}
   */
  getUnrefinedDisjunctiveFacets: function () {
    var refinedFacets = this.getRefinedDisjunctiveFacets();
    return this.disjunctiveFacets.filter(function (f) {
      return refinedFacets.indexOf(f) === -1;
    });
  },
  managedParameters: ['index', 'facets', 'disjunctiveFacets', 'facetsRefinements', 'hierarchicalFacets', 'facetsExcludes', 'disjunctiveFacetsRefinements', 'numericRefinements', 'tagRefinements', 'hierarchicalFacetsRefinements'],
  getQueryParams: function getQueryParams() {
    var managedParameters = this.managedParameters;
    var queryParams = {};
    var self = this;
    Object.keys(this).forEach(function (paramName) {
      var paramValue = self[paramName];

      if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) {
        queryParams[paramName] = paramValue;
      }
    });
    return queryParams;
  },

  /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */
  setQueryParameter: function setParameter(parameter, value) {
    if (this[parameter] === value) return this;
    var modification = {};
    modification[parameter] = value;
    return this.setQueryParameters(modification);
  },

  /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */
  setQueryParameters: function setQueryParameters(params) {
    if (!params) return this;
    var error = SearchParameters.validate(this, params);

    if (error) {
      throw error;
    }

    var self = this;

    var nextWithNumbers = SearchParameters._parseNumbers(params);

    var previousPlainObject = Object.keys(this).reduce(function (acc, key) {
      acc[key] = self[key];
      return acc;
    }, {});
    var nextPlainObject = Object.keys(nextWithNumbers).reduce(function (previous, key) {
      var isPreviousValueDefined = previous[key] !== undefined;
      var isNextValueDefined = nextWithNumbers[key] !== undefined;

      if (isPreviousValueDefined && !isNextValueDefined) {
        return omit(previous, [key]);
      }

      if (isNextValueDefined) {
        previous[key] = nextWithNumbers[key];
      }

      return previous;
    }, previousPlainObject);
    return new this.constructor(nextPlainObject);
  },

  /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */
  resetPage: function () {
    if (this.page === undefined) {
      return this;
    }

    return this.setPage(0);
  },

  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSortBy: function (hierarchicalFacet) {
    return hierarchicalFacet.sortBy || ['isRefined:desc', 'name:asc'];
  },

  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSeparator: function (hierarchicalFacet) {
    return hierarchicalFacet.separator || ' > ';
  },

  /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */
  _getHierarchicalRootPath: function (hierarchicalFacet) {
    return hierarchicalFacet.rootPath || null;
  },

  /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */
  _getHierarchicalShowParentLevel: function (hierarchicalFacet) {
    if (typeof hierarchicalFacet.showParentLevel === 'boolean') {
      return hierarchicalFacet.showParentLevel;
    }

    return true;
  },

  /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName
   * @return {object} a hierarchicalFacet
   */
  getHierarchicalFacetByName: function (hierarchicalFacetName) {
    return find(this.hierarchicalFacets, function (f) {
      return f.name === hierarchicalFacetName;
    });
  },

  /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */
  getHierarchicalFacetBreadcrumb: function (facetName) {
    if (!this.isHierarchicalFacet(facetName)) {
      return [];
    }

    var refinement = this.getHierarchicalRefinement(facetName)[0];
    if (!refinement) return [];

    var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));

    var path = refinement.split(separator);
    return path.map(function (part) {
      return part.trim();
    });
  },
  toString: function () {
    return JSON.stringify(this, null, 2);
  }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */

module.exports = SearchParameters;

/***/ }),

/***/ 5270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = generateTrees;

var orderBy = __webpack_require__(3689);

var find = __webpack_require__(8671);

var prepareHierarchicalFacetSortBy = __webpack_require__(4771);

var fv = __webpack_require__(9785);

var escapeFacetValue = fv.escapeFacetValue;
var unescapeFacetValue = fv.unescapeFacetValue;

function generateTrees(state) {
  return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
    var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
    var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';

    var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

    var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);

    var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);

    var sortBy = prepareHierarchicalFacetSortBy(state._getHierarchicalFacetSortBy(hierarchicalFacet));
    var rootExhaustive = hierarchicalFacetResult.every(function (facetResult) {
      return facetResult.exhaustive;
    });
    var generateTreeFn = generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
    var results = hierarchicalFacetResult;

    if (hierarchicalRootPath) {
      results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
    }

    return results.reduce(generateTreeFn, {
      name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
      count: null,
      // root level, no count
      isRefined: true,
      // root level, always refined
      path: null,
      // root level, no path
      escapedValue: null,
      exhaustive: rootExhaustive,
      data: null
    });
  };
}

function generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
  return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
    var parent = hierarchicalTree;

    if (currentHierarchicalLevel > 0) {
      var level = 0;
      parent = hierarchicalTree;

      while (level < currentHierarchicalLevel) {
        /**
         * @type {object[]]} hierarchical data
         */
        var data = parent && Array.isArray(parent.data) ? parent.data : [];
        parent = find(data, function (subtree) {
          return subtree.isRefined;
        });
        level++;
      }
    } // we found a refined parent, let's add current level data under it


    if (parent) {
      // filter values in case an object has multiple categories:
      //   {
      //     categories: {
      //       level0: ['beers', 'bières'],
      //       level1: ['beers > IPA', 'bières > Belges']
      //     }
      //   }
      //
      // If parent refinement is `beers`, then we do not want to have `bières > Belges`
      // showing up
      var picked = Object.keys(hierarchicalFacetResult.data).map(function (facetValue) {
        return [facetValue, hierarchicalFacetResult.data[facetValue]];
      }).filter(function (tuple) {
        var facetValue = tuple[0];
        return onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
      });
      parent.data = orderBy(picked.map(function (tuple) {
        var facetValue = tuple[0];
        var facetCount = tuple[1];
        return format(facetCount, facetValue, hierarchicalSeparator, unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
      }), sortBy[0], sortBy[1]);
    }

    return hierarchicalTree;
  };
}

function onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
  // we want the facetValue is a child of hierarchicalRootPath
  if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) {
    return false;
  } // we always want root levels (only when there is no prefix path)


  return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
  hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
  // keep the facetValue
  facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
  currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
  facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}

function format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
  var parts = facetValue.split(hierarchicalSeparator);
  return {
    name: parts[parts.length - 1].trim(),
    path: facetValue,
    escapedValue: escapeFacetValue(facetValue),
    count: facetCount,
    isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
    exhaustive: exhaustive,
    data: null
  };
}

/***/ }),

/***/ 2454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

var merge = __webpack_require__(4532);

var defaultsPure = __webpack_require__(6847);

var orderBy = __webpack_require__(3689);

var compact = __webpack_require__(180);

var find = __webpack_require__(8671);

var findIndex = __webpack_require__(238);

var formatSort = __webpack_require__(4771);

var fv = __webpack_require__(9785);

var escapeFacetValue = fv.escapeFacetValue;
var unescapeFacetValue = fv.unescapeFacetValue;

var generateHierarchicalTree = __webpack_require__(5270);
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */

/**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */

/**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */

/**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */

/**
 * @param {string[]} attributes
 */


function getIndices(attributes) {
  var indices = {};
  attributes.forEach(function (val, idx) {
    indices[val] = idx;
  });
  return indices;
}

function assignFacetStats(dest, facetStats, key) {
  if (facetStats && facetStats[key]) {
    dest.stats = facetStats[key];
  }
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */

/**
 * @param {HierarchicalFacet[]} hierarchicalFacets
 * @param {string} hierarchicalAttributeName
 */


function findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
  return find(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
    var facetNames = hierarchicalFacet.attributes || [];
    return facetNames.indexOf(hierarchicalAttributeName) > -1;
  });
}
/*eslint-disable */

/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/

/*eslint-enable */


function SearchResults(state, results, options) {
  var mainSubResponse = results[0];
  this._rawResults = results;
  var self = this; // https://www.algolia.com/doc/api-reference/api-methods/search/#response

  Object.keys(mainSubResponse).forEach(function (key) {
    self[key] = mainSubResponse[key];
  }); // Make every key of the result options reachable from the instance

  Object.keys(options || {}).forEach(function (key) {
    self[key] = options[key];
  });
  /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */

  /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */

  /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   *  - `value` : the value of the facet highlighted (html)
   *  - `matchLevel`: full, partial or none depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */

  /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */

  /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */

  /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */

  /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */

  /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */

  /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */

  /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */

  /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */

  /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */

  /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */

  /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */

  /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */

  /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */

  /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */

  /**
   * sum of the processing time of all the queries
   * @member {number}
   */

  this.processingTimeMS = results.reduce(function (sum, result) {
    return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
  }, 0);
  /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */

  this.disjunctiveFacets = [];
  /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */

  this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
    return [];
  });
  /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */

  this.facets = [];
  var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
  var facetsIndices = getIndices(state.facets);
  var disjunctiveFacetsIndices = getIndices(state.disjunctiveFacets);
  var nextDisjunctiveResult = 1; // Since we send request only for disjunctive facets that have been refined,
  // we get the facets information from the first, general, response.

  var mainFacets = mainSubResponse.facets || {};
  Object.keys(mainFacets).forEach(function (facetKey) {
    var facetValueObject = mainFacets[facetKey];
    var hierarchicalFacet = findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);

    if (hierarchicalFacet) {
      // Place the hierarchicalFacet data at the correct index depending on
      // the attributes order that was defined at the helper initialization
      var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
      var idxAttributeName = findIndex(state.hierarchicalFacets, function (f) {
        return f.name === hierarchicalFacet.name;
      });
      self.hierarchicalFacets[idxAttributeName][facetIndex] = {
        attribute: facetKey,
        data: facetValueObject,
        exhaustive: mainSubResponse.exhaustiveFacetsCount
      };
    } else {
      var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
      var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
      var position;

      if (isFacetDisjunctive) {
        position = disjunctiveFacetsIndices[facetKey];
        self.disjunctiveFacets[position] = {
          name: facetKey,
          data: facetValueObject,
          exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
      }

      if (isFacetConjunctive) {
        position = facetsIndices[facetKey];
        self.facets[position] = {
          name: facetKey,
          data: facetValueObject,
          exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
      }
    }
  }); // Make sure we do not keep holes within the hierarchical facets

  this.hierarchicalFacets = compact(this.hierarchicalFacets); // aggregate the refined disjunctive facets

  disjunctiveFacets.forEach(function (disjunctiveFacet) {
    var result = results[nextDisjunctiveResult];
    var facets = result && result.facets ? result.facets : {};
    var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet); // There should be only item in facets.

    Object.keys(facets).forEach(function (dfacet) {
      var facetResults = facets[dfacet];
      var position;

      if (hierarchicalFacet) {
        position = findIndex(state.hierarchicalFacets, function (f) {
          return f.name === hierarchicalFacet.name;
        });
        var attributeIndex = findIndex(self.hierarchicalFacets[position], function (f) {
          return f.attribute === dfacet;
        }); // previous refinements and no results so not able to find it

        if (attributeIndex === -1) {
          return;
        }

        self.hierarchicalFacets[position][attributeIndex].data = merge({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
      } else {
        position = disjunctiveFacetsIndices[dfacet];
        var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
        self.disjunctiveFacets[position] = {
          name: dfacet,
          data: defaultsPure({}, facetResults, dataFromMainRequest),
          exhaustive: result.exhaustiveFacetsCount
        };
        assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);

        if (state.disjunctiveFacetsRefinements[dfacet]) {
          state.disjunctiveFacetsRefinements[dfacet].forEach(function (refinementValue) {
            // add the disjunctive refinements if it is no more retrieved
            if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf(unescapeFacetValue(refinementValue)) > -1) {
              self.disjunctiveFacets[position].data[refinementValue] = 0;
            }
          });
        }
      }
    });
    nextDisjunctiveResult++;
  }); // if we have some root level values for hierarchical facets, merge them

  state.getRefinedHierarchicalFacets().forEach(function (refinedFacet) {
    var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);

    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

    var currentRefinement = state.getHierarchicalRefinement(refinedFacet); // if we are already at a root refinement (or no refinement at all), there is no
    // root level values request

    if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) {
      return;
    }

    var result = results[nextDisjunctiveResult];
    var facets = result && result.facets ? result.facets : {};
    Object.keys(facets).forEach(function (dfacet) {
      var facetResults = facets[dfacet];
      var position = findIndex(state.hierarchicalFacets, function (f) {
        return f.name === hierarchicalFacet.name;
      });
      var attributeIndex = findIndex(self.hierarchicalFacets[position], function (f) {
        return f.attribute === dfacet;
      }); // previous refinements and no results so not able to find it

      if (attributeIndex === -1) {
        return;
      } // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
      // then the disjunctive values will be `beers` (count: 100),
      // but we do not want to display
      //   | beers (100)
      //     > IPA (5)
      // We want
      //   | beers (5)
      //     > IPA (5)


      var defaultData = {};

      if (currentRefinement.length > 0) {
        var root = currentRefinement[0].split(separator)[0];
        defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
      }

      self.hierarchicalFacets[position][attributeIndex].data = defaultsPure(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
    });
    nextDisjunctiveResult++;
  }); // add the excludes

  Object.keys(state.facetsExcludes).forEach(function (facetName) {
    var excludes = state.facetsExcludes[facetName];
    var position = facetsIndices[facetName];
    self.facets[position] = {
      name: facetName,
      data: mainSubResponse.facets[facetName],
      exhaustive: mainSubResponse.exhaustiveFacetsCount
    };
    excludes.forEach(function (facetValue) {
      self.facets[position] = self.facets[position] || {
        name: facetName
      };
      self.facets[position].data = self.facets[position].data || {};
      self.facets[position].data[facetValue] = 0;
    });
  });
  /**
   * @type {Array}
   */

  this.hierarchicalFacets = this.hierarchicalFacets.map(generateHierarchicalTree(state));
  /**
   * @type {Array}
   */

  this.facets = compact(this.facets);
  /**
   * @type {Array}
   */

  this.disjunctiveFacets = compact(this.disjunctiveFacets);
  this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */


SearchResults.prototype.getFacetByName = function (name) {
  function predicate(facet) {
    return facet.name === name;
  }

  return find(this.facets, predicate) || find(this.disjunctiveFacets, predicate) || find(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */


function extractNormalizedFacetValues(results, attribute) {
  function predicate(facet) {
    return facet.name === attribute;
  }

  if (results._state.isConjunctiveFacet(attribute)) {
    var facet = find(results.facets, predicate);
    if (!facet) return [];
    return Object.keys(facet.data).map(function (name) {
      var value = escapeFacetValue(name);
      return {
        name: name,
        escapedValue: value,
        count: facet.data[name],
        isRefined: results._state.isFacetRefined(attribute, value),
        isExcluded: results._state.isExcludeRefined(attribute, name)
      };
    });
  } else if (results._state.isDisjunctiveFacet(attribute)) {
    var disjunctiveFacet = find(results.disjunctiveFacets, predicate);
    if (!disjunctiveFacet) return [];
    return Object.keys(disjunctiveFacet.data).map(function (name) {
      var value = escapeFacetValue(name);
      return {
        name: name,
        escapedValue: value,
        count: disjunctiveFacet.data[name],
        isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
      };
    });
  } else if (results._state.isHierarchicalFacet(attribute)) {
    return find(results.hierarchicalFacets, predicate);
  }
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 */


function recSort(sortFn, node, names, level) {
  level = level || 0;

  if (Array.isArray(node)) {
    return sortFn(node, names[level]);
  }

  if (!node.data || node.data.length === 0) {
    return node;
  }

  var children = node.data.map(function (childNode) {
    return recSort(sortFn, childNode, names, level + 1);
  });
  var sortedChildren = sortFn(children, names[level]);
  var newNode = defaultsPure({
    data: sortedChildren
  }, node);
  return newNode;
}

SearchResults.DEFAULT_SORT = ['isRefined:desc', 'count:desc', 'name:asc'];

function vanillaSortFn(order, data) {
  return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */

/**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array}
 */


function sortViaFacetOrdering(facetValues, facetOrdering) {
  var orderedFacets = [];
  var remainingFacets = [];
  var order = facetOrdering.order || [];
  /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */

  var reverseOrder = order.reduce(function (acc, name, i) {
    acc[name] = i;
    return acc;
  }, {});
  facetValues.forEach(function (item) {
    // hierarchical facets get sorted using their raw name
    var name = item.path || item.name;

    if (reverseOrder[name] !== undefined) {
      orderedFacets[reverseOrder[name]] = item;
    } else {
      remainingFacets.push(item);
    }
  });
  orderedFacets = orderedFacets.filter(function (facet) {
    return facet;
  });
  var sortRemainingBy = facetOrdering.sortRemainingBy;
  var ordering;

  if (sortRemainingBy === 'hidden') {
    return orderedFacets;
  } else if (sortRemainingBy === 'alpha') {
    ordering = [['path', 'name'], ['asc', 'asc']];
  } else {
    ordering = [['count'], ['desc']];
  }

  return orderedFacets.concat(orderBy(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering=}
 */


function getFacetOrdering(results, attribute) {
  return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */


SearchResults.prototype.getFacetValues = function (attribute, opts) {
  var facetValues = extractNormalizedFacetValues(this, attribute);

  if (!facetValues) {
    return undefined;
  }

  var options = defaultsPure({}, opts, {
    sortBy: SearchResults.DEFAULT_SORT,
    // if no sortBy is given, attempt to sort based on facetOrdering
    // if it is given, we still allow to sort via facet ordering first
    facetOrdering: !(opts && opts.sortBy)
  });
  var results = this;
  var attributes;

  if (Array.isArray(facetValues)) {
    attributes = [attribute];
  } else {
    var config = results._state.getHierarchicalFacetByName(facetValues.name);

    attributes = config.attributes;
  }

  return recSort(function (data, facetName) {
    if (options.facetOrdering) {
      var facetOrdering = getFacetOrdering(results, facetName);

      if (Boolean(facetOrdering)) {
        return sortViaFacetOrdering(data, facetOrdering);
      }
    }

    if (Array.isArray(options.sortBy)) {
      var order = formatSort(options.sortBy, SearchResults.DEFAULT_SORT);
      return orderBy(data, order[0], order[1]);
    } else if (typeof options.sortBy === 'function') {
      return vanillaSortFn(options.sortBy, data);
    }

    throw new Error('options.sortBy is optional but if defined it must be ' + 'either an array of string (predicates) or a sorting function');
  }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */


SearchResults.prototype.getFacetStats = function (attribute) {
  if (this._state.isConjunctiveFacet(attribute)) {
    return getFacetStatsIfAvailable(this.facets, attribute);
  } else if (this._state.isDisjunctiveFacet(attribute)) {
    return getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
  }

  return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */

/**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName
 */


function getFacetStatsIfAvailable(facetList, facetName) {
  var data = find(facetList, function (facet) {
    return facet.name === facetName;
  });
  return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */


SearchResults.prototype.getRefinements = function () {
  var state = this._state;
  var results = this;
  var res = [];
  Object.keys(state.facetsRefinements).forEach(function (attributeName) {
    state.facetsRefinements[attributeName].forEach(function (name) {
      res.push(getRefinement(state, 'facet', attributeName, name, results.facets));
    });
  });
  Object.keys(state.facetsExcludes).forEach(function (attributeName) {
    state.facetsExcludes[attributeName].forEach(function (name) {
      res.push(getRefinement(state, 'exclude', attributeName, name, results.facets));
    });
  });
  Object.keys(state.disjunctiveFacetsRefinements).forEach(function (attributeName) {
    state.disjunctiveFacetsRefinements[attributeName].forEach(function (name) {
      res.push(getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
    });
  });
  Object.keys(state.hierarchicalFacetsRefinements).forEach(function (attributeName) {
    state.hierarchicalFacetsRefinements[attributeName].forEach(function (name) {
      res.push(getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
    });
  });
  Object.keys(state.numericRefinements).forEach(function (attributeName) {
    var operators = state.numericRefinements[attributeName];
    Object.keys(operators).forEach(function (operator) {
      operators[operator].forEach(function (value) {
        res.push({
          type: 'numeric',
          attributeName: attributeName,
          name: value,
          numericValue: value,
          operator: operator
        });
      });
    });
  });
  state.tagRefinements.forEach(function (name) {
    res.push({
      type: 'tag',
      attributeName: '_tags',
      name: name
    });
  });
  return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */

/**
 * @param {*} state
 * @param {*} type
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */


function getRefinement(state, type, attributeName, name, resultsFacets) {
  var facet = find(resultsFacets, function (f) {
    return f.name === attributeName;
  });
  var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
  var exhaustive = facet && facet.exhaustive || false;
  return {
    type: type,
    attributeName: attributeName,
    name: name,
    count: count,
    exhaustive: exhaustive
  };
}
/**
 * @param {*} state
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */


function getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
  var facetDeclaration = state.getHierarchicalFacetByName(attributeName);

  var separator = state._getHierarchicalFacetSeparator(facetDeclaration);

  var split = name.split(separator);
  var rootFacet = find(resultsFacets, function (facet) {
    return facet.name === attributeName;
  });
  var facet = split.reduce(function (intermediateFacet, part) {
    var newFacet = intermediateFacet && find(intermediateFacet.data, function (f) {
      return f.name === part;
    });
    return newFacet !== undefined ? newFacet : intermediateFacet;
  }, rootFacet);
  var count = facet && facet.count || 0;
  var exhaustive = facet && facet.exhaustive || false;
  var path = facet && facet.path || '';
  return {
    type: 'hierarchical',
    attributeName: attributeName,
    name: path,
    count: count,
    exhaustive: exhaustive
  };
}

module.exports = SearchResults;

/***/ }),

/***/ 410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

var SearchParameters = __webpack_require__(5527);

var SearchResults = __webpack_require__(2454);

var DerivedHelper = __webpack_require__(9717);

var requestBuilder = __webpack_require__(5697);

var EventEmitter = __webpack_require__(8878);

var inherits = __webpack_require__(7306);

var objectHasKeys = __webpack_require__(8067);

var omit = __webpack_require__(1845);

var merge = __webpack_require__(4532);

var version = __webpack_require__(8147);

var escapeFacetValue = (__webpack_require__(9785).escapeFacetValue);
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */

/**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */

/**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */

/**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */

/**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */

/**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */

/**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */

/**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */


function AlgoliaSearchHelper(client, index, options) {
  if (typeof client.addAlgoliaAgent === 'function') {
    client.addAlgoliaAgent('JS Helper (' + version + ')');
  }

  this.setClient(client);
  var opts = options || {};
  opts.index = index;
  this.state = SearchParameters.make(opts);
  this.lastResults = null;
  this._queryId = 0;
  this._lastQueryIdReceived = -1;
  this.derivedHelpers = [];
  this._currentNbQueries = 0;
}

inherits(AlgoliaSearchHelper, EventEmitter);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper}
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */

AlgoliaSearchHelper.prototype.search = function () {
  this._search({
    onlyWithDerivedHelpers: false
  });

  return this;
};

AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function () {
  this._search({
    onlyWithDerivedHelpers: true
  });

  return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */


AlgoliaSearchHelper.prototype.getQuery = function () {
  var state = this.state;
  return requestBuilder._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [callback] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */


AlgoliaSearchHelper.prototype.searchOnce = function (options, cb) {
  var tempState = !options ? this.state : this.state.setQueryParameters(options);

  var queries = requestBuilder._getQueries(tempState.index, tempState);

  var self = this;
  this._currentNbQueries++;
  this.emit('searchOnce', {
    state: tempState
  });

  if (cb) {
    this.client.search(queries).then(function (content) {
      self._currentNbQueries--;

      if (self._currentNbQueries === 0) {
        self.emit('searchQueueEmpty');
      }

      cb(null, new SearchResults(tempState, content.results), tempState);
    }).catch(function (err) {
      self._currentNbQueries--;

      if (self._currentNbQueries === 0) {
        self.emit('searchQueueEmpty');
      }

      cb(err, null, tempState);
    });
    return undefined;
  }

  return this.client.search(queries).then(function (content) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    return {
      content: new SearchResults(tempState, content.results),
      state: tempState,
      _originalResponse: content
    };
  }, function (e) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    throw e;
  });
};
/**
* Start the search for answers with the parameters set in the state.
* This method returns a promise.
* @param {Object} options - the options for answers API call
* @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
* @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
* @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
*
* @return {promise} the answer results
*/


AlgoliaSearchHelper.prototype.findAnswers = function (options) {
  var state = this.state;
  var derivedHelper = this.derivedHelpers[0];

  if (!derivedHelper) {
    return Promise.resolve([]);
  }

  var derivedState = derivedHelper.getModifiedState(state);
  var data = merge({
    attributesForPrediction: options.attributesForPrediction,
    nbHits: options.nbHits
  }, {
    params: omit(requestBuilder._getHitsSearchParams(derivedState), ['attributesToSnippet', 'hitsPerPage', 'restrictSearchableAttributes', 'snippetEllipsisText' // FIXME remove this line once the engine is fixed.
    ])
  });
  var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';

  if (typeof this.client.initIndex !== 'function') {
    throw new Error(errorMessage);
  }

  var index = this.client.initIndex(derivedState.index);

  if (typeof index.findAnswers !== 'function') {
    throw new Error(errorMessage);
  }

  return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */

/**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */

/**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */


AlgoliaSearchHelper.prototype.searchForFacetValues = function (facet, query, maxFacetHits, userState) {
  var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';

  if (!clientHasSFFV && typeof this.client.initIndex !== 'function') {
    throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
  }

  var state = this.state.setQueryParameters(userState || {});
  var isDisjunctive = state.isDisjunctiveFacet(facet);
  var algoliaQuery = requestBuilder.getSearchForFacetQuery(facet, query, maxFacetHits, state);
  this._currentNbQueries++;
  var self = this;
  this.emit('searchForFacetValues', {
    state: state,
    facet: facet,
    query: query
  });
  var searchForFacetValuesPromise = clientHasSFFV ? this.client.searchForFacetValues([{
    indexName: state.index,
    params: algoliaQuery
  }]) : this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
  return searchForFacetValuesPromise.then(function addIsRefined(content) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    content = Array.isArray(content) ? content[0] : content;
    content.facetHits.forEach(function (f) {
      f.escapedValue = escapeFacetValue(f.value);
      f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
    });
    return content;
  }, function (e) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    throw e;
  });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.setQuery = function (q) {
  this._change({
    state: this.state.resetPage().setQuery(q),
    isPageReset: true
  });

  return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */


AlgoliaSearchHelper.prototype.clearRefinements = function (name) {
  this._change({
    state: this.state.resetPage().clearRefinements(name),
    isPageReset: true
  });

  return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.clearTags = function () {
  this._change({
    state: this.state.resetPage().clearTags(),
    isPageReset: true
  });

  return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */


AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function () {
  return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */


AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().addHierarchicalFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.addNumericRefinement = function (attribute, operator, value) {
  this._change({
    state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
    isPageReset: true
  });

  return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.addFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().addFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */


AlgoliaSearchHelper.prototype.addRefine = function () {
  return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.addFacetExclusion = function (facet, value) {
  this._change({
    state: this.state.resetPage().addExcludeRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */


AlgoliaSearchHelper.prototype.addExclude = function () {
  return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.addTag = function (tag) {
  this._change({
    state: this.state.resetPage().addTagRefinement(tag),
    isPageReset: true
  });

  return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeNumericRefinement = function (attribute, operator, value) {
  this._change({
    state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
    isPageReset: true
  });

  return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */


AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function () {
  return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function (facet) {
  this._change({
    state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
    isPageReset: true
  });

  return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().removeFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */


AlgoliaSearchHelper.prototype.removeRefine = function () {
  return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeFacetExclusion = function (facet, value) {
  this._change({
    state: this.state.resetPage().removeExcludeRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */


AlgoliaSearchHelper.prototype.removeExclude = function () {
  return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.removeTag = function (tag) {
  this._change({
    state: this.state.resetPage().removeTagRefinement(tag),
    isPageReset: true
  });

  return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.toggleFacetExclusion = function (facet, value) {
  this._change({
    state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */


AlgoliaSearchHelper.prototype.toggleExclude = function () {
  return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */


AlgoliaSearchHelper.prototype.toggleRefinement = function (facet, value) {
  return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.toggleFacetRefinement = function (facet, value) {
  this._change({
    state: this.state.resetPage().toggleFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */


AlgoliaSearchHelper.prototype.toggleRefine = function () {
  return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.toggleTag = function (tag) {
  this._change({
    state: this.state.resetPage().toggleTagRefinement(tag),
    isPageReset: true
  });

  return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */


AlgoliaSearchHelper.prototype.nextPage = function () {
  var page = this.state.page || 0;
  return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper}
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */


AlgoliaSearchHelper.prototype.previousPage = function () {
  var page = this.state.page || 0;
  return this.setPage(page - 1);
};
/**
 * @private
 */


function setCurrentPage(page) {
  if (page < 0) throw new Error('Page requested below 0.');

  this._change({
    state: this.state.setPage(page),
    isPageReset: false
  });

  return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.setCurrentPage = setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */

AlgoliaSearchHelper.prototype.setPage = setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */

AlgoliaSearchHelper.prototype.setIndex = function (name) {
  this._change({
    state: this.state.resetPage().setIndex(name),
    isPageReset: true
  });

  return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */


AlgoliaSearchHelper.prototype.setQueryParameter = function (parameter, value) {
  this._change({
    state: this.state.resetPage().setQueryParameter(parameter, value),
    isPageReset: true
  });

  return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */


AlgoliaSearchHelper.prototype.setState = function (newState) {
  this._change({
    state: SearchParameters.make(newState),
    isPageReset: false
  });

  return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */


AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function (newState) {
  this.state = new SearchParameters(newState);
  return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */


AlgoliaSearchHelper.prototype.hasRefinements = function (attribute) {
  if (objectHasKeys(this.state.getNumericRefinements(attribute))) {
    return true;
  } else if (this.state.isConjunctiveFacet(attribute)) {
    return this.state.isFacetRefined(attribute);
  } else if (this.state.isDisjunctiveFacet(attribute)) {
    return this.state.isDisjunctiveFacetRefined(attribute);
  } else if (this.state.isHierarchicalFacet(attribute)) {
    return this.state.isHierarchicalFacetRefined(attribute);
  } // there's currently no way to know that the user did call `addNumericRefinement` at some point
  // thus we cannot distinguish if there once was a numeric refinement that was cleared
  // so we will return false in every other situations to be consistent
  // while what we should do here is throw because we did not find the attribute in any type
  // of refinement


  return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
   * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */


AlgoliaSearchHelper.prototype.isExcluded = function (facet, value) {
  return this.state.isExcludeRefined(facet, value);
};
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */


AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function (facet, value) {
  return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean}
 */


AlgoliaSearchHelper.prototype.hasTag = function (tag) {
  return this.state.isTagRefined(tag);
};
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */


AlgoliaSearchHelper.prototype.isTagRefined = function () {
  return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string}
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */


AlgoliaSearchHelper.prototype.getIndex = function () {
  return this.state.index;
};

function getCurrentPage() {
  return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */


AlgoliaSearchHelper.prototype.getCurrentPage = getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */

AlgoliaSearchHelper.prototype.getPage = getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */

AlgoliaSearchHelper.prototype.getTags = function () {
  return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */


AlgoliaSearchHelper.prototype.getRefinements = function (facetName) {
  var refinements = [];

  if (this.state.isConjunctiveFacet(facetName)) {
    var conjRefinements = this.state.getConjunctiveRefinements(facetName);
    conjRefinements.forEach(function (r) {
      refinements.push({
        value: r,
        type: 'conjunctive'
      });
    });
    var excludeRefinements = this.state.getExcludeRefinements(facetName);
    excludeRefinements.forEach(function (r) {
      refinements.push({
        value: r,
        type: 'exclude'
      });
    });
  } else if (this.state.isDisjunctiveFacet(facetName)) {
    var disjRefinements = this.state.getDisjunctiveRefinements(facetName);
    disjRefinements.forEach(function (r) {
      refinements.push({
        value: r,
        type: 'disjunctive'
      });
    });
  }

  var numericRefinements = this.state.getNumericRefinements(facetName);
  Object.keys(numericRefinements).forEach(function (operator) {
    var value = numericRefinements[operator];
    refinements.push({
      value: value,
      operator: operator,
      type: 'numeric'
    });
  });
  return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */


AlgoliaSearchHelper.prototype.getNumericRefinement = function (attribute, operator) {
  return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */


AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function (facetName) {
  return this.state.getHierarchicalFacetBreadcrumb(facetName);
}; // /////////// PRIVATE

/**
 * Perform the underlying queries
 * @private
 * @return {undefined}
 * @fires search
 * @fires result
 * @fires error
 */


AlgoliaSearchHelper.prototype._search = function (options) {
  var state = this.state;
  var states = [];
  var mainQueries = [];

  if (!options.onlyWithDerivedHelpers) {
    mainQueries = requestBuilder._getQueries(state.index, state);
    states.push({
      state: state,
      queriesCount: mainQueries.length,
      helper: this
    });
    this.emit('search', {
      state: state,
      results: this.lastResults
    });
  }

  var derivedQueries = this.derivedHelpers.map(function (derivedHelper) {
    var derivedState = derivedHelper.getModifiedState(state);

    var derivedStateQueries = requestBuilder._getQueries(derivedState.index, derivedState);

    states.push({
      state: derivedState,
      queriesCount: derivedStateQueries.length,
      helper: derivedHelper
    });
    derivedHelper.emit('search', {
      state: derivedState,
      results: derivedHelper.lastResults
    });
    return derivedStateQueries;
  });
  var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
  var queryId = this._queryId++;
  this._currentNbQueries++;

  try {
    this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
  } catch (error) {
    // If we reach this part, we're in an internal error state
    this.emit('error', {
      error: error
    });
  }
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>}
 *  state state used for to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */


AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function (states, queryId, content) {
  // FIXME remove the number of outdated queries discarded instead of just one
  if (queryId < this._lastQueryIdReceived) {
    // Outdated answer
    return;
  }

  this._currentNbQueries -= queryId - this._lastQueryIdReceived;
  this._lastQueryIdReceived = queryId;
  if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
  var results = content.results.slice();
  states.forEach(function (s) {
    var state = s.state;
    var queriesCount = s.queriesCount;
    var helper = s.helper;
    var specificResults = results.splice(0, queriesCount);
    var formattedResponse = helper.lastResults = new SearchResults(state, specificResults);
    helper.emit('result', {
      results: formattedResponse,
      state: state
    });
  });
};

AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function (queryId, error) {
  if (queryId < this._lastQueryIdReceived) {
    // Outdated answer
    return;
  }

  this._currentNbQueries -= queryId - this._lastQueryIdReceived;
  this._lastQueryIdReceived = queryId;
  this.emit('error', {
    error: error
  });
  if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};

AlgoliaSearchHelper.prototype.containsRefinement = function (query, facetFilters, numericFilters, tagFilters) {
  return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean}
 */


AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function (facet) {
  return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};

AlgoliaSearchHelper.prototype._change = function (event) {
  var state = event.state;
  var isPageReset = event.isPageReset;

  if (state !== this.state) {
    this.state = state;
    this.emit('change', {
      state: this.state,
      results: this.lastResults,
      isPageReset: isPageReset
    });
  }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper}
 */


AlgoliaSearchHelper.prototype.clearCache = function () {
  this.client.clearCache && this.client.clearCache();
  return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper}
 */


AlgoliaSearchHelper.prototype.setClient = function (newClient) {
  if (this.client === newClient) return this;

  if (typeof newClient.addAlgoliaAgent === 'function') {
    newClient.addAlgoliaAgent('JS Helper (' + version + ')');
  }

  this.client = newClient;
  return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch}
 */


AlgoliaSearchHelper.prototype.getClient = function () {
  return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper}
 */


AlgoliaSearchHelper.prototype.derive = function (fn) {
  var derivedHelper = new DerivedHelper(this, fn);
  this.derivedHelpers.push(derivedHelper);
  return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @return {undefined}
 * @throws Error
 */


AlgoliaSearchHelper.prototype.detachDerivedHelper = function (derivedHelper) {
  var pos = this.derivedHelpers.indexOf(derivedHelper);
  if (pos === -1) throw new Error('Derived helper already detached');
  this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */


AlgoliaSearchHelper.prototype.hasPendingRequests = function () {
  return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */

/**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */


module.exports = AlgoliaSearchHelper;

/***/ }),

/***/ 180:
/***/ (function(module) {

"use strict";


module.exports = function compact(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter(Boolean);
};

/***/ }),

/***/ 6847:
/***/ (function(module) {

"use strict";
 // NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order

module.exports = function defaultsPure() {
  var sources = Array.prototype.slice.call(arguments);
  return sources.reduceRight(function (acc, source) {
    Object.keys(Object(source)).forEach(function (key) {
      if (source[key] === undefined) {
        return;
      }

      if (acc[key] !== undefined) {
        // remove if already added, so that we can add it in correct order
        delete acc[key];
      }

      acc[key] = source[key];
    });
    return acc;
  }, {});
};

/***/ }),

/***/ 9785:
/***/ (function(module) {

"use strict";

/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns any
 */

function escapeFacetValue(value) {
  if (typeof value !== 'string') return value;
  return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns any
 */


function unescapeFacetValue(value) {
  if (typeof value !== 'string') return value;
  return value.replace(/^\\-/, '-');
}

module.exports = {
  escapeFacetValue: escapeFacetValue,
  unescapeFacetValue: unescapeFacetValue
};

/***/ }),

/***/ 8671:
/***/ (function(module) {

"use strict";
 // @MAJOR can be replaced by native Array#find when we change support

module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return undefined;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return array[i];
    }
  }
};

/***/ }),

/***/ 238:
/***/ (function(module) {

"use strict";
 // @MAJOR can be replaced by native Array#findIndex when we change support

module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return -1;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return i;
    }
  }

  return -1;
};

/***/ }),

/***/ 4771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var find = __webpack_require__(8671);
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */


module.exports = function formatSort(sortBy, defaults) {
  var defaultInstructions = (defaults || []).map(function (sort) {
    return sort.split(':');
  });
  return sortBy.reduce(function preparePredicate(out, sort) {
    var sortInstruction = sort.split(':');
    var matchingDefault = find(defaultInstructions, function (defaultInstruction) {
      return defaultInstruction[0] === sortInstruction[0];
    });

    if (sortInstruction.length > 1 || !matchingDefault) {
      out[0].push(sortInstruction[0]);
      out[1].push(sortInstruction[1]);
      return out;
    }

    out[0].push(matchingDefault[0]);
    out[1].push(matchingDefault[1]);
    return out;
  }, [[], []]);
};

/***/ }),

/***/ 7306:
/***/ (function(module) {

"use strict";


function inherits(ctor, superCtor) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

module.exports = inherits;

/***/ }),

/***/ 839:
/***/ (function(module) {

"use strict";


function intersection(arr1, arr2) {
  return arr1.filter(function (value, index) {
    return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index
    /* skips duplicates */
    ;
  });
}

module.exports = intersection;

/***/ }),

/***/ 4532:
/***/ (function(module) {

"use strict";


function clone(value) {
  if (typeof value === 'object' && value !== null) {
    return _merge(Array.isArray(value) ? [] : {}, value);
  }

  return value;
}

function isObjectOrArrayOrFunction(value) {
  return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}

function _merge(target, source) {
  if (target === source) {
    return target;
  }

  for (var key in source) {
    if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__') {
      continue;
    }

    var sourceVal = source[key];
    var targetVal = target[key];

    if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') {
      continue;
    }

    if (isObjectOrArrayOrFunction(targetVal) && isObjectOrArrayOrFunction(sourceVal)) {
      target[key] = _merge(targetVal, sourceVal);
    } else {
      target[key] = clone(sourceVal);
    }
  }

  return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */


function merge(target) {
  if (!isObjectOrArrayOrFunction(target)) {
    target = {};
  }

  for (var i = 1, l = arguments.length; i < l; i++) {
    var source = arguments[i];

    if (isObjectOrArrayOrFunction(source)) {
      _merge(target, source);
    }
  }

  return target;
}

module.exports = merge;

/***/ }),

/***/ 8067:
/***/ (function(module) {

"use strict";


function objectHasKeys(obj) {
  return obj && Object.keys(obj).length > 0;
}

module.exports = objectHasKeys;

/***/ }),

/***/ 1845:
/***/ (function(module) {

"use strict";
 // https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source === null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key;
  var i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 3689:
/***/ (function(module) {

"use strict";


function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined;
    var valIsNull = value === null;
    var othIsDefined = other !== undefined;
    var othIsNull = other === null;

    if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) {
      return 1;
    }

    if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) {
      return -1;
    }
  }

  return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 */


function orderBy(collection, iteratees, orders) {
  if (!Array.isArray(collection)) {
    return [];
  }

  if (!Array.isArray(orders)) {
    orders = [];
  }

  var result = collection.map(function (value, index) {
    return {
      criteria: iteratees.map(function (iteratee) {
        return value[iteratee];
      }),
      index: index,
      value: value
    };
  });
  result.sort(function comparer(object, other) {
    var index = -1;

    while (++index < object.criteria.length) {
      var res = compareAscending(object.criteria[index], other.criteria[index]);

      if (res) {
        if (index >= orders.length) {
          return res;
        }

        if (orders[index] === 'desc') {
          return -res;
        }

        return res;
      }
    } // This ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


    return object.index - other.index;
  });
  return result.map(function (res) {
    return res.value;
  });
}

module.exports = orderBy;

/***/ }),

/***/ 2660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

function valToNumber(v) {
  if (typeof v === 'number') {
    return v;
  } else if (typeof v === 'string') {
    return parseFloat(v);
  } else if (Array.isArray(v)) {
    return v.map(valToNumber);
  }

  throw new Error('The value should be a number, a parsable string or an array of those.');
}

module.exports = valToNumber;

/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(4532);

var requestBuilder = {
  /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @return {object[]} The queries
   */
  _getQueries: function getQueries(index, state) {
    var queries = []; // One query for the hits

    queries.push({
      indexName: index,
      params: requestBuilder._getHitsSearchParams(state)
    }); // One for each disjunctive facets

    state.getRefinedDisjunctiveFacets().forEach(function (refinedFacet) {
      queries.push({
        indexName: index,
        params: requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
      });
    }); // maybe more to get the root level of hierarchical facets when activated

    state.getRefinedHierarchicalFacets().forEach(function (refinedFacet) {
      var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
      var currentRefinement = state.getHierarchicalRefinement(refinedFacet); // if we are deeper than level 0 (starting from `beer > IPA`)
      // we want to get the root values

      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

      if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
        queries.push({
          indexName: index,
          params: requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet, true)
        });
      }
    });
    return queries;
  },

  /**
   * Build search parameters used to fetch hits
   * @private
   * @return {object.<string, any>}
   */
  _getHitsSearchParams: function (state) {
    var facets = state.facets.concat(state.disjunctiveFacets).concat(requestBuilder._getHitsHierarchicalFacetsAttributes(state));

    var facetFilters = requestBuilder._getFacetFilters(state);

    var numericFilters = requestBuilder._getNumericFilters(state);

    var tagFilters = requestBuilder._getTagFilters(state);

    var additionalParams = {
      facets: facets.indexOf('*') > -1 ? ['*'] : facets,
      tagFilters: tagFilters
    };

    if (facetFilters.length > 0) {
      additionalParams.facetFilters = facetFilters;
    }

    if (numericFilters.length > 0) {
      additionalParams.numericFilters = numericFilters;
    }

    return merge({}, state.getQueryParams(), additionalParams);
  },

  /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object}
   */
  _getDisjunctiveFacetSearchParams: function (state, facet, hierarchicalRootLevel) {
    var facetFilters = requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);

    var numericFilters = requestBuilder._getNumericFilters(state, facet);

    var tagFilters = requestBuilder._getTagFilters(state);

    var additionalParams = {
      hitsPerPage: 1,
      page: 0,
      attributesToRetrieve: [],
      attributesToHighlight: [],
      attributesToSnippet: [],
      tagFilters: tagFilters,
      analytics: false,
      clickAnalytics: false
    };
    var hierarchicalFacet = state.getHierarchicalFacetByName(facet);

    if (hierarchicalFacet) {
      additionalParams.facets = requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
    } else {
      additionalParams.facets = facet;
    }

    if (numericFilters.length > 0) {
      additionalParams.numericFilters = numericFilters;
    }

    if (facetFilters.length > 0) {
      additionalParams.facetFilters = facetFilters;
    }

    return merge({}, state.getQueryParams(), additionalParams);
  },

  /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */
  _getNumericFilters: function (state, facetName) {
    if (state.numericFilters) {
      return state.numericFilters;
    }

    var numericFilters = [];
    Object.keys(state.numericRefinements).forEach(function (attribute) {
      var operators = state.numericRefinements[attribute] || {};
      Object.keys(operators).forEach(function (operator) {
        var values = operators[operator] || [];

        if (facetName !== attribute) {
          values.forEach(function (value) {
            if (Array.isArray(value)) {
              var vs = value.map(function (v) {
                return attribute + operator + v;
              });
              numericFilters.push(vs);
            } else {
              numericFilters.push(attribute + operator + value);
            }
          });
        }
      });
    });
    return numericFilters;
  },

  /**
   * Return the tags filters depending
   * @private
   * @return {string}
   */
  _getTagFilters: function (state) {
    if (state.tagFilters) {
      return state.tagFilters;
    }

    return state.tagRefinements.join(',');
  },

  /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {string} [facet] if set, the current disjunctive facet
   * @return {array.<string>}
   */
  _getFacetFilters: function (state, facet, hierarchicalRootLevel) {
    var facetFilters = [];
    var facetsRefinements = state.facetsRefinements || {};
    Object.keys(facetsRefinements).forEach(function (facetName) {
      var facetValues = facetsRefinements[facetName] || [];
      facetValues.forEach(function (facetValue) {
        facetFilters.push(facetName + ':' + facetValue);
      });
    });
    var facetsExcludes = state.facetsExcludes || {};
    Object.keys(facetsExcludes).forEach(function (facetName) {
      var facetValues = facetsExcludes[facetName] || [];
      facetValues.forEach(function (facetValue) {
        facetFilters.push(facetName + ':-' + facetValue);
      });
    });
    var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
    Object.keys(disjunctiveFacetsRefinements).forEach(function (facetName) {
      var facetValues = disjunctiveFacetsRefinements[facetName] || [];

      if (facetName === facet || !facetValues || facetValues.length === 0) {
        return;
      }

      var orFilters = [];
      facetValues.forEach(function (facetValue) {
        orFilters.push(facetName + ':' + facetValue);
      });
      facetFilters.push(orFilters);
    });
    var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
    Object.keys(hierarchicalFacetsRefinements).forEach(function (facetName) {
      var facetValues = hierarchicalFacetsRefinements[facetName] || [];
      var facetValue = facetValues[0];

      if (facetValue === undefined) {
        return;
      }

      var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);

      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);

      var attributeToRefine;
      var attributesIndex; // we ask for parent facet values only when the `facet` is the current hierarchical facet

      if (facet === facetName) {
        // if we are at the root level already, no need to ask for facet values, we get them from
        // the hits query
        if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) {
          return;
        }

        if (!rootPath) {
          attributesIndex = facetValue.split(separator).length - 2;
          facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
        } else {
          attributesIndex = rootPath.split(separator).length - 1;
          facetValue = rootPath;
        }

        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
      } else {
        attributesIndex = facetValue.split(separator).length - 1;
        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
      }

      if (attributeToRefine) {
        facetFilters.push([attributeToRefine + ':' + facetValue]);
      }
    });
    return facetFilters;
  },
  _getHitsHierarchicalFacetsAttributes: function (state) {
    var out = [];
    return state.hierarchicalFacets.reduce( // ask for as much levels as there's hierarchical refinements
    function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
      var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0]; // if no refinement, ask for root level

      if (!hierarchicalRefinement) {
        allAttributes.push(hierarchicalFacet.attributes[0]);
        return allAttributes;
      }

      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

      var level = hierarchicalRefinement.split(separator).length;
      var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
      return allAttributes.concat(newAttributes);
    }, out);
  },
  _getDisjunctiveHierarchicalFacetAttribute: function (state, hierarchicalFacet, rootLevel) {
    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

    if (rootLevel === true) {
      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);

      var attributeIndex = 0;

      if (rootPath) {
        attributeIndex = rootPath.split(separator).length;
      }

      return [hierarchicalFacet.attributes[attributeIndex]];
    }

    var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || ''; // if refinement is 'beers > IPA > Flying dog',
    // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)

    var parentLevel = hierarchicalRefinement.split(separator).length - 1;
    return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
  },
  getSearchForFacetQuery: function (facetName, query, maxFacetHits, state) {
    var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
    var searchForFacetSearchParameters = {
      facetQuery: query,
      facetName: facetName
    };

    if (typeof maxFacetHits === 'number') {
      searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
    }

    return merge({}, requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters);
  }
};
module.exports = requestBuilder;

/***/ }),

/***/ 3665:
/***/ (function(module) {

"use strict";


module.exports = function isValidUserToken(userToken) {
  if (userToken === null) {
    return false;
  }

  return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

/***/ }),

/***/ 8147:
/***/ (function(module) {

"use strict";


module.exports = '3.8.2';

/***/ }),

/***/ 9840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(1703);

/*! algoliasearch-lite.umd.js | 4.13.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function (e, t) {
   true ? module.exports = t() : 0;
}(this, function () {
  "use strict";

  function e(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function t(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function r(r) {
    for (var n = 1; n < arguments.length; n++) {
      var o = null != arguments[n] ? arguments[n] : {};
      n % 2 ? t(Object(o), !0).forEach(function (t) {
        e(r, t, o[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function (e) {
        Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
      });
    }

    return r;
  }

  function n(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          a = Object.keys(e);

      for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }

    return o;
  }

  function o(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var r = [],
          n = !0,
          o = !1,
          a = void 0;

      try {
        for (var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (o) throw a;
        }
      }

      return r;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function a(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = new Array(e.length); t < e.length; t++) r[t] = e[t];

        return r;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function u(e) {
    var t,
        r = "algoliasearch-client-js-".concat(e.key),
        n = function () {
      return void 0 === t && (t = e.localStorage || window.localStorage), t;
    },
        a = function () {
      return JSON.parse(n().getItem(r) || "{}");
    };

    return {
      get: function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          miss: function () {
            return Promise.resolve();
          }
        };
        return Promise.resolve().then(function () {
          var r = JSON.stringify(e),
              n = a()[r];
          return Promise.all([n || t(), void 0 !== n]);
        }).then(function (e) {
          var t = o(e, 2),
              n = t[0],
              a = t[1];
          return Promise.all([n, a || r.miss(n)]);
        }).then(function (e) {
          return o(e, 1)[0];
        });
      },
      set: function (e, t) {
        return Promise.resolve().then(function () {
          var o = a();
          return o[JSON.stringify(e)] = t, n().setItem(r, JSON.stringify(o)), t;
        });
      },
      delete: function (e) {
        return Promise.resolve().then(function () {
          var t = a();
          delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
        });
      },
      clear: function () {
        return Promise.resolve().then(function () {
          n().removeItem(r);
        });
      }
    };
  }

  function i(e) {
    var t = a(e.caches),
        r = t.shift();
    return void 0 === r ? {
      get: function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          miss: function () {
            return Promise.resolve();
          }
        },
            n = t();
        return n.then(function (e) {
          return Promise.all([e, r.miss(e)]);
        }).then(function (e) {
          return o(e, 1)[0];
        });
      },
      set: function (e, t) {
        return Promise.resolve(t);
      },
      delete: function (e) {
        return Promise.resolve();
      },
      clear: function () {
        return Promise.resolve();
      }
    } : {
      get: function (e, n) {
        var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          miss: function () {
            return Promise.resolve();
          }
        };
        return r.get(e, n, o).catch(function () {
          return i({
            caches: t
          }).get(e, n, o);
        });
      },
      set: function (e, n) {
        return r.set(e, n).catch(function () {
          return i({
            caches: t
          }).set(e, n);
        });
      },
      delete: function (e) {
        return r.delete(e).catch(function () {
          return i({
            caches: t
          }).delete(e);
        });
      },
      clear: function () {
        return r.clear().catch(function () {
          return i({
            caches: t
          }).clear();
        });
      }
    };
  }

  function s() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
      serializable: !0
    },
        t = {};
    return {
      get: function (r, n) {
        var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          miss: function () {
            return Promise.resolve();
          }
        },
            a = JSON.stringify(r);
        if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);

        var u = n(),
            i = o && o.miss || function () {
          return Promise.resolve();
        };

        return u.then(function (e) {
          return i(e);
        }).then(function () {
          return u;
        });
      },
      set: function (r, n) {
        return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
      },
      delete: function (e) {
        return delete t[JSON.stringify(e)], Promise.resolve();
      },
      clear: function () {
        return t = {}, Promise.resolve();
      }
    };
  }

  function c(e) {
    for (var t = e.length - 1; t > 0; t--) {
      var r = Math.floor(Math.random() * (t + 1)),
          n = e[t];
      e[t] = e[r], e[r] = n;
    }

    return e;
  }

  function l(e, t) {
    return t ? (Object.keys(t).forEach(function (r) {
      e[r] = t[r](e);
    }), e) : e;
  }

  function f(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

    var o = 0;
    return e.replace(/%s/g, function () {
      return encodeURIComponent(r[o++]);
    });
  }

  var h = {
    WithinQueryParameters: 0,
    WithinHeaders: 1
  };

  function d(e, t) {
    var r = e || {},
        n = r.data || {};
    return Object.keys(r).forEach(function (e) {
      -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e) && (n[e] = r[e]);
    }), {
      data: Object.entries(n).length > 0 ? n : void 0,
      timeout: r.timeout || t,
      headers: r.headers || {},
      queryParameters: r.queryParameters || {},
      cacheable: r.cacheable
    };
  }

  var m = {
    Read: 1,
    Write: 2,
    Any: 3
  },
      p = 1,
      v = 2,
      y = 3;

  function g(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
    return r(r({}, e), {}, {
      status: t,
      lastUpdate: Date.now()
    });
  }

  function b(e) {
    return "string" == typeof e ? {
      protocol: "https",
      url: e,
      accept: m.Any
    } : {
      protocol: e.protocol || "https",
      url: e.url,
      accept: e.accept || m.Any
    };
  }

  var O = "GET",
      P = "POST";

  function q(e, t) {
    return Promise.all(t.map(function (t) {
      return e.get(t, function () {
        return Promise.resolve(g(t));
      });
    })).then(function (e) {
      var r = e.filter(function (e) {
        return function (e) {
          return e.status === p || Date.now() - e.lastUpdate > 12e4;
        }(e);
      }),
          n = e.filter(function (e) {
        return function (e) {
          return e.status === y && Date.now() - e.lastUpdate <= 12e4;
        }(e);
      }),
          o = [].concat(a(r), a(n));
      return {
        getTimeout: function (e, t) {
          return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
        },
        statelessHosts: o.length > 0 ? o.map(function (e) {
          return b(e);
        }) : t
      };
    });
  }

  function w(e, t, n, o) {
    var u = [],
        i = function (e, t) {
      if (e.method === O || void 0 === e.data && void 0 === t.data) return;
      var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
      return JSON.stringify(n);
    }(n, o),
        s = function (e, t) {
      var n = r(r({}, e.headers), t.headers),
          o = {};
      return Object.keys(n).forEach(function (e) {
        var t = n[e];
        o[e.toLowerCase()] = t;
      }), o;
    }(e, o),
        c = n.method,
        l = n.method !== O ? {} : r(r({}, n.data), o.data),
        f = r(r(r({
      "x-algolia-agent": e.userAgent.value
    }, e.queryParameters), l), o.queryParameters),
        h = 0,
        d = function t(r, a) {
      var l = r.pop();
      if (void 0 === l) throw {
        name: "RetryError",
        message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
        transporterStackTrace: A(u)
      };

      var d = {
        data: i,
        headers: s,
        method: c,
        url: S(l, n.path, f),
        connectTimeout: a(h, e.timeouts.connect),
        responseTimeout: a(h, o.timeout)
      },
          m = function (e) {
        var t = {
          request: d,
          response: e,
          host: l,
          triesLeft: r.length
        };
        return u.push(t), t;
      },
          p = {
        onSuccess: function (e) {
          return function (e) {
            try {
              return JSON.parse(e.content);
            } catch (t) {
              throw function (e, t) {
                return {
                  name: "DeserializationError",
                  message: e,
                  response: t
                };
              }(t.message, e);
            }
          }(e);
        },
        onRetry: function (n) {
          var o = m(n);
          return n.isTimedOut && h++, Promise.all([e.logger.info("Retryable failure", x(o)), e.hostsCache.set(l, g(l, n.isTimedOut ? y : v))]).then(function () {
            return t(r, a);
          });
        },
        onFail: function (e) {
          throw m(e), function (e, t) {
            var r = e.content,
                n = e.status,
                o = r;

            try {
              o = JSON.parse(r).message;
            } catch (e) {}

            return function (e, t, r) {
              return {
                name: "ApiError",
                message: e,
                status: t,
                transporterStackTrace: r
              };
            }(o, n, t);
          }(e, A(u));
        }
      };

      return e.requester.send(d).then(function (e) {
        return function (e, t) {
          return function (e) {
            var t = e.status;
            return e.isTimedOut || function (e) {
              var t = e.isTimedOut,
                  r = e.status;
              return !t && 0 == ~~r;
            }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
          }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
        }(e, p);
      });
    };

    return q(e.hostsCache, t).then(function (e) {
      return d(a(e.statelessHosts).reverse(), e.getTimeout);
    });
  }

  function j(e) {
    var t = {
      value: "Algolia for JavaScript (".concat(e, ")"),
      add: function (e) {
        var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
        return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
      }
    };
    return t;
  }

  function S(e, t, r) {
    var n = T(r),
        o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
    return n.length && (o += "?".concat(n)), o;
  }

  function T(e) {
    return Object.keys(e).map(function (t) {
      return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
      var r;
    }).join("&");
  }

  function A(e) {
    return e.map(function (e) {
      return x(e);
    });
  }

  function x(e) {
    var t = e.request.headers["x-algolia-api-key"] ? {
      "x-algolia-api-key": "*****"
    } : {};
    return r(r({}, e), {}, {
      request: r(r({}, e.request), {}, {
        headers: r(r({}, e.request.headers), t)
      })
    });
  }

  var N = function (e) {
    var t = e.appId,
        n = function (e, t, r) {
      var n = {
        "x-algolia-api-key": r,
        "x-algolia-application-id": t
      };
      return {
        headers: function () {
          return e === h.WithinHeaders ? n : {};
        },
        queryParameters: function () {
          return e === h.WithinQueryParameters ? n : {};
        }
      };
    }(void 0 !== e.authMode ? e.authMode : h.WithinHeaders, t, e.apiKey),
        a = function (e) {
      var t = e.hostsCache,
          r = e.logger,
          n = e.requester,
          a = e.requestsCache,
          u = e.responsesCache,
          i = e.timeouts,
          s = e.userAgent,
          c = e.hosts,
          l = e.queryParameters,
          f = {
        hostsCache: t,
        logger: r,
        requester: n,
        requestsCache: a,
        responsesCache: u,
        timeouts: i,
        userAgent: s,
        headers: e.headers,
        queryParameters: l,
        hosts: c.map(function (e) {
          return b(e);
        }),
        read: function (e, t) {
          var r = d(t, f.timeouts.read),
              n = function () {
            return w(f, f.hosts.filter(function (e) {
              return 0 != (e.accept & m.Read);
            }), e, r);
          };

          if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
          var a = {
            request: e,
            mappedRequestOptions: r,
            transporter: {
              queryParameters: f.queryParameters,
              headers: f.headers
            }
          };
          return f.responsesCache.get(a, function () {
            return f.requestsCache.get(a, function () {
              return f.requestsCache.set(a, n()).then(function (e) {
                return Promise.all([f.requestsCache.delete(a), e]);
              }, function (e) {
                return Promise.all([f.requestsCache.delete(a), Promise.reject(e)]);
              }).then(function (e) {
                var t = o(e, 2);
                t[0];
                return t[1];
              });
            });
          }, {
            miss: function (e) {
              return f.responsesCache.set(a, e);
            }
          });
        },
        write: function (e, t) {
          return w(f, f.hosts.filter(function (e) {
            return 0 != (e.accept & m.Write);
          }), e, d(t, f.timeouts.write));
        }
      };
      return f;
    }(r(r({
      hosts: [{
        url: "".concat(t, "-dsn.algolia.net"),
        accept: m.Read
      }, {
        url: "".concat(t, ".algolia.net"),
        accept: m.Write
      }].concat(c([{
        url: "".concat(t, "-1.algolianet.com")
      }, {
        url: "".concat(t, "-2.algolianet.com")
      }, {
        url: "".concat(t, "-3.algolianet.com")
      }]))
    }, e), {}, {
      headers: r(r(r({}, n.headers()), {
        "content-type": "application/x-www-form-urlencoded"
      }), e.headers),
      queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
    }));

    return l({
      transporter: a,
      appId: t,
      addAlgoliaAgent: function (e, t) {
        a.userAgent.add({
          segment: e,
          version: t
        });
      },
      clearCache: function () {
        return Promise.all([a.requestsCache.clear(), a.responsesCache.clear()]).then(function () {});
      }
    }, e.methods);
  },
      C = function (e) {
    return function (t, r) {
      return t.method === O ? e.transporter.read(t, r) : e.transporter.write(t, r);
    };
  },
      k = function (e) {
    return function (t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = {
        transporter: e.transporter,
        appId: e.appId,
        indexName: t
      };
      return l(n, r.methods);
    };
  },
      J = function (e) {
    return function (t, n) {
      var o = t.map(function (e) {
        return r(r({}, e), {}, {
          params: T(e.params || {})
        });
      });
      return e.transporter.read({
        method: P,
        path: "1/indexes/*/queries",
        data: {
          requests: o
        },
        cacheable: !0
      }, n);
    };
  },
      E = function (e) {
    return function (t, o) {
      return Promise.all(t.map(function (t) {
        var a = t.params,
            u = a.facetName,
            i = a.facetQuery,
            s = n(a, ["facetName", "facetQuery"]);
        return k(e)(t.indexName, {
          methods: {
            searchForFacetValues: R
          }
        }).searchForFacetValues(u, i, r(r({}, o), s));
      }));
    };
  },
      I = function (e) {
    return function (t, r, n) {
      return e.transporter.read({
        method: P,
        path: f("1/answers/%s/prediction", e.indexName),
        data: {
          query: t,
          queryLanguages: r
        },
        cacheable: !0
      }, n);
    };
  },
      F = function (e) {
    return function (t, r) {
      return e.transporter.read({
        method: P,
        path: f("1/indexes/%s/query", e.indexName),
        data: {
          query: t
        },
        cacheable: !0
      }, r);
    };
  },
      R = function (e) {
    return function (t, r, n) {
      return e.transporter.read({
        method: P,
        path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
        data: {
          facetQuery: r
        },
        cacheable: !0
      }, n);
    };
  },
      D = 1,
      W = 2,
      H = 3;

  function Q(e, t, n) {
    var o,
        a = {
      appId: e,
      apiKey: t,
      timeouts: {
        connect: 1,
        read: 2,
        write: 30
      },
      requester: {
        send: function (e) {
          return new Promise(function (t) {
            var r = new XMLHttpRequest();
            r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function (t) {
              return r.setRequestHeader(t, e.headers[t]);
            });

            var n,
                o = function (e, n) {
              return setTimeout(function () {
                r.abort(), t({
                  status: 0,
                  content: n,
                  isTimedOut: !0
                });
              }, 1e3 * e);
            },
                a = o(e.connectTimeout, "Connection timeout");

            r.onreadystatechange = function () {
              r.readyState > r.OPENED && void 0 === n && (clearTimeout(a), n = o(e.responseTimeout, "Socket timeout"));
            }, r.onerror = function () {
              0 === r.status && (clearTimeout(a), clearTimeout(n), t({
                content: r.responseText || "Network request failed",
                status: r.status,
                isTimedOut: !1
              }));
            }, r.onload = function () {
              clearTimeout(a), clearTimeout(n), t({
                content: r.responseText,
                status: r.status,
                isTimedOut: !1
              });
            }, r.send(e.data);
          });
        }
      },
      logger: (o = H, {
        debug: function (e, t) {
          return D >= o && console.debug(e, t), Promise.resolve();
        },
        info: function (e, t) {
          return W >= o && console.info(e, t), Promise.resolve();
        },
        error: function (e, t) {
          return console.error(e, t), Promise.resolve();
        }
      }),
      responsesCache: s(),
      requestsCache: s({
        serializable: !1
      }),
      hostsCache: i({
        caches: [u({
          key: "".concat("4.13.0", "-").concat(e)
        }), s()]
      }),
      userAgent: j("4.13.0").add({
        segment: "Browser",
        version: "lite"
      }),
      authMode: h.WithinQueryParameters
    };
    return N(r(r(r({}, a), n), {}, {
      methods: {
        search: J,
        searchForFacetValues: E,
        multipleQueries: J,
        multipleSearchForFacetValues: E,
        customRequest: C,
        initIndex: function (e) {
          return function (t) {
            return k(e)(t, {
              methods: {
                search: F,
                searchForFacetValues: R,
                findAnswers: I
              }
            });
          };
        }
      }
    }));
  }

  return Q.version = "4.13.0", Q;
});

/***/ }),

/***/ 2885:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375),
    root = __webpack_require__(6035);
/* Built-in method references that are verified to be native. */


var DataView = getNative(root, 'DataView');
module.exports = DataView;

/***/ }),

/***/ 8521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(4903),
    hashDelete = __webpack_require__(3379),
    hashGet = __webpack_require__(8698),
    hashHas = __webpack_require__(4919),
    hashSet = __webpack_require__(2327);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

/***/ }),

/***/ 4818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(4715),
    listCacheDelete = __webpack_require__(6322),
    listCacheGet = __webpack_require__(5118),
    listCacheHas = __webpack_require__(4268),
    listCacheSet = __webpack_require__(2267);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

/***/ }),

/***/ 6349:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375),
    root = __webpack_require__(6035);
/* Built-in method references that are verified to be native. */


var Map = getNative(root, 'Map');
module.exports = Map;

/***/ }),

/***/ 2417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(9944),
    mapCacheDelete = __webpack_require__(5166),
    mapCacheGet = __webpack_require__(9941),
    mapCacheHas = __webpack_require__(7607),
    mapCacheSet = __webpack_require__(5271);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

/***/ }),

/***/ 4783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375),
    root = __webpack_require__(6035);
/* Built-in method references that are verified to be native. */


var Promise = getNative(root, 'Promise');
module.exports = Promise;

/***/ }),

/***/ 6031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375),
    root = __webpack_require__(6035);
/* Built-in method references that are verified to be native. */


var Set = getNative(root, 'Set');
module.exports = Set;

/***/ }),

/***/ 6333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(2417),
    setCacheAdd = __webpack_require__(8036),
    setCacheHas = __webpack_require__(2079);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */


function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

/***/ }),

/***/ 584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(4818),
    stackClear = __webpack_require__(8437),
    stackDelete = __webpack_require__(6130),
    stackGet = __webpack_require__(4367),
    stackHas = __webpack_require__(1282),
    stackSet = __webpack_require__(735);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

/***/ }),

/***/ 6637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(6035);
/** Built-in value references. */


var Symbol = root.Symbol;
module.exports = Symbol;

/***/ }),

/***/ 9857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(6035);
/** Built-in value references. */


var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

/***/ }),

/***/ 4311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375),
    root = __webpack_require__(6035);
/* Built-in method references that are verified to be native. */


var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

/***/ }),

/***/ 707:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),

/***/ 4878:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

module.exports = arrayFilter;

/***/ }),

/***/ 2357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(2556),
    isArguments = __webpack_require__(921),
    isArray = __webpack_require__(1284),
    isBuffer = __webpack_require__(8705),
    isIndex = __webpack_require__(4597),
    isTypedArray = __webpack_require__(8913);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

module.exports = arrayLikeKeys;

/***/ }),

/***/ 8190:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

module.exports = arrayPush;

/***/ }),

/***/ 4359:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

module.exports = arraySome;

/***/ }),

/***/ 1883:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3697),
    eq = __webpack_require__(7417);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */


function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

/***/ }),

/***/ 8919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3697),
    eq = __webpack_require__(7417);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),

/***/ 1461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(7417);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

module.exports = assocIndexOf;

/***/ }),

/***/ 3697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(2567);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */


function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),

/***/ 5073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(7630);
/** Built-in value references. */


var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),

/***/ 6722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(6503);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */


var baseFor = createBaseFor();
module.exports = baseFor;

/***/ }),

/***/ 1658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(8190),
    isArray = __webpack_require__(1284);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */


function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),

/***/ 9663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(6637),
    getRawTag = __webpack_require__(1469),
    objectToString = __webpack_require__(9099);
/** `Object#toString` result references. */


var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ 2372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9663),
    isObjectLike = __webpack_require__(6158);
/** `Object#toString` result references. */


var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),

/***/ 6383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(6331),
    isObjectLike = __webpack_require__(6158);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */


function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),

/***/ 6331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(584),
    equalArrays = __webpack_require__(8472),
    equalByTag = __webpack_require__(4775),
    equalObjects = __webpack_require__(8258),
    getTag = __webpack_require__(2278),
    isArray = __webpack_require__(1284),
    isBuffer = __webpack_require__(8705),
    isTypedArray = __webpack_require__(8913);
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),

/***/ 1490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(2244),
    isMasked = __webpack_require__(418),
    isObject = __webpack_require__(7630),
    toSource = __webpack_require__(9764);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),

/***/ 4434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9663),
    isLength = __webpack_require__(5418),
    isObjectLike = __webpack_require__(6158);
/** `Object#toString` result references. */


var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),

/***/ 7463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(2724),
    nativeKeys = __webpack_require__(2383);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

module.exports = baseKeys;

/***/ }),

/***/ 8009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(7630),
    isPrototype = __webpack_require__(2724),
    nativeKeysIn = __webpack_require__(226);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

module.exports = baseKeysIn;

/***/ }),

/***/ 5031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(584),
    assignMergeValue = __webpack_require__(1883),
    baseFor = __webpack_require__(6722),
    baseMergeDeep = __webpack_require__(6261),
    isObject = __webpack_require__(7630),
    keysIn = __webpack_require__(7116),
    safeGet = __webpack_require__(1666);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */


function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  baseFor(source, function (srcValue, key) {
    stack || (stack = new Stack());

    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

/***/ }),

/***/ 6261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(1883),
    cloneBuffer = __webpack_require__(126),
    cloneTypedArray = __webpack_require__(2070),
    copyArray = __webpack_require__(7151),
    initCloneObject = __webpack_require__(7897),
    isArguments = __webpack_require__(921),
    isArray = __webpack_require__(1284),
    isArrayLikeObject = __webpack_require__(4916),
    isBuffer = __webpack_require__(8705),
    isFunction = __webpack_require__(2244),
    isObject = __webpack_require__(7630),
    isPlainObject = __webpack_require__(2805),
    isTypedArray = __webpack_require__(8913),
    safeGet = __webpack_require__(1666),
    toPlainObject = __webpack_require__(5042);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */


function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;

      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

/***/ }),

/***/ 6836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(1434),
    overRest = __webpack_require__(7095),
    setToString = __webpack_require__(6468);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */


function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),

/***/ 7841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(1311),
    defineProperty = __webpack_require__(2567),
    identity = __webpack_require__(1434);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */


var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
module.exports = baseSetToString;

/***/ }),

/***/ 2556:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

module.exports = baseTimes;

/***/ }),

/***/ 201:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),

/***/ 4048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(9857);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */


function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(6035);
/** Detect free variable `exports`. */


var freeExports =  true && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/***/ }),

/***/ 2070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(4048);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */


function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

/***/ }),

/***/ 7151:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

module.exports = copyArray;

/***/ }),

/***/ 3292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(8919),
    baseAssignValue = __webpack_require__(3697);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */


function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}

module.exports = copyObject;

/***/ }),

/***/ 5287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(6035);
/** Used to detect overreaching core-js shims. */


var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

/***/ }),

/***/ 5095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(6836),
    isIterateeCall = __webpack_require__(5972);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */


function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

module.exports = createAssigner;

/***/ }),

/***/ 6503:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

module.exports = createBaseFor;

/***/ }),

/***/ 2567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),

/***/ 8472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(6333),
    arraySome = __webpack_require__(4359),
    cacheHas = __webpack_require__(4932);
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),

/***/ 4775:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(6637),
    Uint8Array = __webpack_require__(9857),
    eq = __webpack_require__(7417),
    equalArrays = __webpack_require__(8472),
    mapToArray = __webpack_require__(4663),
    setToArray = __webpack_require__(5682);
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */

var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }

      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

module.exports = equalByTag;

/***/ }),

/***/ 8258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(555);
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),

/***/ 3801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
module.exports = freeGlobal;

/***/ }),

/***/ 555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1658),
    getSymbols = __webpack_require__(6796),
    keys = __webpack_require__(9678);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),

/***/ 3446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(9084);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),

/***/ 4375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1490),
    getValue = __webpack_require__(5789);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),

/***/ 4092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(2621);
/** Built-in value references. */


var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

/***/ }),

/***/ 1469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(6637);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ 6796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(4878),
    stubArray = __webpack_require__(2101);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
module.exports = getSymbols;

/***/ }),

/***/ 2278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(2885),
    Map = __webpack_require__(6349),
    Promise = __webpack_require__(4783),
    Set = __webpack_require__(6031),
    WeakMap = __webpack_require__(4311),
    baseGetTag = __webpack_require__(9663),
    toSource = __webpack_require__(9764);
/** `Object#toString` result references. */


var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function (value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

module.exports = getTag;

/***/ }),

/***/ 5789:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),

/***/ 4903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(5658);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),

/***/ 3379:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),

/***/ 8698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(5658);
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),

/***/ 4919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(5658);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),

/***/ 2327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(5658);
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),

/***/ 7897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(5073),
    getPrototype = __webpack_require__(4092),
    isPrototype = __webpack_require__(2724);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */


function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

module.exports = initCloneObject;

/***/ }),

/***/ 4597:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),

/***/ 5972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(7417),
    isArrayLike = __webpack_require__(2410),
    isIndex = __webpack_require__(4597),
    isObject = __webpack_require__(7630);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */


function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }

  return false;
}

module.exports = isIterateeCall;

/***/ }),

/***/ 9084:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),

/***/ 418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5287);
/** Used to detect methods masquerading as native. */


var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),

/***/ 2724:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

module.exports = isPrototype;

/***/ }),

/***/ 4715:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),

/***/ 6322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1461);
/** Used for built-in method references. */


var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),

/***/ 5118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1461);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),

/***/ 4268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1461);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),

/***/ 2267:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1461);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

module.exports = listCacheSet;

/***/ }),

/***/ 9944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(8521),
    ListCache = __webpack_require__(4818),
    Map = __webpack_require__(6349);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),

/***/ 5166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(3446);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),

/***/ 9941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(3446);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),

/***/ 7607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(3446);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),

/***/ 5271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(3446);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),

/***/ 4663:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),

/***/ 5658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4375);
/* Built-in method references that are verified to be native. */


var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

/***/ }),

/***/ 2383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(2621);
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

/***/ }),

/***/ 226:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

module.exports = nativeKeysIn;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(3801);
/** Detect free variable `exports`. */


var freeExports =  true && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;

/***/ }),

/***/ 9099:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ 2621:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),

/***/ 7095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(707);
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),

/***/ 6035:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(3801);
/** Detect free variable `self`. */


var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

/***/ }),

/***/ 1666:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

/***/ }),

/***/ 8036:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

module.exports = setCacheAdd;

/***/ }),

/***/ 2079:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),

/***/ 5682:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),

/***/ 6468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(7841),
    shortOut = __webpack_require__(5406);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */


var setToString = shortOut(baseSetToString);
module.exports = setToString;

/***/ }),

/***/ 5406:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),

/***/ 8437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(4818);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */


function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),

/***/ 6130:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),

/***/ 4367:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),

/***/ 1282:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),

/***/ 735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(4818),
    Map = __webpack_require__(6349),
    MapCache = __webpack_require__(2417);
/** Used as the size to enable large array optimizations. */


var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),

/***/ 9764:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

module.exports = toSource;

/***/ }),

/***/ 1311:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),

/***/ 7417:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),

/***/ 1434:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),

/***/ 921:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2372),
    isObjectLike = __webpack_require__(6158);
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

/***/ }),

/***/ 1284:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
module.exports = isArray;

/***/ }),

/***/ 2410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(2244),
    isLength = __webpack_require__(5418);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),

/***/ 4916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(2410),
    isObjectLike = __webpack_require__(6158);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */


function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

/***/ }),

/***/ 8705:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(6035),
    stubFalse = __webpack_require__(3551);
/** Detect free variable `exports`. */


var freeExports =  true && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

/***/ }),

/***/ 7881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(6383);
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */


function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),

/***/ 2244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9663),
    isObject = __webpack_require__(7630);
/** `Object#toString` result references. */


var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),

/***/ 5418:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),

/***/ 7630:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ 6158:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ 2805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9663),
    getPrototype = __webpack_require__(4092),
    isObjectLike = __webpack_require__(6158);
/** `Object#toString` result references. */


var objectTag = '[object Object]';
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }

  var proto = getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),

/***/ 8913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4434),
    baseUnary = __webpack_require__(201),
    nodeUtil = __webpack_require__(368);
/* Node.js helper references. */


var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

/***/ }),

/***/ 9678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(2357),
    baseKeys = __webpack_require__(7463),
    isArrayLike = __webpack_require__(2410);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),

/***/ 7116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(2357),
    baseKeysIn = __webpack_require__(8009),
    isArrayLike = __webpack_require__(2410);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */


function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),

/***/ 6867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5031),
    createAssigner = __webpack_require__(5095);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */


var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
module.exports = merge;

/***/ }),

/***/ 2101:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),

/***/ 3551:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),

/***/ 5042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(3292),
    keysIn = __webpack_require__(7116);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */


function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

/***/ }),

/***/ 3063:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
module.exports = {
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function (value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function (value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};

/***/ }),

/***/ 7421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(6953);

var parse = __webpack_require__(3069);

var formats = __webpack_require__(3063);

module.exports = {
  formats: formats,
  parse: parse,
  stringify: stringify
};

/***/ }),

/***/ 3069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

var utils = __webpack_require__(4858);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function (str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};

var parseArrayValue = function (val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }

  return val;
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
      });
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    if (part.indexOf('[]=') > -1) {
      val = isArray(val) ? [val] : val;
    }

    if (has.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else if (cleanRoot !== '__proto__') {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

module.exports = function (str, opts) {
  var options = normalizeParseOptions(opts);

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
    obj = utils.merge(obj, newObj, options);
  }

  return utils.compact(obj);
};

/***/ }),

/***/ 6953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(1703);

var utils = __webpack_require__(4858);

var formats = __webpack_require__(3063);

var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;

var pushToArray = function (arr, valueOrArray) {
  push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};

var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
  var obj = object;

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
    obj = utils.maybeMap(obj, function (value) {
      if (value instanceof Date) {
        return serializeDate(value);
      }

      return value;
    });
  }

  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
    }

    obj = '';
  }

  if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);

      if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
        var valuesArray = split.call(String(obj), ',');
        var valuesJoined = '';

        for (var i = 0; i < valuesArray.length; ++i) {
          valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
        }

        return [formatter(keyValue) + '=' + valuesJoined];
      }

      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (generateArrayPrefix === 'comma' && isArray(obj)) {
    // we need to join elements in
    objKeys = [{
      value: obj.length > 0 ? obj.join(',') || null : void undefined
    }];
  } else if (isArray(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

    if (skipNulls && value === null) {
      continue;
    }

    var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? '.' + key : '[' + key + ']');
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
  }

  return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var charset = opts.charset || defaults.charset;

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var format = formats['default'];

  if (typeof opts.format !== 'undefined') {
    if (!has.call(formats.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }

    format = opts.format;
  }

  var formatter = formats.formatters[format];
  var filter = defaults.filter;

  if (typeof opts.filter === 'function' || isArray(opts.filter)) {
    filter = opts.filter;
  }

  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
    filter: filter,
    format: format,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

module.exports = function (object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (typeof obj !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && 'indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (options.sort) {
    objKeys.sort(options.sort);
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (options.skipNulls && obj[key] === null) {
      continue;
    }

    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
  }

  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';

  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }

  return joined.length > 0 ? prefix + joined : '';
};

/***/ }),

/***/ 4858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(3063);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        var targetItem = target[i];

        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function (str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = str;

  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
    ) {
      out += string.charAt(i);
      continue;
    }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    /* eslint operator-linebreak: [2, "before"] */

    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
  if (isArray(val)) {
    var mapped = [];

    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn(val[i]));
    }

    return mapped;
  }

  return fn(val);
};

module.exports = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  maybeMap: maybeMap,
  merge: merge
};

/***/ }),

/***/ 7405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5334);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("63ba82db", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8622);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("50c1affd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6866);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("1f0f0aee", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9371);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("74c8e572", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9623);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("8f542b62", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1997);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("11467afa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6595);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("27c1e8fa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6627);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("c00307c6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6649);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("e32bceb4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6196);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("48004c9c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7545);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("0cd0398c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2909);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("795e683a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7658);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("58315896", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("086e3915", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(42);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("35082dc9", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8962:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1525);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("7303cd58", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9995);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("cbeb9d34", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1962:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7012);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("22be45ea", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4106);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("6ac892f0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9969);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("603250d5", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6626);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("1a44d4b4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9621);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("f3f47110", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(721);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("5f25d689", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8234);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("41295d6d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2752);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("e2c98c5c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1249);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("0f4f3817", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5242);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("3a86d174", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1316);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("6f43b064", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3124:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1706);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("40665ae0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1091);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("0d921246", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8792:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1118);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("1f64e909", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("824a7aa6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2963);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("20f1e2fa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1901);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("1d6b7f77", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(190);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("6919d3a6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1457);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("17983f40", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(462);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("258cb664", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5226);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("364dc40a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1421);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("458ccccc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8996);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("1829fc89", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 17:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2821);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("fc746940", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3358);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("ff66c490", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5659);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("65e283e2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7692);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("38d6393a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8314);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("9050aff2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4702);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("6a138c88", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9573);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("6ff1fd2b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(986);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("e986df68", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6353);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("d3ff90e0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7978);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("d19e5e8c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(396);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("0df5e87e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8286:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("4b176ae0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 176:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7058);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(730)/* ["default"] */ .Z)
var update = add("5d4f2cb2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addStylesClient; }
});

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };

    if (!newStyles[id]) {
      styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });
    } else {
      newStyles[id].parts.push(part);
    }
  }

  return styles;
}
;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

// NAMESPACE OBJECT: ./node_modules/vue-instantsearch/vue2/es/src/widgets.js
var widgets_namespaceObject = {};
__webpack_require__.r(widgets_namespaceObject);
__webpack_require__.d(widgets_namespaceObject, {
  "AisAutocomplete": function() { return Autocomplete_vue; },
  "AisBreadcrumb": function() { return Breadcrumb_vue; },
  "AisClearRefinements": function() { return ClearRefinements_vue; },
  "AisConfigure": function() { return Configure; },
  "AisCurrentRefinements": function() { return CurrentRefinements_vue; },
  "AisDynamicWidgets": function() { return DynamicWidgets; },
  "AisExperimentalConfigureRelatedItems": function() { return ConfigureRelatedItems; },
  "AisExperimentalDynamicWidgets": function() { return ExperimentalDynamicWidgets; },
  "AisHierarchicalMenu": function() { return HierarchicalMenu_vue; },
  "AisHighlight": function() { return Highlight_vue; },
  "AisHits": function() { return Hits_vue; },
  "AisHitsPerPage": function() { return HitsPerPage_vue; },
  "AisIndex": function() { return Index; },
  "AisInfiniteHits": function() { return InfiniteHits_vue; },
  "AisInstantSearch": function() { return components_InstantSearch; },
  "AisInstantSearchSsr": function() { return InstantSearchSsr; },
  "AisMenu": function() { return Menu_vue; },
  "AisMenuSelect": function() { return MenuSelect_vue; },
  "AisNumericMenu": function() { return NumericMenu_vue; },
  "AisPagination": function() { return Pagination_vue; },
  "AisPanel": function() { return Panel_vue; },
  "AisPoweredBy": function() { return PoweredBy_vue; },
  "AisQueryRuleContext": function() { return QueryRuleContext; },
  "AisQueryRuleCustomData": function() { return QueryRuleCustomData_vue; },
  "AisRangeInput": function() { return RangeInput_vue; },
  "AisRatingMenu": function() { return RatingMenu_vue; },
  "AisRefinementList": function() { return RefinementList_vue; },
  "AisRelevantSort": function() { return RelevantSort_vue; },
  "AisSearchBox": function() { return SearchBox_vue; },
  "AisSnippet": function() { return Snippet_vue; },
  "AisSortBy": function() { return SortBy_vue; },
  "AisStateResults": function() { return StateResults_vue; },
  "AisStats": function() { return Stats_vue; },
  "AisToggleRefinement": function() { return ToggleRefinement_vue; },
  "AisVoiceSearch": function() { return VoiceSearch_vue; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(1703);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/popper.js/dist/esm/popper.js


/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];

  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }

  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/

var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */

function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */


function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  } // NOTE: 1 DOM access here


  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */


function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }

  return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */


function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;

    case '#document':
      return element.body;
  } // Firefox want us to check `-x` and `-y` variations as well


  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */


function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */

function isIE(version) {
  if (version === 11) {
    return isIE11;
  }

  if (version === 10) {
    return isIE10;
  }

  return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here

  var offsetParent = element.offsetParent || null; // Skip hidden elements which don't have an offsetParent

  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  } // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...


  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }

  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */


function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */


function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  } // Here we make sure to give as "start" the element that comes first in the DOM


  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1; // Get common ancestor container

  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  } // one of the nodes is inside shadowDOM, find which one


  var element1root = getRoot(element1);

  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */


function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */


function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */


function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */


function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */


function getBoundingClientRect(element) {
  var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11

  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  }; // subtract scrollbar size from sizes

  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons

  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth); // In cases where the parent is fixed, we must ignore negative scroll in offset calc

  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.

  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them

    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */


function isFixed(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }

  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }

  var parentNode = getParentNode(element);

  if (!parentNode) {
    return false;
  }

  return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */


function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }

  var el = element.parentElement;

  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }

  return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */


function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference)); // Handle viewport case

  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;

    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));

      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition); // In case of HTML, we need a different computation

    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  } // Add paddings


  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */


function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */


function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */


function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */


function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0]; // Get popper node sizes

  var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object

  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  }; // depending by the popper placement we have to compute its offsets slightly differently

  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;

  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  } // use `filter` to obtain the same behavior of `find`


  return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  } // use `find` + `indexOf` if `findIndex` isn't supported


  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */


function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }

    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation

    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */


function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  }; // compute reference element offsets

  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding); // store the computed placement inside `originalPlacement`

  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed; // compute the popper offsets

  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'; // run the modifiers

  data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback

  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */


function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */


function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;

    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }

  return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */


function destroy() {
  this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled

  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners(); // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it

  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }

  return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */


function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }

  scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  }); // Scroll event listener on scroll parents

  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */


function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound); // Remove scroll event listener on scroll parents

  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  }); // Reset state

  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */


function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */


function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = ''; // add unit if the value is numeric and is one of the following

    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }

    element.style[prop] = styles[prop] + unit;
  });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];

    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */


function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element

  setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties

  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */


function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement); // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations

  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */


function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;

  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }

  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent); // Styles

  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right'; // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed

  var prefixedProperty = getSupportedPropertyName('transform'); // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.

  var left = void 0,
      top = void 0;

  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }

  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }

  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  } // Attributes


  var attributes = {
    'x-placement': data.placement
  }; // Update `data` attributes, styles and arrowStyles

  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */


function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';

    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }

  return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function arrow(data, options) {
  var _data$offsets$arrow; // arrow depends on keepTogether in order to work


  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier

    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len]; //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //
  // top/left side

  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  } // bottom/right side


  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper

  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available

  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper

  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */


function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }

  return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */


var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']; // Get rid of `auto` `auto-start` and `auto-end`

var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */

function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;

    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;

    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;

    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here

    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom; // flip the variation if required

    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1; // flips variation if reference element overflows boundaries

    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom); // flips variation if popper content overflows boundaries

    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : ''); // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future

      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }

  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */


function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2]; // If it's not a number it's an operator, I guess

  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;

    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;

      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;

    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */


function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one

  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)

  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  }); // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space

  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  } // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.


  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments]; // Convert the values with units to absolute pixels to allow our computations

  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []) // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  }); // Loop trough the offsets arrays and execute the operations

  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */


function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;

  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken

  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  } // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself


  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification

  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed); // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed

  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];

      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }

      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];

      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }

      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1]; // if shift shiftvariation is specified, run the modifier

  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */


var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: offset,

    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: preventOverflow,

    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],

    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: arrow,

    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: flip,

    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',

    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',

    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,

    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,

    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,

    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: computeStyle,

    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,

    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',

    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: applyStyle,

    /** @prop {Function} */
    onLoad: applyStyleOnLoad,

    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */

var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */
// Utils
// Methods

var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    }; // make update() debounced, so that it only runs at most once-per-tick


    this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it

    this.options = _extends({}, Popper.Defaults, options); // init state

    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    }; // get reference and popper elements (allow jQuery wrappers)

    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options

    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    }); // Refactoring modifiers' list (Object => Array)

    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    }) // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!

    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    }); // fire the first update to position the popper in the right place

    this.update();
    var eventsEnabled = this.options.eventsEnabled;

    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  } // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
/* harmony default export */ var popper = (Popper);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(7881);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./node_modules/vue-resize/dist/vue-resize.esm.js
function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return -1;
} //


var vue_resize_esm_isIE;

function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    vue_resize_esm_isIE = getInternetExplorerVersion() !== -1;
  }
}

var script = {
  name: 'ResizeObserver',
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    initCompat();
    this.$nextTick(function () {
      _this._w = _this.$el.offsetWidth;
      _this._h = _this.$el.offsetHeight;

      if (_this.emitOnMount) {
        _this.emitSize();
      }
    });
    var object = document.createElement('object');
    this._resizeObject = object;
    object.setAttribute('aria-hidden', 'true');
    object.setAttribute('tabindex', -1);
    object.onload = this.addResizeHandlers;
    object.type = 'text/html';

    if (vue_resize_esm_isIE) {
      this.$el.appendChild(object);
    }

    object.data = 'about:blank';

    if (!vue_resize_esm_isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },
    emitSize: function emitSize() {
      this.$emit('notify', {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);

      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!vue_resize_esm_isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
        }

        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "resize-observer",
    attrs: {
      tabindex: "-1"
    }
  });
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-8859cc6c";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function install(Vue) {
  // eslint-disable-next-line vue/component-definition-name-casing
  Vue.component('resize-observer', __vue_component__);
  Vue.component('ResizeObserver', __vue_component__);
}

var vue_resize_esm_plugin = {
  // eslint-disable-next-line no-undef
  version: "1.0.1",
  install: install
};
var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof __webpack_require__.g !== 'undefined') {
  GlobalVue = __webpack_require__.g.Vue;
}

if (GlobalVue) {
  GlobalVue.use(vue_resize_esm_plugin);
}

/* harmony default export */ var vue_resize_esm = ((/* unused pure expression or super */ null && (vue_resize_esm_plugin)));

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(6867);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js









var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */


function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */


function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}

var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip = /*#__PURE__*/function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @param {string} [options.ariaId] Id used for accessibility
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    _defineProperty(this, "_events", []);

    _defineProperty(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    }); // apply user options over default ones


    _options = _objectSpread$2(_objectSpread$2({}, DEFAULT_OPTIONS), _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */


  _createClass(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (!isEqual_default()(this._classes, classes)) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      var _this2 = this; // create tooltip element


      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = this.options.ariaId || "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
        tooltipNode.addEventListener('click', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this3 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        if (!_this3.popperInstance) return;

        _this3.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this4._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this4.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this4.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this4._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this4._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this4._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this5 = this; // don't show if it's already visible


      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread$2(_objectSpread$2({}, options.popperOptions), {}, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread$2(_objectSpread$2({}, popperOptions.modifiers), {}, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new popper(reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this5._isDisposed && _this5.popperInstance) {
          _this5.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this5._isDisposed) {
              _this5._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this5.dispose();
            }
          });
        } else {
          _this5.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this6 = this; // don't hide if it's already hidden


      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this6._tooltipNode) {
            _this6._tooltipNode.removeEventListener('mouseenter', _this6.hide);

            _this6._tooltipNode.removeEventListener('click', _this6.hide); // Don't remove popper instance, just the HTML element


            _this6._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this7 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this7.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this8 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this8._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this8._scheduleShow(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this8._scheduleHide(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this9 = this; // defaults to 0


      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this9._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this10 = this; // defaults to 0


      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this10._isOpen === false) {
          return;
        }

        if (!_this10._tooltipNode.ownerDocument.body.contains(_this10._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this10._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this10._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices


if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */


function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};

function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread$1({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = _typeof(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}

function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}

function getContent(value) {
  var type = _typeof(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}

function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread$1({
    title: content
  }, getOptions(_objectSpread$1(_objectSpread$1({}, _typeof(value) === 'object' ? value : {}), {}, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}

function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}

function bind(el, _ref) {
  var value = _ref.value;
  _ref.oldValue;
  var modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread$1(_objectSpread$1({}, value), {}, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}

var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var v_tooltip_esm_script = {
  name: 'VPopover',
  components: {
    ResizeObserver: __vue_component__
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    },
    ariaId: {
      default: null
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return _defineProperty({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.ariaId != null ? this.ariaId : this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event;

      _ref2.skipDelay;
      var _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event;

      _ref3.skipDelay;
      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
        this.isOpen = false;

        if (this.popperInstance) {
          requestAnimationFrame(function () {
            if (!_this3.hidden) {
              _this3.isOpen = true;
            }
          });
        }
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread(_objectSpread({}, this.popperOptions), {}, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread(_objectSpread({}, popperOptions.modifiers), {}, {
          arrow: _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow), {}, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset), {}, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow), {}, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new popper(reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this; // Already hidden


      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = _typeof(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  }; // Delay so that close directive has time to set values


  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function v_tooltip_esm_normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  const options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  let hook;

  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      const originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var v_tooltip_esm_vue_script_ = v_tooltip_esm_script;
/* template */

var v_tooltip_esm_vue_render_ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.isOpen ? _vm.popoverId : undefined,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover", null, {
    isOpen: _vm.isOpen
  })], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var v_tooltip_esm_vue_staticRenderFns_ = [];
v_tooltip_esm_vue_render_._withStripped = true;
/* style */

var v_tooltip_esm_vue_inject_styles_ = undefined;
/* scoped */

var v_tooltip_esm_vue_scope_id_ = undefined;
/* module identifier */

var v_tooltip_esm_vue_module_identifier_ = undefined;
/* functional template */

var v_tooltip_esm_vue_is_functional_template_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var v_tooltip_esm_vue_component_ = /*#__PURE__*/v_tooltip_esm_normalizeComponent({
  render: v_tooltip_esm_vue_render_,
  staticRenderFns: v_tooltip_esm_vue_staticRenderFns_
}, v_tooltip_esm_vue_inject_styles_, v_tooltip_esm_vue_script_, v_tooltip_esm_vue_scope_id_, v_tooltip_esm_vue_is_functional_template_, v_tooltip_esm_vue_module_identifier_, false, undefined, undefined, undefined);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".resize-observer[data-v-8859cc6c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-8859cc6c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css_248z);

function v_tooltip_esm_install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (v_tooltip_esm_install.installed) return;
  v_tooltip_esm_install.installed = true;
  var finalOptions = {};
  merge_default()(finalOptions, defaultOptions, options);
  v_tooltip_esm_plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('VPopover', v_tooltip_esm_vue_component_);
}

var VTooltip = (/* unused pure expression or super */ null && (directive));
var VClosePopover = (/* unused pure expression or super */ null && (vclosepopover));
var VPopover = (/* unused pure expression or super */ null && (v_tooltip_esm_vue_component_));
var v_tooltip_esm_plugin = {
  install: v_tooltip_esm_install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var v_tooltip_esm_GlobalVue = null;

if (typeof window !== 'undefined') {
  v_tooltip_esm_GlobalVue = window.Vue;
} else if (typeof __webpack_require__.g !== 'undefined') {
  v_tooltip_esm_GlobalVue = __webpack_require__.g.Vue;
}

if (v_tooltip_esm_GlobalVue) {
  v_tooltip_esm_GlobalVue.use(v_tooltip_esm_plugin);
}

/* harmony default export */ var v_tooltip_esm = (v_tooltip_esm_plugin);

;// CONCATENATED MODULE: ./node_modules/vuex-module-decorators/dist/esm/index.js


/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
  var _loop_1 = function (k) {
    Object.defineProperty(target, k, {
      get: function () {
        return source[k];
      }
    });
  };

  for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
    var k = _a[_i];

    _loop_1(k);
  }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */


function getModuleName(module) {
  if (!module._vmdModuleName) {
    throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
  }

  return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule =
/** @class */
function () {
  function VuexModule(module) {
    this.actions = module.actions;
    this.mutations = module.mutations;
    this.state = module.state;
    this.getters = module.getters;
    this.namespaced = module.namespaced;
    this.modules = module.modules;
  }

  return VuexModule;
}();

function getModule(moduleClass, store) {
  var moduleName = getModuleName(moduleClass);

  if (store && store.getters[moduleName]) {
    return store.getters[moduleName];
  } else if (moduleClass._statics) {
    return moduleClass._statics;
  }

  var genStatic = moduleClass._genStatic;

  if (!genStatic) {
    throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
  }

  var storeModule = genStatic(store);

  if (store) {
    store.getters[moduleName] = storeModule;
  } else {
    moduleClass._statics = storeModule;
  }

  return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];

function stateFactory(module) {
  var state = new module.prototype.constructor({});
  var s = {};
  Object.keys(state).forEach(function (key) {
    if (reservedKeys.indexOf(key) !== -1) {
      if (typeof state[key] !== 'undefined') {
        throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
      }

      return;
    }

    if (state.hasOwnProperty(key)) {
      if (typeof state[key] !== 'function') {
        s[key] = state[key];
      }
    }
  });
  return s;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
  var state = modOpt.stateFactory ? module.state() : module.state;
  Object.keys(state).forEach(function (key) {
    if (state.hasOwnProperty(key)) {
      // If not undefined or function means it is a state value
      if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
        Object.defineProperty(statics, key, {
          get: function () {
            var path = modOpt.name.split('/');
            var data = statics.store.state;

            for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
              var segment = path_1[_i];
              data = data[segment];
            }

            return data[key];
          }
        });
      }
    }
  });
}

function staticGetterGenerator(module, modOpt, statics) {
  Object.keys(module.getters).forEach(function (key) {
    if (module.namespaced) {
      Object.defineProperty(statics, key, {
        get: function () {
          return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
        }
      });
    } else {
      Object.defineProperty(statics, key, {
        get: function () {
          return statics.store.getters[key];
        }
      });
    }
  });
}

function staticMutationGenerator(module, modOpt, statics) {
  Object.keys(module.mutations).forEach(function (key) {
    if (module.namespaced) {
      statics[key] = function () {
        var _a;

        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
      };
    } else {
      statics[key] = function () {
        var _a;

        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
      };
    }
  });
}

function staticActionGenerators(module, modOpt, statics) {
  Object.keys(module.actions).forEach(function (key) {
    if (module.namespaced) {
      statics[key] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return __awaiter(this, void 0, void 0, function () {
          var _a;

          return __generator(this, function (_b) {
            return [2
            /*return*/
            , (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
          });
        });
      };
    } else {
      statics[key] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return __awaiter(this, void 0, void 0, function () {
          var _a;

          return __generator(this, function (_b) {
            return [2
            /*return*/
            , (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
          });
        });
      };
    }
  });
}

function registerDynamicModule(module, modOpt) {
  if (!modOpt.name) {
    throw new Error('Name of module not provided in decorator options');
  }

  if (!modOpt.store) {
    throw new Error('Store not provided in decorator options when using dynamic option');
  }

  modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
  module, {
    preserveState: modOpt.preserveState || false
  });
}

function addGettersToModule(targetModule, srcModule) {
  Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
    var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);

    if (descriptor.get && targetModule.getters) {
      targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
        var thisObj = {
          context: {
            state: state,
            getters: getters,
            rootState: rootState,
            rootGetters: rootGetters
          }
        };
        addPropertiesToObject(thisObj, state);
        addPropertiesToObject(thisObj, getters);
        var got = descriptor.get.call(thisObj);
        return got;
      };
    }
  });
}

function moduleDecoratorFactory(moduleOptions) {
  return function (constructor) {
    var module = constructor;

    var stateFactory$1 = function () {
      return stateFactory(module);
    };

    if (!module.state) {
      module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
    }

    if (!module.getters) {
      module.getters = {};
    }

    if (!module.namespaced) {
      module.namespaced = moduleOptions && moduleOptions.namespaced;
    }

    var parentModule = Object.getPrototypeOf(module);

    while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
      addGettersToModule(module, parentModule);
      parentModule = Object.getPrototypeOf(parentModule);
    }

    addGettersToModule(module, module);
    var modOpt = moduleOptions;

    if (modOpt.name) {
      Object.defineProperty(constructor, '_genStatic', {
        value: function (store) {
          var statics = {
            store: store || modOpt.store
          };

          if (!statics.store) {
            throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
          } // ===========  For statics ==============
          // ------ state -------


          staticStateGenerator(module, modOpt, statics); // ------- getters -------

          if (module.getters) {
            staticGetterGenerator(module, modOpt, statics);
          } // -------- mutations --------


          if (module.mutations) {
            staticMutationGenerator(module, modOpt, statics);
          } // -------- actions ---------


          if (module.actions) {
            staticActionGenerators(module, modOpt, statics);
          }

          return statics;
        }
      });
      Object.defineProperty(constructor, '_vmdModuleName', {
        value: modOpt.name
      });
    }

    if (modOpt.dynamic) {
      registerDynamicModule(module, modOpt);
    }

    return constructor;
  };
}

function Module(modOrOpt) {
  if (typeof modOrOpt === 'function') {
    /*
     * @Module decorator called without options (directly on the class definition)
     */
    moduleDecoratorFactory({})(modOrOpt);
  } else {
    /*
     * @Module({...}) decorator called with options
     */
    return moduleDecoratorFactory(modOrOpt);
  }
}

var config = {};

function actionDecoratorFactory(params) {
  var _a = params || {},
      _b = _a.commit,
      commit = _b === void 0 ? undefined : _b,
      _c = _a.rawError,
      rawError = _c === void 0 ? !!config.rawError : _c,
      _d = _a.root,
      root = _d === void 0 ? false : _d;

  return function (target, key, descriptor) {
    var module = target.constructor;

    if (!module.hasOwnProperty('actions')) {
      module.actions = Object.assign({}, module.actions);
    }

    var actionFunction = descriptor.value;

    var action = function (context, payload) {
      return __awaiter(this, void 0, void 0, function () {
        var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 5,, 6]);

              actionPayload = null;
              if (!module._genStatic) return [3
              /*break*/
              , 2];
              moduleName = getModuleName(module);
              moduleAccessor = context.rootGetters[moduleName] ? context.rootGetters[moduleName] : getModule(module);
              moduleAccessor.context = context;
              return [4
              /*yield*/
              , actionFunction.call(moduleAccessor, payload)];

            case 1:
              actionPayload = _a.sent();
              return [3
              /*break*/
              , 4];

            case 2:
              thisObj = {
                context: context
              };
              addPropertiesToObject(thisObj, context.state);
              addPropertiesToObject(thisObj, context.getters);
              return [4
              /*yield*/
              , actionFunction.call(thisObj, payload)];

            case 3:
              actionPayload = _a.sent();
              _a.label = 4;

            case 4:
              if (commit) {
                context.commit(commit, actionPayload);
              }

              return [2
              /*return*/
              , actionPayload];

            case 5:
              e_1 = _a.sent();
              throw rawError ? e_1 : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' + 'this.someMutation() or this.someGetter inside an @Action? \n' + 'That works only in dynamic modules. \n' + 'If not dynamic use this.context.commit("mutationName", payload) ' + 'and this.context.getters["getterName"]' + '\n' + new Error("Could not perform action ".concat(key.toString())).stack + '\n' + e_1.stack);

            case 6:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    module.actions[key] = root ? {
      root: root,
      handler: action
    } : action;
  };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */


function Action(targetOrParams, key, descriptor) {
  if (!key && !descriptor) {
    /*
     * This is the case when `targetOrParams` is params.
     * i.e. when used as -
     * <pre>
        @Action({commit: 'incrCount'})
        async getCountDelta() {
          return 5
        }
     * </pre>
     */
    return actionDecoratorFactory(targetOrParams);
  } else {
    /*
     * This is the case when @Action is called on action function
     * without any params
     * <pre>
     *   @Action
     *   async doSomething() {
     *    ...
     *   }
     * </pre>
     */
    actionDecoratorFactory()(targetOrParams, key, descriptor);
  }
}

function Mutation(target, key, descriptor) {
  var module = target.constructor;

  if (!module.hasOwnProperty('mutations')) {
    module.mutations = Object.assign({}, module.mutations);
  }

  var mutationFunction = descriptor.value;

  var mutation = function (state, payload) {
    mutationFunction.call(state, payload);
  };

  module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
  return function (target, key, descriptor) {
    var module = target.constructor;

    if (!module.hasOwnProperty('mutations')) {
      module.mutations = Object.assign({}, module.mutations);
    }

    if (!module.hasOwnProperty('actions')) {
      module.actions = Object.assign({}, module.actions);
    }

    var mutactFunction = descriptor.value;

    var action = function (context, payload) {
      return __awaiter(this, void 0, void 0, function () {
        var thisObj, actionPayload, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              thisObj = {
                context: context
              };
              addPropertiesToObject(thisObj, context.state);
              addPropertiesToObject(thisObj, context.getters);
              return [4
              /*yield*/
              , mutactFunction.call(thisObj, payload)];

            case 1:
              actionPayload = _a.sent();
              if (actionPayload === undefined) return [2
              /*return*/
              ];
              context.commit(key, actionPayload);
              return [3
              /*break*/
              , 3];

            case 2:
              e_1 = _a.sent();

              if (params.rawError) {
                throw e_1;
              } else {
                console.error('Could not perform action ' + key.toString());
                console.error(e_1);
                return [2
                /*return*/
                , Promise.reject(e_1)];
              }

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    var mutation = function (state, payload) {
      if (!params.mutate) {
        params.mutate = Object.keys(payload);
      }

      for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
        var stateItem = _a[_i];

        if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
          state[stateItem] = payload[stateItem];
        } else {
          throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
        }
      }
    };

    module.actions[key] = params.root ? {
      root: true,
      handler: action
    } : action;
    module.mutations[key] = mutation;
  };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */


function MutationAction(paramsOrTarget, key, descriptor) {
  if (!key && !descriptor) {
    /*
     * This is the case when `paramsOrTarget` is params.
     * i.e. when used as -
     * <pre>
        @MutationAction({mutate: ['incrCount']})
        async getCountDelta() {
          return {incrCount: 5}
        }
     * </pre>
     */
    return mutationActionDecoratorFactory(paramsOrTarget);
  } else {
    /*
     * This is the case when `paramsOrTarget` is target.
     * i.e. when used as -
     * <pre>
        @MutationAction
        async getCountDelta() {
          return {incrCount: 5}
        }
     * </pre>
     */
    mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
  }
}


// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind_bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




 // utils is a library of generic helper functions non-specific to axios

const {
  toString: utils_toString
} = Object.prototype;
const {
  getPrototypeOf
} = Object;

const kindOf = (cache => thing => {
  const str = utils_toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = type => {
  type = type.toLowerCase();
  return thing => kindOf(thing) === type;
};

const typeOfTest = type => thing => typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */


const {
  isArray
} = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */

const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */

function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && utils_isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */

function isArrayBufferView(val) {
  let result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */


const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */

const utils_isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */

const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */

const isObject = thing => thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */


const isBoolean = thing => thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */


const isPlainObject = val => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */


const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */

const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */

const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */

const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */

const isStream = val => isObject(val) && utils_isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */


const isFormData = thing => {
  let kind;
  return thing && (typeof FormData === 'function' && thing instanceof FormData || utils_isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
  kind === 'object' && utils_isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


const isURLSearchParams = kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */

const trim = str => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */


function forEach(obj, fn, {
  allOwnKeys = false
} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l; // Force an array if not already something iterable

  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;

  let _key;

  while (i-- > 0) {
    _key = keys[i];

    if (key === _key.toLowerCase()) {
      return _key;
    }
  }

  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();

const isContextDefined = context => !isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
utils_merge() {
  const {
    caseless
  } = isContextDefined(this) && this || {};
  const result = {};

  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;

    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = utils_merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = utils_merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */


const extend = (a, b, thisArg, {
  allOwnKeys
} = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && utils_isFunction(val)) {
      a[key] = bind_bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {
    allOwnKeys
  });
  return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */


const stripBOM = content => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */


const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */


const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {}; // eslint-disable-next-line no-eq-null,eqeqeq

  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;

    while (i-- > 0) {
      prop = props[i];

      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }

    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */


const endsWith = (str, searchString, position) => {
  str = String(str);

  if (position === undefined || position > str.length) {
    position = str.length;
  }

  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */


const toArray = thing => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);

  while (i-- > 0) {
    arr[i] = thing[i];
  }

  return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names


const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */


const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */


const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */


const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};
/* Creating a function that will check if an object has a property. */


const utils_hasOwnProperty = (({
  hasOwnProperty
}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */


const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors, (descriptor, name) => {
    let ret;

    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */


const freezeMethods = obj => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (utils_isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];
    if (!utils_isFunction(value)) return;
    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = arr => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const DIGIT = '0123456789';
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {
    length
  } = alphabet;

  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }

  return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */


function isSpecCompliantForm(thing) {
  return !!(thing && utils_isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = obj => {
  const stack = new Array(10);

  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if (!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = undefined;
        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = thing => thing && (isObject(thing) || utils_isFunction(thing)) && utils_isFunction(thing.then) && utils_isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: utils_isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge: utils_merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */

function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};
['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL' // eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {
    value: code
  };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {
  value: true
}); // eslint-disable-next-line func-names

AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);
  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js




 // temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */


function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */


function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */


function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */

function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  } // eslint-disable-next-line no-param-reassign


  formData = formData || new (helpers_null || FormData)(); // eslint-disable-next-line no-param-reassign

  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens; // eslint-disable-next-line no-use-before-define

  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;

  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;

  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }
  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */


  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2); // eslint-disable-next-line no-param-reassign

        value = JSON.stringify(value);
      } else if (utils.isArray(value) && isFlatArray(value) || (utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append( // eslint-disable-next-line no-nested-ternary
          indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }

  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);
    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers);

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);
  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js



/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */

function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */


function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function (value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js




/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */

function buildURL_encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */


function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;
  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */


  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */


  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */


  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */


  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }

}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js



/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */

const hasStandardBrowserEnv = (product => {
  return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0;
})(typeof navigator !== 'undefined' && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */


const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();


;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js


/* harmony default export */ var platform = ({ ...common_utils_namespaceObject,
  ...browser
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js





function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function (value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js



/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */

function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */


function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;

  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }

  return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */


function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);
;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js









/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {
  transitional: defaults_transitional,
  adapter: ['xhr', 'http'],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }

      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }

    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(isFileList ? {
          'files[]': data
        } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }

    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};
utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], method => {
  defaults.headers[method] = {};
});
/* harmony default export */ var lib_defaults = (defaults);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js


 // RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers

const ignoreDuplicateOf = utils.toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */

/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });
  return parsed;
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = str => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);
  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function (arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) => utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);
      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];
          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];

      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};
    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);
    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });
    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach(target => computed.set(target));
    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }

}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']); // reserved names hotfix

utils.reduceDescriptors(AxiosHeaders.prototype, ({
  value
}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`

  return {
    get: () => value,

    set(headerValue) {
      this[mapped] = headerValue;
    }

  };
});
utils.freezeMethods(AxiosHeaders);
/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js





/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */

function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });
  headers.normalize();
  return data;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js




/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */

function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});
/* harmony default export */ var cancel_CanceledError = (CanceledError);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__(2801);
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js



/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */

function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError('Request failed with status code ' + response.status, [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js


/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
  write(name, value, expires, path, domain, secure) {
    const cookie = [name + '=' + encodeURIComponent(value)];
    utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
    utils.isString(path) && cookie.push('path=' + path);
    utils.isString(domain) && cookie.push('domain=' + domain);
    secure === true && cookie.push('secure');
    document.cookie = cookie.join('; ');
  },

  read(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : null;
  },

  remove(name) {
    this.write(name, '', Date.now() - 86400000);
  }

} : // Non-standard browser env (web workers, react-native) lack needed support.
{
  write() {},

  read() {
    return null;
  },

  remove() {}

});
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */

function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js




/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */

function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js




/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  const msie = /(msie|trident)/i.test(navigator.userAgent);
  const urlParsingNode = document.createElement('a');
  let originURL;
  /**
  * Parse a URL to discover its components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    let href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}());
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */

function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== undefined ? min : 1000;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js

















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;

  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;

    const rate = _speedometer(progressBytes);

    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };
    data[isDownloadStream ? 'download' : 'upload'] = true;
    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {
      responseType,
      withXSRFToken
    } = config;
    let onCanceled;

    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      const responseHeaders = core_AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(new core_AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED, config, request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(fullPath)) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    } // Remove Content-Type if data is undefined


    requestData === undefined && requestHeaders.setContentType(null); // Add headers to the request

    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    } // Add withCredentials to request if needed


    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }

        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);

      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    } // Send the request


    request.send(requestData || null);
  });
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js




const knownAdapters = {
  http: helpers_null,
  xhr: xhr
};
utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {
        value
      });
    } catch (e) {// eslint-disable-next-line no-empty
    }

    Object.defineProperty(fn, 'adapterName', {
      value
    });
  }
});

const renderReason = reason => `- ${reason}`;

const isResolvedHandle = adapter => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: adapters => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];
    const {
      length
    } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;
      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(([id, state]) => `adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
      let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
      throw new core_AxiosError(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }

    return adapter;
  },
  adapters: knownAdapters
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js








/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */


function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = core_AxiosHeaders.from(config.headers); // Transform request data

  config.data = transformData.call(config, config.transformRequest);

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, config.transformResponse, response);
    response.headers = core_AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = thing => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */


function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({
        caseless
      }, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }

    return source;
  } // eslint-disable-next-line consistent-return


  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  } // eslint-disable-next-line consistent-return


  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  } // eslint-disable-next-line consistent-return


  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  } // eslint-disable-next-line consistent-return


  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };
  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.6.2";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js




const validators = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */

validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), core_AxiosError.ERR_DEPRECATED);
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */


function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }

  const keys = Object.keys(options);
  let i = keys.length;

  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];

    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});
;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js










const Axios_validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */

class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */


  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);
    const {
      transitional,
      paramsSerializer,
      headers
    } = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    } // Set config.method


    config.method = (config.method || this.defaults.method || 'get').toLowerCase(); // Flatten headers

    let contextHeaders = headers && utils.merge(headers.common, headers[config.method]);
    headers && utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], method => {
      delete headers[method];
    });
    config.headers = core_AxiosHeaders.concat(contextHeaders, headers); // filter out skipped interceptors

    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];

      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }

} // Provide aliases for supported request methods


utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
/* harmony default export */ var core_Axios = (Axios);
;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */

class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this; // eslint-disable-next-line func-names

    this.promise.then(cancel => {
      if (!token._listeners) return;
      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }

      token._listeners = null;
    }); // eslint-disable-next-line func-names

    this.promise.then = onfulfilled => {
      let _resolve; // eslint-disable-next-line func-names


      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */


  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */


  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */


  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }

    const index = this._listeners.indexOf(listener);

    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */


  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }

}

/* harmony default export */ var cancel_CancelToken = (CancelToken);
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */

function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js



/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */

function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);
;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */

function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind_bind(core_Axios.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, core_Axios.prototype, context, {
    allOwnKeys: true
  }); // Copy context to instance

  utils.extend(instance, context, null, {
    allOwnKeys: true
  }); // Factory for creating new instances

  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
} // Create the default instance to be exported


const axios = createInstance(lib_defaults); // Expose Axios class to allow class inheritance

axios.Axios = core_Axios; // Expose Cancel & CancelToken

axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData; // Expose AxiosError class

axios.AxiosError = core_AxiosError; // alias for CanceledError for backward compatibility

axios.Cancel = axios.CanceledError; // Expose all/spread

axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread; // Expose isAxiosError

axios.isAxiosError = isAxiosError; // Expose mergeConfig

axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = helpers_HttpStatusCode;
axios.default = axios; // this module should only have a default export

/* harmony default export */ var lib_axios = (axios);
;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject);
;// CONCATENATED MODULE: ./src/utils/takeGlobalOptions.ts


const globalOptions = () => (external_commonjs_vue_commonjs2_vue_root_Vue_default()).prototype.$globalOptions;

/* harmony default export */ var takeGlobalOptions = (globalOptions);
;// CONCATENATED MODULE: ./src/utils/setCookie.ts
const setCookie = (token, cookieActiveDays = 30, name = 'cgToken') => {
  const cookieName = `${name}=${token};`;
  const path = 'path=/;';
  const domainInfo = window.location.host.split('.');
  if (!['staging', 'development', 'corporategift'].includes(domainInfo[0])) domainInfo.splice(0, 1);
  let domain = `domain=.${domainInfo.join('.')};`;
  if (window.location.host.includes('localhost')) domain = '';
  const maxAge = 60 * 60 * 24 * cookieActiveDays;
  const expiration = `max-age=${maxAge};`;
  document.cookie = `${cookieName}${domain}${path}${expiration}`;
};

/* harmony default export */ var utils_setCookie = (setCookie);
;// CONCATENATED MODULE: ./src/utils/getCookie.ts
const getCookie = cookieName => {
  const cookie = {};
  document.cookie.split(';').forEach(el => {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName] ?? null;
};

/* harmony default export */ var utils_getCookie = (getCookie);
;// CONCATENATED MODULE: ./src/store/auth.store.ts


var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







const userIsInAccountModule = () => {
  const {
    host
  } = window.location;
  const domains = host.split('.');
  const subdomain = domains[0];
  return subdomain === 'account';
};

const removeCompanyStoreCookie = name => {
  const token = null;
  const cookieActiveDays = 0;
  const cookieName = `${name}=${token};`;
  const path = 'path=/;';
  const domainInfo = window.location.host;
  const domain = `domain=.${domainInfo};`;
  const maxAge = 60 * 60 * 24 * cookieActiveDays;
  const expiration = `max-age=${maxAge};`;
  document.cookie = `${cookieName}${domain}${path}${expiration}`;
};

let AuthModule = class AuthModule extends VuexModule {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "token", '');

    _defineProperty(this, "userIsLoggedIn", false);

    _defineProperty(this, "loadingToken", false);

    _defineProperty(this, "showRestoreSession", false);
  }

  setToken(token) {
    const [firstPart, secondPart] = token.split('|');
    const adminCgToken = utils_getCookie('adminCgToken');
    this.token = `${firstPart}|${secondPart}`;
    this.showRestoreSession = !!adminCgToken;
    this.userIsLoggedIn = true;
    this.loadingToken = false;
  }

  clearToken() {
    this.userIsLoggedIn = false;
    this.showRestoreSession = false;
    this.token = '';
    utils_setCookie(null, 0, 'cgToken');
    utils_setCookie(null, 0, 'cgUserIsVendor'); // try to remove cookies when the domain is not a corporategift.com

    if (!window.location.host.includes('corporategift.com')) {
      removeCompanyStoreCookie('cgToken');
      removeCompanyStoreCookie('cgUserIsVendor');
    }
  }

  setLoadingToken(value = true) {
    this.loadingToken = value;
  }

  async getToken() {
    const {
      token: envToken,
      testMode,
      testEmail: email,
      testPassword: password
    } = takeGlobalOptions();
    const cookieToken = utils_getCookie('cgToken');
    if (envToken) return envToken;

    if (cookieToken && cookieToken !== 'null') {
      this.context.commit('setToken', cookieToken);
      return cookieToken;
    }

    if (testMode && testMode !== 'false') {
      await this.context.dispatch('login', {
        email,
        password
      });
    }

    return '';
  }

  async login({
    email,
    password
  }) {
    const {
      apiUrl
    } = takeGlobalOptions();
    this.context.commit('setLoadingToken', true);
    await lib_axios.post('/api/customer/login', {
      email,
      password
    }, {
      baseURL: apiUrl
    }).then(({
      data
    }) => {
      if (data?.token) {
        utils_setCookie(data.token, 14, 'cgToken');
        this.context.commit('setToken', data.token);
        this.context.dispatch('header/loadHeader', null, {
          root: true
        });
      }
    }).catch(err => console.error(err));
  }

  logout() {
    const {
      apiUrl,
      storeUrl
    } = takeGlobalOptions();
    const {
      token
    } = this.context.state;
    this.context.commit('clearToken');
    lib_axios.get('/api/customer/logout', {
      baseURL: apiUrl,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(() => {
      if (!userIsInAccountModule()) window.location.href = storeUrl;
    });
  }

};

__decorate([Mutation], AuthModule.prototype, "setToken", null);

__decorate([Mutation], AuthModule.prototype, "clearToken", null);

__decorate([Mutation], AuthModule.prototype, "setLoadingToken", null);

__decorate([Action], AuthModule.prototype, "getToken", null);

__decorate([Action], AuthModule.prototype, "login", null);

__decorate([Action], AuthModule.prototype, "logout", null);

AuthModule = __decorate([Module({
  namespaced: true
})], AuthModule);

;// CONCATENATED MODULE: ./node_modules/camelize-ts/dist/index.js
function camelCase(str) {
  return str.replace(/[_.-](\w|$)/g, function (_, x) {
    return x.toUpperCase();
  });
}

function walk(obj) {
  if (!obj || typeof obj !== "object") return obj;
  if (obj instanceof Date || obj instanceof RegExp) return obj;
  if (Array.isArray(obj)) return obj.map(walk);
  return Object.keys(obj).reduce((res, key) => {
    const camel = camelCase(key);
    res[camel] = walk(obj[key]);
    return res;
  }, {});
}

function camelize(obj) {
  return typeof obj === "string" ? camelCase(obj) : walk(obj);
}
;// CONCATENATED MODULE: ./src/store/header.store.ts


var header_store_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}; // prettier-ignore







const getExternalDomain = () => {
  const hostInfo = window.location.host;
  const [subdomain] = hostInfo.split('.');
  const internalDomains = ['staging', 'development', 'dev', 'corporategift', 'account'];

  if (internalDomains.includes(subdomain)) {
    return undefined;
  }

  return hostInfo;
};

const findMenuDataByRouterKey = (cmsResponse, routerKeyToFind) => {
  // prettier-ignore
  const itemToFind = cmsResponse.find(responseItem => responseItem.uiRouterKey?.includes(routerKeyToFind));

  if (!itemToFind) {
    return [];
  }

  const activeItems = itemToFind.items?.filter(item => item.menuAttached);
  return activeItems.map(item => ({
    subTitle: item.items[0]?.title ?? '',
    title: item.title,
    url: item.path?.replace('/#/', '') ?? ''
  }));
};

const sendUserIdentification = ({
  customerId,
  customerName,
  customerLastName,
  customerEmail
}) => {
  if (!customerEmail || !customerId) {
    return;
  }

  if (LogRocket) {
    LogRocket.identify(customerId, {
      name: [customerName, customerLastName].join(' '),
      email: customerEmail
    });
  } // eslint-disable-next-line no-underscore-dangle


  const hsq = window?._hsq;

  if (hsq) {
    hsq.push(['identify', {
      email: customerEmail
    }]);
    hsq.push(['trackPageView']);
    window?.HubSpotConversations?.widget?.refresh();
  }
};

const getNavigationLinkWithImage = (cmsResponse, routerKeyToFind) => {
  // prettier-ignore
  const itemToFind = cmsResponse.find(responseItem => responseItem.uiRouterKey?.includes(routerKeyToFind));

  if (!itemToFind) {
    return [];
  }

  const activeItems = itemToFind.items?.filter(item => item.menuAttached);
  return activeItems.map(item => ({
    text: item.title,
    image: item.items.find(subItems => subItems.title === 'STORY_IMAGE')?.path ?? '',
    url: item.path?.replace('/#/', '') ?? ''
  }));
};

let HeaderModule = class HeaderModule extends VuexModule {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "headerData", {
      logoUrl: '',
      customerName: '',
      customerLastName: '',
      companyName: '',
      companyId: undefined,
      customerId: undefined,
      customerEmail: '',
      eliteTrial: null,
      menus: {
        approvableOrders: false,
        hideDefaultMenu: false,
        hideMenu: false,
        hideSearch: false,
        mySubAccounts: false,
        myInventory: false,
        myCgCredits: false,
        myCampaigns: false,
        vendorPanel: false,
        mySettings: false,
        groupLink: false,
        myQuotes: false
      },
      cart: {
        count: 0,
        items: [],
        subtotal: 0
      },
      links: [],
      isElite: false,
      isAdmin: false,
      isSubaccount: false,
      isMasterAccount: false,
      isSuperAdmin: false,
      checkoutNeedsApproval: false,
      isInternationalShipping: false,
      ordersForApprovalCount: 0,
      hideCgEliteLogo: false,
      hideTopStrip: false,
      searchableCategories: [],
      searchFilters: '',
      sso: false
    });

    _defineProperty(this, "cmsHeaderData", {
      menuSolutionsServices: {
        id: 0,
        menuGiftingNeeds: [],
        menuGiftingNeedsIcon: undefined,
        menuGiftingNeedsTitle: '',
        menuGiftingServices: [],
        menuGiftingServicesIcon: undefined,
        menuGiftingServicesTitle: '',
        menuSolutions: [],
        menuSolutionsByRole: [],
        menuSolutionsByRoleIcon: undefined,
        menuSolutionsByRoleTitle: '',
        menuSolutionsIcon: undefined,
        menuSolutionsTitle: ''
      }
    });

    _defineProperty(this, "cmsWhatWeOfferData", {
      shopCustomize: [],
      enrageRecipient: [],
      streamlineGifting: [],
      storeAndManageMerchandise: [],
      secureData: [],
      enterpriseSolutions: [],
      customerStories: []
    });

    _defineProperty(this, "cmsResourcesData", {
      articlesAndInspiration: [],
      learn: [],
      lastArticles: []
    });

    _defineProperty(this, "showCart", false);

    _defineProperty(this, "shopProductsNavigation", []);

    _defineProperty(this, "shopByNavigation", []);

    _defineProperty(this, "hideHeaderDropdowns", false);

    _defineProperty(this, "hideHeaderTopInfo", false);

    _defineProperty(this, "hideSearchInput", false);

    _defineProperty(this, "hideFavoritesIcon", false);

    _defineProperty(this, "hideMiniCartIcon", false);
  }

  setHeader(data) {
    const camelizedData = camelize(data);
    this.headerData = camelizedData;
    sendUserIdentification(camelizedData);
  }

  setCmsHeader(data) {
    const camelizedData = camelize(data);
    this.cmsHeaderData = camelizedData;
  }

  setShopProductsNavigation(data) {
    this.shopProductsNavigation = data;
  }

  setShopByNavigation(data) {
    this.shopByNavigation = data;
  }

  setCartAmount(value) {
    this.headerData.cart.count = value;
  }

  setShowCart(value) {
    this.showCart = value;
  }

  setHideHeaderDropdowns(value) {
    this.hideHeaderDropdowns = value;
  }

  setHideHeaderTopInfo(value) {
    this.hideHeaderTopInfo = value;
  }

  setHideSearchInput(value) {
    this.hideSearchInput = value;
  }

  setHideFavoritesIcon(value) {
    this.hideFavoritesIcon = value;
  }

  setHideMiniCartIcon(value) {
    this.hideMiniCartIcon = value;
  }

  decreaseNumberOrderForApproval(value = 1) {
    const {
      ordersForApprovalCount
    } = this.headerData;

    if (ordersForApprovalCount) {
      this.headerData.ordersForApprovalCount = ordersForApprovalCount - value;
    }
  }

  setWhatWeOfferData({
    shopCustomize,
    enrageRecipient,
    streamlineGifting,
    storeAndManageMerchandise,
    secureData,
    enterpriseSolutions
  }) {
    this.cmsWhatWeOfferData.shopCustomize = shopCustomize;
    this.cmsWhatWeOfferData.enrageRecipient = enrageRecipient;
    this.cmsWhatWeOfferData.streamlineGifting = streamlineGifting;
    this.cmsWhatWeOfferData.storeAndManageMerchandise = storeAndManageMerchandise;
    this.cmsWhatWeOfferData.secureData = secureData;
    this.cmsWhatWeOfferData.enterpriseSolutions = enterpriseSolutions;
  }

  setCustomerStories(stories) {
    this.cmsWhatWeOfferData.customerStories = stories;
  }

  setResourcesData({
    articlesAndInspiration,
    learn
  }) {
    this.cmsResourcesData.learn = learn;
    this.cmsResourcesData.articlesAndInspiration = articlesAndInspiration;
  }

  setLastArticles(articles) {
    this.cmsResourcesData.lastArticles = articles;
  }

  async loadHeader() {
    const {
      apiUrl
    } = takeGlobalOptions();
    const externalDomain = getExternalDomain();
    const token = await this.context.dispatch('headerAuth/getToken', null, {
      root: true
    });
    await lib_axios.get('/customer/header', {
      baseURL: `${apiUrl}/api`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      params: {
        cartToken: localStorage.getItem('cartToken'),
        externalDomain
      }
    }).then(({
      data
    }) => {
      this.context.commit('setHeader', data?.data);
    }).catch(err => console.error(err));
  }

  setNavigationShopProducts(data) {
    const parentItems = data.filter(item => !item.parent && item.menuAttached).map(item => ({
      id: item.id,
      path: ['/#', '#'].includes(item.path) ? null : item.path,
      title: item.title,
      children: item?.items?.filter(subItem => subItem.menuAttached)?.map(child => ({
        id: child.id,
        order: child.order,
        title: child.title,
        path: child.externalPath || child.path
      })) ?? []
    }));
    this.context.commit('setShopProductsNavigation', parentItems);
  }

  setNavigationShopBy(data) {
    const parentItems = data.filter(item => !item.parent && item.menuAttached).map(item => ({
      id: item.id,
      path: ['/#', '#'].includes(item.path) ? null : item.path,
      title: item.title,
      children: item?.items?.filter(subItem => subItem.menuAttached)?.map(child => ({
        id: child.id,
        order: child.order,
        title: child.title,
        path: child.externalPath || child.path
      })) ?? []
    }));
    this.context.commit('setShopByNavigation', parentItems);
  }

  setNavigationWhatWeOffer(data) {
    const shopCustomize = findMenuDataByRouterKey(data, 'shop-customize-and-ideate');
    const enrageRecipient = findMenuDataByRouterKey(data, 'engage-recipients');
    const streamlineGifting = findMenuDataByRouterKey(data, 'streamline-gifting');
    const storeAndManageMerchandise = findMenuDataByRouterKey(data, 'store-and-manage-merchandise');
    const secureData = findMenuDataByRouterKey(data, 'secure-data');
    const enterpriseSolutions = findMenuDataByRouterKey(data, 'enterprise-solutions');
    this.context.commit('setWhatWeOfferData', {
      secureData,
      shopCustomize,
      enrageRecipient,
      streamlineGifting,
      enterpriseSolutions,
      storeAndManageMerchandise
    });
  }

  setNavigationResources(data) {
    const articlesAndInspiration = findMenuDataByRouterKey(data, 'articles');
    const learn = findMenuDataByRouterKey(data, 'learn');
    const lastArticle = getNavigationLinkWithImage(data, 'last-article');
    this.context.commit('setResourcesData', {
      articlesAndInspiration,
      learn
    });
    this.context.commit('setLastArticles', lastArticle);
  }

  setNavigationCustomerStories(data) {
    const customerStories = getNavigationLinkWithImage(data, 'customer-stories');
    this.context.commit('setCustomerStories', customerStories);
  }

  async loadCMSNavigationData() {
    const {
      cmsUrl
    } = takeGlobalOptions();
    const externalDomain = getExternalDomain();
    await lib_axios.get('/nav/bundled', {
      baseURL: cmsUrl,
      headers: {
        Accept: 'application/json'
      },
      params: {
        externalDomain
      }
    }).then(({
      data
    }) => {
      this.context.commit('setCmsHeader', data.header);
      this.context.dispatch('setNavigationShopProducts', data.shopProducts);
      this.context.dispatch('setNavigationShopBy', data.shopBy);
      this.context.dispatch('setNavigationWhatWeOffer', data.whatWeOffer);
      this.context.dispatch('setNavigationResources', data.resources);
      this.context.dispatch('setNavigationCustomerStories', data.customerStories);
    });
  }

  get customerId() {
    return this.headerData?.customerId ?? undefined;
  }

  get companyId() {
    return this.headerData?.companyId ?? undefined;
  }

  get userCanApproveOrders() {
    return this.headerData?.menus?.approvableOrders ?? false;
  }

  get userOrdersRequireApproval() {
    return this.headerData?.checkoutNeedsApproval ?? false;
  }

};

header_store_decorate([Mutation], HeaderModule.prototype, "setHeader", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setCmsHeader", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setShopProductsNavigation", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setShopByNavigation", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setCartAmount", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setShowCart", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setHideHeaderDropdowns", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setHideHeaderTopInfo", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setHideSearchInput", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setHideFavoritesIcon", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setHideMiniCartIcon", null);

header_store_decorate([Mutation], HeaderModule.prototype, "decreaseNumberOrderForApproval", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setWhatWeOfferData", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setCustomerStories", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setResourcesData", null);

header_store_decorate([Mutation], HeaderModule.prototype, "setLastArticles", null);

header_store_decorate([Action], HeaderModule.prototype, "loadHeader", null);

header_store_decorate([Action], HeaderModule.prototype, "setNavigationShopProducts", null);

header_store_decorate([Action], HeaderModule.prototype, "setNavigationShopBy", null);

header_store_decorate([Action], HeaderModule.prototype, "setNavigationWhatWeOffer", null);

header_store_decorate([Action], HeaderModule.prototype, "setNavigationResources", null);

header_store_decorate([Action], HeaderModule.prototype, "setNavigationCustomerStories", null);

header_store_decorate([Action], HeaderModule.prototype, "loadCMSNavigationData", null);

HeaderModule = header_store_decorate([Module({
  namespaced: true
})], HeaderModule);

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeader.vue?vue&type=template&id=46832b98&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cg-header",class:{ 'cg-header--is-fixed': _vm.fixed },style:(("left: " + _vm.left + "px; --header-height: -" + _vm.headerHeight + "px"))},[_c('header',{class:{ 'header--is-hidden': _vm.hideHeader }},[(!_vm.userUsingPhone
      && !_vm.userUsingTablet && !_vm.hideHeaderTopInfo && !_vm.userIsInAccountModule && !_vm.hasExternalDomain)?_c('the-header-info'):_vm._e(),(!_vm.userUsingPhone && _vm.userIsInAccountModule && _vm.userHasFreeTrial)?_c('header-free-trail-strip'):_vm._e(),_c('the-header-user-area',_vm._g({attrs:{"domain-logo":_vm.domainLogo},on:{"onShowCart":function($event){_vm.showCart = !_vm.showCart}}},_vm.$listeners)),(_vm.showHeaderMenus)?_c('the-header-menus'):_vm._e()],1),_c('the-cart-panel',_vm._g({model:{value:(_vm.showCart),callback:function ($$v) {_vm.showCart=$$v},expression:"showCart"}},_vm.$listeners))],1)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js


/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function vue_class_component_esm_typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    vue_class_component_esm_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    vue_class_component_esm_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return vue_class_component_esm_typeof(obj);
}

function vue_class_component_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
} // The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.


function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}

function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;

function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}

function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
    mixins: Ctors
  });
}

function isPrimitive(value) {
  var type = vue_class_component_esm_typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}

function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this; // proxy to actual vm


    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];

function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return vue_class_component_esm_defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_commonjs_vue_commonjs2_vue_root_Vue_default()) ? superProto.constructor : (external_commonjs_vue_commonjs2_vue_root_Vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}

var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);

;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}; // Code copied from Vue/src/shared/util.js


var hyphenateRE = /\B([A-Z])/g;

var hyphenate = function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase();
};
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */


function Emit(event) {
  return function (_target, propertyKey, descriptor) {
    var key = hyphenate(propertyKey);
    var original = descriptor.value;

    descriptor.value = function emitter() {
      var _this = this;

      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var emit = function (returnValue) {
        var emitName = event || key;

        if (returnValue === undefined) {
          if (args.length === 0) {
            _this.$emit(emitName);
          } else if (args.length === 1) {
            _this.$emit(emitName, args[0]);
          } else {
            _this.$emit.apply(_this, __spreadArrays([emitName], args));
          }
        } else {
          args.unshift(returnValue);

          _this.$emit.apply(_this, __spreadArrays([emitName], args));
        }
      };

      var returnValue = original.apply(this, args);

      if (isPromise(returnValue)) {
        returnValue.then(emit);
      } else {
        emit(returnValue);
      }

      return returnValue;
    };
  };
}

function isPromise(obj) {
  return obj instanceof Promise || obj && typeof obj.then === 'function';
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
  if (reflectMetadataIsSupported) {
    if (!Array.isArray(options) && typeof options !== 'function' && !options.hasOwnProperty('type') && typeof options.type === 'undefined') {
      var type = Reflect.getMetadata('design:type', target, key);

      if (type !== Object) {
        options.type = type;
      }
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */

function Model(event, options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    applyMetadata(options, target, key);
    createDecorator(function (componentOptions, k) {
      ;
      (componentOptions.props || (componentOptions.props = {}))[k] = options;
      componentOptions.model = {
        prop: k,
        event: event || k
      };
    })(target, key);
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */

function ModelSync(propName, event, options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    applyMetadata(options, target, key);
    createDecorator(function (componentOptions, k) {
      ;
      (componentOptions.props || (componentOptions.props = {}))[propName] = options;
      componentOptions.model = {
        prop: propName,
        event: event || k
      };
      (componentOptions.computed || (componentOptions.computed = {}))[k] = {
        get: function () {
          return this[propName];
        },
        set: function (value) {
          // @ts-ignore
          this.$emit(event, value);
        }
      };
    })(target, key);
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */

function Prop(options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    metadata_applyMetadata(options, target, key);
    vue_class_component_esm_createDecorator(function (componentOptions, k) {
      ;
      (componentOptions.props || (componentOptions.props = {}))[k] = options;
    })(target, key);
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */

function PropSync(propName, options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    applyMetadata(options, target, key);
    createDecorator(function (componentOptions, k) {
      ;
      (componentOptions.props || (componentOptions.props = {}))[propName] = options;
      (componentOptions.computed || (componentOptions.computed = {}))[k] = {
        get: function () {
          return this[propName];
        },
        set: function (value) {
          this.$emit("update:" + propName, value);
        }
      };
    })(target, key);
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */

function Watch(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.deep,
      deep = _a === void 0 ? false : _a,
      _b = options.immediate,
      immediate = _b === void 0 ? false : _b;
  return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
    if (typeof componentOptions.watch !== 'object') {
      componentOptions.watch = Object.create(null);
    }

    var watch = componentOptions.watch;

    if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
      watch[path] = [watch[path]];
    } else if (typeof watch[path] === 'undefined') {
      watch[path] = [];
    }

    watch[path].push({
      handler: handler,
      deep: deep,
      immediate: immediate
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>















;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanel.vue?vue&type=template&id=0b9f4ff8&scoped=true&
var TheCartPanelvue_type_template_id_0b9f4ff8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-left-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"the-cart-panel",class:{ 'the-cart-panel--expanded': _vm.showExpandedPanel }},[_c('div',{staticClass:"the-cart-panel__title"},[_c('div',{staticClass:"title__wrapper"},[_vm._v(" Cart summary "),_c('div',{staticClass:"title__wrapper--badge"},[_vm._v(" "+_vm._s(_vm.userCartAmount)+" ")])]),_c('div',{staticClass:"the-cart-panel__title--icon",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.show = false},"keypress":function($event){_vm.show = false}}},[_c('close-icon',{attrs:{"color":"#95979D","height":24,"width":24}})],1)]),_c('div',{staticClass:"the-cart-panel__content"},[_c('div',{staticClass:"the-cart-panel__content-item"},[_c('div',{staticClass:"the-cart-panel__products"},[(_vm.cartProducts.length)?[_vm._l((_vm.cartProducts),function(product){return _c('the-cart-panel-item',{key:product.id,attrs:{"product":product,"readonly":_vm.isCartReadonly,"showCustomization":(_vm.showExpandedPanel && product.id === _vm.selectedProduct.id)},on:{"showProductCustomizationInfo":function($event){return _vm.showProductCustomization(product)},"updateProductQty":_vm.updateProductQty,"deleteProduct":_vm.removeProduct}})}),_c('the-cart-panel-subtotal',{attrs:{"cart-product-amount":_vm.userCartAmount,"cart-subtotal":_vm.userCartSubtotal,"cart-discount":_vm.discount,"cart-setup-fee":_vm.cartSetupFee}})]:[_c('div',{staticClass:"the-cart-panel__products--empty"},[(_vm.loading)?_c('img',{attrs:{"alt":"Loading...","src":"https://account.corporategift.com/images/loading.gif"}}):[_c('empty-cart-icon'),_vm._v(" No items in your cart ")]],2)]],2),(_vm.cartProducts.length)?_c('the-cart-panel-actions',{attrs:{"cart-total":_vm.cartTotal,"show-box-shadow":_vm.showBottomShadow}}):_vm._e()],1),(_vm.showExpandedPanel)?_c('div',{staticClass:"the-cart-panel__content-item"},[_c('the-cart-panel-customization',{attrs:{"product":_vm.selectedProduct},on:{"hideCustomizationInfo":function($event){_vm.showExpandedPanel = false}}})],1):_vm._e()])])])}
var TheCartPanelvue_type_template_id_0b9f4ff8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/userIsLoggedIn.ts
var userIsLoggedIn_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserIsLoggedIn = class UserIsLoggedIn extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get userIsLoggedIn() {
    return this.$store.state.headerAuth.userIsLoggedIn || false;
  }

};
UserIsLoggedIn = userIsLoggedIn_decorate([vue_class_component_esm], UserIsLoggedIn);
/* harmony default export */ var userIsLoggedIn = (UserIsLoggedIn);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/EmptyCart.vue?vue&type=template&id=cd515d0a&
var EmptyCartvue_type_template_id_cd515d0a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 98 102","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{staticStyle:{"mix-blend-mode":"multiply"}},[_c('circle',{attrs:{"cx":"60.125","cy":"64.5","r":"37","fill":"#DFDDEE"}}),_c('circle',{attrs:{"cx":"7.375","cy":"43","r":"6.5","fill":"#DFDDEE"}}),_c('circle',{attrs:{"cx":"22.625","cy":"10","r":"9.5","fill":"#DFDDEE"}})]),_c('path',{attrs:{"d":"M43.6669 59.5913H79.2226C79.7132 59.5908 80.1452 59.2567 80.2861 58.7693L86.9528\n      35.7084C87.054 35.3594 86.9905 34.9815 86.7807 34.6886C86.5714 34.3962 86.2405 34.2238\n      85.8893 34.2243H40.378L38.068 25.8365C37.9316 25.3418 37.4961 25.0005 37 25H28.1111C27.4975\n      25 27 25.5163 27 26.153C27 26.7898 27.4975 27.3061 28.1111 27.3061H36.1622L44.4167\n      57.2853H43.6667C40.8879 57.2853 38.3204 58.8239 36.9311 61.3209C35.5417 63.818 35.5417\n      66.8952 36.9311 69.3922C38.3204 71.8893 40.8879 73.4279 43.6667 73.4279H45.3998C44.2351\n      74.7575 43.6145 76.5051 43.6691 78.301C43.7242 80.097 44.4504 81.8003 45.6939\n      83.0506C46.9375 84.301 48.6012 85 50.3328 85C52.064 85 53.7276 84.301 54.9712\n      83.0506C56.2152 81.8003 56.9409 80.097 56.9959 78.301C57.0505 76.505 56.43 74.7574 55.2653\n      73.4279H68.7333C67.3736 75.0113 66.7918 77.1563 67.1564 79.2431C67.5209 81.3304 68.7913\n      83.1269 70.6003 84.1142C72.4093 85.1015 74.5556 85.1694 76.4193 84.298C78.2824 83.427\n      79.6558 81.714 80.1419 79.6539C80.6285 77.5938 80.1737 75.416 78.9088 73.7496C77.6444\n      72.0833 75.7108 71.1141 73.6667 71.1219H43.6666C41.682 71.1219 39.8477 70.0229 38.8555\n      68.2393C37.863 66.4557 37.863 64.2576 38.8555 62.474C39.8476 60.6904 41.682 59.5914 43.6666\n      59.5914L43.6669 59.5913ZM41.0122 36.5304H84.3965L78.3965 57.2852H46.7265L41.0122\n      36.5304ZM73.6675 73.4279C74.8461 73.4279 75.9766 73.9138 76.8104 74.7786C77.6438 75.6439\n      78.112 76.817 78.112 78.04C78.112 79.2631 77.6438 80.4363 76.8104 81.3015C75.9766 82.1663\n      74.8461 82.6522 73.6675 82.6522C72.489 82.6522 71.3585 82.1663 70.5247 81.3015C69.6913\n      80.4362 69.2231 79.2631 69.2231 78.04C69.2246 76.817 69.6933 75.6449 70.5262\n      74.7802C71.3595 73.9159 72.489 73.4294 73.6675 73.4279ZM50.3341 73.4279C51.5127 73.4279\n      52.6432 73.9138 53.477 74.7786C54.3103 75.6439 54.7786 76.817 54.7786 78.04C54.7786 79.2631\n      54.3103 80.4363 53.477 81.3015C52.6431 82.1663 51.5126 82.6522 50.3341 82.6522C49.1556\n      82.6522 48.025 82.1663 47.1912 81.3015C46.3579 80.4362 45.8896 79.2631 45.8896\n      78.04C45.8911 76.817 46.3599 75.6449 47.1928 74.7802C48.0261 73.9159 49.1556 73.4294\n      50.3341 73.4279Z\n    ","fill":"#95979D"}})])}
var EmptyCartvue_type_template_id_cd515d0a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/EmptyCart.vue?vue&type=script&lang=ts&


var EmptyCartvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let EmptyCart = class EmptyCart extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

EmptyCartvue_type_script_lang_ts_decorate([Prop({
  default: 98
})], EmptyCart.prototype, "width", void 0);

EmptyCartvue_type_script_lang_ts_decorate([Prop({
  default: 102
})], EmptyCart.prototype, "height", void 0);

EmptyCart = EmptyCartvue_type_script_lang_ts_decorate([vue_class_component_esm], EmptyCart);
/* harmony default export */ var EmptyCartvue_type_script_lang_ts_ = (EmptyCart);
;// CONCATENATED MODULE: ./src/components/icons/EmptyCart.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_EmptyCartvue_type_script_lang_ts_ = (EmptyCartvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function componentNormalizer_normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/icons/EmptyCart.vue





/* normalize component */
;
var component = componentNormalizer_normalizeComponent(
  icons_EmptyCartvue_type_script_lang_ts_,
  EmptyCartvue_type_template_id_cd515d0a_render,
  EmptyCartvue_type_template_id_cd515d0a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_EmptyCart = (component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Close.vue?vue&type=template&id=1bc38ad0&
var Closevue_type_template_id_1bc38ad0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M12 11.086L16.95 6.13599L18.364 7.54999L13.414 12.5L18.364 17.45L16.95 18.864L12\n      13.914L7.04999 18.864L5.63599 17.45L10.586 12.5L5.63599 7.54999L7.04999 6.13599L12 11.086Z","fill":_vm.color}})])}
var Closevue_type_template_id_1bc38ad0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Close.vue?vue&type=script&lang=ts&


var Closevue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Close = class Close extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);

    _defineProperty(this, "color", void 0);
  }

};

Closevue_type_script_lang_ts_decorate([Prop({
  default: 24
})], Close.prototype, "width", void 0);

Closevue_type_script_lang_ts_decorate([Prop({
  default: 24
})], Close.prototype, "height", void 0);

Closevue_type_script_lang_ts_decorate([Prop({
  default: '#95979D'
})], Close.prototype, "color", void 0);

Close = Closevue_type_script_lang_ts_decorate([vue_class_component_esm], Close);
/* harmony default export */ var Closevue_type_script_lang_ts_ = (Close);
;// CONCATENATED MODULE: ./src/components/icons/Close.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Closevue_type_script_lang_ts_ = (Closevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Close.vue





/* normalize component */
;
var Close_component = componentNormalizer_normalizeComponent(
  icons_Closevue_type_script_lang_ts_,
  Closevue_type_template_id_1bc38ad0_render,
  Closevue_type_template_id_1bc38ad0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Close = (Close_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelItem.vue?vue&type=template&id=c98208f0&scoped=true&
var TheCartPanelItemvue_type_template_id_c98208f0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-item",class:{ 'the-cart-panel-item--show-arrow': _vm.showCustomization }},[_c('div',{staticClass:"the-cart-panel-item__image"},[_c('a',{attrs:{"href":_vm.product.redirectUrl}},[_c('img',{attrs:{"src":_vm.productImage,"alt":_vm.product.name}})]),(_vm.productHasPersonalization)?_c('a',{on:{"click":function($event){return _vm.$emit('showProductCustomizationInfo')},"keypress":function($event){return _vm.$emit('showProductCustomizationInfo')}}},[_vm._v(" Customized ")]):_vm._e()]),_c('div',{staticClass:"the-cart-panel-item__content"},[_c('div',{staticClass:"content__title"},[_c('h5',[_c('a',{attrs:{"href":_vm.product.redirectUrl}},[_vm._v(" "+_vm._s(_vm.product.name)+" ")])]),(!_vm.readonly)?_c('div',{attrs:{"tabindex":"0","id":"delete"},on:{"click":function($event){return _vm.$emit('deleteProduct', _vm.product.id)},"keypress":function($event){return _vm.$emit('deleteProduct', _vm.product.id)}}},[_c('delete-icon')],1):_vm._e()]),(_vm.productHasPersonalization)?_c('div',{staticClass:"content__attributes"},_vm._l((_vm.product.personalizations),function(personalization,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(personalization.title)+" ")])}),0):_vm._e(),(_vm.productHasConfigurations)?_c('div',{staticClass:"content__attributes"},_vm._l((_vm.product.configurations),function(configuration,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(configuration.label)+": "+_vm._s(configuration.value)+" ")])}),0):_vm._e(),(_vm.productHasQuoteOptions)?_c('div',{staticClass:"content__attributes"},_vm._l((_vm.product.myQuoteOptions),function(quoteOption,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(quoteOption.label)+": "+_vm._s(quoteOption.value)+" ")])}),0):_vm._e(),_c('div',{staticClass:"content__actions"},[_c('div',{staticClass:"input-wrapper",class:{ 'input-wrapper--disabled': _vm.readonly }},[_c('button',{attrs:{"tabindex":"0","id":"decrement","disabled":_vm.productMinQty >= _vm.productQty},on:{"click":function($event){_vm.productQty -= _vm.productPackSize},"keypress":function($event){_vm.productQty -= _vm.productPackSize}}},[_c('minus-icon')],1),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.productQty),expression:"productQty",modifiers:{"number":true}}],attrs:{"tabindex":"0","type":"number","min":_vm.productMinQty,"disabled":_vm.readonly || _vm.productPackSize > 1,"step":_vm.productPackSize},domProps:{"value":(_vm.productQty)},on:{"blur":[_vm.onBlur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.productQty=_vm._n($event.target.value)}}}),_c('button',{attrs:{"tabindex":"0","id":"increment","disabled":_vm.readonly},on:{"click":function($event){_vm.productQty += _vm.productPackSize},"keypress":function($event){_vm.productQty += _vm.productPackSize}}},[_c('plus-icon')],1)]),_c('div',{staticClass:"price-wrapper"},[(_vm.productHasDiscount)?_c('span',{staticClass:"price-info price-info--active"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.product.rowTotalWithDiscount))+" ")]):_vm._e(),_c('span',{staticClass:"price-info",class:{
            'price-info--active': !_vm.productHasDiscount,
            'price-info--disabled': _vm.productHasDiscount,
          }},[(!_vm.productIsPrepurchased)?[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.product.rowTotal))+" ")]:[_vm._v(" N/A from inventory ")]],2)])]),(_vm.productPackSize > 1)?_c('div',{staticClass:"the-cart-panel-item__pack-size-info"},[_vm._v(" This item is available for purchase in bundles of "+_vm._s(_vm.productPackSize)+" units. ")]):_vm._e(),(_vm.showMinQtyWarning)?_c('div',{staticClass:"the-cart-panel-item__min-qty-warning"},[_vm._v(" Min qty. for this item is "+_vm._s(_vm.productMinQty)+" ")]):_vm._e()])])}
var TheCartPanelItemvue_type_template_id_c98208f0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/priceFilter.ts
var priceFilter_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let PriceFilter = class PriceFilter extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
PriceFilter = priceFilter_decorate([vue_class_component_esm({
  filters: {
    priceFilter: (num, options = {
      style: 'currency',
      currency: 'USD'
    }) => new Intl.NumberFormat('en-US', options).format(num)
  }
})], PriceFilter);
/* harmony default export */ var priceFilter = (PriceFilter);
;// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject_isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject_isObject);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/* harmony default export */ var _freeGlobal = (freeGlobal);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js

/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
/* harmony default export */ var _root = (root);
;// CONCATENATED MODULE: ./node_modules/lodash-es/now.js

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function () {
  return _root.Date.now();
};

/* harmony default export */ var lodash_es_now = (now);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

/* harmony default export */ var _trimmedEndIndex = (trimmedEndIndex);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTrim.js

/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/* harmony default export */ var _baseTrim = (baseTrim);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js

/** Built-in value references. */

var _Symbol_Symbol = _root.Symbol;
/* harmony default export */ var _Symbol = (_Symbol_Symbol);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js

/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js



/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);
;// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);
;// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js


/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag;
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);
;// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js



/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (lodash_es_isSymbol(value)) {
    return NAN;
  }

  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/* harmony default export */ var lodash_es_toNumber = (toNumber);
;// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce_debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = lodash_es_toNumber(wait) || 0;

  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = lodash_es_now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce_debounce);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Delete.vue?vue&type=template&id=179709c2&
var Deletevue_type_template_id_179709c2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 16","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M4.94849 5.12001C4.94849 6.74183 4.94849 8.36728 4.94849 9.9891C4.94849 10.2218 4.94849\n      10.4546 4.94849 10.6909C4.94849 10.9746 5.1876 11.2509 5.46829 11.2364C5.74898 11.2218\n      5.98809 10.9964 5.98809 10.6909C5.98809 9.0691 5.98809 7.44365 5.98809 5.82183C5.98809\n      5.5891 5.98809 5.35637 5.98809 5.12001C5.98809 4.83637 5.74898 4.56001 5.46829\n      4.57456C5.1876 4.5891 4.94849 4.81456 4.94849 5.12001Z\n    ","fill":"#9B9B9B"}}),_c('path',{attrs:{"d":"M8.01184 5.12001C8.01184 6.74183 8.01184 8.36728 8.01184 9.9891C8.01184 10.2218 8.01184\n      10.4546 8.01184 10.6909C8.01184 10.9746 8.25095 11.2509 8.53164 11.2364C8.81234 11.2218\n      9.05145 10.9964 9.05145 10.6909C9.05145 9.0691 9.05145 7.44365 9.05145 5.82183C9.05145\n      5.5891 9.05145 5.35637 9.05145 5.12001C9.05145 4.83637 8.81234 4.56001 8.53164\n      4.57456C8.25095 4.5891 8.01184 4.81456 8.01184 5.12001Z\n    ","fill":"#9B9B9B"}}),_c('path',{attrs:{"d":"M4.42523 0.483637C4.87572 -0.0581813 5.54107 0.0109097 6.15444 0.0109097H8.12968C8.29602\n      0.0109097 8.46236 0.0072733 8.62869 0.0109097C9.18661 0.0218188 9.68563 0.356364 9.90048\n      0.901819C10.0322 1.22909 10.0079 1.57818 10.0079 1.92727L10.0078 2.18506L13.4663\n      2.18546C13.7251 2.18546 13.9236 2.3837 13.9742 2.63463L13.9861 2.73091C14 3.02545 13.7366\n      3.27636 13.4663 3.27636H13.4455C13.1066 3.28814 12.7663 3.28466 12.4264 3.28075L12.4267\n      13.3964C12.4267 13.5273 12.4302 13.6618 12.4267 13.7927C12.4094 14.7891 11.6435 15.5782\n      10.6975 15.5965C10.6736 15.5971 10.6592 15.5717 10.652 15.5282L10.6468 15.4621L10.6372\n      15.527C10.6337 15.5488 10.6308 15.5662 10.6287 15.5781L10.6247 15.5965H3.37523C2.93513\n      15.5965 2.53315 15.4691 2.19008 15.1782C1.7881 14.8364 1.57325 14.3091 1.56978\n      13.7673L1.56878 3.27606L0.537111 3.27636C0.275285 3.27636 0.0764336 3.07811 0.0281754\n      2.82719L0.0173088 2.73091C0.00344739 2.43636 0.266814 2.18546 0.537111\n      2.18546H0.557903C1.08117 2.16727 1.6079 2.18546 2.13117 2.18546L4.06778 2.18506L4.0683\n      1.79273C4.0683 1.73636 4.06743 1.67909 4.067 1.62182L4.0683 1.45091C4.07869 1.08727 4.19652\n      0.756364 4.42523 0.483637ZM11.3828 3.30906H2.61178L2.609 3.67273L2.60592 4.09818L2.60664\n      13.8137C2.60838 13.8438 2.61254 13.8961 2.61072 13.897L2.61978 13.9455L2.65578\n      14.0681L2.66483 14.0836C2.6735 14.1 2.68303 14.1173 2.69256 14.1345L2.72028 14.1855C2.72952\n      14.2 2.76032 14.2404 2.76032 14.242L2.80648 14.295L2.87078 14.3561C2.88488 14.3662 2.90067\n      14.378 2.91415 14.3878L2.93167 14.4C2.95939 14.4182 2.98365 14.4327 3.01137 14.4473L3.02378\n      14.4551L3.03563 14.4582C3.05469 14.4636 3.07288 14.4691 3.09107 14.4745L3.14652\n      14.4909C3.17424 14.4982 3.20543 14.5055 3.23662 14.5091L3.20078 14.5031C3.19588 14.4985\n      3.24963 14.5029 3.27735 14.5047L3.29206 14.5055C3.71137 14.5127 4.13068 14.5152 4.54998\n      14.5152L7.06582 14.5055H10.7079C10.7349 14.5055 10.7379 14.6087 10.729 14.7518L10.7208\n      14.8581L10.7417 14.7527C10.764 14.6451 10.7842 14.5599 10.7946 14.524L10.8015\n      14.5055C10.8465 14.4945 10.8916 14.48 10.9366 14.4691C10.9477 14.4647 10.9567 14.4612\n      10.9636 14.4586L10.9698 14.4561L10.9799 14.4509L11.0198 14.4291C11.0579 14.4036 11.096\n      14.3782 11.1341 14.3527L11.1068 14.3701C11.1116 14.3619 11.1605 14.3198 11.1862\n      14.2966L11.2 14.2836C11.2099 14.2732 11.2569 14.2091 11.259 14.209L11.2736 14.1873L11.3074\n      14.1273C11.3119 14.1195 11.324 14.0896 11.3333 14.067L11.3408 14.0471L11.3572\n      13.9909L11.3802 13.8982L11.3848 13.8791L11.3836 13.8473L11.3828 3.30906ZM8.51087\n      1.10182L5.41678 1.10106C5.40199 1.10383 5.39314 1.10508 5.38546 1.10621L5.3678\n      1.10909C5.34701 1.11636 5.32275 1.12364 5.30196 1.13091C5.35345 1.11429 5.33025 1.12616\n      5.29509 1.14346L5.24378 1.16806C5.22926 1.1843 5.20507 1.20615 5.18789 1.22247L5.17378\n      1.23506L5.18414 1.21818C5.18137 1.224 5.14976 1.26007 5.15852 1.25193L5.17278\n      1.23606L5.15988 1.25818L5.13563 1.29818L5.12078 1.31706L5.1183 1.34546C5.1183 1.34727\n      5.1131 1.38182 5.10834 1.40773L5.10378 1.42706L5.10422 1.41609C5.10388 1.39636 5.10305\n      1.38109 5.10097 1.41818L5.10105 1.43578L5.10378 1.42906V2.18506H8.96778L8.9683\n      1.45091L8.97078 1.41606L8.97496 1.42768C8.98388 1.44667 8.97611 1.38808 8.97117\n      1.41354L8.97078 1.41406L8.96483 1.39636C8.9631 1.39091 8.9527 1.35636 8.94577\n      1.33136L8.93978 1.31006C8.94357 1.31703 8.94601 1.32294 8.94826 1.32835L8.95178\n      1.33706L8.94751 1.32364L8.94013 1.30554L8.93978 1.30906C8.93365 1.29455 8.91545 1.26455\n      8.90289 1.24318L8.89378 1.22606L8.90078 1.23506L8.89131 1.22126L8.89292 1.22601L8.88513\n      1.21818C8.87993 1.21455 8.85481 1.19182 8.83748 1.175L8.82278 1.16106C8.80543 1.15273\n      8.7959 1.14727 8.78637 1.14136L8.75878 1.12406C8.7485 1.12208 8.74157 1.12052 8.7336\n      1.11899L8.68107 1.11047C8.64793 1.10538 8.62869 1.10182 8.68414 1.10182H8.63216C8.59404\n      1.10546 8.55246 1.10182 8.51087 1.10182Z\n    ","fill":"#9B9B9B"}})])}
var Deletevue_type_template_id_179709c2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Delete.vue?vue&type=script&lang=ts&


var Deletevue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Delete = class Delete extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Deletevue_type_script_lang_ts_decorate([Prop({
  default: 14
})], Delete.prototype, "width", void 0);

Deletevue_type_script_lang_ts_decorate([Prop({
  default: 16
})], Delete.prototype, "height", void 0);

Delete = Deletevue_type_script_lang_ts_decorate([vue_class_component_esm], Delete);
/* harmony default export */ var Deletevue_type_script_lang_ts_ = (Delete);
;// CONCATENATED MODULE: ./src/components/icons/Delete.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Deletevue_type_script_lang_ts_ = (Deletevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Delete.vue





/* normalize component */
;
var Delete_component = componentNormalizer_normalizeComponent(
  icons_Deletevue_type_script_lang_ts_,
  Deletevue_type_template_id_179709c2_render,
  Deletevue_type_template_id_179709c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Delete = (Delete_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Minus.vue?vue&type=template&id=39d06612&
var Minusvue_type_template_id_39d06612_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 2","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M7.10938 0.505188H0.078125C0.0351562 0.505188 0 0.552063 0 0.609355V1.3906C0 1.4479\n      0.0351562 1.49477 0.078125 1.49477H7.10938C7.15234 1.49477 7.1875 1.4479 7.1875\n      1.3906V0.609355C7.1875 0.552063 7.15234 0.505188 7.10938 0.505188Z\n    ","fill":"currentColor"}})])}
var Minusvue_type_template_id_39d06612_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Minus.vue?vue&type=script&lang=ts&


var Minusvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Minus = class Minus extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Minusvue_type_script_lang_ts_decorate([Prop({
  default: 8
})], Minus.prototype, "width", void 0);

Minusvue_type_script_lang_ts_decorate([Prop({
  default: 2
})], Minus.prototype, "height", void 0);

Minus = Minusvue_type_script_lang_ts_decorate([vue_class_component_esm], Minus);
/* harmony default export */ var Minusvue_type_script_lang_ts_ = (Minus);
;// CONCATENATED MODULE: ./src/components/icons/Minus.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Minusvue_type_script_lang_ts_ = (Minusvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Minus.vue





/* normalize component */
;
var Minus_component = componentNormalizer_normalizeComponent(
  icons_Minusvue_type_script_lang_ts_,
  Minusvue_type_template_id_39d06612_render,
  Minusvue_type_template_id_39d06612_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Minus = (Minus_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Plus.vue?vue&type=template&id=d966b10e&
var Plusvue_type_template_id_d966b10e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 8","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M7.29688 3.50519H0.265625C0.222656 3.50519 0.1875 3.55206 0.1875 3.60935V4.3906C0.1875\n      4.4479 0.222656 4.49477 0.265625 4.49477H7.29688C7.33984 4.49477 7.375 4.4479 7.375\n      4.3906V3.60935C7.375 3.55206 7.33984 3.50519 7.29688 3.50519Z\n    ","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.28644 0.484375L3.28644 7.51562C3.28644 7.55859 3.33331 7.59375 3.3906\n      7.59375H4.17185C4.22915 7.59375 4.27602 7.55859 4.27602 7.51562V0.484375C4.27602 0.441406\n      4.22915 0.40625 4.17185 0.40625H3.3906C3.33331 0.40625 3.28644 0.441406 3.28644 0.484375Z\n    ","fill":"currentColor"}})])}
var Plusvue_type_template_id_d966b10e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Plus.vue?vue&type=script&lang=ts&


var Plusvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Plus = class Plus extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Plusvue_type_script_lang_ts_decorate([Prop({
  default: 8
})], Plus.prototype, "width", void 0);

Plusvue_type_script_lang_ts_decorate([Prop({
  default: 8
})], Plus.prototype, "height", void 0);

Plus = Plusvue_type_script_lang_ts_decorate([vue_class_component_esm], Plus);
/* harmony default export */ var Plusvue_type_script_lang_ts_ = (Plus);
;// CONCATENATED MODULE: ./src/components/icons/Plus.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Plusvue_type_script_lang_ts_ = (Plusvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Plus.vue





/* normalize component */
;
var Plus_component = componentNormalizer_normalizeComponent(
  icons_Plusvue_type_script_lang_ts_,
  Plusvue_type_template_id_d966b10e_render,
  Plusvue_type_template_id_d966b10e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Plus = (Plus_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelItem.vue?vue&type=script&lang=ts&


var TheCartPanelItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TheCartPanelItem = class TheCartPanelItem extends mixins(priceFilter) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "product", void 0);

    _defineProperty(this, "showCustomization", void 0);

    _defineProperty(this, "readonly", void 0);

    _defineProperty(this, "productQty", 0);

    _defineProperty(this, "showMinQtyWarning", false);

    _defineProperty(this, "warningTimeoutId", undefined);

    _defineProperty(this, "debounceUpdateProductQty", void 0);
  }

  get productHasPersonalization() {
    return !!this.product?.personalizations?.length || false;
  }

  get productHasConfigurations() {
    return !!this.product?.configurations?.length || false;
  }

  get productHasQuoteOptions() {
    return !!this.product?.myQuoteOptions?.length || false;
  }

  get productImage() {
    return this.product.image || 'https://account.corporategift.com/images/empty-order.png';
  }

  get productMinQty() {
    const {
      qtyIncrements,
      enableQtyIncrements,
      minQty
    } = this.product;
    return (enableQtyIncrements ? qtyIncrements : minQty) || 1;
  }

  get productHasDiscount() {
    return !!+this.product.discount ?? false;
  }

  get productIsPrepurchased() {
    return this.product?.isPrepurchased ?? false;
  }

  get productPackSize() {
    const {
      qtyIncrements,
      enableQtyIncrements
    } = this.product;
    return enableQtyIncrements ? qtyIncrements || 1 : 1;
  }

  onProductQtyChanged(val) {
    this.debounceUpdateProductQty(val);
  }

  created() {
    const {
      qty
    } = this.product;
    this.productQty = Number(qty) || 0;
    this.debounceUpdateProductQty = lodash_es_debounce(this.updateProductQty, 300);
  }

  updateProductQty(val) {
    const {
      qty,
      id,
      parentItemId
    } = this.product;
    if (qty !== val) this.$emit('updateProductQty', val, parentItemId || id);
  }

  onBlur() {
    const {
      productQty,
      productMinQty,
      product
    } = this;

    if (productQty < productMinQty) {
      clearTimeout(this.warningTimeoutId);
      this.showMinQtyWarning = true;
      this.productQty = Number(product.qty) || 0;
      this.warningTimeoutId = undefined;
      this.warningTimeoutId = setTimeout(() => {
        this.showMinQtyWarning = false;
      }, 3000);
    }
  }

};

TheCartPanelItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheCartPanelItem.prototype, "product", void 0);

TheCartPanelItemvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: false,
  type: Boolean
})], TheCartPanelItem.prototype, "showCustomization", void 0);

TheCartPanelItemvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: false,
  type: Boolean
})], TheCartPanelItem.prototype, "readonly", void 0);

TheCartPanelItemvue_type_script_lang_ts_decorate([Watch('productQty')], TheCartPanelItem.prototype, "onProductQtyChanged", null);

TheCartPanelItem = TheCartPanelItemvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    DeleteIcon: icons_Delete,
    MinusIcon: icons_Minus,
    PlusIcon: icons_Plus
  }
})], TheCartPanelItem);
/* harmony default export */ var TheCartPanelItemvue_type_script_lang_ts_ = (TheCartPanelItem);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelItemvue_type_script_lang_ts_ = (TheCartPanelItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelItem.vue?vue&type=style&index=0&id=c98208f0&lang=scss&scoped=true&
var TheCartPanelItemvue_type_style_index_0_id_c98208f0_lang_scss_scoped_true_ = __webpack_require__(3227);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelItem.vue?vue&type=style&index=0&id=c98208f0&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelItem.vue



;


/* normalize component */

var TheCartPanelItem_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelItemvue_type_script_lang_ts_,
  TheCartPanelItemvue_type_template_id_c98208f0_scoped_true_render,
  TheCartPanelItemvue_type_template_id_c98208f0_scoped_true_staticRenderFns,
  false,
  null,
  "c98208f0",
  null
  
)

/* harmony default export */ var cart_TheCartPanelItem = (TheCartPanelItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelSubtotal.vue?vue&type=template&id=68272c70&scoped=true&
var TheCartPanelSubtotalvue_type_template_id_68272c70_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-subtotal"},[_c('div',{staticClass:"the-cart-panel-subtotal__prices"},[_c('div',{staticClass:"the-cart-panel-subtotal__prices--row"},[_c('span',{staticClass:"price price--normal"},[_c('b',[_vm._v("Subtotal")]),_vm._v(" ("+_vm._s(_vm.cartProductAmount)+" items) ")]),_c('span',{staticClass:"price price--bold"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.cartSubtotal))+" ")])]),_c('div',{staticClass:"the-cart-panel-subtotal__prices--row"},[_vm._m(0),_c('span',{staticClass:"price price--bold"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.cartSetupFee))+" ")])]),(_vm.hasDiscount)?_c('div',{staticClass:"the-cart-panel-subtotal__prices--row"},[_c('span',{staticClass:"price price--normal"},[_c('b',[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#95979d"}},[_vm._v(_vm._s(_vm.cartDiscount.couponCode))])]),_c('span',{staticClass:"price price--bold"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(-Math.abs(_vm.cartDiscount.value)))+" ")])]):_vm._e(),_vm._m(1),_vm._m(2)])])}
var TheCartPanelSubtotalvue_type_template_id_68272c70_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"price price--normal"},[_c('b',[_vm._v("Customization setup fee")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-subtotal__prices--row"},[_c('span',{staticClass:"price price--bold"},[_vm._v("Taxes")]),_c('span',{staticClass:"price price--normal"},[_vm._v(" Calculated at checkout ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-subtotal__prices--row"},[_c('span',{staticClass:"price price--bold"},[_vm._v("Shipping")]),_c('span',{staticClass:"price price--normal"},[_vm._v(" Calculated at checkout ")])])}]


;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelSubtotal.vue?vue&type=template&id=68272c70&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelSubtotal.vue?vue&type=script&lang=ts&


var TheCartPanelSubtotalvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheCartPanelSubtotal = class TheCartPanelSubtotal extends mixins(priceFilter) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "cartProductAmount", void 0);

    _defineProperty(this, "cartSubtotal", void 0);

    _defineProperty(this, "cartSetupFee", void 0);

    _defineProperty(this, "cartDiscount", void 0);
  }

  get hasDiscount() {
    return !!this.cartDiscount;
  }

};

TheCartPanelSubtotalvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Number
})], TheCartPanelSubtotal.prototype, "cartProductAmount", void 0);

TheCartPanelSubtotalvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Number,
  default: 0
})], TheCartPanelSubtotal.prototype, "cartSubtotal", void 0);

TheCartPanelSubtotalvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: [Number, String],
  default: 0
})], TheCartPanelSubtotal.prototype, "cartSetupFee", void 0);

TheCartPanelSubtotalvue_type_script_lang_ts_decorate([Prop({
  required: false,
  type: Object,
  default: null
})], TheCartPanelSubtotal.prototype, "cartDiscount", void 0);

TheCartPanelSubtotal = TheCartPanelSubtotalvue_type_script_lang_ts_decorate([vue_class_component_esm], TheCartPanelSubtotal);
/* harmony default export */ var TheCartPanelSubtotalvue_type_script_lang_ts_ = (TheCartPanelSubtotal);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelSubtotal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelSubtotalvue_type_script_lang_ts_ = (TheCartPanelSubtotalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelSubtotal.vue?vue&type=style&index=0&id=68272c70&lang=scss&scoped=true&
var TheCartPanelSubtotalvue_type_style_index_0_id_68272c70_lang_scss_scoped_true_ = __webpack_require__(6186);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelSubtotal.vue?vue&type=style&index=0&id=68272c70&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelSubtotal.vue



;


/* normalize component */

var TheCartPanelSubtotal_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelSubtotalvue_type_script_lang_ts_,
  TheCartPanelSubtotalvue_type_template_id_68272c70_scoped_true_render,
  TheCartPanelSubtotalvue_type_template_id_68272c70_scoped_true_staticRenderFns,
  false,
  null,
  "68272c70",
  null
  
)

/* harmony default export */ var cart_TheCartPanelSubtotal = (TheCartPanelSubtotal_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelActions.vue?vue&type=template&id=6a177ce2&scoped=true&
var TheCartPanelActionsvue_type_template_id_6a177ce2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-actions",class:{ 'the-cart-panel-actions--elevation': _vm.showBoxShadow }},[_c('div',{staticClass:"the-cart-panel-actions__est-cost"},[_c('span',{staticClass:"price price--bold"},[_vm._v("Estimated total")]),_c('span',{staticClass:"price price--bold the-cart-panel-actions__est-cost--total"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.cartTotal))+" ")])]),_c('div',{staticClass:"the-cart-panel-actions__buttons"},[_c('button',{staticClass:"outlined",attrs:{"type":"button","id":"view-cart"},on:{"click":function($event){return _vm.moveUserToCheckout()}}},[_vm._v(" View my cart ")]),_c('button',{attrs:{"type":"button","id":"checkout"},on:{"click":function($event){return _vm.moveUserToCheckout()}}},[_c('lock-icon'),_vm._v(" Checkout ")],1)])])}
var TheCartPanelActionsvue_type_template_id_6a177ce2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Lock.vue?vue&type=template&id=6b6d8a49&
var Lockvue_type_template_id_6b6d8a49_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 20","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.72","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.5 11.6875V13.7031M1.10938 8.32812V18.4062H15.8906V8.32812H1.10938ZM3.79688\n      8.32812C3.79688 4.29688 3.79688 1.60938 8.5 1.60938C13.2031 1.60938 13.2031 4.29688 13.2031\n      8.32812H3.79688Z\n    "}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.72","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.5 15.0469C8.87107 15.0469 9.17188 14.7461 9.17188 14.375C9.17188 14.0039 8.87107\n      13.7031 8.5 13.7031C8.12893 13.7031 7.82812 14.0039 7.82812 14.375C7.82812 14.7461 8.12893\n      15.0469 8.5 15.0469Z\n    "}})])}
var Lockvue_type_template_id_6b6d8a49_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Lock.vue?vue&type=script&lang=ts&


var Lockvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Lock = class Lock extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Lockvue_type_script_lang_ts_decorate([Prop({
  default: 17
})], Lock.prototype, "width", void 0);

Lockvue_type_script_lang_ts_decorate([Prop({
  default: 20
})], Lock.prototype, "height", void 0);

Lock = Lockvue_type_script_lang_ts_decorate([vue_class_component_esm], Lock);
/* harmony default export */ var Lockvue_type_script_lang_ts_ = (Lock);
;// CONCATENATED MODULE: ./src/components/icons/Lock.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Lockvue_type_script_lang_ts_ = (Lockvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Lock.vue





/* normalize component */
;
var Lock_component = componentNormalizer_normalizeComponent(
  icons_Lockvue_type_script_lang_ts_,
  Lockvue_type_template_id_6b6d8a49_render,
  Lockvue_type_template_id_6b6d8a49_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Lock = (Lock_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelActions.vue?vue&type=script&lang=ts&


var TheCartPanelActionsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TheCartPanelActions = class TheCartPanelActions extends mixins(priceFilter) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "cartTotal", void 0);

    _defineProperty(this, "showBoxShadow", void 0);
  }

  moveUserToCheckout() {
    const {
      magentoUrl
    } = takeGlobalOptions();
    window.location.href = `${magentoUrl}/cart/`;
  }

};

TheCartPanelActionsvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Number
})], TheCartPanelActions.prototype, "cartTotal", void 0);

TheCartPanelActionsvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: false,
  type: Boolean
})], TheCartPanelActions.prototype, "showBoxShadow", void 0);

TheCartPanelActions = TheCartPanelActionsvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    LockIcon: icons_Lock
  }
})], TheCartPanelActions);
/* harmony default export */ var TheCartPanelActionsvue_type_script_lang_ts_ = (TheCartPanelActions);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelActions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelActionsvue_type_script_lang_ts_ = (TheCartPanelActionsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelActions.vue?vue&type=style&index=0&id=6a177ce2&lang=scss&scoped=true&
var TheCartPanelActionsvue_type_style_index_0_id_6a177ce2_lang_scss_scoped_true_ = __webpack_require__(2387);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelActions.vue?vue&type=style&index=0&id=6a177ce2&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelActions.vue



;


/* normalize component */

var TheCartPanelActions_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelActionsvue_type_script_lang_ts_,
  TheCartPanelActionsvue_type_template_id_6a177ce2_scoped_true_render,
  TheCartPanelActionsvue_type_template_id_6a177ce2_scoped_true_staticRenderFns,
  false,
  null,
  "6a177ce2",
  null
  
)

/* harmony default export */ var cart_TheCartPanelActions = (TheCartPanelActions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomization.vue?vue&type=template&id=050440f3&scoped=true&
var TheCartPanelCustomizationvue_type_template_id_050440f3_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-customization"},[_c('div',{staticClass:"the-cart-panel-customization__actions"},[(_vm.product.redirectUrl)?_c('a',{attrs:{"href":_vm.product.redirectUrl}},[_vm._v(" Edit customization ")]):_vm._e(),_c('a',{staticStyle:{"margin-left":"auto"},on:{"click":function($event){return _vm.$emit('hideCustomizationInfo')},"keypress":function($event){return _vm.$emit('hideCustomizationInfo')}}},[_vm._v(" Close ")])]),_c('div',{staticClass:"the-cart-panel-customization__title"},[_c('b',[_vm._v("Customization")]),_vm._v(" "+_vm._s(_vm.product.name)+" ")]),_c('div',{staticClass:"the-cart-panel-customization__content"},_vm._l((_vm.product.personalizations),function(personalization,index){return _c('the-cart-panel-customization-item',{key:index,attrs:{"personalization":personalization}})}),1)])}
var TheCartPanelCustomizationvue_type_template_id_050440f3_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomizationItem.vue?vue&type=template&id=c6fdacee&scoped=true&
var TheCartPanelCustomizationItemvue_type_template_id_c6fdacee_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-cart-panel-customization-item"},[(_vm.images.length)?_c('div',{staticClass:"the-cart-panel-customization-item__images"},_vm._l((_vm.images),function(image){return _c('embed',{key:image,attrs:{"src":image,"alt":_vm.name}})}),0):_vm._e(),_c('div',{staticClass:"the-cart-panel-customization-item__info"},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('div',{staticClass:"the-cart-panel-customization-item__info--subtext"},[_vm._v(" "+_vm._s(_vm.namesOfSelectedOptions)+" ")]),_c('div',{staticClass:"the-cart-panel-customization-item__info--subtext"},[_vm._v("QTY: "+_vm._s(_vm.qty))])]),(+_vm.price > 0)?_c('div',{staticClass:"the-cart-panel-customization-item__price"},[_vm._v(" "+_vm._s(_vm._f("priceFilter")(_vm.price))+" ")]):_vm._e()])}
var TheCartPanelCustomizationItemvue_type_template_id_c6fdacee_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomizationItem.vue?vue&type=script&lang=ts&


var TheCartPanelCustomizationItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheCartPanelCustomizationItem = class TheCartPanelCustomizationItem extends mixins(priceFilter) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "personalization", void 0);
  }

  get images() {
    const value = this.personalization?.value;
    const result = Array.isArray(value) ? value?.map(item => item?.image) : [];
    return result?.filter(item => item) ?? [];
  }

  get name() {
    return this.personalization?.title ?? null;
  }

  get namesOfSelectedOptions() {
    const value = this.personalization?.value;
    const result = Array.isArray(value) ? value?.map(item => item.title) : [];
    return result?.filter(item => item).join(', ') ?? '';
  }

  get qty() {
    return  null ?? '-';
  }

  get price() {
    return this.personalization?.price ?? null;
  }

};

TheCartPanelCustomizationItemvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: null
})], TheCartPanelCustomizationItem.prototype, "personalization", void 0);

TheCartPanelCustomizationItem = TheCartPanelCustomizationItemvue_type_script_lang_ts_decorate([vue_class_component_esm], TheCartPanelCustomizationItem);
/* harmony default export */ var TheCartPanelCustomizationItemvue_type_script_lang_ts_ = (TheCartPanelCustomizationItem);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomizationItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelCustomizationItemvue_type_script_lang_ts_ = (TheCartPanelCustomizationItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomizationItem.vue?vue&type=style&index=0&id=c6fdacee&lang=scss&scoped=true&
var TheCartPanelCustomizationItemvue_type_style_index_0_id_c6fdacee_lang_scss_scoped_true_ = __webpack_require__(5888);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomizationItem.vue?vue&type=style&index=0&id=c6fdacee&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomizationItem.vue



;


/* normalize component */

var TheCartPanelCustomizationItem_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelCustomizationItemvue_type_script_lang_ts_,
  TheCartPanelCustomizationItemvue_type_template_id_c6fdacee_scoped_true_render,
  TheCartPanelCustomizationItemvue_type_template_id_c6fdacee_scoped_true_staticRenderFns,
  false,
  null,
  "c6fdacee",
  null
  
)

/* harmony default export */ var cart_TheCartPanelCustomizationItem = (TheCartPanelCustomizationItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomization.vue?vue&type=script&lang=ts&


var TheCartPanelCustomizationvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheCartPanelCustomization = class TheCartPanelCustomization extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "product", void 0);
  }

};

TheCartPanelCustomizationvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: null
})], TheCartPanelCustomization.prototype, "product", void 0);

TheCartPanelCustomization = TheCartPanelCustomizationvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheCartPanelCustomizationItem: cart_TheCartPanelCustomizationItem
  }
})], TheCartPanelCustomization);
/* harmony default export */ var TheCartPanelCustomizationvue_type_script_lang_ts_ = (TheCartPanelCustomization);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomization.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelCustomizationvue_type_script_lang_ts_ = (TheCartPanelCustomizationvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanelCustomization.vue?vue&type=style&index=0&id=050440f3&lang=scss&scoped=true&
var TheCartPanelCustomizationvue_type_style_index_0_id_050440f3_lang_scss_scoped_true_ = __webpack_require__(3448);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomization.vue?vue&type=style&index=0&id=050440f3&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanelCustomization.vue



;


/* normalize component */

var TheCartPanelCustomization_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelCustomizationvue_type_script_lang_ts_,
  TheCartPanelCustomizationvue_type_template_id_050440f3_scoped_true_render,
  TheCartPanelCustomizationvue_type_template_id_050440f3_scoped_true_staticRenderFns,
  false,
  null,
  "050440f3",
  null
  
)

/* harmony default export */ var cart_TheCartPanelCustomization = (TheCartPanelCustomization_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogLeftTransition.vue?vue&type=template&id=1600fbde&scoped=true&
var DialogLeftTransitionvue_type_template_id_1600fbde_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog-left"}},[_vm._t("default")],2)}
var DialogLeftTransitionvue_type_template_id_1600fbde_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogLeftTransition.vue?vue&type=script&lang=ts&
var DialogLeftTransitionvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let DialogLeftTransition = class DialogLeftTransition extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
DialogLeftTransition = DialogLeftTransitionvue_type_script_lang_ts_decorate([vue_class_component_esm], DialogLeftTransition);
/* harmony default export */ var DialogLeftTransitionvue_type_script_lang_ts_ = (DialogLeftTransition);
;// CONCATENATED MODULE: ./src/components/transitions/DialogLeftTransition.vue?vue&type=script&lang=ts&
 /* harmony default export */ var transitions_DialogLeftTransitionvue_type_script_lang_ts_ = (DialogLeftTransitionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogLeftTransition.vue?vue&type=style&index=0&id=1600fbde&lang=scss&scoped=true&
var DialogLeftTransitionvue_type_style_index_0_id_1600fbde_lang_scss_scoped_true_ = __webpack_require__(637);
;// CONCATENATED MODULE: ./src/components/transitions/DialogLeftTransition.vue?vue&type=style&index=0&id=1600fbde&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/transitions/DialogLeftTransition.vue



;


/* normalize component */

var DialogLeftTransition_component = componentNormalizer_normalizeComponent(
  transitions_DialogLeftTransitionvue_type_script_lang_ts_,
  DialogLeftTransitionvue_type_template_id_1600fbde_scoped_true_render,
  DialogLeftTransitionvue_type_template_id_1600fbde_scoped_true_staticRenderFns,
  false,
  null,
  "1600fbde",
  null
  
)

/* harmony default export */ var transitions_DialogLeftTransition = (DialogLeftTransition_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanel.vue?vue&type=script&lang=ts&


var TheCartPanelvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};













let TheCartPanel = class TheCartPanel extends mixins(userIsLoggedIn) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "value", void 0);

    _defineProperty(this, "cartProducts", []);

    _defineProperty(this, "discount", null);

    _defineProperty(this, "Api", void 0);

    _defineProperty(this, "showBottomShadow", false);

    _defineProperty(this, "showExpandedPanel", false);

    _defineProperty(this, "loading", false);

    _defineProperty(this, "isCartReadonly", false);

    _defineProperty(this, "selectedProduct", null);

    _defineProperty(this, "cartSubtotal", 0);

    _defineProperty(this, "cartTotal", 0);

    _defineProperty(this, "cartSetupFee", 0);
  }

  get show() {
    return this.value;
  }

  set show(val) {
    this.$emit('input', val);
  }

  get userCartAmount() {
    return this.cartProducts.reduce((acc, item) => acc + Number(item?.qty || 0), 0);
  }

  get userCartSubtotal() {
    return Number(this.cartSubtotal);
  }

  onChildChanged(val) {
    const content = this.getScrollAreaElement();
    this.showExpandedPanel = false;

    if (val) {
      this.cartProducts = [];
      this.fetchCartInfo();
      content?.addEventListener('scroll', this.scrollHandler);
    } else {
      content?.removeEventListener('scroll', this.scrollHandler);
    }
  }

  onCartAmountChanged(val) {
    this.$store.commit('header/setCartAmount', val);
  }

  created() {
    const {
      apiUrl
    } = takeGlobalOptions();
    const api = lib_axios.create({
      baseURL: apiUrl,
      headers: {
        Accept: 'application/json'
      }
    });
    api.interceptors.request.use(config => {
      if (config.headers) {
        config.headers.Authorization = `Bearer ${this.$store.state.headerAuth.token}`;
      }

      return config;
    });
    this.Api = api;
  }

  scrollHandler() {
    const content = this.getScrollAreaElement();
    const scrollHegiht = (content?.scrollHeight || 0) - (content?.offsetHeight || 0);
    const scrollPosition = content?.scrollTop || 0;
    this.showBottomShadow = scrollHegiht !== scrollPosition;
  }

  getScrollAreaElement() {
    return this.$el.querySelector('.the-cart-panel__products');
  }

  fetchCartInfo() {
    this.loading = true;
    this.Api?.get('/api/cart', {
      params: {
        cartToken: this.userIsLoggedIn ? undefined : localStorage.getItem('cartToken')
      }
    }).then(({
      data
    }) => {
      if (data) {
        const camelizedData = camelize(data);
        const items = camelizedData.items || []; // @ts-ignore

        this.cartSetupFee = camelizedData.personalizationSetupFee ?? 0;
        this.cartSubtotal = data.subtotal;
        this.cartTotal = Number(data.subtotal) + Number(this.cartSetupFee);
        this.isCartReadonly = data.isReadOnly ?? false;
        const {
          discount,
          coupon_code
        } = data;
        this.discount = coupon_code ? {
          couponCode: coupon_code,
          value: Number(discount)
        } : null;
        this.cartProducts = items.map(item => item?.groupItems?.length ? item.groupItems : item).flat() || [];
      }
    }).finally(() => {
      this.loading = false;
      this.scrollHandler();
    });
  }

  showProductCustomization(product) {
    this.selectedProduct = product;
    this.showExpandedPanel = true;
  }

  updateProductQty(val, id) {
    this.Api?.patch(`/api/cart/item/${id}/qty`, {
      qty: val,
      cartToken: this.userIsLoggedIn ? undefined : localStorage.getItem('cartToken')
    }).then(() => {
      const index = this.cartProducts.findIndex(item => item.id === id || item.parentItemId === id);
      this.cartProducts[index].qty = val; // calculate product total price and discount

      const {
        price
      } = this.cartProducts[index];
      this.cartProducts[index].rowTotal = Number(Number(price) * val);
      this.$emit('productQtyUpdate', {
        productId: id,
        qty: val
      });
      this.fetchCartInfo();
    });
  }

  removeProduct(id) {
    this.cartProducts = this.cartProducts.filter(item => item.id !== id);
    this.Api?.delete(`/api/cart/item/${id}`, {
      data: {
        cartToken: this.userIsLoggedIn ? undefined : localStorage.getItem('cartToken')
      }
    }).then(() => {
      this.$emit('productRemoved', {
        productId: id
      });
    });
  }

};

TheCartPanelvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Boolean
})], TheCartPanel.prototype, "value", void 0);

TheCartPanelvue_type_script_lang_ts_decorate([Watch('show')], TheCartPanel.prototype, "onChildChanged", null);

TheCartPanelvue_type_script_lang_ts_decorate([Watch('userCartAmount')], TheCartPanel.prototype, "onCartAmountChanged", null);

TheCartPanel = TheCartPanelvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CloseIcon: icons_Close,
    EmptyCartIcon: icons_EmptyCart,
    TheCartPanelItem: cart_TheCartPanelItem,
    TheCartPanelActions: cart_TheCartPanelActions,
    TheCartPanelSubtotal: cart_TheCartPanelSubtotal,
    DialogLeftTransition: transitions_DialogLeftTransition,
    TheCartPanelCustomization: cart_TheCartPanelCustomization
  }
})], TheCartPanel);
/* harmony default export */ var TheCartPanelvue_type_script_lang_ts_ = (TheCartPanel);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var cart_TheCartPanelvue_type_script_lang_ts_ = (TheCartPanelvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/cart/TheCartPanel.vue?vue&type=style&index=0&id=0b9f4ff8&lang=scss&scoped=true&
var TheCartPanelvue_type_style_index_0_id_0b9f4ff8_lang_scss_scoped_true_ = __webpack_require__(6477);
;// CONCATENATED MODULE: ./src/components/cart/TheCartPanel.vue?vue&type=style&index=0&id=0b9f4ff8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/cart/TheCartPanel.vue



;


/* normalize component */

var TheCartPanel_component = componentNormalizer_normalizeComponent(
  cart_TheCartPanelvue_type_script_lang_ts_,
  TheCartPanelvue_type_template_id_0b9f4ff8_scoped_true_render,
  TheCartPanelvue_type_template_id_0b9f4ff8_scoped_true_staticRenderFns,
  false,
  null,
  "0b9f4ff8",
  null
  
)

/* harmony default export */ var cart_TheCartPanel = (TheCartPanel_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderInfo.vue?vue&type=template&id=489e83c8&scoped=true&
var TheHeaderInfovue_type_template_id_489e83c8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-info"},[_c('div',{staticClass:"the-header-info__message"}),_c('a',{staticClass:"the-header-info__cta-button",attrs:{"href":"https://corporategift.com/request-demo/","target":"_blank","rel":"noopener noreferrer"},on:{"click":_vm.onTalkToSalesClick}},[_vm._v(" Talk to sales ")])])}
var TheHeaderInfovue_type_template_id_489e83c8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/utils/googleTagManager.ts


/* eslint-disable import/prefer-default-export */

/* eslint-disable quote-props */
const tagManager = window?.dataLayer ?? null;

const isTagManagerSet = () => {
  if (!tagManager) {
    throw new Error('Tag manager not detected');
  }

  return !!tagManager;
};

const searchEvent = ({
  searchTerm,
  method,
  eventCallback,
  timeout = 0
}) => {
  if (!isTagManagerSet()) {
    return;
  }

  tagManager?.push({
    'event': 'search',
    'search_term': searchTerm,
    'method': method,
    'eventCallback': eventCallback,
    'eventTimeout': timeout
  });
};

const navigationClick = ({
  item,
  itemCategory = undefined,
  itemSubCategory = undefined
}) => {
  if (!isTagManagerSet()) {
    return;
  }

  tagManager?.push({
    'event': 'navigation_click',
    'item': item,
    'item_category': itemCategory,
    'item_sub_category': itemSubCategory,
    'section': 'header'
  });
};

const searchNavigation = (searchValue, section = 'header') => {
  if (!isTagManagerSet()) {
    return;
  }

  tagManager?.push({
    'event': 'search_navigation',
    'item': searchValue,
    'section': section
  });
};


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderInfo.vue?vue&type=script&lang=ts&
var TheHeaderInfovue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheHeaderInfo = class TheHeaderInfo extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  onTalkToSalesClick() {
    navigationClick({
      item: 'talk to sales'
    });
  }

};
TheHeaderInfo = TheHeaderInfovue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderInfo);
/* harmony default export */ var TheHeaderInfovue_type_script_lang_ts_ = (TheHeaderInfo);
;// CONCATENATED MODULE: ./src/components/TheHeaderInfo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderInfovue_type_script_lang_ts_ = (TheHeaderInfovue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderInfo.vue?vue&type=style&index=0&id=489e83c8&lang=scss&scoped=true&
var TheHeaderInfovue_type_style_index_0_id_489e83c8_lang_scss_scoped_true_ = __webpack_require__(1352);
;// CONCATENATED MODULE: ./src/components/TheHeaderInfo.vue?vue&type=style&index=0&id=489e83c8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderInfo.vue



;


/* normalize component */

var TheHeaderInfo_component = componentNormalizer_normalizeComponent(
  components_TheHeaderInfovue_type_script_lang_ts_,
  TheHeaderInfovue_type_template_id_489e83c8_scoped_true_render,
  TheHeaderInfovue_type_template_id_489e83c8_scoped_true_staticRenderFns,
  false,
  null,
  "489e83c8",
  null
  
)

/* harmony default export */ var components_TheHeaderInfo = (TheHeaderInfo_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderFreeTrailStrip.vue?vue&type=template&id=02fb0f56&scoped=true&
var TheHeaderFreeTrailStripvue_type_template_id_02fb0f56_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-free-trail-alert"},[_c('div',{staticClass:"header-free-trail-alert__content"},[_vm._v(" Free trial ends in "+_vm._s(_vm.freeTrailDays)+" days. "),(_vm.showUpgradeLink)?_c('a',{staticClass:"header-free-trail-alert__link",attrs:{"href":"https://corporategift.com/individual-plan","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Upgrade now ")]):_vm._e()])])}
var TheHeaderFreeTrailStripvue_type_template_id_02fb0f56_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/userRole.ts
var userRole_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserRole = class UserRole extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get accountOwner() {
    return this.$store.state.header?.headerData?.isMasterAccount || false;
  }

  get superAdmin() {
    return this.$store.state.header?.headerData?.isSuperAdmin || false;
  }

  get admin() {
    return this.$store.state.header?.headerData?.isAdmin || false;
  }

  get subAccount() {
    return this.$store.state.header?.headerData?.isSubaccount || false;
  }

  get individual() {
    return this.$store.state.header?.headerData?.companyId === 1;
  }

  get vendor() {
    const companyId = this.$store.state.header?.headerData?.companyId ?? 0;
    return [4, 5].includes(Number(companyId));
  }

};
UserRole = userRole_decorate([vue_class_component_esm], UserRole);
/* harmony default export */ var userRole = (UserRole);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderFreeTrailStrip.vue?vue&type=script&lang=ts&
var TheHeaderFreeTrailStripvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheHeaderFreeTrailStrip = class TheHeaderFreeTrailStrip extends mixins(userRole) {
  get showUpgradeLink() {
    const {
      accountOwner,
      superAdmin
    } = this;
    return accountOwner || superAdmin;
  }

  get freeTrailDays() {
    const freeTrailData = this.$store.state?.header?.headerData?.eliteTrial;
    return freeTrailData?.daysLeft ?? 0;
  }

};
TheHeaderFreeTrailStrip = TheHeaderFreeTrailStripvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderFreeTrailStrip);
/* harmony default export */ var TheHeaderFreeTrailStripvue_type_script_lang_ts_ = (TheHeaderFreeTrailStrip);
;// CONCATENATED MODULE: ./src/components/TheHeaderFreeTrailStrip.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderFreeTrailStripvue_type_script_lang_ts_ = (TheHeaderFreeTrailStripvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderFreeTrailStrip.vue?vue&type=style&index=0&id=02fb0f56&lang=scss&scoped=true&
var TheHeaderFreeTrailStripvue_type_style_index_0_id_02fb0f56_lang_scss_scoped_true_ = __webpack_require__(698);
;// CONCATENATED MODULE: ./src/components/TheHeaderFreeTrailStrip.vue?vue&type=style&index=0&id=02fb0f56&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderFreeTrailStrip.vue



;


/* normalize component */

var TheHeaderFreeTrailStrip_component = componentNormalizer_normalizeComponent(
  components_TheHeaderFreeTrailStripvue_type_script_lang_ts_,
  TheHeaderFreeTrailStripvue_type_template_id_02fb0f56_scoped_true_render,
  TheHeaderFreeTrailStripvue_type_template_id_02fb0f56_scoped_true_staticRenderFns,
  false,
  null,
  "02fb0f56",
  null
  
)

/* harmony default export */ var components_TheHeaderFreeTrailStrip = (TheHeaderFreeTrailStrip_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserArea.vue?vue&type=template&id=e443521a&scoped=true&
var TheHeaderUserAreavue_type_template_id_e443521a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-user-area"},[(_vm.userUsingPhone)?_c('div',{staticClass:"icon-wrapper",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.showMobileNavigation = !_vm.showMobileNavigation},"keypress":function($event){_vm.showMobileNavigation = !_vm.showMobileNavigation}}},[(!_vm.showMobileNavigation)?_c('hamburger-menu-icon'):_c('close-icon',{attrs:{"color":"#09121F","height":20,"width":20}})],1):_vm._e(),_c('the-header-user-area-logos',{attrs:{"is-elite":_vm.userIsCgElite,"domain-logo":_vm.domainLogo,"userCompanyLogo":_vm.userCompanyLogo}}),(_vm.userUsingPhone)?_c('div',{staticClass:"the-header-user-area__phone-icons-area"},[_c('a',{attrs:{"href":"tel:+16467517075"}},[_c('phone-icon',{attrs:{"aria-label":"Call a customer support at +1 646-751-7075"}})],1),_c('cart-amount',{on:{"showCartPanel":function($event){return _vm.$emit('onShowCart')}}})],1):_vm._e(),(!_vm.userUsingTablet && !_vm.userUsingPhone && !_vm.hideSearchInput)?_c('header-search'):_vm._e(),(!_vm.userUsingPhone)?_c('the-header-user-area-info',_vm._g({},_vm.$listeners)):_vm._e(),(_vm.userUsingPhone)?_c('the-header-mobile-navigation',_vm._g({on:{"showNavigationPanel":_vm.handleNavigationPanelData},model:{value:(_vm.showMobileNavigation),callback:function ($$v) {_vm.showMobileNavigation=$$v},expression:"showMobileNavigation"}},_vm.$listeners)):_vm._e(),(_vm.userUsingPhone)?_c('the-header-mobile-navigation-panel',{attrs:{"component-data":_vm.mobileNavigationPanelData},model:{value:(_vm.showMobileNavigationPanel),callback:function ($$v) {_vm.showMobileNavigationPanel=$$v},expression:"showMobileNavigationPanel"}}):_vm._e()],1)}
var TheHeaderUserAreavue_type_template_id_e443521a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/userIsCgElite.ts
var userIsCgElite_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserIsCgElite = class UserIsCgElite extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get userIsCgElite() {
    return this.$store.state.header?.headerData?.isElite || false;
  }

};
UserIsCgElite = userIsCgElite_decorate([vue_class_component_esm], UserIsCgElite);
/* harmony default export */ var userIsCgElite = (UserIsCgElite);
;// CONCATENATED MODULE: ./src/mixins/userDeviceWidth.ts


var userDeviceWidth_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserDeviceWidth = class UserDeviceWidth extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "userDeviceWidth", window.innerWidth);

    _defineProperty(this, "userDeviceHeight", window.innerHeight);

    _defineProperty(this, "userUsingPhone", false);

    _defineProperty(this, "userUsingTablet", false);
  }

  onChildChanged(val) {
    this.userUsingPhone = val <= 600 || false;
    this.userUsingTablet = val <= 960 && val > 600 || false;
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resizeHandler);
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  resizeHandler() {
    this.userDeviceWidth = window.innerWidth || 0;
    this.userDeviceHeight = window.innerHeight || 0;
  }

};

userDeviceWidth_decorate([Watch('userDeviceWidth', {
  immediate: true
})], UserDeviceWidth.prototype, "onChildChanged", null);

UserDeviceWidth = userDeviceWidth_decorate([vue_class_component_esm], UserDeviceWidth);
/* harmony default export */ var userDeviceWidth = (UserDeviceWidth);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/HamburgerMenu.vue?vue&type=template&id=d097df70&
var HamburgerMenuvue_type_template_id_d097df70_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M2.5 3.33337H17.5V5.00004H2.5V3.33337ZM2.5 9.16671H17.5V10.8334H2.5V9.16671ZM2.5\n      15H17.5V16.6667H2.5V15Z","fill":"#09121F"}})])}
var HamburgerMenuvue_type_template_id_d097df70_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/HamburgerMenu.vue?vue&type=script&lang=ts&


var HamburgerMenuvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let HamburgerMenu = class HamburgerMenu extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

HamburgerMenuvue_type_script_lang_ts_decorate([Prop({
  default: 20
})], HamburgerMenu.prototype, "width", void 0);

HamburgerMenuvue_type_script_lang_ts_decorate([Prop({
  default: 20
})], HamburgerMenu.prototype, "height", void 0);

HamburgerMenu = HamburgerMenuvue_type_script_lang_ts_decorate([vue_class_component_esm], HamburgerMenu);
/* harmony default export */ var HamburgerMenuvue_type_script_lang_ts_ = (HamburgerMenu);
;// CONCATENATED MODULE: ./src/components/icons/HamburgerMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_HamburgerMenuvue_type_script_lang_ts_ = (HamburgerMenuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/HamburgerMenu.vue





/* normalize component */
;
var HamburgerMenu_component = componentNormalizer_normalizeComponent(
  icons_HamburgerMenuvue_type_script_lang_ts_,
  HamburgerMenuvue_type_template_id_d097df70_render,
  HamburgerMenuvue_type_template_id_d097df70_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_HamburgerMenu = (HamburgerMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Phone.vue?vue&type=template&id=f66bc31e&
var Phonevue_type_template_id_f66bc31e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M15.7851 12.4859L12.1389 13.1761C9.67571 11.9687 8.15456 10.5814 7.26915 8.41916L7.95092\n      4.84714L6.66264 1.5H3.34144C2.34269 1.5 1.55644 2.30608 1.70608 3.27044C2.07795 5.67744\n      3.17587 10.0426 6.38373 13.1761C9.75274 16.467 14.6057 17.895 17.2761 18.4632C18.3076\n      18.682 19.2223 17.8967 19.2223 16.8649V13.7651L15.7851 12.4859V12.4859Z","stroke":"black","stroke-width":"1.5625","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var Phonevue_type_template_id_f66bc31e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Phone.vue?vue&type=script&lang=ts&


var Phonevue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Phone = class Phone extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Phonevue_type_script_lang_ts_decorate([Prop({
  default: 20
})], Phone.prototype, "width", void 0);

Phonevue_type_script_lang_ts_decorate([Prop({
  default: 20
})], Phone.prototype, "height", void 0);

Phone = Phonevue_type_script_lang_ts_decorate([vue_class_component_esm], Phone);
/* harmony default export */ var Phonevue_type_script_lang_ts_ = (Phone);
;// CONCATENATED MODULE: ./src/components/icons/Phone.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Phonevue_type_script_lang_ts_ = (Phonevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Phone.vue





/* normalize component */
;
var Phone_component = componentNormalizer_normalizeComponent(
  icons_Phonevue_type_script_lang_ts_,
  Phonevue_type_template_id_f66bc31e_render,
  Phonevue_type_template_id_f66bc31e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Phone = (Phone_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CartAmount.vue?vue&type=template&id=11fa9137&scoped=true&
var CartAmountvue_type_template_id_11fa9137_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-icon-wrapper",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.$emit('showCartPanel')},"keypress":function($event){return _vm.$emit('showCartPanel')}}},[_c('cart-icon'),(_vm.userCartAmount)?_c('div',{staticClass:"cart-icon-wrapper__badge"},[_vm._v(" "+_vm._s(_vm.userCartAmount)+" ")]):_vm._e()],1)}
var CartAmountvue_type_template_id_11fa9137_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Cart.vue?vue&type=template&id=d4c0dc82&
var Cartvue_type_template_id_d4c0dc82_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 23","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.46387 21.125L2.73289 7.375H5.5873V8.94044C5.17174 9.179 4.88889 9.61763 4.88889\n      10.125C4.88889 10.884 5.51466 11.5 6.28571 11.5C7.05746 11.5 7.68254 10.884 7.68254\n      10.125C7.68254 9.61763 7.40038 9.179 6.98412 8.94044V7.375H12.5714V8.94044C12.1559 9.179\n      11.873 9.61763 11.873 10.125C11.873 10.884 12.4988 11.5 13.2698 11.5C14.0416 11.5 14.6667\n      10.884 14.6667 10.125C14.6667 9.61763 14.3845 9.179 13.9683 8.94044V7.375H16.8227L18.0924\n      21.125H1.46387ZM6.98412 4.625C6.98412 3.10837 8.23778 1.875 9.77778 1.875C11.3178 1.875\n      12.5714 3.10837 12.5714 4.625V6H6.98412V4.625ZM18.1559 6.62562C18.1238 6.27156 17.8221 6\n      17.4603 6H13.9682V4.625C13.9682 2.35006 12.0888 0.5 9.77776 0.5C7.46741 0.5 5.58728 2.35006\n      5.58728 4.625V6H2.09522C1.73414 6 1.43242 6.27156 1.3996 6.62562L0.00277084\n      21.7506C-0.0146895 21.9424 0.0509613 22.1336 0.182961 22.2759C0.314961 22.4189 0.502136\n      22.5 0.69839 22.5H18.8571C19.0541 22.5 19.2405 22.4189 19.3732 22.2759C19.5052 22.1336\n      19.5709 21.9424 19.5527 21.7506L18.1559 6.62562Z","fill":"black"}})])}
var Cartvue_type_template_id_d4c0dc82_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Cart.vue?vue&type=script&lang=ts&


var Cartvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Cart = class Cart extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Cartvue_type_script_lang_ts_decorate([Prop({
  default: 20
})], Cart.prototype, "width", void 0);

Cartvue_type_script_lang_ts_decorate([Prop({
  default: 23
})], Cart.prototype, "height", void 0);

Cart = Cartvue_type_script_lang_ts_decorate([vue_class_component_esm], Cart);
/* harmony default export */ var Cartvue_type_script_lang_ts_ = (Cart);
;// CONCATENATED MODULE: ./src/components/icons/Cart.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Cartvue_type_script_lang_ts_ = (Cartvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Cart.vue





/* normalize component */
;
var Cart_component = componentNormalizer_normalizeComponent(
  icons_Cartvue_type_script_lang_ts_,
  Cartvue_type_template_id_d4c0dc82_render,
  Cartvue_type_template_id_d4c0dc82_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Cart = (Cart_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CartAmount.vue?vue&type=script&lang=ts&
var CartAmountvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let CartAmount = class CartAmount extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get userCartAmount() {
    return this.$store.state.header.headerData.cart?.count || 0;
  }

};
CartAmount = CartAmountvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CartIcon: icons_Cart
  }
})], CartAmount);
/* harmony default export */ var CartAmountvue_type_script_lang_ts_ = (CartAmount);
;// CONCATENATED MODULE: ./src/components/CartAmount.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CartAmountvue_type_script_lang_ts_ = (CartAmountvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CartAmount.vue?vue&type=style&index=0&id=11fa9137&lang=scss&scoped=true&
var CartAmountvue_type_style_index_0_id_11fa9137_lang_scss_scoped_true_ = __webpack_require__(7405);
;// CONCATENATED MODULE: ./src/components/CartAmount.vue?vue&type=style&index=0&id=11fa9137&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/CartAmount.vue



;


/* normalize component */

var CartAmount_component = componentNormalizer_normalizeComponent(
  components_CartAmountvue_type_script_lang_ts_,
  CartAmountvue_type_template_id_11fa9137_scoped_true_render,
  CartAmountvue_type_template_id_11fa9137_scoped_true_staticRenderFns,
  false,
  null,
  "11fa9137",
  null
  
)

/* harmony default export */ var components_CartAmount = (CartAmount_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigation.vue?vue&type=template&id=1dd687dc&scoped=true&
var TheHeaderMobileNavigationvue_type_template_id_1dd687dc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-right-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"header-mobile-navigation"},[(!_vm.hideSearch)?_c('div',{staticClass:"header-mobile-navigation__search-wrapper"},[_c('header-search')],1):_vm._e(),_vm._l((_vm.navigationButtonsData),function(buttonData,index){return _c('the-header-mobile-navigation-button',{key:index,nativeOn:{"click":function($event){return _vm.handleButtonClick(buttonData)},"keypress":function($event){return _vm.handleButtonClick(buttonData)}}},[(buttonData.icon)?_c(buttonData.icon,{tag:"component",attrs:{"width":buttonData.iconWidth,"height":buttonData.iconHeight}}):_vm._e(),_vm._v(" "+_vm._s(buttonData.name)+" ")],1)})],2)])}
var TheHeaderMobileNavigationvue_type_template_id_1dd687dc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/companyName.ts
var companyName_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CompanyName = class CompanyName extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get companyName() {
    return this.$store.state.header.headerData?.companyName || null;
  }

};
CompanyName = companyName_decorate([vue_class_component_esm], CompanyName);
/* harmony default export */ var companyName = (CompanyName);
;// CONCATENATED MODULE: ./src/mixins/subdomainInfo.ts


var subdomainInfo_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SubdomainInfo = class SubdomainInfo extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "domainInfo", window.location.host.split('.'));
  }

  get hasExternalDomain() {
    const [subdomain] = this.domainInfo;
    const internalDomains = ['staging', 'development', 'dev', 'corporategift', 'account'];

    if (internalDomains.includes(subdomain)) {
      return false;
    }

    return true;
  }

};
SubdomainInfo = subdomainInfo_decorate([vue_class_component_esm], SubdomainInfo);
/* harmony default export */ var subdomainInfo = (SubdomainInfo);
;// CONCATENATED MODULE: ./src/mixins/showShopHolidaysLink.ts
var showShopHolidaysLink_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ShowShopHolidaysLink = class ShowShopHolidaysLink extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get showShopHolidaysLink() {
    const currentDate = new Date();
    const startDate = new Date('2024-06-01');
    const endDate = new Date('2024-11-01');
    return currentDate >= startDate && currentDate < endDate;
  }

};
ShowShopHolidaysLink = showShopHolidaysLink_decorate([vue_class_component_esm], ShowShopHolidaysLink);
/* harmony default export */ var showShopHolidaysLink = (ShowShopHolidaysLink);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/User.vue?vue&type=template&id=6199d67a&
var Uservue_type_template_id_6199d67a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 22","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.7344 13.434C16.3079 13.434 15.9629 13.7824 15.9629 14.212C15.9629 14.6426 16.3079\n      14.991 16.7344 14.991C19.3707 14.991 21.5169 17.1567 21.5169 19.8196C21.5169 20.1623\n      21.2399 20.4419 20.8994 20.4419H2.85054C2.51109 20.4419 2.23417 20.1623 2.23417\n      19.8196C2.23417 17.1567 4.38029 14.991 7.01549 14.991C7.44203 14.991 7.78706 14.6426\n      7.78706 14.212C7.78706 13.7824 7.44203 13.434 7.01549 13.434C3.52832 13.434 0.692139\n      16.2976 0.692139 19.8196C0.692139 21.0214 1.66135 22 2.85054 22H20.8994C22.0897 22 23.06\n      21.0214 23.06 19.8196C23.06 16.2976 20.2227 13.434 16.7344 13.434ZM11.8761 1.55693C14.2143\n      1.55693 16.1181 4.04622 16.1181 7.10598C16.1181 10.1646 14.2143 12.655 11.8761\n      12.655C9.53678 12.655 7.63409 10.1646 7.63185 7.10598C7.63185 4.04622 9.53567 1.55693\n      11.8761 1.55693ZM11.8761 14.212C15.0662 14.212 17.6601 11.0248 17.6601 7.10598C17.6601\n      3.18715 15.0662 0 11.8761 0C10.2983 0 8.82439 0.760992 7.72788 2.14431C6.67157 3.47802\n      6.09093 5.23901 6.09093 7.10598C6.09093 11.0248 8.68593 14.212 11.8761 14.212Z","fill":"black"}})])}
var Uservue_type_template_id_6199d67a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/User.vue?vue&type=script&lang=ts&


var Uservue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let User = class User extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Uservue_type_script_lang_ts_decorate([Prop({
  default: 24
})], User.prototype, "width", void 0);

Uservue_type_script_lang_ts_decorate([Prop({
  default: 22
})], User.prototype, "height", void 0);

User = Uservue_type_script_lang_ts_decorate([vue_class_component_esm], User);
/* harmony default export */ var Uservue_type_script_lang_ts_ = (User);
;// CONCATENATED MODULE: ./src/components/icons/User.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Uservue_type_script_lang_ts_ = (Uservue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/User.vue





/* normalize component */
;
var User_component = componentNormalizer_normalizeComponent(
  icons_Uservue_type_script_lang_ts_,
  Uservue_type_template_id_6199d67a_render,
  Uservue_type_template_id_6199d67a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_User = (User_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Help.vue?vue&type=template&id=6731f458&
var Helpvue_type_template_id_6731f458_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29 29","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.8719 19.0004C14.3021 19.0004 13.8406 19.4619 13.8406 20.0317C13.8406 20.6015 14.3021\n      21.0641 14.8719 21.0641C15.4417 21.0641 15.9032 20.6015 15.9032 20.0317C15.9032 19.4619\n      15.4417 19.0004 14.8719 19.0004M14.8721 8.16643C12.7445 8.16643 11.0026 9.90836 11.0026\n      12.0359C10.9972 12.4628 11.3384 12.8148 11.7663 12.8202C12.1931 12.8267 12.5441 12.4855\n      12.5506 12.0576C12.5506 12.05 12.5506 12.0435 12.5506 12.0359C12.5506 10.7447 13.5808\n      9.71445 14.8721 9.71445C16.1634 9.71445 17.1936 10.7447 17.1936 12.0359C17.1936 12.8387\n      16.8697 13.3868 16.3389 13.9458C15.808 14.5058 15.0725 15.0117 14.3889 15.5588C14.2048\n      15.705 14.0986 15.9282 14.0986 16.1633V17.1946C14.0921 17.6225 14.4334 17.9734 14.8613\n      17.9799C15.2881 17.9854 15.6401 17.6441 15.6456 17.2162C15.6456 17.2097 15.6456 17.2021\n      15.6456 17.1946V16.5413C16.2099 16.1113 16.8718 15.6379 17.4676 15.0107C18.162 14.2783\n      18.7416 13.2915 18.7416 12.0359C18.7416 9.90836 16.9997 8.16643 14.8721 8.16643M14.8718\n      4.55582C20.4367 4.55582 24.9313 9.05039 24.9313 14.6152C24.9313 20.1801 20.4367 24.6747\n      14.8718 24.6747C9.30698 24.6747 4.81242 20.1801 4.81242 14.6152C4.81242 9.05039 9.30698\n      4.55582 14.8718 4.55582M14.8721 3.00781C8.47094 3.00781 3.26465 8.2141 3.26465\n      14.6153C3.26465 21.0164 8.47094 26.2227 14.8721 26.2227C21.2732 26.2227 26.4795 21.0164\n      26.4795 14.6153C26.4795 8.2141 21.2732 3.00781 14.8721 3.00781","fill":"currentColor"}})])}
var Helpvue_type_template_id_6731f458_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Help.vue?vue&type=script&lang=ts&


var Helpvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Heart = class Heart extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Helpvue_type_script_lang_ts_decorate([Prop({
  default: 29
})], Heart.prototype, "width", void 0);

Helpvue_type_script_lang_ts_decorate([Prop({
  default: 29
})], Heart.prototype, "height", void 0);

Heart = Helpvue_type_script_lang_ts_decorate([vue_class_component_esm], Heart);
/* harmony default export */ var Helpvue_type_script_lang_ts_ = (Heart);
;// CONCATENATED MODULE: ./src/components/icons/Help.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Helpvue_type_script_lang_ts_ = (Helpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Help.vue





/* normalize component */
;
var Help_component = componentNormalizer_normalizeComponent(
  icons_Helpvue_type_script_lang_ts_,
  Helpvue_type_template_id_6731f458_render,
  Helpvue_type_template_id_6731f458_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Help = (Help_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Heart.vue?vue&type=template&id=72471ec1&
var Heartvue_type_template_id_72471ec1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 22","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.7689 21.7659C11.9249 21.922 12.133 22 12.3671 22C12.6011 22 12.8092 21.922 12.9653\n      21.7659L22.6925 12.0647C22.6925 12.0517 22.699 12.0452 22.7055 12.0387C22.712 12.0322\n      22.7185 12.0257 22.7185 12.0127C25.4234 9.25581 25.3974 4.78234 22.6665 2.05144C19.9096\n      -0.679462 15.4101 -0.679462 12.6792 2.02543L12.3671 2.33753L12.081 2.05144C9.32407\n      -0.679462 4.82459 -0.679462 2.06768 2.05144C-0.689227 4.80834 -0.689227 9.28182 2.06768\n      12.0387L2.09369 12.0647L11.7689 21.7659ZM12.3671 19.9713L3.26407 10.8683C2.22373 9.854\n      1.67755 8.50156 1.67755 7.07109C1.67755 5.61461 2.24974 4.26216 3.26407 3.24783C5.34476\n      1.14114 8.77789 1.14114 10.8846 3.24783L11.7689 4.13212C11.9249 4.28817 12.133 4.3662\n      12.3671 4.3662C12.6011 4.3662 12.8092 4.28817 12.9653 4.13212L13.8496 3.24783C15.9302\n      1.14114 19.3634 1.14114 21.4701 3.24783C23.5768 5.32852 23.5768 8.76164 21.4701\n      10.8683L21.4441 10.8943L12.3671 19.9713Z","fill":"black"}})])}
var Heartvue_type_template_id_72471ec1_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Heart.vue?vue&type=script&lang=ts&


var Heartvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Heartvue_type_script_lang_ts_Heart = class Heart extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Heartvue_type_script_lang_ts_decorate([Prop({
  default: 25
})], Heartvue_type_script_lang_ts_Heart.prototype, "width", void 0);

Heartvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Heartvue_type_script_lang_ts_Heart.prototype, "height", void 0);

Heartvue_type_script_lang_ts_Heart = Heartvue_type_script_lang_ts_decorate([vue_class_component_esm], Heartvue_type_script_lang_ts_Heart);
/* harmony default export */ var Heartvue_type_script_lang_ts_ = (Heartvue_type_script_lang_ts_Heart);
;// CONCATENATED MODULE: ./src/components/icons/Heart.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Heartvue_type_script_lang_ts_ = (Heartvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Heart.vue





/* normalize component */
;
var Heart_component = componentNormalizer_normalizeComponent(
  icons_Heartvue_type_script_lang_ts_,
  Heartvue_type_template_id_72471ec1_render,
  Heartvue_type_template_id_72471ec1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Heart = (Heart_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeaderSearch.vue?vue&type=template&id=52e0e9c6&scoped=true&
var HeaderSearchvue_type_template_id_52e0e9c6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-instant-search',{attrs:{"search-client":_vm.searchClient,"search-function":_vm.searchFunction,"index-name":"search"}},[_c('ais-configure',{attrs:{"query":_vm.search,"removeWordsIfNoResults":'allOptional',"hitsPerPage":_vm.hitsNumber,"filters":_vm.filters,"distinct":true,"analytics":true,"enablePersonalization":true}}),_c('ais-autocomplete',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var indices = ref.indices;
return [_c('v-popover',{attrs:{"open":_vm.showAlgoliaAutocomplete,"placement":"top","trigger":"click","boundaries-element":"body"},on:{"update:open":function($event){_vm.showAlgoliaAutocomplete=$event},"show":function($event){return _vm.updateElementWidth()},"hide":function($event){return _vm.checkIfPopperShouldBeStillVisible()}}},[_c('div',{staticClass:"the-header-search",class:{ 'the-header-search--focused': _vm.inFocusMode }},[(_vm.inFocusMode)?_c('div',{staticClass:"the-header-search__icon"},[_c('search-icon')],1):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],ref:"search-input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSearch(_vm.search)},"focus":function($event){_vm.inFocusMode = true},"blur":function($event){_vm.inFocusMode = false},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),(_vm.search)?_c('div',{staticClass:"the-header-search__icon the-header-search__icon--clear",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.clearSearchInput()},"keypress":function($event){return _vm.clearSearchInput()}}},[_c('close-icon')],1):_vm._e(),_c('div',{staticClass:"the-header-search__icon",class:{ 'the-header-search__icon--black': _vm.inFocusMode },attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.onSearch(_vm.search)},"keypress":function($event){return _vm.onSearch(_vm.search)}}},[_c('search-icon',{attrs:{"color":_vm.inFocusMode ? '#fff' : '#000'}})],1)]),(indices[0].hits.length > 0)?_c('the-header-search-algolia-content',{attrs:{"slot":"popover","products":indices[0].hits,"width":_vm.searchWidth,"currentValue":_vm.search},on:{"showSearchPage":function (val) { return _vm.onSuggestionClick(val); }},slot:"popover"}):_vm._e()],1)]}}])})],1)}
var HeaderSearchvue_type_template_id_52e0e9c6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/types/tagManager/SearchMethod.ts
// eslint-disable-next-line no-shadow
var SearchMethod;

(function (SearchMethod) {
  SearchMethod["SearchBar"] = "Search bar";
  SearchMethod["Image"] = "Image";
  SearchMethod["Suggestion"] = "Suggestion";
})(SearchMethod || (SearchMethod = {}));

/* harmony default export */ var tagManager_SearchMethod = (SearchMethod);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Search.vue?vue&type=template&id=ee99bcb6&
var Searchvue_type_template_id_ee99bcb6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M7.33333 13.1667C10.2789 13.1667 12.6667 10.7789 12.6667 7.83333C12.6667 4.88781 10.2789\n      2.5 7.33333 2.5C4.38781 2.5 2 4.88781 2 7.83333C2 10.7789 4.38781 13.1667 7.33333 13.1667Z","stroke":_vm.color,"stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 14.5L11.1 11.6","stroke":_vm.color,"stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var Searchvue_type_template_id_ee99bcb6_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Search.vue?vue&type=script&lang=ts&


var Searchvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Search = class Search extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);

    _defineProperty(this, "color", void 0);
  }

};

Searchvue_type_script_lang_ts_decorate([Prop({
  default: 16
})], Search.prototype, "width", void 0);

Searchvue_type_script_lang_ts_decorate([Prop({
  default: 16
})], Search.prototype, "height", void 0);

Searchvue_type_script_lang_ts_decorate([Prop({
  default: '#919191'
})], Search.prototype, "color", void 0);

Search = Searchvue_type_script_lang_ts_decorate([vue_class_component_esm], Search);
/* harmony default export */ var Searchvue_type_script_lang_ts_ = (Search);
;// CONCATENATED MODULE: ./src/components/icons/Search.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Searchvue_type_script_lang_ts_ = (Searchvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Search.vue





/* normalize component */
;
var Search_component = componentNormalizer_normalizeComponent(
  icons_Searchvue_type_script_lang_ts_,
  Searchvue_type_template_id_ee99bcb6_render,
  Searchvue_type_template_id_ee99bcb6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Search = (Search_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContent.vue?vue&type=template&id=7d3ee84b&scoped=true&
var TheHeaderSearchAlgoliaContentvue_type_template_id_7d3ee84b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-search-algolia-content",style:(("--width:" + _vm.width + "px"))},[_c('div',{staticClass:"the-header-search-algolia-content__products"},[_vm._l((_vm.products),function(product){return _c('the-header-search-algolia-content-item',{key:product.id,attrs:{"product":product}})}),(_vm.searchValue)?_c('div',{staticClass:"the-header-search-algolia-content__all-results"},[_c('a',{attrs:{"href":(_vm.storeUrl + "/search?q=" + _vm.searchValue)},on:{"click":function($event){return _vm.onHintClick()}}},[_vm._v(" View all results ")]),_vm._v(" for \""+_vm._s(_vm.searchValue)+"\" ")]):_vm._e()],2),_c('div',{staticClass:"the-header-search-algolia-content__suggestions"},[_c('the-header-search-algolia-content-hints',_vm._g({},_vm.$listeners))],1)])}
var TheHeaderSearchAlgoliaContentvue_type_template_id_7d3ee84b_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentItem.vue?vue&type=template&id=55ae8088&scoped=true&
var TheHeaderSearchAlgoliaContentItemvue_type_template_id_55ae8088_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"algolia-product"},[_c('a',{attrs:{"href":_vm.product.url,"target":"_blank"},on:{"&click":function($event){return _vm.onProductClick($event, _vm.product.name)}}},[_c('img',{attrs:{"alt":_vm.product.name,"src":_vm.product.thumbnail}}),_c('div',{staticClass:"algolia-product__info"},[_c('ais-highlight',{attrs:{"attribute":"name","hit":_vm.product}}),_c('div',{staticClass:"algolia-product__price"},[_c('span',[_vm._v("From")]),_c('span',[_vm._v("$"+_vm._s(_vm.product.price))])])],1)])])}
var TheHeaderSearchAlgoliaContentItemvue_type_template_id_55ae8088_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/suit.js

/* harmony default export */ function suit(r, e, o) {
  if (!r) throw new Error("You need to provide `widgetName` in your data");
  var t = ["ais-" + r];
  return e && t.push("-" + e), o && t.push("--" + o), t.join("");
}
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/mixins/suit.js


var suit_t = function (t) {
  var a = t.name;
  return {
    props: {
      classNames: {
        type: Object,
        default: void 0
      }
    },
    methods: {
      suit: function (t, e) {
        var r = suit(a, t, e),
            i = this.classNames && this.classNames[r];
        return i ? [r, i].join(" ") : r;
      }
    }
  };
};


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/vue-compat/index-vue2.js


var index_vue2_t = !0,
    index_vue2_e = !1,
    u = external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject,
    index_vue2_n = external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.version;

function o(r) {
  return function (t) {
    return r.call(this, t);
  };
}

function f(r) {
  return r.$slots.default;
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/warn.js
var warn_n = new Set();

function a(a) {
  warn_n.has(a) || (warn_n.add(a), console.warn(a));
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/mixins/widget.js




var widget_e = function (e) {
  var n;
  void 0 === e && (e = {});
  var i = e.connector;
  return (n = {
    inject: {
      instantSearchInstance: {
        from: "$_ais_instantSearchInstance",
        default: function () {
          var t = this.$options._componentTag;
          throw new TypeError('It looks like you forgot to wrap your Algolia search component "<' + t + '>" inside of an "<ais-instant-search>" component.');
        }
      },
      getParentIndex: {
        from: "$_ais_getParentIndex",
        default: function () {
          var t = this;
          return function () {
            return t.instantSearchInstance.mainIndex;
          };
        }
      }
    },
    data: function () {
      return {
        state: null
      };
    },
    created: function () {
      if ("function" == typeof i) {
        if (this.factory = i(this.updateState, function () {}), this.widget = this.factory(this.widgetParams), this.getParentIndex().addWidgets([this.widget]), this.instantSearchInstance._initialResults && !this.instantSearchInstance.started) {
          if ("function" != typeof this.instantSearchInstance.__forceRender) throw new Error("You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.");

          this.instantSearchInstance.__forceRender(this.widget, this.getParentIndex());
        }
      } else !0 !== i && a("You are using the InstantSearch widget mixin, but didn't provide a connector.\nWhile this is technically possible, and will give you access to the Helper,\nit's not the recommended way of making custom components.\n\nIf you want to disable this message, pass { connector: true } to the mixin.\n\nRead more on using connectors: https://alg.li/vue-custom");
    }
  }).beforeDestroy = function () {
    this.widget && this.getParentIndex().removeWidgets([this.widget]);
  }, n.watch = {
    widgetParams: {
      handler: function (t) {
        this.state = null, this.getParentIndex().removeWidgets([this.widget]), this.widget = this.factory(t), this.getParentIndex().addWidgets([this.widget]);
      },
      deep: !0
    }
  }, n.methods = {
    updateState: function (t, e) {
      void 0 === t && (t = {}), e || (this.state = t);
    }
  }, n;
};


;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/documentation.js
var createDocumentationLink = function createDocumentationLink(_ref) {
  var name = _ref.name,
      _ref$connector = _ref.connector,
      connector = _ref$connector === void 0 ? false : _ref$connector;
  return ['https://www.algolia.com/doc/api-reference/widgets/', name, '/js/', connector ? '#connector' : ''].join('');
};
var createDocumentationMessageGenerator = function createDocumentationMessageGenerator() {
  for (var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++) {
    widgets[_key] = arguments[_key];
  }

  var links = widgets.map(function (widget) {
    return createDocumentationLink(widget);
  }).join(', ');
  return function (message) {
    return [message, "See documentation: ".concat(links)].filter(Boolean).join('\n\n');
  };
};
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/noop.js
function noop_noop() {}

/* harmony default export */ var utils_noop = (noop_noop);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getObjectType.js
function getObjectType(object) {
  return Object.prototype.toString.call(object).slice(8, -1);
}

/* harmony default export */ var utils_getObjectType = (getObjectType);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/checkRendering.js



function checkRendering(rendering, usage) {
  if (rendering === undefined || typeof rendering !== 'function') {
    throw new Error("The render function is not valid (received type ".concat(utils_getObjectType(rendering), ").\n\n").concat(usage));
  }
}

/* harmony default export */ var utils_checkRendering = (checkRendering);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/escape.js
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */
// Used to map characters to HTML entities.
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}; // Used to match HTML entities and HTML characters.

var regexUnescapedHtml = /[&<>"']/g;
var regexHasUnescapedHtml = RegExp(regexUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 */

function escape_escape(value) {
  return value && regexHasUnescapedHtml.test(value) ? value.replace(regexUnescapedHtml, function (character) {
    return htmlEscapes[character];
  }) : value;
}

/* harmony default export */ var utils_escape = (escape_escape);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/isPlainObject.js
function isPlainObject_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    isPlainObject_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    isPlainObject_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return isPlainObject_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */


function getTag(value) {
  if (value === null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }

  return Object.prototype.toString.call(value);
}

function isPlainObject_isObjectLike(value) {
  return isPlainObject_typeof(value) === 'object' && value !== null;
}
/**
 * Checks if `value` is a plain object.
 *
 * A plain object is an object created by the `Object`
 * constructor or with a `[[Prototype]]` of `null`.
 */


function isPlainObject_isPlainObject(value) {
  if (!isPlainObject_isObjectLike(value) || getTag(value) !== '[object Object]') {
    return false;
  }

  if (Object.getPrototypeOf(value) === null) {
    return true;
  }

  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

/* harmony default export */ var utils_isPlainObject = (isPlainObject_isPlainObject);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/escape-highlight.js
function escape_highlight_extends() {
  escape_highlight_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return escape_highlight_extends.apply(this, arguments);
}

function escape_highlight_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function escape_highlight_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      escape_highlight_ownKeys(Object(source), true).forEach(function (key) {
        escape_highlight_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      escape_highlight_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function escape_highlight_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var TAG_PLACEHOLDER = {
  highlightPreTag: '__ais-highlight__',
  highlightPostTag: '__/ais-highlight__'
};
var TAG_REPLACEMENT = {
  highlightPreTag: '<mark>',
  highlightPostTag: '</mark>'
};

function replaceTagsAndEscape(value) {
  return utils_escape(value).replace(new RegExp(TAG_PLACEHOLDER.highlightPreTag, 'g'), TAG_REPLACEMENT.highlightPreTag).replace(new RegExp(TAG_PLACEHOLDER.highlightPostTag, 'g'), TAG_REPLACEMENT.highlightPostTag);
}

function recursiveEscape(input) {
  if (utils_isPlainObject(input) && typeof input.value !== 'string') {
    return Object.keys(input).reduce(function (acc, key) {
      return escape_highlight_objectSpread(escape_highlight_objectSpread({}, acc), {}, escape_highlight_defineProperty({}, key, recursiveEscape(input[key])));
    }, {});
  }

  if (Array.isArray(input)) {
    return input.map(recursiveEscape);
  }

  return escape_highlight_objectSpread(escape_highlight_objectSpread({}, input), {}, {
    value: replaceTagsAndEscape(input.value)
  });
}

function escapeHits(hits) {
  if (hits.__escaped === undefined) {
    // We don't override the value on hit because it will mutate the raw results
    // instead we make a shallow copy and we assign the escaped values on it.
    hits = hits.map(function (_ref) {
      var hit = escape_highlight_extends({}, _ref);

      if (hit._highlightResult) {
        hit._highlightResult = recursiveEscape(hit._highlightResult);
      }

      if (hit._snippetResult) {
        hit._snippetResult = recursiveEscape(hit._snippetResult);
      }

      return hit;
    });
    hits.__escaped = true;
  }

  return hits;
}
function escapeFacets(facetHits) {
  return facetHits.map(function (h) {
    return escape_highlight_objectSpread(escape_highlight_objectSpread({}, h), {}, {
      highlighted: replaceTagsAndEscape(h.highlighted)
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/serializer.js

function serializePayload(payload) {
  return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function serializer_deserializePayload(serialized) {
  return JSON.parse(decodeURIComponent(atob(serialized)));
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/createSendEventForHits.js


function createSendEventForHits_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    createSendEventForHits_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    createSendEventForHits_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return createSendEventForHits_typeof(obj);
}
/**
 * @jest-environment jsdom
 */




function chunk(arr) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var chunks = [];

  for (var i = 0; i < Math.ceil(arr.length / chunkSize); i++) {
    chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
  }

  return chunks;
}

var buildPayloads = function buildPayloads(_ref) {
  var index = _ref.index,
      widgetType = _ref.widgetType,
      methodName = _ref.methodName,
      args = _ref.args; // when there's only one argument, that means it's custom

  if (args.length === 1 && createSendEventForHits_typeof(args[0]) === 'object') {
    return [args[0]];
  }

  var eventType = args[0];
  var hits = args[1];
  var eventName = args[2];

  if (!hits) {
    if (false) {} else {
      return [];
    }
  }

  if ((eventType === 'click' || eventType === 'conversion') && !eventName) {
    if (false) {} else {
      return [];
    }
  }

  var hitsArray = Array.isArray(hits) ? removeEscapedFromHits(hits) : [hits];

  if (hitsArray.length === 0) {
    return [];
  }

  var queryID = hitsArray[0].__queryID;
  var hitsChunks = chunk(hitsArray);
  var objectIDsByChunk = hitsChunks.map(function (batch) {
    return batch.map(function (hit) {
      return hit.objectID;
    });
  });
  var positionsByChunk = hitsChunks.map(function (batch) {
    return batch.map(function (hit) {
      return hit.__position;
    });
  });

  if (eventType === 'view') {
    return hitsChunks.map(function (batch, i) {
      return {
        insightsMethod: 'viewedObjectIDs',
        widgetType: widgetType,
        eventType: eventType,
        payload: {
          eventName: eventName || 'Hits Viewed',
          index: index,
          objectIDs: objectIDsByChunk[i]
        },
        hits: batch
      };
    });
  } else if (eventType === 'click') {
    return hitsChunks.map(function (batch, i) {
      return {
        insightsMethod: 'clickedObjectIDsAfterSearch',
        widgetType: widgetType,
        eventType: eventType,
        payload: {
          eventName: eventName,
          index: index,
          queryID: queryID,
          objectIDs: objectIDsByChunk[i],
          positions: positionsByChunk[i]
        },
        hits: batch
      };
    });
  } else if (eventType === 'conversion') {
    return hitsChunks.map(function (batch, i) {
      return {
        insightsMethod: 'convertedObjectIDsAfterSearch',
        widgetType: widgetType,
        eventType: eventType,
        payload: {
          eventName: eventName,
          index: index,
          queryID: queryID,
          objectIDs: objectIDsByChunk[i]
        },
        hits: batch
      };
    });
  } else if (false) {} else {
    return [];
  }
};

function removeEscapedFromHits(hits) {
  // remove `hits.__escaped` without mutating
  return hits.slice();
}

function createSendEventForHits(_ref2) {
  var instantSearchInstance = _ref2.instantSearchInstance,
      index = _ref2.index,
      widgetType = _ref2.widgetType;

  var sendEventForHits = function sendEventForHits() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var payloads = buildPayloads({
      widgetType: widgetType,
      index: index,
      methodName: 'sendEvent',
      args: args
    });
    payloads.forEach(function (payload) {
      return instantSearchInstance.sendEventToInsights(payload);
    });
  };

  return sendEventForHits;
}
function createBindEventForHits(_ref3) {
  var index = _ref3.index,
      widgetType = _ref3.widgetType;

  var bindEventForHits = function bindEventForHits() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var payloads = buildPayloads({
      widgetType: widgetType,
      index: index,
      methodName: 'bindEvent',
      args: args
    });
    return payloads.length ? "data-insights-event=".concat(serializePayload(payloads)) : '';
  };

  return bindEventForHits;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/autocomplete/connectAutocomplete.js
function connectAutocomplete_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectAutocomplete_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectAutocomplete_ownKeys(Object(source), true).forEach(function (key) {
        connectAutocomplete_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectAutocomplete_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectAutocomplete_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var withUsage = createDocumentationMessageGenerator({
  name: 'autocomplete',
  connector: true
});

var connectAutocomplete = function connectAutocomplete(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        _ref$escapeHTML = _ref.escapeHTML,
        escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML;

     false ? 0 : void 0;
    var connectorState = {};
    return {
      $$type: 'ais.autocomplete',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        var renderState = this.getWidgetRenderState(renderOptions);
        renderState.indices.forEach(function (_ref3) {
          var sendEvent = _ref3.sendEvent,
              hits = _ref3.hits;
          sendEvent('view', hits);
        });
        renderFn(connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, renderState), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, renderState), {}, {
          autocomplete: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref4) {
        var _this = this;

        var helper = _ref4.helper,
            state = _ref4.state,
            scopedResults = _ref4.scopedResults,
            instantSearchInstance = _ref4.instantSearchInstance;

        if (!connectorState.refine) {
          connectorState.refine = function (query) {
            helper.setQuery(query).search();
          };
        }

        var indices = scopedResults.map(function (scopedResult) {
          // We need to escape the hits because highlighting
          // exposes HTML tags to the end-user.
          scopedResult.results.hits = escapeHTML ? escapeHits(scopedResult.results.hits) : scopedResult.results.hits;
          var sendEvent = createSendEventForHits({
            instantSearchInstance: instantSearchInstance,
            index: scopedResult.results.index,
            widgetType: _this.$$type
          });
          return {
            indexId: scopedResult.indexId,
            indexName: scopedResult.results.index,
            hits: scopedResult.results.hits,
            results: scopedResult.results,
            sendEvent: sendEvent
          };
        });
        return {
          currentRefinement: state.query || '',
          indices: indices,
          refine: connectorState.refine,
          widgetParams: widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        var query = searchParameters.query || '';

        if (query === '' || uiState && uiState.query === query) {
          return uiState;
        }

        return connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, uiState), {}, {
          query: query
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
        var uiState = _ref6.uiState;
        var parameters = {
          query: uiState.query || ''
        };

        if (!escapeHTML) {
          return searchParameters.setQueryParameters(parameters);
        }

        return searchParameters.setQueryParameters(connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, parameters), TAG_PLACEHOLDER));
      },
      dispose: function dispose(_ref7) {
        var state = _ref7.state;
        unmountFn();
        var stateWithoutQuery = state.setQueryParameter('query', undefined);

        if (!escapeHTML) {
          return stateWithoutQuery;
        }

        return stateWithoutQuery.setQueryParameters(Object.keys(TAG_PLACEHOLDER).reduce(function (acc, key) {
          return connectAutocomplete_objectSpread(connectAutocomplete_objectSpread({}, acc), {}, connectAutocomplete_defineProperty({}, key, undefined));
        }, {}));
      }
    };
  };
};

/* harmony default export */ var autocomplete_connectAutocomplete = (connectAutocomplete);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Autocomplete.vue.js



/* harmony default export */ var Autocomplete_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: e.suit()
    }, [e._t("default", [n("p", [e._v("This widget doesn't render anything without a filled in default slot.")]), e._v(" "), n("p", [e._v("query, function to refine and results are provided.")]), e._v(" "), n("pre", [e._v("refine: Function")]), e._v(" "), n("pre", [e._v('currentRefinement: "' + e._s(e.state.currentRefinement) + '"')]), e._v(" "), n("details", [e._m(0), e._v(" "), n("pre", [e._v(e._s(e.state.indices))])])], {
      refine: e.state.refine,
      currentRefinement: e.state.currentRefinement,
      indices: e.state.indices
    })], 2) : e._e();
  },
  staticRenderFns: [function () {
    var e = this.$createElement,
        t = this._self._c || e;
    return t("summary", [t("code", [this._v("indices")]), this._v(":")]);
  }],
  name: "AisAutocomplete",
  mixins: [widget_e({
    connector: autocomplete_connectAutocomplete
  }), suit_t({
    name: "Autocomplete"
  })],
  props: {
    escapeHTML: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        escapeHTML: this.escapeHTML
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/breadcrumb/connectBreadcrumb.js


function connectBreadcrumb_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectBreadcrumb_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectBreadcrumb_ownKeys(Object(source), true).forEach(function (key) {
        connectBreadcrumb_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectBreadcrumb_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectBreadcrumb_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


var connectBreadcrumb_withUsage = createDocumentationMessageGenerator({
  name: 'breadcrumb',
  connector: true
});

var connectBreadcrumb = function connectBreadcrumb(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectBreadcrumb_withUsage());
  var connectorState = {};
  return function (widgetParams) {
    var _ref = widgetParams || {},
        attributes = _ref.attributes,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? ' > ' : _ref$separator,
        _ref$rootPath = _ref.rootPath,
        rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
      throw new Error(connectBreadcrumb_withUsage('The `attributes` option expects an array of strings.'));
    }

    var _attributes = _slicedToArray(attributes, 1),
        hierarchicalFacetName = _attributes[0];

    function getRefinedState(state, facetValue) {
      if (!facetValue) {
        var breadcrumb = state.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);

        if (breadcrumb.length === 0) {
          return state;
        } else {
          return state.resetPage().toggleFacetRefinement(hierarchicalFacetName, breadcrumb[0]);
        }
      }

      return state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue);
    }

    return {
      $$type: 'ais.breadcrumb',
      init: function init(initOptions) {
        renderFn(connectBreadcrumb_objectSpread(connectBreadcrumb_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(connectBreadcrumb_objectSpread(connectBreadcrumb_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectBreadcrumb_objectSpread(connectBreadcrumb_objectSpread({}, renderState), {}, {
          breadcrumb: connectBreadcrumb_objectSpread(connectBreadcrumb_objectSpread({}, renderState.breadcrumb), {}, connectBreadcrumb_defineProperty({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var helper = _ref2.helper,
            createURL = _ref2.createURL,
            results = _ref2.results,
            state = _ref2.state;

        function getItems() {
          // The hierarchicalFacets condition is required for flavors
          // that render immediately with empty results, without relying
          // on init() (like React InstantSearch Hooks).
          if (!results || state.hierarchicalFacets.length === 0) {
            return [];
          }

          var _state$hierarchicalFa = _slicedToArray(state.hierarchicalFacets, 1),
              facetName = _state$hierarchicalFa[0].name;

          var facetValues = results.getFacetValues(facetName, {});
          var data = Array.isArray(facetValues.data) ? facetValues.data : [];
          var items = transformItems(shiftItemsValues(prepareItems(data)), {
            results: results
          });
          return items;
        }

        var items = getItems();

        if (!connectorState.createURL) {
          connectorState.createURL = function (facetValue) {
            return createURL(getRefinedState(helper.state, facetValue));
          };
        }

        if (!connectorState.refine) {
          connectorState.refine = function (facetValue) {
            helper.setState(getRefinedState(helper.state, facetValue)).search();
          };
        }

        return {
          canRefine: items.length > 0,
          createURL: connectorState.createURL,
          items: items,
          refine: connectorState.refine,
          widgetParams: widgetParams
        };
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters) {
        if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) {
          var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
           false ? 0 : void 0;
          return searchParameters;
        }

        return searchParameters.addHierarchicalFacet({
          name: hierarchicalFacetName,
          attributes: attributes,
          separator: separator,
          rootPath: rootPath
        });
      }
    };
  };
};

function prepareItems(data) {
  return data.reduce(function (result, currentItem) {
    if (currentItem.isRefined) {
      result.push({
        label: currentItem.name,
        value: currentItem.escapedValue
      });

      if (Array.isArray(currentItem.data)) {
        result = result.concat(prepareItems(currentItem.data));
      }
    }

    return result;
  }, []);
}

function shiftItemsValues(array) {
  return array.map(function (x, idx) {
    return {
      label: x.label,
      value: idx + 1 === array.length ? null : array[idx + 1].value
    };
  });
}

/* harmony default export */ var breadcrumb_connectBreadcrumb = (connectBreadcrumb);
;// CONCATENATED MODULE: ./node_modules/mitt/dist/mitt.es.js
/* harmony default export */ function mitt_es(n) {
  return {
    all: n = n || new Map(),
    on: function (t, e) {
      var i = n.get(t);
      i && i.push(e) || n.set(t, [e]);
    },
    off: function (t, e) {
      var i = n.get(t);
      i && i.splice(i.indexOf(e) >>> 0, 1);
    },
    emit: function (t, e) {
      (n.get(t) || []).slice().map(function (n) {
        n(e);
      }), (n.get("*") || []).slice().map(function (n) {
        n(t, e);
      });
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/mixins/panel.js



var panel_e = "instantSearchPanelEmitter",
    panel_n = "PANEL_CHANGE_EVENT",
    i = function () {
  var e;
  return (e = {
    props: {
      emitter: {
        type: Object,
        required: !1,
        default: function () {
          return mitt_es();
        }
      }
    },
    provide: function () {
      var t;
      return (t = {}).instantSearchPanelEmitter = this.emitter, t;
    },
    data: function () {
      return {
        canRefine: !0
      };
    },
    created: function () {
      var t = this;
      this.emitter.on("PANEL_CHANGE_EVENT", function (e) {
        t.updateCanRefine(e);
      });
    }
  }).beforeDestroy = function () {
    this.emitter.all.clear();
  }, e.methods = {
    updateCanRefine: function (t) {
      this.canRefine = t;
    }
  }, e;
},
    r = function (t) {
  var e = t.mapStateToCanRefine;
  return {
    inject: {
      emitter: {
        from: "instantSearchPanelEmitter",
        default: function () {
          return {
            emit: function () {}
          };
        }
      }
    },
    data: function () {
      return {
        state: null,
        hasAlreadyEmitted: !1
      };
    },
    watch: {
      state: {
        immediate: !0,
        handler: function (t, n) {
          if (t) {
            var i = e(n || {}),
                r = e(t);
            this.hasAlreadyEmitted && i === r || (this.emitter.emit("PANEL_CHANGE_EVENT", r), this.hasAlreadyEmitted = !0);
          }
        }
      }
    }
  };
};


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Breadcrumb.vue.js




/* harmony default export */ var Breadcrumb_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state ? s("div", {
      class: [t.suit(), !t.state.canRefine && t.suit("", "noRefinement")]
    }, [t._t("default", [s("ul", {
      class: t.suit("list")
    }, [s("li", {
      class: [t.suit("item"), !t.state.items.length && t.suit("item", "selected")]
    }, [Boolean(t.state.items.length) ? s("a", {
      class: t.suit("link"),
      attrs: {
        href: t.state.createURL()
      },
      on: {
        click: function (e) {
          return e.preventDefault(), t.state.refine();
        }
      }
    }, [t._t("rootLabel", [t._v("Home")])], 2) : s("span", [t._t("rootLabel", [t._v("Home")])], 2)]), t._v(" "), t._l(t.state.items, function (e, a) {
      return s("li", {
        key: e.label,
        class: [t.suit("item"), t.isLastItem(a) && t.suit("item", "selected")]
      }, [s("span", {
        class: t.suit("separator"),
        attrs: {
          "aria-hidden": "true"
        }
      }, [t._t("separator", [t._v(">")])], 2), t._v(" "), t.isLastItem(a) ? s("span", [t._v(t._s(e.label))]) : s("a", {
        class: t.suit("link"),
        attrs: {
          href: t.state.createURL(e.value)
        },
        on: {
          click: function (s) {
            return s.preventDefault(), t.state.refine(e.value);
          }
        }
      }, [t._v(t._s(e.label))])]);
    })], 2)], {
      items: t.state.items,
      canRefine: t.state.canRefine,
      refine: t.state.refine,
      createURL: t.state.createURL
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisBreadcrumb",
  mixins: [widget_e({
    connector: breadcrumb_connectBreadcrumb
  }), r({
    mapStateToCanRefine: function (t) {
      return Boolean(t.canRefine);
    }
  }), suit_t({
    name: "Breadcrumb"
  })],
  props: {
    attributes: {
      type: Array,
      required: !0
    },
    separator: {
      type: String,
      default: void 0
    },
    rootPath: {
      type: String,
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attributes: this.attributes,
        separator: this.separator,
        rootPath: this.rootPath,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    isLastItem: function (t) {
      return this.state.items.length - 1 === t;
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/clearRefinements.js
/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @param {object} $0 parameters
 * @param {Helper} $0.helper instance of the Helper
 * @param {string[]} [$0.attributesToClear = []] list of parameters to clear
 * @returns {SearchParameters} search parameters with refinements cleared
 */
function clearRefinements(_ref) {
  var helper = _ref.helper,
      _ref$attributesToClea = _ref.attributesToClear,
      attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
  var finalState = helper.state.setPage(0);
  finalState = attributesToClear.reduce(function (state, attribute) {
    if (finalState.isNumericRefined(attribute)) {
      return state.removeNumericRefinement(attribute);
    }

    if (finalState.isHierarchicalFacet(attribute)) {
      return state.removeHierarchicalFacetRefinement(attribute);
    }

    if (finalState.isDisjunctiveFacet(attribute)) {
      return state.removeDisjunctiveFacetRefinement(attribute);
    }

    if (finalState.isConjunctiveFacet(attribute)) {
      return state.removeFacetRefinement(attribute);
    }

    return state;
  }, finalState);

  if (attributesToClear.indexOf('query') !== -1) {
    finalState = finalState.setQuery('');
  }

  return finalState;
}

/* harmony default export */ var utils_clearRefinements = (clearRefinements);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/findIndex.js
// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function findIndex_findIndex(array, comparator) {
  if (!Array.isArray(array)) {
    return -1;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return i;
    }
  }

  return -1;
}

/* harmony default export */ var utils_findIndex = (findIndex_findIndex);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/uniq.js
function uniq(array) {
  return array.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

/* harmony default export */ var utils_uniq = (uniq);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/mergeSearchParameters.js
function mergeSearchParameters_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function mergeSearchParameters_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      mergeSearchParameters_ownKeys(Object(source), true).forEach(function (key) {
        mergeSearchParameters_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      mergeSearchParameters_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function mergeSearchParameters_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}




var mergeWithRest = function mergeWithRest(left, right) {
  var facets = right.facets,
      disjunctiveFacets = right.disjunctiveFacets,
      facetsRefinements = right.facetsRefinements,
      facetsExcludes = right.facetsExcludes,
      disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements,
      numericRefinements = right.numericRefinements,
      tagRefinements = right.tagRefinements,
      hierarchicalFacets = right.hierarchicalFacets,
      hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements,
      ruleContexts = right.ruleContexts,
      rest = _objectWithoutProperties(right, ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"]);

  return left.setQueryParameters(rest);
}; // Merge facets


var mergeFacets = function mergeFacets(left, right) {
  return right.facets.reduce(function (_, name) {
    return _.addFacet(name);
  }, left);
};

var mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
  return right.disjunctiveFacets.reduce(function (_, name) {
    return _.addDisjunctiveFacet(name);
  }, left);
};

var mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
  return left.setQueryParameters({
    hierarchicalFacets: right.hierarchicalFacets.reduce(function (facets, facet) {
      var index = utils_findIndex(facets, function (_) {
        return _.name === facet.name;
      });

      if (index === -1) {
        return facets.concat(facet);
      }

      var nextFacets = facets.slice();
      nextFacets.splice(index, 1, facet);
      return nextFacets;
    }, left.hierarchicalFacets)
  });
}; // Merge facet refinements


var mergeTagRefinements = function mergeTagRefinements(left, right) {
  return right.tagRefinements.reduce(function (_, value) {
    return _.addTagRefinement(value);
  }, left);
};

var mergeFacetRefinements = function mergeFacetRefinements(left, right) {
  return left.setQueryParameters({
    facetsRefinements: mergeSearchParameters_objectSpread(mergeSearchParameters_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
  });
};

var mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
  return left.setQueryParameters({
    facetsExcludes: mergeSearchParameters_objectSpread(mergeSearchParameters_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
  });
};

var mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
  return left.setQueryParameters({
    disjunctiveFacetsRefinements: mergeSearchParameters_objectSpread(mergeSearchParameters_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
  });
};

var mergeNumericRefinements = function mergeNumericRefinements(left, right) {
  return left.setQueryParameters({
    numericRefinements: mergeSearchParameters_objectSpread(mergeSearchParameters_objectSpread({}, left.numericRefinements), right.numericRefinements)
  });
};

var mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
  return left.setQueryParameters({
    hierarchicalFacetsRefinements: mergeSearchParameters_objectSpread(mergeSearchParameters_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
  });
};

var mergeRuleContexts = function mergeRuleContexts(left, right) {
  var ruleContexts = utils_uniq([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));

  if (ruleContexts.length > 0) {
    return left.setQueryParameters({
      ruleContexts: ruleContexts
    });
  }

  return left;
};

var mergeSearchParameters_merge = function merge() {
  for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
    parameters[_key] = arguments[_key];
  }

  return parameters.reduce(function (left, right) {
    var hierarchicalFacetsRefinementsMerged = mergeHierarchicalFacetsRefinements(left, right);
    var hierarchicalFacetsMerged = mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
    var tagRefinementsMerged = mergeTagRefinements(hierarchicalFacetsMerged, right);
    var numericRefinementsMerged = mergeNumericRefinements(tagRefinementsMerged, right);
    var disjunctiveFacetsRefinementsMerged = mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
    var facetsExcludesMerged = mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
    var facetRefinementsMerged = mergeFacetRefinements(facetsExcludesMerged, right);
    var disjunctiveFacetsMerged = mergeDisjunctiveFacets(facetRefinementsMerged, right);
    var ruleContextsMerged = mergeRuleContexts(disjunctiveFacetsMerged, right);
    var facetsMerged = mergeFacets(ruleContextsMerged, right);
    return mergeWithRest(facetsMerged, right);
  });
};

/* harmony default export */ var mergeSearchParameters = (mergeSearchParameters_merge);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/find.js
// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function find_find(items, predicate) {
  var value;

  for (var i = 0; i < items.length; i++) {
    value = items[i]; // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {

    if (predicate(value, i, items)) {
      return value;
    }
  }

  return undefined;
}

/* harmony default export */ var utils_find = (find_find);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/escapeFacetValue.js
function unescapeFacetValue(value) {
  if (typeof value === 'string') {
    return value.replace(/^\\-/, '-');
  }

  return value;
}
function escapeFacetValue(value) {
  if (typeof value === 'number' && value < 0 || typeof value === 'string') {
    return String(value).replace(/^-/, '\\-');
  }

  return value;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getRefinements.js



function getRefinement(state, type, attribute, name) {
  var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var res = {
    type: type,
    attribute: attribute,
    name: name,
    escapedValue: escapeFacetValue(name)
  };
  var facet = utils_find(resultsFacets, function (resultsFacet) {
    return resultsFacet.name === attribute;
  });
  var count;

  if (type === 'hierarchical') {
    (function () {
      var facetDeclaration = state.getHierarchicalFacetByName(attribute);
      var nameParts = name.split(facetDeclaration.separator);

      var getFacetRefinement = function getFacetRefinement(facetData) {
        return function (refinementKey) {
          return facetData[refinementKey];
        };
      };

      var _loop = function _loop(i) {
        facet = facet && facet.data && utils_find(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function (refinement) {
          return refinement.name === nameParts[i];
        });
      };

      for (var i = 0; facet !== undefined && i < nameParts.length; ++i) {
        _loop(i);
      }

      count = facet && facet.count;
    })();
  } else {
    count = facet && facet.data && facet.data[res.name];
  }

  if (count !== undefined) {
    res.count = count;
  }

  if (facet && facet.exhaustive !== undefined) {
    res.exhaustive = facet.exhaustive;
  }

  return res;
}

function getRefinements(results, state) {
  var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var refinements = [];
  var _state$facetsRefineme = state.facetsRefinements,
      facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme,
      _state$facetsExcludes = state.facetsExcludes,
      facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes,
      _state$disjunctiveFac = state.disjunctiveFacetsRefinements,
      disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac,
      _state$hierarchicalFa = state.hierarchicalFacetsRefinements,
      hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa,
      _state$numericRefinem = state.numericRefinements,
      numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem,
      _state$tagRefinements = state.tagRefinements,
      tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
  Object.keys(facetsRefinements).forEach(function (attribute) {
    var refinementNames = facetsRefinements[attribute];
    refinementNames.forEach(function (refinementName) {
      refinements.push(getRefinement(state, 'facet', attribute, refinementName, results.facets));
    });
  });
  Object.keys(facetsExcludes).forEach(function (attribute) {
    var refinementNames = facetsExcludes[attribute];
    refinementNames.forEach(function (refinementName) {
      refinements.push({
        type: 'exclude',
        attribute: attribute,
        name: refinementName,
        exclude: true
      });
    });
  });
  Object.keys(disjunctiveFacetsRefinements).forEach(function (attribute) {
    var refinementNames = disjunctiveFacetsRefinements[attribute];
    refinementNames.forEach(function (refinementName) {
      refinements.push(getRefinement(state, 'disjunctive', attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
      // they can be escaped on negative numeric values with `escapeFacetValue`.
      unescapeFacetValue(refinementName), results.disjunctiveFacets));
    });
  });
  Object.keys(hierarchicalFacetsRefinements).forEach(function (attribute) {
    var refinementNames = hierarchicalFacetsRefinements[attribute];
    refinementNames.forEach(function (refinement) {
      refinements.push(getRefinement(state, 'hierarchical', attribute, refinement, results.hierarchicalFacets));
    });
  });
  Object.keys(numericRefinements).forEach(function (attribute) {
    var operators = numericRefinements[attribute];
    Object.keys(operators).forEach(function (operatorOriginal) {
      var operator = operatorOriginal;
      var valueOrValues = operators[operator];
      var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [valueOrValues];
      refinementNames.forEach(function (refinementName) {
        refinements.push({
          type: 'numeric',
          attribute: attribute,
          name: "".concat(refinementName),
          numericValue: refinementName,
          operator: operator
        });
      });
    });
  });
  tagRefinements.forEach(function (refinementName) {
    refinements.push({
      type: 'tag',
      attribute: '_tags',
      name: refinementName
    });
  });

  if (includesQuery && state.query && state.query.trim()) {
    refinements.push({
      attribute: 'query',
      type: 'query',
      name: state.query,
      query: state.query
    });
  }

  return refinements;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/clear-refinements/connectClearRefinements.js


function connectClearRefinements_toConsumableArray(arr) {
  return connectClearRefinements_arrayWithoutHoles(arr) || connectClearRefinements_iterableToArray(arr) || connectClearRefinements_unsupportedIterableToArray(arr) || connectClearRefinements_nonIterableSpread();
}

function connectClearRefinements_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectClearRefinements_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectClearRefinements_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectClearRefinements_arrayLikeToArray(o, minLen);
}

function connectClearRefinements_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectClearRefinements_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectClearRefinements_arrayLikeToArray(arr);
}

function connectClearRefinements_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectClearRefinements_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectClearRefinements_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectClearRefinements_ownKeys(Object(source), true).forEach(function (key) {
        connectClearRefinements_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectClearRefinements_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectClearRefinements_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectClearRefinements_withUsage = createDocumentationMessageGenerator({
  name: 'clear-refinements',
  connector: true
});

var connectClearRefinements = function connectClearRefinements(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectClearRefinements_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        _ref$includedAttribut = _ref.includedAttributes,
        includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut,
        _ref$excludedAttribut = _ref.excludedAttributes,
        excludedAttributes = _ref$excludedAttribut === void 0 ? ['query'] : _ref$excludedAttribut,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) {
      throw new Error(connectClearRefinements_withUsage('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
    }

    var connectorState = {
      refine: utils_noop,
      createURL: function createURL() {
        return '';
      },
      attributesToClear: []
    };

    var cachedRefine = function cachedRefine() {
      return connectorState.refine();
    };

    var cachedCreateURL = function cachedCreateURL() {
      return connectorState.createURL();
    };

    return {
      $$type: 'ais.clearRefinements',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectClearRefinements_objectSpread(connectClearRefinements_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectClearRefinements_objectSpread(connectClearRefinements_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectClearRefinements_objectSpread(connectClearRefinements_objectSpread({}, renderState), {}, {
          clearRefinements: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var createURL = _ref2.createURL,
            scopedResults = _ref2.scopedResults,
            results = _ref2.results;
        connectorState.attributesToClear = scopedResults.reduce(function (attributesToClear, scopedResult) {
          return attributesToClear.concat(getAttributesToClear({
            scopedResult: scopedResult,
            includedAttributes: includedAttributes,
            excludedAttributes: excludedAttributes,
            transformItems: transformItems,
            results: results
          }));
        }, []);

        connectorState.refine = function () {
          connectorState.attributesToClear.forEach(function (_ref3) {
            var indexHelper = _ref3.helper,
                items = _ref3.items;
            indexHelper.setState(utils_clearRefinements({
              helper: indexHelper,
              attributesToClear: items
            })).search();
          });
        };

        connectorState.createURL = function () {
          return createURL(mergeSearchParameters.apply(void 0, connectClearRefinements_toConsumableArray(connectorState.attributesToClear.map(function (_ref4) {
            var indexHelper = _ref4.helper,
                items = _ref4.items;
            return utils_clearRefinements({
              helper: indexHelper,
              attributesToClear: items
            });
          }))));
        };

        var canRefine = connectorState.attributesToClear.some(function (attributeToClear) {
          return attributeToClear.items.length > 0;
        });
        return {
          canRefine: canRefine,
          hasRefinements: canRefine,
          refine: cachedRefine,
          createURL: cachedCreateURL,
          widgetParams: widgetParams
        };
      }
    };
  };
};

function getAttributesToClear(_ref5) {
  var scopedResult = _ref5.scopedResult,
      includedAttributes = _ref5.includedAttributes,
      excludedAttributes = _ref5.excludedAttributes,
      transformItems = _ref5.transformItems,
      results = _ref5.results;
  var includesQuery = includedAttributes.indexOf('query') !== -1 || excludedAttributes.indexOf('query') === -1;
  return {
    helper: scopedResult.helper,
    items: transformItems(utils_uniq(getRefinements(scopedResult.results, scopedResult.helper.state, includesQuery).map(function (refinement) {
      return refinement.attribute;
    }).filter(function (attribute) {
      return (// If the array is empty (default case), we keep all the attributes
        includedAttributes.length === 0 || // Otherwise, only add the specified attributes
        includedAttributes.indexOf(attribute) !== -1
      );
    }).filter(function (attribute) {
      return (// If the query is included, we ignore the default `excludedAttributes = ['query']`
        attribute === 'query' && includesQuery || // Otherwise, ignore the excluded attributes
        excludedAttributes.indexOf(attribute) === -1
      );
    })), {
      results: results
    })
  };
}

/* harmony default export */ var clear_refinements_connectClearRefinements = (connectClearRefinements);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/ClearRefinements.vue.js




/* harmony default export */ var ClearRefinements_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: e.suit()
    }, [e._t("default", [n("button", {
      class: [e.suit("button"), !e.canRefine && e.suit("button", "disabled")],
      attrs: {
        type: "reset",
        disabled: !e.canRefine
      },
      on: {
        click: function (t) {
          return t.preventDefault(), e.state.refine(t);
        }
      }
    }, [e._t("resetLabel", [e._v("Clear refinements")])], 2)], {
      canRefine: e.canRefine,
      refine: e.state.refine,
      createURL: e.state.createURL
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisClearRefinements",
  mixins: [widget_e({
    connector: clear_refinements_connectClearRefinements
  }), r({
    mapStateToCanRefine: function (e) {
      return Boolean(e.hasRefinements);
    }
  }), suit_t({
    name: "ClearRefinements"
  })],
  props: {
    excludedAttributes: {
      type: Array,
      default: void 0
    },
    includedAttributes: {
      type: Array,
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        includedAttributes: this.includedAttributes,
        excludedAttributes: this.excludedAttributes,
        transformItems: this.transformItems
      };
    },
    canRefine: function () {
      return this.state.hasRefinements;
    }
  }
});
// EXTERNAL MODULE: ./node_modules/algoliasearch-helper/index.js
var algoliasearch_helper = __webpack_require__(5731);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/configure/connectConfigure.js


function connectConfigure_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectConfigure_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectConfigure_ownKeys(Object(source), true).forEach(function (key) {
        connectConfigure_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectConfigure_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectConfigure_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



/**
 * Refine the given search parameters.
 */

var connectConfigure_withUsage = createDocumentationMessageGenerator({
  name: 'configure',
  connector: true
});

function getInitialSearchParameters(state, widgetParams) {
  // We leverage the helper internals to remove the `widgetParams` from
  // the state. The function `setQueryParameters` omits the values that
  // are `undefined` on the next state.
  return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function (acc, key) {
    return connectConfigure_objectSpread(connectConfigure_objectSpread({}, acc), {}, connectConfigure_defineProperty({}, key, undefined));
  }, {}));
}

var connectConfigure = function connectConfigure() {
  var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : utils_noop;
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  return function (widgetParams) {
    if (!widgetParams || !utils_isPlainObject(widgetParams.searchParameters)) {
      throw new Error(connectConfigure_withUsage('The `searchParameters` option expects an object.'));
    }

    var connectorState = {};

    function refine(helper) {
      return function (searchParameters) {
        // Merge new `searchParameters` with the ones set from other widgets
        var actualState = getInitialSearchParameters(helper.state, widgetParams);
        var nextSearchParameters = mergeSearchParameters(actualState, new algoliasearch_helper.SearchParameters(searchParameters)); // Update original `widgetParams.searchParameters` to the new refined one

        widgetParams.searchParameters = searchParameters; // Trigger a search with the resolved search parameters

        helper.setState(nextSearchParameters).search();
      };
    }

    return {
      $$type: 'ais.configure',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectConfigure_objectSpread(connectConfigure_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectConfigure_objectSpread(connectConfigure_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref) {
        var state = _ref.state;
        unmountFn();
        return getInitialSearchParameters(state, widgetParams);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        var _renderState$configur;

        var widgetRenderState = this.getWidgetRenderState(renderOptions);
        return connectConfigure_objectSpread(connectConfigure_objectSpread({}, renderState), {}, {
          configure: connectConfigure_objectSpread(connectConfigure_objectSpread({}, widgetRenderState), {}, {
            widgetParams: connectConfigure_objectSpread(connectConfigure_objectSpread({}, widgetRenderState.widgetParams), {}, {
              searchParameters: mergeSearchParameters(new algoliasearch_helper.SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new algoliasearch_helper.SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var helper = _ref2.helper;

        if (!connectorState.refine) {
          connectorState.refine = refine(helper);
        }

        return {
          refine: connectorState.refine,
          widgetParams: widgetParams
        };
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
        var uiState = _ref3.uiState;
        return mergeSearchParameters(state, new algoliasearch_helper.SearchParameters(connectConfigure_objectSpread(connectConfigure_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
      },
      getWidgetUiState: function getWidgetUiState(uiState) {
        return connectConfigure_objectSpread(connectConfigure_objectSpread({}, uiState), {}, {
          configure: connectConfigure_objectSpread(connectConfigure_objectSpread({}, uiState.configure), widgetParams.searchParameters)
        });
      }
    };
  };
};

/* harmony default export */ var configure_connectConfigure = (connectConfigure);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Configure.js




/* harmony default export */ var Configure = ({
  inheritAttrs: !1,
  name: "AisConfigure",
  mixins: [suit_t({
    name: "Configure"
  }), widget_e({
    connector: configure_connectConfigure
  })],
  computed: {
    widgetParams: function () {
      return {
        searchParameters: this.$attrs
      };
    }
  },
  render: o(function (t) {
    var e = this.$scopedSlots.default;
    return this.state && e ? t("div", {
      class: this.suit()
    }, [e({
      refine: this.state.refine,
      searchParameters: this.state.widgetParams.searchParameters
    })]) : null;
  })
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getPropertyByPath.js
function getPropertyByPath(object, path) {
  var parts = Array.isArray(path) ? path : path.split('.');
  return parts.reduce(function (current, key) {
    return current && current[key];
  }, object);
}

/* harmony default export */ var utils_getPropertyByPath = (getPropertyByPath);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/configure-related-items/connectConfigureRelatedItems.js


function connectConfigureRelatedItems_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectConfigureRelatedItems_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectConfigureRelatedItems_ownKeys(Object(source), true).forEach(function (key) {
        connectConfigureRelatedItems_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectConfigureRelatedItems_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectConfigureRelatedItems_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectConfigureRelatedItems_toConsumableArray(arr) {
  return connectConfigureRelatedItems_arrayWithoutHoles(arr) || connectConfigureRelatedItems_iterableToArray(arr) || connectConfigureRelatedItems_unsupportedIterableToArray(arr) || connectConfigureRelatedItems_nonIterableSpread();
}

function connectConfigureRelatedItems_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectConfigureRelatedItems_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectConfigureRelatedItems_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectConfigureRelatedItems_arrayLikeToArray(o, minLen);
}

function connectConfigureRelatedItems_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectConfigureRelatedItems_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectConfigureRelatedItems_arrayLikeToArray(arr);
}

function connectConfigureRelatedItems_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}




var connectConfigureRelatedItems_withUsage = createDocumentationMessageGenerator({
  name: 'configure-related-items',
  connector: true
});

function createOptionalFilter(_ref) {
  var attributeName = _ref.attributeName,
      attributeValue = _ref.attributeValue,
      attributeScore = _ref.attributeScore;
  return "".concat(attributeName, ":").concat(attributeValue, "<score=").concat(attributeScore || 1, ">");
}

var connectConfigureRelatedItems = function connectConfigureRelatedItems(renderFn, unmountFn) {
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        hit = _ref2.hit,
        matchingPatterns = _ref2.matchingPatterns,
        _ref2$transformSearch = _ref2.transformSearchParameters,
        transformSearchParameters = _ref2$transformSearch === void 0 ? function (x) {
      return x;
    } : _ref2$transformSearch;

    if (!hit) {
      throw new Error(connectConfigureRelatedItems_withUsage('The `hit` option is required.'));
    }

    if (!matchingPatterns) {
      throw new Error(connectConfigureRelatedItems_withUsage('The `matchingPatterns` option is required.'));
    }

    var optionalFilters = Object.keys(matchingPatterns).reduce(function (acc, attributeName) {
      var attribute = matchingPatterns[attributeName];
      var attributeValue = utils_getPropertyByPath(hit, attributeName);
      var attributeScore = attribute.score;

      if (Array.isArray(attributeValue)) {
        return [].concat(connectConfigureRelatedItems_toConsumableArray(acc), [attributeValue.map(function (attributeSubValue) {
          return createOptionalFilter({
            attributeName: attributeName,
            attributeValue: attributeSubValue,
            attributeScore: attributeScore
          });
        })]);
      }

      if (typeof attributeValue === 'string') {
        return [].concat(connectConfigureRelatedItems_toConsumableArray(acc), [createOptionalFilter({
          attributeName: attributeName,
          attributeValue: attributeValue,
          attributeScore: attributeScore
        })]);
      }

       false ? 0 : void 0;
      return acc;
    }, []);

    var searchParameters = connectConfigureRelatedItems_objectSpread({}, transformSearchParameters(new algoliasearch_helper.SearchParameters({
      sumOrFiltersScores: true,
      facetFilters: ["objectID:-".concat(hit.objectID)],
      optionalFilters: optionalFilters
    })));

    var makeWidget = configure_connectConfigure(renderFn, unmountFn);
    return connectConfigureRelatedItems_objectSpread(connectConfigureRelatedItems_objectSpread({}, makeWidget({
      searchParameters: searchParameters
    })), {}, {
      $$type: 'ais.configureRelatedItems'
    });
  };
};

/* harmony default export */ var configure_related_items_connectConfigureRelatedItems = (connectConfigureRelatedItems);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/ConfigureRelatedItems.js


/* harmony default export */ var ConfigureRelatedItems = ({
  inheritAttrs: !1,
  name: "AisExperimentalConfigureRelatedItems",
  mixins: [widget_e({
    connector: configure_related_items_connectConfigureRelatedItems
  })],
  props: {
    hit: {
      type: Object,
      required: !0
    },
    matchingPatterns: {
      type: Object,
      required: !0
    },
    transformSearchParameters: {
      type: Function,
      required: !1
    }
  },
  computed: {
    widgetParams: function () {
      return {
        hit: this.hit,
        matchingPatterns: this.matchingPatterns,
        transformSearchParameters: this.transformSearchParameters
      };
    }
  },
  render: function () {
    return null;
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements.js


function connectCurrentRefinements_toConsumableArray(arr) {
  return connectCurrentRefinements_arrayWithoutHoles(arr) || connectCurrentRefinements_iterableToArray(arr) || connectCurrentRefinements_unsupportedIterableToArray(arr) || connectCurrentRefinements_nonIterableSpread();
}

function connectCurrentRefinements_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectCurrentRefinements_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectCurrentRefinements_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectCurrentRefinements_arrayLikeToArray(o, minLen);
}

function connectCurrentRefinements_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectCurrentRefinements_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectCurrentRefinements_arrayLikeToArray(arr);
}

function connectCurrentRefinements_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectCurrentRefinements_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectCurrentRefinements_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectCurrentRefinements_ownKeys(Object(source), true).forEach(function (key) {
        connectCurrentRefinements_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectCurrentRefinements_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectCurrentRefinements_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectCurrentRefinements_withUsage = createDocumentationMessageGenerator({
  name: 'current-refinements',
  connector: true
});

var connectCurrentRefinements = function connectCurrentRefinements(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectCurrentRefinements_withUsage());
  return function (widgetParams) {
    if ((widgetParams || {}).includedAttributes && (widgetParams || {}).excludedAttributes) {
      throw new Error(connectCurrentRefinements_withUsage('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
    }

    var _ref = widgetParams || {},
        includedAttributes = _ref.includedAttributes,
        _ref$excludedAttribut = _ref.excludedAttributes,
        excludedAttributes = _ref$excludedAttribut === void 0 ? ['query'] : _ref$excludedAttribut,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    return {
      $$type: 'ais.currentRefinements',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectCurrentRefinements_objectSpread(connectCurrentRefinements_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectCurrentRefinements_objectSpread(connectCurrentRefinements_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectCurrentRefinements_objectSpread(connectCurrentRefinements_objectSpread({}, renderState), {}, {
          currentRefinements: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var results = _ref2.results,
            scopedResults = _ref2.scopedResults,
            _createURL = _ref2.createURL,
            helper = _ref2.helper;

        function getItems() {
          if (!results) {
            return transformItems(getRefinementsItems({
              results: {},
              helper: helper,
              includedAttributes: includedAttributes,
              excludedAttributes: excludedAttributes
            }), {
              results: results
            });
          }

          return scopedResults.reduce(function (accResults, scopedResult) {
            return accResults.concat(transformItems(getRefinementsItems({
              results: scopedResult.results,
              helper: scopedResult.helper,
              includedAttributes: includedAttributes,
              excludedAttributes: excludedAttributes
            }), {
              results: results
            }));
          }, []);
        }

        var items = getItems();
        return {
          items: items,
          canRefine: items.length > 0,
          refine: function refine(refinement) {
            return clearRefinement(helper, refinement);
          },
          createURL: function createURL(refinement) {
            return _createURL(clearRefinementFromState(helper.state, refinement));
          },
          widgetParams: widgetParams
        };
      }
    };
  };
};

function getRefinementsItems(_ref3) {
  var results = _ref3.results,
      helper = _ref3.helper,
      includedAttributes = _ref3.includedAttributes,
      excludedAttributes = _ref3.excludedAttributes;
  var includesQuery = (includedAttributes || []).indexOf('query') !== -1 || (excludedAttributes || []).indexOf('query') === -1;
  var filterFunction = includedAttributes ? function (item) {
    return includedAttributes.indexOf(item.attribute) !== -1;
  } : function (item) {
    return excludedAttributes.indexOf(item.attribute) === -1;
  };
  var items = getRefinements(results, helper.state, includesQuery).map(normalizeRefinement).filter(filterFunction);
  return items.reduce(function (allItems, currentItem) {
    return [].concat(connectCurrentRefinements_toConsumableArray(allItems.filter(function (item) {
      return item.attribute !== currentItem.attribute;
    })), [{
      indexName: helper.state.index,
      attribute: currentItem.attribute,
      label: currentItem.attribute,
      refinements: items.filter(function (result) {
        return result.attribute === currentItem.attribute;
      }) // We want to keep the order of refinements except the numeric ones.
      .sort(function (a, b) {
        return a.type === 'numeric' ? a.value - b.value : 0;
      }),
      refine: function refine(refinement) {
        return clearRefinement(helper, refinement);
      }
    }]);
  }, []);
}

function clearRefinementFromState(state, refinement) {
  switch (refinement.type) {
    case 'facet':
      return state.removeFacetRefinement(refinement.attribute, String(refinement.value));

    case 'disjunctive':
      return state.removeDisjunctiveFacetRefinement(refinement.attribute, String(refinement.value));

    case 'hierarchical':
      return state.removeHierarchicalFacetRefinement(refinement.attribute);

    case 'exclude':
      return state.removeExcludeRefinement(refinement.attribute, String(refinement.value));

    case 'numeric':
      return state.removeNumericRefinement(refinement.attribute, refinement.operator, String(refinement.value));

    case 'tag':
      return state.removeTagRefinement(String(refinement.value));

    case 'query':
      return state.setQueryParameter('query', '');

    default:
       false ? 0 : void 0;
      return state;
  }
}

function clearRefinement(helper, refinement) {
  helper.setState(clearRefinementFromState(helper.state, refinement)).search();
}

function getOperatorSymbol(operator) {
  switch (operator) {
    case '>=':
      return '≥';

    case '<=':
      return '≤';

    default:
      return operator;
  }
}

function normalizeRefinement(refinement) {
  var value = getValue(refinement);
  var label = refinement.operator ? "".concat(getOperatorSymbol(refinement.operator), " ").concat(refinement.name) : refinement.name;
  var normalizedRefinement = {
    attribute: refinement.attribute,
    type: refinement.type,
    value: value,
    label: label
  };

  if (refinement.operator !== undefined) {
    normalizedRefinement.operator = refinement.operator;
  }

  if (refinement.count !== undefined) {
    normalizedRefinement.count = refinement.count;
  }

  if (refinement.exhaustive !== undefined) {
    normalizedRefinement.exhaustive = refinement.exhaustive;
  }

  return normalizedRefinement;
}

function getValue(refinement) {
  if (refinement.type === 'numeric') {
    return Number(refinement.name);
  }

  if ('escapedValue' in refinement) {
    return refinement.escapedValue;
  }

  return refinement.name;
}

/* harmony default export */ var current_refinements_connectCurrentRefinements = (connectCurrentRefinements);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/CurrentRefinements.vue.js




/* harmony default export */ var CurrentRefinements_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        i = e._self._c || t;
    return e.state ? i("div", {
      class: [e.suit(), e.noRefinement && e.suit("", "noRefinement")]
    }, [e._t("default", [i("ul", {
      class: e.suit("list")
    }, e._l(e.state.items, function (t) {
      return i("li", {
        key: t.attribute,
        class: e.suit("item")
      }, [e._t("item", [i("span", {
        class: e.suit("label")
      }, [e._v(e._s(e.capitalize(t.label)) + ": ")]), e._v(" "), e._l(t.refinements, function (n) {
        return i("span", {
          key: e.createItemKey(n),
          class: e.suit("category")
        }, [e._t("refinement", [i("span", {
          class: e.suit("categoryLabel")
        }, ["query" === n.attribute ? i("q", [e._v(e._s(n.label))]) : [e._v(" " + e._s(n.label) + " ")]], 2), e._v(" "), i("button", {
          class: e.suit("delete"),
          on: {
            click: function (e) {
              return t.refine(n);
            }
          }
        }, [e._v(" ✕ ")])], {
          refine: t.refine,
          refinement: n,
          createURL: e.state.createURL
        })], 2);
      })], {
        refine: t.refine,
        item: t,
        createURL: e.state.createURL
      })], 2);
    }), 0)], {
      refine: e.state.refine,
      items: e.state.items,
      createURL: e.state.createURL
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisCurrentRefinements",
  mixins: [suit_t({
    name: "CurrentRefinements"
  }), widget_e({
    connector: current_refinements_connectCurrentRefinements
  }), r({
    mapStateToCanRefine: function (e) {
      return Boolean(e.items) && e.items.length > 0;
    }
  })],
  props: {
    includedAttributes: {
      type: Array,
      default: void 0
    },
    excludedAttributes: {
      type: Array,
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    noRefinement: function () {
      return this.state && 0 === this.state.items.length;
    },
    widgetParams: function () {
      return {
        includedAttributes: this.includedAttributes,
        excludedAttributes: this.excludedAttributes,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    createItemKey: function (e) {
      var t = e.attribute,
          i = e.value;
      return [t, e.type, i, e.operator].join(":");
    },
    capitalize: function (e) {
      return e ? e.toString().charAt(0).toLocaleUpperCase() + e.toString().slice(1) : "";
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/isFacetRefined.js
function isFacetRefined(helper, facet, value) {
  if (helper.state.isHierarchicalFacet(facet)) {
    return helper.state.isHierarchicalFacetRefined(facet, value);
  } else if (helper.state.isConjunctiveFacet(facet)) {
    return helper.state.isFacetRefined(facet, value);
  } else {
    return helper.state.isDisjunctiveFacetRefined(facet, value);
  }
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/createSendEventForFacet.js


function createSendEventForFacet_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    createSendEventForFacet_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    createSendEventForFacet_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return createSendEventForFacet_typeof(obj);
}


function createSendEventForFacet(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
      helper = _ref.helper,
      attribute = _ref.attribute,
      widgetType = _ref.widgetType;

  var sendEventForFacet = function sendEventForFacet() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var eventType = args[0],
        facetValue = args[1],
        _args$ = args[2],
        eventName = _args$ === void 0 ? 'Filter Applied' : _args$;

    if (args.length === 1 && createSendEventForFacet_typeof(args[0]) === 'object') {
      instantSearchInstance.sendEventToInsights(args[0]);
    } else if (eventType === 'click' && (args.length === 2 || args.length === 3)) {
      if (!isFacetRefined(helper, attribute, facetValue)) {
        // send event only when the facet is being checked "ON"
        instantSearchInstance.sendEventToInsights({
          insightsMethod: 'clickedFilters',
          widgetType: widgetType,
          eventType: eventType,
          payload: {
            eventName: eventName,
            index: helper.getIndex(),
            filters: ["".concat(attribute, ":").concat(facetValue)]
          },
          attribute: attribute
        });
      }
    } else if (false) {}
  };

  return sendEventForFacet;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu.js


function connectHierarchicalMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectHierarchicalMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectHierarchicalMenu_ownKeys(Object(source), true).forEach(function (key) {
        connectHierarchicalMenu_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectHierarchicalMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectHierarchicalMenu_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectHierarchicalMenu_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = connectHierarchicalMenu_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function connectHierarchicalMenu_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function connectHierarchicalMenu_slicedToArray(arr, i) {
  return connectHierarchicalMenu_arrayWithHoles(arr) || connectHierarchicalMenu_iterableToArrayLimit(arr, i) || connectHierarchicalMenu_unsupportedIterableToArray(arr, i) || connectHierarchicalMenu_nonIterableRest();
}

function connectHierarchicalMenu_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectHierarchicalMenu_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectHierarchicalMenu_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectHierarchicalMenu_arrayLikeToArray(o, minLen);
}

function connectHierarchicalMenu_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectHierarchicalMenu_iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function connectHierarchicalMenu_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


var connectHierarchicalMenu_withUsage = createDocumentationMessageGenerator({
  name: 'hierarchical-menu',
  connector: true
});
var DEFAULT_SORT = ['name:asc'];
/**
 * **HierarchicalMenu** connector provides the logic to build a custom widget
 * that will give the user the ability to explore facets in a tree-like structure.
 *
 * This is commonly used for multi-level categorization of products on e-commerce
 * websites. From a UX point of view, we suggest not displaying more than two
 * levels deep.
 *
 * @type {Connector}
 * @param {function(HierarchicalMenuRenderingOptions, boolean)} renderFn Rendering function for the custom **HierarchicalMenu** widget.
 * @param {function} unmountFn Unmount function called when the widget is disposed.
 * @return {function(CustomHierarchicalMenuWidgetParams)} Re-usable widget factory for a custom **HierarchicalMenu** widget.
 */

var connectHierarchicalMenu = function connectHierarchicalMenu(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectHierarchicalMenu_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        attributes = _ref.attributes,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? ' > ' : _ref$separator,
        _ref$rootPath = _ref.rootPath,
        rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath,
        _ref$showParentLevel = _ref.showParentLevel,
        showParentLevel = _ref$showParentLevel === void 0 ? true : _ref$showParentLevel,
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? 10 : _ref$limit,
        _ref$showMore = _ref.showMore,
        showMore = _ref$showMore === void 0 ? false : _ref$showMore,
        _ref$showMoreLimit = _ref.showMoreLimit,
        showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit,
        _ref$sortBy = _ref.sortBy,
        sortBy = _ref$sortBy === void 0 ? DEFAULT_SORT : _ref$sortBy,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
      throw new Error(connectHierarchicalMenu_withUsage('The `attributes` option expects an array of strings.'));
    }

    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(connectHierarchicalMenu_withUsage('The `showMoreLimit` option must be greater than `limit`.'));
    } // we need to provide a hierarchicalFacet name for the search state
    // so that we can always map $hierarchicalFacetName => real attributes
    // we use the first attribute name


    var _attributes = connectHierarchicalMenu_slicedToArray(attributes, 1),
        hierarchicalFacetName = _attributes[0];

    var sendEvent; // Provide the same function to the `renderFn` so that way the user
    // has to only bind it once when `isFirstRendering` for instance

    var toggleShowMore = function toggleShowMore() {};

    function cachedToggleShowMore() {
      toggleShowMore();
    }

    var _refine;

    var isShowingMore = false;

    function createToggleShowMore(renderOptions, widget) {
      return function () {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }

    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }

    function _prepareFacetValues(facetValues) {
      return facetValues.slice(0, getLimit()).map(function (_ref2) {
        var label = _ref2.name,
            value = _ref2.escapedValue,
            data = _ref2.data,
            path = _ref2.path,
            subValue = connectHierarchicalMenu_objectWithoutProperties(_ref2, ["name", "escapedValue", "data", "path"]);

        var item = connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, subValue), {}, {
          value: value,
          label: label,
          data: null
        });

        if (Array.isArray(data)) {
          item.data = _prepareFacetValues(data);
        }

        return item;
      });
    }

    return {
      $$type: 'ais.hierarchicalMenu',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        toggleShowMore = createToggleShowMore(renderOptions, this);
        renderFn(connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref3) {
        var state = _ref3.state;
        unmountFn();
        return state.removeHierarchicalFacet(hierarchicalFacetName).setQueryParameter('maxValuesPerFacet', undefined);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, renderState), {}, {
          hierarchicalMenu: connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, renderState.hierarchicalMenu), {}, connectHierarchicalMenu_defineProperty({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref4) {
        var results = _ref4.results,
            state = _ref4.state,
            createURL = _ref4.createURL,
            instantSearchInstance = _ref4.instantSearchInstance,
            helper = _ref4.helper;
        var items = [];
        var canToggleShowMore = false; // Bind createURL to this specific attribute

        function _createURL(facetValue) {
          return createURL(state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue));
        }

        if (!sendEvent) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            attribute: hierarchicalFacetName,
            widgetType: this.$$type
          });
        }

        if (!_refine) {
          _refine = function _refine(facetValue) {
            sendEvent('click', facetValue);
            helper.toggleFacetRefinement(hierarchicalFacetName, facetValue).search();
          };
        }

        if (results) {
          var facetValues = results.getFacetValues(hierarchicalFacetName, {
            sortBy: sortBy,
            facetOrdering: sortBy === DEFAULT_SORT
          });
          var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : []; // If the limit is the max number of facet retrieved it is impossible to know
          // if the facets are exhaustive. The only moment we are sure it is exhaustive
          // is when it is strictly under the number requested unless we know that another
          // widget has requested more values (maxValuesPerFacet > getLimit()).
          // Because this is used for making the search of facets unable or not, it is important
          // to be conservative here.

          var hasExhaustiveItems = (state.maxValuesPerFacet || 0) > getLimit() ? facetItems.length <= getLimit() : facetItems.length < getLimit();
          canToggleShowMore = showMore && (isShowingMore || !hasExhaustiveItems);
          items = transformItems(_prepareFacetValues(facetItems), {
            results: results
          });
        }

        return {
          items: items,
          refine: _refine,
          canRefine: items.length > 0,
          createURL: _createURL,
          sendEvent: sendEvent,
          widgetParams: widgetParams,
          isShowingMore: isShowingMore,
          toggleShowMore: cachedToggleShowMore,
          canToggleShowMore: canToggleShowMore
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        var path = searchParameters.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);

        if (!path.length) {
          return uiState;
        }

        return connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, uiState), {}, {
          hierarchicalMenu: connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, uiState.hierarchicalMenu), {}, connectHierarchicalMenu_defineProperty({}, hierarchicalFacetName, path))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
        var uiState = _ref6.uiState;
        var values = uiState.hierarchicalMenu && uiState.hierarchicalMenu[hierarchicalFacetName];

        if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) {
          var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
           false ? 0 : void 0;
        }

        var withFacetConfiguration = searchParameters.removeHierarchicalFacet(hierarchicalFacetName).addHierarchicalFacet({
          name: hierarchicalFacetName,
          attributes: attributes,
          separator: separator,
          rootPath: rootPath,
          showParentLevel: showParentLevel
        });
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);

        if (!values) {
          return withMaxValuesPerFacet.setQueryParameters({
            hierarchicalFacetsRefinements: connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, connectHierarchicalMenu_defineProperty({}, hierarchicalFacetName, []))
          });
        }

        return withMaxValuesPerFacet.addHierarchicalFacetRefinement(hierarchicalFacetName, values.join(separator));
      }
    };
  };
};

/* harmony default export */ var hierarchical_menu_connectHierarchicalMenu = (connectHierarchicalMenu);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/HierarchicalMenuList.vue.js
/* harmony default export */ var HierarchicalMenuList_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        i = e._self._c || t;
    return i("ul", {
      class: [e.suit("list"), e.level > 0 && e.suit("list", "child"), e.suit("list", "lvl" + e.level)]
    }, e._l(e.items, function (t) {
      return i("li", {
        key: t.value,
        class: [e.suit("item"), t.data && e.suit("item", "parent"), t.isRefined && e.suit("item", "selected")]
      }, [i("a", {
        class: e.suit("link"),
        attrs: {
          href: e.createURL(t.value)
        },
        on: {
          click: function (i) {
            return i.preventDefault(), e.refine(t.value);
          }
        }
      }, [i("span", {
        class: e.suit("label")
      }, [e._v(e._s(t.label))]), e._v(" "), i("span", {
        class: e.suit("count")
      }, [e._v(e._s(t.count))])]), e._v(" "), t.data ? i("hierarchical-menu-list", {
        attrs: {
          items: t.data,
          level: e.level + 1,
          refine: e.refine,
          createURL: e.createURL,
          suit: e.suit
        }
      }) : e._e()], 1);
    }), 0);
  },
  staticRenderFns: [],
  name: "HierarchicalMenuList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    level: {
      type: Number,
      required: !0
    },
    refine: {
      type: Function,
      required: !0
    },
    createURL: {
      type: Function,
      required: !0
    },
    suit: {
      type: Function,
      required: !0
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/HierarchicalMenu.vue.js






var HierarchicalMenu_vue_r = function (e) {
  return Boolean(e.items) && e.items.length > 0;
};

/* harmony default export */ var HierarchicalMenu_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        o = e._self._c || t;
    return e.state ? o("div", {
      class: [e.suit(), !e.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", [o("hierarchical-menu-list", {
      attrs: {
        items: e.state.items,
        level: 0,
        refine: e.state.refine,
        createURL: e.state.createURL,
        suit: e.suit
      }
    }), e._v(" "), e.showMore ? o("button", {
      class: [e.suit("showMore"), !e.state.canToggleShowMore && e.suit("showMore", "disabled")],
      attrs: {
        disabled: !e.state.canToggleShowMore
      },
      on: {
        click: function (t) {
          return t.preventDefault(), e.state.toggleShowMore(t);
        }
      }
    }, [e._t("showMoreLabel", [e._v(e._s(e.state.isShowingMore ? "Show less" : "Show more"))], {
      isShowingMore: e.state.isShowingMore
    })], 2) : e._e()], {
      items: e.state.items,
      canRefine: e.canRefine,
      canToggleShowMore: e.state.canToggleShowMore,
      isShowingMore: e.state.isShowingMore,
      refine: e.state.refine,
      createURL: e.state.createURL,
      toggleShowMore: e.state.toggleShowMore,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisHierarchicalMenu",
  mixins: [suit_t({
    name: "HierarchicalMenu"
  }), widget_e({
    connector: hierarchical_menu_connectHierarchicalMenu
  }), r({
    mapStateToCanRefine: HierarchicalMenu_vue_r
  })],
  components: {
    HierarchicalMenuList: HierarchicalMenuList_vue
  },
  props: {
    attributes: {
      type: Array,
      required: !0
    },
    limit: {
      type: Number,
      default: void 0
    },
    showMoreLimit: {
      type: Number,
      default: void 0
    },
    showMore: {
      type: Boolean,
      default: !1
    },
    sortBy: {
      type: [Array, Function],
      default: void 0
    },
    separator: {
      type: String,
      default: void 0
    },
    rootPath: {
      type: String,
      default: void 0
    },
    showParentLevel: {
      type: Boolean,
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attributes: this.attributes,
        limit: this.limit,
        showMore: this.showMore,
        showMoreLimit: this.showMoreLimit,
        separator: this.separator,
        rootPath: this.rootPath,
        showParentLevel: this.showParentLevel,
        sortBy: this.sortBy,
        transformItems: this.transformItems
      };
    },
    canRefine: function () {
      return HierarchicalMenu_vue_r(this.state);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/unescape.js
var unescape_t = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
},
    unescape_e = /&(?:amp|lt|gt|quot|#39);/g,
    unescape_r = RegExp(unescape_e.source);

function unescape_u(u) {
  return u && unescape_r.test(u) ? u.replace(unescape_e, function (e) {
    return unescape_t[e];
  }) : u;
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/parseAlgoliaHit.js



var parseAlgoliaHit_t = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
};

function parseAlgoliaHit_r(i) {
  var h = i.preTag,
      t = i.postTag,
      r = i.highlightedValue;
  void 0 === r && (r = "");
  var a = r.split(h),
      g = a.shift(),
      e = "" === g ? [] : [{
    value: g,
    isHighlighted: !1
  }];

  if (t === h) {
    var s = !0;
    a.forEach(function (i) {
      e.push({
        value: i,
        isHighlighted: s
      }), s = !s;
    });
  } else a.forEach(function (i) {
    var h = i.split(t);
    e.push({
      value: h[0],
      isHighlighted: !0
    }), "" !== h[1] && e.push({
      value: " " === h[1] ? "  " : h[1],
      isHighlighted: !1
    });
  });

  return e;
}

function parseAlgoliaHit_a(a) {
  var g = a.preTag;
  void 0 === g && (g = parseAlgoliaHit_t.highlightPreTag);
  var e = a.postTag;
  void 0 === e && (e = parseAlgoliaHit_t.highlightPostTag);
  var s = a.highlightProperty,
      l = a.attribute,
      o = a.hit;
  if (!o) throw new Error("`hit`, the matching record, must be provided");
  var u = utils_getPropertyByPath(o[s], l) || {};
  return Array.isArray(u) ? u.map(function (i) {
    return parseAlgoliaHit_r({
      preTag: g,
      postTag: e,
      highlightedValue: unescape_u(i.value)
    });
  }) : parseAlgoliaHit_r({
    preTag: g,
    postTag: e,
    highlightedValue: unescape_u(u.value)
  });
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Highlighter.vue.js


var Highlighter_vue_e = {
  functional: !0,
  render: function (t, e) {
    return e.slots().default;
  }
};
/* harmony default export */ var Highlighter_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        i = t._self._c || e;
    return i("span", {
      class: t.suit()
    }, t._l(t.parsedHighlights, function (e, r) {
      var a = e.value,
          g = e.isHighlighted;
      return i(g ? t.highlightedTagName : t.TextNode, {
        key: r,
        tag: "component",
        class: [g && t.suit("highlighted")]
      }, [t._v(t._s(a))]);
    }), 1);
  },
  staticRenderFns: [],
  name: "AisHighlighter",
  props: {
    hit: {
      type: Object,
      required: !0
    },
    attribute: {
      type: String,
      required: !0
    },
    highlightedTagName: {
      type: String,
      default: "mark"
    },
    suit: {
      type: Function,
      required: !0
    },
    highlightProperty: {
      type: String,
      required: !0
    },
    preTag: {
      type: String,
      required: !0
    },
    postTag: {
      type: String,
      required: !0
    }
  },
  data: function () {
    return {
      TextNode: Highlighter_vue_e
    };
  },
  computed: {
    parsedHighlights: function () {
      return parseAlgoliaHit_a({
        attribute: this.attribute,
        hit: this.hit,
        highlightProperty: this.highlightProperty,
        preTag: this.preTag,
        postTag: this.postTag
      });
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Highlight.vue.js


/* harmony default export */ var Highlight_vue = ({
  render: function () {
    var t = this.$createElement;
    return (this._self._c || t)("ais-highlighter", {
      attrs: {
        hit: this.hit,
        attribute: this.attribute,
        "highlighted-tag-name": this.highlightedTagName,
        suit: this.suit,
        "highlight-property": "_highlightResult",
        "pre-tag": "<mark>",
        "post-tag": "</mark>"
      }
    });
  },
  staticRenderFns: [],
  name: "AisHighlight",
  mixins: [suit_t({
    name: "Highlight"
  })],
  components: {
    AisHighlighter: Highlighter_vue
  },
  props: {
    hit: {
      type: Object,
      required: !0
    },
    attribute: {
      type: String,
      required: !0
    },
    highlightedTagName: {
      type: String,
      default: "mark"
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/insights/client.js


function client_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function client_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      client_ownKeys(Object(source), true).forEach(function (key) {
        client_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      client_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function client_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
  return selectedObjectIDs.map(function (objectID) {
    var hit = utils_find(hits, function (h) {
      return h.objectID === objectID;
    });

    if (typeof hit === 'undefined') {
      throw new Error("Could not find objectID \"".concat(objectID, "\" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID."));
    }

    return hit;
  });
};

var getQueryID = function getQueryID(selectedHits) {
  var queryIDs = utils_uniq(selectedHits.map(function (hit) {
    return hit.__queryID;
  }));

  if (queryIDs.length > 1) {
    throw new Error('Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.');
  }

  var queryID = queryIDs[0];

  if (typeof queryID !== 'string') {
    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
  }

  return queryID;
};

var getPositions = function getPositions(selectedHits) {
  return selectedHits.map(function (hit) {
    return hit.__position;
  });
};

var inferPayload = function inferPayload(_ref) {
  var method = _ref.method,
      results = _ref.results,
      hits = _ref.hits,
      objectIDs = _ref.objectIDs;
  var index = results.index;
  var selectedHits = getSelectedHits(hits, objectIDs);
  var queryID = getQueryID(selectedHits);

  switch (method) {
    case 'clickedObjectIDsAfterSearch':
      {
        var positions = getPositions(selectedHits);
        return {
          index: index,
          queryID: queryID,
          objectIDs: objectIDs,
          positions: positions
        };
      }

    case 'convertedObjectIDsAfterSearch':
      return {
        index: index,
        queryID: queryID,
        objectIDs: objectIDs
      };

    default:
      throw new Error("Unsupported method passed to insights: \"".concat(method, "\"."));
  }
};

var wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
  return function (method) {
    for (var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      payloads[_key - 1] = arguments[_key];
    }

    var payload = payloads[0];
     false ? 0 : void 0;

    if (!aa) {
      var withInstantSearchUsage = createDocumentationMessageGenerator({
        name: 'instantsearch'
      });
      throw new Error(withInstantSearchUsage('The `insightsClient` option has not been provided to `instantsearch`.'));
    }

    if (!Array.isArray(payload.objectIDs)) {
      throw new TypeError('Expected `objectIDs` to be an array.');
    }

    var inferredPayload = inferPayload({
      method: method,
      results: results,
      hits: hits,
      objectIDs: payload.objectIDs
    });
    aa(method, client_objectSpread(client_objectSpread({}, inferredPayload), payload));
  };
};
/**
 * @deprecated This function will be still supported in 4.x releases, but not further. It is replaced by the `insights` middleware. For more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/
 * It passes `insights` to `HitsWithInsightsListener` and `InfiniteHitsWithInsightsListener`.
 */


function withInsights(connector) {
  return function (renderFn, unmountFn) {
    return connector(function (renderOptions, isFirstRender) {
      var results = renderOptions.results,
          hits = renderOptions.hits,
          instantSearchInstance = renderOptions.instantSearchInstance;

      if (results && hits && instantSearchInstance) {
        var insights = wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
        return renderFn(client_objectSpread(client_objectSpread({}, renderOptions), {}, {
          insights: insights
        }), isFirstRender);
      }

      return renderFn(renderOptions, isFirstRender);
    }, unmountFn);
  };
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/hits-absolute-position.js
function hits_absolute_position_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function hits_absolute_position_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      hits_absolute_position_ownKeys(Object(source), true).forEach(function (key) {
        hits_absolute_position_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      hits_absolute_position_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function hits_absolute_position_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function addAbsolutePosition(hits, page, hitsPerPage) {
  return hits.map(function (hit, idx) {
    return hits_absolute_position_objectSpread(hits_absolute_position_objectSpread({}, hit), {}, {
      __position: hitsPerPage * page + idx + 1
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/hits-query-id.js
function hits_query_id_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function hits_query_id_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      hits_query_id_ownKeys(Object(source), true).forEach(function (key) {
        hits_query_id_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      hits_query_id_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function hits_query_id_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function addQueryID(hits, queryID) {
  if (!queryID) {
    return hits;
  }

  return hits.map(function (hit) {
    return hits_query_id_objectSpread(hits_query_id_objectSpread({}, hit), {}, {
      __queryID: queryID
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/hits/connectHits.js
function connectHits_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectHits_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectHits_ownKeys(Object(source), true).forEach(function (key) {
        connectHits_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectHits_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectHits_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectHits_withUsage = createDocumentationMessageGenerator({
  name: 'hits',
  connector: true
});

var connectHits = function connectHits(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectHits_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        _ref$escapeHTML = _ref.escapeHTML,
        escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    var sendEvent;
    var bindEvent;
    return {
      $$type: 'ais.hits',
      init: function init(initOptions) {
        renderFn(connectHits_objectSpread(connectHits_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(connectHits_objectSpread(connectHits_objectSpread({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
        renderState.sendEvent('view', renderState.hits);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectHits_objectSpread(connectHits_objectSpread({}, renderState), {}, {
          hits: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var results = _ref2.results,
            helper = _ref2.helper,
            instantSearchInstance = _ref2.instantSearchInstance;

        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance: instantSearchInstance,
            index: helper.getIndex(),
            widgetType: this.$$type
          });
        }

        if (!bindEvent) {
          bindEvent = createBindEventForHits({
            index: helper.getIndex(),
            widgetType: this.$$type
          });
        }

        if (!results) {
          return {
            hits: [],
            results: undefined,
            sendEvent: sendEvent,
            bindEvent: bindEvent,
            widgetParams: widgetParams
          };
        }

        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }

        var hitsWithAbsolutePosition = addAbsolutePosition(results.hits, results.page, results.hitsPerPage);
        var hitsWithAbsolutePositionAndQueryID = addQueryID(hitsWithAbsolutePosition, results.queryID);
        var transformedHits = transformItems(hitsWithAbsolutePositionAndQueryID, {
          results: results
        });
        return {
          hits: transformedHits,
          results: results,
          sendEvent: sendEvent,
          bindEvent: bindEvent,
          widgetParams: widgetParams
        };
      },
      dispose: function dispose(_ref3) {
        var state = _ref3.state;
        unmountFn();

        if (!escapeHTML) {
          return state;
        }

        return state.setQueryParameters(Object.keys(TAG_PLACEHOLDER).reduce(function (acc, key) {
          return connectHits_objectSpread(connectHits_objectSpread({}, acc), {}, connectHits_defineProperty({}, key, undefined));
        }, {}));
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state) {
        if (!escapeHTML) {
          return state;
        }

        return state.setQueryParameters(TAG_PLACEHOLDER);
      }
    };
  };
};

/* harmony default export */ var hits_connectHits = (connectHits);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/hits/connectHitsWithInsights.js


var connectHitsWithInsights = withInsights(hits_connectHits);
/* harmony default export */ var hits_connectHitsWithInsights = (connectHitsWithInsights);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Hits.vue.js



/* harmony default export */ var Hits_vue = ({
  render: function () {
    var t = this,
        s = t.$createElement,
        e = t._self._c || s;
    return t.state ? e("div", {
      class: t.suit()
    }, [t._t("default", [e("ol", {
      class: t.suit("list")
    }, t._l(t.items, function (s, i) {
      return e("li", {
        key: s.objectID,
        class: t.suit("item")
      }, [t._t("item", [t._v("objectID: " + t._s(s.objectID) + ", index: " + t._s(i))], {
        item: s,
        index: i,
        insights: t.state.insights
      })], 2);
    }), 0)], {
      items: t.items,
      insights: t.state.insights,
      sendEvent: t.state.sendEvent
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisHits",
  mixins: [widget_e({
    connector: hits_connectHitsWithInsights
  }), suit_t({
    name: "Hits"
  })],
  props: {
    escapeHTML: {
      type: Boolean,
      default: !0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    items: function () {
      return this.state.hits;
    },
    widgetParams: function () {
      return {
        escapeHTML: this.escapeHTML,
        transformItems: this.transformItems
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/hits-per-page/connectHitsPerPage.js


function connectHitsPerPage_toConsumableArray(arr) {
  return connectHitsPerPage_arrayWithoutHoles(arr) || connectHitsPerPage_iterableToArray(arr) || connectHitsPerPage_unsupportedIterableToArray(arr) || connectHitsPerPage_nonIterableSpread();
}

function connectHitsPerPage_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectHitsPerPage_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectHitsPerPage_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectHitsPerPage_arrayLikeToArray(o, minLen);
}

function connectHitsPerPage_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectHitsPerPage_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectHitsPerPage_arrayLikeToArray(arr);
}

function connectHitsPerPage_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectHitsPerPage_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectHitsPerPage_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectHitsPerPage_ownKeys(Object(source), true).forEach(function (key) {
        connectHitsPerPage_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectHitsPerPage_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectHitsPerPage_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectHitsPerPage_withUsage = createDocumentationMessageGenerator({
  name: 'hits-per-page',
  connector: true
});

var connectHitsPerPage = function connectHitsPerPage(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectHitsPerPage_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        userItems = _ref.items,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (!Array.isArray(userItems)) {
      throw new Error(connectHitsPerPage_withUsage('The `items` option expects an array of objects.'));
    }

    var items = userItems;
    var defaultItems = items.filter(function (item) {
      return item.default === true;
    });

    if (defaultItems.length === 0) {
      throw new Error(connectHitsPerPage_withUsage("A default value must be specified in `items`."));
    }

    if (defaultItems.length > 1) {
      throw new Error(connectHitsPerPage_withUsage('More than one default value is specified in `items`.'));
    }

    var defaultItem = defaultItems[0];

    var normalizeItems = function normalizeItems(_ref2) {
      var hitsPerPage = _ref2.hitsPerPage;
      return items.map(function (item) {
        return connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, item), {}, {
          isRefined: Number(item.value) === Number(hitsPerPage)
        });
      });
    };

    var connectorState = {
      getRefine: function getRefine(helper) {
        return function (value) {
          return !value && value !== 0 ? helper.setQueryParameter('hitsPerPage', undefined).search() : helper.setQueryParameter('hitsPerPage', value).search();
        };
      },
      createURLFactory: function createURLFactory(_ref3) {
        var state = _ref3.state,
            createURL = _ref3.createURL;
        return function (value) {
          return createURL(state.resetPage().setQueryParameter('hitsPerPage', !value && value !== 0 ? undefined : value));
        };
      }
    };
    return {
      $$type: 'ais.hitsPerPage',
      init: function init(initOptions) {
        var state = initOptions.state,
            instantSearchInstance = initOptions.instantSearchInstance;
        var isCurrentInOptions = items.some(function (item) {
          return Number(state.hitsPerPage) === Number(item.value);
        });

        if (!isCurrentInOptions) {
           false ? 0 : void 0;
           false ? 0 : void 0;
          items = [// The helper will convert the empty string to `undefined`.
          {
            value: '',
            label: ''
          }].concat(connectHitsPerPage_toConsumableArray(items));
        }

        renderFn(connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref4) {
        var state = _ref4.state;
        unmountFn();
        return state.setQueryParameter('hitsPerPage', undefined);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, renderState), {}, {
          hitsPerPage: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref5) {
        var state = _ref5.state,
            results = _ref5.results,
            createURL = _ref5.createURL,
            helper = _ref5.helper;
        return {
          items: transformItems(normalizeItems(state), {
            results: results
          }),
          refine: connectorState.getRefine(helper),
          createURL: connectorState.createURLFactory({
            state: state,
            createURL: createURL
          }),
          hasNoResults: results ? results.nbHits === 0 : true,
          widgetParams: widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref6) {
        var searchParameters = _ref6.searchParameters;
        var hitsPerPage = searchParameters.hitsPerPage;

        if (hitsPerPage === undefined || hitsPerPage === defaultItem.value) {
          return uiState;
        }

        return connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, uiState), {}, {
          hitsPerPage: hitsPerPage
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
        var uiState = _ref7.uiState;
        return searchParameters.setQueryParameters({
          hitsPerPage: uiState.hitsPerPage || defaultItem.value
        });
      }
    };
  };
};

/* harmony default export */ var hits_per_page_connectHitsPerPage = (connectHitsPerPage);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/HitsPerPage.vue.js




/* harmony default export */ var HitsPerPage_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: e.suit()
    }, [e._t("default", [s("select", {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: e.selected,
        expression: "selected"
      }],
      class: e.suit("select"),
      on: {
        change: [function (t) {
          var s = Array.prototype.filter.call(t.target.options, function (e) {
            return e.selected;
          }).map(function (e) {
            return "_value" in e ? e._value : e.value;
          });
          e.selected = t.target.multiple ? s : s[0];
        }, e.handleChange]
      }
    }, e._l(e.state.items, function (t) {
      return s("option", {
        key: t.value,
        class: e.suit("option"),
        domProps: {
          value: t.value
        }
      }, [e._v(e._s(t.label))]);
    }), 0)], {
      items: e.state.items,
      refine: e.state.refine,
      hasNoResults: e.state.hasNoResults
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisHitsPerPage",
  mixins: [suit_t({
    name: "HitsPerPage"
  }), widget_e({
    connector: hits_per_page_connectHitsPerPage
  }), r({
    mapStateToCanRefine: function (e) {
      return !1 === e.hasNoResults;
    }
  })],
  props: {
    items: {
      type: Array,
      required: !0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  data: function () {
    return {
      selected: this.items.find(function (e) {
        return !0 === e.default;
      }).value
    };
  },
  computed: {
    widgetParams: function () {
      return {
        items: this.items,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    handleChange: function () {
      this.state.refine(this.selected);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/resolveSearchParameters.js
var resolveSearchParameters = function resolveSearchParameters(current) {
  var parent = current.getParent();
  var states = [current.getHelper().state];

  while (parent !== null) {
    states = [parent.getHelper().state].concat(states);
    parent = parent.getParent();
  }

  return states;
};

/* harmony default export */ var utils_resolveSearchParameters = (resolveSearchParameters);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/widgets/index/index.js


function index_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      index_ownKeys(Object(source), true).forEach(function (key) {
        index_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      index_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function index_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function index_toConsumableArray(arr) {
  return index_arrayWithoutHoles(arr) || index_iterableToArray(arr) || index_unsupportedIterableToArray(arr) || index_nonIterableSpread();
}

function index_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function index_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return index_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return index_arrayLikeToArray(o, minLen);
}

function index_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function index_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return index_arrayLikeToArray(arr);
}

function index_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function index_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = index_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function index_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}



var index_withUsage = createDocumentationMessageGenerator({
  name: 'index-widget'
});
function isIndexWidget(widget) {
  return widget.$$type === 'ais.index';
}
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */

function privateHelperSetState(helper, _ref) {
  var state = _ref.state,
      isPageReset = _ref.isPageReset,
      _uiState = _ref._uiState;

  if (state !== helper.state) {
    helper.state = state;
    helper.emit('change', {
      state: helper.state,
      results: helper.lastResults,
      isPageReset: isPageReset,
      _uiState: _uiState
    });
  }
}

function getLocalWidgetsUiState(widgets, widgetStateOptions) {
  var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return widgets.reduce(function (uiState, widget) {
    if (isIndexWidget(widget)) {
      return uiState;
    }

    if (!widget.getWidgetUiState && !widget.getWidgetState) {
      return uiState;
    }

    if (widget.getWidgetUiState) {
      return widget.getWidgetUiState(uiState, widgetStateOptions);
    }

    return widget.getWidgetState(uiState, widgetStateOptions);
  }, initialUiState);
}

function getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
  var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters,
      rest = index_objectWithoutProperties(widgetSearchParametersOptions, ["initialSearchParameters"]);

  return widgets.filter(function (widget) {
    return !isIndexWidget(widget);
  }).reduce(function (state, widget) {
    if (!widget.getWidgetSearchParameters) {
      return state;
    }

    return widget.getWidgetSearchParameters(state, rest);
  }, initialSearchParameters);
}

function resetPageFromWidgets(widgets) {
  var indexWidgets = widgets.filter(isIndexWidget);

  if (indexWidgets.length === 0) {
    return;
  }

  indexWidgets.forEach(function (widget) {
    var widgetHelper = widget.getHelper();
    privateHelperSetState(widgetHelper, {
      state: widgetHelper.state.resetPage(),
      isPageReset: true
    });
    resetPageFromWidgets(widget.getWidgets());
  });
}

function resolveScopedResultsFromWidgets(widgets) {
  var indexWidgets = widgets.filter(isIndexWidget);
  return indexWidgets.reduce(function (scopedResults, current) {
    return scopedResults.concat.apply(scopedResults, [{
      indexId: current.getIndexId(),
      results: current.getResults(),
      helper: current.getHelper()
    }].concat(index_toConsumableArray(resolveScopedResultsFromWidgets(current.getWidgets()))));
  }, []);
}

var index = function index(widgetParams) {
  if (widgetParams === undefined || widgetParams.indexName === undefined) {
    throw new Error(index_withUsage('The `indexName` option is required.'));
  }

  var indexName = widgetParams.indexName,
      _widgetParams$indexId = widgetParams.indexId,
      indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
  var localWidgets = [];
  var localUiState = {};
  var localInstantSearchInstance = null;
  var localParent = null;
  var helper = null;
  var derivedHelper = null;
  return {
    $$type: 'ais.index',
    $$widgetType: 'ais.index',
    getIndexName: function getIndexName() {
      return indexName;
    },
    getIndexId: function getIndexId() {
      return indexId;
    },
    getHelper: function getHelper() {
      return helper;
    },
    getResults: function getResults() {
      return derivedHelper && derivedHelper.lastResults;
    },
    getScopedResults: function getScopedResults() {
      var widgetParent = this.getParent(); // If the widget is the root, we consider itself as the only sibling.

      var widgetSiblings = widgetParent ? widgetParent.getWidgets() : [this];
      return resolveScopedResultsFromWidgets(widgetSiblings);
    },
    getParent: function getParent() {
      return localParent;
    },
    createURL: function createURL(nextState) {
      return localInstantSearchInstance._createURL(index_defineProperty({}, indexId, getLocalWidgetsUiState(localWidgets, {
        searchParameters: nextState,
        helper: helper
      })));
    },
    getWidgets: function getWidgets() {
      return localWidgets;
    },
    addWidgets: function addWidgets(widgets) {
      var _this = this;

      if (!Array.isArray(widgets)) {
        throw new Error(index_withUsage('The `addWidgets` method expects an array of widgets.'));
      }

      if (widgets.some(function (widget) {
        return typeof widget.init !== 'function' && typeof widget.render !== 'function';
      })) {
        throw new Error(index_withUsage('The widget definition expects a `render` and/or an `init` method.'));
      }

      localWidgets = localWidgets.concat(widgets);

      if (localInstantSearchInstance && Boolean(widgets.length)) {
        privateHelperSetState(helper, {
          state: getLocalWidgetsSearchParameters(localWidgets, {
            uiState: localUiState,
            initialSearchParameters: helper.state
          }),
          _uiState: localUiState
        }); // We compute the render state before calling `init` in a separate loop
        // to construct the whole render state object that is then passed to
        // `init`.

        widgets.forEach(function (widget) {
          if (widget.getRenderState) {
            var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, {
              uiState: localInstantSearchInstance._initialUiState,
              helper: _this.getHelper(),
              parent: _this,
              instantSearchInstance: localInstantSearchInstance,
              state: helper.state,
              renderState: localInstantSearchInstance.renderState,
              templatesConfig: localInstantSearchInstance.templatesConfig,
              createURL: _this.createURL,
              scopedResults: [],
              searchMetadata: {
                isSearchStalled: localInstantSearchInstance._isSearchStalled
              }
            });
            storeRenderState({
              renderState: renderState,
              instantSearchInstance: localInstantSearchInstance,
              parent: _this
            });
          }
        });
        widgets.forEach(function (widget) {
          if (widget.init) {
            widget.init({
              helper: helper,
              parent: _this,
              uiState: localInstantSearchInstance._initialUiState,
              instantSearchInstance: localInstantSearchInstance,
              state: helper.state,
              renderState: localInstantSearchInstance.renderState,
              templatesConfig: localInstantSearchInstance.templatesConfig,
              createURL: _this.createURL,
              scopedResults: [],
              searchMetadata: {
                isSearchStalled: localInstantSearchInstance._isSearchStalled
              }
            });
          }
        });
        localInstantSearchInstance.scheduleSearch();
      }

      return this;
    },
    removeWidgets: function removeWidgets(widgets) {
      var _this2 = this;

      if (!Array.isArray(widgets)) {
        throw new Error(index_withUsage('The `removeWidgets` method expects an array of widgets.'));
      }

      if (widgets.some(function (widget) {
        return typeof widget.dispose !== 'function';
      })) {
        throw new Error(index_withUsage('The widget definition expects a `dispose` method.'));
      }

      localWidgets = localWidgets.filter(function (widget) {
        return widgets.indexOf(widget) === -1;
      });

      if (localInstantSearchInstance && Boolean(widgets.length)) {
        var nextState = widgets.reduce(function (state, widget) {
          // the `dispose` method exists at this point we already assert it
          var next = widget.dispose({
            helper: helper,
            state: state,
            parent: _this2
          });
          return next || state;
        }, helper.state);
        localUiState = getLocalWidgetsUiState(localWidgets, {
          searchParameters: nextState,
          helper: helper
        });
        helper.setState(getLocalWidgetsSearchParameters(localWidgets, {
          uiState: localUiState,
          initialSearchParameters: nextState
        }));

        if (localWidgets.length) {
          localInstantSearchInstance.scheduleSearch();
        }
      }

      return this;
    },
    init: function init(_ref2) {
      var _this3 = this,
          _instantSearchInstanc;

      var instantSearchInstance = _ref2.instantSearchInstance,
          parent = _ref2.parent,
          uiState = _ref2.uiState;

      if (helper !== null) {
        // helper is already initialized, therefore we do not need to set up
        // any listeners
        return;
      }

      localInstantSearchInstance = instantSearchInstance;
      localParent = parent;
      localUiState = uiState[indexId] || {}; // The `mainHelper` is already defined at this point. The instance is created
      // inside InstantSearch at the `start` method, which occurs before the `init`
      // step.

      var mainHelper = instantSearchInstance.mainHelper;
      var parameters = getLocalWidgetsSearchParameters(localWidgets, {
        uiState: localUiState,
        initialSearchParameters: new algoliasearch_helper.SearchParameters({
          index: indexName
        })
      }); // This Helper is only used for state management we do not care about the
      // `searchClient`. Only the "main" Helper created at the `InstantSearch`
      // level is aware of the client.

      helper = algoliasearch_helper({}, parameters.index, parameters); // We forward the call to `search` to the "main" instance of the Helper
      // which is responsible for managing the queries (it's the only one that is
      // aware of the `searchClient`).

      helper.search = function () {
        if (instantSearchInstance.onStateChange) {
          instantSearchInstance.onStateChange({
            uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
            setUiState: instantSearchInstance.setUiState.bind(instantSearchInstance)
          }); // We don't trigger a search when controlled because it becomes the
          // responsibility of `setUiState`.

          return mainHelper;
        }

        return mainHelper.search();
      };

      helper.searchWithoutTriggeringOnStateChange = function () {
        return mainHelper.search();
      }; // We use the same pattern for the `searchForFacetValues`.


      helper.searchForFacetValues = function (facetName, facetValue, maxFacetHits, userState) {
        var state = helper.state.setQueryParameters(userState);
        return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
      };

      derivedHelper = mainHelper.derive(function () {
        return mergeSearchParameters.apply(void 0, index_toConsumableArray(utils_resolveSearchParameters(_this3)));
      });
      var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];

      if (indexInitialResults) {
        // We restore the shape of the results provided to the instance to respect
        // the helper's structure.
        var results = new algoliasearch_helper.SearchResults(new algoliasearch_helper.SearchParameters(indexInitialResults.state), indexInitialResults.results);
        derivedHelper.lastResults = results;
        helper.lastResults = results;
      } // Subscribe to the Helper state changes for the page before widgets
      // are initialized. This behavior mimics the original one of the Helper.
      // It makes sense to replicate it at the `init` step. We have another
      // listener on `change` below, once `init` is done.


      helper.on('change', function (_ref3) {
        var isPageReset = _ref3.isPageReset;

        if (isPageReset) {
          resetPageFromWidgets(localWidgets);
        }
      });
      derivedHelper.on('search', function () {
        // The index does not manage the "staleness" of the search. This is the
        // responsibility of the main instance. It does not make sense to manage
        // it at the index level because it's either: all of them or none of them
        // that are stalled. The queries are performed into a single network request.
        instantSearchInstance.scheduleStalledRender();

        if (false) {}
      });
      derivedHelper.on('result', function (_ref4) {
        var results = _ref4.results; // The index does not render the results it schedules a new render
        // to let all the other indices emit their own results. It allows us to
        // run the render process in one pass.

        instantSearchInstance.scheduleRender(); // the derived helper is the one which actually searches, but the helper
        // which is exposed e.g. via instance.helper, doesn't search, and thus
        // does not have access to lastResults, which it used to in pre-federated
        // search behavior.

        helper.lastResults = results;
      }); // We compute the render state before calling `init` in a separate loop
      // to construct the whole render state object that is then passed to
      // `init`.

      localWidgets.forEach(function (widget) {
        if (widget.getRenderState) {
          var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, {
            uiState: uiState,
            helper: helper,
            parent: _this3,
            instantSearchInstance: instantSearchInstance,
            state: helper.state,
            renderState: instantSearchInstance.renderState,
            templatesConfig: instantSearchInstance.templatesConfig,
            createURL: _this3.createURL,
            scopedResults: [],
            searchMetadata: {
              isSearchStalled: instantSearchInstance._isSearchStalled
            }
          });
          storeRenderState({
            renderState: renderState,
            instantSearchInstance: instantSearchInstance,
            parent: _this3
          });
        }
      });
      localWidgets.forEach(function (widget) {
         false ? 0 : void 0;

        if (widget.init) {
          widget.init({
            uiState: uiState,
            helper: helper,
            parent: _this3,
            instantSearchInstance: instantSearchInstance,
            state: helper.state,
            renderState: instantSearchInstance.renderState,
            templatesConfig: instantSearchInstance.templatesConfig,
            createURL: _this3.createURL,
            scopedResults: [],
            searchMetadata: {
              isSearchStalled: instantSearchInstance._isSearchStalled
            }
          });
        }
      }); // Subscribe to the Helper state changes for the `uiState` once widgets
      // are initialized. Until the first render, state changes are part of the
      // configuration step. This is mainly for backward compatibility with custom
      // widgets. When the subscription happens before the `init` step, the (static)
      // configuration of the widget is pushed in the URL. That's what we want to avoid.
      // https://github.com/algolia/instantsearch.js/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454

      helper.on('change', function (event) {
        var state = event.state;
        var _uiState = event._uiState;
        localUiState = getLocalWidgetsUiState(localWidgets, {
          searchParameters: state,
          helper: helper
        }, _uiState || {}); // We don't trigger an internal change when controlled because it
        // becomes the responsibility of `setUiState`.

        if (!instantSearchInstance.onStateChange) {
          instantSearchInstance.onInternalStateChange();
        }
      });

      if (indexInitialResults) {
        // If there are initial results, we're not notified of the next results
        // because we don't trigger an initial search. We therefore need to directly
        // schedule a render that will render the results injected on the helper.
        instantSearchInstance.scheduleRender();
      }
    },
    render: function render(_ref5) {
      var _this4 = this;

      var instantSearchInstance = _ref5.instantSearchInstance;

      if (!this.getResults()) {
        return;
      }

      localWidgets.forEach(function (widget) {
        if (widget.getRenderState) {
          var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, {
            helper: _this4.getHelper(),
            parent: _this4,
            instantSearchInstance: instantSearchInstance,
            results: _this4.getResults(),
            scopedResults: _this4.getScopedResults(),
            state: _this4.getResults()._state,
            renderState: instantSearchInstance.renderState,
            templatesConfig: instantSearchInstance.templatesConfig,
            createURL: _this4.createURL,
            searchMetadata: {
              isSearchStalled: instantSearchInstance._isSearchStalled
            }
          });
          storeRenderState({
            renderState: renderState,
            instantSearchInstance: instantSearchInstance,
            parent: _this4
          });
        }
      });
      localWidgets.forEach(function (widget) {
        // At this point, all the variables used below are set. Both `helper`
        // and `derivedHelper` have been created at the `init` step. The attribute
        // `lastResults` might be `null` though. It's possible that a stalled render
        // happens before the result e.g with a dynamically added index the request might
        // be delayed. The render is triggered for the complete tree but some parts do
        // not have results yet.
        if (widget.render) {
          widget.render({
            helper: helper,
            parent: _this4,
            instantSearchInstance: instantSearchInstance,
            results: _this4.getResults(),
            scopedResults: _this4.getScopedResults(),
            state: _this4.getResults()._state,
            renderState: instantSearchInstance.renderState,
            templatesConfig: instantSearchInstance.templatesConfig,
            createURL: _this4.createURL,
            searchMetadata: {
              isSearchStalled: instantSearchInstance._isSearchStalled
            }
          });
        }
      });
    },
    dispose: function dispose() {
      var _this5 = this;

      localWidgets.forEach(function (widget) {
        if (widget.dispose) {
          // The dispose function is always called once the instance is started
          // (it's an effect of `removeWidgets`). The index is initialized and
          // the Helper is available. We don't care about the return value of
          // `dispose` because the index is removed. We can't call `removeWidgets`
          // because we want to keep the widgets on the instance, to allow idempotent
          // operations on `add` & `remove`.
          widget.dispose({
            helper: helper,
            state: helper.state,
            parent: _this5
          });
        }
      });
      localInstantSearchInstance = null;
      localParent = null;
      helper.removeAllListeners();
      helper = null;
      derivedHelper.detach();
      derivedHelper = null;
    },
    getWidgetUiState: function getWidgetUiState(uiState) {
      return localWidgets.filter(isIndexWidget).reduce(function (previousUiState, innerIndex) {
        return innerIndex.getWidgetUiState(previousUiState);
      }, index_objectSpread(index_objectSpread({}, uiState), {}, index_defineProperty({}, this.getIndexId(), localUiState)));
    },
    getWidgetState: function getWidgetState(uiState) {
       false ? 0 : void 0;
      return this.getWidgetUiState(uiState);
    },
    getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
      var uiState = _ref6.uiState;
      return getLocalWidgetsSearchParameters(localWidgets, {
        uiState: uiState,
        initialSearchParameters: searchParameters
      });
    },
    refreshUiState: function refreshUiState() {
      localUiState = getLocalWidgetsUiState(localWidgets, {
        searchParameters: this.getHelper().state,
        helper: this.getHelper()
      }, localUiState);
    }
  };
};

/* harmony default export */ var widgets_index = (index);

function storeRenderState(_ref7) {
  var renderState = _ref7.renderState,
      instantSearchInstance = _ref7.instantSearchInstance,
      parent = _ref7.parent;
  var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
  instantSearchInstance.renderState = index_objectSpread(index_objectSpread({}, instantSearchInstance.renderState), {}, index_defineProperty({}, parentIndexName, index_objectSpread(index_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Index.js




/* harmony default export */ var Index = ({
  name: "AisIndex",
  mixins: [suit_t({
    name: "Index"
  }), widget_e({
    connector: function () {
      return widgets_index;
    }
  })],
  provide: function () {
    var e = this;
    return {
      $_ais_getParentIndex: function () {
        return e.widget;
      }
    };
  },
  props: {
    indexName: {
      type: String,
      required: !0
    },
    indexId: {
      type: String,
      required: !1
    }
  },
  render: o(function (e) {
    return e("div", {}, f(this));
  }),
  computed: {
    widgetParams: function () {
      return {
        indexName: this.indexName,
        indexId: this.indexId
      };
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@algolia/events/events.js
var events = __webpack_require__(8878);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/version.js
/* harmony default export */ var version = ('4.40.5');
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/suit.js
var NAMESPACE = 'ais';
var suit_component = function component(componentName) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        descendantName = _ref.descendantName,
        modifierName = _ref.modifierName;

    var descendent = descendantName ? "-".concat(descendantName) : '';
    var modifier = modifierName ? "--".concat(modifierName) : '';
    return "".concat(NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
  };
};
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/highlight.js


var highlight_suit = suit_component('Highlight');
function highlight_highlight(_ref) {
  var attribute = _ref.attribute,
      _ref$highlightedTagNa = _ref.highlightedTagName,
      highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa,
      hit = _ref.hit,
      _ref$cssClasses = _ref.cssClasses,
      cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
  var highlightAttributeResult = utils_getPropertyByPath(hit._highlightResult, attribute); // @MAJOR fallback to attribute value if highlight is not found

   false ? 0 : void 0;

  var _ref2 = highlightAttributeResult || {},
      _ref2$value = _ref2.value,
      attributeValue = _ref2$value === void 0 ? '' : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular


  var className = highlight_suit({
    descendantName: 'highlighted'
  }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
  return attributeValue.replace(new RegExp(TAG_REPLACEMENT.highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp(TAG_REPLACEMENT.highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/concatHighlightedParts.js

function concatHighlightedParts(parts) {
  var highlightPreTag = TAG_REPLACEMENT.highlightPreTag,
      highlightPostTag = TAG_REPLACEMENT.highlightPostTag;
  return parts.map(function (part) {
    return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
  }).join('');
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/unescape.js
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */
// Used to map HTML entities to characters.
var unescape_htmlEscapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
}; // Used to match HTML entities and HTML characters.

var regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var regexHasEscapedHtml = RegExp(regexEscapedHtml.source);
/**
 * Converts the HTML entities "&", "<", ">", '"', and "'" in `string` to their
 * characters.
 */

function unescape_unescape(value) {
  return value && regexHasEscapedHtml.test(value) ? value.replace(regexEscapedHtml, function (character) {
    return unescape_htmlEscapes[character];
  }) : value;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getHighlightFromSiblings.js

var hasAlphanumeric = new RegExp(/\w/i);
function getHighlightFromSiblings(parts, i) {
  var _parts, _parts2;

  var current = parts[i];
  var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
  var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;

  if (!hasAlphanumeric.test(unescape_unescape(current.value)) && isPreviousHighlighted === isNextHighlighted) {
    return isPreviousHighlighted;
  }

  return current.isHighlighted;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/reverseHighlightedParts.js
function reverseHighlightedParts_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function reverseHighlightedParts_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      reverseHighlightedParts_ownKeys(Object(source), true).forEach(function (key) {
        reverseHighlightedParts_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      reverseHighlightedParts_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function reverseHighlightedParts_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


function reverseHighlightedParts(parts) {
  if (!parts.some(function (part) {
    return part.isHighlighted;
  })) {
    return parts.map(function (part) {
      return reverseHighlightedParts_objectSpread(reverseHighlightedParts_objectSpread({}, part), {}, {
        isHighlighted: false
      });
    });
  }

  return parts.map(function (part, i) {
    return reverseHighlightedParts_objectSpread(reverseHighlightedParts_objectSpread({}, part), {}, {
      isHighlighted: !getHighlightFromSiblings(parts, i)
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getHighlightedParts.js

function getHighlightedParts(highlightedValue) {
  var highlightPostTag = TAG_REPLACEMENT.highlightPostTag,
      highlightPreTag = TAG_REPLACEMENT.highlightPreTag;
  var splitByPreTag = highlightedValue.split(highlightPreTag);
  var firstValue = splitByPreTag.shift();
  var elements = !firstValue ? [] : [{
    value: firstValue,
    isHighlighted: false
  }];
  splitByPreTag.forEach(function (split) {
    var splitByPostTag = split.split(highlightPostTag);
    elements.push({
      value: splitByPostTag[0],
      isHighlighted: true
    });

    if (splitByPostTag[1] !== '') {
      elements.push({
        value: splitByPostTag[1],
        isHighlighted: false
      });
    }
  });
  return elements;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/reverseHighlight.js


var reverseHighlight_suit = suit_component('ReverseHighlight');
function reverseHighlight_reverseHighlight(_ref) {
  var attribute = _ref.attribute,
      _ref$highlightedTagNa = _ref.highlightedTagName,
      highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa,
      hit = _ref.hit,
      _ref$cssClasses = _ref.cssClasses,
      cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
  var highlightAttributeResult = utils_getPropertyByPath(hit._highlightResult, attribute); // @MAJOR fallback to attribute value if highlight is not found

   false ? 0 : void 0;

  var _ref2 = highlightAttributeResult || {},
      _ref2$value = _ref2.value,
      attributeValue = _ref2$value === void 0 ? '' : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular


  var className = reverseHighlight_suit({
    descendantName: 'highlighted'
  }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
  var reverseHighlightedValue = concatHighlightedParts(reverseHighlightedParts(getHighlightedParts(attributeValue)));
  return reverseHighlightedValue.replace(new RegExp(TAG_REPLACEMENT.highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp(TAG_REPLACEMENT.highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/snippet.js


var snippet_suit = suit_component('Snippet');
function snippet_snippet(_ref) {
  var attribute = _ref.attribute,
      _ref$highlightedTagNa = _ref.highlightedTagName,
      highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa,
      hit = _ref.hit,
      _ref$cssClasses = _ref.cssClasses,
      cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
  var snippetAttributeResult = utils_getPropertyByPath(hit._snippetResult, attribute); // @MAJOR fallback to attribute value if snippet is not found

   false ? 0 : void 0;

  var _ref2 = snippetAttributeResult || {},
      _ref2$value = _ref2.value,
      attributeValue = _ref2$value === void 0 ? '' : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular


  var className = snippet_suit({
    descendantName: 'highlighted'
  }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
  return attributeValue.replace(new RegExp(TAG_REPLACEMENT.highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp(TAG_REPLACEMENT.highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/reverseSnippet.js


var reverseSnippet_suit = suit_component('ReverseSnippet');
function reverseSnippet_reverseSnippet(_ref) {
  var attribute = _ref.attribute,
      _ref$highlightedTagNa = _ref.highlightedTagName,
      highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa,
      hit = _ref.hit,
      _ref$cssClasses = _ref.cssClasses,
      cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
  var snippetAttributeResult = utils_getPropertyByPath(hit._snippetResult, attribute); // @MAJOR fallback to attribute value if snippet is not found

   false ? 0 : void 0;

  var _ref2 = snippetAttributeResult || {},
      _ref2$value = _ref2.value,
      attributeValue = _ref2$value === void 0 ? '' : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular


  var className = reverseSnippet_suit({
    descendantName: 'highlighted'
  }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
  var reverseHighlightedValue = concatHighlightedParts(reverseHighlightedParts(getHighlightedParts(attributeValue)));
  return reverseHighlightedValue.replace(new RegExp(TAG_REPLACEMENT.highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp(TAG_REPLACEMENT.highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/insights.js


function insights_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    insights_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    insights_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return insights_typeof(obj);
}


function readDataAttributes(domElement) {
  var method = domElement.getAttribute('data-insights-method');
  var serializedPayload = domElement.getAttribute('data-insights-payload');

  if (typeof serializedPayload !== 'string') {
    throw new Error('The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.');
  }

  try {
    var payload = deserializePayload(serializedPayload);
    return {
      method: method,
      payload: payload
    };
  } catch (error) {
    throw new Error('The insights helper was unable to parse `data-insights-payload`.');
  }
}
function hasDataAttributes(domElement) {
  return domElement.hasAttribute('data-insights-method');
}
function writeDataAttributes(_ref) {
  var method = _ref.method,
      payload = _ref.payload;

  if (insights_typeof(payload) !== 'object') {
    throw new Error("The insights helper expects the payload to be an object.");
  }

  var serializedPayload;

  try {
    serializedPayload = serializePayload(payload);
  } catch (error) {
    throw new Error("Could not JSON serialize the payload object.");
  }

  return "data-insights-method=\"".concat(method, "\" data-insights-payload=\"").concat(serializedPayload, "\"");
}
/**
 * @deprecated This function will be still supported in 4.x releases, but not further. It is replaced by the `insights` middleware. For more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/
 */

function insights_insights(method, payload) {
   false ? 0 : void 0;
  return writeDataAttributes({
    method: method,
    payload: payload
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/createHelpers.js


function createHelpers_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createHelpers_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createHelpers_ownKeys(Object(source), true).forEach(function (key) {
        createHelpers_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createHelpers_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createHelpers_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


function hoganHelpers(_ref) {
  var numberLocale = _ref.numberLocale;
  return {
    formatNumber: function formatNumber(value, render) {
      return Number(render(value)).toLocaleString(numberLocale);
    },
    highlight: function highlight(options, render) {
      try {
        var highlightOptions = JSON.parse(options);
        return render(highlight_highlight(createHelpers_objectSpread(createHelpers_objectSpread({}, highlightOptions), {}, {
          hit: this
        })));
      } catch (error) {
        throw new Error("\nThe highlight helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
      }
    },
    reverseHighlight: function reverseHighlight(options, render) {
      try {
        var reverseHighlightOptions = JSON.parse(options);
        return render(reverseHighlight_reverseHighlight(createHelpers_objectSpread(createHelpers_objectSpread({}, reverseHighlightOptions), {}, {
          hit: this
        })));
      } catch (error) {
        throw new Error("\n  The reverseHighlight helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
      }
    },
    snippet: function snippet(options, render) {
      try {
        var snippetOptions = JSON.parse(options);
        return render(snippet_snippet(createHelpers_objectSpread(createHelpers_objectSpread({}, snippetOptions), {}, {
          hit: this
        })));
      } catch (error) {
        throw new Error("\nThe snippet helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
      }
    },
    reverseSnippet: function reverseSnippet(options, render) {
      try {
        var reverseSnippetOptions = JSON.parse(options);
        return render(reverseSnippet_reverseSnippet(createHelpers_objectSpread(createHelpers_objectSpread({}, reverseSnippetOptions), {}, {
          hit: this
        })));
      } catch (error) {
        throw new Error("\n  The reverseSnippet helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
      }
    },
    insights: function insights(options, render) {
      try {
        var _JSON$parse = JSON.parse(options),
            method = _JSON$parse.method,
            payload = _JSON$parse.payload;

        return render(insights_insights(method, createHelpers_objectSpread({
          objectIDs: [this.objectID]
        }, payload)));
      } catch (error) {
        throw new Error("\nThe insights helper expects a JSON object of the format:\n{ \"method\": \"method-name\", \"payload\": { \"eventName\": \"name of the event\" } }");
      }
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/defer.js

var nextMicroTask = Promise.resolve();

var defer = function defer(callback) {
  var progress = null;
  var cancelled = false;

  var fn = function fn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (progress !== null) {
      return;
    }

    progress = nextMicroTask.then(function () {
      progress = null;

      if (cancelled) {
        cancelled = false;
        return;
      }

      callback.apply(void 0, args);
    });
  };

  fn.wait = function () {
    if (progress === null) {
      throw new Error('The deferred function should be called before calling `wait()`');
    }

    return progress;
  };

  fn.cancel = function () {
    if (progress === null) {
      return;
    }

    cancelled = true;
  };

  return fn;
};

/* harmony default export */ var utils_defer = (defer);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/stateMappings/simple.js
function simple_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function simple_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      simple_ownKeys(Object(source), true).forEach(function (key) {
        simple_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      simple_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function simple_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function simple_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = simple_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function simple_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getIndexStateWithoutConfigure(uiState) {
  var configure = uiState.configure,
      trackedUiState = simple_objectWithoutProperties(uiState, ["configure"]);

  return trackedUiState;
} // technically a URL could contain any key, since users provide it,
// which is why the input to this function is UiState, not something
// which excludes "configure" as this function does.


function simpleStateMapping() {
  return {
    stateToRoute: function stateToRoute(uiState) {
      return Object.keys(uiState).reduce(function (state, indexId) {
        return simple_objectSpread(simple_objectSpread({}, state), {}, simple_defineProperty({}, indexId, getIndexStateWithoutConfigure(uiState[indexId])));
      }, {});
    },
    routeToState: function routeToState() {
      var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.keys(routeState).reduce(function (state, indexId) {
        return simple_objectSpread(simple_objectSpread({}, state), {}, simple_defineProperty({}, indexId, getIndexStateWithoutConfigure(routeState[indexId])));
      }, {});
    }
  };
}
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(7421);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/safelyRunOnBrowser.js
// eslint-disable-next-line no-restricted-globals

/**
 * Runs code on browser enviromnents safely.
 */
function safelyRunOnBrowser(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    fallback: function fallback() {
      return undefined;
    }
  },
      fallback = _ref.fallback; // eslint-disable-next-line no-restricted-globals


  if (typeof window === 'undefined') {
    return fallback();
  } // eslint-disable-next-line no-restricted-globals


  return callback({
    window: window
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/routers/history.js


function history_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function history_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function history_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) history_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) history_defineProperties(Constructor, staticProps);
  return Constructor;
}

function history_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}




var setWindowTitle = function setWindowTitle(title) {
  if (title) {
    // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
  }
};

var BrowserHistory = /*#__PURE__*/function () {
  /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */
  function BrowserHistory(_ref) {
    var _this = this;

    var windowTitle = _ref.windowTitle,
        _ref$writeDelay = _ref.writeDelay,
        writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay,
        createURL = _ref.createURL,
        parseURL = _ref.parseURL,
        getLocation = _ref.getLocation;

    history_classCallCheck(this, BrowserHistory);

    history_defineProperty(this, "windowTitle", void 0);

    history_defineProperty(this, "writeDelay", void 0);

    history_defineProperty(this, "_createURL", void 0);

    history_defineProperty(this, "parseURL", void 0);

    history_defineProperty(this, "getLocation", void 0);

    history_defineProperty(this, "writeTimer", void 0);

    history_defineProperty(this, "inPopState", false);

    history_defineProperty(this, "isDisposed", false);

    history_defineProperty(this, "latestAcknowledgedHistory", 0);

    this.windowTitle = windowTitle;
    this.writeTimer = undefined;
    this.writeDelay = writeDelay;
    this._createURL = createURL;
    this.parseURL = parseURL;
    this.getLocation = getLocation;
    safelyRunOnBrowser(function (_ref2) {
      var window = _ref2.window;

      var title = _this.windowTitle && _this.windowTitle(_this.read());

      setWindowTitle(title);
      _this.latestAcknowledgedHistory = window.history.length;
    });
  }
  /**
   * Reads the URL and returns a syncable UI search state.
   */


  history_createClass(BrowserHistory, [{
    key: "read",
    value: function read() {
      return this.parseURL({
        qsModule: lib,
        location: this.getLocation()
      });
    }
    /**
     * Pushes a search state into the URL.
     */

  }, {
    key: "write",
    value: function write(routeState) {
      var _this2 = this;

      safelyRunOnBrowser(function (_ref3) {
        var window = _ref3.window;

        var url = _this2.createURL(routeState);

        var title = _this2.windowTitle && _this2.windowTitle(routeState);

        if (_this2.writeTimer) {
          clearTimeout(_this2.writeTimer);
        }

        _this2.writeTimer = setTimeout(function () {
          setWindowTitle(title);

          if (_this2.shouldWrite(url)) {
            window.history.pushState(routeState, title || '', url);
            _this2.latestAcknowledgedHistory = window.history.length;
          }

          _this2.inPopState = false;
          _this2.writeTimer = undefined;
        }, _this2.writeDelay);
      });
    }
    /**
     * Sets a callback on the `onpopstate` event of the history API of the current page.
     * It enables the URL sync to keep track of the changes.
     */

  }, {
    key: "onUpdate",
    value: function onUpdate(callback) {
      var _this3 = this;

      this._onPopState = function (event) {
        if (_this3.writeTimer) {
          clearTimeout(_this3.writeTimer);
          _this3.writeTimer = undefined;
        }

        _this3.inPopState = true;
        var routeState = event.state; // At initial load, the state is read from the URL without update.
        // Therefore the state object is not available.
        // In this case, we fallback and read the URL.

        if (!routeState) {
          callback(_this3.read());
        } else {
          callback(routeState);
        }
      };

      safelyRunOnBrowser(function (_ref4) {
        var window = _ref4.window;
        window.addEventListener('popstate', _this3._onPopState);
      });
    }
    /**
     * Creates a complete URL from a given syncable UI state.
     *
     * It always generates the full URL, not a relative one.
     * This allows to handle cases like using a <base href>.
     * See: https://github.com/algolia/instantsearch.js/issues/790
     */

  }, {
    key: "createURL",
    value: function createURL(routeState) {
      return this._createURL({
        qsModule: lib,
        routeState: routeState,
        location: this.getLocation()
      });
    }
    /**
     * Removes the event listener and cleans up the URL.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      var _this4 = this;

      this.isDisposed = true;
      safelyRunOnBrowser(function (_ref5) {
        var window = _ref5.window;

        if (_this4._onPopState) {
          window.removeEventListener('popstate', _this4._onPopState);
        }
      });

      if (this.writeTimer) {
        clearTimeout(this.writeTimer);
      }

      this.write({});
    }
  }, {
    key: "shouldWrite",
    value: function shouldWrite(url) {
      var _this5 = this;

      return safelyRunOnBrowser(function (_ref6) {
        var window = _ref6.window; // We do want to `pushState` if:
        // - the router is not disposed, IS.js needs to update the URL
        // OR
        // - the last write was from InstantSearch.js
        // (unlike a SPA, where it would have last written)

        var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window.history.length);
        return (// When the last state change was through popstate, the IS.js state changes,
          // but that should not write the URL.
          !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
          lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
          url !== window.location.href
        );
      });
    }
  }]);

  return BrowserHistory;
}();

function historyRouter() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$createURL = _ref7.createURL,
      createURL = _ref7$createURL === void 0 ? function (_ref8) {
    var qsModule = _ref8.qsModule,
        routeState = _ref8.routeState,
        location = _ref8.location;
    var protocol = location.protocol,
        hostname = location.hostname,
        _location$port = location.port,
        port = _location$port === void 0 ? '' : _location$port,
        pathname = location.pathname,
        hash = location.hash;
    var queryString = qsModule.stringify(routeState);
    var portWithPrefix = port === '' ? '' : ":".concat(port); // IE <= 11 has no proper `location.origin` so we cannot rely on it.
    // IE <= 11 has no proper `location.origin` so we cannot rely on it.

    if (!queryString) {
      return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
    }

    return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
  } : _ref7$createURL,
      _ref7$parseURL = _ref7.parseURL,
      parseURL = _ref7$parseURL === void 0 ? function (_ref9) {
    var qsModule = _ref9.qsModule,
        location = _ref9.location; // `qs` by default converts arrays with more than 20 items to an object.
    // We want to avoid this because the data structure manipulated can therefore vary.
    // Setting the limit to `100` seems a good number because the engine's default is 100
    // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
    //
    // Using an `arrayLimit` of `n` allows `n + 1` items.
    //
    // See:
    //   - https://github.com/ljharb/qs#parsing-arrays
    //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/

    return qsModule.parse(location.search.slice(1), {
      arrayLimit: 99
    });
  } : _ref7$parseURL,
      _ref7$writeDelay = _ref7.writeDelay,
      writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay,
      windowTitle = _ref7.windowTitle,
      _ref7$getLocation = _ref7.getLocation,
      getLocation = _ref7$getLocation === void 0 ? function () {
    return safelyRunOnBrowser(function (_ref10) {
      var window = _ref10.window;
      return window.location;
    }, {
      fallback: function fallback() {
        throw new Error('You need to provide `getLocation` to the `history` router in environments where `window` does not exist.');
      }
    });
  } : _ref7$getLocation;

  return new BrowserHistory({
    createURL: createURL,
    parseURL: parseURL,
    writeDelay: writeDelay,
    windowTitle: windowTitle,
    getLocation: getLocation
  });
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/isEqual.js
function isEqual_isPrimitive(obj) {
  return obj !== Object(obj);
}

function isEqual_isEqual(first, second) {
  if (first === second) {
    return true;
  }

  if (isEqual_isPrimitive(first) || isEqual_isPrimitive(second) || typeof first === 'function' || typeof second === 'function') {
    return first === second;
  }

  if (Object.keys(first).length !== Object.keys(second).length) {
    return false;
  }

  for (var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (!(key in second)) {
      return false;
    }

    if (!isEqual_isEqual(first[key], second[key])) {
      return false;
    }
  }

  return true;
}

/* harmony default export */ var utils_isEqual = (isEqual_isEqual);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/middlewares/createRouterMiddleware.js
function createRouterMiddleware_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createRouterMiddleware_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createRouterMiddleware_ownKeys(Object(source), true).forEach(function (key) {
        createRouterMiddleware_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createRouterMiddleware_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createRouterMiddleware_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}




var createRouterMiddleware = function createRouterMiddleware() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$router = props.router,
      router = _props$router === void 0 ? historyRouter() : _props$router,
      _props$stateMapping = props.stateMapping,
      stateMapping = _props$stateMapping === void 0 ? simpleStateMapping() : _props$stateMapping;
  return function (_ref) {
    var instantSearchInstance = _ref.instantSearchInstance;

    function topLevelCreateURL(nextState) {
      var uiState = Object.keys(nextState).reduce(function (acc, indexId) {
        return createRouterMiddleware_objectSpread(createRouterMiddleware_objectSpread({}, acc), {}, createRouterMiddleware_defineProperty({}, indexId, nextState[indexId]));
      }, instantSearchInstance.mainIndex.getWidgetUiState({}));
      var route = stateMapping.stateToRoute(uiState);
      return router.createURL(route);
    } // casting to UiState here to keep createURL unaware of custom UiState
    // (as long as it's an object, it's ok)


    instantSearchInstance._createURL = topLevelCreateURL;
    var lastRouteState = undefined;
    var initialUiState = instantSearchInstance._initialUiState;
    return {
      onStateChange: function onStateChange(_ref2) {
        var uiState = _ref2.uiState;
        var routeState = stateMapping.stateToRoute(uiState);

        if (lastRouteState === undefined || !utils_isEqual(lastRouteState, routeState)) {
          router.write(routeState);
          lastRouteState = routeState;
        }
      },
      subscribe: function subscribe() {
        instantSearchInstance._initialUiState = createRouterMiddleware_objectSpread(createRouterMiddleware_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
        router.onUpdate(function (route) {
          instantSearchInstance.setUiState(stateMapping.routeToState(route));
        });
      },
      unsubscribe: function unsubscribe() {
        router.dispose();
      }
    };
  };
};
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/middlewares/createMetadataMiddleware.js


function extractPayload(widgets, instantSearchInstance, payload) {
  var parent = instantSearchInstance.mainIndex;
  var initOptions = {
    instantSearchInstance: instantSearchInstance,
    parent: parent,
    scopedResults: [],
    state: parent.getHelper().state,
    helper: parent.getHelper(),
    createURL: parent.createURL,
    uiState: instantSearchInstance._initialUiState,
    renderState: instantSearchInstance.renderState,
    templatesConfig: instantSearchInstance.templatesConfig,
    searchMetadata: {
      isSearchStalled: instantSearchInstance._isSearchStalled
    }
  };
  widgets.forEach(function (widget) {
    var widgetParams = {};

    if (widget.getWidgetRenderState) {
      var renderState = widget.getWidgetRenderState(initOptions);

      if (renderState && renderState.widgetParams) {
        // casting, as we just earlier checked widgetParams exists, and thus an object
        widgetParams = renderState.widgetParams;
      }
    } // since we destructure in all widgets, the parameters with defaults are set to "undefined"


    var params = Object.keys(widgetParams).filter(function (key) {
      return widgetParams[key] !== undefined;
    });
    payload.widgets.push({
      type: widget.$$type,
      widgetType: widget.$$widgetType,
      params: params
    });

    if (widget.$$type === 'ais.index') {
      extractPayload(widget.getWidgets(), instantSearchInstance, payload);
    }
  });
}

function isMetadataEnabled() {
  return safelyRunOnBrowser(function (_ref) {
    var _window$navigator, _window$navigator$use;

    var window = _ref.window;
    return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf('Algolia Crawler')) > -1;
  }, {
    fallback: function fallback() {
      return false;
    }
  });
}
/**
 * Exposes the metadata of mounted widgets in a custom
 * `<meta name="instantsearch:widgets" />` tag. The metadata per widget is:
 * - applied parameters
 * - widget name
 * - connector name
 */

function createMetadataMiddleware() {
  return function (_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance;
    var payload = {
      widgets: []
    };
    var payloadContainer = document.createElement('meta');
    var refNode = document.querySelector('head');
    payloadContainer.name = 'instantsearch:widgets';
    return {
      onStateChange: function onStateChange() {},
      subscribe: function subscribe() {
        // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
        setTimeout(function () {
          var client = instantSearchInstance.client;
          payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
          extractPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
          payloadContainer.content = JSON.stringify(payload);
          refNode.appendChild(payloadContainer);
        }, 0);
      },
      unsubscribe: function unsubscribe() {
        payloadContainer.remove();
      }
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/InstantSearch.js


function InstantSearch_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    InstantSearch_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    InstantSearch_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return InstantSearch_typeof(obj);
}

function InstantSearch_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function InstantSearch_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      InstantSearch_ownKeys(Object(source), true).forEach(function (key) {
        InstantSearch_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      InstantSearch_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function InstantSearch_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function InstantSearch_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function InstantSearch_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) InstantSearch_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) InstantSearch_defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (InstantSearch_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function InstantSearch_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}









var InstantSearch_withUsage = createDocumentationMessageGenerator({
  name: 'instantsearch'
});

function defaultCreateURL() {
  return '#';
}
/**
 * Global options for an InstantSearch instance.
 */

/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */


var InstantSearch_InstantSearch = /*#__PURE__*/function (_EventEmitter) {
  _inherits(InstantSearch, _EventEmitter);

  var _super = _createSuper(InstantSearch);

  function InstantSearch(options) {
    var _this;

    InstantSearch_classCallCheck(this, InstantSearch);

    _this = _super.call(this);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "client", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "indexName", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "insightsClient", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "onStateChange", null);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "helper", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "mainHelper", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "mainIndex", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "started", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "templatesConfig", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "renderState", {});

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_stalledSearchDelay", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_searchStalledTimer", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_isSearchStalled", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_initialUiState", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_initialResults", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_createURL", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_searchFunction", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "_mainHelperSearch", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "middleware", []);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "sendEventToInsights", void 0);

    InstantSearch_defineProperty(_assertThisInitialized(_this), "scheduleSearch", utils_defer(function () {
      if (_this.started) {
        _this.mainHelper.search();
      }
    }));

    InstantSearch_defineProperty(_assertThisInitialized(_this), "scheduleRender", utils_defer(function () {
      if (!_this.mainHelper.hasPendingRequests()) {
        clearTimeout(_this._searchStalledTimer);
        _this._searchStalledTimer = null;
        _this._isSearchStalled = false;
      }

      _this.mainIndex.render({
        instantSearchInstance: _assertThisInitialized(_this)
      });

      _this.emit('render');
    }));

    InstantSearch_defineProperty(_assertThisInitialized(_this), "onInternalStateChange", utils_defer(function () {
      var nextUiState = _this.mainIndex.getWidgetUiState({});

      _this.middleware.forEach(function (_ref) {
        var instance = _ref.instance;
        instance.onStateChange({
          uiState: nextUiState
        });
      });
    }));

    var _options$indexName = options.indexName,
        indexName = _options$indexName === void 0 ? null : _options$indexName,
        numberLocale = options.numberLocale,
        _options$initialUiSta = options.initialUiState,
        initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta,
        _options$routing = options.routing,
        routing = _options$routing === void 0 ? null : _options$routing,
        searchFunction = options.searchFunction,
        _options$stalledSearc = options.stalledSearchDelay,
        stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc,
        _options$searchClient = options.searchClient,
        searchClient = _options$searchClient === void 0 ? null : _options$searchClient,
        _options$insightsClie = options.insightsClient,
        insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie,
        _options$onStateChang = options.onStateChange,
        onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang;

    if (indexName === null) {
      throw new Error(InstantSearch_withUsage('The `indexName` option is required.'));
    }

    if (searchClient === null) {
      throw new Error(InstantSearch_withUsage('The `searchClient` option is required.'));
    }

    if (typeof searchClient.search !== 'function') {
      throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
    }

    if (typeof searchClient.addAlgoliaAgent === 'function') {
      searchClient.addAlgoliaAgent("instantsearch.js (".concat(version, ")"));
    }

     false ? 0 : void 0;

    if (insightsClient && typeof insightsClient !== 'function') {
      throw new Error(InstantSearch_withUsage('The `insightsClient` option should be a function.'));
    }

     false ? 0 : void 0;
    _this.client = searchClient;
    _this.insightsClient = insightsClient;
    _this.indexName = indexName;
    _this.helper = null;
    _this.mainHelper = null;
    _this.mainIndex = widgets_index({
      indexName: indexName
    });
    _this.onStateChange = onStateChange;
    _this.started = false;
    _this.templatesConfig = {
      helpers: hoganHelpers({
        numberLocale: numberLocale
      }),
      compileOptions: {}
    };
    _this._stalledSearchDelay = stalledSearchDelay;
    _this._searchStalledTimer = null;
    _this._isSearchStalled = false;
    _this._createURL = defaultCreateURL;
    _this._initialUiState = initialUiState;
    _this._initialResults = null;

    if (searchFunction) {
      _this._searchFunction = searchFunction;
    }

    _this.sendEventToInsights = utils_noop;

    if (routing) {
      var routerOptions = typeof routing === 'boolean' ? undefined : routing;

      _this.use(createRouterMiddleware(routerOptions));
    }

    if (isMetadataEnabled()) {
      _this.use(createMetadataMiddleware());
    }

    return _this;
  }
  /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */


  InstantSearch_createClass(InstantSearch, [{
    key: "use",
    value: function use() {
      var _this2 = this;

      for (var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++) {
        middleware[_key] = arguments[_key];
      }

      var newMiddlewareList = middleware.map(function (fn) {
        var newMiddleware = InstantSearch_objectSpread({
          subscribe: utils_noop,
          unsubscribe: utils_noop,
          onStateChange: utils_noop
        }, fn({
          instantSearchInstance: _this2
        }));

        _this2.middleware.push({
          creator: fn,
          instance: newMiddleware
        });

        return newMiddleware;
      }); // If the instance has already started, we directly subscribe the
      // middleware so they're notified of changes.

      if (this.started) {
        newMiddlewareList.forEach(function (m) {
          m.subscribe();
        });
      }

      return this;
    }
    /**
     * Removes a middleware from the InstantSearch lifecycle.
     */

  }, {
    key: "unuse",
    value: function unuse() {
      for (var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        middlewareToUnuse[_key2] = arguments[_key2];
      }

      this.middleware.filter(function (m) {
        return middlewareToUnuse.includes(m.creator);
      }).forEach(function (m) {
        return m.instance.unsubscribe();
      });
      this.middleware = this.middleware.filter(function (m) {
        return !middlewareToUnuse.includes(m.creator);
      });
      return this;
    } // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now

  }, {
    key: "EXPERIMENTAL_use",
    value: function EXPERIMENTAL_use() {
       false ? 0 : void 0;
      return this.use.apply(this, arguments);
    }
    /**
     * Adds a widget to the search instance.
     * A widget can be added either before or after InstantSearch has started.
     * @param widget The widget to add to InstantSearch.
     *
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`.
     */

  }, {
    key: "addWidget",
    value: function addWidget(widget) {
       false ? 0 : void 0;
      return this.addWidgets([widget]);
    }
    /**
     * Adds multiple widgets to the search instance.
     * Widgets can be added either before or after InstantSearch has started.
     * @param widgets The array of widgets to add to InstantSearch.
     */

  }, {
    key: "addWidgets",
    value: function addWidgets(widgets) {
      if (!Array.isArray(widgets)) {
        throw new Error(InstantSearch_withUsage('The `addWidgets` method expects an array of widgets. Please use `addWidget`.'));
      }

      if (widgets.some(function (widget) {
        return typeof widget.init !== 'function' && typeof widget.render !== 'function';
      })) {
        throw new Error(InstantSearch_withUsage('The widget definition expects a `render` and/or an `init` method.'));
      }

      this.mainIndex.addWidgets(widgets);
      return this;
    }
    /**
     * Removes a widget from the search instance.
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`
     * @param widget The widget instance to remove from InstantSearch.
     *
     * The widget must implement a `dispose()` method to clear its state.
     */

  }, {
    key: "removeWidget",
    value: function removeWidget(widget) {
       false ? 0 : void 0;
      return this.removeWidgets([widget]);
    }
    /**
     * Removes multiple widgets from the search instance.
     * @param widgets Array of widgets instances to remove from InstantSearch.
     *
     * The widgets must implement a `dispose()` method to clear their states.
     */

  }, {
    key: "removeWidgets",
    value: function removeWidgets(widgets) {
      if (!Array.isArray(widgets)) {
        throw new Error(InstantSearch_withUsage('The `removeWidgets` method expects an array of widgets. Please use `removeWidget`.'));
      }

      if (widgets.some(function (widget) {
        return typeof widget.dispose !== 'function';
      })) {
        throw new Error(InstantSearch_withUsage('The widget definition expects a `dispose` method.'));
      }

      this.mainIndex.removeWidgets(widgets);
      return this;
    }
    /**
     * Ends the initialization of InstantSearch.js and triggers the
     * first search. This method should be called after all widgets have been added
     * to the instance of InstantSearch.js. InstantSearch.js also supports adding and removing
     * widgets after the start as an **EXPERIMENTAL** feature.
     */

  }, {
    key: "start",
    value: function start() {
      var _this3 = this;

      if (this.started) {
        throw new Error(InstantSearch_withUsage('The `start` method has already been called once.'));
      } // This Helper is used for the queries, we don't care about its state. The
      // states are managed at the `index` level. We use this Helper to create
      // DerivedHelper scoped into the `index` widgets.
      // In Vue InstantSearch' hydrate, a main helper gets set before start, so
      // we need to respect this helper as a way to keep all listeners correct.


      var mainHelper = this.mainHelper || algoliasearch_helper(this.client, this.indexName);

      mainHelper.search = function () {
        // This solution allows us to keep the exact same API for the users but
        // under the hood, we have a different implementation. It should be
        // completely transparent for the rest of the codebase. Only this module
        // is impacted.
        return mainHelper.searchOnlyWithDerivedHelpers();
      };

      if (this._searchFunction) {
        // this client isn't used to actually search, but required for the helper
        // to not throw errors
        var fakeClient = {
          search: function search() {
            return new Promise(utils_noop);
          }
        };
        this._mainHelperSearch = mainHelper.search.bind(mainHelper);

        mainHelper.search = function () {
          var mainIndexHelper = _this3.mainIndex.getHelper();

          var searchFunctionHelper = algoliasearch_helper(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
          searchFunctionHelper.once('search', function (_ref2) {
            var state = _ref2.state;
            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);

            _this3._mainHelperSearch();
          }); // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`

          searchFunctionHelper.on('change', function (_ref3) {
            var state = _ref3.state;
            mainIndexHelper.setState(state);
          });

          _this3._searchFunction(searchFunctionHelper);

          return mainHelper;
        };
      } // Only the "main" Helper emits the `error` event vs the one for `search`
      // and `results` that are also emitted on the derived one.


      mainHelper.on('error', function (_ref4) {
        var error = _ref4.error; // If an error is emitted, it is re-thrown by events. In previous versions
        // we emitted {error}, which is thrown as:
        // "Uncaught, unspecified \"error\" event. ([object Object])"
        // To avoid breaking changes, we make the error available in both
        // `error` and `error.error`
        // @MAJOR emit only error

        error.error = error;

        _this3.emit('error', error);
      });
      this.mainHelper = mainHelper;
      this.middleware.forEach(function (_ref5) {
        var instance = _ref5.instance;
        instance.subscribe();
      });
      this.mainIndex.init({
        instantSearchInstance: this,
        parent: null,
        uiState: this._initialUiState
      });

      if (this._initialResults) {
        var originalScheduleSearch = this.scheduleSearch; // We don't schedule a first search when initial results are provided
        // because we already have the results to render. This skips the initial
        // network request on the browser on `start`.

        this.scheduleSearch = utils_defer(utils_noop); // We also skip the initial network request when widgets are dynamically
        // added in the first tick (that's the case in all the framework-based flavors).
        // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
        // on our `defer` util to restore the original `scheduleSearch` value once
        // widgets are added to hook back to the regular lifecycle.

        utils_defer(function () {
          _this3.scheduleSearch = originalScheduleSearch;
        })();
      } else {
        this.scheduleSearch();
      } // Keep the previous reference for legacy purpose, some pattern use
      // the direct Helper access `search.helper` (e.g multi-index).


      this.helper = this.mainIndex.getHelper(); // track we started the search if we add more widgets,
      // to init them directly after add

      this.started = true;
    }
    /**
     * Removes all widgets without triggering a search afterwards. This is an **EXPERIMENTAL** feature,
     * if you find an issue with it, please
     * [open an issue](https://github.com/algolia/instantsearch.js/issues/new?title=Problem%20with%20dispose).
     * @return {undefined} This method does not return anything
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this.scheduleSearch.cancel();
      this.scheduleRender.cancel();
      clearTimeout(this._searchStalledTimer);
      this.removeWidgets(this.mainIndex.getWidgets());
      this.mainIndex.dispose(); // You can not start an instance two times, therefore a disposed instance
      // needs to set started as false otherwise this can not be restarted at a
      // later point.

      this.started = false; // The helper needs to be reset to perform the next search from a fresh state.
      // If not reset, it would use the state stored before calling `dispose()`.

      this.removeAllListeners();
      this.mainHelper.removeAllListeners();
      this.mainHelper = null;
      this.helper = null;
      this.middleware.forEach(function (_ref6) {
        var instance = _ref6.instance;
        instance.unsubscribe();
      });
    }
  }, {
    key: "scheduleStalledRender",
    value: function scheduleStalledRender() {
      var _this4 = this;

      if (!this._searchStalledTimer) {
        this._searchStalledTimer = setTimeout(function () {
          _this4._isSearchStalled = true;

          _this4.scheduleRender();
        }, this._stalledSearchDelay);
      }
    }
  }, {
    key: "setUiState",
    value: function setUiState(uiState) {
      if (!this.mainHelper) {
        throw new Error(InstantSearch_withUsage('The `start` method needs to be called before `setUiState`.'));
      } // We refresh the index UI state to update the local UI state that the
      // main index passes to the function form of `setUiState`.


      this.mainIndex.refreshUiState();
      var nextUiState = typeof uiState === 'function' ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;

      var setIndexHelperState = function setIndexHelperState(indexWidget) {
        var nextIndexUiState = nextUiState[indexWidget.getIndexId()] || {};

        if (false) {}

        indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
          uiState: nextIndexUiState
        }));
        indexWidget.getWidgets().filter(isIndexWidget).forEach(setIndexHelperState);
      };

      setIndexHelperState(this.mainIndex);
      this.scheduleSearch();
      this.onInternalStateChange();
    }
  }, {
    key: "getUiState",
    value: function getUiState() {
      if (this.started) {
        // We refresh the index UI state to make sure changes from `refine` are taken in account
        this.mainIndex.refreshUiState();
      }

      return this.mainIndex.getWidgetUiState({});
    }
  }, {
    key: "createURL",
    value: function createURL() {
      var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.started) {
        throw new Error(InstantSearch_withUsage('The `start` method needs to be called before `createURL`.'));
      }

      return this._createURL(nextState);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (!this.mainHelper) {
        throw new Error(InstantSearch_withUsage('The `start` method needs to be called before `refresh`.'));
      }

      this.mainHelper.clearCache().search();
    }
  }]);

  return InstantSearch;
}(events);

/* harmony default export */ var lib_InstantSearch = (InstantSearch_InstantSearch);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/helpers/get-insights-anonymous-user-token.js

var ANONYMOUS_TOKEN_COOKIE_KEY = '_ALGOLIA';

function get_insights_anonymous_user_token_getCookie(name) {
  var prefix = "".concat(name, "=");
  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(prefix) === 0) {
      return cookie.substring(prefix.length, cookie.length);
    }
  }

  return undefined;
}

function getInsightsAnonymousUserTokenInternal() {
  return get_insights_anonymous_user_token_getCookie(ANONYMOUS_TOKEN_COOKIE_KEY);
}
/**
 * @deprecated This function will be still supported in 4.x releases, but not further. It is replaced by the `insights` middleware. For more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/
 */

function getInsightsAnonymousUserToken() {
   false ? 0 : void 0;
  return getInsightsAnonymousUserTokenInternal();
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/infiniteHitsCache/sessionStorage.js


function sessionStorage_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = sessionStorage_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function sessionStorage_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}



function getStateWithoutPage(state) {
  var _ref = state || {},
      page = _ref.page,
      rest = sessionStorage_objectWithoutProperties(_ref, ["page"]);

  return rest;
}

var KEY = 'ais.infiniteHits';
function createInfiniteHitsSessionStorageCache() {
  return {
    read: function read(_ref2) {
      var state = _ref2.state;
      var sessionStorage = safelyRunOnBrowser(function (_ref3) {
        var window = _ref3.window;
        return window.sessionStorage;
      });

      if (!sessionStorage) {
        return null;
      }

      try {
        var cache = JSON.parse( // @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
        sessionStorage.getItem(KEY));
        return cache && utils_isEqual(cache.state, getStateWithoutPage(state)) ? cache.hits : null;
      } catch (error) {
        if (error instanceof SyntaxError) {
          try {
            sessionStorage.removeItem(KEY);
          } catch (err) {// do nothing
          }
        }

        return null;
      }
    },
    write: function write(_ref4) {
      var state = _ref4.state,
          hits = _ref4.hits;
      var sessionStorage = safelyRunOnBrowser(function (_ref5) {
        var window = _ref5.window;
        return window.sessionStorage;
      });

      if (!sessionStorage) {
        return;
      }

      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          state: getStateWithoutPage(state),
          hits: hits
        }));
      } catch (error) {// do nothing
      }
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/logger.js

/**
 * Logs a warning when this function is called, in development environment only.
 */

var deprecate = function deprecate(fn, message) {
  return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */


var logger_warn = utils_noop;
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */

var _warning = utils_noop;

if (false) {}


;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/index.js






/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */

var instantsearch = function instantsearch(options) {
  return new lib_InstantSearch(options);
};

instantsearch.version = version;
instantsearch.createInfiniteHitsSessionStorageCache = deprecate(createInfiniteHitsSessionStorageCache, "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/helpers'");
instantsearch.highlight = deprecate(highlight_highlight, "import { highlight } from 'instantsearch.js/es/helpers'");
instantsearch.reverseHighlight = deprecate(reverseHighlight_reverseHighlight, "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
instantsearch.snippet = deprecate(snippet_snippet, "import { snippet } from 'instantsearch.js/es/helpers'");
instantsearch.reverseSnippet = deprecate(reverseSnippet_reverseSnippet, "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
instantsearch.insights = insights_insights;
instantsearch.getInsightsAnonymousUserToken = getInsightsAnonymousUserToken;
Object.defineProperty(instantsearch, 'widgets', {
  get: function get() {
    throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
  }
});
Object.defineProperty(instantsearch, 'connectors', {
  get: function get() {
    throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
  }
});
/* harmony default export */ var es = (instantsearch);

;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/package.json.js
var package_json_r = "4.3.3";

;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/polyfills.js
function polyfills_e(e) {
  for (var r = arguments, n = 1; n < arguments.length; n++) {
    var o = null != r[n] ? r[n] : {},
        c = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (c = c.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), c.forEach(function (r) {
      polyfills_t(e, r, o[r]);
    });
  }

  return e;
}

function polyfills_t(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/createInstantSearchComponent.js






var createInstantSearchComponent_i = function (i) {
  var s;
  return polyfills_e(((s = {
    mixins: [suit_t({
      name: "InstantSearch"
    })],
    provide: function () {
      return {
        $_ais_instantSearchInstance: this.instantSearchInstance
      };
    },
    watch: {
      searchClient: function (n) {
        this.instantSearchInstance.helper.setClient(n).search();
      },
      indexName: function (n) {
        this.instantSearchInstance.helper.setIndex(n).search();
      },
      stalledSearchDelay: function (n) {
        this.instantSearchInstance._stalledSearchDelay = n;
      },
      routing: function () {
        throw new Error("routing configuration can not be changed dynamically at this point.\n\nPlease open a new issue: https://github.com/algolia/vue-instantsearch/issues/new?template=feature.md");
      },
      searchFunction: function (n) {
        this.instantSearchInstance._searchFunction = n;
      },
      middlewares: {
        immediate: !0,
        handler: function (n, t) {
          var e = this;
          (t || []).filter(function (t) {
            return -1 === (n || []).indexOf(t);
          }).forEach(function (n) {
            e.instantSearchInstance.unuse(n);
          }), (n || []).filter(function (n) {
            return -1 === (t || []).indexOf(n);
          }).forEach(function (n) {
            e.instantSearchInstance.use(n);
          });
        }
      }
    },
    created: function () {
      var n = this.instantSearchInstance.client;
      "function" == typeof n.addAlgoliaAgent && (n.addAlgoliaAgent("Vue (" + index_vue2_n + ")"), n.addAlgoliaAgent("Vue InstantSearch (" + package_json_r + ")"));
    },
    mounted: function () {
      var n = this;
      this.$nextTick(function () {
        n.instantSearchInstance.started || n.instantSearchInstance.start();
      });
    }
  }).beforeDestroy = function () {
    this.instantSearchInstance.started && this.instantSearchInstance.dispose(), this.instantSearchInstance.__initialSearchResults = void 0;
  }, s), i);
};


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/InstantSearch.js




var InstantSearch_r = "Vue InstantSearch: You used the prop api-key or app-id.\nThese have been replaced by search-client.\n\nSee more info here: https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-search-client";
/* harmony default export */ var components_InstantSearch = (createInstantSearchComponent_i({
  name: "AisInstantSearch",
  props: {
    searchClient: {
      type: Object,
      required: !0
    },
    insightsClient: {
      type: Function,
      default: void 0
    },
    indexName: {
      type: String,
      required: !0
    },
    routing: {
      default: void 0,
      validator: function (e) {
        return !("boolean" == typeof e || !e.router && !e.stateMapping) || (a("The `routing` option expects an object with `router` and/or `stateMapping`.\n\nSee https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-routing"), !1);
      }
    },
    stalledSearchDelay: {
      type: Number,
      default: void 0
    },
    searchFunction: {
      type: Function,
      default: void 0
    },
    initialUiState: {
      type: Object,
      default: void 0
    },
    apiKey: {
      type: String,
      default: void 0,
      validator: function (e) {
        return e && a(InstantSearch_r), !1;
      }
    },
    appId: {
      type: String,
      default: void 0,
      validator: function (e) {
        return e && a(InstantSearch_r), !1;
      }
    },
    middlewares: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      instantSearchInstance: es({
        searchClient: this.searchClient,
        insightsClient: this.insightsClient,
        indexName: this.indexName,
        routing: this.routing,
        stalledSearchDelay: this.stalledSearchDelay,
        searchFunction: this.searchFunction,
        initialUiState: this.initialUiState
      })
    };
  },
  render: o(function (e) {
    var i;
    return e("div", {
      class: (i = {}, i[this.suit()] = !0, i[this.suit("", "ssr")] = !1, i)
    }, f(this));
  })
}));
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/InstantSearchSsr.js



/* harmony default export */ var InstantSearchSsr = (createInstantSearchComponent_i({
  name: "AisInstantSearchSsr",
  inject: {
    $_ais_ssrInstantSearchInstance: {
      default: function () {
        throw new Error("`createServerRootMixin` is required when using SSR.");
      }
    }
  },
  data: function () {
    return {
      instantSearchInstance: this.$_ais_ssrInstantSearchInstance
    };
  },
  render: o(function (t) {
    var e;
    return t("div", {
      class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !0, e)
    }, f(this));
  })
}));
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/infinite-hits/connectInfiniteHits.js


function connectInfiniteHits_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectInfiniteHits_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectInfiniteHits_ownKeys(Object(source), true).forEach(function (key) {
        connectInfiniteHits_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectInfiniteHits_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectInfiniteHits_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectInfiniteHits_toConsumableArray(arr) {
  return connectInfiniteHits_arrayWithoutHoles(arr) || connectInfiniteHits_iterableToArray(arr) || connectInfiniteHits_unsupportedIterableToArray(arr) || connectInfiniteHits_nonIterableSpread();
}

function connectInfiniteHits_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectInfiniteHits_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectInfiniteHits_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectInfiniteHits_arrayLikeToArray(o, minLen);
}

function connectInfiniteHits_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectInfiniteHits_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectInfiniteHits_arrayLikeToArray(arr);
}

function connectInfiniteHits_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectInfiniteHits_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = connectInfiniteHits_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function connectInfiniteHits_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}


var connectInfiniteHits_withUsage = createDocumentationMessageGenerator({
  name: 'infinite-hits',
  connector: true
});

function connectInfiniteHits_getStateWithoutPage(state) {
  var _ref = state || {},
      page = _ref.page,
      rest = connectInfiniteHits_objectWithoutProperties(_ref, ["page"]);

  return rest;
}

function getInMemoryCache() {
  var cachedHits = null;
  var cachedState = null;
  return {
    read: function read(_ref2) {
      var state = _ref2.state;
      return utils_isEqual(cachedState, connectInfiniteHits_getStateWithoutPage(state)) ? cachedHits : null;
    },
    write: function write(_ref3) {
      var state = _ref3.state,
          hits = _ref3.hits;
      cachedState = connectInfiniteHits_getStateWithoutPage(state);
      cachedHits = hits;
    }
  };
}

function extractHitsFromCachedHits(cachedHits) {
  return Object.keys(cachedHits).map(Number).sort(function (a, b) {
    return a - b;
  }).reduce(function (acc, page) {
    return acc.concat(cachedHits[page]);
  }, []);
}

var connectInfiniteHits = function connectInfiniteHits(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectInfiniteHits_withUsage()); // @TODO: this should be a generic, but a Connector can not yet be generic itself

  return function (widgetParams) {
    var _ref4 = widgetParams || {},
        _ref4$escapeHTML = _ref4.escapeHTML,
        escapeHTML = _ref4$escapeHTML === void 0 ? true : _ref4$escapeHTML,
        _ref4$transformItems = _ref4.transformItems,
        transformItems = _ref4$transformItems === void 0 ? function (items) {
      return items;
    } : _ref4$transformItems,
        _ref4$cache = _ref4.cache,
        cache = _ref4$cache === void 0 ? getInMemoryCache() : _ref4$cache;

    var showPrevious;
    var showMore;
    var sendEvent;
    var bindEvent;

    var getFirstReceivedPage = function getFirstReceivedPage(state, cachedHits) {
      var _state$page = state.page,
          page = _state$page === void 0 ? 0 : _state$page;
      var pages = Object.keys(cachedHits).map(Number);

      if (pages.length === 0) {
        return page;
      } else {
        return Math.min.apply(Math, [page].concat(connectInfiniteHits_toConsumableArray(pages)));
      }
    };

    var getLastReceivedPage = function getLastReceivedPage(state, cachedHits) {
      var _state$page2 = state.page,
          page = _state$page2 === void 0 ? 0 : _state$page2;
      var pages = Object.keys(cachedHits).map(Number);

      if (pages.length === 0) {
        return page;
      } else {
        return Math.max.apply(Math, [page].concat(connectInfiniteHits_toConsumableArray(pages)));
      }
    };

    var getShowPrevious = function getShowPrevious(helper) {
      return function () {
        // Using the helper's `overrideStateWithoutTriggeringChangeEvent` method
        // avoid updating the browser URL when the user displays the previous page.
        helper.overrideStateWithoutTriggeringChangeEvent(connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, helper.state), {}, {
          page: getFirstReceivedPage(helper.state, cache.read({
            state: helper.state
          }) || {}) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    };

    var getShowMore = function getShowMore(helper) {
      return function () {
        helper.setPage(getLastReceivedPage(helper.state, cache.read({
          state: helper.state
        }) || {}) + 1).search();
      };
    };

    return {
      $$type: 'ais.infiniteHits',
      init: function init(initOptions) {
        renderFn(connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        var widgetRenderState = this.getWidgetRenderState(renderOptions);
        renderFn(connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, widgetRenderState), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
        sendEvent('view', widgetRenderState.currentPageHits);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, renderState), {}, {
          infiniteHits: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref5) {
        var results = _ref5.results,
            helper = _ref5.helper,
            state = _ref5.state,
            instantSearchInstance = _ref5.instantSearchInstance;
        var isFirstPage;
        var currentPageHits = [];
        var cachedHits = cache.read({
          state: state
        }) || {};

        if (!results) {
          showPrevious = getShowPrevious(helper);
          showMore = getShowMore(helper);
          sendEvent = createSendEventForHits({
            instantSearchInstance: instantSearchInstance,
            index: helper.getIndex(),
            widgetType: this.$$type
          });
          bindEvent = createBindEventForHits({
            index: helper.getIndex(),
            widgetType: this.$$type
          });
          isFirstPage = state.page === undefined || getFirstReceivedPage(state, cachedHits) === 0;
        } else {
          var _state$page3 = state.page,
              _page = _state$page3 === void 0 ? 0 : _state$page3;

          if (escapeHTML && results.hits.length > 0) {
            results.hits = escapeHits(results.hits);
          }

          var hitsWithAbsolutePosition = addAbsolutePosition(results.hits, results.page, results.hitsPerPage);
          var hitsWithAbsolutePositionAndQueryID = addQueryID(hitsWithAbsolutePosition, results.queryID);
          var transformedHits = transformItems(hitsWithAbsolutePositionAndQueryID, {
            results: results
          });

          if (cachedHits[_page] === undefined && !results.__isArtificial) {
            cachedHits[_page] = transformedHits;
            cache.write({
              state: state,
              hits: cachedHits
            });
          }

          currentPageHits = transformedHits;
          isFirstPage = getFirstReceivedPage(state, cachedHits) === 0;
        }

        var hits = extractHitsFromCachedHits(cachedHits);
        var isLastPage = results ? results.nbPages <= getLastReceivedPage(state, cachedHits) + 1 : true;
        return {
          hits: hits,
          currentPageHits: currentPageHits,
          sendEvent: sendEvent,
          bindEvent: bindEvent,
          results: results,
          showPrevious: showPrevious,
          showMore: showMore,
          isFirstPage: isFirstPage,
          isLastPage: isLastPage,
          widgetParams: widgetParams
        };
      },
      dispose: function dispose(_ref6) {
        var state = _ref6.state;
        unmountFn();
        var stateWithoutPage = state.setQueryParameter('page', undefined);

        if (!escapeHTML) {
          return stateWithoutPage;
        }

        return stateWithoutPage.setQueryParameters(Object.keys(TAG_PLACEHOLDER).reduce(function (acc, key) {
          return connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, acc), {}, connectInfiniteHits_defineProperty({}, key, undefined));
        }, {}));
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref7) {
        var searchParameters = _ref7.searchParameters;
        var page = searchParameters.page || 0;

        if (!page) {
          // return without adding `page` to uiState
          // because we don't want `page=1` in the URL
          return uiState;
        }

        return connectInfiniteHits_objectSpread(connectInfiniteHits_objectSpread({}, uiState), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: page + 1
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref8) {
        var uiState = _ref8.uiState;
        var widgetSearchParameters = searchParameters;

        if (escapeHTML) {
          widgetSearchParameters = searchParameters.setQueryParameters(TAG_PLACEHOLDER);
        } // The page in the search parameters is decremented by one
        // to get to the actual parameter value from the UI state.


        var page = uiState.page ? uiState.page - 1 : 0;
        return widgetSearchParameters.setQueryParameter('page', page);
      }
    };
  };
};

/* harmony default export */ var infinite_hits_connectInfiniteHits = (connectInfiniteHits);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/infinite-hits/connectInfiniteHitsWithInsights.js


var connectInfiniteHitsWithInsights = withInsights(infinite_hits_connectInfiniteHits);
/* harmony default export */ var infinite_hits_connectInfiniteHitsWithInsights = (connectInfiniteHitsWithInsights);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/InfiniteHits.vue.js



/* harmony default export */ var InfiniteHits_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: e.suit()
    }, [e.showPrevious ? e._t("loadPrevious", [s("button", {
      class: [e.suit("loadPrevious"), e.state.isFirstPage && e.suit("loadPrevious", "disabled")],
      attrs: {
        disabled: e.state.isFirstPage
      },
      on: {
        click: function (t) {
          return e.refinePrevious();
        }
      }
    }, [e._v("Show previous results")])], {
      refinePrevious: e.refinePrevious,
      page: e.state.results.page,
      isFirstPage: e.state.isFirstPage
    }) : e._e(), e._v(" "), e._t("default", [s("ol", {
      class: e.suit("list")
    }, e._l(e.items, function (t, i) {
      return s("li", {
        key: t.objectID,
        class: e.suit("item")
      }, [e._t("item", [e._v("objectID: " + e._s(t.objectID) + ", index: " + e._s(i))], {
        item: t,
        index: i,
        insights: e.state.insights
      })], 2);
    }), 0), e._v(" "), e._t("loadMore", [s("button", {
      class: [e.suit("loadMore"), e.state.isLastPage && e.suit("loadMore", "disabled")],
      attrs: {
        disabled: e.state.isLastPage
      },
      on: {
        click: function (t) {
          return e.refineNext();
        }
      }
    }, [e._v("Show more results")])], {
      refineNext: e.refineNext,
      refine: e.refineNext,
      page: e.state.results.page,
      isLastPage: e.state.isLastPage
    })], {
      items: e.items,
      results: e.state.results,
      isLastPage: e.state.isLastPage,
      refinePrevious: e.refinePrevious,
      refineNext: e.refineNext,
      refine: e.refineNext,
      insights: e.state.insights,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisInfiniteHits",
  mixins: [widget_e({
    connector: infinite_hits_connectInfiniteHitsWithInsights
  }), suit_t({
    name: "InfiniteHits"
  })],
  props: {
    showPrevious: {
      type: Boolean,
      default: !1
    },
    escapeHTML: {
      type: Boolean,
      default: !0
    },
    transformItems: {
      type: Function,
      default: void 0
    },
    cache: {
      type: Object,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        showPrevious: this.showPrevious,
        escapeHTML: this.escapeHTML,
        transformItems: this.transformItems,
        cache: this.cache
      };
    },
    items: function () {
      return this.state.hits;
    }
  },
  methods: {
    refinePrevious: function () {
      this.state.showPrevious();
    },
    refineNext: function () {
      this.state.showMore();
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/menu/connectMenu.js


function connectMenu_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = connectMenu_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function connectMenu_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function connectMenu_slicedToArray(arr, i) {
  return connectMenu_arrayWithHoles(arr) || connectMenu_iterableToArrayLimit(arr, i) || connectMenu_unsupportedIterableToArray(arr, i) || connectMenu_nonIterableRest();
}

function connectMenu_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectMenu_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectMenu_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectMenu_arrayLikeToArray(o, minLen);
}

function connectMenu_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectMenu_iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function connectMenu_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function connectMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectMenu_ownKeys(Object(source), true).forEach(function (key) {
        connectMenu_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectMenu_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectMenu_withUsage = createDocumentationMessageGenerator({
  name: 'menu',
  connector: true
});
var connectMenu_DEFAULT_SORT = ['isRefined', 'name:asc'];
/**
 * **Menu** connector provides the logic to build a widget that will give the user the ability to choose a single value for a specific facet. The typical usage of menu is for navigation in categories.
 *
 * This connector provides a `toggleShowMore()` function to display more or less items and a `refine()`
 * function to select an item. While selecting a new element, the `refine` will also unselect the
 * one that is currently selected.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in "attributes for faceting" on the Algolia dashboard or configured as attributesForFaceting via a set settings call to the Algolia API.
 */

var connectMenu = function connectMenu(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectMenu_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        attribute = _ref.attribute,
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? 10 : _ref$limit,
        _ref$showMore = _ref.showMore,
        showMore = _ref$showMore === void 0 ? false : _ref$showMore,
        _ref$showMoreLimit = _ref.showMoreLimit,
        showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit,
        _ref$sortBy = _ref.sortBy,
        sortBy = _ref$sortBy === void 0 ? connectMenu_DEFAULT_SORT : _ref$sortBy,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (!attribute) {
      throw new Error(connectMenu_withUsage('The `attribute` option is required.'));
    }

    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(connectMenu_withUsage('The `showMoreLimit` option must be greater than `limit`.'));
    }

    var sendEvent;

    var _createURL;

    var _refine; // Provide the same function to the `renderFn` so that way the user
    // has to only bind it once when `isFirstRendering` for instance


    var isShowingMore = false;

    var toggleShowMore = function toggleShowMore() {};

    function createToggleShowMore(renderOptions, widget) {
      return function () {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }

    function cachedToggleShowMore() {
      toggleShowMore();
    }

    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }

    return {
      $$type: 'ais.menu',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectMenu_objectSpread(connectMenu_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectMenu_objectSpread(connectMenu_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref2) {
        var state = _ref2.state;
        unmountFn();
        return state.removeHierarchicalFacet(attribute).setQueryParameter('maxValuesPerFacet', undefined);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectMenu_objectSpread(connectMenu_objectSpread({}, renderState), {}, {
          menu: connectMenu_objectSpread(connectMenu_objectSpread({}, renderState.menu), {}, connectMenu_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var results = renderOptions.results,
            createURL = renderOptions.createURL,
            instantSearchInstance = renderOptions.instantSearchInstance,
            helper = renderOptions.helper;
        var items = [];
        var canToggleShowMore = false;

        if (!sendEvent) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            attribute: attribute,
            widgetType: this.$$type
          });
        }

        if (!_createURL) {
          _createURL = function _createURL(facetValue) {
            return createURL(helper.state.resetPage().toggleFacetRefinement(attribute, facetValue));
          };
        }

        if (!_refine) {
          _refine = function _refine(facetValue) {
            var _helper$getHierarchic = helper.getHierarchicalFacetBreadcrumb(attribute),
                _helper$getHierarchic2 = connectMenu_slicedToArray(_helper$getHierarchic, 1),
                refinedItem = _helper$getHierarchic2[0];

            sendEvent('click', facetValue ? facetValue : refinedItem);
            helper.toggleFacetRefinement(attribute, facetValue ? facetValue : refinedItem).search();
          };
        }

        if (renderOptions.results) {
          toggleShowMore = createToggleShowMore(renderOptions, this);
        }

        if (results) {
          var facetValues = results.getFacetValues(attribute, {
            sortBy: sortBy,
            facetOrdering: sortBy === connectMenu_DEFAULT_SORT
          });
          var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
          canToggleShowMore = showMore && (isShowingMore || facetItems.length > getLimit());
          items = transformItems(facetItems.slice(0, getLimit()).map(function (_ref3) {
            var label = _ref3.name,
                value = _ref3.escapedValue,
                path = _ref3.path,
                item = connectMenu_objectWithoutProperties(_ref3, ["name", "escapedValue", "path"]);

            return connectMenu_objectSpread(connectMenu_objectSpread({}, item), {}, {
              label: label,
              value: value
            });
          }), {
            results: results
          });
        }

        return {
          items: items,
          createURL: _createURL,
          refine: _refine,
          sendEvent: sendEvent,
          canRefine: items.length > 0,
          widgetParams: widgetParams,
          isShowingMore: isShowingMore,
          toggleShowMore: cachedToggleShowMore,
          canToggleShowMore: canToggleShowMore
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
        var searchParameters = _ref4.searchParameters;

        var _searchParameters$get = searchParameters.getHierarchicalFacetBreadcrumb(attribute),
            _searchParameters$get2 = connectMenu_slicedToArray(_searchParameters$get, 1),
            value = _searchParameters$get2[0];

        if (!value) {
          return uiState;
        }

        return connectMenu_objectSpread(connectMenu_objectSpread({}, uiState), {}, {
          menu: connectMenu_objectSpread(connectMenu_objectSpread({}, uiState.menu), {}, connectMenu_defineProperty({}, attribute, value))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
        var uiState = _ref5.uiState;
        var value = uiState.menu && uiState.menu[attribute];
        var withFacetConfiguration = searchParameters.removeHierarchicalFacet(attribute).addHierarchicalFacet({
          name: attribute,
          attributes: [attribute]
        });
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);

        if (!value) {
          return withMaxValuesPerFacet.setQueryParameters({
            hierarchicalFacetsRefinements: connectMenu_objectSpread(connectMenu_objectSpread({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, connectMenu_defineProperty({}, attribute, []))
          });
        }

        return withMaxValuesPerFacet.addHierarchicalFacetRefinement(attribute, value);
      }
    };
  };
};

/* harmony default export */ var menu_connectMenu = (connectMenu);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Menu.vue.js




/* harmony default export */ var Menu_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: [e.suit(), !e.state.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", [s("ul", {
      class: e.suit("list")
    }, e._l(e.state.items, function (t) {
      return s("li", {
        key: t.value,
        class: [e.suit("item"), t.isRefined && e.suit("item", "selected")]
      }, [s("a", {
        class: e.suit("link"),
        attrs: {
          href: e.state.createURL(t.value)
        },
        on: {
          click: function (s) {
            return s.preventDefault(), e.state.refine(t.value);
          }
        }
      }, [s("span", {
        class: e.suit("label")
      }, [e._v(e._s(t.label))]), e._v(" "), s("span", {
        class: e.suit("count")
      }, [e._v(e._s(t.count))])])]);
    }), 0), e._v(" "), e.showShowMoreButton ? s("button", {
      class: [e.suit("showMore"), !e.state.canToggleShowMore && e.suit("showMore", "disabled")],
      attrs: {
        disabled: !e.state.canToggleShowMore
      },
      on: {
        click: function (t) {
          return t.preventDefault(), e.state.toggleShowMore();
        }
      }
    }, [e._t("showMoreLabel", [e._v(e._s(e.state.isShowingMore ? "Show less" : "Show more"))], {
      isShowingMore: e.state.isShowingMore
    })], 2) : e._e()], {
      items: e.state.items,
      canRefine: e.state.canRefine,
      canToggleShowMore: e.state.canToggleShowMore,
      isShowingMore: e.state.isShowingMore,
      refine: e.state.refine,
      createURL: e.state.createURL,
      toggleShowMore: e.state.toggleShowMore,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisMenu",
  mixins: [suit_t({
    name: "Menu"
  }), widget_e({
    connector: menu_connectMenu
  }), r({
    mapStateToCanRefine: function (e) {
      return Boolean(e.canRefine);
    }
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    limit: {
      type: Number,
      default: void 0
    },
    showMoreLimit: {
      type: Number,
      default: void 0
    },
    showMore: {
      type: Boolean,
      default: !1
    },
    sortBy: {
      type: [Array, Function],
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        limit: this.limit,
        showMore: this.showMore,
        showMoreLimit: this.showMoreLimit,
        sortBy: this.sortBy,
        transformItems: this.transformItems
      };
    },
    showShowMoreButton: function () {
      return this.state.canRefine && this.showMore;
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/MenuSelect.vue.js




/* harmony default export */ var MenuSelect_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        n = t._self._c || e;
    return t.state ? n("div", {
      class: [t.suit(), !t.state.canRefine && t.suit("", "noRefinement")]
    }, [t._t("default", [n("select", {
      class: t.suit("select"),
      on: {
        change: function (e) {
          return t.refine(e.currentTarget.value);
        }
      }
    }, [n("option", {
      class: t.suit("option"),
      attrs: {
        value: ""
      }
    }, [t._t("defaultOption", [t._v("See all")])], 2), t._v(" "), t._l(t.state.items, function (e) {
      return n("option", {
        key: e.value,
        class: t.suit("option"),
        domProps: {
          value: e.value,
          selected: e.isRefined
        }
      }, [t._t("item", [t._v(t._s(e.label) + " (" + t._s(e.count) + ")")], {
        item: e
      })], 2);
    })], 2)], {
      items: t.state.items,
      canRefine: t.state.canRefine,
      refine: t.refine,
      createURL: t.state.createURL,
      sendEvent: t.state.sendEvent
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisMenuSelect",
  mixins: [suit_t({
    name: "MenuSelect"
  }), widget_e({
    connector: menu_connectMenu
  }), r({
    mapStateToCanRefine: function (t) {
      return Boolean(t.canRefine);
    }
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    limit: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [Array, Function],
      default: void 0
    },
    transformItems: {
      type: Function,
      default: function (t) {
        return t;
      }
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        limit: this.limit,
        sortBy: this.sortBy,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    refine: function (t) {
      this.state.refine(t);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/convertNumericRefinementsToFilters.js
function convertNumericRefinementsToFilters(state, attribute) {
  if (!state) {
    return null;
  }

  var filtersObj = state.numericRefinements[attribute];
  /*
    filtersObj === {
      "<=": [10],
      "=": [],
      ">=": [5]
    }
  */

  var filters = [];
  Object.keys(filtersObj).filter(function (operator) {
    return Array.isArray(filtersObj[operator]) && filtersObj[operator].length > 0;
  }).forEach(function (operator) {
    filtersObj[operator].forEach(function (value) {
      filters.push("".concat(attribute).concat(operator).concat(value));
    });
  });
  return filters;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/isFiniteNumber.js
// This is the `Number.isFinite()` polyfill recommended by MDN.
// We do not provide any tests for this function.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite#Polyfill
function isFiniteNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

/* harmony default export */ var utils_isFiniteNumber = (isFiniteNumber);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/numeric-menu/connectNumericMenu.js


function connectNumericMenu_slicedToArray(arr, i) {
  return connectNumericMenu_arrayWithHoles(arr) || connectNumericMenu_iterableToArrayLimit(arr, i) || connectNumericMenu_unsupportedIterableToArray(arr, i) || connectNumericMenu_nonIterableRest();
}

function connectNumericMenu_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectNumericMenu_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectNumericMenu_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectNumericMenu_arrayLikeToArray(o, minLen);
}

function connectNumericMenu_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectNumericMenu_iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function connectNumericMenu_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function connectNumericMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectNumericMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectNumericMenu_ownKeys(Object(source), true).forEach(function (key) {
        connectNumericMenu_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectNumericMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectNumericMenu_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectNumericMenu_withUsage = createDocumentationMessageGenerator({
  name: 'numeric-menu',
  connector: true
});
var $$type = 'ais.numericMenu';

var createSendEvent = function createSendEvent(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
      helper = _ref.helper,
      attribute = _ref.attribute;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }

    var eventType = args[0],
        facetValue = args[1],
        _args$ = args[2],
        eventName = _args$ === void 0 ? 'Filter Applied' : _args$;

    if (eventType !== 'click') {
      return;
    } // facetValue === "%7B%22start%22:5,%22end%22:10%7D"


    var filters = convertNumericRefinementsToFilters(getRefinedState(helper.state, attribute, facetValue), attribute);

    if (filters && filters.length > 0) {
      /*
        filters === ["price<=10", "price>=5"]
      */
      instantSearchInstance.sendEventToInsights({
        insightsMethod: 'clickedFilters',
        widgetType: $$type,
        eventType: eventType,
        payload: {
          eventName: eventName,
          index: helper.getIndex(),
          filters: filters
        },
        attribute: attribute
      });
    }
  };
};

var connectNumericMenu = function connectNumericMenu(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectNumericMenu_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        _ref2$attribute = _ref2.attribute,
        attribute = _ref2$attribute === void 0 ? '' : _ref2$attribute,
        _ref2$items = _ref2.items,
        items = _ref2$items === void 0 ? [] : _ref2$items,
        _ref2$transformItems = _ref2.transformItems,
        transformItems = _ref2$transformItems === void 0 ? function (item) {
      return item;
    } : _ref2$transformItems;

    if (attribute === '') {
      throw new Error(connectNumericMenu_withUsage('The `attribute` option is required.'));
    }

    if (!items || items.length === 0) {
      throw new Error(connectNumericMenu_withUsage('The `items` option expects an array of objects.'));
    }

    var prepareItems = function prepareItems(state) {
      return items.map(function (_ref3) {
        var start = _ref3.start,
            end = _ref3.end,
            label = _ref3.label;
        return {
          label: label,
          value: encodeURI(JSON.stringify({
            start: start,
            end: end
          })),
          isRefined: isRefined(state, attribute, {
            start: start,
            end: end,
            label: label
          })
        };
      });
    };

    var connectorState = {};
    return {
      $$type: $$type,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref4) {
        var state = _ref4.state;
        unmountFn();
        return state.clearRefinements(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        var values = searchParameters.getNumericRefinements(attribute);
        var equal = values['='] && values['='][0];

        if (equal || equal === 0) {
          return connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, uiState), {}, {
            numericMenu: connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, uiState.numericMenu), {}, connectNumericMenu_defineProperty({}, attribute, "".concat(values['='])))
          });
        }

        var min = values['>='] && values['>='][0] || '';
        var max = values['<='] && values['<='][0] || '';

        if (min === '' && max === '') {
          return uiState;
        }

        return connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, uiState), {}, {
          numericMenu: connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, uiState.numericMenu), {}, connectNumericMenu_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
        var uiState = _ref6.uiState;
        var value = uiState.numericMenu && uiState.numericMenu[attribute];
        var withoutRefinements = searchParameters.clearRefinements(attribute);

        if (!value) {
          return withoutRefinements.setQueryParameters({
            numericRefinements: connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, withoutRefinements.numericRefinements), {}, connectNumericMenu_defineProperty({}, attribute, {}))
          });
        }

        var isExact = value.indexOf(':') === -1;

        if (isExact) {
          return withoutRefinements.addNumericRefinement(attribute, '=', Number(value));
        }

        var _value$split$map = value.split(':').map(parseFloat),
            _value$split$map2 = connectNumericMenu_slicedToArray(_value$split$map, 2),
            min = _value$split$map2[0],
            max = _value$split$map2[1];

        var withMinRefinement = utils_isFiniteNumber(min) ? withoutRefinements.addNumericRefinement(attribute, '>=', min) : withoutRefinements;
        var withMaxRefinement = utils_isFiniteNumber(max) ? withMinRefinement.addNumericRefinement(attribute, '<=', max) : withMinRefinement;
        return withMaxRefinement;
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, renderState), {}, {
          numericMenu: connectNumericMenu_objectSpread(connectNumericMenu_objectSpread({}, renderState.numericMenu), {}, connectNumericMenu_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref7) {
        var results = _ref7.results,
            state = _ref7.state,
            instantSearchInstance = _ref7.instantSearchInstance,
            helper = _ref7.helper,
            createURL = _ref7.createURL;

        if (!connectorState.refine) {
          connectorState.refine = function (facetValue) {
            var refinedState = getRefinedState(helper.state, attribute, facetValue);
            connectorState.sendEvent('click', facetValue);
            helper.setState(refinedState).search();
          };
        }

        if (!connectorState.createURL) {
          connectorState.createURL = function (newState) {
            return function (facetValue) {
              return createURL(getRefinedState(newState, attribute, facetValue));
            };
          };
        }

        if (!connectorState.sendEvent) {
          connectorState.sendEvent = createSendEvent({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            attribute: attribute
          });
        }

        return {
          createURL: connectorState.createURL(state),
          items: transformItems(prepareItems(state), {
            results: results
          }),
          hasNoResults: results ? results.nbHits === 0 : true,
          refine: connectorState.refine,
          sendEvent: connectorState.sendEvent,
          widgetParams: widgetParams
        };
      }
    };
  };
};

function isRefined(state, attribute, option) {
  // @TODO: same as another spot, why is this mixing arrays & elements?
  var currentRefinements = state.getNumericRefinements(attribute);

  if (option.start !== undefined && option.end !== undefined) {
    if (option.start === option.end) {
      return hasNumericRefinement(currentRefinements, '=', option.start);
    } else {
      return hasNumericRefinement(currentRefinements, '>=', option.start) && hasNumericRefinement(currentRefinements, '<=', option.end);
    }
  }

  if (option.start !== undefined) {
    return hasNumericRefinement(currentRefinements, '>=', option.start);
  }

  if (option.end !== undefined) {
    return hasNumericRefinement(currentRefinements, '<=', option.end);
  }

  if (option.start === undefined && option.end === undefined) {
    return Object.keys(currentRefinements).every(function (operator) {
      return (currentRefinements[operator] || []).length === 0;
    });
  }

  return false;
}

function getRefinedState(state, attribute, facetValue) {
  var resolvedState = state;
  var refinedOption = JSON.parse(decodeURI(facetValue)); // @TODO: why is array / element mixed here & hasRefinements; seems wrong?

  var currentRefinements = resolvedState.getNumericRefinements(attribute);

  if (refinedOption.start === undefined && refinedOption.end === undefined) {
    return resolvedState.removeNumericRefinement(attribute);
  }

  if (!isRefined(resolvedState, attribute, refinedOption)) {
    resolvedState = resolvedState.removeNumericRefinement(attribute);
  }

  if (refinedOption.start !== undefined && refinedOption.end !== undefined) {
    if (refinedOption.start > refinedOption.end) {
      throw new Error('option.start should be > to option.end');
    }

    if (refinedOption.start === refinedOption.end) {
      if (hasNumericRefinement(currentRefinements, '=', refinedOption.start)) {
        resolvedState = resolvedState.removeNumericRefinement(attribute, '=', refinedOption.start);
      } else {
        resolvedState = resolvedState.addNumericRefinement(attribute, '=', refinedOption.start);
      }

      return resolvedState;
    }
  }

  if (refinedOption.start !== undefined) {
    if (hasNumericRefinement(currentRefinements, '>=', refinedOption.start)) {
      resolvedState = resolvedState.removeNumericRefinement(attribute, '>=', refinedOption.start);
    }

    resolvedState = resolvedState.addNumericRefinement(attribute, '>=', refinedOption.start);
  }

  if (refinedOption.end !== undefined) {
    if (hasNumericRefinement(currentRefinements, '<=', refinedOption.end)) {
      resolvedState = resolvedState.removeNumericRefinement(attribute, '<=', refinedOption.end);
    }

    resolvedState = resolvedState.addNumericRefinement(attribute, '<=', refinedOption.end);
  }

  if (typeof resolvedState.page === 'number') {
    resolvedState.page = 0;
  }

  return resolvedState;
}

function hasNumericRefinement(currentRefinements, operator, value) {
  return currentRefinements[operator] !== undefined && currentRefinements[operator].includes(value);
}

/* harmony default export */ var numeric_menu_connectNumericMenu = (connectNumericMenu);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/NumericMenu.vue.js




/* harmony default export */ var NumericMenu_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: [e.suit(), !e.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", [s("ul", {
      class: [e.suit("list")]
    }, e._l(e.state.items, function (t) {
      return s("li", {
        key: t.label,
        class: [e.suit("item"), t.isRefined && e.suit("item", "selected")]
      }, [s("label", {
        class: e.suit("label")
      }, [s("input", {
        class: e.suit("radio"),
        attrs: {
          type: "radio",
          name: e.attribute
        },
        domProps: {
          value: t.value,
          checked: t.isRefined
        },
        on: {
          change: function (t) {
            return e.state.refine(t.target.value);
          }
        }
      }), e._v(" "), s("span", {
        class: e.suit("labelText")
      }, [e._v(e._s(t.label))])])]);
    }), 0)], {
      items: e.state.items,
      canRefine: e.canRefine,
      refine: e.state.refine,
      createURL: e.state.createURL,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisNumericMenu",
  mixins: [widget_e({
    connector: numeric_menu_connectNumericMenu
  }), suit_t({
    name: "NumericMenu"
  }), r({
    mapStateToCanRefine: function (e) {
      return !1 === e.hasNoResults;
    }
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        transformItems: this.transformItems,
        items: this.items
      };
    },
    canRefine: function () {
      return !this.state.hasNoResults;
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/range.js


function range_toConsumableArray(arr) {
  return range_arrayWithoutHoles(arr) || range_iterableToArray(arr) || range_unsupportedIterableToArray(arr) || range_nonIterableSpread();
}

function range_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function range_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return range_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return range_arrayLikeToArray(o, minLen);
}

function range_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function range_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return range_arrayLikeToArray(arr);
}

function range_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function range(_ref) {
  var _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      end = _ref.end,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step; // We can't divide by 0 so we re-assign the step to 1 if it happens.

  var limitStep = step === 0 ? 1 : step; // In some cases the array to create has a decimal length.
  // We therefore need to round the value.
  // Example:
  //   { start: 1, end: 5000, step: 500 }
  //   => Array length = (5000 - 1) / 500 = 9.998

  var arrayLength = Math.round((end - start) / limitStep);
  return range_toConsumableArray(Array(arrayLength)).map(function (_, current) {
    return start + current * limitStep;
  });
}

/* harmony default export */ var utils_range = (range);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/pagination/Paginator.js


function Paginator_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Paginator_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function Paginator_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) Paginator_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) Paginator_defineProperties(Constructor, staticProps);
  return Constructor;
}

function Paginator_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var Paginator = /*#__PURE__*/function () {
  function Paginator(params) {
    Paginator_classCallCheck(this, Paginator);

    Paginator_defineProperty(this, "currentPage", void 0);

    Paginator_defineProperty(this, "total", void 0);

    Paginator_defineProperty(this, "padding", void 0);

    this.currentPage = params.currentPage;
    this.total = params.total;
    this.padding = params.padding;
  }

  Paginator_createClass(Paginator, [{
    key: "pages",
    value: function pages() {
      var total = this.total,
          currentPage = this.currentPage,
          padding = this.padding;
      if (total === 0) return [0];
      var totalDisplayedPages = this.nbPagesDisplayed(padding, total);

      if (totalDisplayedPages === total) {
        return utils_range({
          end: total
        });
      }

      var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
      var paddingRight = totalDisplayedPages - paddingLeft;
      var first = currentPage - paddingLeft;
      var last = currentPage + paddingRight;
      return utils_range({
        start: first,
        end: last
      });
    }
  }, {
    key: "nbPagesDisplayed",
    value: function nbPagesDisplayed(padding, total) {
      return Math.min(2 * padding + 1, total);
    }
  }, {
    key: "calculatePaddingLeft",
    value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
      if (current <= padding) {
        return current;
      }

      if (current >= total - padding) {
        return totalDisplayedPages - (total - current);
      }

      return padding;
    }
  }, {
    key: "isLastPage",
    value: function isLastPage() {
      return this.currentPage === this.total - 1 || this.total === 0;
    }
  }, {
    key: "isFirstPage",
    value: function isFirstPage() {
      return this.currentPage === 0;
    }
  }]);

  return Paginator;
}();

/* harmony default export */ var pagination_Paginator = (Paginator);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/pagination/connectPagination.js
function connectPagination_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectPagination_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectPagination_ownKeys(Object(source), true).forEach(function (key) {
        connectPagination_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectPagination_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectPagination_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var connectPagination_withUsage = createDocumentationMessageGenerator({
  name: 'pagination',
  connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */

var connectPagination = function connectPagination(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectPagination_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        totalPages = _ref.totalPages,
        _ref$padding = _ref.padding,
        padding = _ref$padding === void 0 ? 3 : _ref$padding;

    var pager = new pagination_Paginator({
      currentPage: 0,
      total: 0,
      padding: padding
    });
    var connectorState = {};

    function getMaxPage(_ref2) {
      var nbPages = _ref2.nbPages;
      return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
    }

    return {
      $$type: 'ais.pagination',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectPagination_objectSpread(connectPagination_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectPagination_objectSpread(connectPagination_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref3) {
        var state = _ref3.state;
        unmountFn();
        return state.setQueryParameter('page', undefined);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
        var searchParameters = _ref4.searchParameters;
        var page = searchParameters.page || 0;

        if (!page) {
          return uiState;
        }

        return connectPagination_objectSpread(connectPagination_objectSpread({}, uiState), {}, {
          page: page + 1
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
        var uiState = _ref5.uiState;
        var page = uiState.page ? uiState.page - 1 : 0;
        return searchParameters.setQueryParameter('page', page);
      },
      getWidgetRenderState: function getWidgetRenderState(_ref6) {
        var results = _ref6.results,
            helper = _ref6.helper,
            state = _ref6.state,
            createURL = _ref6.createURL;

        if (!connectorState.refine) {
          connectorState.refine = function (page) {
            helper.setPage(page);
            helper.search();
          };
        }

        if (!connectorState.createURL) {
          connectorState.createURL = function (helperState) {
            return function (page) {
              return createURL(helperState.setPage(page));
            };
          };
        }

        var page = state.page || 0;
        var nbPages = getMaxPage(results || {
          nbPages: 0
        });
        pager.currentPage = page;
        pager.total = nbPages;
        return {
          createURL: connectorState.createURL(state),
          refine: connectorState.refine,
          canRefine: nbPages > 1,
          currentRefinement: page,
          nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
          nbPages: nbPages,
          pages: results ? pager.pages() : [],
          isFirstPage: pager.isFirstPage(),
          isLastPage: pager.isLastPage(),
          widgetParams: widgetParams
        };
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectPagination_objectSpread(connectPagination_objectSpread({}, renderState), {}, {
          pagination: this.getWidgetRenderState(renderOptions)
        });
      }
    };
  };
};

/* harmony default export */ var pagination_connectPagination = (connectPagination);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Pagination.vue.js




/* harmony default export */ var Pagination_vue = ({
  render: function () {
    var t,
        e,
        s,
        a,
        i = this,
        n = i.$createElement,
        r = i._self._c || n;
    return i.state ? r("div", {
      class: i.suit()
    }, [i._t("default", [r("ul", {
      class: i.suit("list")
    }, [i.showFirst ? r("li", {
      class: (t = {}, t[i.suit("item")] = !0, t[i.suit("item", "firstPage")] = !0, t[i.suit("item", "disabled")] = i.state.isFirstPage, t)
    }, [i._t("first", [i.state.isFirstPage ? [r("span", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "First"
      }
    }, [i._v("‹‹")])] : [r("a", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "First",
        href: i.state.createURL(0)
      },
      on: {
        click: function (t) {
          return t.preventDefault(), i.refine(0);
        }
      }
    }, [i._v("‹‹")])]], {
      createURL: function () {
        return i.state.createURL(0);
      },
      isFirstPage: i.state.isFirstPage,
      refine: function () {
        return i.refine(0);
      }
    })], 2) : i._e(), i._v(" "), i.showPrevious ? r("li", {
      class: (e = {}, e[i.suit("item")] = !0, e[i.suit("item", "previousPage")] = !0, e[i.suit("item", "disabled")] = i.state.isFirstPage, e)
    }, [i._t("previous", [i.state.isFirstPage ? [r("span", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Previous"
      }
    }, [i._v("‹")])] : [r("a", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Previous",
        href: i.state.createURL(i.state.currentRefinement - 1)
      },
      on: {
        click: function (t) {
          return t.preventDefault(), i.refine(i.state.currentRefinement - 1);
        }
      }
    }, [i._v("‹")])]], {
      createURL: function () {
        return i.state.createURL(i.state.currentRefinement - 1);
      },
      isFirstPage: i.state.isFirstPage,
      refine: function () {
        return i.refine(i.state.currentRefinement - 1);
      }
    })], 2) : i._e(), i._v(" "), i._l(i.state.pages, function (t) {
      var e;
      return r("li", {
        key: t,
        class: (e = {}, e[i.suit("item")] = !0, e[i.suit("item", "selected")] = i.state.currentRefinement === t, e)
      }, [i._t("item", [r("a", {
        class: i.suit("link"),
        attrs: {
          href: i.state.createURL(t)
        },
        on: {
          click: function (e) {
            return e.preventDefault(), i.refine(t);
          }
        }
      }, [i._v(i._s(t + 1))])], {
        page: t,
        createURL: function () {
          return i.state.createURL(t);
        },
        isFirstPage: i.state.isFirstPage,
        isLastPage: i.state.isLastPage,
        refine: function () {
          return i.refine(t);
        }
      })], 2);
    }), i._v(" "), i.showNext ? r("li", {
      class: (s = {}, s[i.suit("item")] = !0, s[i.suit("item", "nextPage")] = !0, s[i.suit("item", "disabled")] = i.state.isLastPage, s)
    }, [i._t("next", [i.state.isLastPage ? [r("span", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Next"
      }
    }, [i._v("›")])] : [r("a", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Next",
        href: i.state.createURL(i.state.currentRefinement + 1)
      },
      on: {
        click: function (t) {
          return t.preventDefault(), i.refine(i.state.currentRefinement + 1);
        }
      }
    }, [i._v("›")])]], {
      createURL: function () {
        return i.state.createURL(i.state.currentRefinement + 1);
      },
      isLastPage: i.state.isLastPage,
      refine: function () {
        return i.refine(i.state.currentRefinement + 1);
      }
    })], 2) : i._e(), i._v(" "), i.showLast ? r("li", {
      class: (a = {}, a[i.suit("item")] = !0, a[i.suit("item", "lastPage")] = !0, a[i.suit("item", "disabled")] = i.state.isLastPage, a)
    }, [i._t("last", [i.state.isLastPage ? [r("span", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Last"
      }
    }, [i._v("››")])] : [r("a", {
      class: i.suit("link"),
      attrs: {
        "aria-label": "Last",
        href: i.state.createURL(i.state.nbPages - 1)
      },
      on: {
        click: function (t) {
          return t.preventDefault(), i.refine(i.state.nbPages - 1);
        }
      }
    }, [i._v("››")])]], {
      createURL: function () {
        return i.state.createURL(i.state.nbPages - 1);
      },
      isLastPage: i.state.isLastPage,
      refine: function () {
        return i.refine(i.state.nbPages - 1);
      }
    })], 2) : i._e()], 2)], {
      refine: i.refine,
      createURL: i.state.createURL,
      currentRefinement: i.state.currentRefinement,
      nbHits: i.state.nbHits,
      nbPages: i.state.nbPages,
      pages: i.state.pages,
      isFirstPage: i.state.isFirstPage,
      isLastPage: i.state.isLastPage
    })], 2) : i._e();
  },
  staticRenderFns: [],
  name: "AisPagination",
  mixins: [suit_t({
    name: "Pagination"
  }), widget_e({
    connector: pagination_connectPagination
  }), r({
    mapStateToCanRefine: function (t) {
      return t.nbPages > 1;
    }
  })],
  props: {
    padding: {
      type: Number,
      default: void 0,
      validator: function (t) {
        return t > 0;
      }
    },
    totalPages: {
      type: Number,
      default: void 0,
      validator: function (t) {
        return t > 0;
      }
    },
    showFirst: {
      type: Boolean,
      default: !0
    },
    showLast: {
      type: Boolean,
      default: !0
    },
    showNext: {
      type: Boolean,
      default: !0
    },
    showPrevious: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        padding: this.padding,
        totalPages: this.totalPages
      };
    }
  },
  emits: ["page-change"],
  methods: {
    refine: function (t) {
      var e = Math.min(Math.max(t, 0), this.state.nbPages - 1);
      this.state.refine(e), this.$emit("page-change", e);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Panel.vue.js



/* harmony default export */ var Panel_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return n("div", {
      class: [e.suit(), !e.canRefine && e.suit("", "noRefinement")]
    }, [e.getSlot("header") ? n("div", {
      class: e.suit("header")
    }, [e._t("header", null, {
      hasRefinements: e.canRefine
    })], 2) : e._e(), e._v(" "), n("div", {
      class: e.suit("body")
    }, [e._t("default", null, {
      hasRefinements: e.canRefine
    })], 2), e._v(" "), e.getSlot("footer") ? n("div", {
      class: e.suit("footer")
    }, [e._t("footer", null, {
      hasRefinements: e.canRefine
    })], 2) : e._e()]);
  },
  staticRenderFns: [],
  name: "AisPanel",
  mixins: [suit_t({
    name: "Panel"
  }), i()],
  methods: {
    getSlot: function (e) {
      return this.$slots[e] || this.$scopedSlots[e];
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/PoweredBy.vue.js

/* harmony default export */ var PoweredBy_vue = ({
  render: function () {
    var a = this,
        c = a.$createElement,
        t = a._self._c || c;
    return t("div", {
      class: a.suit()
    }, [t("a", {
      class: a.suit("link"),
      attrs: {
        href: a.algoliaUrl,
        target: "_blank",
        rel: "noopener",
        "aria-label": "search by Algolia"
      }
    }, [t("svg", {
      class: [a.suit("logo"), a.suit("", a.theme)],
      staticStyle: {
        height: "1.2em",
        width: "auto"
      },
      attrs: {
        viewBox: "0 0 168 24"
      }
    }, [t("path", {
      attrs: {
        fill: "dark" === a.theme ? "#FFF" : "#5D6494",
        d: "M6.97 6.68V8.3a4.47 4.47 0 0 0-2.42-.67 2.2 2.2 0 0 0-1.38.4c-.34.26-.5.6-.5 1.02 0 .43.16.77.49 1.03.33.25.83.53 1.51.83a7.04 7.04 0 0 1 1.9 1.08c.34.24.58.54.73.89.15.34.23.74.23 1.18 0 .95-.33 1.7-1 2.24a4 4 0 0 1-2.6.81 5.71 5.71 0 0 1-2.94-.68v-1.71c.84.63 1.81.94 2.92.94.58 0 1.05-.14 1.39-.4.34-.28.5-.65.5-1.13 0-.29-.1-.55-.3-.8a2.2 2.2 0 0 0-.65-.53 23.03 23.03 0 0 0-1.64-.78 13.67 13.67 0 0 1-1.11-.64c-.12-.1-.28-.22-.46-.4a1.72 1.72 0 0 1-.39-.5 4.46 4.46 0 0 1-.22-.6c-.07-.23-.1-.48-.1-.75 0-.91.33-1.63 1-2.17a4 4 0 0 1 2.57-.8c.97 0 1.8.18 2.47.52zm7.47 5.7v-.3a2.26 2.26 0 0 0-.5-1.44c-.3-.35-.74-.53-1.32-.53-.53 0-.99.2-1.37.58-.38.39-.62.95-.72 1.68h3.91zm1 2.79v1.4c-.6.34-1.38.51-2.36.51a4.02 4.02 0 0 1-3-1.13 4.04 4.04 0 0 1-1.11-2.97c0-1.3.34-2.32 1.02-3.06a3.38 3.38 0 0 1 2.6-1.1c1.03 0 1.85.32 2.46.96.6.64.9 1.57.9 2.78 0 .33-.03.68-.09 1.04h-5.31c.1.7.4 1.24.89 1.61.49.38 1.1.56 1.85.56.86 0 1.58-.2 2.15-.6zm6.61-1.78h-1.21c-.6 0-1.05.12-1.35.36-.3.23-.46.53-.46.89 0 .37.12.66.36.88.23.2.57.32 1.02.32.5 0 .9-.15 1.2-.43.3-.28.44-.65.44-1.1v-.92zm-4.07-2.55V9.33a4.96 4.96 0 0 1 2.5-.55c2.1 0 3.17 1.03 3.17 3.08V17H22.1v-.96c-.42.68-1.15 1.02-2.19 1.02-.76 0-1.38-.22-1.84-.66-.46-.44-.7-1-.7-1.68 0-.78.3-1.38.88-1.81.59-.43 1.4-.65 2.46-.65h1.34v-.46c0-.55-.13-.97-.4-1.25-.26-.29-.7-.43-1.32-.43-.86 0-1.65.24-2.35.72zm9.34-1.93v1.42c.39-1 1.1-1.5 2.12-1.5.15 0 .31.02.5.05v1.53c-.23-.1-.48-.14-.76-.14-.54 0-.99.24-1.34.71a2.8 2.8 0 0 0-.52 1.71V17h-1.57V8.91h1.57zm5 4.09a3 3 0 0 0 .76 2.01c.47.53 1.14.8 2 .8.64 0 1.24-.18 1.8-.53v1.4c-.53.32-1.2.48-2 .48a3.98 3.98 0 0 1-4.17-4.18c0-1.16.38-2.15 1.14-2.98a4 4 0 0 1 3.1-1.23c.7 0 1.34.15 1.92.44v1.44a3.24 3.24 0 0 0-1.77-.5A2.65 2.65 0 0 0 32.33 13zm7.92-7.28v4.58c.46-1 1.3-1.5 2.5-1.5.8 0 1.42.24 1.9.73.48.5.72 1.17.72 2.05V17H43.8v-5.1c0-.56-.14-.99-.43-1.29-.28-.3-.65-.45-1.1-.45-.54 0-1 .2-1.42.6-.4.4-.61 1.02-.61 1.85V17h-1.56V5.72h1.56zM55.2 15.74c.6 0 1.1-.25 1.5-.76.4-.5.6-1.16.6-1.95 0-.92-.2-1.62-.6-2.12-.4-.5-.92-.74-1.55-.74-.56 0-1.05.22-1.5.67-.44.45-.66 1.13-.66 2.06 0 .96.22 1.67.64 2.14.43.47.95.7 1.57.7zM53 5.72v4.42a2.74 2.74 0 0 1 2.43-1.34c1.03 0 1.86.38 2.51 1.15.65.76.97 1.78.97 3.05 0 1.13-.3 2.1-.92 2.9-.62.81-1.47 1.21-2.54 1.21s-1.9-.45-2.46-1.34V17h-1.58V5.72H53zm9.9 11.1l-3.22-7.9h1.74l1 2.62 1.26 3.42c.1-.32.48-1.46 1.15-3.42l.91-2.63h1.66l-2.92 7.87c-.78 2.07-1.96 3.1-3.56 3.1-.28 0-.53-.02-.73-.07v-1.34c.17.04.35.06.54.06 1.03 0 1.76-.57 2.17-1.7z"
      }
    }), a._v(" "), t("path", {
      attrs: {
        fill: "#5468FF",
        d: "M78.99.94h16.6a2.97 2.97 0 0 1 2.96 2.96v16.6a2.97 2.97 0 0 1-2.97 2.96h-16.6a2.97 2.97 0 0 1-2.96-2.96V3.9A2.96 2.96 0 0 1 79 .94"
      }
    }), a._v(" "), t("path", {
      attrs: {
        fill: "#FFF",
        d: "M89.63 5.97v-.78a.98.98 0 0 0-.98-.97h-2.28a.98.98 0 0 0-.97.97V6c0 .09.08.15.17.13a7.13 7.13 0 0 1 3.9-.02c.08.02.16-.04.16-.13m-6.25 1L83 6.6a.98.98 0 0 0-1.38 0l-.46.46a.97.97 0 0 0 0 1.38l.38.39c.06.06.15.04.2-.02a7.49 7.49 0 0 1 1.63-1.62c.07-.04.08-.14.02-.2m4.16 2.45v3.34c0 .1.1.17.2.12l2.97-1.54c.06-.03.08-.12.05-.18a3.7 3.7 0 0 0-3.08-1.87c-.07 0-.14.06-.14.13m0 8.05a4.49 4.49 0 1 1 0-8.98 4.49 4.49 0 0 1 0 8.98m0-10.85a6.37 6.37 0 1 0 0 12.74 6.37 6.37 0 0 0 0-12.74"
      }
    }), a._v(" "), t("path", {
      attrs: {
        fill: "dark" === a.theme ? "#FFF" : "#5468FF",
        d: "M120.92 18.8c-4.38.02-4.38-3.54-4.38-4.1V1.36l2.67-.42v13.25c0 .32 0 2.36 1.71 2.37v2.24zm-10.84-2.18c.82 0 1.43-.04 1.85-.12v-2.72a5.48 5.48 0 0 0-1.57-.2c-.3 0-.6.02-.9.07-.3.04-.57.12-.81.24-.24.11-.44.28-.58.49a.93.93 0 0 0-.22.65c0 .63.22 1 .61 1.23.4.24.94.36 1.62.36zm-.23-9.7c.88 0 1.62.11 2.23.33.6.22 1.09.53 1.44.92.36.4.61.92.76 1.48.16.56.23 1.17.23 1.85v6.87c-.4.1-1.03.2-1.86.32-.84.12-1.78.18-2.82.18-.69 0-1.32-.07-1.9-.2a4 4 0 0 1-1.46-.63c-.4-.3-.72-.67-.96-1.13a4.3 4.3 0 0 1-.34-1.8c0-.66.13-1.08.39-1.53.26-.45.6-.82 1.04-1.1.45-.3.95-.5 1.54-.62a8.8 8.8 0 0 1 3.79.05v-.44c0-.3-.04-.6-.11-.87a1.78 1.78 0 0 0-1.1-1.22c-.31-.12-.7-.2-1.15-.2a9.75 9.75 0 0 0-2.95.46l-.33-2.19c.34-.12.84-.23 1.48-.35.65-.12 1.34-.18 2.08-.18zm52.84 9.63c.82 0 1.43-.05 1.85-.13V13.7a5.42 5.42 0 0 0-1.57-.2c-.3 0-.6.02-.9.07-.3.04-.57.12-.81.24-.24.12-.44.28-.58.5a.93.93 0 0 0-.22.65c0 .63.22.99.61 1.23.4.24.94.36 1.62.36zm-.23-9.7c.88 0 1.63.11 2.23.33.6.22 1.1.53 1.45.92.35.39.6.92.76 1.48.15.56.23 1.18.23 1.85v6.88c-.41.08-1.03.19-1.87.31-.83.12-1.77.18-2.81.18-.7 0-1.33-.06-1.9-.2a4 4 0 0 1-1.47-.63c-.4-.3-.72-.67-.95-1.13a4.3 4.3 0 0 1-.34-1.8c0-.66.13-1.08.38-1.53.26-.45.61-.82 1.05-1.1.44-.3.95-.5 1.53-.62a8.8 8.8 0 0 1 3.8.05v-.43c0-.31-.04-.6-.12-.88-.07-.28-.2-.52-.38-.73a1.78 1.78 0 0 0-.73-.5c-.3-.1-.68-.2-1.14-.2a9.85 9.85 0 0 0-2.95.47l-.32-2.19a11.63 11.63 0 0 1 3.55-.53zm-8.03-1.27a1.62 1.62 0 0 0 0-3.24 1.62 1.62 0 1 0 0 3.24zm1.35 13.22h-2.7V7.27l2.7-.42V18.8zm-4.72 0c-4.38.02-4.38-3.54-4.38-4.1l-.01-13.34 2.67-.42v13.25c0 .32 0 2.36 1.72 2.37v2.24zm-8.7-5.9a4.7 4.7 0 0 0-.74-2.79 2.4 2.4 0 0 0-2.07-1 2.4 2.4 0 0 0-2.06 1 4.7 4.7 0 0 0-.74 2.8c0 1.16.25 1.94.74 2.62a2.4 2.4 0 0 0 2.07 1.02c.88 0 1.57-.34 2.07-1.02.49-.68.73-1.46.73-2.63zm2.74 0a6.46 6.46 0 0 1-1.52 4.23c-.49.53-1.07.94-1.76 1.22-.68.29-1.73.45-2.26.45-.53 0-1.58-.15-2.25-.45a5.1 5.1 0 0 1-2.88-3.13 7.3 7.3 0 0 1-.01-4.84 5.13 5.13 0 0 1 2.9-3.1 5.67 5.67 0 0 1 2.22-.42c.81 0 1.56.14 2.24.42.69.29 1.28.69 1.75 1.22.49.52.87 1.15 1.14 1.89a7 7 0 0 1 .43 2.5zm-20.14 0c0 1.11.25 2.36.74 2.88.5.52 1.13.78 1.91.78a4.07 4.07 0 0 0 2.12-.6V9.33c-.19-.04-.99-.2-1.76-.23a2.67 2.67 0 0 0-2.23 1 4.73 4.73 0 0 0-.78 2.8zm7.44 5.27c0 1.82-.46 3.16-1.4 4-.94.85-2.37 1.27-4.3 1.27-.7 0-2.17-.13-3.34-.4l.43-2.11c.98.2 2.27.26 2.95.26 1.08 0 1.84-.22 2.3-.66.46-.43.68-1.08.68-1.94v-.44a5.2 5.2 0 0 1-2.54.6 5.6 5.6 0 0 1-2.01-.36 4.2 4.2 0 0 1-2.58-2.71 9.88 9.88 0 0 1 .02-5.35 4.92 4.92 0 0 1 2.93-2.96 6.6 6.6 0 0 1 2.43-.46 19.64 19.64 0 0 1 4.43.66v10.6z"
      }
    })])])]);
  },
  staticRenderFns: [],
  name: "AisPoweredBy",
  mixins: [suit_t({
    name: "PoweredBy"
  })],
  props: {
    theme: {
      default: "light",
      validator: function (a) {
        return -1 !== ["light", "dark"].indexOf(a);
      }
    }
  },
  computed: {
    algoliaUrl: function () {
      return "https://www.algolia.com/?utm_source=vue-instantsearch&utm_medium=website&utm_content=" + (location ? location.hostname : "") + "&utm_campaign=poweredby";
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/query-rules/connectQueryRules.js


function connectQueryRules_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectQueryRules_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectQueryRules_ownKeys(Object(source), true).forEach(function (key) {
        connectQueryRules_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectQueryRules_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectQueryRules_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectQueryRules_toConsumableArray(arr) {
  return connectQueryRules_arrayWithoutHoles(arr) || connectQueryRules_iterableToArray(arr) || connectQueryRules_unsupportedIterableToArray(arr) || connectQueryRules_nonIterableSpread();
}

function connectQueryRules_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectQueryRules_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectQueryRules_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectQueryRules_arrayLikeToArray(o, minLen);
}

function connectQueryRules_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectQueryRules_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectQueryRules_arrayLikeToArray(arr);
}

function connectQueryRules_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}


var connectQueryRules_withUsage = createDocumentationMessageGenerator({
  name: 'query-rules',
  connector: true
});

function hasStateRefinements(state) {
  return [state.disjunctiveFacetsRefinements, state.facetsRefinements, state.hierarchicalFacetsRefinements, state.numericRefinements].some(function (refinement) {
    return Boolean(refinement && Object.keys(refinement).length > 0);
  });
} // A context rule must consist only of alphanumeric characters, hyphens, and underscores.
// See https://www.algolia.com/doc/guides/managing-results/refine-results/merchandising-and-promoting/in-depth/implementing-query-rules/#context


function escapeRuleContext(ruleName) {
  return ruleName.replace(/[^a-z0-9-_]+/gi, '_');
}

function getRuleContextsFromTrackedFilters(_ref) {
  var helper = _ref.helper,
      sharedHelperState = _ref.sharedHelperState,
      trackedFilters = _ref.trackedFilters;
  var ruleContexts = Object.keys(trackedFilters).reduce(function (facets, facetName) {
    var facetRefinements = getRefinements(helper.lastResults || {}, sharedHelperState, true).filter(function (refinement) {
      return refinement.attribute === facetName;
    }).map(function (refinement) {
      return refinement.numericValue || refinement.name;
    });
    var getTrackedFacetValues = trackedFilters[facetName];
    var trackedFacetValues = getTrackedFacetValues(facetRefinements);
    return [].concat(connectQueryRules_toConsumableArray(facets), connectQueryRules_toConsumableArray(facetRefinements.filter(function (facetRefinement) {
      return trackedFacetValues.includes(facetRefinement);
    }).map(function (facetValue) {
      return escapeRuleContext("ais-".concat(facetName, "-").concat(facetValue));
    })));
  }, []);
  return ruleContexts;
}

function applyRuleContexts(event) {
  var helper = this.helper,
      initialRuleContexts = this.initialRuleContexts,
      trackedFilters = this.trackedFilters,
      transformRuleContexts = this.transformRuleContexts;
  var sharedHelperState = event.state;
  var previousRuleContexts = sharedHelperState.ruleContexts || [];
  var newRuleContexts = getRuleContextsFromTrackedFilters({
    helper: helper,
    sharedHelperState: sharedHelperState,
    trackedFilters: trackedFilters
  });
  var nextRuleContexts = [].concat(connectQueryRules_toConsumableArray(initialRuleContexts), connectQueryRules_toConsumableArray(newRuleContexts));
   false ? 0 : void 0;
  var ruleContexts = transformRuleContexts(nextRuleContexts).slice(0, 10);

  if (!utils_isEqual(previousRuleContexts, ruleContexts)) {
    helper.overrideStateWithoutTriggeringChangeEvent(connectQueryRules_objectSpread(connectQueryRules_objectSpread({}, sharedHelperState), {}, {
      ruleContexts: ruleContexts
    }));
  }
}

var connectQueryRules = function connectQueryRules(_render) {
  var unmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(_render, connectQueryRules_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        _ref2$trackedFilters = _ref2.trackedFilters,
        trackedFilters = _ref2$trackedFilters === void 0 ? {} : _ref2$trackedFilters,
        _ref2$transformRuleCo = _ref2.transformRuleContexts,
        transformRuleContexts = _ref2$transformRuleCo === void 0 ? function (rules) {
      return rules;
    } : _ref2$transformRuleCo,
        _ref2$transformItems = _ref2.transformItems,
        transformItems = _ref2$transformItems === void 0 ? function (items) {
      return items;
    } : _ref2$transformItems;

    Object.keys(trackedFilters).forEach(function (facetName) {
      if (typeof trackedFilters[facetName] !== 'function') {
        throw new Error(connectQueryRules_withUsage("'The \"".concat(facetName, "\" filter value in the `trackedFilters` option expects a function.")));
      }
    });
    var hasTrackedFilters = Object.keys(trackedFilters).length > 0; // We store the initial rule contexts applied before creating the widget
    // so that we do not override them with the rules created from `trackedFilters`.

    var initialRuleContexts = [];
    var onHelperChange;
    return {
      $$type: 'ais.queryRules',
      init: function init(initOptions) {
        var helper = initOptions.helper,
            state = initOptions.state,
            instantSearchInstance = initOptions.instantSearchInstance;
        initialRuleContexts = state.ruleContexts || [];
        onHelperChange = applyRuleContexts.bind({
          helper: helper,
          initialRuleContexts: initialRuleContexts,
          trackedFilters: trackedFilters,
          transformRuleContexts: transformRuleContexts
        });

        if (hasTrackedFilters) {
          // We need to apply the `ruleContexts` based on the `trackedFilters`
          // before the helper changes state in some cases:
          //   - Some filters are applied on the first load (e.g. using `configure`)
          //   - The `transformRuleContexts` option sets initial `ruleContexts`.
          if (hasStateRefinements(state) || Boolean(widgetParams.transformRuleContexts)) {
            onHelperChange({
              state: state
            });
          } // We track every change in the helper to override its state and add
          // any `ruleContexts` needed based on the `trackedFilters`.


          helper.on('change', onHelperChange);
        }

        _render(connectQueryRules_objectSpread(connectQueryRules_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;

        _render(connectQueryRules_objectSpread(connectQueryRules_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      getWidgetRenderState: function getWidgetRenderState(_ref3) {
        var results = _ref3.results;

        var _ref4 = results || {},
            _ref4$userData = _ref4.userData,
            userData = _ref4$userData === void 0 ? [] : _ref4$userData;

        var items = transformItems(userData, {
          results: results
        });
        return {
          items: items,
          widgetParams: widgetParams
        };
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectQueryRules_objectSpread(connectQueryRules_objectSpread({}, renderState), {}, {
          queryRules: this.getWidgetRenderState(renderOptions)
        });
      },
      dispose: function dispose(_ref5) {
        var helper = _ref5.helper,
            state = _ref5.state;
        unmount();

        if (hasTrackedFilters) {
          helper.removeListener('change', onHelperChange);
          return state.setQueryParameter('ruleContexts', initialRuleContexts);
        }

        return state;
      }
    };
  };
};

/* harmony default export */ var query_rules_connectQueryRules = (connectQueryRules);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/QueryRuleContext.js



/* harmony default export */ var QueryRuleContext = ({
  name: "AisQueryRuleContext",
  mixins: [suit_t({
    name: "QueryRuleContext"
  }), widget_e({
    connector: query_rules_connectQueryRules
  })],
  props: {
    trackedFilters: {
      type: Object,
      required: !0
    },
    transformRuleContexts: {
      type: Function,
      required: !1,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        trackedFilters: this.trackedFilters,
        transformRuleContexts: this.transformRuleContexts
      };
    }
  },
  render: function () {
    return null;
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/QueryRuleCustomData.vue.js



/* harmony default export */ var QueryRuleCustomData_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state ? s("div", {
      class: t.suit()
    }, [t._t("default", t._l(t.state.items, function (e, r) {
      return s("div", {
        key: r
      }, [t._t("item", [s("pre", [t._v(t._s(e))])], {
        item: e
      })], 2);
    }), {
      items: t.state.items
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisQueryRuleCustomData",
  mixins: [suit_t({
    name: "QueryRuleCustomData"
  }), widget_e({
    connector: query_rules_connectQueryRules
  })],
  props: {
    transformItems: {
      type: Function,
      required: !1,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        transformItems: this.transformItems
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/range/connectRange.js


function connectRange_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectRange_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectRange_ownKeys(Object(source), true).forEach(function (key) {
        connectRange_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectRange_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectRange_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectRange_slicedToArray(arr, i) {
  return connectRange_arrayWithHoles(arr) || connectRange_iterableToArrayLimit(arr, i) || connectRange_unsupportedIterableToArray(arr, i) || connectRange_nonIterableRest();
}

function connectRange_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectRange_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectRange_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectRange_arrayLikeToArray(o, minLen);
}

function connectRange_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectRange_iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function connectRange_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


var connectRange_withUsage = createDocumentationMessageGenerator({
  name: 'range-input',
  connector: true
}, {
  name: 'range-slider',
  connector: true
});
var connectRange_$$type = 'ais.range';

function toPrecision(_ref) {
  var min = _ref.min,
      max = _ref.max,
      precision = _ref.precision;
  var pow = Math.pow(10, precision);
  return {
    min: min ? Math.floor(min * pow) / pow : min,
    max: max ? Math.ceil(max * pow) / pow : max
  };
}
/**
 * **Range** connector provides the logic to create custom widget that will let
 * the user refine results using a numeric range.
 *
 * This connectors provides a `refine()` function that accepts bounds. It will also provide
 * information about the min and max bounds for the current result set.
 */


var connectRange = function connectRange(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectRange_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        _ref2$attribute = _ref2.attribute,
        attribute = _ref2$attribute === void 0 ? '' : _ref2$attribute,
        minBound = _ref2.min,
        maxBound = _ref2.max,
        _ref2$precision = _ref2.precision,
        precision = _ref2$precision === void 0 ? 0 : _ref2$precision;

    if (!attribute) {
      throw new Error(connectRange_withUsage('The `attribute` option is required.'));
    }

    if (utils_isFiniteNumber(minBound) && utils_isFiniteNumber(maxBound) && minBound > maxBound) {
      throw new Error(connectRange_withUsage("The `max` option can't be lower than `min`."));
    }

    var formatToNumber = function formatToNumber(v) {
      return Number(Number(v).toFixed(precision));
    };

    var rangeFormatter = {
      from: function from(v) {
        return v.toLocaleString();
      },
      to: function to(v) {
        return formatToNumber(v).toLocaleString();
      }
    }; // eslint-disable-next-line complexity

    var getRefinedState = function getRefinedState(helper, currentRange, nextMin, nextMax) {
      var resolvedState = helper.state;
      var currentRangeMin = currentRange.min,
          currentRangeMax = currentRange.max;

      var _ref3 = resolvedState.getNumericRefinement(attribute, '>=') || [],
          _ref4 = connectRange_slicedToArray(_ref3, 1),
          min = _ref4[0];

      var _ref5 = resolvedState.getNumericRefinement(attribute, '<=') || [],
          _ref6 = connectRange_slicedToArray(_ref5, 1),
          max = _ref6[0];

      var isResetMin = nextMin === undefined || nextMin === '';
      var isResetMax = nextMax === undefined || nextMax === '';

      var _toPrecision = toPrecision({
        min: !isResetMin ? parseFloat(nextMin) : undefined,
        max: !isResetMax ? parseFloat(nextMax) : undefined,
        precision: precision
      }),
          nextMinAsNumber = _toPrecision.min,
          nextMaxAsNumber = _toPrecision.max;

      var newNextMin;

      if (!utils_isFiniteNumber(minBound) && currentRangeMin === nextMinAsNumber) {
        newNextMin = undefined;
      } else if (utils_isFiniteNumber(minBound) && isResetMin) {
        newNextMin = minBound;
      } else {
        newNextMin = nextMinAsNumber;
      }

      var newNextMax;

      if (!utils_isFiniteNumber(maxBound) && currentRangeMax === nextMaxAsNumber) {
        newNextMax = undefined;
      } else if (utils_isFiniteNumber(maxBound) && isResetMax) {
        newNextMax = maxBound;
      } else {
        newNextMax = nextMaxAsNumber;
      }

      var isResetNewNextMin = newNextMin === undefined;
      var isGreaterThanCurrentRange = utils_isFiniteNumber(currentRangeMin) && currentRangeMin <= newNextMin;
      var isMinValid = isResetNewNextMin || utils_isFiniteNumber(newNextMin) && (!utils_isFiniteNumber(currentRangeMin) || isGreaterThanCurrentRange);
      var isResetNewNextMax = newNextMax === undefined;
      var isLowerThanRange = utils_isFiniteNumber(newNextMax) && currentRangeMax >= newNextMax;
      var isMaxValid = isResetNewNextMax || utils_isFiniteNumber(newNextMax) && (!utils_isFiniteNumber(currentRangeMax) || isLowerThanRange);
      var hasMinChange = min !== newNextMin;
      var hasMaxChange = max !== newNextMax;

      if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
        resolvedState = resolvedState.removeNumericRefinement(attribute);

        if (utils_isFiniteNumber(newNextMin)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, '>=', newNextMin);
        }

        if (utils_isFiniteNumber(newNextMax)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, '<=', newNextMax);
        }

        return resolvedState.resetPage();
      }

      return null;
    };

    var sendEventWithRefinedState = function sendEventWithRefinedState(refinedState, instantSearchInstance, helper) {
      var eventName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Filter Applied';
      var filters = convertNumericRefinementsToFilters(refinedState, attribute);

      if (filters && filters.length > 0) {
        instantSearchInstance.sendEventToInsights({
          insightsMethod: 'clickedFilters',
          widgetType: connectRange_$$type,
          eventType: 'click',
          payload: {
            eventName: eventName,
            index: helper.getIndex(),
            filters: filters
          },
          attribute: attribute
        });
      }
    };

    var createSendEvent = function createSendEvent(instantSearchInstance, helper, currentRange) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (args.length === 1) {
          instantSearchInstance.sendEventToInsights(args[0]);
          return;
        }

        var eventType = args[0],
            facetValue = args[1],
            eventName = args[2];

        if (eventType !== 'click') {
          return;
        }

        var _facetValue = connectRange_slicedToArray(facetValue, 2),
            nextMin = _facetValue[0],
            nextMax = _facetValue[1];

        var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);
        sendEventWithRefinedState(refinedState, instantSearchInstance, helper, eventName);
      };
    };

    function _getCurrentRange(stats) {
      var min;

      if (utils_isFiniteNumber(minBound)) {
        min = minBound;
      } else if (utils_isFiniteNumber(stats.min)) {
        min = stats.min;
      } else {
        min = 0;
      }

      var max;

      if (utils_isFiniteNumber(maxBound)) {
        max = maxBound;
      } else if (utils_isFiniteNumber(stats.max)) {
        max = stats.max;
      } else {
        max = 0;
      }

      return toPrecision({
        min: min,
        max: max,
        precision: precision
      });
    }

    function _getCurrentRefinement(helper) {
      var _ref7 = helper.getNumericRefinement(attribute, '>=') || [],
          _ref8 = connectRange_slicedToArray(_ref7, 1),
          minValue = _ref8[0];

      var _ref9 = helper.getNumericRefinement(attribute, '<=') || [],
          _ref10 = connectRange_slicedToArray(_ref9, 1),
          maxValue = _ref10[0];

      var min = utils_isFiniteNumber(minValue) ? minValue : -Infinity;
      var max = utils_isFiniteNumber(maxValue) ? maxValue : Infinity;
      return [min, max];
    }

    function _refine(instantSearchInstance, helper, currentRange) {
      return function () {
        var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [undefined, undefined],
            _ref12 = connectRange_slicedToArray(_ref11, 2),
            nextMin = _ref12[0],
            nextMax = _ref12[1];

        var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);

        if (refinedState) {
          sendEventWithRefinedState(refinedState, instantSearchInstance, helper);
          helper.setState(refinedState).search();
        }
      };
    }

    return {
      $$type: connectRange_$$type,
      init: function init(initOptions) {
        renderFn(connectRange_objectSpread(connectRange_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(connectRange_objectSpread(connectRange_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRange_objectSpread(connectRange_objectSpread({}, renderState), {}, {
          range: connectRange_objectSpread(connectRange_objectSpread({}, renderState.range), {}, connectRange_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref13) {
        var results = _ref13.results,
            helper = _ref13.helper,
            instantSearchInstance = _ref13.instantSearchInstance;
        var facetsFromResults = results && results.disjunctiveFacets || [];
        var facet = utils_find(facetsFromResults, function (facetResult) {
          return facetResult.name === attribute;
        });
        var stats = facet && facet.stats || {
          min: undefined,
          max: undefined
        };

        var currentRange = _getCurrentRange(stats);

        var start = _getCurrentRefinement(helper);

        var refine;

        if (!results) {
          // On first render pass an empty range
          // to be able to bypass the validation
          // related to it
          refine = _refine(instantSearchInstance, helper, {
            min: undefined,
            max: undefined
          });
        } else {
          refine = _refine(instantSearchInstance, helper, currentRange);
        }

        return {
          refine: refine,
          canRefine: currentRange.min !== currentRange.max,
          format: rangeFormatter,
          range: currentRange,
          sendEvent: createSendEvent(instantSearchInstance, helper, currentRange),
          widgetParams: connectRange_objectSpread(connectRange_objectSpread({}, widgetParams), {}, {
            precision: precision
          }),
          start: start
        };
      },
      dispose: function dispose(_ref14) {
        var state = _ref14.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
        var searchParameters = _ref15.searchParameters;

        var _searchParameters$get = searchParameters.getNumericRefinements(attribute),
            _searchParameters$get2 = _searchParameters$get['>='],
            min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2,
            _searchParameters$get3 = _searchParameters$get['<='],
            max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;

        if (min.length === 0 && max.length === 0) {
          return uiState;
        }

        return connectRange_objectSpread(connectRange_objectSpread({}, uiState), {}, {
          range: connectRange_objectSpread(connectRange_objectSpread({}, uiState.range), {}, connectRange_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
        var uiState = _ref16.uiState;
        var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
          numericRefinements: connectRange_objectSpread(connectRange_objectSpread({}, searchParameters.numericRefinements), {}, connectRange_defineProperty({}, attribute, {}))
        });

        if (utils_isFiniteNumber(minBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '>=', minBound);
        }

        if (utils_isFiniteNumber(maxBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '<=', maxBound);
        }

        var value = uiState.range && uiState.range[attribute];

        if (!value || value.indexOf(':') === -1) {
          return widgetSearchParameters;
        }

        var _value$split$map = value.split(':').map(parseFloat),
            _value$split$map2 = connectRange_slicedToArray(_value$split$map, 2),
            lowerBound = _value$split$map2[0],
            upperBound = _value$split$map2[1];

        if (utils_isFiniteNumber(lowerBound) && (!utils_isFiniteNumber(minBound) || minBound < lowerBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, '>=');
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '>=', lowerBound);
        }

        if (utils_isFiniteNumber(upperBound) && (!utils_isFiniteNumber(maxBound) || upperBound < maxBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, '<=');
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '<=', upperBound);
        }

        return widgetSearchParameters;
      }
    };
  };
};

/* harmony default export */ var range_connectRange = (connectRange);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/RangeInput.vue.js





var RangeInput_vue_a = function (t) {
  return t && Boolean(t.range) && t.range.min !== t.range.max;
};

/* harmony default export */ var RangeInput_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        n = t._self._c || e;
    return t.state ? n("div", {
      class: [t.suit(), !t.canRefine && t.suit("", "noRefinement")]
    }, [t._t("default", [n("form", {
      class: t.suit("form"),
      on: {
        submit: function (e) {
          e.preventDefault(), t.refine({
            min: t.pick(t.minInput, t.values.min),
            max: t.pick(t.maxInput, t.values.max)
          });
        }
      }
    }, [n("label", {
      class: t.suit("label")
    }, [t._t("minLabel"), t._v(" "), n("input", {
      class: [t.suit("input"), t.suit("input", "min")],
      attrs: {
        type: "number",
        step: t.step,
        min: t.state.range.min,
        max: t.state.range.max,
        placeholder: t.state.range.min
      },
      domProps: {
        value: t.values.min
      },
      on: {
        change: function (e) {
          t.minInput = e.currentTarget.value;
        }
      }
    })], 2), t._v(" "), n("span", {
      class: t.suit("separator")
    }, [t._t("separator", [t._v("to")])], 2), t._v(" "), n("label", {
      class: t.suit("label")
    }, [t._t("maxLabel"), t._v(" "), n("input", {
      class: [t.suit("input"), t.suit("input", "max")],
      attrs: {
        type: "number",
        step: t.step,
        min: t.state.range.min,
        max: t.state.range.max,
        placeholder: t.state.range.max
      },
      domProps: {
        value: t.values.max
      },
      on: {
        change: function (e) {
          t.maxInput = e.currentTarget.value;
        }
      }
    })], 2), t._v(" "), n("button", {
      class: t.suit("submit"),
      attrs: {
        type: "submit"
      }
    }, [t._t("submitLabel", [t._v("Go")])], 2)])], {
      currentRefinement: t.values,
      refine: t.refine,
      canRefine: t.canRefine,
      range: t.state.range,
      sendEvent: t.state.sendEvent
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisRangeInput",
  mixins: [suit_t({
    name: "RangeInput"
  }), widget_e({
    connector: range_connectRange
  }), r({
    mapStateToCanRefine: RangeInput_vue_a
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    min: {
      type: Number,
      required: !1,
      default: void 0
    },
    max: {
      type: Number,
      required: !1,
      default: void 0
    },
    precision: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  data: function () {
    return {
      minInput: void 0,
      maxInput: void 0
    };
  },
  updated: function () {
    this.minInput = void 0, this.maxInput = void 0;
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        min: this.min,
        max: this.max,
        precision: this.precision
      };
    },
    canRefine: function () {
      return RangeInput_vue_a(this.state);
    },
    step: function () {
      return 1 / Math.pow(10, this.precision);
    },
    values: function () {
      var t = this.state.start,
          e = t[0],
          n = t[1],
          i = this.state.range,
          a = i.min,
          s = i.max;
      return {
        min: e !== -1 / 0 && e !== a ? e : void 0,
        max: n !== 1 / 0 && n !== s ? n : void 0
      };
    }
  },
  methods: {
    pick: function (t, e) {
      return null != t ? t : e;
    },
    refine: function (t) {
      var e = t.min,
          n = t.max;
      this.state.refine([e, n]);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/rating-menu/connectRatingMenu.js


function connectRatingMenu_toConsumableArray(arr) {
  return connectRatingMenu_arrayWithoutHoles(arr) || connectRatingMenu_iterableToArray(arr) || connectRatingMenu_unsupportedIterableToArray(arr) || connectRatingMenu_nonIterableSpread();
}

function connectRatingMenu_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectRatingMenu_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function connectRatingMenu_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return connectRatingMenu_arrayLikeToArray(arr);
}

function connectRatingMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectRatingMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectRatingMenu_ownKeys(Object(source), true).forEach(function (key) {
        connectRatingMenu_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectRatingMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectRatingMenu_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectRatingMenu_slicedToArray(arr, i) {
  return connectRatingMenu_arrayWithHoles(arr) || connectRatingMenu_iterableToArrayLimit(arr, i) || connectRatingMenu_unsupportedIterableToArray(arr, i) || connectRatingMenu_nonIterableRest();
}

function connectRatingMenu_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function connectRatingMenu_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return connectRatingMenu_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectRatingMenu_arrayLikeToArray(o, minLen);
}

function connectRatingMenu_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function connectRatingMenu_iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function connectRatingMenu_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


var connectRatingMenu_withUsage = createDocumentationMessageGenerator({
  name: 'rating-menu',
  connector: true
});
var connectRatingMenu_$$type = 'ais.ratingMenu';
var MAX_VALUES_PER_FACET_API_LIMIT = 1000;
var STEP = 1;

var connectRatingMenu_createSendEvent = function createSendEvent(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
      helper = _ref.helper,
      getRefinedStar = _ref.getRefinedStar,
      attribute = _ref.attribute;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }

    var eventType = args[0],
        facetValue = args[1],
        _args$ = args[2],
        eventName = _args$ === void 0 ? 'Filter Applied' : _args$;

    if (eventType !== 'click') {
      return;
    }

    var isRefined = getRefinedStar() === Number(facetValue);

    if (!isRefined) {
      instantSearchInstance.sendEventToInsights({
        insightsMethod: 'clickedFilters',
        widgetType: connectRatingMenu_$$type,
        eventType: eventType,
        payload: {
          eventName: eventName,
          index: helper.getIndex(),
          filters: ["".concat(attribute, ">=").concat(facetValue)]
        },
        attribute: attribute
      });
    }
  };
};
/**
 * **StarRating** connector provides the logic to build a custom widget that will let
 * the user refine search results based on ratings.
 *
 * The connector provides to the rendering: `refine()` to select a value and
 * `items` that are the values that can be selected. `refine` should be used
 * with `items.value`.
 */


var connectRatingMenu = function connectRatingMenu(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectRatingMenu_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        attribute = _ref2.attribute,
        _ref2$max = _ref2.max,
        max = _ref2$max === void 0 ? 5 : _ref2$max;

    var sendEvent;

    if (!attribute) {
      throw new Error(connectRatingMenu_withUsage('The `attribute` option is required.'));
    }

    var _getRefinedStar = function getRefinedStar(state) {
      var _values$;

      var values = state.getNumericRefinements(attribute);

      if (!((_values$ = values['>=']) !== null && _values$ !== void 0 && _values$.length)) {
        return undefined;
      }

      return values['>='][0];
    };

    var getFacetsMaxDecimalPlaces = function getFacetsMaxDecimalPlaces(facetResults) {
      var maxDecimalPlaces = 0;
      facetResults.forEach(function (facetResult) {
        var _facetResult$name$spl = facetResult.name.split('.'),
            _facetResult$name$spl2 = connectRatingMenu_slicedToArray(_facetResult$name$spl, 2),
            _facetResult$name$spl3 = _facetResult$name$spl2[1],
            decimal = _facetResult$name$spl3 === void 0 ? '' : _facetResult$name$spl3;

        maxDecimalPlaces = Math.max(maxDecimalPlaces, decimal.length);
      });
      return maxDecimalPlaces;
    };

    var getFacetValuesWarningMessage = function getFacetValuesWarningMessage(_ref3) {
      var maxDecimalPlaces = _ref3.maxDecimalPlaces,
          maxFacets = _ref3.maxFacets,
          maxValuesPerFacet = _ref3.maxValuesPerFacet;
      var maxDecimalPlacesInRange = Math.max(0, Math.floor(Math.log10(MAX_VALUES_PER_FACET_API_LIMIT / max)));
      var maxFacetsInRange = Math.min(MAX_VALUES_PER_FACET_API_LIMIT, Math.pow(10, maxDecimalPlacesInRange) * max);
      var solutions = [];

      if (maxFacets > MAX_VALUES_PER_FACET_API_LIMIT) {
        solutions.push("- Update your records to lower the precision of the values in the \"".concat(attribute, "\" attribute (for example: ").concat(5.123456789.toPrecision(maxDecimalPlaces + 1), " to ").concat(5.123456789.toPrecision(maxDecimalPlacesInRange + 1), ")"));
      }

      if (maxValuesPerFacet < maxFacetsInRange) {
        solutions.push("- Increase the maximum number of facet values to ".concat(maxFacetsInRange, " using the \"configure\" widget ").concat(createDocumentationLink({
          name: 'configure'
        }), " and the \"maxValuesPerFacet\" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/"));
      }

      return "The ".concat(attribute, " attribute can have ").concat(maxFacets, " different values (0 to ").concat(max, " with a maximum of ").concat(maxDecimalPlaces, " decimals = ").concat(maxFacets, ") but you retrieved only ").concat(maxValuesPerFacet, " facet values. Therefore the number of results that match the refinements can be incorrect.\n    ").concat(solutions.length ? "To resolve this problem you can:\n".concat(solutions.join('\n')) : "");
    };

    function getRefinedState(state, facetValue) {
      var isRefined = _getRefinedStar(state) === Number(facetValue);
      var emptyState = state.resetPage().removeNumericRefinement(attribute);

      if (!isRefined) {
        return emptyState.addNumericRefinement(attribute, '<=', max).addNumericRefinement(attribute, '>=', Number(facetValue));
      }

      return emptyState;
    }

    var toggleRefinement = function toggleRefinement(helper, facetValue) {
      sendEvent('click', facetValue);
      helper.setState(getRefinedState(helper.state, facetValue)).search();
    };

    var connectorState = {
      toggleRefinementFactory: function toggleRefinementFactory(helper) {
        return toggleRefinement.bind(null, helper);
      },
      createURLFactory: function createURLFactory(_ref4) {
        var state = _ref4.state,
            createURL = _ref4.createURL;
        return function (value) {
          return createURL(getRefinedState(state, value));
        };
      }
    };
    return {
      $$type: connectRatingMenu_$$type,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, renderState), {}, {
          ratingMenu: connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, renderState.ratingMenu), {}, connectRatingMenu_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref5) {
        var helper = _ref5.helper,
            results = _ref5.results,
            state = _ref5.state,
            instantSearchInstance = _ref5.instantSearchInstance,
            createURL = _ref5.createURL;
        var facetValues = [];

        if (!sendEvent) {
          sendEvent = connectRatingMenu_createSendEvent({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            getRefinedStar: function getRefinedStar() {
              return _getRefinedStar(helper.state);
            },
            attribute: attribute
          });
        }

        if (results) {
          var facetResults = results.getFacetValues(attribute, {});
          var maxValuesPerFacet = facetResults.length;
          var maxDecimalPlaces = getFacetsMaxDecimalPlaces(facetResults);
          var maxFacets = Math.pow(10, maxDecimalPlaces) * max;
           false ? 0 : void 0;

          var refinedStar = _getRefinedStar(state);

          var _loop = function _loop(star) {
            var isRefined = refinedStar === star;
            var count = facetResults.filter(function (f) {
              return Number(f.name) >= star && Number(f.name) <= max;
            }).map(function (f) {
              return f.count;
            }).reduce(function (sum, current) {
              return sum + current;
            }, 0);

            if (refinedStar && !isRefined && count === 0) {
              // skip count==0 when at least 1 refinement is enabled
              // eslint-disable-next-line no-continue
              return "continue";
            }

            var stars = connectRatingMenu_toConsumableArray(new Array(Math.floor(max / STEP))).map(function (_v, i) {
              return i * STEP < star;
            });

            facetValues.push({
              stars: stars,
              name: String(star),
              label: String(star),
              value: String(star),
              count: count,
              isRefined: isRefined
            });
          };

          for (var star = STEP; star < max; star += STEP) {
            var _ret = _loop(star);

            if (_ret === "continue") continue;
          }
        }

        facetValues = facetValues.reverse();
        return {
          items: facetValues,
          hasNoResults: results ? results.nbHits === 0 : true,
          canRefine: facetValues.length > 0,
          refine: connectorState.toggleRefinementFactory(helper),
          sendEvent: sendEvent,
          createURL: connectorState.createURLFactory({
            state: state,
            createURL: createURL
          }),
          widgetParams: widgetParams
        };
      },
      dispose: function dispose(_ref6) {
        var state = _ref6.state;
        unmountFn();
        return state.removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref7) {
        var searchParameters = _ref7.searchParameters;

        var value = _getRefinedStar(searchParameters);

        if (typeof value !== 'number') {
          return uiState;
        }

        return connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, uiState), {}, {
          ratingMenu: connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, uiState.ratingMenu), {}, connectRatingMenu_defineProperty({}, attribute, value))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref8) {
        var uiState = _ref8.uiState;
        var value = uiState.ratingMenu && uiState.ratingMenu[attribute];
        var withoutRefinements = searchParameters.clearRefinements(attribute);
        var withDisjunctiveFacet = withoutRefinements.addDisjunctiveFacet(attribute);

        if (!value) {
          return withDisjunctiveFacet.setQueryParameters({
            numericRefinements: connectRatingMenu_objectSpread(connectRatingMenu_objectSpread({}, withDisjunctiveFacet.numericRefinements), {}, connectRatingMenu_defineProperty({}, attribute, {}))
          });
        }

        return withDisjunctiveFacet.addNumericRefinement(attribute, '<=', max).addNumericRefinement(attribute, '>=', value);
      }
    };
  };
};

/* harmony default export */ var rating_menu_connectRatingMenu = (connectRatingMenu);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/RatingMenu.vue.js




/* harmony default export */ var RatingMenu_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state ? s("div", {
      class: t.suit()
    }, [t._t("default", [s("svg", {
      staticStyle: {
        display: "none"
      },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg"
      }
    }, [s("symbol", {
      attrs: {
        id: "ais-RatingMenu-starSymbol",
        viewBox: "0 0 24 24"
      }
    }, [s("path", {
      attrs: {
        d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
      }
    })]), t._v(" "), s("symbol", {
      attrs: {
        id: "ais-RatingMenu-starEmptySymbol",
        viewBox: "0 0 24 24"
      }
    }, [s("path", {
      attrs: {
        d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z"
      }
    })])]), t._v(" "), s("ul", {
      class: t.suit("list")
    }, t._l(t.state.items, function (e, a) {
      return s("li", {
        key: a,
        class: [t.suit("item"), e.isRefined && t.suit("item", "selected")]
      }, [s("a", {
        class: t.suit("link"),
        attrs: {
          href: t.state.createURL(e.value),
          "aria-label": e.value + " & Up"
        },
        on: {
          click: function (s) {
            return s.preventDefault(), t.state.refine(e.value);
          }
        }
      }, [t._l(e.stars, function (e, a) {
        return [e ? s("svg", {
          key: a + "-full",
          class: [t.suit("starIcon"), t.suit("starIcon--full")],
          attrs: {
            "aria-hidden": "true",
            width: "24",
            height: "24"
          }
        }, [s("use", {
          attrs: {
            "xlink:href": "#ais-RatingMenu-starSymbol"
          }
        })]) : s("svg", {
          key: a + "-empty",
          class: [t.suit("starIcon"), t.suit("starIcon--empty")],
          attrs: {
            "aria-hidden": "true",
            width: "24",
            height: "24"
          }
        }, [s("use", {
          attrs: {
            "xlink:href": "#ais-RatingMenu-starEmptySymbol"
          }
        })])];
      }), t._v(" "), s("span", {
        class: t.suit("label"),
        attrs: {
          "aria-hidden": "true"
        }
      }, [t._t("andUp", [t._v("& Up")])], 2), t._v(" "), s("span", {
        class: t.suit("count")
      }, [t._v(t._s(e.count))])], 2)]);
    }), 0)], {
      items: t.state.items,
      refine: t.state.refine,
      createURL: t.state.createURL,
      sendEvent: t.state.sendEvent
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisRatingMenu",
  mixins: [suit_t({
    name: "RatingMenu"
  }), widget_e({
    connector: rating_menu_connectRatingMenu
  }), r({
    mapStateToCanRefine: function (t) {
      return !1 === t.hasNoResults;
    }
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    max: {
      type: Number,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        max: this.max
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/refinement-list/connectRefinementList.js


function connectRefinementList_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectRefinementList_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectRefinementList_ownKeys(Object(source), true).forEach(function (key) {
        connectRefinementList_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectRefinementList_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectRefinementList_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectRefinementList_objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = connectRefinementList_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function connectRefinementList_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}


var connectRefinementList_withUsage = createDocumentationMessageGenerator({
  name: 'refinement-list',
  connector: true
});
var connectRefinementList_DEFAULT_SORT = ['isRefined', 'count:desc', 'name:asc'];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */

var connectRefinementList = function connectRefinementList(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectRefinementList_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        attribute = _ref.attribute,
        _ref$operator = _ref.operator,
        operator = _ref$operator === void 0 ? 'or' : _ref$operator,
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? 10 : _ref$limit,
        _ref$showMore = _ref.showMore,
        showMore = _ref$showMore === void 0 ? false : _ref$showMore,
        _ref$showMoreLimit = _ref.showMoreLimit,
        showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit,
        _ref$sortBy = _ref.sortBy,
        sortBy = _ref$sortBy === void 0 ? connectRefinementList_DEFAULT_SORT : _ref$sortBy,
        _ref$escapeFacetValue = _ref.escapeFacetValues,
        escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (items) {
      return items;
    } : _ref$transformItems;

    if (!attribute) {
      throw new Error(connectRefinementList_withUsage('The `attribute` option is required.'));
    }

    if (!/^(and|or)$/.test(operator)) {
      throw new Error(connectRefinementList_withUsage("The `operator` must one of: `\"and\"`, `\"or\"` (got \"".concat(operator, "\").")));
    }

    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(connectRefinementList_withUsage('`showMoreLimit` should be greater than `limit`.'));
    }

    var formatItems = function formatItems(_ref2) {
      var label = _ref2.name,
          value = _ref2.escapedValue,
          item = connectRefinementList_objectWithoutProperties(_ref2, ["name", "escapedValue"]);

      return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, item), {}, {
        value: value,
        label: label,
        highlighted: label
      });
    };

    var lastResultsFromMainSearch;
    var lastItemsFromMainSearch = [];
    var hasExhaustiveItems = true;
    var triggerRefine;
    var sendEvent;
    var isShowingMore = false; // Provide the same function to the `renderFn` so that way the user
    // has to only bind it once when `isFirstRendering` for instance

    var toggleShowMore = function toggleShowMore() {};

    function cachedToggleShowMore() {
      toggleShowMore();
    }

    function createToggleShowMore(renderOptions, widget) {
      return function () {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }

    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }

    var searchForFacetValues = function searchForFacetValues() {
      return function () {};
    };

    var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
      return function (renderOptions) {
        return function (query) {
          var instantSearchInstance = renderOptions.instantSearchInstance,
              searchResults = renderOptions.results;

          if (query === '' && lastItemsFromMainSearch) {
            // render with previous data from the helper.
            renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, widget.getWidgetRenderState(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderOptions), {}, {
              results: lastResultsFromMainSearch
            }))), {}, {
              instantSearchInstance: instantSearchInstance
            }), false);
          } else {
            var tags = {
              highlightPreTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPreTag : TAG_REPLACEMENT.highlightPreTag,
              highlightPostTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPostTag : TAG_REPLACEMENT.highlightPostTag
            };
            helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
            // doesn't support a greater number.
            // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
            Math.min(getLimit(), 100), tags).then(function (results) {
              var facetValues = escapeFacetValues ? escapeFacets(results.facetHits) : results.facetHits;
              var normalizedFacetValues = transformItems(facetValues.map(function (_ref3) {
                var escapedValue = _ref3.escapedValue,
                    value = _ref3.value,
                    item = connectRefinementList_objectWithoutProperties(_ref3, ["escapedValue", "value"]);

                return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, item), {}, {
                  value: escapedValue,
                  label: value
                });
              }), {
                results: searchResults
              });
              renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, widget.getWidgetRenderState(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderOptions), {}, {
                results: lastResultsFromMainSearch
              }))), {}, {
                items: normalizedFacetValues,
                canToggleShowMore: false,
                canRefine: true,
                isFromSearch: true,
                instantSearchInstance: instantSearchInstance
              }), false);
            });
          }
        };
      };
    };

    return {
      $$type: 'ais.refinementList',
      init: function init(initOptions) {
        renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderState), {}, {
          refinementList: connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderState.refinementList), {}, connectRefinementList_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var results = renderOptions.results,
            state = renderOptions.state,
            _createURL = renderOptions.createURL,
            instantSearchInstance = renderOptions.instantSearchInstance,
            helper = renderOptions.helper;
        var items = [];
        var facetValues = [];

        if (!sendEvent || !triggerRefine || !searchForFacetValues) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            attribute: attribute,
            widgetType: this.$$type
          });

          triggerRefine = function triggerRefine(facetValue) {
            sendEvent('click', facetValue);
            helper.toggleFacetRefinement(attribute, facetValue).search();
          };

          searchForFacetValues = createSearchForFacetValues(helper, this);
        }

        if (results) {
          var values = results.getFacetValues(attribute, {
            sortBy: sortBy,
            facetOrdering: sortBy === connectRefinementList_DEFAULT_SORT
          });
          facetValues = values && Array.isArray(values) ? values : [];
          items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
            results: results
          });
          var maxValuesPerFacetConfig = state.maxValuesPerFacet;
          var currentLimit = getLimit(); // If the limit is the max number of facet retrieved it is impossible to know
          // if the facets are exhaustive. The only moment we are sure it is exhaustive
          // is when it is strictly under the number requested unless we know that another
          // widget has requested more values (maxValuesPerFacet > getLimit()).
          // Because this is used for making the search of facets unable or not, it is important
          // to be conservative here.

          hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
          lastResultsFromMainSearch = results;
          lastItemsFromMainSearch = items;

          if (renderOptions.results) {
            toggleShowMore = createToggleShowMore(renderOptions, this);
          }
        } // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
        // function


        var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
        var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
        var canShowMore = showMore && !hasExhaustiveItems;
        var canToggleShowMore = canShowLess || canShowMore;
        return {
          createURL: function createURL(facetValue) {
            return _createURL(state.resetPage().toggleFacetRefinement(attribute, facetValue));
          },
          items: items,
          refine: triggerRefine,
          searchForItems: searchFacetValues,
          isFromSearch: false,
          canRefine: items.length > 0,
          widgetParams: widgetParams,
          isShowingMore: isShowingMore,
          canToggleShowMore: canToggleShowMore,
          toggleShowMore: cachedToggleShowMore,
          sendEvent: sendEvent,
          hasExhaustiveItems: hasExhaustiveItems
        };
      },
      dispose: function dispose(_ref4) {
        var state = _ref4.state;
        unmountFn();
        var withoutMaxValuesPerFacet = state.setQueryParameter('maxValuesPerFacet', undefined);

        if (operator === 'and') {
          return withoutMaxValuesPerFacet.removeFacet(attribute);
        }

        return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        var values = operator === 'or' ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);

        if (!values.length) {
          return uiState;
        }

        return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, uiState), {}, {
          refinementList: connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, uiState.refinementList), {}, connectRefinementList_defineProperty({}, attribute, values))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
        var uiState = _ref6.uiState;
        var isDisjunctive = operator === 'or';
        var values = uiState.refinementList && uiState.refinementList[attribute];
        var withoutRefinements = searchParameters.clearRefinements(attribute);
        var withFacetConfiguration = isDisjunctive ? withoutRefinements.addDisjunctiveFacet(attribute) : withoutRefinements.addFacet(attribute);
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);

        if (!values) {
          var key = isDisjunctive ? 'disjunctiveFacetsRefinements' : 'facetsRefinements';
          return withMaxValuesPerFacet.setQueryParameters(connectRefinementList_defineProperty({}, key, connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, withMaxValuesPerFacet[key]), {}, connectRefinementList_defineProperty({}, attribute, []))));
        }

        return values.reduce(function (parameters, value) {
          return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
        }, withMaxValuesPerFacet);
      }
    };
  };
};

/* harmony default export */ var refinement_list_connectRefinementList = (connectRefinementList);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/SearchInput.vue.js

/* harmony default export */ var SearchInput_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        o = t._self._c || e;
    return o("form", {
      class: t.suit("form"),
      attrs: {
        action: "",
        role: "search",
        novalidate: ""
      },
      on: {
        submit: function (e) {
          return e.preventDefault(), t.onFormSubmit(e);
        },
        reset: function (e) {
          return e.preventDefault(), t.onFormReset(e);
        }
      }
    }, [o("input", {
      ref: "input",
      class: t.suit("input"),
      attrs: {
        type: "search",
        autocorrect: "off",
        autocapitalize: "off",
        autocomplete: "off",
        spellcheck: "false",
        required: "",
        maxlength: "512",
        "aria-label": "Search",
        placeholder: t.placeholder,
        autofocus: t.autofocus
      },
      domProps: {
        value: t.value || t.modelValue
      },
      on: {
        focus: function (e) {
          return t.$emit("focus", e);
        },
        blur: function (e) {
          return t.$emit("blur", e);
        },
        input: function (e) {
          t.$emit("input", e.target.value), t.$emit("update:modelValue", e.target.value);
        }
      }
    }), t._v(" "), o("button", {
      class: t.suit("submit"),
      attrs: {
        type: "submit",
        title: t.submitTitle,
        hidden: t.showLoadingIndicator && t.shouldShowLoadingIndicator
      }
    }, [t._t("submit-icon", [o("svg", {
      class: t.suit("submitIcon"),
      attrs: {
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "10",
        viewBox: "0 0 40 40"
      }
    }, [o("path", {
      attrs: {
        d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z",
        fillRule: "evenodd"
      }
    })])])], 2), t._v(" "), o("button", {
      class: t.suit("reset"),
      attrs: {
        type: "reset",
        title: t.resetTitle,
        hidden: !t.value && !t.modelValue || t.showLoadingIndicator && t.shouldShowLoadingIndicator
      }
    }, [t._t("reset-icon", [o("svg", {
      class: t.suit("resetIcon"),
      attrs: {
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }
    }, [o("path", {
      attrs: {
        d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z",
        fillRule: "evenodd"
      }
    })])])], 2), t._v(" "), t.showLoadingIndicator ? o("span", {
      class: t.suit("loadingIndicator"),
      attrs: {
        hidden: !t.shouldShowLoadingIndicator
      }
    }, [t._t("loading-indicator", [o("svg", {
      class: t.suit("loadingIcon"),
      attrs: {
        role: "img",
        "aria-label": "Results are loading",
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "#444",
        viewBox: "0 0 38 38"
      }
    }, [o("g", {
      attrs: {
        fill: "none",
        "fill-rule": "evenodd"
      }
    }, [o("g", {
      attrs: {
        transform: "translate(1 1)",
        "stroke-width": "2"
      }
    }, [o("circle", {
      attrs: {
        "stroke-opacity": ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }
    }), t._v(" "), o("path", {
      attrs: {
        d: "M36 18c0-9.94-8.06-18-18-18"
      }
    }, [o("animateTransform", {
      attrs: {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "1s",
        repeatCount: "indefinite"
      }
    })], 1)])])])])], 2) : t._e()]);
  },
  staticRenderFns: [],
  name: "SearchInput",
  mixins: [suit_t({
    name: "SearchBox"
  })],
  props: {
    placeholder: {
      type: String,
      default: "Search here…"
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    showLoadingIndicator: {
      type: Boolean,
      default: !1
    },
    shouldShowLoadingIndicator: {
      type: Boolean,
      default: !1
    },
    submitTitle: {
      type: String,
      default: "Search"
    },
    resetTitle: {
      type: String,
      default: "Clear"
    },
    value: {
      type: String,
      required: !1,
      default: void 0
    },
    modelValue: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: ["input", "update:modelValue", "blur", "focus", "reset"],
  data: function () {
    return {
      query: ""
    };
  },
  methods: {
    onFormSubmit: function () {
      this.$refs.input.blur();
    },
    onFormReset: function () {
      this.$emit("input", ""), this.$emit("update:modelValue", ""), this.$emit("reset");
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/RefinementList.vue.js







var RefinementList_vue_o = function () {};

/* harmony default export */ var RefinementList_vue = ({
  render: function () {
    var e,
        t = this,
        s = t.$createElement,
        r = t._self._c || s;
    return t.state ? r("div", {
      class: [t.suit(), !t.state.canRefine && t.suit("", "noRefinement")]
    }, [t._t("default", [t.searchable ? r("div", {
      class: t.suit("searchBox")
    }, [r("search-input", {
      attrs: {
        placeholder: t.searchablePlaceholder,
        "class-names": t.classNames
      },
      model: {
        value: t.searchForFacetValues,
        callback: function (e) {
          t.searchForFacetValues = e;
        },
        expression: "searchForFacetValues"
      }
    })], 1) : t._e(), t._v(" "), t.state.isFromSearch && 0 === t.items.length ? t._t("noResults", [r("div", {
      class: t.suit("noResults")
    }, [t._v("No results.")])], {
      query: t.searchForFacetValues
    }) : t._e(), t._v(" "), r("ul", {
      class: t.suit("list")
    }, t._l(t.items, function (e) {
      return r("li", {
        key: e.value,
        class: [t.suit("item"), e.isRefined && t.suit("item", "selected")]
      }, [t._t("item", [r("label", {
        class: t.suit("label")
      }, [r("input", {
        class: t.suit("checkbox"),
        attrs: {
          type: "checkbox"
        },
        domProps: {
          value: e.value,
          checked: e.isRefined
        },
        on: {
          change: function (s) {
            return t.refine(e.value);
          }
        }
      }), t._v(" "), t.searchable ? r("span", {
        class: t.suit("labelText")
      }, [r("ais-highlight", {
        attrs: {
          attribute: "item",
          hit: e
        }
      })], 1) : r("span", {
        class: t.suit("labelText")
      }, [t._v(t._s(e.label))]), t._v(" "), r("span", {
        class: t.suit("count")
      }, [t._v(t._s(e.count))])])], {
        item: e,
        refine: t.refine,
        createURL: t.state.createURL
      })], 2);
    }), 0), t._v(" "), t.showMore ? r("button", {
      class: [t.suit("showMore"), (e = {}, e[t.suit("showMore", "disabled")] = !t.state.canToggleShowMore, e)],
      attrs: {
        disabled: !t.state.canToggleShowMore
      },
      on: {
        click: t.toggleShowMore
      }
    }, [t._t("showMoreLabel", [t._v("Show " + t._s(t.state.isShowingMore ? "less" : "more"))], {
      isShowingMore: t.state.isShowingMore
    })], 2) : t._e()], {
      items: t.items,
      refine: t.refine,
      searchForItems: t.state.searchForItems,
      searchForItemsQuery: t.searchForFacetValuesQuery,
      toggleShowMore: t.toggleShowMore,
      canToggleShowMore: t.state.canToggleShowMore,
      isShowingMore: t.state.isShowingMore,
      createURL: t.state.createURL,
      isFromSearch: t.state.isFromSearch,
      canRefine: t.state.canRefine,
      sendEvent: t.state.sendEvent
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisRefinementList",
  components: {
    SearchInput: SearchInput_vue,
    AisHighlight: Highlight_vue
  },
  mixins: [suit_t({
    name: "RefinementList"
  }), widget_e({
    connector: refinement_list_connectRefinementList
  }), r({
    mapStateToCanRefine: function (e) {
      return Boolean(e.canRefine);
    }
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    searchable: {
      type: Boolean,
      default: void 0
    },
    searchablePlaceholder: {
      type: String,
      required: !1,
      default: "Search here…"
    },
    operator: {
      default: "or",
      validator: function (e) {
        return "and" === e || "or" === e;
      },
      required: !1
    },
    limit: {
      type: Number,
      required: !1,
      default: void 0
    },
    showMoreLimit: {
      type: Number,
      required: !1,
      default: void 0
    },
    showMore: {
      type: Boolean,
      required: !1,
      default: !1
    },
    sortBy: {
      type: [Array, Function],
      required: !1,
      default: void 0
    },
    transformItems: {
      type: Function,
      required: !1,
      default: void 0
    }
  },
  data: function () {
    return {
      searchForFacetValuesQuery: ""
    };
  },
  computed: {
    searchForFacetValues: {
      get: function () {
        return this.searchForFacetValuesQuery;
      },
      set: function (e) {
        this.state.searchForItems(e), this.searchForFacetValuesQuery = e;
      }
    },
    toggleShowMore: function () {
      return this.state.toggleShowMore || RefinementList_vue_o;
    },
    items: function () {
      return this.state.items.map(function (e) {
        return Object.assign({}, e, {
          _highlightResult: {
            item: {
              value: e.highlighted
            }
          }
        });
      });
    },
    widgetParams: function () {
      return {
        attribute: this.attribute,
        operator: this.operator,
        limit: this.limit,
        showMore: this.showMore,
        showMoreLimit: this.showMoreLimit,
        sortBy: this.sortBy,
        escapeFacetValues: !0,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    refine: function (e) {
      this.state.refine(e), this.searchForFacetValuesQuery = "";
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/connectors/connectStateResults.js

/* harmony default export */ function connectStateResults(n, e) {
  return void 0 === e && (e = function () {}), function (s) {
    return void 0 === s && (s = {}), {
      init: function (t) {
        var e = t.instantSearchInstance;
        n({
          state: void 0,
          results: void 0,
          instantSearchInstance: e,
          widgetParams: s
        }, !0);
      },
      render: function (e) {
        var a = e.results,
            i = e.instantSearchInstance,
            r = e.state,
            o = polyfills_e({}, a),
            c = polyfills_e({}, r);
        n({
          results: o,
          state: c,
          instantSearchInstance: i,
          widgetParams: s
        }, !1);
      },
      dispose: function () {
        e();
      }
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/StateResults.vue.js




/* harmony default export */ var StateResults_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state && t.state.state && t.state.results ? s("div", {
      class: t.suit()
    }, [t._t("default", [s("p", [t._v(" Use this component to have a different layout based on a certain state. ")]), t._v(" "), s("p", [t._v(" Fill in the slot, and get access to the following things: ")]), t._v(" "), s("pre", [t._v("results: " + t._s(Object.keys(t.state.results)))]), t._v(" "), s("pre", [t._v("state: " + t._s(Object.keys(t.state.state)))])], null, t.stateResults)], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisStateResults",
  mixins: [widget_e({
    connector: connectStateResults
  }), suit_t({
    name: "StateResults"
  })],
  computed: {
    stateResults: function () {
      var t = this.state,
          e = t.state,
          a = t.results;
      return polyfills_e({}, a, {
        results: a,
        state: e
      });
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/search-box/connectSearchBox.js
function connectSearchBox_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectSearchBox_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectSearchBox_ownKeys(Object(source), true).forEach(function (key) {
        connectSearchBox_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectSearchBox_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectSearchBox_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectSearchBox_withUsage = createDocumentationMessageGenerator({
  name: 'search-box',
  connector: true
});

var defaultQueryHook = function defaultQueryHook(query, hook) {
  return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */


var connectSearchBox = function connectSearchBox(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectSearchBox_withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
        _ref$queryHook = _ref.queryHook,
        queryHook = _ref$queryHook === void 0 ? defaultQueryHook : _ref$queryHook;

    var _refine;

    var _clear;

    return {
      $$type: 'ais.searchBox',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectSearchBox_objectSpread(connectSearchBox_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectSearchBox_objectSpread(connectSearchBox_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref2) {
        var state = _ref2.state;
        unmountFn();
        return state.setQueryParameter('query', undefined);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectSearchBox_objectSpread(connectSearchBox_objectSpread({}, renderState), {}, {
          searchBox: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref3) {
        var helper = _ref3.helper,
            searchMetadata = _ref3.searchMetadata,
            state = _ref3.state;

        if (!_refine) {
          _refine = function _refine(query) {
            queryHook(query, function (q) {
              return helper.setQuery(q).search();
            });
          };

          _clear = function _clear() {
            helper.setQuery('').search();
          };
        }

        return {
          query: state.query || '',
          refine: _refine,
          clear: _clear,
          widgetParams: widgetParams,
          isSearchStalled: searchMetadata.isSearchStalled
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
        var searchParameters = _ref4.searchParameters;
        var query = searchParameters.query || '';

        if (query === '' || uiState && uiState.query === query) {
          return uiState;
        }

        return connectSearchBox_objectSpread(connectSearchBox_objectSpread({}, uiState), {}, {
          query: query
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
        var uiState = _ref5.uiState;
        return searchParameters.setQueryParameter('query', uiState.query || '');
      }
    };
  };
};

/* harmony default export */ var search_box_connectSearchBox = (connectSearchBox);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/SearchBox.vue.js





/* harmony default export */ var SearchBox_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        i = e._self._c || t;
    return e.state ? i("div", {
      class: e.suit()
    }, [e._t("default", [i("search-input", {
      attrs: {
        placeholder: e.placeholder,
        autofocus: e.autofocus,
        "show-loading-indicator": e.showLoadingIndicator,
        "should-show-loading-indicator": e.state.isSearchStalled,
        "submit-title": e.submitTitle,
        "reset-title": e.resetTitle,
        "class-names": e.classNames
      },
      on: {
        focus: function (t) {
          return e.$emit("focus", t);
        },
        blur: function (t) {
          return e.$emit("blur", t);
        },
        reset: function (t) {
          return e.$emit("reset");
        }
      },
      scopedSlots: e._u([e.isVue3 ? {
        key: "loading-indicator",
        fn: function (t) {
          return [e._t("loading-indicator")];
        }
      } : null, e.isVue3 ? {
        key: "submit-icon",
        fn: function (t) {
          return [e._t("submit-icon")];
        }
      } : null, e.isVue3 ? {
        key: "reset-icon",
        fn: function (t) {
          return [e._t("reset-icon")];
        }
      } : null], !0),
      model: {
        value: e.currentRefinement,
        callback: function (t) {
          e.currentRefinement = t;
        },
        expression: "currentRefinement"
      }
    }, [e._v(" "), e.isVue2 ? e._t("loading-indicator", null, {
      slot: "loading-indicator"
    }) : e._e(), e._v(" "), e._v(" "), e.isVue2 ? e._t("submit-icon", null, {
      slot: "submit-icon"
    }) : e._e(), e._v(" "), e._v(" "), e.isVue2 ? e._t("reset-icon", null, {
      slot: "reset-icon"
    }) : e._e()], 2)], {
      currentRefinement: e.currentRefinement,
      isSearchStalled: e.state.isSearchStalled,
      refine: e.state.refine
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisSearchBox",
  mixins: [widget_e({
    connector: search_box_connectSearchBox
  }), suit_t({
    name: "SearchBox"
  })],
  components: {
    SearchInput: SearchInput_vue
  },
  props: {
    placeholder: {
      type: String,
      default: "Search here…"
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    showLoadingIndicator: {
      type: Boolean,
      default: !1
    },
    submitTitle: {
      type: String,
      default: "Search"
    },
    resetTitle: {
      type: String,
      default: "Clear"
    },
    value: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: String,
      default: void 0
    }
  },
  data: function () {
    return {
      localValue: "",
      isVue2: index_vue2_t,
      isVue3: index_vue2_e
    };
  },
  computed: {
    isControlled: function () {
      return void 0 !== this.value || void 0 !== this.modelValue;
    },
    model: function () {
      return this.value || this.modelValue;
    },
    currentRefinement: {
      get: function () {
        return this.isControlled && this.model !== this.localValue && (this.localValue = this.model, this.$emit("input", this.model), this.$emit("update:modelValue", this.model), this.state.refine(this.model)), this.model || this.state.query || "";
      },
      set: function (e) {
        this.localValue = e, this.state.refine(e), this.isControlled && (this.$emit("input", e), this.$emit("update:modelValue", e));
      }
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Snippet.vue.js


/* harmony default export */ var Snippet_vue = ({
  render: function () {
    var t = this.$createElement;
    return (this._self._c || t)("ais-highlighter", {
      attrs: {
        hit: this.hit,
        attribute: this.attribute,
        "highlighted-tag-name": this.highlightedTagName,
        suit: this.suit,
        "highlight-property": "_snippetResult",
        "pre-tag": "<mark>",
        "post-tag": "</mark>"
      }
    });
  },
  staticRenderFns: [],
  name: "AisSnippet",
  mixins: [suit_t({
    name: "Snippet"
  })],
  components: {
    AisHighlighter: Highlighter_vue
  },
  props: {
    hit: {
      type: Object,
      required: !0
    },
    attribute: {
      type: String,
      required: !0
    },
    highlightedTagName: {
      type: String,
      default: "mark"
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/sort-by/connectSortBy.js


function connectSortBy_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectSortBy_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectSortBy_ownKeys(Object(source), true).forEach(function (key) {
        connectSortBy_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectSortBy_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectSortBy_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectSortBy_withUsage = createDocumentationMessageGenerator({
  name: 'sort-by',
  connector: true
});
/**
 * The **SortBy** connector provides the logic to build a custom widget that will display a
 * list of indices. With Algolia, this is most commonly used for changing ranking strategy. This allows
 * a user to change how the hits are being sorted.
 */

var connectSortBy = function connectSortBy(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectSortBy_withUsage());
  var connectorState = {};
  return function (widgetParams) {
    var _ref = widgetParams || {},
        items = _ref.items,
        _ref$transformItems = _ref.transformItems,
        transformItems = _ref$transformItems === void 0 ? function (x) {
      return x;
    } : _ref$transformItems;

    if (!Array.isArray(items)) {
      throw new Error(connectSortBy_withUsage('The `items` option expects an array of objects.'));
    }

    return {
      $$type: 'ais.sortBy',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        var widgetRenderState = this.getWidgetRenderState(initOptions);
        var currentIndex = widgetRenderState.currentRefinement;
        var isCurrentIndexInItems = utils_find(items, function (item) {
          return item.value === currentIndex;
        });
         false ? 0 : void 0;
        renderFn(connectSortBy_objectSpread(connectSortBy_objectSpread({}, widgetRenderState), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectSortBy_objectSpread(connectSortBy_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref2) {
        var state = _ref2.state;
        unmountFn();
        return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectSortBy_objectSpread(connectSortBy_objectSpread({}, renderState), {}, {
          sortBy: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref3) {
        var results = _ref3.results,
            helper = _ref3.helper,
            state = _ref3.state,
            parent = _ref3.parent;

        if (!connectorState.initialIndex && parent) {
          connectorState.initialIndex = parent.getIndexName();
        }

        if (!connectorState.setIndex) {
          connectorState.setIndex = function (indexName) {
            helper.setIndex(indexName).search();
          };
        }

        return {
          currentRefinement: state.index,
          options: transformItems(items, {
            results: results
          }),
          refine: connectorState.setIndex,
          hasNoResults: results ? results.nbHits === 0 : true,
          widgetParams: widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
        var searchParameters = _ref4.searchParameters;
        var currentIndex = searchParameters.index;
        return connectSortBy_objectSpread(connectSortBy_objectSpread({}, uiState), {}, {
          sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : undefined
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
        var uiState = _ref5.uiState;
        return searchParameters.setQueryParameter('index', uiState.sortBy || connectorState.initialIndex || searchParameters.index);
      }
    };
  };
};

/* harmony default export */ var sort_by_connectSortBy = (connectSortBy);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/SortBy.vue.js




/* harmony default export */ var SortBy_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: e.suit()
    }, [e._t("default", [s("select", {
      class: e.suit("select"),
      on: {
        change: function (t) {
          return e.state.refine(t.currentTarget.value);
        }
      }
    }, e._l(e.state.options, function (t) {
      return s("option", {
        key: t.value,
        class: e.suit("option"),
        domProps: {
          value: t.value,
          selected: t.value === e.state.currentRefinement
        }
      }, [e._v(e._s(t.label))]);
    }), 0)], {
      items: e.state.options,
      hasNoResults: e.state.hasNoResults,
      refine: e.state.refine,
      currentRefinement: e.state.currentRefinement
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisSortBy",
  mixins: [suit_t({
    name: "SortBy"
  }), widget_e({
    connector: sort_by_connectSortBy
  }), r({
    mapStateToCanRefine: function (e) {
      return !1 === e.hasNoResults;
    }
  })],
  props: {
    items: {
      type: Array,
      required: !0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        items: this.items,
        transformItems: this.transformItems
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/stats/connectStats.js
function connectStats_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectStats_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectStats_ownKeys(Object(source), true).forEach(function (key) {
        connectStats_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectStats_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectStats_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectStats_withUsage = createDocumentationMessageGenerator({
  name: 'stats',
  connector: true
});
/**
 * **Stats** connector provides the logic to build a custom widget that will displays
 * search statistics (hits number and processing time).
 */

var connectStats = function connectStats(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectStats_withUsage());
  return function (widgetParams) {
    return {
      $$type: 'ais.stats',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectStats_objectSpread(connectStats_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectStats_objectSpread(connectStats_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectStats_objectSpread(connectStats_objectSpread({}, renderState), {}, {
          stats: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref) {
        var results = _ref.results,
            state = _ref.state;

        if (!results) {
          return {
            hitsPerPage: state.hitsPerPage,
            nbHits: 0,
            nbSortedHits: undefined,
            areHitsSorted: false,
            nbPages: 0,
            page: state.page || 0,
            processingTimeMS: -1,
            query: state.query || '',
            widgetParams: widgetParams
          };
        }

        return {
          hitsPerPage: results.hitsPerPage,
          nbHits: results.nbHits,
          nbSortedHits: results.nbSortedHits,
          areHitsSorted: typeof results.appliedRelevancyStrictness !== 'undefined' && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
          nbPages: results.nbPages,
          page: results.page,
          processingTimeMS: results.processingTimeMS,
          query: results.query,
          widgetParams: widgetParams
        };
      }
    };
  };
};

/* harmony default export */ var stats_connectStats = (connectStats);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/Stats.vue.js



/* harmony default export */ var Stats_vue = ({
  render: function () {
    var t = this,
        s = t.$createElement,
        e = t._self._c || s;
    return t.state ? e("div", {
      class: t.suit()
    }, [t._t("default", [e("span", {
      class: t.suit("text")
    }, [t.state.areHitsSorted ? [t._v(t._s(t.state.nbSortedHits.toLocaleString()) + " relevant results sorted out of " + t._s(t.state.nbHits.toLocaleString()))] : [t._v(t._s(t.state.nbHits.toLocaleString()) + " results")], t._v(" found in " + t._s(t.state.processingTimeMS.toLocaleString()) + "ms")], 2)], {
      results: t.state.instantSearchInstance.helper.lastResults
    }, t.state)], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisStats",
  mixins: [widget_e({
    connector: stats_connectStats
  }), suit_t({
    name: "Stats"
  })],
  computed: {
    widgetParams: function () {
      return {};
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/toArray.js
function toArray_toArray(value) {
  return Array.isArray(value) ? value : [value];
}

/* harmony default export */ var utils_toArray = (toArray_toArray);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js


function connectToggleRefinement_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectToggleRefinement_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectToggleRefinement_ownKeys(Object(source), true).forEach(function (key) {
        connectToggleRefinement_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectToggleRefinement_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectToggleRefinement_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


var connectToggleRefinement_withUsage = createDocumentationMessageGenerator({
  name: 'toggle-refinement',
  connector: true
});
var connectToggleRefinement_$$type = 'ais.toggleRefinement';

var connectToggleRefinement_createSendEvent = function createSendEvent(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
      helper = _ref.helper,
      attribute = _ref.attribute,
      on = _ref.on;

  var sendEventForToggle = function sendEventForToggle() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }

    var eventType = args[0],
        isRefined = args[1],
        _args$ = args[2],
        eventName = _args$ === void 0 ? 'Filter Applied' : _args$;

    if (eventType !== 'click' || on === undefined) {
      return;
    } // only send an event when the refinement gets applied,
    // not when it gets removed


    if (!isRefined) {
      instantSearchInstance.sendEventToInsights({
        insightsMethod: 'clickedFilters',
        widgetType: connectToggleRefinement_$$type,
        eventType: eventType,
        payload: {
          eventName: eventName,
          index: helper.getIndex(),
          filters: on.map(function (value) {
            return "".concat(attribute, ":").concat(value);
          })
        },
        attribute: attribute
      });
    }
  };

  return sendEventForToggle;
};
/**
 * **Toggle** connector provides the logic to build a custom widget that will provide
 * an on/off filtering feature based on an attribute value or values.
 *
 * Two modes are implemented in the custom widget:
 *  - with or without the value filtered
 *  - switch between two values.
 */


var connectToggleRefinement = function connectToggleRefinement(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectToggleRefinement_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
        attribute = _ref2.attribute,
        _ref2$on = _ref2.on,
        userOn = _ref2$on === void 0 ? true : _ref2$on,
        userOff = _ref2.off;

    if (!attribute) {
      throw new Error(connectToggleRefinement_withUsage('The `attribute` option is required.'));
    }

    var hasAnOffValue = userOff !== undefined;
    var on = utils_toArray(userOn).map(escapeFacetValue);
    var off = hasAnOffValue ? utils_toArray(userOff).map(escapeFacetValue) : undefined;
    var sendEvent;

    var toggleRefinementFactory = function toggleRefinementFactory(helper) {
      return function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          isRefined: false
        },
            isRefined = _ref3.isRefined;

        if (!isRefined) {
          sendEvent('click', isRefined);

          if (hasAnOffValue) {
            off.forEach(function (v) {
              return helper.removeDisjunctiveFacetRefinement(attribute, v);
            });
          }

          on.forEach(function (v) {
            return helper.addDisjunctiveFacetRefinement(attribute, v);
          });
        } else {
          on.forEach(function (v) {
            return helper.removeDisjunctiveFacetRefinement(attribute, v);
          });

          if (hasAnOffValue) {
            off.forEach(function (v) {
              return helper.addDisjunctiveFacetRefinement(attribute, v);
            });
          }
        }

        helper.search();
      };
    };

    var connectorState = {
      createURLFactory: function createURLFactory(isRefined, _ref4) {
        var state = _ref4.state,
            createURL = _ref4.createURL;
        return function () {
          state = state.resetPage();
          var valuesToRemove = isRefined ? on : off;

          if (valuesToRemove) {
            valuesToRemove.forEach(function (v) {
              state = state.removeDisjunctiveFacetRefinement(attribute, v);
            });
          }

          var valuesToAdd = isRefined ? off : on;

          if (valuesToAdd) {
            valuesToAdd.forEach(function (v) {
              state = state.addDisjunctiveFacetRefinement(attribute, v);
            });
          }

          return createURL(state);
        };
      }
    };
    return {
      $$type: connectToggleRefinement_$$type,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref5) {
        var state = _ref5.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, renderState), {}, {
          toggleRefinement: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, renderState.toggleRefinement), {}, connectToggleRefinement_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref6) {
        var state = _ref6.state,
            helper = _ref6.helper,
            results = _ref6.results,
            createURL = _ref6.createURL,
            instantSearchInstance = _ref6.instantSearchInstance;
        var isRefined = results ? on.every(function (v) {
          return state.isDisjunctiveFacetRefined(attribute, v);
        }) : on.every(function (v) {
          return state.isDisjunctiveFacetRefined(attribute, v);
        });
        var onFacetValue = {
          isRefined: isRefined,
          count: 0
        };
        var offFacetValue = {
          isRefined: hasAnOffValue && !isRefined,
          count: 0
        };

        if (results) {
          var offValue = utils_toArray(off || false);
          var allFacetValues = results.getFacetValues(attribute, {}) || [];
          var onData = on.map(function (v) {
            return utils_find(allFacetValues, function (_ref7) {
              var escapedValue = _ref7.escapedValue;
              return escapedValue === escapeFacetValue(String(v));
            });
          }).filter(function (v) {
            return v !== undefined;
          });
          var offData = hasAnOffValue ? offValue.map(function (v) {
            return utils_find(allFacetValues, function (_ref8) {
              var escapedValue = _ref8.escapedValue;
              return escapedValue === escapeFacetValue(String(v));
            });
          }).filter(function (v) {
            return v !== undefined;
          }) : [];
          onFacetValue = {
            isRefined: onData.length ? onData.every(function (v) {
              return v.isRefined;
            }) : false,
            count: onData.reduce(function (acc, v) {
              return acc + v.count;
            }, 0) || null
          };
          offFacetValue = {
            isRefined: offData.length ? offData.every(function (v) {
              return v.isRefined;
            }) : false,
            count: offData.reduce(function (acc, v) {
              return acc + v.count;
            }, 0) || allFacetValues.reduce(function (total, _ref9) {
              var count = _ref9.count;
              return total + count;
            }, 0)
          };
        }

        if (!sendEvent) {
          sendEvent = connectToggleRefinement_createSendEvent({
            instantSearchInstance: instantSearchInstance,
            attribute: attribute,
            on: on,
            helper: helper
          });
        }

        var nextRefinement = isRefined ? offFacetValue : onFacetValue;
        return {
          value: {
            name: attribute,
            isRefined: isRefined,
            count: results ? nextRefinement.count : null,
            onFacetValue: onFacetValue,
            offFacetValue: offFacetValue
          },
          createURL: connectorState.createURLFactory(isRefined, {
            state: state,
            createURL: createURL
          }),
          sendEvent: sendEvent,
          canRefine: Boolean(results ? nextRefinement.count : null),
          refine: toggleRefinementFactory(helper),
          widgetParams: widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref10) {
        var searchParameters = _ref10.searchParameters;
        var isRefined = on && on.every(function (v) {
          return searchParameters.isDisjunctiveFacetRefined(attribute, v);
        });

        if (!isRefined) {
          return uiState;
        }

        return connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, uiState), {}, {
          toggle: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, uiState.toggle), {}, connectToggleRefinement_defineProperty({}, attribute, isRefined))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref11) {
        var uiState = _ref11.uiState;
        var withFacetConfiguration = searchParameters.clearRefinements(attribute).addDisjunctiveFacet(attribute);
        var isRefined = Boolean(uiState.toggle && uiState.toggle[attribute]);

        if (isRefined) {
          if (on) {
            on.forEach(function (v) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
            });
          }

          return withFacetConfiguration;
        } // It's not refined with an `off` value


        if (hasAnOffValue) {
          if (off) {
            off.forEach(function (v) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
            });
          }

          return withFacetConfiguration;
        } // It's not refined without an `off` value


        return withFacetConfiguration.setQueryParameters({
          disjunctiveFacetsRefinements: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, searchParameters.disjunctiveFacetsRefinements), {}, connectToggleRefinement_defineProperty({}, attribute, []))
        });
      }
    };
  };
};

/* harmony default export */ var toggle_refinement_connectToggleRefinement = (connectToggleRefinement);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/ToggleRefinement.vue.js





var ToggleRefinement_vue_i = function (e) {
  return Boolean(e.value && e.value.count);
};

/* harmony default export */ var ToggleRefinement_vue = ({
  render: function () {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: [e.suit(), !e.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", [n("label", {
      class: e.suit("label")
    }, [n("input", {
      class: e.suit("checkbox"),
      attrs: {
        type: "checkbox",
        name: e.state.value.name
      },
      domProps: {
        value: e.on,
        checked: e.state.value.isRefined
      },
      on: {
        change: function (t) {
          return e.state.refine(e.state.value);
        }
      }
    }), e._v(" "), n("span", {
      class: e.suit("labelText")
    }, [e._v(e._s(e.label))]), e._v(" "), null !== e.state.value.count ? n("span", {
      class: e.suit("count")
    }, [e._v(e._s(e.state.value.count.toLocaleString()))]) : e._e()])], {
      value: e.state.value,
      canRefine: e.canRefine,
      refine: e.state.refine,
      createURL: e.state.createURL,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: [],
  name: "AisToggleRefinement",
  mixins: [suit_t({
    name: "ToggleRefinement"
  }), widget_e({
    connector: toggle_refinement_connectToggleRefinement
  }), r({
    mapStateToCanRefine: ToggleRefinement_vue_i
  })],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    on: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: !0
    },
    off: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: void 0
    }
  },
  computed: {
    widgetParams: function () {
      return {
        attribute: this.attribute,
        label: this.label,
        on: this.on,
        off: this.off
      };
    },
    canRefine: function () {
      return ToggleRefinement_vue_i(this.state);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/voiceSearchHelper/index.js
function voiceSearchHelper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function voiceSearchHelper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      voiceSearchHelper_ownKeys(Object(source), true).forEach(function (key) {
        voiceSearchHelper_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      voiceSearchHelper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function voiceSearchHelper_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // `SpeechRecognition` is an API used on the browser so we can safely disable
// the `window` check.

/* eslint-disable no-restricted-globals */

/* global SpeechRecognition SpeechRecognitionEvent */


var createVoiceSearchHelper = function createVoiceSearchHelper(_ref) {
  var searchAsYouSpeak = _ref.searchAsYouSpeak,
      language = _ref.language,
      onQueryChange = _ref.onQueryChange,
      onStateChange = _ref.onStateChange;
  var SpeechRecognitionAPI = window.webkitSpeechRecognition || window.SpeechRecognition;

  var getDefaultState = function getDefaultState(status) {
    return {
      status: status,
      transcript: '',
      isSpeechFinal: false,
      errorCode: undefined
    };
  };

  var state = getDefaultState('initial');
  var recognition;

  var isBrowserSupported = function isBrowserSupported() {
    return Boolean(SpeechRecognitionAPI);
  };

  var isListening = function isListening() {
    return state.status === 'askingPermission' || state.status === 'waiting' || state.status === 'recognizing';
  };

  var setState = function setState() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    state = voiceSearchHelper_objectSpread(voiceSearchHelper_objectSpread({}, state), newState);
    onStateChange();
  };

  var getState = function getState() {
    return state;
  };

  var resetState = function resetState() {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
    setState(getDefaultState(status));
  };

  var onStart = function onStart() {
    setState({
      status: 'waiting'
    });
  };

  var onError = function onError(event) {
    setState({
      status: 'error',
      errorCode: event.error
    });
  };

  var onResult = function onResult(event) {
    setState({
      status: 'recognizing',
      transcript: event.results[0] && event.results[0][0] && event.results[0][0].transcript || '',
      isSpeechFinal: event.results[0] && event.results[0].isFinal
    });

    if (searchAsYouSpeak && state.transcript) {
      onQueryChange(state.transcript);
    }
  };

  var onEnd = function onEnd() {
    if (!state.errorCode && state.transcript && !searchAsYouSpeak) {
      onQueryChange(state.transcript);
    }

    if (state.status !== 'error') {
      setState({
        status: 'finished'
      });
    }
  };

  var startListening = function startListening() {
    recognition = new SpeechRecognitionAPI();

    if (!recognition) {
      return;
    }

    resetState('askingPermission');
    recognition.interimResults = true;

    if (language) {
      recognition.lang = language;
    }

    recognition.addEventListener('start', onStart);
    recognition.addEventListener('error', onError);
    recognition.addEventListener('result', onResult);
    recognition.addEventListener('end', onEnd);
    recognition.start();
  };

  var dispose = function dispose() {
    if (!recognition) {
      return;
    }

    recognition.stop();
    recognition.removeEventListener('start', onStart);
    recognition.removeEventListener('error', onError);
    recognition.removeEventListener('result', onResult);
    recognition.removeEventListener('end', onEnd);
    recognition = undefined;
  };

  var stopListening = function stopListening() {
    dispose(); // Because `dispose` removes event listeners, `end` listener is not called.
    // So we're setting the `status` as `finished` here.
    // If we don't do it, it will be still `waiting` or `recognizing`.

    resetState('finished');
  };

  return {
    getState: getState,
    isBrowserSupported: isBrowserSupported,
    isListening: isListening,
    startListening: startListening,
    stopListening: stopListening,
    dispose: dispose
  };
};

/* harmony default export */ var voiceSearchHelper = (createVoiceSearchHelper);
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/voice-search/connectVoiceSearch.js
function connectVoiceSearch_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectVoiceSearch_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectVoiceSearch_ownKeys(Object(source), true).forEach(function (key) {
        connectVoiceSearch_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectVoiceSearch_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectVoiceSearch_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var connectVoiceSearch_withUsage = createDocumentationMessageGenerator({
  name: 'voice-search',
  connector: true
});

var connectVoiceSearch = function connectVoiceSearch(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectVoiceSearch_withUsage());
  return function (widgetParams) {
    var _widgetParams$searchA = widgetParams.searchAsYouSpeak,
        searchAsYouSpeak = _widgetParams$searchA === void 0 ? false : _widgetParams$searchA,
        language = widgetParams.language,
        additionalQueryParameters = widgetParams.additionalQueryParameters,
        _widgetParams$createV = widgetParams.createVoiceSearchHelper,
        createVoiceSearchHelper = _widgetParams$createV === void 0 ? voiceSearchHelper : _widgetParams$createV;
    return {
      $$type: 'ais.voiceSearch',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, renderState), {}, {
          voiceSearch: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var _this = this;

        var helper = renderOptions.helper,
            instantSearchInstance = renderOptions.instantSearchInstance;

        if (!this._refine) {
          this._refine = function (query) {
            if (query !== helper.state.query) {
              var queryLanguages = language ? [language.split('-')[0]] : undefined;
              helper.setQueryParameter('queryLanguages', queryLanguages);

              if (typeof additionalQueryParameters === 'function') {
                helper.setState(helper.state.setQueryParameters(connectVoiceSearch_objectSpread({
                  ignorePlurals: true,
                  removeStopWords: true,
                  // @ts-ignore (optionalWords only allows array in v3, while string is also valid)
                  optionalWords: query
                }, additionalQueryParameters({
                  query: query
                }))));
              }

              helper.setQuery(query).search();
            }
          };
        }

        if (!this._voiceSearchHelper) {
          this._voiceSearchHelper = createVoiceSearchHelper({
            searchAsYouSpeak: searchAsYouSpeak,
            language: language,
            onQueryChange: function onQueryChange(query) {
              return _this._refine(query);
            },
            onStateChange: function onStateChange() {
              renderFn(connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, _this.getWidgetRenderState(renderOptions)), {}, {
                instantSearchInstance: instantSearchInstance
              }), false);
            }
          });
        }

        var _voiceSearchHelper = this._voiceSearchHelper,
            isBrowserSupported = _voiceSearchHelper.isBrowserSupported,
            isListening = _voiceSearchHelper.isListening,
            startListening = _voiceSearchHelper.startListening,
            stopListening = _voiceSearchHelper.stopListening,
            getState = _voiceSearchHelper.getState;
        return {
          isBrowserSupported: isBrowserSupported(),
          isListening: isListening(),
          toggleListening: function toggleListening() {
            if (!isBrowserSupported()) {
              return;
            }

            if (isListening()) {
              stopListening();
            } else {
              startListening();
            }
          },
          voiceListeningState: getState(),
          widgetParams: widgetParams
        };
      },
      dispose: function dispose(_ref) {
        var state = _ref.state;

        this._voiceSearchHelper.dispose();

        unmountFn();
        var newState = state;

        if (typeof additionalQueryParameters === 'function') {
          var additional = additionalQueryParameters({
            query: ''
          });
          var toReset = additional ? Object.keys(additional).reduce(function (acc, current) {
            // @ts-ignore search parameters is typed as readonly in v4
            acc[current] = undefined;
            return acc;
          }, {}) : {};
          newState = state.setQueryParameters(connectVoiceSearch_objectSpread({
            // @ts-ignore (queryLanguages is not added to algoliasearch v3)
            queryLanguages: undefined,
            ignorePlurals: undefined,
            removeStopWords: undefined,
            optionalWords: undefined
          }, toReset));
        }

        return newState.setQueryParameter('query', undefined);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref2) {
        var searchParameters = _ref2.searchParameters;
        var query = searchParameters.query || '';

        if (!query) {
          return uiState;
        }

        return connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, uiState), {}, {
          query: query
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref3) {
        var uiState = _ref3.uiState;
        return searchParameters.setQueryParameter('query', uiState.query || '');
      }
    };
  };
};

/* harmony default export */ var voice_search_connectVoiceSearch = (connectVoiceSearch);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/VoiceSearch.vue.js



/* harmony default export */ var VoiceSearch_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state ? s("div", {
      class: t.suit()
    }, [t._t("default", [s("button", {
      class: t.suit("button"),
      attrs: {
        type: "button",
        title: t.state.isBrowserSupported ? t.buttonTitle : t.disabledButtonTitle,
        disabled: !t.state.isBrowserSupported
      },
      on: {
        click: t.handleClick
      }
    }, [t._t("buttonText", [t.errorNotAllowed ? s("svg", t._b({}, "svg", t.buttonSvgAttrs, !1), [s("line", {
      attrs: {
        x1: "1",
        y1: "1",
        x2: "23",
        y2: "23"
      }
    }), t._v(" "), s("path", {
      attrs: {
        d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
      }
    }), t._v(" "), s("path", {
      attrs: {
        d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
      }
    }), t._v(" "), s("line", {
      attrs: {
        x1: "12",
        y1: "19",
        x2: "12",
        y2: "23"
      }
    }), t._v(" "), s("line", {
      attrs: {
        x1: "8",
        y1: "23",
        x2: "16",
        y2: "23"
      }
    })]) : s("svg", t._b({}, "svg", t.buttonSvgAttrs, !1), [s("path", {
      attrs: {
        d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z",
        fill: t.state.isListening ? "currentColor" : "none"
      }
    }), t._v(" "), s("path", {
      attrs: {
        d: "M19 10v2a7 7 0 0 1-14 0v-2"
      }
    }), t._v(" "), s("line", {
      attrs: {
        x1: "12",
        y1: "19",
        x2: "12",
        y2: "23"
      }
    }), t._v(" "), s("line", {
      attrs: {
        x1: "8",
        y1: "23",
        x2: "16",
        y2: "23"
      }
    })])], null, t.innerSlotProps)], 2), t._v(" "), s("div", {
      class: t.suit("status")
    }, [t._t("status", [s("p", [t._v(t._s(t.state.voiceListeningState.transcript))])], null, t.innerSlotProps)], 2)], null, t.rootSlotProps)], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisVoiceSearch",
  mixins: [widget_e({
    connector: voice_search_connectVoiceSearch
  }), suit_t({
    name: "VoiceSearch"
  })],
  props: {
    searchAsYouSpeak: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    buttonTitle: {
      type: String,
      required: !1,
      default: "Search by voice"
    },
    disabledButtonTitle: {
      type: String,
      required: !1,
      default: "Search by voice (not supported on this browser)"
    }
  },
  data: function () {
    return {
      buttonSvgAttrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    };
  },
  computed: {
    widgetParams: function () {
      return {
        searchAsYouSpeak: this.searchAsYouSpeak
      };
    },
    errorNotAllowed: function () {
      return "error" === this.state.voiceListeningState.status && "not-allowed" === this.state.voiceListeningState.errorCode;
    },
    rootSlotProps: function () {
      return {
        isBrowserSupported: this.state.isBrowserSupported,
        isListening: this.state.isListening,
        toggleListening: this.state.toggleListening,
        voiceListeningState: this.state.voiceListeningState
      };
    },
    innerSlotProps: function () {
      return {
        status: this.state.voiceListeningState.status,
        errorCode: this.state.voiceListeningState.errorCode,
        isListening: this.state.isListening,
        transcript: this.state.voiceListeningState.transcript,
        isSpeechFinal: this.state.voiceListeningState.isSpeechFinal,
        isBrowserSupported: this.state.isBrowserSupported
      };
    }
  },
  methods: {
    handleClick: function (t) {
      t.currentTarget.blur(), this.state.toggleListening();
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/relevant-sort/connectRelevantSort.js
function connectRelevantSort_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectRelevantSort_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectRelevantSort_ownKeys(Object(source), true).forEach(function (key) {
        connectRelevantSort_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectRelevantSort_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectRelevantSort_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}



var connectRelevantSort = function connectRelevantSort() {
  var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : utils_noop;
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  return function (widgetParams) {
    var connectorState = {};
    return {
      $$type: 'ais.relevantSort',
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectRelevantSort_objectSpread(connectRelevantSort_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectRelevantSort_objectSpread(connectRelevantSort_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref) {
        var state = _ref.state;
        unmountFn();
        return state.setQueryParameter('relevancyStrictness', undefined);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRelevantSort_objectSpread(connectRelevantSort_objectSpread({}, renderState), {}, {
          relevantSort: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref2) {
        var results = _ref2.results,
            helper = _ref2.helper;

        if (!connectorState.refine) {
          connectorState.refine = function (relevancyStrictness) {
            helper.setQueryParameter('relevancyStrictness', relevancyStrictness).search();
          };
        }

        var _ref3 = results || {},
            appliedRelevancyStrictness = _ref3.appliedRelevancyStrictness;

        var isVirtualReplica = appliedRelevancyStrictness !== undefined;
        return {
          isRelevantSorted: typeof appliedRelevancyStrictness !== 'undefined' && appliedRelevancyStrictness > 0,
          isVirtualReplica: isVirtualReplica,
          canRefine: isVirtualReplica,
          refine: connectorState.refine,
          widgetParams: widgetParams
        };
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref4) {
        var _uiState$relevantSort;

        var uiState = _ref4.uiState;
        return state.setQueryParameter('relevancyStrictness', (_uiState$relevantSort = uiState.relevantSort) !== null && _uiState$relevantSort !== void 0 ? _uiState$relevantSort : state.relevancyStrictness);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        return connectRelevantSort_objectSpread(connectRelevantSort_objectSpread({}, uiState), {}, {
          relevantSort: searchParameters.relevancyStrictness || uiState.relevantSort
        });
      }
    };
  };
};

/* harmony default export */ var relevant_sort_connectRelevantSort = (connectRelevantSort);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/RelevantSort.vue.js



/* harmony default export */ var RelevantSort_vue = ({
  render: function () {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state && t.state.isVirtualReplica ? s("div", {
      class: t.suit()
    }, [t._t("default", [s("div", {
      class: t.suit("text")
    }, [t._t("text", null, {
      isRelevantSorted: t.state.isRelevantSorted
    })], 2), t._v(" "), s("button", {
      class: t.suit("button"),
      attrs: {
        type: "button"
      },
      on: {
        click: function (e) {
          return t.refine();
        }
      }
    }, [t._t("button", [t._v(t._s(t.state.isRelevantSorted ? "See all results" : "See relevant results"))], {
      isRelevantSorted: t.state.isRelevantSorted
    })], 2)], {
      isRelevantSorted: t.state.isRelevantSorted,
      refine: t.state.refine
    })], 2) : t._e();
  },
  staticRenderFns: [],
  name: "AisRelevantSort",
  mixins: [suit_t({
    name: "RelevantSort"
  }), widget_e({
    connector: relevant_sort_connectRelevantSort
  })],
  methods: {
    refine: function () {
      this.state.isRelevantSorted ? this.state.refine(0) : this.state.refine(void 0);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/lib/utils/getWidgetAttribute.js

function getWidgetAttribute(widget, initOptions) {
  var _widget$getWidgetRend;

  var renderState = (_widget$getWidgetRend = widget.getWidgetRenderState) === null || _widget$getWidgetRend === void 0 ? void 0 : _widget$getWidgetRend.call(widget, initOptions);
  var attribute = null;

  if (renderState && renderState.widgetParams) {
    // casting as widgetParams is checked just before
    var widgetParams = renderState.widgetParams;

    if (widgetParams.attribute) {
      attribute = widgetParams.attribute;
    } else if (Array.isArray(widgetParams.attributes)) {
      attribute = widgetParams.attributes[0];
    }
  }

  if (typeof attribute !== 'string') {
    throw new Error("Could not find the attribute of the widget:\n\n".concat(JSON.stringify(widget), "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."));
  }

  return attribute;
}
;// CONCATENATED MODULE: ./node_modules/instantsearch.js/es/connectors/dynamic-widgets/connectDynamicWidgets.js


function connectDynamicWidgets_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function connectDynamicWidgets_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      connectDynamicWidgets_ownKeys(Object(source), true).forEach(function (key) {
        connectDynamicWidgets_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      connectDynamicWidgets_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function connectDynamicWidgets_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function connectDynamicWidgets_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    connectDynamicWidgets_typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    connectDynamicWidgets_typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return connectDynamicWidgets_typeof(obj);
}


var connectDynamicWidgets_withUsage = createDocumentationMessageGenerator({
  name: 'dynamic-widgets',
  connector: true
});
var MAX_WILDCARD_FACETS = 20;

var connectDynamicWidgets = function connectDynamicWidgets(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_noop;
  utils_checkRendering(renderFn, connectDynamicWidgets_withUsage());
  return function (widgetParams) {
    var widgets = widgetParams.widgets,
        _widgetParams$maxValu = widgetParams.maxValuesPerFacet,
        maxValuesPerFacet = _widgetParams$maxValu === void 0 ? 20 : _widgetParams$maxValu,
        _widgetParams$facets = widgetParams.facets,
        facets = _widgetParams$facets === void 0 ? ['*'] : _widgetParams$facets,
        _widgetParams$transfo = widgetParams.transformItems,
        transformItems = _widgetParams$transfo === void 0 ? function (items) {
      return items;
    } : _widgetParams$transfo,
        fallbackWidget = widgetParams.fallbackWidget;

    if (!(widgets && Array.isArray(widgets) && widgets.every(function (widget) {
      return connectDynamicWidgets_typeof(widget) === 'object';
    }))) {
      throw new Error(connectDynamicWidgets_withUsage('The `widgets` option expects an array of widgets.'));
    }

    if (!(Array.isArray(facets) && facets.length <= 1 && (facets[0] === '*' || facets[0] === undefined))) {
      throw new Error(connectDynamicWidgets_withUsage("The `facets` option only accepts [] or [\"*\"], you passed ".concat(JSON.stringify(facets))));
    }

    var localWidgets = new Map();
    return {
      $$type: 'ais.dynamicWidgets',
      init: function init(initOptions) {
        widgets.forEach(function (widget) {
          var attribute = getWidgetAttribute(widget, initOptions);
          localWidgets.set(attribute, {
            widget: widget,
            isMounted: false
          });
        });
        renderFn(connectDynamicWidgets_objectSpread(connectDynamicWidgets_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var parent = renderOptions.parent;
        var renderState = this.getWidgetRenderState(renderOptions);
        var widgetsToUnmount = [];
        var widgetsToMount = [];

        if (fallbackWidget) {
          renderState.attributesToRender.forEach(function (attribute) {
            if (!localWidgets.has(attribute)) {
              var widget = fallbackWidget({
                attribute: attribute
              });
              localWidgets.set(attribute, {
                widget: widget,
                isMounted: false
              });
            }
          });
        }

        localWidgets.forEach(function (_ref, attribute) {
          var widget = _ref.widget,
              isMounted = _ref.isMounted;
          var shouldMount = renderState.attributesToRender.indexOf(attribute) > -1;

          if (!isMounted && shouldMount) {
            widgetsToMount.push(widget);
            localWidgets.set(attribute, {
              widget: widget,
              isMounted: true
            });
          } else if (isMounted && !shouldMount) {
            widgetsToUnmount.push(widget);
            localWidgets.set(attribute, {
              widget: widget,
              isMounted: false
            });
          }
        });
        parent.addWidgets(widgetsToMount); // make sure this only happens after the regular render, otherwise it
        // happens too quick, since render is "deferred" for the next microtask,
        // so this needs to be a whole task later

        setTimeout(function () {
          return parent.removeWidgets(widgetsToUnmount);
        }, 0);
        renderFn(connectDynamicWidgets_objectSpread(connectDynamicWidgets_objectSpread({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref2) {
        var parent = _ref2.parent;
        var toRemove = [];
        localWidgets.forEach(function (_ref3) {
          var widget = _ref3.widget,
              isMounted = _ref3.isMounted;

          if (isMounted) {
            toRemove.push(widget);
          }
        });
        parent.removeWidgets(toRemove);
        unmountFn();
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state) {
        // broadening the scope of facets to avoid conflict between never and *
        return facets.reduce(function (acc, curr) {
          return acc.addFacet(curr);
        }, state.setQueryParameters({
          maxValuesPerFacet: Math.max(maxValuesPerFacet || 0, state.maxValuesPerFacet || 0)
        }));
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectDynamicWidgets_objectSpread(connectDynamicWidgets_objectSpread({}, renderState), {}, {
          dynamicWidgets: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref4) {
        var _results$renderingCon, _results$renderingCon2, _results$renderingCon3, _results$renderingCon4;

        var results = _ref4.results,
            state = _ref4.state;

        if (!results) {
          return {
            attributesToRender: [],
            widgetParams: widgetParams
          };
        }

        var attributesToRender = transformItems((_results$renderingCon = (_results$renderingCon2 = results.renderingContent) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.facetOrdering) === null || _results$renderingCon3 === void 0 ? void 0 : (_results$renderingCon4 = _results$renderingCon3.facets) === null || _results$renderingCon4 === void 0 ? void 0 : _results$renderingCon4.order) !== null && _results$renderingCon !== void 0 ? _results$renderingCon : [], {
          results: results
        });

        if (!Array.isArray(attributesToRender)) {
          throw new Error(connectDynamicWidgets_withUsage('The `transformItems` option expects a function that returns an Array.'));
        }

         false ? 0 : void 0;
         false ? 0 : void 0;
        return {
          attributesToRender: attributesToRender,
          widgetParams: widgetParams
        };
      }
    };
  };
};

/* harmony default export */ var dynamic_widgets_connectDynamicWidgets = (connectDynamicWidgets);
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/DynamicWidgets.js





/* harmony default export */ var DynamicWidgets = ({
  name: "AisDynamicWidgets",
  mixins: [widget_e({
    connector: dynamic_widgets_connectDynamicWidgets
  }), suit_t({
    name: "DynamicWidgets"
  })],
  props: {
    transformItems: {
      type: Function,
      default: void 0
    },
    facets: {
      type: Array,
      default: void 0
    },
    maxValuesPerFacet: {
      type: Number,
      default: void 0
    }
  },
  render: o(function (t) {
    var e = this,
        r = new Map();

    if ((f(this) || []).forEach(function (i) {
      var s = function t(e) {
        var i,
            r = e.componentOptions && e.componentOptions.propsData;

        if (r) {
          if (r.attribute) return r.attribute;
          if (Array.isArray(r.attributes)) return r.attributes[0];
        }

        if (i = e.componentOptions && e.componentOptions.children ? e.componentOptions.children : e.children, Array.isArray(i)) return i.reduce(function (e, i) {
          return e || t(i);
        }, void 0);
      }(i);

      s && r.set(s, t("div", {
        key: s,
        class: [e.suit("widget")]
      }, [i]));
    }), !this.state) {
      var s = [];
      return r.forEach(function (t) {
        return s.push(t);
      }), t("div", polyfills_e({
        class: [this.suit()]
      }, {
        attrs: {
          hidden: !0
        }
      }), s);
    }

    return t("div", {
      class: [this.suit()]
    }, this.state.attributesToRender.map(function (t) {
      return r.get(t);
    }));
  }),
  computed: {
    widgetParams: function () {
      return {
        transformItems: this.transformItems,
        facets: this.facets,
        maxValuesPerFacet: this.maxValuesPerFacet,
        widgets: []
      };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/components/ExperimentalDynamicWidgets.js


/* harmony default export */ var ExperimentalDynamicWidgets = (Object.assign({}, DynamicWidgets, {
  name: "AisExperimentalDynamicWidgets",
  mounted: function () {
    a("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.");
  }
}));
;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/widgets.js






































































;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/plugin.js

var plugin_o = {
  install: function (o) {
    Object.keys(widgets_namespaceObject).forEach(function (t) {
      o.component(widgets_namespaceObject[t].name, widgets_namespaceObject[t]);
    });
  }
};

;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/util/createServerRootMixin.js





function createServerRootMixin_r(e, n) {
  void 0 === n && (n = {});
  var r = n.mixins;
  void 0 === r && (r = []);
  var o,
      s = {
    serverPrefetch: void 0,
    fetch: void 0,
    _base: void 0,
    name: "ais-ssr-root-component"
  };
  return s.router = e.$router, s.store = e.$store, (o = new (e.$vnode ? e.$vnode.componentOptions.Ctor.extend(s) : t.component(s.name, Object.assign({}, e.$options, s)))({
    propsData: e.$options.propsData,
    mixins: [].concat(r)
  })).$slots = e.$slots, o.$root = e.$root, o.$options.serverPrefetch = [], o;
}

function createServerRootMixin_o(t, r) {
  var o,
      s = n(t);
  return s.findResultsState = function (t) {
    var e,
        n,
        i = t.component,
        a = t.renderToString;
    if (!a) throw new Error("findResultsState requires `renderToString: (component) => Promise<string>` in the first argument.");
    return Promise.resolve().then(function () {
      e = r(i, {
        mixins: [{
          beforeCreate: function () {
            i.$nuxt && (this.$nuxt = i.$nuxt);
          },
          created: function () {
            (n = this.instantsearch).start(), n.started = !1;
          }
        }]
      });
    }).then(function () {
      return a(e);
    }).then(function () {
      return t = n.mainHelper, new Promise(function (e, n) {
        t.searchOnlyWithDerivedHelpers(), t.derivedHelpers[0].on("result", function () {
          e();
        }), t.derivedHelpers.forEach(function (t) {
          return t.on("error", function (t) {
            n(t);
          });
        });
      });
      var t;
    }).then(function () {
      return o = {}, function t(e, n) {
        return n(e), e.getWidgets().forEach(function (e) {
          "ais.index" === e.$$type && (n(e), t(e, n));
        });
      }(n.mainIndex, function (t) {
        var e = t.getResults(),
            n = e._state,
            r = e._rawResults;
        o[t.getIndexId()] = {
          state: Object.keys(n).reduce(function (t, e) {
            return t[e] = n[e], t;
          }, {}),
          results: r
        };
      }), s.hydrate(o), s.getState();
    });
  }, s.getState = function () {
    if (!o) throw new Error("You need to wait for findResultsState to finish");
    return o;
  }, s.__forceRender = function (t, e) {
    var n = e.getResults();

    if (null !== n) {
      var r = n._state,
          o = e.getHelper();
      o.state = r, t.render({
        helper: o,
        results: n,
        scopedResults: e.getScopedResults(),
        parent: e,
        state: r,
        templatesConfig: {},
        createURL: e.createURL,
        instantSearchInstance: s,
        searchMetadata: {
          isSearchStalled: !1
        }
      });
    }
  }, s.hydrate = function (t) {
    t ? (s._initialResults = t, s.start(), s.started = !1) : e("The result of `findResultsState()` needs to be passed to `hydrate()`.");
  }, s;
}

function s(t) {
  void 0 === t && (t = {});
  var e = t.$cloneComponent;
  void 0 === e && (e = createServerRootMixin_r);
  var n = createServerRootMixin_o(t, e);
  return {
    provide: function () {
      return {
        $_ais_ssrInstantSearchInstance: this.instantsearch
      };
    },
    data: function () {
      return {
        instantsearch: n
      };
    }
  };
}


;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/src/instantsearch.js








































;// CONCATENATED MODULE: ./node_modules/vue-instantsearch/vue2/es/index.js

/* harmony default export */ var vue2_es = ((/* unused pure expression or super */ null && (InstantSearch)));

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentItem.vue?vue&type=script&lang=ts&


var TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TheHeaderSearchAlgoliaContentItem = class TheHeaderSearchAlgoliaContentItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "product", void 0);
  }

  onProductClick(event, productName) {
    searchNavigation(productName, 'product_click');
    searchEvent({
      searchTerm: productName,
      method: tagManager_SearchMethod.Image
    });
  }

};

TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_decorate([Prop()], TheHeaderSearchAlgoliaContentItem.prototype, "product", void 0);

TheHeaderSearchAlgoliaContentItem = TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    AisHighlight: Highlight_vue
  }
})], TheHeaderSearchAlgoliaContentItem);
/* harmony default export */ var TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContentItem);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentItem.vue?vue&type=style&index=0&id=55ae8088&lang=scss&scoped=true&
var TheHeaderSearchAlgoliaContentItemvue_type_style_index_0_id_55ae8088_lang_scss_scoped_true_ = __webpack_require__(5419);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentItem.vue?vue&type=style&index=0&id=55ae8088&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentItem.vue



;


/* normalize component */

var TheHeaderSearchAlgoliaContentItem_component = componentNormalizer_normalizeComponent(
  components_TheHeaderSearchAlgoliaContentItemvue_type_script_lang_ts_,
  TheHeaderSearchAlgoliaContentItemvue_type_template_id_55ae8088_scoped_true_render,
  TheHeaderSearchAlgoliaContentItemvue_type_template_id_55ae8088_scoped_true_staticRenderFns,
  false,
  null,
  "55ae8088",
  null
  
)

/* harmony default export */ var components_TheHeaderSearchAlgoliaContentItem = (TheHeaderSearchAlgoliaContentItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentHints.vue?vue&type=template&id=77c670a9&scoped=true&
var TheHeaderSearchAlgoliaContentHintsvue_type_template_id_77c670a9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"algolia-suggestions"},[_c('div',{staticClass:"algolia-suggestions__title"},[_vm._v(" Search suggestions ")]),_c('ais-index',{attrs:{"index-name":"products_query_suggestions"}},[_c('ais-hits',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return _vm._l((items),function(item,index){return _c('div',{key:index,staticClass:"algolia-suggestions__hint",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.onHintClick(item.query)},"keypress":function($event){return _vm.onHintClick(item.query)}}},[_vm._v(" "+_vm._s(item.query)+" ")])})}}])})],1)],1)}
var TheHeaderSearchAlgoliaContentHintsvue_type_template_id_77c670a9_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentHints.vue?vue&type=script&lang=ts&
var TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TheHeaderSearchAlgoliaContentHints = class TheHeaderSearchAlgoliaContentHints extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  onHintClick(hint) {
    searchNavigation(hint, 'search_suggestions');
    this.$emit('showSearchPage', hint);
  }

};
TheHeaderSearchAlgoliaContentHints = TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    AisHits: Hits_vue,
    AisIndex: Index
  }
})], TheHeaderSearchAlgoliaContentHints);
/* harmony default export */ var TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContentHints);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentHints.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContentHints.vue?vue&type=style&index=0&id=77c670a9&lang=scss&scoped=true&
var TheHeaderSearchAlgoliaContentHintsvue_type_style_index_0_id_77c670a9_lang_scss_scoped_true_ = __webpack_require__(6727);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentHints.vue?vue&type=style&index=0&id=77c670a9&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContentHints.vue



;


/* normalize component */

var TheHeaderSearchAlgoliaContentHints_component = componentNormalizer_normalizeComponent(
  components_TheHeaderSearchAlgoliaContentHintsvue_type_script_lang_ts_,
  TheHeaderSearchAlgoliaContentHintsvue_type_template_id_77c670a9_scoped_true_render,
  TheHeaderSearchAlgoliaContentHintsvue_type_template_id_77c670a9_scoped_true_staticRenderFns,
  false,
  null,
  "77c670a9",
  null
  
)

/* harmony default export */ var components_TheHeaderSearchAlgoliaContentHints = (TheHeaderSearchAlgoliaContentHints_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContent.vue?vue&type=script&lang=ts&


var TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TheHeaderSearchAlgoliaContent = class TheHeaderSearchAlgoliaContent extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "products", void 0);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "currentValue", void 0);

    _defineProperty(this, "storeUrl", null);
  }

  get searchValue() {
    const {
      currentValue
    } = this;

    if (currentValue) {
      return currentValue.replace(/\W*$/, '');
    }

    return currentValue;
  }

  mounted() {
    const {
      storeUrl
    } = takeGlobalOptions();
    this.storeUrl = storeUrl;
  }

  onHintClick() {
    searchEvent({
      searchTerm: this.searchValue,
      method: tagManager_SearchMethod.Suggestion
    });
  }

};

TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_decorate([Prop({
  default: () => [],
  type: Array
})], TheHeaderSearchAlgoliaContent.prototype, "products", void 0);

TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_decorate([Prop({
  default: 800,
  type: Number
})], TheHeaderSearchAlgoliaContent.prototype, "width", void 0);

TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_decorate([Prop({
  default: null,
  type: String
})], TheHeaderSearchAlgoliaContent.prototype, "currentValue", void 0);

TheHeaderSearchAlgoliaContent = TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheHeaderSearchAlgoliaContentItem: components_TheHeaderSearchAlgoliaContentItem,
    TheHeaderSearchAlgoliaContentHints: components_TheHeaderSearchAlgoliaContentHints
  }
})], TheHeaderSearchAlgoliaContent);
/* harmony default export */ var TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContent);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_ = (TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderSearchAlgoliaContent.vue?vue&type=style&index=0&id=7d3ee84b&lang=scss&scoped=true&
var TheHeaderSearchAlgoliaContentvue_type_style_index_0_id_7d3ee84b_lang_scss_scoped_true_ = __webpack_require__(1198);
;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContent.vue?vue&type=style&index=0&id=7d3ee84b&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderSearchAlgoliaContent.vue



;


/* normalize component */

var TheHeaderSearchAlgoliaContent_component = componentNormalizer_normalizeComponent(
  components_TheHeaderSearchAlgoliaContentvue_type_script_lang_ts_,
  TheHeaderSearchAlgoliaContentvue_type_template_id_7d3ee84b_scoped_true_render,
  TheHeaderSearchAlgoliaContentvue_type_template_id_7d3ee84b_scoped_true_staticRenderFns,
  false,
  null,
  "7d3ee84b",
  null
  
)

/* harmony default export */ var components_TheHeaderSearchAlgoliaContent = (TheHeaderSearchAlgoliaContent_component.exports);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(9840);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/algoliasearch-helper/src/DerivedHelper/index.js
var DerivedHelper = __webpack_require__(9717);
var DerivedHelper_default = /*#__PURE__*/__webpack_require__.n(DerivedHelper);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeaderSearch.vue?vue&type=script&lang=ts&


var HeaderSearchvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














(DerivedHelper_default()).prototype.getModifiedState = function modify(parameters) {
  const data = this.fn(parameters);
  if (data.index === 'products_query_suggestions') data.filters = '';
  return data;
};

let HeaderSearch = class HeaderSearch extends mixins(userDeviceWidth) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "search", '');

    _defineProperty(this, "inFocusMode", false);

    _defineProperty(this, "showAlgoliaAutocomplete", false);

    _defineProperty(this, "searchClient", null);

    _defineProperty(this, "searchWidth", 800);

    _defineProperty(this, "searchAnalytics", lodash_es_debounce(this.handleSearchAnalytics, 500));
  }

  get filters() {
    const companyId = this.$store.state.header?.headerData?.companyId ?? 0; // prettier-ignore

    let searchableCategories = this.$store.state.header?.headerData?.searchableCategories ?? [];
    const searchFilters = this.$store.state.header?.headerData?.searchFilters;
    let groupFilter = 'group_id:0';

    if (Number(companyId)) {
      groupFilter += ` OR group_id:${companyId}`;
    }

    let categoriesToSearch = searchFilters ? ` AND ${searchFilters}` : '';

    if (!searchFilters) {
      if (searchableCategories.length > 0) {
        searchableCategories = searchableCategories.map(previousValue => `category_ids:${previousValue}`);
        categoriesToSearch = searchableCategories.join(' AND ');
        categoriesToSearch = ` AND ${categoriesToSearch}`;
      }
    }

    return `in_search=1 AND (${groupFilter})${categoriesToSearch}`;
  }

  get hitsNumber() {
    const {
      userDeviceWidth,
      userDeviceHeight
    } = this;
    if (userDeviceHeight <= 1000 && userDeviceWidth <= 1400) return 4;
    return userDeviceWidth <= 960 ? 4 : 6;
  }

  onChildChanged() {
    this.$nextTick(() => {
      this.updateElementWidth();
      this.searchAnalytics();
    });
  }

  created() {
    const {
      algoliaAppId,
      algoliaAppKey
    } = takeGlobalOptions();
    const algoliaSearchClient = algoliasearch_lite_umd_default()(algoliaAppId, algoliaAppKey);
    this.searchClient = { ...algoliaSearchClient,

      search(requests) {
        if (requests.every(({
          params
        }) => !params?.query)) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              hitsPerPage: 0,
              exhaustiveNbHits: false,
              query: '',
              params: ''
            }))
          });
        }

        return algoliaSearchClient.search(requests);
      }

    };
  }

  mounted() {
    this.updateElementWidth();
  } // this should be also emitted when inFocusMode change or check event for resize in v-tooltip


  updateElementWidth() {
    this.searchWidth = this.$el?.clientWidth;
  }

  clearSearchInput() {
    this.search = '';
    this.$refs['search-input'].focus();
    setTimeout(() => {
      this.showAlgoliaAutocomplete = true;
    }, 0);
  }

  checkIfPopperShouldBeStillVisible() {
    if (this.inFocusMode) {
      setTimeout(() => {
        this.showAlgoliaAutocomplete = true;
      }, 0);
    }
  }

  handleSearchAnalytics() {
    const {
      search
    } = this;

    if (search) {
      searchNavigation(search);
    }
  }

  searchFunction(helper) {
    if (helper.state.query && helper.state.query.length < 3) return;
    helper?.search();
  }

  onSuggestionClick(hint) {
    searchEvent({
      searchTerm: hint,
      method: tagManager_SearchMethod.Suggestion,
      eventCallback: this.showSearchPage(hint),
      timeout: 1000
    });
  }

  onSearch(hint) {
    searchEvent({
      searchTerm: hint,
      method: tagManager_SearchMethod.SearchBar,
      eventCallback: this.showSearchPage(hint),
      timeout: 1000
    });
  }

  showSearchPage(hint) {
    const {
      storeUrl
    } = takeGlobalOptions();
    let searchText = hint;

    if (hint) {
      searchText = encodeURIComponent(hint.replace(/\W*$/, ''));
    }

    window.location.href = `${storeUrl}/search?q=${searchText}`;
  }

};

HeaderSearchvue_type_script_lang_ts_decorate([Watch('search')], HeaderSearch.prototype, "onChildChanged", null);

HeaderSearch = HeaderSearchvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CloseIcon: icons_Close,
    SearchIcon: icons_Search,
    AisConfigure: Configure,
    AisAutocomplete: Autocomplete_vue,
    AisInstantSearch: components_InstantSearch,
    TheHeaderSearchAlgoliaContent: components_TheHeaderSearchAlgoliaContent
  }
})], HeaderSearch);
/* harmony default export */ var HeaderSearchvue_type_script_lang_ts_ = (HeaderSearch);
;// CONCATENATED MODULE: ./src/components/HeaderSearch.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_HeaderSearchvue_type_script_lang_ts_ = (HeaderSearchvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeaderSearch.vue?vue&type=style&index=0&id=52e0e9c6&lang=scss&scoped=true&
var HeaderSearchvue_type_style_index_0_id_52e0e9c6_lang_scss_scoped_true_ = __webpack_require__(3549);
;// CONCATENATED MODULE: ./src/components/HeaderSearch.vue?vue&type=style&index=0&id=52e0e9c6&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HeaderSearch.vue



;


/* normalize component */

var HeaderSearch_component = componentNormalizer_normalizeComponent(
  components_HeaderSearchvue_type_script_lang_ts_,
  HeaderSearchvue_type_template_id_52e0e9c6_scoped_true_render,
  HeaderSearchvue_type_template_id_52e0e9c6_scoped_true_staticRenderFns,
  false,
  null,
  "52e0e9c6",
  null
  
)

/* harmony default export */ var components_HeaderSearch = (HeaderSearch_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogRightTransition.vue?vue&type=template&id=17d54095&scoped=true&
var DialogRightTransitionvue_type_template_id_17d54095_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog-right"}},[_vm._t("default")],2)}
var DialogRightTransitionvue_type_template_id_17d54095_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogRightTransition.vue?vue&type=script&lang=ts&
var DialogRightTransitionvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let DialogRightTransition = class DialogRightTransition extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
DialogRightTransition = DialogRightTransitionvue_type_script_lang_ts_decorate([vue_class_component_esm], DialogRightTransition);
/* harmony default export */ var DialogRightTransitionvue_type_script_lang_ts_ = (DialogRightTransition);
;// CONCATENATED MODULE: ./src/components/transitions/DialogRightTransition.vue?vue&type=script&lang=ts&
 /* harmony default export */ var transitions_DialogRightTransitionvue_type_script_lang_ts_ = (DialogRightTransitionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/DialogRightTransition.vue?vue&type=style&index=0&id=17d54095&lang=scss&scoped=true&
var DialogRightTransitionvue_type_style_index_0_id_17d54095_lang_scss_scoped_true_ = __webpack_require__(8286);
;// CONCATENATED MODULE: ./src/components/transitions/DialogRightTransition.vue?vue&type=style&index=0&id=17d54095&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/transitions/DialogRightTransition.vue



;


/* normalize component */

var DialogRightTransition_component = componentNormalizer_normalizeComponent(
  transitions_DialogRightTransitionvue_type_script_lang_ts_,
  DialogRightTransitionvue_type_template_id_17d54095_scoped_true_render,
  DialogRightTransitionvue_type_template_id_17d54095_scoped_true_staticRenderFns,
  false,
  null,
  "17d54095",
  null
  
)

/* harmony default export */ var transitions_DialogRightTransition = (DialogRightTransition_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationButton.vue?vue&type=template&id=25237f92&scoped=true&
var TheHeaderMobileNavigationButtonvue_type_template_id_25237f92_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation__button",class:{ 'header-mobile-navigation__button--active': _vm.active },attrs:{"tabindex":"0"}},[(_vm.active)?_c('div',{staticClass:"button__icon button__icon--left"},[_c('chevron-down-icon',{attrs:{"color":"#62646A"}})],1):_vm._e(),_c('div',{staticClass:"button__content"},[_vm._t("default")],2),_c('div',{staticClass:"button__icon button__icon--right"},[(!_vm.active)?_c('chevron-down-icon',{attrs:{"color":"#62646A"}}):_vm._e()],1)])}
var TheHeaderMobileNavigationButtonvue_type_template_id_25237f92_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/ChevronDown.vue?vue&type=template&id=64e26299&
var ChevronDownvue_type_template_id_64e26299_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 8","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M0.578979 1.23792L5.59345 6.33336","stroke":_vm.color,"stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.225 1.08337L5.21051 6.17882","stroke":_vm.color,"stroke-width":"1.5"}})])}
var ChevronDownvue_type_template_id_64e26299_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/ChevronDown.vue?vue&type=script&lang=ts&


var ChevronDownvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ChevronDown = class ChevronDown extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);

    _defineProperty(this, "color", void 0);
  }

};

ChevronDownvue_type_script_lang_ts_decorate([Prop({
  default: 11
})], ChevronDown.prototype, "width", void 0);

ChevronDownvue_type_script_lang_ts_decorate([Prop({
  default: 8
})], ChevronDown.prototype, "height", void 0);

ChevronDownvue_type_script_lang_ts_decorate([Prop({
  default: '#020303'
})], ChevronDown.prototype, "color", void 0);

ChevronDown = ChevronDownvue_type_script_lang_ts_decorate([vue_class_component_esm], ChevronDown);
/* harmony default export */ var ChevronDownvue_type_script_lang_ts_ = (ChevronDown);
;// CONCATENATED MODULE: ./src/components/icons/ChevronDown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChevronDownvue_type_script_lang_ts_ = (ChevronDownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/ChevronDown.vue





/* normalize component */
;
var ChevronDown_component = componentNormalizer_normalizeComponent(
  icons_ChevronDownvue_type_script_lang_ts_,
  ChevronDownvue_type_template_id_64e26299_render,
  ChevronDownvue_type_template_id_64e26299_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_ChevronDown = (ChevronDown_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationButton.vue?vue&type=script&lang=ts&


var TheHeaderMobileNavigationButtonvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


 // TODO change name

let TheHeaderMobileNavigationButton = class TheHeaderMobileNavigationButton extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "active", void 0);
  }

};

TheHeaderMobileNavigationButtonvue_type_script_lang_ts_decorate([Prop({
  required: false,
  type: Boolean,
  default: false
})], TheHeaderMobileNavigationButton.prototype, "active", void 0);

TheHeaderMobileNavigationButton = TheHeaderMobileNavigationButtonvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    ChevronDownIcon: icons_ChevronDown
  }
})], TheHeaderMobileNavigationButton);
/* harmony default export */ var TheHeaderMobileNavigationButtonvue_type_script_lang_ts_ = (TheHeaderMobileNavigationButton);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderMobileNavigationButtonvue_type_script_lang_ts_ = (TheHeaderMobileNavigationButtonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationButton.vue?vue&type=style&index=0&id=25237f92&lang=scss&scoped=true&
var TheHeaderMobileNavigationButtonvue_type_style_index_0_id_25237f92_lang_scss_scoped_true_ = __webpack_require__(1824);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationButton.vue?vue&type=style&index=0&id=25237f92&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationButton.vue



;


/* normalize component */

var TheHeaderMobileNavigationButton_component = componentNormalizer_normalizeComponent(
  components_TheHeaderMobileNavigationButtonvue_type_script_lang_ts_,
  TheHeaderMobileNavigationButtonvue_type_template_id_25237f92_scoped_true_render,
  TheHeaderMobileNavigationButtonvue_type_template_id_25237f92_scoped_true_staticRenderFns,
  false,
  null,
  "25237f92",
  null
  
)

/* harmony default export */ var components_TheHeaderMobileNavigationButton = (TheHeaderMobileNavigationButton_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigation.vue?vue&type=script&lang=ts&


var TheHeaderMobileNavigationvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














let TheHeaderMobileNavigation = class TheHeaderMobileNavigation extends mixins(showShopHolidaysLink, userIsLoggedIn, subdomainInfo, companyName) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "value", void 0);

    _defineProperty(this, "myAccountButton", {
      name: 'My Account',
      component: 'UserMenu',
      icon: 'UserIcon',
      iconWidth: 19,
      iconHeight: 18
    });

    _defineProperty(this, "myFavoritesButton", {
      name: 'My Favorites',
      component: '',
      icon: 'HeartIcon',
      iconWidth: 19,
      iconHeight: 18
    });

    _defineProperty(this, "eGiftCollectionsButton", {
      name: 'Let Them Choose!',
      component: 'TheMobileNavigationLetThem'
    });

    _defineProperty(this, "shopHolidayButton", {
      name: 'Shop Holiday',
      component: ''
    });

    _defineProperty(this, "defaultHeaderDropdownsData", [{
      name: 'What we offer',
      component: 'TheMobileNavigationWhatWeOffer'
    }, {
      name: 'Resources',
      component: 'TheMobileNavigationResources'
    }, {
      name: 'Pricing',
      component: ''
    }, {
      name: 'Shop Products',
      component: 'TheMobileNavigationShopProducts'
    }, {
      name: 'Shop By',
      component: 'TheMobileNavigationShopBy'
    }]);

    _defineProperty(this, "helpDataButton", {
      name: 'Help',
      component: 'TheMobileNavigationHelp',
      icon: 'HelpIcon',
      iconWidth: 19,
      iconHeight: 19
    });
  }

  get userHasCompanyMenu() {
    return !!this.$store.state.header.headerData?.links?.length ?? false;
  }

  get hideSearch() {
    return this.$store.state.header.headerData?.menus?.hideSearch;
  }

  get hideDefaultDropdowns() {
    return this.$store.state.header.headerData?.menus?.hideMenu ?? false;
  }

  get navigationButtonsData() {
    const {
      defaultHeaderDropdownsData,
      eGiftCollectionsButton,
      hideDefaultDropdowns,
      showShopHolidaysLink,
      userHasCompanyMenu,
      myFavoritesButton,
      shopHolidayButton,
      hasExternalDomain,
      myAccountButton,
      helpDataButton,
      companyName
    } = this;
    const result = [myAccountButton, myFavoritesButton];

    if (!hideDefaultDropdowns) {
      result.push(...defaultHeaderDropdownsData);

      if (showShopHolidaysLink) {
        result.push(shopHolidayButton);
      }

      if (!hasExternalDomain) {
        result.push(eGiftCollectionsButton);
      }

      if (hasExternalDomain) {
        result.splice(2, 3);
      }
    }

    if (userHasCompanyMenu) {
      result.push({
        name: `Shop ${companyName}`,
        component: 'TheMobileNavigationUserCompanyMenu'
      });
    }

    result.push(helpDataButton);
    return result;
  }

  handleButtonClick(data) {
    const {
      userIsLoggedIn,
      myAccountButton: {
        name
      },
      myFavoritesButton: {
        name: favName
      },
      eGiftCollectionsButton: {
        name: collectionsName
      },
      shopHolidayButton: {
        name: shopHolidayName
      }
    } = this;
    const {
      accountUrl,
      storeUrl
    } = takeGlobalOptions();

    switch (data.name) {
      case name:
        {
          if (!userIsLoggedIn) this.$emit('loginRequired');
          if (userIsLoggedIn) this.$emit('showNavigationPanel', data);
          break;
        }

      case favName:
        {
          const redirect = `${accountUrl}/my-favorites`;
          if (!userIsLoggedIn) this.$emit('showLoginPanel', {
            redirect
          });
          if (userIsLoggedIn) window.location.href = redirect;
          break;
        }

      case 'Pricing':
        {
          navigationClick({
            item: 'Pricing'
          });
          const redirect = `${storeUrl}/pricing`;
          window.location.href = redirect;
          break;
        }

      case collectionsName:
        {
          navigationClick({
            item: collectionsName
          });
          this.$emit('showNavigationPanel', data);
          break;
        }

      case shopHolidayName:
        {
          navigationClick({
            item: shopHolidayName
          });
          const redirect = `${storeUrl}/occasions/holiday-2024`;
          window.location.href = redirect;
          break;
        }

      default:
        this.$emit('showNavigationPanel', data);
        break;
    }
  }

};

TheHeaderMobileNavigationvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Boolean
})], TheHeaderMobileNavigation.prototype, "value", void 0);

TheHeaderMobileNavigation = TheHeaderMobileNavigationvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    HelpIcon: Help,
    UserIcon: icons_User,
    HeartIcon: icons_Heart,
    HeaderSearch: components_HeaderSearch,
    DialogRightTransition: transitions_DialogRightTransition,
    TheHeaderMobileNavigationButton: components_TheHeaderMobileNavigationButton
  }
})], TheHeaderMobileNavigation);
/* harmony default export */ var TheHeaderMobileNavigationvue_type_script_lang_ts_ = (TheHeaderMobileNavigation);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigation.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderMobileNavigationvue_type_script_lang_ts_ = (TheHeaderMobileNavigationvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigation.vue?vue&type=style&index=0&id=1dd687dc&lang=scss&scoped=true&
var TheHeaderMobileNavigationvue_type_style_index_0_id_1dd687dc_lang_scss_scoped_true_ = __webpack_require__(3289);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigation.vue?vue&type=style&index=0&id=1dd687dc&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigation.vue



;


/* normalize component */

var TheHeaderMobileNavigation_component = componentNormalizer_normalizeComponent(
  components_TheHeaderMobileNavigationvue_type_script_lang_ts_,
  TheHeaderMobileNavigationvue_type_template_id_1dd687dc_scoped_true_render,
  TheHeaderMobileNavigationvue_type_template_id_1dd687dc_scoped_true_staticRenderFns,
  false,
  null,
  "1dd687dc",
  null
  
)

/* harmony default export */ var components_TheHeaderMobileNavigation = (TheHeaderMobileNavigation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationPanel.vue?vue&type=template&id=285936be&scoped=true&
var TheHeaderMobileNavigationPanelvue_type_template_id_285936be_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-right-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"header-mobile-navigation__panel"},[(_vm.componentData)?_c('the-header-mobile-navigation-button',{attrs:{"active":""},nativeOn:{"click":function($event){_vm.show = false},"keypress":function($event){_vm.show = false}}},[(_vm.componentData.icon)?_c(_vm.componentData.icon,{tag:"component",attrs:{"width":_vm.componentData.iconWidth,"height":_vm.componentData.iconHeight}}):_vm._e(),_vm._v(" "+_vm._s(_vm.componentData.name)+" ")],1):_vm._e(),_c('div',{staticClass:"panel__content"},[(_vm.componentData)?_c(_vm.componentData.component,{tag:"component"}):_vm._e()],1)],1)])}
var TheHeaderMobileNavigationPanelvue_type_template_id_285936be_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserMenu.vue?vue&type=template&id=a60cb1f0&scoped=true&
var UserMenuvue_type_template_id_a60cb1f0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop-user-menu"},[_c('div',{staticClass:"desktop-user-menu__user-name"},[_vm._v(" "+_vm._s(_vm.userFullName)+" ")]),_c('div',{staticClass:"desktop-user-menu__profile-link"},[_c('a',{attrs:{"href":_vm.viewProfileLink,"to":_vm.viewProfileLink,"tabindex":"0"}},[_vm._v(" View profile ")])]),_c('div',{staticClass:"desktop-user-menu__links"},_vm._l((_vm.menus),function(menu,index){return _c('ul',{key:index},_vm._l((menu),function(menuData,menuDataIndex){return _c('li',{key:'user-menu-item-'+ menuDataIndex},[_c('a',{attrs:{"href":menuData.url,"aria-disabled":menuData.disabled,"disabled":menuData.disabled,"tabindex":menuData.disabled ? -1 : 0},on:{"click":function($event){!menuData.url ? _vm.handleLinkClick(menuData) : null}}},[_c(menuData.icon,{tag:"component"}),_vm._v(" "+_vm._s(menuData.title)+" ")],1),(menuData.disabled)?_c('question-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: menuData.disabledTooltip,
            container: false,
            classes: 'desktop-user-menu-tooltip__content',
            trigger: (_vm.userUsingPhone || _vm.userUsingTablet) ? 'click' : 'hover',
            offset: 7,
            autoHide: false,
          }),expression:"{\n            content: menuData.disabledTooltip,\n            container: false,\n            classes: 'desktop-user-menu-tooltip__content',\n            trigger: (userUsingPhone || userUsingTablet) ? 'click' : 'hover',\n            offset: 7,\n            autoHide: false,\n          }"}],staticClass:"desktop-user-menu-tooltip__activator"}):_vm._e()],1)}),0)}),0)])}
var UserMenuvue_type_template_id_a60cb1f0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/userIsInAccountModule.ts


var userIsInAccountModule_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserIsInAccountModule = class UserIsInAccountModule extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "host", window.location.host);

    _defineProperty(this, "domains", this.host.split('.'));

    _defineProperty(this, "subdomain", this.domains[0]);
  }

  get userIsInAccountModule() {
    return this.subdomain === 'account';
  }

};
UserIsInAccountModule = userIsInAccountModule_decorate([vue_class_component_esm], UserIsInAccountModule);
/* harmony default export */ var mixins_userIsInAccountModule = (UserIsInAccountModule);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Question.vue?vue&type=template&id=6e3330b6&
var Questionvue_type_template_id_6e3330b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.32241 11.9094C8.9066 11.9094 8.56984 12.2461 8.56984 12.6619C8.56984 13.0777 8.9066\n      13.4153 9.32241 13.4153C9.73822 13.4153 10.075 13.0777 10.075 12.6619C10.075 12.2461\n      9.73822 11.9094 9.32241 11.9094M9.32241 4.00344C7.76984 4.00344 6.49869 5.27459 6.49869\n      6.82716C6.49474 7.13862 6.74375 7.39554 7.056 7.39949C7.36747 7.40423 7.62359 7.15522\n      7.62834 6.84297C7.62834 6.83743 7.62834 6.83269 7.62834 6.82716C7.62834 5.88486 8.38011\n      5.13308 9.32241 5.13308C10.2647 5.13308 11.0165 5.88486 11.0165 6.82716C11.0165 7.41293\n      10.7801 7.81293 10.3928 8.22083C10.0054 8.62953 9.46865 8.9987 8.96984 9.39791C8.83545\n      9.50463 8.75798 9.66747 8.75798 9.83901V10.5916C8.75324 10.9038 9.00225 11.16 9.3145\n      11.1647C9.62596 11.1687 9.88288 10.9196 9.88683 10.6074C9.88683 10.6027 9.88683 10.5971\n      9.88683 10.5916V10.1149C10.2987 9.80107 10.7817 9.45561 11.2165 8.99791C11.7232 8.46352\n      12.1461 7.74336 12.1461 6.82716C12.1461 5.27459 10.875 4.00344 9.32241 4.00344M9.32241\n      1.36866C13.3833 1.36866 16.6631 4.6485 16.6631 8.70937C16.6631 12.7702 13.3833 16.0501\n      9.32241 16.0501C5.26154 16.0501 1.9817 12.7702 1.9817 8.70937C1.9817 4.6485 5.26154 1.36866\n      9.32241 1.36866M9.32241 0.239014C4.65126 0.239014 0.852051 4.03822 0.852051\n      8.70937C0.852051 13.3805 4.65126 17.1797 9.32241 17.1797C13.9936 17.1797 17.7928 13.3805\n      17.7928 8.70937C17.7928 4.03822 13.9936 0.239014 9.32241 0.239014","fill":"currentColor"}})])}
var Questionvue_type_template_id_6e3330b6_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Question.vue?vue&type=script&lang=ts&


var Questionvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Question = class Question extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Questionvue_type_script_lang_ts_decorate([Prop({
  default: 18
})], Question.prototype, "width", void 0);

Questionvue_type_script_lang_ts_decorate([Prop({
  default: 18
})], Question.prototype, "height", void 0);

Question = Questionvue_type_script_lang_ts_decorate([vue_class_component_esm], Question);
/* harmony default export */ var Questionvue_type_script_lang_ts_ = (Question);
;// CONCATENATED MODULE: ./src/components/icons/Question.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Questionvue_type_script_lang_ts_ = (Questionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Question.vue





/* normalize component */
;
var Question_component = componentNormalizer_normalizeComponent(
  icons_Questionvue_type_script_lang_ts_,
  Questionvue_type_template_id_6e3330b6_render,
  Questionvue_type_template_id_6e3330b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Question = (Question_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Account.vue?vue&type=template&id=11b457b0&
var Accountvue_type_template_id_11b457b0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_1252_5469","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"21","height":"21"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 10.5001C0 15.9954 4.51887 20.4501 10.0931 20.4501V20.4501C15.6677 20.4501 20.1866\n        15.9954 20.1866 10.5001V10.5001C20.1866 5.00458 15.6677 0.549805 10.0931\n        0.549805V0.549805C4.51887 0.549805 0 5.00458 0 10.5001V10.5001ZM0.960305 10.5001C0.960305\n        5.52779 5.04944 1.49749 10.0924 1.49749V1.49749C15.1359 1.49749 19.2242 5.52779 19.2242\n        10.5001V10.5001C19.2254 13.051 18.144 15.3499 16.4135 16.9877V16.9877C16.2296 16.7206\n        16.0344 16.4528 15.8609 16.1857V16.1857C15.8609 16.1857 15.1034 14.9004 12.0158\n        14.7643V14.7643C11.7058 14.7643 11.5509 14.5641 11.5509 14.2591V14.2591V13.8167C11.5509\n        13.7631 11.5604 13.7158 11.562 13.6641V13.6641C11.9185 13.5012 12.3254 13.2737 12.7842\n        12.932V12.932C12.7842 12.932 13.9379 12.2112 13.9379 11.4474V11.4474C13.9379 11.4474\n        14.4185 9.00164 14.4185 8.13079V8.13079C14.4185 5.93005 13.4189 3.86662 10.0928\n        3.86662V3.86662C6.72163 3.86662 5.76708 5.93005 5.76708 8.13079V8.13079C5.76708 9.02385\n        6.24783 11.4474 6.24783 11.4474V11.4474C6.24783 12.2323 7.40131 12.932 7.40131\n        12.932V12.932C7.86986 13.2543 8.27401 13.478 8.62156 13.6398V13.6398C8.62444 13.6991\n        8.63461 13.7546 8.63461 13.8167V13.8167C8.63461 13.8167 8.63461 14.0119 8.63546\n        14.2591V14.2591H8.63461C8.63461 14.5648 8.47973 14.7643 8.16979 14.7643V14.7643C5.12722\n        14.8855 4.32485 16.1857 4.32485 16.1857V16.1857C4.15217 16.4528 3.95645 16.7206 3.7731\n        16.9877V16.9877C2.04262 15.3499 0.960305 13.051 0.960305 10.5001V10.5001ZM4.5021\n        17.6072C4.57801 17.4974 4.67274 17.3618 4.74916 17.2555V17.2555C4.88219 17.0684 5.01589\n        16.8827 5.13688 16.6946V16.6946C5.13789 16.6946 5.82809 15.8062 8.21063\n        15.7109V15.7109H8.21148C8.99826 15.7109 9.59729 15.1002 9.59729 14.2591V14.2591L9.61288\n        13.8199C9.61271 13.8189 9.61271 13.8179 9.61254 13.8167V13.8167C9.61254 13.8049 9.61271\n        13.799 9.61305 13.797V13.797V13.343L9.13247 12.8689C8.78407 12.7059 8.33162 12.4155\n        7.95255 12.1546V12.1546L7.90629 12.125C7.59297 11.9317 7.23965 11.5811 7.20898\n        11.4319V11.4319L7.1922 11.2652C7.01394 10.3631 6.72925 8.71381 6.72925\n        8.1308V8.1308C6.72925 5.86841 7.79886 4.81414 10.0936 4.81414V4.81414C12.3579 4.81414\n        13.4582 5.89881 13.4582 8.1308V8.1308C13.4582 8.69794 13.1745 10.3554 12.9952\n        11.267V11.267L12.9771 11.4474C12.9405 11.5884 12.5499 11.9565 12.2699\n        12.1314V12.1314L12.2052 12.1748C11.8522 12.4387 11.4062 12.7079 11.0539\n        12.8689V12.8689L10.5735 13.343V13.8C10.5734 13.7992 10.5732 13.7989 10.5732\n        13.7989V13.7989C10.5723 13.7989 10.5715 13.8086 10.571 13.8183V13.8183C10.57 13.8348\n        10.57 13.8513 10.5735 13.8198V13.8198V13.8167V13.8C10.5737 13.802 10.5739 13.8072 10.5739\n        13.8167V13.8167C10.5737 13.8177 10.5735 13.8188 10.5735 13.8198V13.8198L10.5893\n        14.2591C10.5903 15.101 11.19 15.712 12.0153 15.712V15.712C14.3876 15.8175 15.0456 16.6884\n        15.0519 16.6976V16.6976C15.171 16.8818 15.3032 17.0684 15.4369 17.2555V17.2555C15.5128\n        17.3621 15.6084 17.4974 15.684 17.6072V17.6072C14.1384 18.7907 12.2028 19.5025 10.0931\n        19.5025V19.5025C7.98475 19.5025 6.04838 18.7907 4.5021 17.6072V17.6072ZM9.61305\n        13.797V13.8167L9.61288 13.8199C9.61576 13.8472 9.61576 13.8314 9.61508\n        13.8154V13.8154C9.61457 13.8057 9.6139 13.796 9.61339 13.796V13.796C9.61322 13.796\n        9.61305 13.7964 9.61305 13.797V13.797Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_1252_5469)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M-0.651123 21.0921H20.8378V-0.092041H-0.651123V21.0921Z","fill":"currentColor"}})])])}
var Accountvue_type_template_id_11b457b0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Account.vue?vue&type=script&lang=ts&


var Accountvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Account = class Account extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Accountvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Account.prototype, "width", void 0);

Accountvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Account.prototype, "height", void 0);

Account = Accountvue_type_script_lang_ts_decorate([vue_class_component_esm], Account);
/* harmony default export */ var Accountvue_type_script_lang_ts_ = (Account);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Account.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Accountvue_type_script_lang_ts_ = (Accountvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Account.vue





/* normalize component */
;
var Account_component = componentNormalizer_normalizeComponent(
  userMenu_Accountvue_type_script_lang_ts_,
  Accountvue_type_template_id_11b457b0_render,
  Accountvue_type_template_id_11b457b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Account = (Account_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Order.vue?vue&type=template&id=3cf15e59&
var Ordervue_type_template_id_3cf15e59_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M5.53197 1.99572L14.9591 5.97417L14.6068 6.73228L5.17966 2.75384L5.53197 1.99572Z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 17.0351L10.0933 20.9477L20.1866 17.4097V4.38139L10.0933 0.0524902L0\n      3.96515V17.0351ZM10.0933 20.032L0.877677 16.4523V4.50626L10.0933 0.926594L19.3089\n      4.9225V16.8686L10.0933 20.032Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M0.593792 3.89452L10.1767 7.63025L9.84729 8.39765L0.264368 4.66193L0.593792 3.89452Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.1186 20.1441H9.2522V7.459L19.0856 4.0708L19.3455 4.81455L10.1186 8.03747V20.1441Z","fill":"currentColor"}})])}
var Ordervue_type_template_id_3cf15e59_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Order.vue?vue&type=script&lang=ts&


var Ordervue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Order = class Order extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Ordervue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Order.prototype, "width", void 0);

Ordervue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Order.prototype, "height", void 0);

Order = Ordervue_type_script_lang_ts_decorate([vue_class_component_esm], Order);
/* harmony default export */ var Ordervue_type_script_lang_ts_ = (Order);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Order.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Ordervue_type_script_lang_ts_ = (Ordervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Order.vue





/* normalize component */
;
var Order_component = componentNormalizer_normalizeComponent(
  userMenu_Ordervue_type_script_lang_ts_,
  Ordervue_type_template_id_3cf15e59_render,
  Ordervue_type_template_id_3cf15e59_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Order = (Order_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/ApprovalOrder.vue?vue&type=template&id=c0235cfe&
var ApprovalOrdervue_type_template_id_c0235cfe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M5.20685 2.32893L14.0799 6.07352L13.7483 6.78707L4.87525 3.04248L5.20685 2.32893Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 16.4844L9.5 20.167L19 16.837V4.57444L9.5 0.5L0 4.18267V16.4844ZM9.5 19.3051L0.826087\n      15.9359V4.69198L9.5 1.32272L18.1739 5.08375V16.3276L9.5 19.3051Z","fill":"black"}}),_c('path',{attrs:{"d":"M0.558805 4.11617L9.57844 7.63231L9.26838 8.35461L0.248745 4.83847L0.558805 4.11617Z","fill":"black"}}),_c('path',{attrs:{"d":"M9.5237 19.4107H8.70825V7.47126L17.9636 4.28223L18.2083 4.98226L9.5237 8.01573V19.4107Z","fill":"black"}}),_c('path',{attrs:{"d":"M16.4999 8.64526C13.5426 8.64526 11.1453 11.0426 11.1453 13.9999C11.1453 16.9572 13.5426\n      19.3545 16.4999 19.3545C19.4572 19.3545 21.8545 16.9572 21.8545 13.9999C21.8513 11.044\n      19.4558 8.64851 16.4999 8.64526Z","fill":"#42B77A"}}),_c('path',{attrs:{"d":"M18.6468 12.4442L15.9322 15.1942L14.3607 13.5894C14.1915 13.4174 13.9149 13.4152 13.743\n      13.5844C13.571 13.7537 13.5688 14.0303 13.7381 14.2022L15.6297 16.1233C15.6591 16.149\n      15.6922 16.1702 15.7279 16.1861C15.741 16.1977 15.7555 16.2076 15.7711 16.2156C15.8234\n      16.2372 15.8795 16.2485 15.9361 16.249C15.9927 16.2487 16.0488 16.2374 16.1011\n      16.2156C16.1199 16.2057 16.1377 16.1938 16.1541 16.1802C16.1861 16.1655 16.2159 16.1463\n      16.2425 16.1233L19.2695 13.059C19.3883 12.9496 19.4374 12.7838 19.3971 12.6273C19.3568\n      12.4709 19.2337 12.3494 19.0768 12.3111C18.9199 12.2728 18.7546 12.3239 18.6468 12.4442Z","fill":"white"}})])}
var ApprovalOrdervue_type_template_id_c0235cfe_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/ApprovalOrder.vue?vue&type=script&lang=ts&


var ApprovalOrdervue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ApprovalOrder = class ApprovalOrder extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

ApprovalOrdervue_type_script_lang_ts_decorate([Prop({
  default: 22
})], ApprovalOrder.prototype, "width", void 0);

ApprovalOrdervue_type_script_lang_ts_decorate([Prop({
  default: 21
})], ApprovalOrder.prototype, "height", void 0);

ApprovalOrder = ApprovalOrdervue_type_script_lang_ts_decorate([vue_class_component_esm], ApprovalOrder);
/* harmony default export */ var ApprovalOrdervue_type_script_lang_ts_ = (ApprovalOrder);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/ApprovalOrder.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_ApprovalOrdervue_type_script_lang_ts_ = (ApprovalOrdervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/ApprovalOrder.vue





/* normalize component */
;
var ApprovalOrder_component = componentNormalizer_normalizeComponent(
  userMenu_ApprovalOrdervue_type_script_lang_ts_,
  ApprovalOrdervue_type_template_id_c0235cfe_render,
  ApprovalOrdervue_type_template_id_c0235cfe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_ApprovalOrder = (ApprovalOrder_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/EGiftOrders.vue?vue&type=template&id=6f5aaa44&
var EGiftOrdersvue_type_template_id_6f5aaa44_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 15","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.4974 5.3369C15.9196 5.2047 16.3571 5.13771 16.8035 5.13771C19.1951 5.13771 21.1408\n      7.05583 21.1408 9.41345C21.1408 11.7711 19.1951 13.6892 16.8035 13.6892H5.33726C2.94572\n      13.6892 1 11.7711 1 9.41345C1 7.8229 1.89731 6.37131 3.31078 5.6348C3.19873 5.35423 3.14032\n      5.05398 3.14032 4.75139C3.14032 3.42201 4.23759 2.3403 5.5861 2.3403C6.05844 2.3403 6.51887\n      2.47632 6.91284 2.72809C7.8027 1.49596 9.21855 0.77002 10.7628 0.77002C13.3398 0.77002\n      15.4425 2.80947 15.4974 5.3369ZM5.33726 13.0875H16.8035C18.8586 13.0875 20.5305 11.4394\n      20.5305 9.41345C20.5305 7.38751 18.8586 5.73938 16.8035 5.73938C16.2838 5.73938 15.7778\n      5.84515 15.2992 6.05373C15.2002 6.09604 15.0867 6.08458 14.9994 6.02406C14.9118 5.96266\n      14.8632 5.86042 14.8715 5.75495L14.8715 5.75488C14.8799 5.65003 14.8882 5.54517 14.8882\n      5.43855C14.8882 3.19609 13.0376 1.37169 10.7628 1.37169C9.32107 1.37169 8.00714 2.0991\n      7.2487 3.31742C7.20161 3.39263 7.12354 3.44405 7.03473 3.45727C6.94652 3.47107 6.85622\n      3.44522 6.78827 3.38705C6.45361 3.10002 6.02685 2.94197 5.5861 2.94197C4.57405 2.94197\n      3.75064 3.75369 3.75064 4.75139C3.75064 5.0581 3.83051 5.36158 3.9819 5.62951C4.02362\n      5.70354 4.03167 5.79138 4.00455 5.87159C3.97713 5.95179 3.91664 6.01701 3.83826\n      6.05109C2.48469 6.63836 1.61033 7.95804 1.61033 9.41345C1.61033 11.4394 3.28217 13.0875\n      5.33726 13.0875Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.4974 5.3369L15.2474 5.34232L15.2546 5.67485L15.572 5.57548L15.4974 5.3369ZM3.31078\n      5.6348L3.4263 5.8565L3.6268 5.75203L3.54295 5.54207L3.31078 5.6348ZM6.91284 2.72809L6.77822\n      2.93875L6.97723 3.06593L7.11551 2.87446L6.91284 2.72809ZM15.2992 6.05373L15.3975\n      6.28361L15.3991 6.28291L15.2992 6.05373ZM14.9994 6.02406L14.8559 6.22879L14.857\n      6.22953L14.9994 6.02406ZM14.8715 5.75495L14.6224 5.73461L14.6223 5.73524L14.8715\n      5.75495ZM14.8715 5.75488L15.1207 5.77522L15.1207 5.77471L14.8715 5.75488ZM7.2487\n      3.31742L7.4606 3.45009L7.46094 3.44955L7.2487 3.31742ZM7.03473 3.45727L6.99792\n      3.20998L6.99607 3.21027L7.03473 3.45727ZM6.78827 3.38705L6.62552 3.57682L6.62569\n      3.57696L6.78827 3.38705ZM3.9819 5.62951L4.1997 5.50677L4.19956 5.50652L3.9819\n      5.62951ZM4.00455 5.87159L4.24111 5.95245L4.24138 5.95167L4.00455 5.87159ZM3.83826\n      6.05109L3.93777 6.28043L3.93795 6.28035L3.83826 6.05109ZM16.8035 4.88771C16.3319 4.88771\n      15.8692 4.95852 15.4227 5.09832L15.572 5.57548C15.9701 5.45087 16.3824 5.38771 16.8035\n      5.38771V4.88771ZM21.3908 9.41345C21.3908 6.91441 19.3298 4.88771 16.8035\n      4.88771V5.38771C19.0604 5.38771 20.8908 7.19726 20.8908 9.41345H21.3908ZM16.8035\n      13.9392C19.3298 13.9392 21.3908 11.9125 21.3908 9.41345H20.8908C20.8908 11.6296 19.0604\n      13.4392 16.8035 13.4392V13.9392ZM5.33726 13.9392H16.8035V13.4392H5.33726V13.9392ZM0.75\n      9.41345C0.75 11.9125 2.81102 13.9392 5.33726 13.9392V13.4392C3.08041 13.4392 1.25 11.6296\n      1.25 9.41345H0.75ZM3.19525 5.41309C1.70087 6.19177 0.75 7.72778 0.75 9.41345H1.25C1.25\n      7.91803 2.09375 6.55086 3.4263 5.8565L3.19525 5.41309ZM2.89032 4.75139C2.89032 5.08609\n      2.95491 5.41778 3.07861 5.72752L3.54295 5.54207C3.44255 5.29068 3.39032 5.02188 3.39032\n      4.75139H2.89032ZM5.5861 2.0903C4.1029 2.0903 2.89032 3.28059 2.89032\n      4.75139H3.39032C3.39032 3.56344 4.37229 2.5903 5.5861 2.5903V2.0903ZM7.04747\n      2.51744C6.61352 2.24012 6.10643 2.0903 5.5861 2.0903V2.5903C6.01046 2.5903 6.42422 2.71252\n      6.77822 2.93875L7.04747 2.51744ZM10.7628 0.52002C9.13876 0.52002 7.64731 1.28412 6.71017\n      2.58172L7.11551 2.87446C7.95809 1.7078 9.29835 1.02002 10.7628 1.02002V0.52002ZM15.7473\n      5.33148C15.6894 2.66518 13.4727 0.52002 10.7628 0.52002V1.02002C13.2068 1.02002 15.1956\n      2.95376 15.2474 5.34232L15.7473 5.33148ZM16.8035\n      12.8375H5.33726V13.3375H16.8035V12.8375ZM20.2805 9.41345C20.2805 11.298 18.7239 12.8375\n      16.8035 12.8375V13.3375C18.9933 13.3375 20.7805 11.5808 20.7805 9.41345H20.2805ZM16.8035\n      5.98938C18.7239 5.98938 20.2805 7.52894 20.2805 9.41345H20.7805C20.7805 7.24609 18.9933\n      5.48938 16.8035 5.48938V5.98938ZM15.3991 6.28291C15.8463 6.08799 16.3184 5.98938 16.8035\n      5.98938V5.48938C16.2493 5.48938 15.7093 5.6023 15.1993 5.82455L15.3991 6.28291ZM14.857\n      6.22953C15.0156 6.33945 15.2201 6.35945 15.3975 6.2836L15.2009 5.82386C15.1804 5.83263\n      15.1578 5.82971 15.1418 5.81859L14.857 6.22953ZM14.6223 5.73524C14.6069 5.9302 14.6968\n      6.11729 14.8559 6.22879L15.1429 5.81933C15.1267 5.80803 15.1195 5.79064 15.1208\n      5.77467L14.6223 5.73524ZM14.6224 5.73454L14.6224 5.73461L15.1207 5.77529L15.1207\n      5.77522L14.6224 5.73454ZM14.6382 5.43855C14.6382 5.53362 14.6308 5.62864 14.6223\n      5.73506L15.1207 5.77471C15.129 5.67141 15.1382 5.55672 15.1382 5.43855H14.6382ZM10.7628\n      1.62169C12.9029 1.62169 14.6382 3.33752 14.6382 5.43855H15.1382C15.1382 3.05467 13.1723\n      1.12169 10.7628 1.12169V1.62169ZM7.46094 3.44955C8.17347 2.30497 9.40692 1.62169 10.7628\n      1.62169V1.12169C9.23523 1.12169 7.84081 1.89324 7.03647 3.1853L7.46094 3.44955ZM7.07154\n      3.70454C7.23273 3.68055 7.37475 3.58721 7.4606 3.45009L7.0368 3.18476C7.02848 3.19806\n      7.01435 3.20755 6.99792 3.20999L7.07154 3.70454ZM6.62569 3.57696C6.74873 3.6823 6.91243\n      3.72945 7.07339 3.70426L6.99607 3.21027C6.98061 3.21269 6.96371 3.20815 6.95086\n      3.19714L6.62569 3.57696ZM5.5861 3.19197C5.9671 3.19197 6.33613 3.32862 6.62552\n      3.57682L6.95103 3.19728C6.57108 2.87143 6.08661 2.69197 5.5861 2.69197V3.19197ZM4.00064\n      4.75139C4.00064 3.89512 4.70874 3.19197 5.5861 3.19197V2.69197C4.43936 2.69197 3.50064\n      3.61227 3.50064 4.75139H4.00064ZM4.19956 5.50652C4.06932 5.27602 4.00064 5.01489 4.00064\n      4.75139H3.50064C3.50064 5.1013 3.5917 5.44713 3.76424 5.75249L4.19956 5.50652ZM4.24138\n      5.95167C4.29114 5.80449 4.27641 5.64289 4.1997 5.50677L3.76411 5.75225C3.77084 5.76419\n      3.7722 5.77827 3.76772 5.79151L4.24138 5.95167ZM3.93795 6.28035C4.07999 6.21859 4.19068\n      6.09997 4.24111 5.95245L3.76799 5.79072C3.76359 5.8036 3.75328 5.81543 3.73857\n      5.82182L3.93795 6.28035ZM1.86033 9.41345C1.86033 8.05942 2.67393 6.82877 3.93777\n      6.28043L3.73875 5.82175C2.29545 6.44795 1.36033 7.85667 1.36033 9.41345H1.86033ZM5.33726\n      12.8375C3.41686 12.8375 1.86033 11.298 1.86033 9.41345H1.36033C1.36033 11.5808 3.14748\n      13.3375 5.33726 13.3375V12.8375Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.0909 6.32514L9.12779 9.18531L8.45459 8.5354C8.28406 8.37076 8.00779 8.37076 7.83725\n      8.5354C7.66672 8.70004 7.66672 8.96675 7.83725 9.13139L8.81912 10.0793C8.90438 10.1616\n      9.01609 10.2028 9.12779 10.2028C9.23949 10.2028 9.35119 10.1616 9.43646 10.0793L12.7082\n      6.92113C12.8787 6.75649 12.8787 6.48978 12.7082 6.32514C12.5377 6.1605 12.2614 6.1605\n      12.0909 6.32514Z","fill":"currentColor"}})])}
var EGiftOrdersvue_type_template_id_6f5aaa44_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/EGiftOrders.vue?vue&type=script&lang=ts&


var EGiftOrdersvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let EGiftOrders = class EGiftOrders extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

EGiftOrdersvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], EGiftOrders.prototype, "width", void 0);

EGiftOrdersvue_type_script_lang_ts_decorate([Prop({
  default: 14
})], EGiftOrders.prototype, "height", void 0);

EGiftOrders = EGiftOrdersvue_type_script_lang_ts_decorate([vue_class_component_esm], EGiftOrders);
/* harmony default export */ var EGiftOrdersvue_type_script_lang_ts_ = (EGiftOrders);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/EGiftOrders.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_EGiftOrdersvue_type_script_lang_ts_ = (EGiftOrdersvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/EGiftOrders.vue





/* normalize component */
;
var EGiftOrders_component = componentNormalizer_normalizeComponent(
  userMenu_EGiftOrdersvue_type_script_lang_ts_,
  EGiftOrdersvue_type_template_id_6f5aaa44_render,
  EGiftOrdersvue_type_template_id_6f5aaa44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_EGiftOrders = (EGiftOrders_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Occassions.vue?vue&type=template&id=1372279a&
var Occassionsvue_type_template_id_1372279a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 22","fill":"none","width":_vm.width,"height":_vm.height}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_1252_5484","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"18","height":"22"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.770752 0.776367H17.1937V21.9476H0.770752V0.776367Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_1252_5484)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.54151 12.0026C1.54151 11.4928 1.96235 11.0779 2.47953 11.0779H15.4826C15.9967 11.0779\n        16.4176 11.4905 16.4203 11.9977L16.423 13.0527C16.423 13.9026 15.7185 14.5952 14.8521\n        14.5952C13.9862 14.5952 13.2817 13.9026 13.2817 13.0516C13.2817 12.8415 13.1091 12.6717\n        12.8963 12.6717C12.6836 12.6717 12.511 12.8415 12.511 13.0516C12.511 13.9026 11.8065\n        14.5952 10.9402 14.5952C10.0742 14.5952 9.36935 13.9026 9.36935 13.0516C9.36935 12.8415\n        9.19708 12.6717 8.98397 12.6717C8.77124 12.6717 8.59859 12.8415 8.59859 13.0516C8.59859\n        13.9026 7.89411 14.5952 7.02817 14.5952C6.16183 14.5952 5.45736 13.9026 5.45736\n        13.0516C5.45736 12.8415 5.28471 12.6717 5.07198 12.6717C4.85925 12.6717 4.6866 12.8415\n        4.6866 13.0516C4.6866 13.9026 3.98212 14.5952 3.11579 14.5952C2.24984 14.5952 1.54537\n        13.9026 1.54537 13.0516C1.54537 13.0333 1.54382 13.0155 1.54151 12.998V12.0026ZM3.46263\n        15.3273C4.13396 15.2289 4.71357 14.8512 5.07198 14.3163C5.49089 14.9416 6.21155 15.355\n        7.02817 15.355C7.84479 15.355 8.56506 14.9416 8.98397 14.3163C9.40326 14.9416 10.1235\n        15.355 10.9402 15.355C11.7568 15.355 12.4771 14.9416 12.8963 14.3163C13.254 14.8501\n        13.832 15.227 14.5015 15.3265L13.7677 21.1878H4.18946L3.46263 15.3273ZM14.8155\n        10.3181H3.14893C3.29615 9.07502 4.33166 8.10775 5.58607 8.10775H12.3788C13.6328 8.10775\n        14.6683 9.07502 14.8155 10.3181V10.3181ZM8.98243 5.49015C8.14268 5.49015 7.45979 4.81694\n        7.45979 3.98911C7.45979 3.4295 8.30763 2.38017 8.98243 1.69253C9.65723 2.38017 10.5051\n        3.4295 10.5051 3.98911C10.5051 4.81694 9.82178 5.49015 8.98243 5.49015V5.49015ZM0.770752\n        12.0026V13.0516C0.770752 13.0713 0.772293 13.0907 0.775377 13.1097C0.803124 14.2088\n        1.61782 15.1179 2.68455 15.3143L3.46571 21.6137C3.48922 21.8044 3.65339 21.9476 3.84801\n        21.9476H14.1084C14.303 21.9476 14.4668 21.8048 14.4907 21.6141L15.2795 15.3147C16.3671\n        15.1164 17.1937 14.178 17.1937 13.0516L17.191 11.9947C17.186 11.1068 16.4773 10.3857\n        15.5917 10.3291C15.4449 8.66053 14.061 7.34793 12.3788 7.34793H9.36781V6.21578C10.4488\n        6.03419 11.2758 5.10606 11.2758 3.98911C11.2758 2.82125 9.45567 1.07669 9.24795\n        0.881793C9.09958 0.741225 8.86489 0.741225 8.71651 0.881793C8.5088 1.07669 6.68903\n        2.82125 6.68903 3.98911C6.68903 5.10606 7.51567 6.03419 8.59705\n        6.21578V7.34793H5.58607C3.90389 7.34793 2.51999 8.66053 2.37316 10.3287C1.48139 10.3842\n        0.770752 11.1098 0.770752 12.0026V12.0026Z","fill":"currentColor"}})])])}
var Occassionsvue_type_template_id_1372279a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Occassions.vue?vue&type=script&lang=ts&


var Occassionsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Occassions = class Occassions extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Occassionsvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], Occassions.prototype, "width", void 0);

Occassionsvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Occassions.prototype, "height", void 0);

Occassions = Occassionsvue_type_script_lang_ts_decorate([vue_class_component_esm], Occassions);
/* harmony default export */ var Occassionsvue_type_script_lang_ts_ = (Occassions);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Occassions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Occassionsvue_type_script_lang_ts_ = (Occassionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Occassions.vue





/* normalize component */
;
var Occassions_component = componentNormalizer_normalizeComponent(
  userMenu_Occassionsvue_type_script_lang_ts_,
  Occassionsvue_type_template_id_1372279a_render,
  Occassionsvue_type_template_id_1372279a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Occassions = (Occassions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Credits.vue?vue&type=template&id=021e4da8&
var Creditsvue_type_template_id_021e4da8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.27151 4.67163C6.95105 2.62981 8.742 1.05029 11 1.05029C13.2579 1.05029 15.0489 2.62981\n      15.7284 4.67163C16.0019 4.59742 16.3034 4.53175 16.6312 4.53175C19.4651 4.53175 21.7729\n      6.87569 21.7729 9.75393C21.7729 12.6322 19.4651 14.9761 16.6312 14.9761H16.1339C16.0074\n      17.7409 13.7528 19.9496 11 19.9496C8.24709 19.9496 5.99255 17.7409 5.86599\n      14.9761H5.36866C2.53483 14.9761 0.227051 12.6322 0.227051 9.75393C0.227051 6.87569 2.53483\n      4.53175 5.36866 4.53175C5.69651 4.53175 5.99801 4.59742 6.27151 4.67163ZM14.9327\n      5.38657C14.4905 3.50786 12.9534 2.04499 11 2.04499C9.04651 2.04499 7.50943 3.50786 7.06723\n      5.38657C7.03809 5.51555 6.95955 5.62742 6.84898 5.69742C6.73841 5.76743 6.60494 5.7898\n      6.47809 5.75958C6.405 5.74142 6.32889 5.72184 6.25181 5.70201L6.25168 5.70197L6.25167\n      5.70197C5.91941 5.61648 5.56949 5.52645 5.36866 5.52645C3.06411 5.52645 1.20641 7.41326\n      1.20641 9.75393C1.20641 12.0946 3.06411 13.9814 5.36866 13.9814H5.9119C6.26948 11.4555\n      8.4156 9.50525 11 9.50525C13.5843 9.50525 15.7304 11.4555 16.088 13.9814H16.6312C18.9358\n      13.9814 20.7935 12.0946 20.7935 9.75393C20.7935 7.41326 18.9358 5.52645 16.6312\n      5.52645C16.4304 5.52645 16.0805 5.61648 15.7482 5.70197L15.7481 5.70199L15.748\n      5.70202C15.671 5.72185 15.5949 5.74143 15.5218 5.75958C15.395 5.7898 15.2615 5.76743\n      15.1509 5.69742C15.0404 5.62742 14.9618 5.51555 14.9327 5.38657ZM11 10.5C13.3045 10.5\n      15.1622 12.3868 15.1622 14.7274C15.1622 17.0681 13.3045 18.9549 11 18.9549C8.6954 18.9549\n      6.8377 17.0681 6.8377 14.7274C6.8377 12.3868 8.6954 10.5 11 10.5ZM10.5103 11.992C10.5048\n      11.7343 10.6941 11.515 10.9464 11.4869C11.0866 11.4712 11.2267 11.5177 11.3307\n      11.6144C11.4348 11.7112 11.4927 11.8488 11.4896 11.992V12.2407H12.2241C12.4007 12.2381\n      12.565 12.3324 12.654 12.4873C12.7431 12.6422 12.7431 12.8338 12.654 12.9888C12.565 13.1437\n      12.4007 13.2379 12.2241 13.2354H10.7551C10.3888 13.2354 10.2654 13.4118 10.2654\n      13.7327C10.2654 13.9872 10.4541 14.2301 11 14.2301C11.9318 14.2301 12.7138 14.8745 12.7138\n      15.7221C12.7138 16.4251 12.2034 17.0686 11.4896 17.1909V17.4629C11.4921 17.6422 11.3993\n      17.8091 11.2468 17.8995C11.0943 17.9899 10.9056 17.9899 10.7531 17.8995C10.6006 17.8091\n      10.5078 17.6422 10.5103 17.4629V17.2142H9.77576C9.59917 17.2167 9.43491 17.1225 9.34588\n      16.9676C9.25685 16.8126 9.25685 16.621 9.34588 16.4661C9.43491 16.3112 9.59917 16.2169\n      9.77576 16.2195H11.2448C11.6111 16.2195 11.7345 16.0431 11.7345 15.7221C11.7345 15.4677\n      11.5458 15.2248 11 15.2248C10.0681 15.2248 9.28608 14.5804 9.28608 13.7327C9.28608 13.0295\n      9.79607 12.3859 10.5103 12.264V11.992Z","fill":"currentColor"}})])}
var Creditsvue_type_template_id_021e4da8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Credits.vue?vue&type=script&lang=ts&


var Creditsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Credits = class Credits extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Creditsvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Credits.prototype, "width", void 0);

Creditsvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Credits.prototype, "height", void 0);

Credits = Creditsvue_type_script_lang_ts_decorate([vue_class_component_esm], Credits);
/* harmony default export */ var Creditsvue_type_script_lang_ts_ = (Credits);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Credits.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Creditsvue_type_script_lang_ts_ = (Creditsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Credits.vue





/* normalize component */
;
var Credits_component = componentNormalizer_normalizeComponent(
  userMenu_Creditsvue_type_script_lang_ts_,
  Creditsvue_type_template_id_021e4da8_render,
  Creditsvue_type_template_id_021e4da8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Credits = (Credits_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Inventory.vue?vue&type=template&id=639c88da&
var Inventoryvue_type_template_id_639c88da_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 23","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.03 0.718657L15.8846 2.9791C15.9778 3.01212 16.0381 3.10327 16.0325\n      3.20266V9.88462L20.7146 12.0705C20.8078 12.1036 20.8681 12.1947 20.8625\n      12.2941V19.1499C20.8681 19.2493 20.8078 19.3405 20.7146 19.3735L15.86\n      21.6339H15.6382L10.9314 19.448L6.22464 21.6339H6.00286L1.14822 19.3735C1.05505 19.3405\n      0.994766 19.2493 1.00036 19.1499V12.2941C0.994766 12.1947 1.05505 12.1036 1.14822\n      12.0705L5.83036 9.88462V3.20266C5.82477 3.10327 5.88505 3.01212 5.97822 2.9791L10.8329\n      0.718657C10.8962 0.693716 10.9666 0.693716 11.03 0.718657ZM10.3154 12.3189L6.05214\n      10.3317L1.83822 12.2941L6.10143 14.2565L10.3154 12.3189ZM10.685 5.61214V11.9463L6.32322\n      9.90946V3.57526L10.685 5.61214ZM15.5396 3.57526L11.1779 5.61214V11.9463L15.5396\n      9.90946V3.57526ZM6.34786 14.7036L10.685 12.6915V19.0009L6.34786 21.0129V14.7036ZM15.515\n      14.7036L11.1779 12.6915V19.0009L15.515 21.0129V14.7036ZM15.7614 14.2565L11.5475\n      12.3189L15.8107 10.3317L20.0246 12.2941L15.7614 14.2565ZM15.1946 3.20266L10.9314\n      1.21546L6.66822 3.20266L10.9314 5.18986L15.1946 3.20266ZM1.49322 12.6667L5.855\n      14.7036V21.0129L1.49322 19.0009V12.6667ZM16.0079 14.7036V21.0129L20.3696\n      19.0009V12.6667L16.0079 14.7036Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.8846 2.9791L15.7791 3.20573L15.7899 3.21076L15.8011 3.21473L15.8846 2.9791ZM11.03\n      0.718657L11.1355 0.492021L11.1286 0.488807L11.1215 0.486019L11.03 0.718657ZM16.0325\n      3.20266L15.7825 3.18859V3.20266H16.0325ZM16.0325 9.88462H15.7825V10.0438L15.9267\n      10.1111L16.0325 9.88462ZM20.7146 12.0705L20.6089 12.2971L20.6198 12.3022L20.6311\n      12.3062L20.7146 12.0705ZM20.8625 12.2941L20.6125 12.28V12.2941H20.8625ZM20.8625\n      19.1499H20.6121L20.6129 19.164L20.8625 19.1499ZM20.7146 19.3735L20.6311 19.1379L20.6199\n      19.1418L20.6091 19.1469L20.7146 19.3735ZM15.86 21.6339V21.8839H15.9154L15.9655\n      21.8606L15.86 21.6339ZM15.6382 21.6339L15.5329 21.8607L15.583\n      21.8839H15.6382V21.6339ZM10.9314 19.448L11.0367 19.2213L10.9314 19.1724L10.8261\n      19.2213L10.9314 19.448ZM6.22464 21.6339V21.8839H6.27986L6.32995 21.8607L6.22464\n      21.6339ZM6.00286 21.6339L5.89733 21.8606L5.94751 21.8839H6.00286V21.6339ZM1.14822\n      19.3735L1.25374 19.1469L1.24295 19.1418L1.23174 19.1379L1.14822 19.3735ZM1.00036\n      19.1499L1.25036 19.164V19.1499H1.00036ZM1.00036 12.2941H1.25075L1.24996 12.2801L1.00036\n      12.2941ZM1.14822 12.0705L1.23174 12.3062L1.24308 12.3022L1.25397 12.2971L1.14822\n      12.0705ZM5.83036 9.88462L5.93612 10.1111L6.08036 10.0438V9.88462H5.83036ZM5.83036\n      3.20266H6.08075L6.07996 3.18861L5.83036 3.20266ZM5.97822 2.9791L6.06174 3.21473L6.07295\n      3.21076L6.08374 3.20573L5.97822 2.9791ZM10.8329 0.718657L10.7413 0.486018L10.7342\n      0.488806L10.7273 0.492021L10.8329 0.718657ZM6.05214 10.3317L6.15777 10.1051L6.05219\n      10.0559L5.94661 10.1051L6.05214 10.3317ZM10.3154 12.3189L10.4198 12.5461L10.9104\n      12.3205L10.421 12.0923L10.3154 12.3189ZM1.83822 12.2941L1.73268 12.0675L1.24318\n      12.2954L1.73368 12.5212L1.83822 12.2941ZM6.10143 14.2565L5.9969 14.4836L6.10137\n      14.5316L6.20587 14.4836L6.10143 14.2565ZM10.685 11.9463L10.5792 12.1729L10.935\n      12.339V11.9463H10.685ZM10.685 5.61214H10.935V5.45297L10.7908 5.38562L10.685\n      5.61214ZM6.32322 9.90946H6.07322V10.0686L6.21744 10.136L6.32322 9.90946ZM6.32322\n      3.57526L6.429 3.34874L6.07322 3.1826V3.57526H6.32322ZM11.1779 5.61214L11.0721\n      5.38562L10.9279 5.45297V5.61214H11.1779ZM15.5396 3.57526H15.7896V3.1826L15.4339\n      3.34874L15.5396 3.57526ZM11.1779 11.9463H10.9279V12.339L11.2836 12.1729L11.1779\n      11.9463ZM15.5396 9.90946L15.6454 10.136L15.7896 10.0686V9.90946H15.5396ZM10.685\n      12.6915H10.935V12.3L10.5798 12.4648L10.685 12.6915ZM6.34786 14.7036L6.24265 14.4768L6.09786\n      14.544V14.7036H6.34786ZM10.685 19.0009L10.7902 19.2277L10.935\n      19.1605V19.0009H10.685ZM6.34786 21.0129H6.09786V21.4045L6.45307 21.2397L6.34786\n      21.0129ZM11.1779 12.6915L11.2831 12.4648L10.9279 12.3V12.6915H11.1779ZM15.515\n      14.7036H15.765V14.544L15.6202 14.4768L15.515 14.7036ZM11.1779\n      19.0009H10.9279V19.1605L11.0727 19.2277L11.1779 19.0009ZM15.515 21.0129L15.4098\n      21.2397L15.765 21.4045V21.0129H15.515ZM11.5475 12.3189L11.4419 12.0923L10.9524\n      12.3205L11.4431 12.5461L11.5475 12.3189ZM15.7614 14.2565L15.657 14.4836L15.7615\n      14.5316L15.866 14.4836L15.7614 14.2565ZM15.8107 10.3317L15.9163 10.1051L15.8107\n      10.0559L15.7051 10.1051L15.8107 10.3317ZM20.0246 12.2941L20.1292 12.5212L20.6197\n      12.2954L20.1302 12.0675L20.0246 12.2941ZM10.9314 1.21546L11.0371 0.988864L10.9314\n      0.939632L10.8258 0.988864L10.9314 1.21546ZM15.1946 3.20266L15.3003 3.42925L15.7864\n      3.20266L15.3003 2.97606L15.1946 3.20266ZM6.66822 3.20266L6.56259 2.97606L6.07648\n      3.20266L6.56259 3.42925L6.66822 3.20266ZM10.9314 5.18986L10.8258 5.41645L10.9314\n      5.46568L11.0371 5.41645L10.9314 5.18986ZM5.855 14.7036H6.105V14.5444L5.96078 14.4771L5.855\n      14.7036ZM1.49322 12.6667L1.599 12.4402L1.24322 12.274V12.6667H1.49322ZM5.855 21.0129L5.75028\n      21.2399L6.105 21.4036V21.0129H5.855ZM1.49322 19.0009H1.24322V19.1609L1.3885 19.2279L1.49322\n      19.0009ZM16.0079 21.0129H15.7579V21.4036L16.1126 21.2399L16.0079 21.0129ZM16.0079\n      14.7036L15.9021 14.4771L15.7579 14.5444V14.7036H16.0079ZM20.3696 19.0009L20.4744\n      19.2279L20.6196 19.1609V19.0009H20.3696ZM20.3696 12.6667H20.6196V12.274L20.2639\n      12.4402L20.3696 12.6667ZM15.9902 2.75246L11.1355 0.492021L10.9245 0.945293L15.7791\n      3.20573L15.9902 2.75246ZM16.2821 3.2167C16.2939 3.00754 16.167 2.81396 15.9682\n      2.74346L15.8011 3.21473C15.7886 3.21029 15.7823 3.19899 15.7829 3.18861L16.2821\n      3.2167ZM16.2825 9.88462V3.20266H15.7825V9.88462H16.2825ZM20.8204 11.844L16.1383\n      9.65809L15.9267 10.1111L20.6089 12.2971L20.8204 11.844ZM21.1121 12.3081C21.1239 12.099\n      20.997 11.9054 20.7982 11.8349L20.6311 12.3062C20.6186 12.3017 20.6123 12.2904 20.6129\n      12.2801L21.1121 12.3081ZM21.1125 19.1499V12.2941H20.6125V19.1499H21.1125ZM20.7982\n      19.6091C20.997 19.5386 21.1239 19.3451 21.1121 19.1359L20.6129 19.164C20.6123 19.1536\n      20.6186 19.1423 20.6311 19.1379L20.7982 19.6091ZM15.9655 21.8606L20.8202 19.6001L20.6091\n      19.1469L15.7545 21.4073L15.9655 21.8606ZM15.6382\n      21.8839H15.86V21.3839H15.6382V21.8839ZM10.8261 19.6748L15.5329 21.8607L15.7435\n      21.4072L11.0367 19.2213L10.8261 19.6748ZM6.32995 21.8607L11.0367 19.6748L10.8261\n      19.2213L6.11934 21.4072L6.32995 21.8607ZM6.00286\n      21.8839H6.22464V21.3839H6.00286V21.8839ZM1.04269 19.6001L5.89733 21.8606L6.10839\n      21.4073L1.25374 19.1469L1.04269 19.6001ZM0.750753 19.1359C0.738984 19.3451 0.865818 19.5386\n      1.06469 19.6091L1.23174 19.1379C1.24428 19.1423 1.25055 19.1536 1.24996 19.164L0.750753\n      19.1359ZM0.750359 12.2941V19.1499H1.25036V12.2941H0.750359ZM1.06469 11.8349C0.865817\n      11.9054 0.738984 12.099 0.750753 12.3081L1.24996 12.2801C1.25055 12.2904 1.24428 12.3017\n      1.23174 12.3062L1.06469 11.8349ZM5.7246 9.65809L1.04246 11.844L1.25397 12.2971L5.93612\n      10.1111L5.7246 9.65809ZM5.58036 3.20266V9.88462H6.08036V3.20266H5.58036ZM5.89469\n      2.74346C5.69582 2.81395 5.56898 3.00753 5.58075 3.2167L6.07996 3.18861C6.08055 3.199\n      6.07428 3.21029 6.06174 3.21473L5.89469 2.74346ZM10.7273 0.492021L5.87269 2.75246L6.08374\n      3.20573L10.9384 0.945293L10.7273 0.492021ZM11.1215 0.486019C10.9993 0.437928 10.8635\n      0.437929 10.7413 0.486018L10.9244 0.951296C10.929 0.949503 10.9339 0.949503 10.9385\n      0.951295L11.1215 0.486019ZM5.94652 10.5583L10.2097 12.5455L10.421 12.0923L6.15777\n      10.1051L5.94652 10.5583ZM1.94375 12.5207L6.15768 10.5584L5.94661 10.1051L1.73268\n      12.0675L1.94375 12.5207ZM6.20596 14.0294L1.94275 12.067L1.73368 12.5212L5.9969\n      14.4836L6.20596 14.0294ZM10.2109 12.0918L5.99699 14.0293L6.20587 14.4836L10.4198\n      12.5461L10.2109 12.0918ZM10.935 11.9463V5.61214H10.435V11.9463H10.935ZM6.21744\n      10.136L10.5792 12.1729L10.7908 11.7198L6.429 9.68294L6.21744 10.136ZM6.07322\n      3.57526V9.90946H6.57322V3.57526H6.07322ZM10.7908 5.38562L6.429 3.34874L6.21744\n      3.80178L10.5792 5.83866L10.7908 5.38562ZM11.2836 5.83866L15.6454 3.80178L15.4339\n      3.34874L11.0721 5.38562L11.2836 5.83866ZM11.4279\n      11.9463V5.61214H10.9279V11.9463H11.4279ZM15.4339 9.68294L11.0721 11.7198L11.2836\n      12.1729L15.6454 10.136L15.4339 9.68294ZM15.2896\n      3.57526V9.90946H15.7896V3.57526H15.2896ZM10.5798 12.4648L6.24265 14.4768L6.45307\n      14.9304L10.7902 12.9183L10.5798 12.4648ZM10.935\n      19.0009V12.6915H10.435V19.0009H10.935ZM6.45307 21.2397L10.7902 19.2277L10.5798\n      18.7741L6.24265 20.7862L6.45307 21.2397ZM6.09786\n      14.7036V21.0129H6.59786V14.7036H6.09786ZM11.0727 12.9183L15.4098 14.9304L15.6202\n      14.4768L11.2831 12.4648L11.0727 12.9183ZM11.4279\n      19.0009V12.6915H10.9279V19.0009H11.4279ZM15.6202 20.7862L11.2831 18.7741L11.0727\n      19.2277L15.4098 21.2397L15.6202 20.7862ZM15.265\n      14.7036V21.0129H15.765V14.7036H15.265ZM11.4431 12.5461L15.657 14.4836L15.8659\n      14.0293L11.6519 12.0918L11.4431 12.5461ZM15.7051 10.1051L11.4419 12.0923L11.6531\n      12.5455L15.9163 10.5583L15.7051 10.1051ZM20.1302 12.0675L15.9163 10.1051L15.7052\n      10.5584L19.9191 12.5207L20.1302 12.0675ZM15.866 14.4836L20.1292 12.5212L19.9201\n      12.067L15.6569 14.0294L15.866 14.4836ZM10.8258 1.44205L15.089 3.42925L15.3003\n      2.97606L11.0371 0.988864L10.8258 1.44205ZM6.77384 3.42925L11.0371 1.44205L10.8258\n      0.988864L6.56259 2.97606L6.77384 3.42925ZM11.0371 4.96326L6.77384 2.97606L6.56259\n      3.42925L10.8258 5.41645L11.0371 4.96326ZM15.089 2.97606L10.8258 4.96326L11.0371\n      5.41645L15.3003 3.42925L15.089 2.97606ZM5.96078 14.4771L1.599 12.4402L1.38744\n      12.8932L5.74922 14.9301L5.96078 14.4771ZM6.105\n      21.0129V14.7036H5.605V21.0129H6.105ZM1.3885 19.2279L5.75028 21.2399L5.95972\n      20.7859L1.59793 18.7739L1.3885 19.2279ZM1.24322\n      12.6667V19.0009H1.74322V12.6667H1.24322ZM16.2579\n      21.0129V14.7036H15.7579V21.0129H16.2579ZM20.2649 18.7739L15.9031 20.7859L16.1126\n      21.2399L20.4744 19.2279L20.2649 18.7739ZM20.1196\n      12.6667V19.0009H20.6196V12.6667H20.1196ZM16.1136 14.9301L20.4754 12.8932L20.2639\n      12.4402L15.9021 14.4771L16.1136 14.9301Z","fill":"currentColor"}})])}
var Inventoryvue_type_template_id_639c88da_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Inventory.vue?vue&type=script&lang=ts&


var Inventoryvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Inventory = class Inventory extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Inventoryvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Inventory.prototype, "width", void 0);

Inventoryvue_type_script_lang_ts_decorate([Prop({
  default: 23
})], Inventory.prototype, "height", void 0);

Inventory = Inventoryvue_type_script_lang_ts_decorate([vue_class_component_esm], Inventory);
/* harmony default export */ var Inventoryvue_type_script_lang_ts_ = (Inventory);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Inventory.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Inventoryvue_type_script_lang_ts_ = (Inventoryvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Inventory.vue





/* normalize component */
;
var Inventory_component = componentNormalizer_normalizeComponent(
  userMenu_Inventoryvue_type_script_lang_ts_,
  Inventoryvue_type_template_id_639c88da_render,
  Inventoryvue_type_template_id_639c88da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Inventory = (Inventory_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Quotes.vue?vue&type=template&id=3b8385db&
var Quotesvue_type_template_id_3b8385db_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 24","fill":"none","width":_vm.width,"height":_vm.height}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_5359_20599","maskUnits":"userSpaceOnUse","x":"-3","y":"0","width":"24","height":"24"}},[_c('rect',{attrs:{"x":"-3","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_5359_20599)"}},[_c('path',{attrs:{"d":"M8.84615 18.25H9.84615V17.25H11.3462C11.4885 17.25 11.6074 17.2022 11.7029\n        17.1067C11.7984 17.0112 11.8462 16.8923 11.8462 16.75V13.75C11.8462 13.6077\n        11.7984 13.4888 11.7029 13.3933C11.6074 13.2978 11.4885 13.25 11.3462\n        13.25H7.84615V11.25H11.8462V10.25H9.84615V9.25H8.84615V10.25H7.34615C7.20385 10.25 7.08494\n        10.2978 6.98943 10.3933C6.89391 10.4888 6.84615 10.6077 6.84615 10.75V13.75C6.84615\n        13.8923 6.89391 14.0112 6.98943 14.1067C7.08494 14.2022 7.20385 14.25 7.34615\n        14.25H10.8462V16.25H6.84615V17.25H8.84615V18.25ZM3.61537 21C3.15512 21 2.77083 20.8458\n        2.4625 20.5375C2.15417 20.2292 2 19.8449 2 19.3846V4.61537C2 4.15512 2.15417 3.77083\n        2.4625 3.4625C2.77083 3.15417 3.15512 3 3.61537 3H11.5L16 7.5V19.3846C16 19.8449 15.8458\n        20.2292 15.5375 20.5375C15.2292 20.8458 14.8449 21 14.3846 21H3.61537ZM11\n        7.76922V4H3.61537C3.46154 4 3.32052 4.0641 3.1923 4.1923C3.0641 4.32052 3 4.46154 3\n        4.61537V19.3846C3 19.5385 3.0641 19.6795 3.1923 19.8077C3.32052 19.9359 3.46154 20 3.61537\n        20H14.3846C14.5385 20 14.6795 19.9359 14.8077 19.8077C14.9359 19.6795 15 19.5385 15\n        19.3846V7.76922H11Z","fill":"currentColor"}})])])}
var Quotesvue_type_template_id_3b8385db_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Quotes.vue?vue&type=script&lang=ts&


var Quotesvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Quotes = class Quotes extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Quotesvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Quotes.prototype, "width", void 0);

Quotesvue_type_script_lang_ts_decorate([Prop({
  default: 24
})], Quotes.prototype, "height", void 0);

Quotes = Quotesvue_type_script_lang_ts_decorate([vue_class_component_esm], Quotes);
/* harmony default export */ var Quotesvue_type_script_lang_ts_ = (Quotes);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Quotes.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Quotesvue_type_script_lang_ts_ = (Quotesvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Quotes.vue





/* normalize component */
;
var Quotes_component = componentNormalizer_normalizeComponent(
  userMenu_Quotesvue_type_script_lang_ts_,
  Quotesvue_type_template_id_3b8385db_render,
  Quotesvue_type_template_id_3b8385db_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Quotes = (Quotes_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/SubAccount.vue?vue&type=template&id=5900770d&
var SubAccountvue_type_template_id_5900770d_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.9741 9.69017C12.6751 9.69017 12.4333 9.93278 12.4333 10.231C12.4333 10.5299 12.6751\n      10.771 12.9741 10.771C14.8226 10.771 16.2172 12.3111 16.2172 14.1597C16.2172 14.2215\n      16.2055 14.281 16.1804 14.3357C16.0599 14.6089 16.182 14.9282 16.4551 15.0495C16.5263\n      15.0816 16.6007 15.0957 16.6743 15.0957C16.8817 15.0957 17.0789 14.9767 17.1689\n      14.7748C17.255 14.5807 17.2988 14.3741 17.2988 14.1597C17.2988 11.7156 15.419 9.69017\n      12.9741 9.69017M8.23383 1.9267C8.62122 1.69739 9.03365 1.58157 9.46017 1.58157C11.099\n      1.58157 12.4333 3.30957 12.4333 5.43278C12.4333 5.81391 12.391 6.188 12.3073\n      6.54487C12.2392 6.836 12.42 7.12635 12.7103 7.19443C12.7518 7.20461 12.7933 7.2093 12.834\n      7.2093C13.0797 7.2093 13.3012 7.04104 13.3599 6.79217C13.4624 6.35391 13.5149 5.89687\n      13.5149 5.43278C13.5149 2.71322 11.6961 0.5 9.46017 0.5C8.84583 0.5 8.23148 0.672174\n      7.68365 0.996174C7.42696 1.148 7.34165 1.47983 7.49348 1.73652C7.64609 1.994 7.97791\n      2.07852 8.23383 1.9267M11.2437 11.8533C10.9448 11.8533 10.703 12.0951 10.703 12.3933C10.703\n      12.6923 10.9448 12.9341 11.2437 12.9341C13.0915 12.9341 14.5957 14.4375 14.5957\n      16.286C14.5957 16.5239 14.4016 16.718 14.1629 16.718H1.51278C1.27487 16.718 1.08078 16.5239\n      1.08078 16.286C1.08078 14.4375 2.58496 12.9341 4.43191 12.9341C4.73087 12.9341 4.9727\n      12.6923 4.9727 12.3933C4.9727 12.0951 4.73087 11.8533 4.43191 11.8533C1.98783 11.8533 0\n      13.8411 0 16.286C0 17.1203 0.679304 17.7996 1.51278 17.7996H14.1629C14.9971 17.7996 15.6772\n      17.1203 15.6772 16.286C15.6772 13.8411 13.6886 11.8533 11.2437 11.8533M7.83861\n      3.60852C9.47739 3.60852 10.8117 5.33652 10.8117 7.46052C10.8117 9.58374 9.47739 11.3125\n      7.83861 11.3125C6.19904 11.3125 4.86548 9.58374 4.86391 7.46052C4.86391 5.33652 6.19826\n      3.60852 7.83861 3.60852M7.83861 12.3933C10.0745 12.3933 11.8925 10.1809 11.8925\n      7.46052C11.8925 4.74017 10.0745 2.52774 7.83861 2.52774C6.73278 2.52774 5.69974 3.056\n      4.93122 4.01626C4.19087 4.94209 3.78391 6.16452 3.78391 7.46052C3.78391 10.1809 5.6027\n      12.3933 7.83861 12.3933","fill":"currentColor"}})])}
var SubAccountvue_type_template_id_5900770d_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/SubAccount.vue?vue&type=script&lang=ts&


var SubAccountvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SubAccount = class SubAccount extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

SubAccountvue_type_script_lang_ts_decorate([Prop({
  default: 18
})], SubAccount.prototype, "width", void 0);

SubAccountvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], SubAccount.prototype, "height", void 0);

SubAccount = SubAccountvue_type_script_lang_ts_decorate([vue_class_component_esm], SubAccount);
/* harmony default export */ var SubAccountvue_type_script_lang_ts_ = (SubAccount);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/SubAccount.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_SubAccountvue_type_script_lang_ts_ = (SubAccountvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/SubAccount.vue





/* normalize component */
;
var SubAccount_component = componentNormalizer_normalizeComponent(
  userMenu_SubAccountvue_type_script_lang_ts_,
  SubAccountvue_type_template_id_5900770d_render,
  SubAccountvue_type_template_id_5900770d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_SubAccount = (SubAccount_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/AddressBook.vue?vue&type=template&id=e581cc80&
var AddressBookvue_type_template_id_e581cc80_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.1862 11.0383C12.0285 11.0383 11.9009 11.1686 11.9009 11.3289C11.9009 11.4895 12.0285\n      11.619 12.1862 11.619C13.1615 11.619 13.8973 12.4465 13.8973 13.4398C13.8973 13.473 13.8911\n      13.5049 13.8779 13.5344C13.8143 13.6811 13.8787 13.8527 14.0229 13.9179C14.0604 13.9351\n      14.0997 13.9427 14.1385 13.9427C14.2479 13.9427 14.3519 13.8788 14.3994 13.7703C14.4448\n      13.666 14.468 13.555 14.468 13.4398C14.468 12.1265 13.4762 11.0383 12.1862 11.0383M9.68526\n      6.86692C9.88965 6.74371 10.1073 6.68147 10.3323 6.68147C11.1969 6.68147 11.9009 7.60994\n      11.9009 8.75076C11.9009 8.95554 11.8786 9.15654 11.8344 9.34829C11.7985 9.50472 11.8939\n      9.66072 12.0471 9.69731C12.069 9.70277 12.0909 9.7053 12.1123 9.7053C12.242 9.7053 12.3588\n      9.61489 12.3898 9.48117C12.4439 9.24569 12.4716 9.00012 12.4716 8.75076C12.4716 7.28952\n      11.512 6.10034 10.3323 6.10034C10.0082 6.10034 9.68402 6.19285 9.39499 6.36694C9.25955\n      6.44852 9.21455 6.62681 9.29465 6.76473C9.37517 6.90308 9.55024 6.94849 9.68526\n      6.86692M11.2733 12.2006C11.1156 12.2006 10.988 12.3305 10.988 12.4907C10.988 12.6513\n      11.1156 12.7813 11.2733 12.7813C12.2482 12.7813 13.0418 13.589 13.0418 14.5823C13.0418\n      14.7101 12.9394 14.8144 12.8134 14.8144H6.13921C6.01369 14.8144 5.91129 14.7101 5.91129\n      14.5823C5.91129 13.589 6.7049 12.7813 7.67936 12.7813C7.83709 12.7813 7.96468 12.6513\n      7.96468 12.4907C7.96468 12.3305 7.83709 12.2006 7.67936 12.2006C6.38985 12.2006 5.34106\n      13.2686 5.34106 14.5823C5.34106 15.0305 5.69947 15.3955 6.13921 15.3955H12.8134C13.2536\n      15.3955 13.6124 15.0305 13.6124 14.5823C13.6124 13.2686 12.5632 12.2006 11.2733\n      12.2006M9.47674 7.77057C10.3414 7.77057 11.0454 8.69904 11.0454 9.84028C11.0454 10.9811\n      10.3414 11.91 9.47674 11.91C8.6117 11.91 7.90811 10.9811 7.90728 9.84028C7.90728 8.69904\n      8.61129 7.77057 9.47674 7.77057M9.47674 12.4907C10.6564 12.4907 11.6156 11.3019 11.6156\n      9.84028C11.6156 8.37862 10.6564 7.18986 9.47674 7.18986C8.89331 7.18986 8.34827 7.4737\n      7.94279 7.98965C7.55218 8.48711 7.33747 9.14393 7.33747 9.84028C7.33747 11.3019 8.29707\n      12.4907 9.47674 12.4907","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.414 2.41735C16.6254 2.41735 16.7968 2.59186 16.7968 2.80716V18.3855C16.7968 18.6003\n      16.6254 18.7748 16.414 18.7748H2.83762C2.62662 18.7748 2.45527 18.6003 2.45527\n      18.3855V15.854H3.18983C3.50694 15.854 3.76336 15.5921 3.76336 15.27C3.76336 14.9474 3.50694\n      14.6855 3.18983 14.6855H2.45527V11.1802H3.18983C3.50694 11.1802 3.76336 10.9186 3.76336\n      10.5961C3.76336 10.274 3.50694 10.012 3.18983 10.012H2.45527V6.50672H3.18983C3.50694\n      6.50672 3.76336 6.24475 3.76336 5.92265C3.76336 5.60012 3.50694 5.33815 3.18983\n      5.33815H2.45527V2.80716C2.45527 2.59186 2.62662 2.41735 2.83762 2.41735H16.414ZM1.30821\n      2.80716V5.33815H0.57365C0.256537 5.33815 0.00012207 5.60012 0.00012207 5.92265C0.00012207\n      6.24475 0.256537 6.50672 0.57365 6.50672H1.30821V10.012H0.57365C0.256537 10.012 0.00012207\n      10.274 0.00012207 10.5961C0.00012207 10.9186 0.256537 11.1802 0.57365\n      11.1802H1.30821V14.6855H0.57365C0.256537 14.6855 0.00012207 14.9474 0.00012207\n      15.27C0.00012207 15.5921 0.256537 15.854 0.57365 15.854H1.30821V18.3855C1.30821 19.2458\n      1.99281 19.9434 2.83762 19.9434H16.414C17.2588 19.9434 17.9438 19.2458 17.9438\n      18.3855V2.80716C17.9438 1.94639 17.2588 1.24878 16.414 1.24878H2.83762C1.99281 1.24878\n      1.30821 1.94639 1.30821 2.80716V2.80716Z","fill":"currentColor"}})])}
var AddressBookvue_type_template_id_e581cc80_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/AddressBook.vue?vue&type=script&lang=ts&


var AddressBookvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let AddressBook = class AddressBook extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

AddressBookvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], AddressBook.prototype, "width", void 0);

AddressBookvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], AddressBook.prototype, "height", void 0);

AddressBook = AddressBookvue_type_script_lang_ts_decorate([vue_class_component_esm], AddressBook);
/* harmony default export */ var AddressBookvue_type_script_lang_ts_ = (AddressBook);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/AddressBook.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_AddressBookvue_type_script_lang_ts_ = (AddressBookvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/AddressBook.vue





/* normalize component */
;
var AddressBook_component = componentNormalizer_normalizeComponent(
  userMenu_AddressBookvue_type_script_lang_ts_,
  AddressBookvue_type_template_id_e581cc80_render,
  AddressBookvue_type_template_id_e581cc80_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_AddressBook = (AddressBook_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Payment.vue?vue&type=template&id=b1acbb5c&
var Paymentvue_type_template_id_b1acbb5c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 19","fill":"none","width":_vm.width,"height":_vm.height}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_1252_5515","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"22","height":"19"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.7957 0.181128L11.1075 1.47666H1.92132H1.92036C0.914354 1.47666 0.0986328 2.26749\n        0.0986328 3.24295V3.24295V16.0477C0.0986328 17.2667 1.1178 18.2555 2.37591\n        18.2555V18.2555H18.7717C20.0297 18.2555 21.049 17.2667 21.049\n        16.0477V16.0477V5.89224C21.0495 4.91678 20.2336 4.1261 19.2278\n        4.1261V4.1261V3.24295C19.2278 2.26749 18.412 1.47666 17.4059\n        1.47666V1.47666H15.7622L15.3733 0.441262C15.307 0.26457 15.1344 0.154663 14.9502\n        0.154663V0.154663C14.899 0.154663 14.8468 0.163225 14.7957 0.181128V0.181128ZM14.6806\n        1.14865L15.1643 2.43967L15.7968 4.1261H6.20434L11.2315 2.35981H11.236L13.7473\n        1.47666H13.7464L14.6806 1.14865ZM16.0929 2.35981H17.4059C17.9091 2.35981 18.3168 2.75538\n        18.3168 3.24295V3.24295V4.1261H16.7557L16.0929 2.35981ZM1.0099 3.24295C1.0099 2.75538\n        1.41808 2.35981 1.92084 2.35981V2.35981H8.59305L3.59226 4.11676C3.586 4.11894 3.58279\n        4.12376 3.57637 4.1261V4.1261H1.92084C1.41808 4.1261 1.0099 3.73037 1.0099\n        3.24295V3.24295ZM1.0099 16.0477V4.76406C1.2787 4.91537 1.58748 5.00894 1.92084\n        5.00894V5.00894H19.2278C19.731 5.00894 20.1385 5.40466 20.1385\n        5.89224V5.89224V9.42451H18.3168C17.3108 9.42451 16.4949 10.2153 16.4949\n        11.1907V11.1907C16.4949 12.1661 17.3108 12.9569 18.3168\n        12.9569V12.9569H20.1385V16.0477C20.1385 16.7794 19.5274 17.3722 18.7722\n        17.3722V17.3722H2.37639C1.62217 17.3722 1.0099 16.7794 1.0099 16.0477V16.0477ZM17.4059\n        11.1907C17.4059 10.7032 17.8139 10.3075 18.3168\n        10.3075V10.3075H20.1385V12.074H18.3168C17.8139 12.074 17.4059 11.6781 17.4059\n        11.1907V11.1907ZM18.3168 11.6321H19.2279V10.749H18.3168V11.6321Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_1252_5515)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M-0.704224 19.0338H21.8519V-0.623657H-0.704224V19.0338Z","fill":"currentColor"}})])])}
var Paymentvue_type_template_id_b1acbb5c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Payment.vue?vue&type=script&lang=ts&


var Paymentvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Payment = class Payment extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Paymentvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Payment.prototype, "width", void 0);

Paymentvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], Payment.prototype, "height", void 0);

Payment = Paymentvue_type_script_lang_ts_decorate([vue_class_component_esm], Payment);
/* harmony default export */ var Paymentvue_type_script_lang_ts_ = (Payment);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Payment.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Paymentvue_type_script_lang_ts_ = (Paymentvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Payment.vue





/* normalize component */
;
var Payment_component = componentNormalizer_normalizeComponent(
  userMenu_Paymentvue_type_script_lang_ts_,
  Paymentvue_type_template_id_b1acbb5c_render,
  Paymentvue_type_template_id_b1acbb5c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Payment = (Payment_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Logos.vue?vue&type=template&id=2ae57192&
var Logosvue_type_template_id_2ae57192_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 18","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.81969 16.4556L1.26624 8.56867L5.81969 0.681763H14.9266L19.4801 8.56867L14.9266\n      16.4556H5.81969Z","stroke":"currentColor","stroke-width":"1.29545"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.64465 4.34851H9.60465V10.8936H12.7461V11.7009H8.64465V4.34851Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.905 4.92883H14.0454","stroke":"currentColor","stroke-width":"1.29545"}})])}
var Logosvue_type_template_id_2ae57192_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Logos.vue?vue&type=script&lang=ts&


var Logosvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SignOut = class SignOut extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Logosvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], SignOut.prototype, "width", void 0);

Logosvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], SignOut.prototype, "height", void 0);

SignOut = Logosvue_type_script_lang_ts_decorate([vue_class_component_esm], SignOut);
/* harmony default export */ var Logosvue_type_script_lang_ts_ = (SignOut);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Logos.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Logosvue_type_script_lang_ts_ = (Logosvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Logos.vue





/* normalize component */
;
var Logos_component = componentNormalizer_normalizeComponent(
  userMenu_Logosvue_type_script_lang_ts_,
  Logosvue_type_template_id_2ae57192_render,
  Logosvue_type_template_id_2ae57192_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Logos = (Logos_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/RestoreSession.vue?vue&type=template&id=bcb1f8ce&
var RestoreSessionvue_type_template_id_bcb1f8ce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 17","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"clip-path":"url(#clip0_1546_5938)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.8573 10.2702C11.5421 10.2702 11.2871 10.5236 11.2871 10.836C11.2871 11.1492 11.5421\n        11.4025 11.8573 11.4025C13.8059 11.4025 15.3922 12.9776 15.3922 14.9143C15.3922 15.1635\n        15.1875 15.3669 14.9358 15.3669H1.59534C1.34444 15.3669 1.13976 15.1635 1.13976\n        14.9143C1.13976 12.9776 2.72603 11.4025 4.67378 11.4025C4.98905 11.4025 5.24407 11.1492\n        5.24407 10.836C5.24407 10.5236 4.98905 10.2702 4.67378 10.2702C2.09631 10.2702 0 12.3528\n        0 14.9143C0 15.7883 0.716376 16.5 1.59534 16.5H14.9358C15.8156 16.5 16.5328 15.7883\n        16.5328 14.9143C16.5328 12.3528 14.4356 10.2702 11.8573 10.2702ZM8.26639 1.63232C9.99461\n        1.63232 11.4018 3.44271 11.4018 5.66798C11.4018 7.89244 9.99461 9.70365 8.26639\n        9.70365C6.53735 9.70365 5.131 7.89244 5.12935 5.66798C5.12935 3.44271 6.53652 1.63232\n        8.26639 1.63232ZM8.26639 10.836C10.6243 10.836 12.5415 8.51804 12.5415 5.66798C12.5415\n        2.81793 10.6243 0.5 8.26639 0.5C7.10021 0.5 6.01079 1.05345 5.20033 2.0595C4.41958\n        3.02947 3.99041 4.31019 3.99041 5.66798C3.99041 8.51804 5.90845 10.836 8.26639 10.836Z\n      ","fill":"#222325"}})]),_c('path',{attrs:{"d":"M20.0775 5.68428L16.8003 9.16492L14.9032 7.13372C14.6989 6.91608 14.365 6.9133 14.1574\n      7.1275C13.9499 7.3417 13.9472 7.69177 14.1515 7.9094L16.4351 10.3409C16.4706 10.3734 16.5106\n      10.4003 16.5537 10.4204C16.5695 10.4351 16.587 10.4476 16.6058 10.4577C16.669 10.4851\n      16.7367 10.4994 16.805 10.5C16.8734 10.4997 16.9411 10.4853 17.0042 10.4577C17.027 10.4451\n      17.0484 10.4302 17.0683 10.413C17.1069 10.3943 17.1428 10.37 17.175 10.3409L20.8292\n      6.46245C20.9727 6.32404 21.0319 6.11408 20.9833 5.91611C20.9346 5.71815 20.786 5.56432\n      20.5966 5.51583C20.4072 5.46735 20.2077 5.53209 20.0775 5.68428Z\n    ","fill":"#222325"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1546_5938"}},[_c('rect',{attrs:{"width":"17","height":"16","fill":"white","transform":"translate(0 0.5)"}})])])])}
var RestoreSessionvue_type_template_id_bcb1f8ce_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/RestoreSession.vue?vue&type=script&lang=ts&


var RestoreSessionvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let RestoreSession = class RestoreSession extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

RestoreSessionvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], RestoreSession.prototype, "width", void 0);

RestoreSessionvue_type_script_lang_ts_decorate([Prop({
  default: 17
})], RestoreSession.prototype, "height", void 0);

RestoreSession = RestoreSessionvue_type_script_lang_ts_decorate([vue_class_component_esm], RestoreSession);
/* harmony default export */ var RestoreSessionvue_type_script_lang_ts_ = (RestoreSession);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/RestoreSession.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_RestoreSessionvue_type_script_lang_ts_ = (RestoreSessionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/RestoreSession.vue





/* normalize component */
;
var RestoreSession_component = componentNormalizer_normalizeComponent(
  userMenu_RestoreSessionvue_type_script_lang_ts_,
  RestoreSessionvue_type_template_id_bcb1f8ce_render,
  RestoreSessionvue_type_template_id_bcb1f8ce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_RestoreSession = (RestoreSession_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Vendor.vue?vue&type=template&id=a146a3b8&
var Vendorvue_type_template_id_a146a3b8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 21","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.29246 12.6725C3.46811 13.2746 3.71187 13.8554 4.01999 14.4004L3.14197 15.5079C2.85524\n      15.8699 2.88751 16.3861 3.21009 16.7123L4.72256 18.2251C5.0487 18.5513 5.56474 18.58\n      5.92672 18.2933L7.02712 17.4222C7.59345 17.7485 8.19543 18.003 8.82276 18.182L8.98751\n      19.5982C9.04137 20.0568 9.4285 20.401 9.88712 20.401H12.0269C12.4855 20.401 12.8727 20.0568\n      12.9265 19.5982L13.0841 18.2323C13.758 18.0566 14.4032 17.7948 15.0087 17.4542L16.0733\n      18.2968C16.4354 18.5838 16.9515 18.5513 17.2776 18.2287L18.7899 16.716C19.1162 16.3897\n      19.1447 15.8735 18.8582 15.5115L18.0301 14.4612C18.3744 13.8659 18.6432 13.2315 18.8222\n      12.5685L20.0982 12.4214C20.557 12.3677 20.901 11.9806 20.901 11.5216V9.38157C20.901 8.92276\n      20.557 8.53563 20.0982 8.48177L18.8402 8.33484C18.6681 7.6788 18.4101 7.05147 18.0804\n      6.46375L18.8544 5.48514C19.1414 5.12296 19.1091 4.60672 18.7865 4.28058L17.2776\n      2.77147C16.9515 2.44514 16.4354 2.41662 16.0733 2.70336L15.1236 3.45603C14.5071 3.09405\n      13.8475 2.81801 13.1558 2.63147L13.0125 1.40197C12.9588 0.943157 12.5717 0.598999 12.1129\n      0.598999H9.97326C9.51444 0.598999 9.12731 0.943157 9.07365 1.40197L8.93029 2.63147C8.22058\n      2.82157 7.54316 3.10831 6.91246 3.48474L5.92692 2.70336C5.56494 2.41662 5.0487 2.4487\n      4.72256 2.77147L3.21009 4.28415C2.88395 4.61029 2.85524 5.12652 3.14197 5.4887L3.96633\n      6.53167C3.63662 7.12692 3.38573 7.76137 3.22078 8.42098L1.90197 8.57147C1.44316 8.62533\n      1.099 9.01246 1.099 9.47128V11.6115C1.099 12.0701 1.44316 12.4572 1.90197 12.5111L3.29246\n      12.6725Z\n    ","stroke":"black","stroke-width":"1.18812","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.0001 13.1056C12.4391 13.1056 13.6056 11.9389 13.6056 10.5001C13.6056 9.06107 12.4391\n      7.89453 11.0001 7.89453C9.56107 7.89453 8.39453 9.06107 8.39453 10.5001C8.39453 11.9389\n      9.56107 13.1056 11.0001 13.1056Z\n    ","stroke":"black","stroke-width":"1.18812","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var Vendorvue_type_template_id_a146a3b8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/Vendor.vue?vue&type=script&lang=ts&


var Vendorvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Vendor = class Vendor extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Vendorvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], Vendor.prototype, "width", void 0);

Vendorvue_type_script_lang_ts_decorate([Prop({
  default: 21
})], Vendor.prototype, "height", void 0);

Vendor = Vendorvue_type_script_lang_ts_decorate([vue_class_component_esm], Vendor);
/* harmony default export */ var Vendorvue_type_script_lang_ts_ = (Vendor);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Vendor.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_Vendorvue_type_script_lang_ts_ = (Vendorvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/Vendor.vue





/* normalize component */
;
var Vendor_component = componentNormalizer_normalizeComponent(
  userMenu_Vendorvue_type_script_lang_ts_,
  Vendorvue_type_template_id_a146a3b8_render,
  Vendorvue_type_template_id_a146a3b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_Vendor = (Vendor_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/SignOut.vue?vue&type=template&id=4b3483f0&
var SignOutvue_type_template_id_4b3483f0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M10.4337 17.2143H1.95632C1.59617 17.2143 1.30421 16.9265 1.30421 16.5714V2.42857C1.30421\n      2.07353 1.59617 1.78571 1.95632 1.78571H10.4337C10.7939 1.78571 11.0858 1.4979 11.0858\n      1.14286C11.0858 0.787817 10.7939 0.5 10.4337 0.5H1.95632C0.875874 0.5 0 1.36345 0\n      2.42857V16.5714C0 17.6365 0.875874 18.5 1.95632 18.5H10.4337C10.7939 18.5 11.0858 18.2122\n      11.0858 17.8571C11.0858 17.5021 10.7939 17.2143 10.4337 17.2143Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M18.0698 9.04374L13.5051 4.54374C13.2463 4.32531 12.8607 4.34 12.6198 4.57745C12.3789\n      4.8149 12.364 5.19511 12.5856 5.45017L16.0352 8.85731H5.2168C4.85666 8.85731 4.5647\n      9.14513 4.5647 9.50017C4.5647 9.85521 4.85666 10.143 5.2168 10.143H16.0418L12.5921\n      13.5437C12.406 13.7008 12.325 13.9475 12.3823 14.1824C12.4396 14.4172 12.6256 14.6006\n      12.8638 14.657C13.102 14.7135 13.3522 14.6336 13.5116 14.4502L18.0763 9.95017C18.3274\n      9.69766 18.3245 9.29271 18.0698 9.04374Z","fill":"currentColor"}})])}
var SignOutvue_type_template_id_4b3483f0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/SignOut.vue?vue&type=script&lang=ts&


var SignOutvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SignOutvue_type_script_lang_ts_SignOut = class SignOut extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

SignOutvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], SignOutvue_type_script_lang_ts_SignOut.prototype, "width", void 0);

SignOutvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], SignOutvue_type_script_lang_ts_SignOut.prototype, "height", void 0);

SignOutvue_type_script_lang_ts_SignOut = SignOutvue_type_script_lang_ts_decorate([vue_class_component_esm], SignOutvue_type_script_lang_ts_SignOut);
/* harmony default export */ var SignOutvue_type_script_lang_ts_ = (SignOutvue_type_script_lang_ts_SignOut);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/SignOut.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_SignOutvue_type_script_lang_ts_ = (SignOutvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/SignOut.vue





/* normalize component */
;
var SignOut_component = componentNormalizer_normalizeComponent(
  userMenu_SignOutvue_type_script_lang_ts_,
  SignOutvue_type_template_id_4b3483f0_render,
  SignOutvue_type_template_id_4b3483f0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_SignOut = (SignOut_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/CompanySettingsIcon.vue?vue&type=template&id=1b0e1443&
var CompanySettingsIconvue_type_template_id_1b0e1443_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 19","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.06299 11.4552C3.22107 11.9972 3.44045 12.5199 3.71776 13.0104L2.92754 14.0071C2.66948 14.3329 2.69853 14.7975 2.98885 15.0911L4.35007 16.4526C4.6436 16.7462 5.10804 16.772 5.43382 16.5139L6.42417 15.73C6.93388 16.0237 7.47566 16.2527 8.04025 16.4138L8.18853 17.6884C8.23701 18.1011 8.58542 18.4109 8.99817 18.4109H10.924C11.3367 18.4109 11.6852 18.1011 11.7336 17.6884L11.8755 16.4591C12.482 16.301 13.0626 16.0654 13.6076 15.7588L14.5657 16.5172C14.8917 16.7754 15.3561 16.7462 15.6496 16.4558L17.0107 15.0944C17.3044 14.8007 17.33 14.3361 17.0722 14.0103L16.3268 13.0651C16.6368 12.5293 16.8786 11.9583 17.0397 11.3617L18.1882 11.2292C18.6011 11.181 18.9106 10.8325 18.9106 10.4194V8.49343C18.9106 8.0805 18.6011 7.73208 18.1882 7.68361L17.0559 7.55137C16.9011 6.96093 16.6688 6.39634 16.3721 5.86739L17.0688 4.98664C17.327 4.66068 17.298 4.19606 17.0076 3.90254L15.6496 2.54434C15.3561 2.25064 14.8917 2.22497 14.5657 2.48303L13.711 3.16044C13.1562 2.83466 12.5625 2.58622 11.94 2.41834L11.811 1.31178C11.7627 0.898854 11.4143 0.589111 11.0013 0.589111H9.0757C8.66277 0.589111 8.31435 0.898854 8.26605 1.31178L8.13703 2.41834C7.49829 2.58943 6.88861 2.84749 6.32099 3.18628L5.434 2.48303C5.10821 2.22497 4.6436 2.25384 4.35007 2.54434L2.98885 3.90574C2.69532 4.19927 2.66948 4.66388 2.92754 4.98984L3.66946 5.92852C3.37273 6.46424 3.14693 7.03525 2.99847 7.62889L1.81154 7.76434C1.39861 7.81281 1.08887 8.16123 1.08887 8.57416V10.5003C1.08887 10.9131 1.39861 11.2615 1.81154 11.31L3.06299 11.4552Z","stroke":"currentColor","stroke-width":"1.18812","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.99978 11.8451C11.2949 11.8451 12.3448 10.7951 12.3448 9.50014C12.3448 8.20503 11.2949 7.15515 9.99978 7.15515C8.70467 7.15515 7.65479 8.20503 7.65479 9.50014C7.65479 10.7951 8.70467 11.8451 9.99978 11.8451Z","stroke":"currentColor","stroke-width":"1.18812","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var CompanySettingsIconvue_type_template_id_1b0e1443_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/userMenu/CompanySettingsIcon.vue?vue&type=script&lang=ts&


var CompanySettingsIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CompanySettingsIcon = class CompanySettingsIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

CompanySettingsIconvue_type_script_lang_ts_decorate([Prop({
  default: 20
})], CompanySettingsIcon.prototype, "width", void 0);

CompanySettingsIconvue_type_script_lang_ts_decorate([Prop({
  default: 19
})], CompanySettingsIcon.prototype, "height", void 0);

CompanySettingsIcon = CompanySettingsIconvue_type_script_lang_ts_decorate([vue_class_component_esm], CompanySettingsIcon);
/* harmony default export */ var CompanySettingsIconvue_type_script_lang_ts_ = (CompanySettingsIcon);
;// CONCATENATED MODULE: ./src/components/icons/userMenu/CompanySettingsIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var userMenu_CompanySettingsIconvue_type_script_lang_ts_ = (CompanySettingsIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/userMenu/CompanySettingsIcon.vue





/* normalize component */
;
var CompanySettingsIcon_component = componentNormalizer_normalizeComponent(
  userMenu_CompanySettingsIconvue_type_script_lang_ts_,
  CompanySettingsIconvue_type_template_id_1b0e1443_render,
  CompanySettingsIconvue_type_template_id_1b0e1443_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var userMenu_CompanySettingsIcon = (CompanySettingsIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserMenu.vue?vue&type=script&lang=ts&
var UserMenuvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






 // account-order





 // credits-inventory



 // accounts-contacts


 // payment-logos


 // vendor-restore


 // sign-out






let UserMenu = class UserMenu extends mixins(userDeviceWidth, mixins_userIsInAccountModule, userIsCgElite, userRole) {
  get userFullName() {
    const {
      customerName,
      customerLastName
    } = this.$store.state.header.headerData;
    let fullName = '';
    if (customerName) fullName += customerName;
    if (customerLastName) fullName += ` ${customerLastName}`;
    return fullName;
  }

  get showRestoreSession() {
    return this.$store.state.headerAuth.showRestoreSession;
  }

  get viewProfileLink() {
    const {
      userIsInAccountModule
    } = this;
    const {
      accountUrl
    } = takeGlobalOptions();
    return userIsInAccountModule ? '/settings' : `${accountUrl}/settings`;
  }

  get userMenusData() {
    return this.$store.state.header.headerData.menus || {};
  }

  get ordersForApprovalCount() {
    return this.$store.state.header.headerData.ordersForApprovalCount || 0;
  }

  get menus() {
    const mainArray = [];
    mainArray.push(this.getAccountOrdersMenu());
    const creditsInventory = this.getCreditsInventoryMenu();
    const accountContacts = this.getAccountsContactsMenu();
    const paymentLogos = this.getPaymentLogosMenu();
    const vendorRestore = this.getVendorRestoreMenu();
    const signOut = this.getSignOutMenu();
    if (creditsInventory.length) mainArray.push(creditsInventory);
    if (accountContacts.length) mainArray.push(accountContacts);
    if (paymentLogos.length) mainArray.push(paymentLogos);
    if (vendorRestore.length) mainArray.push(vendorRestore);
    if (signOut.length) mainArray.push(signOut);
    return mainArray;
  }

  getAccountOrdersMenu() {
    const {
      userIsCgElite,
      vendor,
      ordersForApprovalCount
    } = this;
    const {
      myCampaigns,
      approvableOrders
    } = this.userMenusData;
    const {
      accountUrl
    } = takeGlobalOptions();
    const accountOrders = [];
    accountOrders.push({
      name: 'Account dashboard',
      title: 'Account dashboard',
      url: this.userIsInAccountModule ? '/dashboard' : `${accountUrl}/dashboard`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'AccountIcon'
    });
    accountOrders.push({
      name: 'My orders',
      title: 'My orders',
      url: this.userIsInAccountModule ? '/orders' : `${accountUrl}/orders`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'OrderIcon'
    });
    accountOrders.push({
      name: `Orders for approval (${ordersForApprovalCount})`,
      title: `Orders for approval (${ordersForApprovalCount})`,
      url: this.userIsInAccountModule ? '/orders?tab=approvable-orders' : `${accountUrl}/orders?tab=approvable-orders`,
      disabled: false,
      disabledTooltip: null,
      show: userIsCgElite && approvableOrders,
      icon: 'ApprovalOrder'
    });
    accountOrders.push({
      name: 'My eGift orders',
      title: 'My eGift orders',
      url: this.userIsInAccountModule ? '/e-gift-orders' : `${accountUrl}/e-gift-orders`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'EGiftOrdersIcon'
    });
    accountOrders.push({
      name: 'My campaigns',
      title: 'My campaigns',
      url: this.userIsInAccountModule ? '/my-campaigns' : `${accountUrl}/my-campaigns`,
      disabled: !myCampaigns && !userIsCgElite || vendor,
      disabledTooltip: `Create, manage and automate multiple-choice eGift campaigns for various
        occasions and recipient groups with the CG Elite gifting platform.`,
      show: myCampaigns || !userIsCgElite,
      icon: 'OccassionsIcon'
    });
    return accountOrders.filter(item => item.show);
  }

  getCreditsInventoryMenu() {
    const {
      userIsCgElite,
      vendor,
      subAccount,
      superAdmin,
      accountOwner,
      userMenusData: {
        myInventory,
        myCgCredits,
        myQuotes
      }
    } = this;
    const {
      accountUrl
    } = takeGlobalOptions();
    const creditsInventory = [];
    creditsInventory.push({
      name: 'My CG Credits',
      title: 'My CG Credits',
      url: this.userIsInAccountModule ? '/my-cg-credits' : `${accountUrl}/my-cg-credits`,
      disabled: false,
      disabledTooltip: null,
      show: !subAccount || myCgCredits,
      icon: 'CreditsIcon'
    });
    creditsInventory.push({
      name: 'My inventory',
      title: 'My inventory',
      url: this.userIsInAccountModule ? '/my-inventory' : `${accountUrl}/my-inventory`,
      disabled: !myInventory && !userIsCgElite || vendor,
      disabledTooltip: `View and manage your dedicated gift inventory for eGifting campaigns and
        on-demand fulfillment with the CG Elite gifting platform.`,
      show: myInventory || (superAdmin || accountOwner) && myInventory || !userIsCgElite,
      icon: 'InventoryIcon'
    });
    creditsInventory.push({
      name: 'My quotes',
      title: 'My quotes',
      url: this.userIsInAccountModule ? '/my-quotes' : `${accountUrl}/my-quotes`,
      disabled: false,
      disabledTooltip: null,
      show: myQuotes,
      icon: 'QuotesIcon'
    });
    return creditsInventory.filter(item => item.show);
  }

  getAccountsContactsMenu() {
    const {
      userIsCgElite,
      vendor,
      superAdmin,
      accountOwner,
      userMenusData: {
        mySubAccounts
      }
    } = this;
    const {
      accountUrl
    } = takeGlobalOptions();
    const accountsContacts = [];
    accountsContacts.push({
      name: 'Manage users',
      title: 'Manage users',
      url: this.userIsInAccountModule ? '/users' : `${accountUrl}/users`,
      disabled: !userIsCgElite && !mySubAccounts || vendor,
      disabledTooltip: `Manage user roles, permissions, budgets and workflows across teams and
        your organization with the CG Elite gifting platform.`,
      show: mySubAccounts || (superAdmin || accountOwner) && mySubAccounts,
      icon: 'SubAccountsIcon'
    });
    accountsContacts.push({
      name: 'Contacts',
      title: 'Contacts',
      url: this.userIsInAccountModule ? '/contacts' : `${accountUrl}/contacts`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'AddressBookIcon'
    });
    return accountsContacts.filter(item => item.show);
  }

  getVendorRestoreMenu() {
    const {
      vendor,
      showRestoreSession
    } = this;
    const vendorRestore = [];
    const {
      magentoUrl
    } = takeGlobalOptions();
    vendorRestore.push({
      name: 'Back to admin',
      title: 'Back to admin',
      url: null,
      disabled: false,
      disabledTooltip: null,
      show: showRestoreSession,
      icon: 'RestoreSessionIcon'
    });
    vendorRestore.push({
      name: 'Vendor panel',
      title: 'Vendor panel',
      url: `${magentoUrl}/marketplace/order/`,
      disabled: false,
      disabledTooltip: null,
      show: vendor,
      icon: 'VendorIcon'
    });
    return vendorRestore.filter(item => item.show);
  } // eslint-disable-next-line class-methods-use-this


  getPaymentLogosMenu() {
    const paymentLogos = [];
    const {
      accountUrl
    } = takeGlobalOptions();
    paymentLogos.push({
      name: 'Payment info',
      title: 'Payment info',
      url: this.userIsInAccountModule ? '/payment' : `${accountUrl}/payment`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'PaymentIcon'
    });
    paymentLogos.push({
      name: 'Logos & Images',
      title: 'Logos & Images',
      url: this.userIsInAccountModule ? '/my-logos-and-images' : `${accountUrl}/my-logos-and-images`,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'LogosIcon'
    });
    return paymentLogos.filter(item => item.show);
  } // eslint-disable-next-line class-methods-use-this


  getSignOutMenu() {
    const {
      accountUrl
    } = takeGlobalOptions();
    const {
      userIsCgElite,
      superAdmin,
      accountOwner,
      individual
    } = this;
    const result = [];
    result.push({
      name: 'Company settings',
      title: 'Company settings',
      url: this.userIsInAccountModule ? '/company-settings' : `${accountUrl}/company-settings`,
      disabled: false,
      disabledTooltip: null,
      show: userIsCgElite && (superAdmin || accountOwner) && !individual,
      icon: 'CompanySettingsIcon'
    });
    result.push({
      name: 'Sign out',
      title: 'Sign out',
      url: null,
      disabled: false,
      disabledTooltip: null,
      show: true,
      icon: 'SignOutIcon'
    });
    return result.filter(item => item.show);
  }

  handleLinkClick(menuLink) {
    const {
      accountUrl
    } = takeGlobalOptions();
    if (menuLink.name === 'Sign out') this.$store.dispatch('headerAuth/logout');

    if (menuLink.name === 'Back to admin') {
      const adminCgToken = utils_getCookie('adminCgToken');
      utils_setCookie(null, 0, 'adminCgToken');
      utils_setCookie(adminCgToken, 14, 'cgToken');
      window.location.href = `${accountUrl}/dashboard`;
    }
  }

};
UserMenu = UserMenuvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    LogosIcon: Logos,
    OrderIcon: userMenu_Order,
    VendorIcon: userMenu_Vendor,
    SignOutIcon: userMenu_SignOut,
    PaymentIcon: userMenu_Payment,
    CreditsIcon: userMenu_Credits,
    QuotesIcon: userMenu_Quotes,
    AccountIcon: userMenu_Account,
    QuestionIcon: icons_Question,
    ApprovalOrder: userMenu_ApprovalOrder,
    InventoryIcon: userMenu_Inventory,
    OccassionsIcon: userMenu_Occassions,
    AddressBookIcon: userMenu_AddressBook,
    SubAccountsIcon: userMenu_SubAccount,
    EGiftOrdersIcon: userMenu_EGiftOrders,
    RestoreSessionIcon: userMenu_RestoreSession,
    CompanySettingsIcon: userMenu_CompanySettingsIcon
  }
})], UserMenu);
/* harmony default export */ var UserMenuvue_type_script_lang_ts_ = (UserMenu);
;// CONCATENATED MODULE: ./src/components/UserMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UserMenuvue_type_script_lang_ts_ = (UserMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserMenu.vue?vue&type=style&index=0&id=a60cb1f0&lang=scss&scoped=true&
var UserMenuvue_type_style_index_0_id_a60cb1f0_lang_scss_scoped_true_ = __webpack_require__(8985);
;// CONCATENATED MODULE: ./src/components/UserMenu.vue?vue&type=style&index=0&id=a60cb1f0&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserMenu.vue?vue&type=style&index=1&lang=scss&
var UserMenuvue_type_style_index_1_lang_scss_ = __webpack_require__(7295);
;// CONCATENATED MODULE: ./src/components/UserMenu.vue?vue&type=style&index=1&lang=scss&

;// CONCATENATED MODULE: ./src/components/UserMenu.vue



;



/* normalize component */

var UserMenu_component = componentNormalizer_normalizeComponent(
  components_UserMenuvue_type_script_lang_ts_,
  UserMenuvue_type_template_id_a60cb1f0_scoped_true_render,
  UserMenuvue_type_template_id_a60cb1f0_scoped_true_staticRenderFns,
  false,
  null,
  "a60cb1f0",
  null
  
)

/* harmony default export */ var components_UserMenu = (UserMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationHelp.vue?vue&type=template&id=8b724518&scoped=true&
var TheMobileNavigationHelpvue_type_template_id_8b724518_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://corporategift.com/faq"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_8395_65564","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_8395_65564)"}},[_c('path',{attrs:{"d":"M13.7499 14.7692C13.9948 14.7692 14.2086 14.6779 14.3913 14.4952C14.574 14.3125\n              14.6653 14.0987 14.6653 13.8538C14.6653 13.6089 14.574 13.3952 14.3913\n              13.2125C14.2086 13.0298 13.9948 12.9385 13.7499 12.9385C13.5051 12.9385 13.2913\n              13.0298 13.1086 13.2125C12.9259 13.3952 12.8345 13.6089 12.8345 13.8538C12.8345\n              14.0987 12.9259 14.3125 13.1086 14.4952C13.2913 14.6779 13.5051 14.7692 13.7499\n              14.7692ZM13.1538 11.7615H14.3461C14.3589 11.3102 14.4169 10.9753 14.5201\n              10.7567C14.6233 10.5381 14.8679 10.2423 15.2538 9.8692C15.7153 9.4269 16.0294\n              9.05318 16.1961 8.74805C16.3627 8.44293 16.4461 8.08845 16.4461 7.6846C16.4461\n              6.97307 16.1948 6.38621 15.6922 5.92403C15.1897 5.46184 14.5422 5.23075 13.7499\n              5.23075C13.1307 5.23075 12.5862 5.40158 12.1163 5.74325C11.6464 6.08492 11.3051\n              6.54357 11.0922 7.1192L12.173 7.57305C12.3422 7.1692 12.5592 6.86632 12.824\n              6.6644C13.0887 6.46247 13.3974 6.3615 13.7499 6.3615C14.1884 6.3615 14.5486 6.48843\n              14.8307 6.74228C15.1128 6.99613 15.2538 7.33074 15.2538 7.74613C15.2538 7.99869\n              15.1823 8.23556 15.0394 8.45673C14.8964 8.67788 14.6487 8.94999 14.2961\n              9.27308C13.8102 9.69871 13.4983 10.057 13.3605 10.3481C13.2227 10.6391 13.1538\n              11.1102 13.1538 11.7615ZM8.05765 17.5C7.55252 17.5 7.12496 17.325 6.77498\n              16.975C6.42498 16.625 6.24998 16.1974 6.24998 15.6923V4.3077C6.24998 3.80257\n              6.42498 3.375 6.77498 3.025C7.12496 2.675 7.55252 2.5 8.05765 2.5H19.4422C19.9473\n              2.5 20.3749 2.675 20.7249 3.025C21.0749 3.375 21.2499 3.80257 21.2499\n              4.3077V15.6923C21.2499 16.1974 21.0749 16.625 20.7249 16.975C20.3749 17.325 19.9473\n              17.5 19.4422 17.5H8.05765ZM8.05765 16H19.4422C19.5191 16 19.5897 15.9679 19.6538\n              15.9038C19.7179 15.8397 19.7499 15.7692 19.7499 15.6923V4.3077C19.7499 4.23077\n              19.7179 4.16024 19.6538 4.09613C19.5897 4.03203 19.5191 3.99998 19.4422\n              3.99998H8.05765C7.98072 3.99998 7.9102 4.03203 7.8461 4.09613C7.78198 4.16024\n              7.74993 4.23077 7.74993 4.3077V15.6923C7.74993 15.7692 7.78198 15.8397 7.8461\n              15.9038C7.9102 15.9679 7.98072 16 8.05765 16ZM4.55768 20.9999C4.05256 20.9999 3.625\n              20.8249 3.275 20.4749C2.925 20.1249 2.75 19.6973 2.75\n              19.1922V6.3077H4.24998V19.1922C4.24998 19.2692 4.28202 19.3397 4.34613\n              19.4038C4.41024 19.4679 4.48076 19.5 4.55768 19.5H17.4422V20.9999H4.55768Z","fill":"#62646A"}})])]),_vm._v(" FAQ ")])]),_c('li',[_c('a',{attrs:{"href":"https://corporategift.com/video-tutorials"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_10268_59323","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_10268_59323)"}},[_c('path',{attrs:{"d":"M12.2504 13.1249L17.6447 9.49994L12.2504 5.87494V13.1249ZM14.8544\n              18.7307H18.3197C18.271 19.0474 18.1303 19.3227 17.8977 19.5567C17.6648 19.7907\n              17.3798 19.9294 17.0427 19.9729L5.94093 21.3459C5.4421 21.4063 4.99435 21.2858\n              4.59768 20.9844C4.20085 20.6833 3.97226 20.2833 3.91193 19.7844L2.65043\n              9.44994C2.59026 8.95128 2.71493 8.50453 3.02443 8.10969C3.3341 7.71469 3.73826\n              7.48711 4.23693 7.42694L5.13118 7.33069V8.83069L4.42343 8.91144C4.33376 8.92428\n              4.26326 8.96278 4.21193 9.02694C4.1606 9.09094 4.14135 9.16786 4.15418\n              9.25769L5.42743 19.5922C5.44026 19.682 5.47868 19.7525 5.54268 19.8037C5.60685\n              19.855 5.68376 19.8743 5.77343 19.8614L14.8544 18.7307ZM8.93893 16.7307C8.43376\n              16.7307 8.00618 16.5557 7.65618 16.2057C7.30618 15.8557 7.13118 15.4281 7.13118\n              14.9229V4.15369C7.13118 3.64869 7.30618 3.22119 7.65618 2.87119C8.00618 2.52119\n              8.43376 2.34619 8.93893 2.34619H19.7082C20.2132 2.34619 20.6407 2.52119 20.9907\n              2.87119C21.3407 3.22119 21.5157 3.64869 21.5157 4.15369V14.9229C21.5157 15.4281\n              21.3407 15.8557 20.9907 16.2057C20.6407 16.5557 20.2132 16.7307 19.7082\n              16.7307H8.93893ZM8.93893 15.2307H19.7082C19.7978 15.2307 19.8715 15.2019 19.9292\n              15.1442C19.987 15.0865 20.0159 15.0128 20.0159 14.9229V4.15369C20.0159 4.06403\n              19.987 3.99036 19.9292 3.93269C19.8715 3.87503 19.7978 3.84619 19.7082\n              3.84619H8.93893C8.8491 3.84619 8.77535 3.87503 8.71768 3.93269C8.66001 3.99036\n              8.63118 4.06403 8.63118 4.15369V14.9229C8.63118 15.0128 8.66001 15.0865 8.71768\n              15.1442C8.77535 15.2019 8.8491 15.2307 8.93893 15.2307Z","fill":"#62646A"}})])]),_vm._v(" Video tutorials ")])]),_c('li',[_c('a',{attrs:{"href":"https://corporategift.com/blog"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_10268_59309","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_10268_59309)"}},[_c('path',{attrs:{"d":"M4.5 21.5V8.23075C4.5 7.73208 4.67658 7.30617 5.02975 6.953C5.38308 6.59967 5.80908\n              6.423 6.30775 6.423H13.8365C14.3352 6.423 14.7612 6.59967 15.1145 6.953C15.4677\n              7.30617 15.6443 7.73208 15.6443 8.23075V21.5L10.077 18.673L4.5 21.5ZM6\n              19.1865L10.077 17.027L14.1443 19.1865V8.23075C14.1443 8.14108 14.1154 8.06733\n              14.0577 8.0095C14.0001 7.95183 13.9263 7.923 13.8365 7.923H6.30775C6.21792 7.923\n              6.14417 7.95183 6.0865 8.0095C6.02883 8.06733 6 8.14108 6 8.23075V19.1865ZM18\n              17.7212V4.30775C18 4.21792 17.9712 4.14417 17.9135 4.0865C17.8558 4.02883 17.7821 4\n              17.6923 4H7.39425V2.5H17.6923C18.1909 2.5 18.6169 2.67658 18.9703 3.02975C19.3234\n              3.38308 19.5 3.80908 19.5 4.30775V17.7212H18Z","fill":"#62646A"}})])]),_vm._v(" Blog ")])]),_c('li',[_c('a',{attrs:{"href":"https://corporategift.com/contact-us"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_10268_59317","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_10268_59317)"}},[_c('path',{attrs:{"d":"M11.25 13.6538V9.2345L9.4 11.0845L8.34625 10L12 6.34625L15.6538 10L14.6\n              11.0845L12.75 9.2345V13.6538H11.25ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025\n              19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025\n              4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975\n              4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625\n              19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775\n              19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19\n              18.6923V15.8077H15.7115C15.2757 16.4411 14.7343 16.9327 14.0875 17.2828C13.4407\n              17.6328 12.7448 17.8077 12 17.8077C11.2552 17.8077 10.5593 17.6328 9.9125\n              17.2828C9.26567 16.9327 8.72433 16.4411 8.2885 15.8077H5V18.6923C5 18.7821 5.02883\n              18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19ZM12 16.3077C12.6333\n              16.3077 13.2083 16.1244 13.725 15.7578C14.2417 15.3911 14.6 14.9078 14.8\n              14.3077H19V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821\n              5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5\n              5.21792 5 5.30775V14.3077H9.2C9.4 14.9078 9.75833 15.3911 10.275 15.7578C10.7917\n              16.1244 11.3667 16.3077 12 16.3077ZM5.30775 19H5H19H5.30775Z","fill":"#62646A"}})])]),_vm._v(" Contact us ")])])])}
var TheMobileNavigationHelpvue_type_template_id_8b724518_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationHelp.vue?vue&type=script&lang=ts&
var TheMobileNavigationHelpvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let TheMobileNavigationHelp = class TheMobileNavigationHelp extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
TheMobileNavigationHelp = TheMobileNavigationHelpvue_type_script_lang_ts_decorate([vue_class_component_esm], TheMobileNavigationHelp);
/* harmony default export */ var TheMobileNavigationHelpvue_type_script_lang_ts_ = (TheMobileNavigationHelp);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationHelp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationHelpvue_type_script_lang_ts_ = (TheMobileNavigationHelpvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationHelp.vue?vue&type=style&index=0&id=8b724518&lang=scss&scoped=true&
var TheMobileNavigationHelpvue_type_style_index_0_id_8b724518_lang_scss_scoped_true_ = __webpack_require__(1057);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationHelp.vue?vue&type=style&index=0&id=8b724518&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationHelp.vue



;


/* normalize component */

var TheMobileNavigationHelp_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationHelpvue_type_script_lang_ts_,
  TheMobileNavigationHelpvue_type_template_id_8b724518_scoped_true_render,
  TheMobileNavigationHelpvue_type_template_id_8b724518_scoped_true_staticRenderFns,
  false,
  null,
  "8b724518",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationHelp = (TheMobileNavigationHelp_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopBy.vue?vue&type=template&id=17d0a2c6&scoped=true&
var TheMobileNavigationShopByvue_type_template_id_17d0a2c6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-shop-by"},_vm._l((_vm.shopByMenus),function(item,index){return _c('the-mobile-navigation-shop-by-item',{key:index,attrs:{"item":item}})}),1)}
var TheMobileNavigationShopByvue_type_template_id_17d0a2c6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/menusData/shopBy.ts
var shopBy_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ShopBy = class ShopBy extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get shopByMenus() {
    return this.$store.state.header.shopByNavigation;
  }

};
ShopBy = shopBy_decorate([vue_class_component_esm], ShopBy);
/* harmony default export */ var shopBy = (ShopBy);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue?vue&type=template&id=31c0f6ff&scoped=true&
var TheMobileNavigationShopByItemvue_type_template_id_31c0f6ff_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[(_vm.item.path)?_c('a',{attrs:{"href":_vm.item.path},on:{"click":function($event){return _vm.onMainCategoryClick(_vm.item.title)}}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]):[_vm._v(" "+_vm._s(_vm.item.title)+" ")]],2),_vm._l((_vm.itemChildren),function(child,index){return _c('li',{key:index},[_c('a',{attrs:{"href":child.path},on:{"click":function($event){return _vm.onSubCategoryClick(_vm.item.title, child.title)}}},[_vm._v(" "+_vm._s(child.title)+" ")])])})],2)}
var TheMobileNavigationShopByItemvue_type_template_id_31c0f6ff_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue?vue&type=script&lang=ts&


var TheMobileNavigationShopByItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheMobileNavigationShopByItem = class TheMobileNavigationShopByItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "item", void 0);
  }

  get itemChildren() {
    return this.item.children ?? [];
  }

  onMainCategoryClick(title) {
    navigationClick({
      itemCategory: 'shop by',
      itemSubCategory: title,
      item: title
    });
  }

  onSubCategoryClick(mainCategory, subCategory) {
    navigationClick({
      itemCategory: 'shop by',
      itemSubCategory: mainCategory,
      item: subCategory
    });
  }

};

TheMobileNavigationShopByItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheMobileNavigationShopByItem.prototype, "item", void 0);

TheMobileNavigationShopByItem = TheMobileNavigationShopByItemvue_type_script_lang_ts_decorate([vue_class_component_esm], TheMobileNavigationShopByItem);
/* harmony default export */ var TheMobileNavigationShopByItemvue_type_script_lang_ts_ = (TheMobileNavigationShopByItem);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationShopByItemvue_type_script_lang_ts_ = (TheMobileNavigationShopByItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue?vue&type=style&index=0&id=31c0f6ff&lang=scss&scoped=true&
var TheMobileNavigationShopByItemvue_type_style_index_0_id_31c0f6ff_lang_scss_scoped_true_ = __webpack_require__(4838);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue?vue&type=style&index=0&id=31c0f6ff&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopByItem.vue



;


/* normalize component */

var TheMobileNavigationShopByItem_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationShopByItemvue_type_script_lang_ts_,
  TheMobileNavigationShopByItemvue_type_template_id_31c0f6ff_scoped_true_render,
  TheMobileNavigationShopByItemvue_type_template_id_31c0f6ff_scoped_true_staticRenderFns,
  false,
  null,
  "31c0f6ff",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationShopByItem = (TheMobileNavigationShopByItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopBy.vue?vue&type=script&lang=ts&
var TheMobileNavigationShopByvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TheMobileNavigationShopBy = class TheMobileNavigationShopBy extends mixins(shopBy) {};
TheMobileNavigationShopBy = TheMobileNavigationShopByvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheMobileNavigationShopByItem: mobileNavigation_TheMobileNavigationShopByItem
  }
})], TheMobileNavigationShopBy);
/* harmony default export */ var TheMobileNavigationShopByvue_type_script_lang_ts_ = (TheMobileNavigationShopBy);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopBy.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationShopByvue_type_script_lang_ts_ = (TheMobileNavigationShopByvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopBy.vue?vue&type=style&index=0&id=17d0a2c6&lang=scss&scoped=true&
var TheMobileNavigationShopByvue_type_style_index_0_id_17d0a2c6_lang_scss_scoped_true_ = __webpack_require__(8929);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopBy.vue?vue&type=style&index=0&id=17d0a2c6&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopBy.vue



;


/* normalize component */

var TheMobileNavigationShopBy_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationShopByvue_type_script_lang_ts_,
  TheMobileNavigationShopByvue_type_template_id_17d0a2c6_scoped_true_render,
  TheMobileNavigationShopByvue_type_template_id_17d0a2c6_scoped_true_staticRenderFns,
  false,
  null,
  "17d0a2c6",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationShopBy = (TheMobileNavigationShopBy_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=template&id=741fc334&scoped=true&
var TheMobileNavigationLetThemvue_type_template_id_741fc334_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-shop-by"},[_c('div',{staticClass:"let-them-block"},[_c('h2',{staticClass:"let-them-block__headline"},[_vm._v(" Select a collection of gift options, let your recipients choose! ")]),_vm._m(0),_c('div',{staticClass:"let-them-block__main-block"},[_c('ul',_vm._l((_vm.collectionsNav),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.navigateTo(item.url)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navigateTo(item.url)}}},[_c('div',[_c('img',{attrs:{"src":_vm.cdn + item.image,"alt":item.text}}),_c('h3',[_vm._v(_vm._s(item.text))]),_c('span',{domProps:{"innerHTML":_vm._s(item.desc)}})])])}),0),_c('div',[_c('div',{staticClass:"how-works-block",on:{"click":function($event){return _vm.navigateTo(_vm.storeUrl + '/egift-collections/?show=howWorks')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navigateTo(_vm.storeUrl + '/egift-collections/?show=howWorks')}}},[_c('h6',[_vm._v("HOW IT WORKS?")]),_c('img',{attrs:{"src":_vm.cdn + '/let_them_video_nav.png',"alt":"how it works"}})])])])])])}
var TheMobileNavigationLetThemvue_type_template_id_741fc334_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"let-them-block__text"},[_c('strong',[_vm._v("Bonus:")]),_vm._v(" You don't need their street address ")])}]


;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=template&id=741fc334&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=script&lang=ts&
var TheMobileNavigationLetThemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheMobileNavigationLetThemvue_type_script_lang_ts_TheMobileNavigationShopBy = class TheMobileNavigationShopBy extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get cdn() {
    return "https://cfstage.corporategift.com";
  }

  get storeUrl() {
    const {
      storeUrl
    } = takeGlobalOptions();
    return storeUrl;
  }

  get collectionsNav() {
    const {
      accountUrl
    } = takeGlobalOptions();
    return [{
      text: 'CURATED COLLECTIONS',
      image: '/current_collections_nav_icon.svg',
      url: `${this.storeUrl}/egift-collections/`,
      desc: '(by occasion)'
    }, {
      text: 'BRANDED COLLECTIONS',
      image: '/branded_collections_nav_icon.svg',
      url: `${this.storeUrl}/egift-collections/?collection_tag=19`,
      desc: 'Send a collection of gift options <br> customized with your logo'
    }, {
      text: 'CREATE YOUR OWN',
      image: '/create_your_own_nav_icon.svg',
      url: `${accountUrl}/my-campaigns/create/name/`,
      desc: 'Choose from thousands of <br> gift options'
    }];
  }

  navigateTo(url) {
    window.location.href = url;
  }

};
TheMobileNavigationLetThemvue_type_script_lang_ts_TheMobileNavigationShopBy = TheMobileNavigationLetThemvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {}
})], TheMobileNavigationLetThemvue_type_script_lang_ts_TheMobileNavigationShopBy);
/* harmony default export */ var TheMobileNavigationLetThemvue_type_script_lang_ts_ = (TheMobileNavigationLetThemvue_type_script_lang_ts_TheMobileNavigationShopBy);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationLetThemvue_type_script_lang_ts_ = (TheMobileNavigationLetThemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=style&index=0&id=741fc334&lang=scss&scoped=true&
var TheMobileNavigationLetThemvue_type_style_index_0_id_741fc334_lang_scss_scoped_true_ = __webpack_require__(30);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationLetThem.vue?vue&type=style&index=0&id=741fc334&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationLetThem.vue



;


/* normalize component */

var TheMobileNavigationLetThem_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationLetThemvue_type_script_lang_ts_,
  TheMobileNavigationLetThemvue_type_template_id_741fc334_scoped_true_render,
  TheMobileNavigationLetThemvue_type_template_id_741fc334_scoped_true_staticRenderFns,
  false,
  null,
  "741fc334",
  null
  
)

/* harmony default export */ var TheMobileNavigationLetThem = (TheMobileNavigationLetThem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationResources.vue?vue&type=template&id=48c7f2ff&scoped=true&
var TheMobileNavigationResourcesvue_type_template_id_48c7f2ff_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-resources"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.articlesAndInspiration,"navigationTitle":"Resources"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Articles & inspiration")]},proxy:true},{key:"icon",fn:function(){return [_c('articles-and-solution-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.learnSolutions,"navigationTitle":"Resources"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Learn")]},proxy:true},{key:"icon",fn:function(){return [_c('learn-icon')]},proxy:true}])}),_c('customer-stories',{attrs:{"maxItems":3}}),_c('div',{staticClass:"header-mobile-navigation-resources__bottom"},[_c('latest-article')],1)],1)}
var TheMobileNavigationResourcesvue_type_template_id_48c7f2ff_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/menusData/resources.ts
var resources_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Resources = class Resources extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get cmsResourcesData() {
    return this.$store.state.header.cmsResourcesData;
  }

  get articlesAndInspiration() {
    return this.cmsResourcesData.articlesAndInspiration;
  }

  get learnSolutions() {
    return this.cmsResourcesData.learn;
  }

};
Resources = resources_decorate([vue_class_component_esm], Resources);
/* harmony default export */ var resources = (Resources);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusDropdown.vue?vue&type=template&id=ec557bcc&scoped=true&
var TheHeaderMenusDropdownvue_type_template_id_ec557bcc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-dropdown"},[_c('div',{staticClass:"menu-dropdown__text",attrs:{"tabindex":"0"}},[_vm._t("default")],2),_c('div',{staticClass:"menu-dropdown__content"},[_vm._t("content")],2)])}
var TheHeaderMenusDropdownvue_type_template_id_ec557bcc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusDropdown.vue?vue&type=script&lang=ts&
var TheHeaderMenusDropdownvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let TheHeaderMenusDropdown = class TheHeaderMenusDropdown extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
TheHeaderMenusDropdown = TheHeaderMenusDropdownvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderMenusDropdown);
/* harmony default export */ var TheHeaderMenusDropdownvue_type_script_lang_ts_ = (TheHeaderMenusDropdown);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusDropdown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusDropdownvue_type_script_lang_ts_ = (TheHeaderMenusDropdownvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusDropdown.vue?vue&type=style&index=0&id=ec557bcc&lang=scss&scoped=true&
var TheHeaderMenusDropdownvue_type_style_index_0_id_ec557bcc_lang_scss_scoped_true_ = __webpack_require__(9375);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusDropdown.vue?vue&type=style&index=0&id=ec557bcc&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusDropdown.vue



;


/* normalize component */

var TheHeaderMenusDropdown_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusDropdownvue_type_script_lang_ts_,
  TheHeaderMenusDropdownvue_type_template_id_ec557bcc_scoped_true_render,
  TheHeaderMenusDropdownvue_type_template_id_ec557bcc_scoped_true_staticRenderFns,
  false,
  null,
  "ec557bcc",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusDropdown = (TheHeaderMenusDropdown_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/CustomerStories.vue?vue&type=template&id=a2dbd860&scoped=true&
var CustomerStoriesvue_type_template_id_a2dbd860_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-stories"},[_c('div',{staticClass:"customer-stories__title"},[_vm._v(" Customer stories "),_c('a',{attrs:{"href":"https://corporategift.com/blog/category?name=customer-stories"}},[_vm._v(" View all "),_c('button-arrow-icon')],1)]),_vm._l((_vm.storiesToDisplay),function(story,index){return _c('a',{key:index,staticClass:"customer-stories__story",attrs:{"href":story.url},on:{"click":function($event){return _vm.onItemClick(story.text)}}},[_c('div',[(story.image)?_c('img',{attrs:{"src":_vm._f("cdnPathReplace")(story.image),"alt":"Customer story image","width":"auto","height":"100%","loading":"lazy"}}):_vm._e()]),_vm._v(" "+_vm._s(story.text)+" ")])})],2)}
var CustomerStoriesvue_type_template_id_a2dbd860_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/cdnPathReplaceFilter.ts
var cdnPathReplaceFilter_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CdnPathReplaceFilter = class CdnPathReplaceFilter extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {};
CdnPathReplaceFilter = cdnPathReplaceFilter_decorate([vue_class_component_esm({
  filters: {
    cdnPathReplace: value => value?.replace('https://ecs-prod-cloudfront-us-east-1.s3.amazonaws.com', 'https://cf.corporategift.com')
  }
})], CdnPathReplaceFilter);
/* harmony default export */ var cdnPathReplaceFilter = (CdnPathReplaceFilter);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ButtonArrowIcon.vue?vue&type=template&id=a048a1b8&
var ButtonArrowIconvue_type_template_id_a048a1b8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 23","fill":'transparent',"width":_vm.width,"height":_vm.height}},[_c('rect',{attrs:{"x":"0.916667","y":"1.41667","width":"20.1667","height":"20.1667","rx":"10.0833","stroke":"black","stroke-width":"1.83333"}}),_c('path',{attrs:{"id":"arrow","d":"M13.4654 11.8692H7.19329V11.1308H13.4654H14.2338L13.6904 10.5874L10.9641 7.86106L11.4861\n      7.33906L15.647 11.5L11.4861 15.6609L10.9641 15.1389L13.6904 12.4126L14.2338\n      11.8692H13.4654Z","fill":"black","stroke":"black","stroke-width":"0.636574"}})])}
var ButtonArrowIconvue_type_template_id_a048a1b8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ButtonArrowIcon.vue?vue&type=script&lang=ts&


var ButtonArrowIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ButtonArrowIcon = class ButtonArrowIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

ButtonArrowIconvue_type_script_lang_ts_decorate([Prop({
  default: 22
})], ButtonArrowIcon.prototype, "width", void 0);

ButtonArrowIconvue_type_script_lang_ts_decorate([Prop({
  default: 23
})], ButtonArrowIcon.prototype, "height", void 0);

ButtonArrowIcon = ButtonArrowIconvue_type_script_lang_ts_decorate([vue_class_component_esm], ButtonArrowIcon);
/* harmony default export */ var ButtonArrowIconvue_type_script_lang_ts_ = (ButtonArrowIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ButtonArrowIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_ButtonArrowIconvue_type_script_lang_ts_ = (ButtonArrowIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ButtonArrowIcon.vue





/* normalize component */
;
var ButtonArrowIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_ButtonArrowIconvue_type_script_lang_ts_,
  ButtonArrowIconvue_type_template_id_a048a1b8_render,
  ButtonArrowIconvue_type_template_id_a048a1b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_ButtonArrowIcon = (ButtonArrowIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/CustomerStories.vue?vue&type=script&lang=ts&


var CustomerStoriesvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let CustomerStories = class CustomerStories extends mixins(cdnPathReplaceFilter) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "maxItems", void 0);
  }

  get customerStories() {
    return this.$store.state.header.cmsWhatWeOfferData?.customerStories ?? [];
  }

  get storiesToDisplay() {
    return this.customerStories.slice(0, this.maxItems);
  }

  onItemClick(title) {
    navigationClick({
      itemCategory: 'What we offer',
      itemSubCategory: 'Customer stories',
      item: title
    });
  }

};

CustomerStoriesvue_type_script_lang_ts_decorate([Prop({
  default: 2
})], CustomerStories.prototype, "maxItems", void 0);

CustomerStories = CustomerStoriesvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    ButtonArrowIcon: whatWeOffer_ButtonArrowIcon
  }
})], CustomerStories);
/* harmony default export */ var CustomerStoriesvue_type_script_lang_ts_ = (CustomerStories);
;// CONCATENATED MODULE: ./src/components/desktopMenus/CustomerStories.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_CustomerStoriesvue_type_script_lang_ts_ = (CustomerStoriesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/CustomerStories.vue?vue&type=style&index=0&id=a2dbd860&lang=scss&scoped=true&
var CustomerStoriesvue_type_style_index_0_id_a2dbd860_lang_scss_scoped_true_ = __webpack_require__(234);
;// CONCATENATED MODULE: ./src/components/desktopMenus/CustomerStories.vue?vue&type=style&index=0&id=a2dbd860&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/CustomerStories.vue



;


/* normalize component */

var CustomerStories_component = componentNormalizer_normalizeComponent(
  desktopMenus_CustomerStoriesvue_type_script_lang_ts_,
  CustomerStoriesvue_type_template_id_a2dbd860_scoped_true_render,
  CustomerStoriesvue_type_template_id_a2dbd860_scoped_true_staticRenderFns,
  false,
  null,
  "a2dbd860",
  null
  
)

/* harmony default export */ var desktopMenus_CustomerStories = (CustomerStories_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/WhatWeOfferItem.vue?vue&type=template&id=7aaaae25&scoped=true&
var WhatWeOfferItemvue_type_template_id_7aaaae25_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-we-offer-item"},[_c('div',{staticClass:"what-we-offer-item__title"},[_vm._t("title")],2),_c('div',{staticClass:"what-we-offer-item__icon"},[_vm._t("icon")],2),_c('ul',_vm._l((_vm.solutionsItems),function(solution,index){return _c('li',{key:index},[_c('a',{attrs:{"href":solution.url},on:{"click":function($event){return _vm.onItemClick(solution)}}},[_c('div',[_vm._v(" "+_vm._s(solution.title)+" ")]),_c('div',[_vm._v(" "+_vm._s(solution.subTitle)+" ")])])])}),0)])}
var WhatWeOfferItemvue_type_template_id_7aaaae25_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/WhatWeOfferItem.vue?vue&type=script&lang=ts&


var WhatWeOfferItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let WhatWeOfferItem = class WhatWeOfferItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "solutionsItems", void 0);

    _defineProperty(this, "navigationTitle", void 0);
  }

  get sectionTitle() {
    return this.$slots.title?.[0]?.text?.trim();
  }

  onItemClick({
    title
  }) {
    const {
      sectionTitle,
      navigationTitle
    } = this;
    navigationClick({
      itemCategory: navigationTitle,
      itemSubCategory: sectionTitle,
      item: title
    });
  }

};

WhatWeOfferItemvue_type_script_lang_ts_decorate([Prop({
  required: false
})], WhatWeOfferItem.prototype, "solutionsItems", void 0);

WhatWeOfferItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], WhatWeOfferItem.prototype, "navigationTitle", void 0);

WhatWeOfferItem = WhatWeOfferItemvue_type_script_lang_ts_decorate([vue_class_component_esm], WhatWeOfferItem);
/* harmony default export */ var WhatWeOfferItemvue_type_script_lang_ts_ = (WhatWeOfferItem);
;// CONCATENATED MODULE: ./src/components/desktopMenus/WhatWeOfferItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_WhatWeOfferItemvue_type_script_lang_ts_ = (WhatWeOfferItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/WhatWeOfferItem.vue?vue&type=style&index=0&id=7aaaae25&lang=scss&scoped=true&
var WhatWeOfferItemvue_type_style_index_0_id_7aaaae25_lang_scss_scoped_true_ = __webpack_require__(17);
;// CONCATENATED MODULE: ./src/components/desktopMenus/WhatWeOfferItem.vue?vue&type=style&index=0&id=7aaaae25&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/WhatWeOfferItem.vue



;


/* normalize component */

var WhatWeOfferItem_component = componentNormalizer_normalizeComponent(
  desktopMenus_WhatWeOfferItemvue_type_script_lang_ts_,
  WhatWeOfferItemvue_type_template_id_7aaaae25_scoped_true_render,
  WhatWeOfferItemvue_type_template_id_7aaaae25_scoped_true_staticRenderFns,
  false,
  null,
  "7aaaae25",
  null
  
)

/* harmony default export */ var desktopMenus_WhatWeOfferItem = (WhatWeOfferItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/LatestArticle.vue?vue&type=template&id=88f5c60c&scoped=true&
var LatestArticlevue_type_template_id_88f5c60c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"latest-article"},[_c('div',{staticClass:"latest-article__title"},[_vm._v("Latest article")]),(_vm.lastArticleInfo)?_c('a',{staticClass:"latest-article__article-info",attrs:{"href":_vm.lastArticleInfo.url},on:{"click":function($event){return _vm.onItemClick(_vm.lastArticleInfo.text)}}},[_c('img',{attrs:{"src":_vm._f("cdnPathReplace")(_vm.lastArticleInfo.image),"alt":_vm.lastArticleInfo.text,"width":"auto","height":"100%","loading":"lazy"}}),_vm._v(" "+_vm._s(_vm.lastArticleInfo.text)+" ")]):_vm._e()])}
var LatestArticlevue_type_template_id_88f5c60c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/LatestArticle.vue?vue&type=script&lang=ts&
var LatestArticlevue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let LatestArticle = class LatestArticle extends mixins(cdnPathReplaceFilter) {
  get lastArticleInfo() {
    const articles = this.$store.state.header.cmsResourcesData?.lastArticles ?? [];
    return articles?.at(0);
  }

  onItemClick(title) {
    navigationClick({
      itemCategory: 'Resources',
      itemSubCategory: 'Latest article',
      item: title
    });
  }

};
LatestArticle = LatestArticlevue_type_script_lang_ts_decorate([vue_class_component_esm], LatestArticle);
/* harmony default export */ var LatestArticlevue_type_script_lang_ts_ = (LatestArticle);
;// CONCATENATED MODULE: ./src/components/desktopMenus/LatestArticle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_LatestArticlevue_type_script_lang_ts_ = (LatestArticlevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/LatestArticle.vue?vue&type=style&index=0&id=88f5c60c&lang=scss&scoped=true&
var LatestArticlevue_type_style_index_0_id_88f5c60c_lang_scss_scoped_true_ = __webpack_require__(3124);
;// CONCATENATED MODULE: ./src/components/desktopMenus/LatestArticle.vue?vue&type=style&index=0&id=88f5c60c&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/LatestArticle.vue



;


/* normalize component */

var LatestArticle_component = componentNormalizer_normalizeComponent(
  desktopMenus_LatestArticlevue_type_script_lang_ts_,
  LatestArticlevue_type_template_id_88f5c60c_scoped_true_render,
  LatestArticlevue_type_template_id_88f5c60c_scoped_true_staticRenderFns,
  false,
  null,
  "88f5c60c",
  null
  
)

/* harmony default export */ var desktopMenus_LatestArticle = (LatestArticle_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/LearnIcon.vue?vue&type=template&id=057241ea&
var LearnIconvue_type_template_id_057241ea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"27","height":"29","viewBox":"0 0 27 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"articles icon"}},[_c('circle',{attrs:{"id":"Oval Copy 2","cx":"13.5","cy":"13.5","r":"13.5","fill":"#ECFFAC"}}),_c('g',{attrs:{"id":"eyeglasses"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9213_68331","maskUnits":"userSpaceOnUse","x":"0","y":"5","width":"24","height":"24"}},[_c('rect',{attrs:{"id":"Bounding box","y":"5","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_9213_68331)"}},[_c('path',{attrs:{"id":"eyeglasses_2","d":"M7.44662 20.0384C7.97611 20.0384 8.45784 19.8819 8.89182 19.5691C9.32579 19.2563\n            9.63251 18.8454 9.812 18.3365L10.1293 17.3211C10.4088 16.4826 10.3325 15.713 9.90047\n            15.0124C9.46842 14.3118 8.85816 13.9615 8.0697 13.9615H4.50625L4.98125 17.8672C5.06458\n            18.489 5.3399 19.0063 5.8072 19.4191C6.27451 19.8319 6.82099 20.0384 7.44662\n            20.0384ZM16.5543 20.0384C17.18 20.0384 17.7264 19.8319 18.1937 19.4191C18.661 19.0063\n            18.9364 18.489 19.0197 17.8672L19.4947 13.9615H15.9562C15.1678 13.9615 14.5543 14.3127\n            14.1159 15.0153C13.6774 15.7178 13.5979 16.4884 13.8774 17.3268L14.1889\n            18.3365C14.3684 18.8454 14.6752 19.2563 15.1091 19.5691C15.5431 19.8819 16.0248\n            20.0384 16.5543 20.0384ZM7.44662 21.0384C6.57739 21.0384 5.81361 20.7496 5.15527\n            20.172C4.49694 19.5945 4.11392 18.8647 4.00622 17.9826L3.50047\n            13.9615H2.6543V12.9614H8.0697C8.64918 12.9614 9.18861 13.1182 9.68797 13.4316C10.1873\n            13.7451 10.5928 14.1781 10.9043 14.7307H13.1216C13.4332 14.1781 13.8386 13.7451 14.338\n            13.4316C14.8373 13.1182 15.3768 12.9614 15.9562\n            12.9614H21.3466V13.9615H20.5005L19.9947 17.9826C19.887 18.8647 19.504 19.5945 18.8457\n            20.172C18.1873 20.7496 17.4236 21.0384 16.5543 21.0384C15.7966 21.0384 15.1187 20.822\n            14.5207 20.3893C13.9226 19.9566 13.4992 19.3865 13.2505 18.6788L12.9332 17.6691C12.887\n            17.514 12.8473 17.3515 12.8139 17.1816C12.7806 17.0118 12.7473 16.7589 12.7139\n            16.423H11.287C11.2537 16.7255 11.2204 16.965 11.187 17.1413C11.1537 17.3175 11.1139\n            17.4832 11.0678 17.6384L10.7505 18.6538C10.5146 19.3615 10.0944 19.9358 9.4899\n            20.3768C8.88541 20.8179 8.20432 21.0384 7.44662 21.0384Z","fill":"#1C1B1F"}})])])])])}
var LearnIconvue_type_template_id_057241ea_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/LearnIcon.vue?vue&type=script&lang=ts&


var LearnIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let LearnIcon = class LearnIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

LearnIconvue_type_script_lang_ts_decorate([Prop({
  default: 27
})], LearnIcon.prototype, "width", void 0);

LearnIconvue_type_script_lang_ts_decorate([Prop({
  default: 29
})], LearnIcon.prototype, "height", void 0);

LearnIcon = LearnIconvue_type_script_lang_ts_decorate([vue_class_component_esm], LearnIcon);
/* harmony default export */ var LearnIconvue_type_script_lang_ts_ = (LearnIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/LearnIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_LearnIconvue_type_script_lang_ts_ = (LearnIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/LearnIcon.vue





/* normalize component */
;
var LearnIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_LearnIconvue_type_script_lang_ts_,
  LearnIconvue_type_template_id_057241ea_render,
  LearnIconvue_type_template_id_057241ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_LearnIcon = (LearnIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ArticlesAndSolutionIcon.vue?vue&type=template&id=704689d8&
var ArticlesAndSolutionIconvue_type_template_id_704689d8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 29","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"articles icon"}},[_c('circle',{attrs:{"id":"Oval Copy 2","cx":"13.5","cy":"13.5","r":"13.5","fill":"#D7DBFF"}}),_c('g',{attrs:{"id":"bookmarks"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9213_68309","maskUnits":"userSpaceOnUse","x":"0","y":"5","width":"24","height":"24"}},[_c('rect',{attrs:{"id":"Bounding box","y":"5","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_9213_68309)"}},[_c('path',{attrs:{"id":"bookmarks_2","d":"M4.5 26.5V12.6154C4.5 12.1551 4.65417 11.7708 4.9625 11.4625C5.27083 11.1542 5.65513\n            11 6.11538 11H14.8846C15.3449 11 15.7292 11.1542 16.0375 11.4625C16.3458 11.7708 16.5\n            12.1551 16.5 12.6154V26.5L10.5 23.9231L4.5 26.5ZM5.5 24.95L10.5 22.8L15.5\n            24.95V12.6154C15.5 12.4615 15.4359 12.3205 15.3077 12.1923C15.1795 12.0641 15.0385 12\n            14.8846 12H6.11538C5.96153 12 5.8205 12.0641 5.6923 12.1923C5.5641 12.3205 5.5 12.4615\n            5.5 12.6154V24.95ZM18.5 23.5V9.61537C18.5 9.46152 18.4359 9.3205 18.3077\n            9.1923C18.1795 9.0641 18.0385 9 17.8846 9H7.5V8H17.8846C18.3449 8 18.7292 8.15417\n            19.0375 8.4625C19.3458 8.77083 19.5 9.15512 19.5 9.61537V23.5H18.5Z","fill":"#1C1B1F"}})])])])])}
var ArticlesAndSolutionIconvue_type_template_id_704689d8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ArticlesAndSolutionIcon.vue?vue&type=script&lang=ts&


var ArticlesAndSolutionIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ArticlesAndSolutionIcon = class ArticlesAndSolutionIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

ArticlesAndSolutionIconvue_type_script_lang_ts_decorate([Prop({
  default: 27
})], ArticlesAndSolutionIcon.prototype, "width", void 0);

ArticlesAndSolutionIconvue_type_script_lang_ts_decorate([Prop({
  default: 29
})], ArticlesAndSolutionIcon.prototype, "height", void 0);

ArticlesAndSolutionIcon = ArticlesAndSolutionIconvue_type_script_lang_ts_decorate([vue_class_component_esm], ArticlesAndSolutionIcon);
/* harmony default export */ var ArticlesAndSolutionIconvue_type_script_lang_ts_ = (ArticlesAndSolutionIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ArticlesAndSolutionIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_ArticlesAndSolutionIconvue_type_script_lang_ts_ = (ArticlesAndSolutionIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ArticlesAndSolutionIcon.vue





/* normalize component */
;
var ArticlesAndSolutionIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_ArticlesAndSolutionIconvue_type_script_lang_ts_,
  ArticlesAndSolutionIconvue_type_template_id_704689d8_render,
  ArticlesAndSolutionIconvue_type_template_id_704689d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_ArticlesAndSolutionIcon = (ArticlesAndSolutionIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationResources.vue?vue&type=script&lang=ts&
var TheMobileNavigationResourcesvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






 // icons



let TheMobileNavigationResources = class TheMobileNavigationResources extends mixins(resources) {};
TheMobileNavigationResources = TheMobileNavigationResourcesvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    ArticlesAndSolutionIcon: whatWeOffer_ArticlesAndSolutionIcon,
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    CustomerStories: desktopMenus_CustomerStories,
    WhatWeOfferItem: desktopMenus_WhatWeOfferItem,
    LatestArticle: desktopMenus_LatestArticle,
    LearnIcon: whatWeOffer_LearnIcon
  }
})], TheMobileNavigationResources);
/* harmony default export */ var TheMobileNavigationResourcesvue_type_script_lang_ts_ = (TheMobileNavigationResources);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationResources.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationResourcesvue_type_script_lang_ts_ = (TheMobileNavigationResourcesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationResources.vue?vue&type=style&index=0&id=48c7f2ff&lang=scss&scoped=true&
var TheMobileNavigationResourcesvue_type_style_index_0_id_48c7f2ff_lang_scss_scoped_true_ = __webpack_require__(3949);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationResources.vue?vue&type=style&index=0&id=48c7f2ff&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationResources.vue



;


/* normalize component */

var TheMobileNavigationResources_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationResourcesvue_type_script_lang_ts_,
  TheMobileNavigationResourcesvue_type_template_id_48c7f2ff_scoped_true_render,
  TheMobileNavigationResourcesvue_type_template_id_48c7f2ff_scoped_true_staticRenderFns,
  false,
  null,
  "48c7f2ff",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationResources = (TheMobileNavigationResources_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue?vue&type=template&id=868973cc&scoped=true&
var TheMobileNavigationWhatWeOffervue_type_template_id_868973cc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-what-we-offer"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.shopCustomize,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Shop, customize & ideate")]},proxy:true},{key:"icon",fn:function(){return [_c('shop-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.enrageRecipient,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Engage recipients")]},proxy:true},{key:"icon",fn:function(){return [_c('engage-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.streamlineGifting,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Streamline gifting")]},proxy:true},{key:"icon",fn:function(){return [_c('streamline-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.storeAndManageMerchandise,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Store & manage merchandise")]},proxy:true},{key:"icon",fn:function(){return [_c('store-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.secureData,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Secure data")]},proxy:true},{key:"icon",fn:function(){return [_c('secure-data-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.enterpriseSolutions,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Enterprise solutions")]},proxy:true},{key:"icon",fn:function(){return [_c('enterprise-icon')]},proxy:true}])}),_c('div',{staticClass:"header-mobile-navigation-what-we-offer__bottom"},[_c('latest-article')],1)],1)}
var TheMobileNavigationWhatWeOffervue_type_template_id_868973cc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/menusData/whatWeOffer.ts
var whatWeOffer_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let WhatWeOffer = class WhatWeOffer extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get whatWeOfferData() {
    return this.$store.state.header.cmsWhatWeOfferData;
  }

  get shopCustomize() {
    return this.whatWeOfferData.shopCustomize;
  }

  get enrageRecipient() {
    return this.whatWeOfferData.enrageRecipient;
  }

  get streamlineGifting() {
    return this.whatWeOfferData.streamlineGifting;
  }

  get storeAndManageMerchandise() {
    return this.whatWeOfferData.storeAndManageMerchandise;
  }

  get secureData() {
    return this.whatWeOfferData.secureData;
  }

  get enterpriseSolutions() {
    return this.whatWeOfferData.enterpriseSolutions;
  }

};
WhatWeOffer = whatWeOffer_decorate([vue_class_component_esm], WhatWeOffer);
/* harmony default export */ var whatWeOffer = (WhatWeOffer);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ShopIcon.vue?vue&type=template&id=7ad419f5&
var ShopIconvue_type_template_id_7ad419f5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 35 30","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"shop icon"}},[_c('circle',{attrs:{"id":"Oval Copy 2","cx":"13.5","cy":"13.5","r":"13.5","fill":"#EBDCFF"}}),_c('g',{attrs:{"id":"shopping_cart"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9180_69655","maskUnits":"userSpaceOnUse","x":"11","y":"6","width":"24","height":"24"}},[_c('rect',{attrs:{"id":"Bounding box","x":"11","y":"6","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_9180_69655)"}},[_c('path',{attrs:{"id":"shopping_cart_2","d":"M18.3077 27.1154C17.8859 27.1154 17.5305 26.9708 17.2414 26.6817C16.9522 26.3926\n            16.8077 26.0372 16.8077 25.6154C16.8077 25.1936 16.9522 24.8382 17.2414\n            24.5491C17.5305 24.2599 17.8859 24.1154 18.3077 24.1154C18.7295 24.1154 19.0849\n            24.2599 19.3741 24.5491C19.6632 24.8382 19.8077 25.1936 19.8077 25.6154C19.8077\n            26.0372 19.6632 26.3926 19.3741 26.6817C19.0849 26.9708 18.7295 27.1154 18.3077\n            27.1154ZM27.6923 27.1154C27.2705 27.1154 26.9151 26.9708 26.626 26.6817C26.3369\n            26.3926 26.1923 26.0372 26.1923 25.6154C26.1923 25.1936 26.3369 24.8382 26.626\n            24.5491C26.9151 24.2599 27.2705 24.1154 27.6923 24.1154C28.1141 24.1154 28.4696\n            24.2599 28.7587 24.5491C29.0478 24.8382 29.1923 25.1936 29.1923 25.6154C29.1923\n            26.0372 29.0478 26.3926 28.7587 26.6817C28.4696 26.9708 28.1141 27.1154 27.6923\n            27.1154ZM16.8808 11.5L19.55 17.1154H26.1846C26.3 17.1154 26.4026 17.0865 26.4923\n            17.0289C26.5821 16.9712 26.659 16.891 26.7231 16.7885L29.3385 12.0385C29.4154\n            11.8974 29.4218 11.7724 29.3577 11.6635C29.2936 11.5545 29.1846 11.5 29.0308\n            11.5H16.8808ZM16.3923 10.5H29.4116C29.8462 10.5 30.1731 10.6772 30.3923\n            11.0317C30.6115 11.3862 30.6231 11.7513 30.4269 12.1269L27.5692 17.3346C27.4244\n            17.5782 27.2362 17.7692 27.0048 17.9077C26.7734 18.0462 26.5192 18.1154 26.2423\n            18.1154H19.1L17.8846 20.3462C17.7821 20.5 17.7789 20.6667 17.875 20.8462C17.9711\n            21.0256 18.1154 21.1154 18.3077 21.1154H29.1923V22.1154H18.3077C17.7244 22.1154\n            17.2891 21.8696 17.0019 21.3779C16.7147 20.8862 16.7077 20.3923 16.9808\n            19.8962L18.4846 17.2154L14.8077 9.5H13V8.5H15.4423L16.3923 10.5Z","fill":"#1C1B1F"}})])])])])}
var ShopIconvue_type_template_id_7ad419f5_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/ShopIcon.vue?vue&type=script&lang=ts&


var ShopIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ShopIcon = class ShopIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

ShopIconvue_type_script_lang_ts_decorate([Prop({
  default: 35
})], ShopIcon.prototype, "width", void 0);

ShopIconvue_type_script_lang_ts_decorate([Prop({
  default: 30
})], ShopIcon.prototype, "height", void 0);

ShopIcon = ShopIconvue_type_script_lang_ts_decorate([vue_class_component_esm], ShopIcon);
/* harmony default export */ var ShopIconvue_type_script_lang_ts_ = (ShopIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ShopIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_ShopIconvue_type_script_lang_ts_ = (ShopIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/ShopIcon.vue





/* normalize component */
;
var ShopIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_ShopIconvue_type_script_lang_ts_,
  ShopIconvue_type_template_id_7ad419f5_render,
  ShopIconvue_type_template_id_7ad419f5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_ShopIcon = (ShopIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/EngageIcon.vue?vue&type=template&id=9ffe8388&
var EngageIconvue_type_template_id_9ffe8388_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 33","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"solutions by role icon"}},[_c('circle',{attrs:{"id":"Oval Copy 2","cx":"13.5","cy":"13.5","r":"13.5","fill":"#D8FDFF"}}),_c('g',{attrs:{"id":"technology icon"}},[_c('g',{attrs:{"id":"Group 3"}},[_c('path',{attrs:{"id":"Fill 1","fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.614 12.9115C10.9727 12.9115 10.4516 12.3971 10.4516 11.7639C10.4516 11.1308\n            10.9727 10.6163 11.614 10.6163C12.2554 10.6163 12.7765 11.1308 12.7765\n            11.7639C12.7765 12.3971 12.2554 12.9115 11.614 12.9115ZM13.378 11.7639C13.378\n            10.7944 12.5764 10.0029 11.5943 10.0029C10.6122 10.0029 9.81055 10.7944 9.81055\n            11.7639C9.81055 12.6345 10.4519 13.3468 11.2736\n            13.4853V32.4802H11.8949V13.4853C12.7568 13.3468 13.378 12.6147 13.378 11.7639Z","fill":"black"}})]),_c('path',{attrs:{"id":"Fill 4","fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.8996 22.1819C17.2524 22.1819 16.7266 21.6722 16.7266 21.0448C16.7266 20.4175\n          17.2524 19.9078 17.8996 19.9078C18.5468 19.9078 19.0726 20.4175 19.0726 21.0448C19.0726\n          21.6722 18.5468 22.1819 17.8996 22.1819ZM19.6996 21.0448C19.6996 20.0842 18.8906 19.3\n          17.8996 19.3C16.9086 19.3 16.0996 20.0842 16.0996 21.0448C16.0996 21.9075 16.7468\n          22.6132 17.576 22.7505V32.2H18.2232V22.7701C19.0524 22.6132 19.6996 21.9075 19.6996\n          21.0448Z","fill":"black"}}),_c('path',{attrs:{"id":"Fill 6","fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.6815 17.4109C14.0637 17.4109 13.5617 16.896 13.5617 16.2624C13.5617 15.6287 14.0637\n          15.1139 14.6815 15.1139C15.2993 15.1139 15.8013 15.6287 15.8013 16.2624C15.8013 16.896\n          15.2993 17.4109 14.6815 17.4109ZM16.4 16.2624C16.4 15.2921 15.6277 14.5 14.6817\n          14.5C13.7356 14.5 12.9634 15.2921 12.9634 16.2624C12.9634 17.1337 13.5812 17.8465\n          14.3728 17.9852V25.3713L12.5 27.2921V32.5H13.0985V27.5495L14.9713\n          25.6287H14.9906V17.9852C15.7822 17.8465 16.4 17.1337 16.4 16.2624Z","fill":"black"}}),_c('g',{attrs:{"id":"Group 10"}},[_c('path',{attrs:{"id":"Fill 8","fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.392 19.2047C19.7813 19.2047 19.2852 18.6926 19.2852 18.0623C19.2852 17.4321\n            19.7813 16.9199 20.392 16.9199C21.0027 16.9199 21.4989 17.4321 21.4989 18.0623C21.4989\n            18.6926 21.0027 19.2047 20.392 19.2047ZM22.0902 18.0623C22.0902 17.0972 21.3269\n            16.3093 20.3918 16.3093C19.4566 16.3093 18.6933 17.0972 18.6933 18.0623C18.6933 18.929\n            19.304 19.6381 20.0864 19.7759V23.8138L14.6094 29.5061V32.5H15.201V29.7621L20.678\n            24.1092H20.6971V19.7956C21.4795 19.6578 22.0902 18.929 22.0902 18.0623Z","fill":"black"}})]),_c('path',{attrs:{"id":"Fill 11","fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.11758 18.3623C7.11758 17.7286 7.61957 17.2138 8.23739 17.2138C8.8552 17.2138 9.35719\n          17.7286 9.35719 18.3623C9.35719 18.9959 8.8552 19.5107 8.23739 19.5107C7.61957 19.5107\n          7.11758 18.9959 7.11758 18.3623ZM10.4 24.6391L8.52724 22.7184V20.0849C9.33813 19.9463\n          9.93663 19.2137 9.93663 18.3623C9.93663 17.392 9.16437 16.6 8.21833 16.6C7.27228 16.6\n          6.5 17.392 6.5 18.3623C6.5 19.2335 7.11782 19.9463 7.90939 20.0849V22.956L9.78219\n          24.8767V32.5H10.3807V24.6391H10.4Z","fill":"black"}})])])])}
var EngageIconvue_type_template_id_9ffe8388_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/EngageIcon.vue?vue&type=script&lang=ts&


var EngageIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let EngageIcon = class EngageIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

EngageIconvue_type_script_lang_ts_decorate([Prop({
  default: 27
})], EngageIcon.prototype, "width", void 0);

EngageIconvue_type_script_lang_ts_decorate([Prop({
  default: 33
})], EngageIcon.prototype, "height", void 0);

EngageIcon = EngageIconvue_type_script_lang_ts_decorate([vue_class_component_esm], EngageIcon);
/* harmony default export */ var EngageIconvue_type_script_lang_ts_ = (EngageIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/EngageIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_EngageIconvue_type_script_lang_ts_ = (EngageIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/EngageIcon.vue





/* normalize component */
;
var EngageIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_EngageIconvue_type_script_lang_ts_,
  EngageIconvue_type_template_id_9ffe8388_render,
  EngageIconvue_type_template_id_9ffe8388_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_EngageIcon = (EngageIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/StreamlineIcon.vue?vue&type=template&id=4f0f55b2&
var StreamlineIconvue_type_template_id_4f0f55b2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 31","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"Streamline gifting"}},[_c('circle',{attrs:{"id":"Oval Copy 2","cx":"14.5","cy":"14.5","r":"13.5","fill":"#FEE3FE"}}),_c('g',{attrs:{"id":"auto_mode"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9180_69685","maskUnits":"userSpaceOnUse","x":"10","y":"7","width":"24","height":"24"}},[_c('rect',{attrs:{"id":"Bounding box","x":"10","y":"7","width":"24","height":"24","fill":"#D9D9D9"}})]),_c('g',{attrs:{"mask":"url(#mask0_9180_69685)"}},[_c('path',{attrs:{"id":"auto_mode_2","d":"M22 22.7885L20.8346 20.1654L18.2115 19L20.8346 17.8096L22 15.2115L23.1904\n            17.8096L25.7885 19L23.1904 20.1654L22 22.7885ZM22 29C20.059 29 18.3042 28.501 16.7356\n            27.5029C15.167 26.5048 13.9218 25.0974 13\n            23.2808V27H12V21.6154H17.3654V22.6154H13.8C14.5731 24.2757 15.6875 25.5881 17.1433\n            26.5529C18.599 27.5176 20.218 28 22 28C23.9808 28 25.7599 27.4083 27.3375\n            26.225C28.9151 25.0417 29.9949 23.5032 30.5769 21.6096L31.5654 21.8096C30.9436 23.9609\n            29.7513 25.6971 27.9885 27.0183C26.2256 28.3394 24.2295 29 22 29ZM12.05 18C12.1795\n            16.9603 12.4141 16.0272 12.7539 15.201C13.0936 14.3747 13.5917 13.5346 14.2481\n            12.6808L14.9808 13.375C14.4474 14.0712 14.0333 14.7715 13.7385 15.476C13.4436 16.1805\n            13.216 17.0218 13.0558 18H12.05ZM16.3808 11.9942L15.6865 11.2615C16.4929 10.6308\n            17.3436 10.1317 18.2384 9.76443C19.1333 9.39711 20.0539 9.17179 21\n            9.08846V10.0885C20.1885 10.1718 19.3898 10.3769 18.6039 10.7039C17.818 11.0308 17.0769\n            11.4609 16.3808 11.9942ZM27.5865 11.9942C26.9801 11.4865 26.2574 11.0596 25.4183\n            10.7135C24.5792 10.3673 23.7731 10.159 23 10.0885V9.08846C23.95 9.17564 24.8734\n            9.40513 25.7702 9.77693C26.667 10.1487 27.5103 10.65 28.3 11.2808L27.5865\n            11.9942ZM30.9115 18C30.8025 17.0731 30.5846 16.2285 30.2577 15.4664C29.9307 14.7042\n            29.5006 14.0135 28.9673 13.3942L29.6808 12.6808C30.3243 13.4449 30.832 14.2753 31.2038\n            15.1721C31.5756 16.0689 31.8116 17.0115 31.9116 18H30.9115Z","fill":"#1C1B1F"}})])])])])}
var StreamlineIconvue_type_template_id_4f0f55b2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/StreamlineIcon.vue?vue&type=script&lang=ts&


var StreamlineIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let StreamlineIcon = class StreamlineIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

StreamlineIconvue_type_script_lang_ts_decorate([Prop({
  default: 34
})], StreamlineIcon.prototype, "width", void 0);

StreamlineIconvue_type_script_lang_ts_decorate([Prop({
  default: 31
})], StreamlineIcon.prototype, "height", void 0);

StreamlineIcon = StreamlineIconvue_type_script_lang_ts_decorate([vue_class_component_esm], StreamlineIcon);
/* harmony default export */ var StreamlineIconvue_type_script_lang_ts_ = (StreamlineIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/StreamlineIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_StreamlineIconvue_type_script_lang_ts_ = (StreamlineIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/StreamlineIcon.vue





/* normalize component */
;
var StreamlineIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_StreamlineIconvue_type_script_lang_ts_,
  StreamlineIconvue_type_template_id_4f0f55b2_render,
  StreamlineIconvue_type_template_id_4f0f55b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_StreamlineIcon = (StreamlineIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/EnterpriseIcon.vue?vue&type=template&id=7e75443a&
var EnterpriseIconvue_type_template_id_7e75443a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 30","fill":"none","width":_vm.width,"height":_vm.height}},[_c('ellipse',{attrs:{"cx":"15.1471","cy":"13.4746","rx":"12.4615","ry":"12.6562","fill":"#BFFDDD"}}),_c('path',{attrs:{"d":"M4.91454 12.9702H5.96182V15.2259H4.91454V12.9702ZM4.91454\n      16.5954H5.96182V18.851H4.91454V16.5954ZM8.53972\n      12.9702H9.58699V15.2259H8.53972V12.9702ZM8.53972\n      16.5954H9.58699V18.851H8.53972V16.5954ZM4.91454\n      20.2206H5.96182V22.4762H4.91454V20.2206ZM8.53972 20.2206H9.58699V22.4762H8.53972V20.2206Z","fill":"black","stroke":"white","stroke-width":"0.161119"}}),_c('path',{attrs:{"d":"M13.2123 15.3066V15.3872H13.2929H16.9181C17.2172 15.3872 17.5041 15.506 17.7156\n      15.7175C17.9271 15.929 18.0459 16.2159 18.0459 16.515V26.1016H1.28954V10.473C1.28954 10.1739\n      1.40837 9.88705 1.61988 9.67554C1.83139 9.46403 2.11826 9.34521 2.41738\n      9.34521H12.0845C12.3836 9.34521 12.6705 9.46403 12.882 9.67554C13.0935 9.88705 13.2123\n      10.1739 13.2123 10.473V15.3066ZM2.41738\n      10.3925H2.33682V10.473V24.9737V25.0543H2.41738H12.0845H12.1651V24.9737V10.473V10.3925H12.0845H2.41738ZM13.2123 24.9737V25.0543H13.2929H16.9181H16.9986V24.9737V16.515V16.4344H16.9181H13.2929H13.2123V16.515V24.9737Z","fill":"black","stroke":"white","stroke-width":"0.161119"}})])}
var EnterpriseIconvue_type_template_id_7e75443a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/EnterpriseIcon.vue?vue&type=script&lang=ts&


var EnterpriseIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let EnterpriseIcon = class EnterpriseIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

EnterpriseIconvue_type_script_lang_ts_decorate([Prop({
  default: 34
})], EnterpriseIcon.prototype, "width", void 0);

EnterpriseIconvue_type_script_lang_ts_decorate([Prop({
  default: 30
})], EnterpriseIcon.prototype, "height", void 0);

EnterpriseIcon = EnterpriseIconvue_type_script_lang_ts_decorate([vue_class_component_esm], EnterpriseIcon);
/* harmony default export */ var EnterpriseIconvue_type_script_lang_ts_ = (EnterpriseIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/EnterpriseIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_EnterpriseIconvue_type_script_lang_ts_ = (EnterpriseIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/EnterpriseIcon.vue





/* normalize component */
;
var EnterpriseIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_EnterpriseIconvue_type_script_lang_ts_,
  EnterpriseIconvue_type_template_id_7e75443a_render,
  EnterpriseIconvue_type_template_id_7e75443a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_EnterpriseIcon = (EnterpriseIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/StoreIcon.vue?vue&type=template&id=c9984ddc&
var StoreIconvue_type_template_id_c9984ddc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 28","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"solutions_icon"}},[_c('circle',{attrs:{"id":"Oval Copy","cx":"20","cy":"14.5","r":"13.5","fill":"#EDFFA4"}}),_c('g',{attrs:{"id":"ship"}},[_c('g',{attrs:{"id":"Shape"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.8457 0.332853L15.5789 2.5305C15.6698 2.56261 15.7285 2.65122 15.7231\n            2.74785V9.2442L20.2882 11.3694C20.379 11.4015 20.4378 11.4901 20.4323\n            11.5868V18.2522C20.4378 18.3488 20.379 18.4374 20.2882 18.4695L15.5549\n            20.6672H15.3387L10.7496 18.542L6.16043 20.6672H5.94419L1.21092 18.4695C1.12008 18.4374\n            1.0613 18.3488 1.06676 18.2522V11.5868C1.0613 11.4901 1.12008 11.4015 1.21092\n            11.3694L5.77601 9.2442V2.74785C5.77055 2.65122 5.82933 2.56261 5.92017 2.5305L10.6534\n            0.332853C10.7152 0.308605 10.7839 0.308605 10.8457 0.332853ZM10.1492 11.6109L5.99253\n            9.67891L1.88395 11.5868L6.04058 13.4946L10.1492 11.6109ZM10.5097\n            5.0904V11.2487L6.25696 9.26835V3.1101L10.5097 5.0904ZM15.2427 3.1101L10.9899\n            5.0904V11.2487L15.2427 9.26835V3.1101ZM6.28082 13.9293L10.5095 11.9732V18.1073L6.28082\n            20.0634V13.9293ZM15.2186 13.9293L10.9899 11.9732V18.1073L15.2186\n            20.0634V13.9293ZM15.4594 13.4946L11.3509 11.6109L15.5075 9.67891L19.6161\n            11.5868L15.4594 13.4946ZM14.9063 2.74785L10.7497 0.815854L6.59304 2.74785L10.7497\n            4.67985L14.9063 2.74785ZM1.54787 11.949L5.80061 13.9293V20.0634L1.54787\n            18.1073V11.949ZM15.699 13.9293V20.0634L19.9517 18.1073V11.949L15.699 13.9293Z","fill":"black"}}),_c('path',{attrs:{"d":"M15.5789 2.5305L15.5158 2.66655L15.5222 2.66955L15.5289 2.67193L15.5789\n          2.5305ZM10.8457 0.332853L10.9089 0.19655L10.9004 0.193217L10.8457 0.332853ZM15.7231\n          2.74785L15.5731 2.73939V2.74785H15.7231ZM15.7231 9.2442H15.5731V9.33983L15.6598\n          9.38019L15.7231 9.2442ZM20.2882 11.3694L20.2249 11.5054L20.2314 11.5084L20.2382\n          11.5108L20.2882 11.3694ZM20.4323 11.5868L20.2823 11.5783V11.5868H20.4323ZM20.4323\n          18.2522H20.2821L20.2826 18.2606L20.4323 18.2522ZM20.2882 18.4695L20.2382 18.3281L20.2315\n          18.3305L20.225 18.3335L20.2882 18.4695ZM15.5549 20.6672V20.8172H15.588L15.6181\n          20.8032L15.5549 20.6672ZM15.3387 20.6672L15.2756 20.8033L15.3056\n          20.8172H15.3387V20.6672ZM10.7496 18.542L10.8126 18.4058L10.7496 18.3766L10.6865\n          18.4058L10.7496 18.542ZM6.16043 20.6672V20.8172H6.19348L6.22347 20.8033L6.16043\n          20.6672ZM5.94419 20.6672L5.88103 20.8032L5.91107 20.8172H5.94419V20.6672ZM1.21092\n          18.4695L1.27408 18.3335L1.26762 18.3305L1.2609 18.3281L1.21092 18.4695ZM1.06676\n          18.2522L1.21676 18.2606V18.2522H1.06676ZM1.06676 11.5868H1.21699L1.21652 11.5783L1.06676\n          11.5868ZM1.21092 11.3694L1.2609 11.5108L1.26769 11.5084L1.27422 11.5054L1.21092\n          11.3694ZM5.77601 9.2442L5.83931 9.38019L5.92601 9.33983V9.2442H5.77601ZM5.77601\n          2.74785H5.92624L5.92577 2.7394L5.77601 2.74785ZM5.92017 2.5305L5.97015 2.67193L5.97687\n          2.66955L5.98333 2.66655L5.92017 2.5305ZM10.6534 0.332853L10.5986 0.192958L10.5903\n          0.196802L10.6534 0.332853ZM5.99253 9.67891L6.05575 9.54289L5.99256 9.51351L5.92935\n          9.54286L5.99253 9.67891ZM10.1492 11.6109L10.2117 11.7473L10.507 11.6118L10.2124\n          11.4749L10.1492 11.6109ZM1.88395 11.5868L1.82077 11.4507L1.52609 11.5876L1.82138\n          11.7231L1.88395 11.5868ZM6.04058 13.4946L5.97801 13.6309L6.04055 13.6596L6.1031\n          13.631L6.04058 13.4946ZM10.5097 11.2487L10.4464 11.3846L10.6597\n          11.484V11.2487H10.5097ZM10.5097 5.0904H10.6597V4.99479L10.573 4.95442L10.5097\n          5.0904ZM6.25696 9.26835H6.10696V9.36397L6.19364 9.40433L6.25696 9.26835ZM6.25696\n          3.1101L6.32028 2.97412L6.10696 2.87479V3.1101H6.25696ZM10.9899 5.0904L10.9266\n          4.95442L10.8399 4.99479V5.0904H10.9899ZM15.2427 3.1101H15.3927V2.87479L15.1793\n          2.97412L15.2427 3.1101ZM10.9899 11.2487H10.8399V11.484L11.0532 11.3846L10.9899\n          11.2487ZM15.2427 9.26835L15.306 9.40433L15.3927 9.36397V9.26835H15.2427ZM10.5095\n          11.9732H10.6595V11.7385L10.4466 11.837L10.5095 11.9732ZM6.28082 13.9293L6.21785\n          13.7932L6.13082 13.8334V13.9293H6.28082ZM10.5095 18.1073L10.5725 18.2434L10.6595\n          18.2031V18.1073H10.5095ZM6.28082 20.0634H6.13082V20.2981L6.3438 20.1995L6.28082\n          20.0634ZM10.9899 11.9732L11.0529 11.837L10.8399 11.7385V11.9732H10.9899ZM15.2186\n          13.9293H15.3686V13.8334L15.2816 13.7932L15.2186 13.9293ZM10.9899\n          18.1073H10.8399V18.2031L10.9269 18.2434L10.9899 18.1073ZM15.2186 20.0634L15.1557\n          20.1995L15.3686 20.2981V20.0634H15.2186ZM11.3509 11.6109L11.2876 11.4749L10.993\n          11.6118L11.2883 11.7473L11.3509 11.6109ZM15.4594 13.4946L15.3969 13.631L15.4595\n          13.6596L15.522 13.6309L15.4594 13.4946ZM15.5075 9.67891L15.5707\n          9.54286L15.5075 9.51351L15.4443 9.54289L15.5075 9.67891ZM19.6161 11.5868L19.6786\n          11.7231L19.9739 11.5876L19.6792 11.4507L19.6161 11.5868ZM10.7497 0.815854L10.8129\n          0.679829L10.7497 0.650442L10.6865 0.679829L10.7497 0.815854ZM14.9063 2.74785L14.9695\n          2.88388L15.2622 2.74785L14.9695 2.61183L14.9063 2.74785ZM6.59304 2.74785L6.52982\n          2.61183L6.23716 2.74785L6.52982 2.88388L6.59304 2.74785ZM10.7497 4.67985L10.6865\n          4.81588L10.7497 4.84526L10.8129 4.81588L10.7497 4.67985ZM5.80061\n          13.9293H5.95061V13.8337L5.86393 13.7933L5.80061 13.9293ZM1.54787 11.949L1.61119\n          11.813L1.39787 11.7137V11.949H1.54787ZM5.80061 20.0634L5.73793 20.1997L5.95061\n          20.2975V20.0634H5.80061ZM1.54787 18.1073H1.39787V18.2034L1.48519 18.2435L1.54787\n          18.1073ZM15.699 20.0634H15.549V20.2975L15.7617 20.1997L15.699 20.0634ZM15.699\n          13.9293L15.6357 13.7933L15.549 13.8337V13.9293H15.699ZM19.9517 18.1073L20.0144\n          18.2435L20.1017 18.2034V18.1073H19.9517ZM19.9517 11.949H20.1017V11.7137L19.8884\n          11.813L19.9517 11.949ZM15.6421 2.39445L10.9088 0.196802L10.7825 0.468904L15.5158\n          2.66655L15.6421 2.39445ZM15.8729 2.7563C15.882 2.59351 15.783 2.44355 15.6289\n          2.38908L15.5289 2.67193C15.5565 2.68167 15.5751 2.70893 15.5733 2.7394L15.8729\n          2.7563ZM15.8731 9.2442V2.74785H15.5731V9.2442H15.8731ZM20.3515 11.2334L15.7864\n          9.10822L15.6598 9.38019L20.2249 11.5054L20.3515 11.2334ZM20.5821 11.5952C20.5913 11.4324\n          20.4923 11.2824 20.3382 11.228L20.2382 11.5108C20.2658 11.5206 20.2843 11.5478 20.2826\n          11.5783L20.5821 11.5952ZM20.5823 18.2522V11.5868H20.2823V18.2522H20.5823ZM20.3382\n          18.6109C20.4923 18.5565 20.5913 18.4065 20.5821 18.2437L20.2826 18.2606C20.2843 18.2911\n          20.2658 18.3183 20.2382 18.3281L20.3382 18.6109ZM15.6181 20.8032L20.3514 18.6056L20.225\n          18.3335L15.4917 20.5311L15.6181 20.8032ZM15.3387\n          20.8172H15.5549V20.5172H15.3387V20.8172ZM10.6865 18.6781L15.2756 20.8033L15.4017\n          20.531L10.8126 18.4058L10.6865 18.6781ZM6.22347 20.8033L10.8126 18.6781L10.6865\n          18.4058L6.0974 20.531L6.22347 20.8033ZM5.94419\n          20.8172H6.16043V20.5172H5.94419V20.8172ZM1.14775 18.6056L5.88103 20.8032L6.00736\n          20.5311L1.27408 18.3335L1.14775 18.6056ZM0.916994 18.2437C0.907808 18.4065 1.00681\n          18.5565 1.16093 18.6109L1.2609 18.3281C1.23334 18.3183 1.2148 18.2911 1.21652\n          18.2606L0.916994 18.2437ZM0.916756 11.5868V18.2522H1.21676V11.5868H0.916756ZM1.16093\n          11.228C1.00681 11.2824 0.907808 11.4324 0.916994 11.5952L1.21652 11.5783C1.2148 11.5478\n          1.23334 11.5206 1.2609 11.5108L1.16093 11.228ZM5.7127 9.10822L1.14761 11.2334L1.27422\n          11.5054L5.83931 9.38019L5.7127 9.10822ZM5.62601\n          2.74785V9.2442H5.92601V2.74785H5.62601ZM5.87018 2.38908C5.71606 2.44355 5.61706 2.59351\n          5.62624 2.7563L5.92577 2.7394C5.92405 2.70893 5.94259 2.68167 5.97015 2.67193L5.87018\n          2.38908ZM10.5903 0.196802L5.857 2.39445L5.98333 2.66655L10.7166 0.468904L10.5903\n          0.196802ZM10.9004 0.193217C10.8034 0.15515 10.6957 0.15515 10.5987 0.193217L10.7082\n          0.472489C10.7348 0.462059 10.7643 0.462059 10.7909 0.472489L10.9004 0.193217ZM5.92931\n          9.81493L10.0859 11.7469L10.2124 11.4749L6.05575 9.54289L5.92931 9.81493ZM1.94712\n          11.7228L6.0557 9.81496L5.92935 9.54286L1.82077 11.4507L1.94712 11.7228ZM6.10315\n          13.3583L1.94652 11.4504L1.82138 11.7231L5.97801 13.6309L6.10315 13.3583ZM10.0866\n          11.4746L5.97807 13.3583L6.1031 13.631L10.2117 11.7473L10.0866 11.4746ZM10.6597\n          11.2487V5.0904H10.3597V11.2487H10.6597ZM6.19364 9.40433L10.4464 11.3846L10.573\n          11.1127L6.32028 9.13237L6.19364 9.40433ZM6.10696\n          3.1101V9.26835H6.40696V3.1101H6.10696ZM10.573 4.95442L6.32028 2.97412L6.19364\n          3.24608L10.4464 5.22638L10.573 4.95442ZM11.0532 5.22638L15.306 3.24608L15.1793\n          2.97412L10.9266 4.95442L11.0532 5.22638ZM11.1399\n          11.2487V5.0904H10.8399V11.2487H11.1399ZM15.1793 9.13237L10.9266 11.1127L11.0532\n          11.3846L15.306 9.40433L15.1793 9.13237ZM15.0927\n          3.1101V9.26835H15.3927V3.1101H15.0927ZM10.4466 11.837L6.21785 13.7932L6.3438\n          14.0654L10.5725 12.1093L10.4466 11.837ZM10.6595\n          18.1073V11.9732H10.3595V18.1073H10.6595ZM6.3438 20.1995L10.5725 18.2434L10.4466\n          17.9711L6.21785 19.9273L6.3438 20.1995ZM6.13082\n          13.9293V20.0634H6.43082V13.9293H6.13082ZM10.9269 12.1093L15.1557 14.0654L15.2816\n          13.7932L11.0529 11.837L10.9269 12.1093ZM11.1399\n          18.1073V11.9732H10.8399V18.1073H11.1399ZM15.2816 19.9273L11.0529 17.9711L10.9269\n          18.2434L15.1557 20.1995L15.2816 19.9273ZM15.0686\n          13.9293V20.0634H15.3686V13.9293H15.0686ZM11.2883 11.7473L15.3969 13.631L15.5219\n          13.3583L11.4134 11.4746L11.2883 11.7473ZM15.4443 9.54289L11.2876 11.4749L11.4141\n          11.7469L15.5707 9.81493L15.4443 9.54289ZM19.6792 11.4507L15.5707 9.54286L15.4443\n          9.81496L19.5529 11.7228L19.6792 11.4507ZM15.522 13.6309L19.6786 11.7231L19.5535\n          11.4504L15.3969 13.3583L15.522 13.6309ZM10.6865 0.951878L14.8431 2.88388L14.9695\n          2.61183L10.8129 0.679829L10.6865 0.951878ZM6.65626 2.88388L10.8129 0.951878L10.6865\n          0.679829L6.52982 2.61183L6.65626 2.88388ZM10.8129 4.54383L6.65626 2.61183L6.52982\n          2.88388L10.6865 4.81588L10.8129 4.54383ZM14.8431 2.61183L10.6865 4.54383L10.8129\n          4.81588L14.9695 2.88388L14.8431 2.61183ZM5.86393 13.7933L1.61119 11.813L1.48455\n          12.085L5.73729 14.0653L5.86393 13.7933ZM5.95061\n          20.0634V13.9293H5.65061V20.0634H5.95061ZM1.48519 18.2435L5.73793 20.1997L5.86329\n          19.9271L1.61055 17.971L1.48519 18.2435ZM1.39787\n          11.949V18.1073H1.69787V11.949H1.39787ZM15.849\n          20.0634V13.9293H15.549V20.0634H15.849ZM19.8891 17.971L15.6363 19.9271L15.7617\n          20.1997L20.0144 18.2435L19.8891 17.971ZM19.8017\n          11.949V18.1073H20.1017V11.949H19.8017ZM15.7623 14.0653L20.0151 12.085L19.8884\n          11.813L15.6357 13.7933L15.7623 14.0653Z","fill":"black"}})])])])])}
var StoreIconvue_type_template_id_c9984ddc_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/StoreIcon.vue?vue&type=script&lang=ts&


var StoreIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SToreIcon = class SToreIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

StoreIconvue_type_script_lang_ts_decorate([Prop({
  default: 34
})], SToreIcon.prototype, "width", void 0);

StoreIconvue_type_script_lang_ts_decorate([Prop({
  default: 28
})], SToreIcon.prototype, "height", void 0);

SToreIcon = StoreIconvue_type_script_lang_ts_decorate([vue_class_component_esm], SToreIcon);
/* harmony default export */ var StoreIconvue_type_script_lang_ts_ = (SToreIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/StoreIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_StoreIconvue_type_script_lang_ts_ = (StoreIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/StoreIcon.vue





/* normalize component */
;
var StoreIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_StoreIconvue_type_script_lang_ts_,
  StoreIconvue_type_template_id_c9984ddc_render,
  StoreIconvue_type_template_id_c9984ddc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StoreIcon = (StoreIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/SecureDataIcon.vue?vue&type=template&id=674817a8&
var SecureDataIconvue_type_template_id_674817a8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 35 29","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":"solutions_icon"}},[_c('ellipse',{attrs:{"id":"Oval Copy","cx":"19.2495","cy":"12.1273","rx":"12.2495","ry":"12.1273","fill":"#AFFFBC"}}),_c('path',{attrs:{"id":"Vector","d":"M28.905 14.9486L28.9045 14.9491L24.4424 19.9272L24.3681 20.0101L24.2921 19.9286L21.4098\n        16.838L21.4093 16.8376C21.3577 16.7815 21.2947 16.7359 21.2241 16.7036C21.1535 16.6713\n        21.0768 16.653 20.9986 16.65C20.9203 16.6469 20.8423 16.6592 20.7692 16.6859C20.6961\n        16.7127 20.6295 16.7533 20.5733 16.8052C20.4572 16.9128 20.3895 17.0593 20.3834\n        17.2134C20.3773 17.3675 20.4334 17.5184 20.5406 17.6341C20.5406 17.6341 20.5406 17.6341\n        20.5406 17.6341L23.9417 21.2805L23.9423 21.281C23.9972 21.3409 24.0649 21.3888 24.1409\n        21.4215C24.217 21.4541 24.2995 21.4706 24.3829 21.4698C24.4663 21.469 24.5485 21.4509\n        24.6239 21.4168C24.6992 21.3827 24.7659 21.3334 24.8195 21.2726L24.8201 21.2719L29.7897\n        15.728C29.7897 15.728 29.7897 15.728 29.7897 15.728C29.8946 15.6105 29.9477 15.4587\n        29.9387 15.3047C29.9297 15.1508 29.8592 15.0056 29.7411 14.9001L28.905 14.9486ZM28.905\n        14.9486C28.9555 14.8914 29.0175 14.8444 29.0875 14.8107C29.1575 14.777 29.2339 14.7572\n        29.3121 14.7526C29.3904 14.7481 29.4688 14.7588 29.5425 14.7842C29.6162 14.8096 29.6837\n        14.8491 29.741 14.9L28.905 14.9486ZM17.8546 12.1026L17.7846\n        12.1256V12.1993V19.6468C17.7846 23.7582 21.1445 27.089 25.2867 27.089C29.429 27.089\n        32.7888 23.7582 32.7888 19.6468V12.2033V12.1294L32.7185 12.1065L25.2738 9.6791L25.2421\n        9.66875L25.2104 9.67919L17.8546 12.1026ZM25.2404 8.43441L33.9726 11.2804V19.6468C33.9726\n        24.4035 30.0841 28.2618 25.2867 28.2618C20.4893 28.2618 16.6008 24.4035 16.6008\n        19.6468V11.2802L25.2404 8.43441Z","fill":"black","stroke":"white","stroke-width":"0.203636"}})])])}
var SecureDataIconvue_type_template_id_674817a8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/whatWeOffer/SecureDataIcon.vue?vue&type=script&lang=ts&


var SecureDataIconvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SecureDataIcon = class SecureDataIcon extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

SecureDataIconvue_type_script_lang_ts_decorate([Prop({
  default: 35
})], SecureDataIcon.prototype, "width", void 0);

SecureDataIconvue_type_script_lang_ts_decorate([Prop({
  default: 29
})], SecureDataIcon.prototype, "height", void 0);

SecureDataIcon = SecureDataIconvue_type_script_lang_ts_decorate([vue_class_component_esm], SecureDataIcon);
/* harmony default export */ var SecureDataIconvue_type_script_lang_ts_ = (SecureDataIcon);
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/SecureDataIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var whatWeOffer_SecureDataIconvue_type_script_lang_ts_ = (SecureDataIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/whatWeOffer/SecureDataIcon.vue





/* normalize component */
;
var SecureDataIcon_component = componentNormalizer_normalizeComponent(
  whatWeOffer_SecureDataIconvue_type_script_lang_ts_,
  SecureDataIconvue_type_template_id_674817a8_render,
  SecureDataIconvue_type_template_id_674817a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var whatWeOffer_SecureDataIcon = (SecureDataIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue?vue&type=script&lang=ts&
var TheMobileNavigationWhatWeOffervue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




 // icons







let TheMobileNavigationWhatWeOffer = class TheMobileNavigationWhatWeOffer extends mixins(whatWeOffer) {};
TheMobileNavigationWhatWeOffer = TheMobileNavigationWhatWeOffervue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    WhatWeOfferItem: desktopMenus_WhatWeOfferItem,
    LatestArticle: desktopMenus_LatestArticle,
    EnterpriseIcon: whatWeOffer_EnterpriseIcon,
    StreamlineIcon: whatWeOffer_StreamlineIcon,
    SecureDataIcon: whatWeOffer_SecureDataIcon,
    EngageIcon: whatWeOffer_EngageIcon,
    ShopIcon: whatWeOffer_ShopIcon,
    StoreIcon: StoreIcon
  }
})], TheMobileNavigationWhatWeOffer);
/* harmony default export */ var TheMobileNavigationWhatWeOffervue_type_script_lang_ts_ = (TheMobileNavigationWhatWeOffer);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationWhatWeOffervue_type_script_lang_ts_ = (TheMobileNavigationWhatWeOffervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue?vue&type=style&index=0&id=868973cc&lang=scss&scoped=true&
var TheMobileNavigationWhatWeOffervue_type_style_index_0_id_868973cc_lang_scss_scoped_true_ = __webpack_require__(3997);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue?vue&type=style&index=0&id=868973cc&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationWhatWeOffer.vue



;


/* normalize component */

var TheMobileNavigationWhatWeOffer_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationWhatWeOffervue_type_script_lang_ts_,
  TheMobileNavigationWhatWeOffervue_type_template_id_868973cc_scoped_true_render,
  TheMobileNavigationWhatWeOffervue_type_template_id_868973cc_scoped_true_staticRenderFns,
  false,
  null,
  "868973cc",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationWhatWeOffer = (TheMobileNavigationWhatWeOffer_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue?vue&type=template&id=45b34240&scoped=true&
var TheMobileNavigationShopProductsvue_type_template_id_45b34240_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-shop-products"},_vm._l((_vm.shopProductsMenus),function(category,index){return _c('the-mobile-navigation-shop-products-item',{key:index,attrs:{"category":category}})}),1)}
var TheMobileNavigationShopProductsvue_type_template_id_45b34240_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/menusData/shopProducts.ts
var shopProducts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ShopProducts = class ShopProducts extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get shopProductsMenus() {
    return this.$store.state.header.shopProductsNavigation;
  }

};
ShopProducts = shopProducts_decorate([vue_class_component_esm], ShopProducts);
/* harmony default export */ var shopProducts = (ShopProducts);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue?vue&type=template&id=552ac44e&scoped=true&
var TheMobileNavigationShopProductsItemvue_type_template_id_552ac44e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-mobile-navigation-shop-products-item"},[(_vm.hasSubCategories)?_c('div',{staticClass:"header-mobile-navigation-shop-products-item__main",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.showSubCategories = !_vm.showSubCategories},"keypress":function($event){_vm.showSubCategories = !_vm.showSubCategories}}},[_vm._v(" "+_vm._s(_vm.category.title)+" ")]):_c('a',{staticClass:"header-mobile-navigation-shop-products-item__main",attrs:{"tabindex":"0","href":_vm.category.path},on:{"click":function($event){return _vm.onMainCategoryClick(_vm.category.title)}}},[_vm._v(" "+_vm._s(_vm.category.title)+" ")]),_c('expand-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSubCategories),expression:"showSubCategories"}]},_vm._l((_vm.subCategories),function(subCategory,index){return _c('li',{key:index},[_c('a',{attrs:{"href":subCategory.path},on:{"click":function($event){return _vm.onSubCategoryClick(_vm.category.title, subCategory.title)}}},[_vm._v(" "+_vm._s(subCategory.title)+" ")])])}),0)])],1)}
var TheMobileNavigationShopProductsItemvue_type_template_id_552ac44e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/ExpandTransition.vue?vue&type=template&id=e79dfc6c&scoped=true&
var ExpandTransitionvue_type_template_id_e79dfc6c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var ExpandTransitionvue_type_template_id_e79dfc6c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/ExpandTransition.vue?vue&type=script&lang=ts&
/* eslint-disable class-methods-use-this */
var ExpandTransitionvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ExpandTransition = class ExpandTransition extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  enter(element) {
    const {
      width
    } = getComputedStyle(element);
    element.style.width = width;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.height = 'auto';
    const {
      height
    } = getComputedStyle(element);
    element.style.width = '';
    element.style.position = '';
    element.style.visibility = '';
    element.style.height = '0';
    const {
      height: _height
    } = getComputedStyle(element);
    requestAnimationFrame(() => {
      element.style.height = height;
    });
  }

  afterEnter(element) {
    element.style.height = 'auto';
  }

  leave(element) {
    const {
      height
    } = getComputedStyle(element);
    element.style.height = height;
    const {
      height: _height
    } = getComputedStyle(element);
    requestAnimationFrame(() => {
      element.style.height = '0';
    });
  }

};
ExpandTransition = ExpandTransitionvue_type_script_lang_ts_decorate([vue_class_component_esm], ExpandTransition);
/* harmony default export */ var ExpandTransitionvue_type_script_lang_ts_ = (ExpandTransition);
;// CONCATENATED MODULE: ./src/components/transitions/ExpandTransition.vue?vue&type=script&lang=ts&
 /* harmony default export */ var transitions_ExpandTransitionvue_type_script_lang_ts_ = (ExpandTransitionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/transitions/ExpandTransition.vue?vue&type=style&index=0&id=e79dfc6c&lang=scss&scoped=true&
var ExpandTransitionvue_type_style_index_0_id_e79dfc6c_lang_scss_scoped_true_ = __webpack_require__(176);
;// CONCATENATED MODULE: ./src/components/transitions/ExpandTransition.vue?vue&type=style&index=0&id=e79dfc6c&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/transitions/ExpandTransition.vue



;


/* normalize component */

var ExpandTransition_component = componentNormalizer_normalizeComponent(
  transitions_ExpandTransitionvue_type_script_lang_ts_,
  ExpandTransitionvue_type_template_id_e79dfc6c_scoped_true_render,
  ExpandTransitionvue_type_template_id_e79dfc6c_scoped_true_staticRenderFns,
  false,
  null,
  "e79dfc6c",
  null
  
)

/* harmony default export */ var transitions_ExpandTransition = (ExpandTransition_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue?vue&type=script&lang=ts&


var TheMobileNavigationShopProductsItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TheMobileNavigationShopProductsItem = class TheMobileNavigationShopProductsItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "category", void 0);

    _defineProperty(this, "showSubCategories", false);
  }

  get subCategories() {
    const {
      children
    } = this.category;
    return children.filter(child => child.title.toLowerCase() !== 'hover_image') ?? [];
  }

  get hasSubCategories() {
    return !!this.subCategories?.length;
  }

  onMainCategoryClick(title) {
    navigationClick({
      itemCategory: 'shop products',
      itemSubCategory: title,
      item: title
    });
  }

  onSubCategoryClick(mainCategory, subCategory) {
    navigationClick({
      itemCategory: 'shop products',
      itemSubCategory: mainCategory,
      item: subCategory
    });
  }

};

TheMobileNavigationShopProductsItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheMobileNavigationShopProductsItem.prototype, "category", void 0);

TheMobileNavigationShopProductsItem = TheMobileNavigationShopProductsItemvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    ExpandTransition: transitions_ExpandTransition
  }
})], TheMobileNavigationShopProductsItem);
/* harmony default export */ var TheMobileNavigationShopProductsItemvue_type_script_lang_ts_ = (TheMobileNavigationShopProductsItem);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationShopProductsItemvue_type_script_lang_ts_ = (TheMobileNavigationShopProductsItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue?vue&type=style&index=0&id=552ac44e&lang=scss&scoped=true&
var TheMobileNavigationShopProductsItemvue_type_style_index_0_id_552ac44e_lang_scss_scoped_true_ = __webpack_require__(5038);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue?vue&type=style&index=0&id=552ac44e&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProductsItem.vue



;


/* normalize component */

var TheMobileNavigationShopProductsItem_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationShopProductsItemvue_type_script_lang_ts_,
  TheMobileNavigationShopProductsItemvue_type_template_id_552ac44e_scoped_true_render,
  TheMobileNavigationShopProductsItemvue_type_template_id_552ac44e_scoped_true_staticRenderFns,
  false,
  null,
  "552ac44e",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationShopProductsItem = (TheMobileNavigationShopProductsItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue?vue&type=script&lang=ts&
var TheMobileNavigationShopProductsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TheMobileNavigationShopProducts = class TheMobileNavigationShopProducts extends mixins(shopProducts) {};
TheMobileNavigationShopProducts = TheMobileNavigationShopProductsvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheMobileNavigationShopProductsItem: mobileNavigation_TheMobileNavigationShopProductsItem
  }
})], TheMobileNavigationShopProducts);
/* harmony default export */ var TheMobileNavigationShopProductsvue_type_script_lang_ts_ = (TheMobileNavigationShopProducts);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationShopProductsvue_type_script_lang_ts_ = (TheMobileNavigationShopProductsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue?vue&type=style&index=0&id=45b34240&lang=scss&scoped=true&
var TheMobileNavigationShopProductsvue_type_style_index_0_id_45b34240_lang_scss_scoped_true_ = __webpack_require__(6237);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue?vue&type=style&index=0&id=45b34240&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationShopProducts.vue



;


/* normalize component */

var TheMobileNavigationShopProducts_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationShopProductsvue_type_script_lang_ts_,
  TheMobileNavigationShopProductsvue_type_template_id_45b34240_scoped_true_render,
  TheMobileNavigationShopProductsvue_type_template_id_45b34240_scoped_true_staticRenderFns,
  false,
  null,
  "45b34240",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationShopProducts = (TheMobileNavigationShopProducts_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue?vue&type=template&id=3c72815b&scoped=true&
var TheMobileNavigationUserCompanyMenuvue_type_template_id_3c72815b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.userCompanyMenu),function(companyMenu,index){return _c('li',{key:index},[_c('a',{attrs:{"href":companyMenu.url}},[_vm._v(" "+_vm._s(companyMenu.title)+" ")])])}),0)}
var TheMobileNavigationUserCompanyMenuvue_type_template_id_3c72815b_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/menusData/userCompanyMenu.ts
var userCompanyMenu_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UserCompanyMenu = class UserCompanyMenu extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get userCompanyMenu() {
    return this.$store.state.header.headerData?.links || [];
  }

};
UserCompanyMenu = userCompanyMenu_decorate([vue_class_component_esm], UserCompanyMenu);
/* harmony default export */ var userCompanyMenu = (UserCompanyMenu);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue?vue&type=script&lang=ts&
var TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheMobileNavigationUserCompanyMenu = class TheMobileNavigationUserCompanyMenu extends mixins(userCompanyMenu) {};
TheMobileNavigationUserCompanyMenu = TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_decorate([vue_class_component_esm], TheMobileNavigationUserCompanyMenu);
/* harmony default export */ var TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_ = (TheMobileNavigationUserCompanyMenu);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var mobileNavigation_TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_ = (TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue?vue&type=style&index=0&id=3c72815b&lang=scss&scoped=true&
var TheMobileNavigationUserCompanyMenuvue_type_style_index_0_id_3c72815b_lang_scss_scoped_true_ = __webpack_require__(1051);
;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue?vue&type=style&index=0&id=3c72815b&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/mobileNavigation/TheMobileNavigationUserCompanyMenu.vue



;


/* normalize component */

var TheMobileNavigationUserCompanyMenu_component = componentNormalizer_normalizeComponent(
  mobileNavigation_TheMobileNavigationUserCompanyMenuvue_type_script_lang_ts_,
  TheMobileNavigationUserCompanyMenuvue_type_template_id_3c72815b_scoped_true_render,
  TheMobileNavigationUserCompanyMenuvue_type_template_id_3c72815b_scoped_true_staticRenderFns,
  false,
  null,
  "3c72815b",
  null
  
)

/* harmony default export */ var mobileNavigation_TheMobileNavigationUserCompanyMenu = (TheMobileNavigationUserCompanyMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationPanel.vue?vue&type=script&lang=ts&


var TheHeaderMobileNavigationPanelvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














let TheHeaderMobileNavigationPanel = class TheHeaderMobileNavigationPanel extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "value", void 0);

    _defineProperty(this, "componentData", void 0);
  }

  get show() {
    return this.value;
  }

  set show(val) {
    this.$emit('input', val);
  }

  onChildChanged(val) {
    if (val) {
      const ele = this.$el.querySelector('.panel__content');
      setTimeout(() => {
        ele?.scroll({
          top: 0,
          left: 0
        });
      }, 0);
    }
  }

};

TheHeaderMobileNavigationPanelvue_type_script_lang_ts_decorate([Prop({
  required: true,
  type: Boolean
})], TheHeaderMobileNavigationPanel.prototype, "value", void 0);

TheHeaderMobileNavigationPanelvue_type_script_lang_ts_decorate([Prop({
  required: false,
  type: Object,
  default: null
})], TheHeaderMobileNavigationPanel.prototype, "componentData", void 0);

TheHeaderMobileNavigationPanelvue_type_script_lang_ts_decorate([Watch('componentData')], TheHeaderMobileNavigationPanel.prototype, "onChildChanged", null);

TheHeaderMobileNavigationPanel = TheHeaderMobileNavigationPanelvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    UserIcon: icons_User,
    UserMenu: components_UserMenu,
    HelpIcon: Help,
    DialogRightTransition: transitions_DialogRightTransition,
    TheMobileNavigationHelp: mobileNavigation_TheMobileNavigationHelp,
    TheMobileNavigationShopBy: mobileNavigation_TheMobileNavigationShopBy,
    TheMobileNavigationLetThem: TheMobileNavigationLetThem,
    TheMobileNavigationResources: mobileNavigation_TheMobileNavigationResources,
    TheMobileNavigationWhatWeOffer: mobileNavigation_TheMobileNavigationWhatWeOffer,
    TheHeaderMobileNavigationButton: components_TheHeaderMobileNavigationButton,
    TheMobileNavigationShopProducts: mobileNavigation_TheMobileNavigationShopProducts,
    TheMobileNavigationUserCompanyMenu: mobileNavigation_TheMobileNavigationUserCompanyMenu
  }
})], TheHeaderMobileNavigationPanel);
/* harmony default export */ var TheHeaderMobileNavigationPanelvue_type_script_lang_ts_ = (TheHeaderMobileNavigationPanel);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationPanel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderMobileNavigationPanelvue_type_script_lang_ts_ = (TheHeaderMobileNavigationPanelvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMobileNavigationPanel.vue?vue&type=style&index=0&id=285936be&lang=scss&scoped=true&
var TheHeaderMobileNavigationPanelvue_type_style_index_0_id_285936be_lang_scss_scoped_true_ = __webpack_require__(1317);
;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationPanel.vue?vue&type=style&index=0&id=285936be&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderMobileNavigationPanel.vue



;


/* normalize component */

var TheHeaderMobileNavigationPanel_component = componentNormalizer_normalizeComponent(
  components_TheHeaderMobileNavigationPanelvue_type_script_lang_ts_,
  TheHeaderMobileNavigationPanelvue_type_template_id_285936be_scoped_true_render,
  TheHeaderMobileNavigationPanelvue_type_template_id_285936be_scoped_true_staticRenderFns,
  false,
  null,
  "285936be",
  null
  
)

/* harmony default export */ var components_TheHeaderMobileNavigationPanel = (TheHeaderMobileNavigationPanel_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaLogos.vue?vue&type=template&id=26a9ad10&scoped=true&
var TheHeaderUserAreaLogosvue_type_template_id_26a9ad10_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-user-area__logos"},[(_vm.hasExternalDomain)?[_c('a',{attrs:{"href":"/","aria-label":"Homepage"}},[_c('img',{staticClass:"logos__external-logo",attrs:{"src":_vm.domainLogo,"alt":""}})])]:[(!_vm.hideCgEliteLogo)?_c('a',{attrs:{"href":"https://corporategift.com/"}},[(_vm.userUsingPhone)?_c('cg-elite',{attrs:{"aria-label":"CG Elite Sygnet"}}):(_vm.isElite)?_c('cg-elite-logo',{attrs:{"aria-label":"CG Elite logo"}}):_c('corporate-gift-logo',{attrs:{"aria-label":"Corporategift logo"}})],1):_vm._e(),(_vm.userCompanyLogo && _vm.isElite && !_vm.userUsingPhone && !_vm.hideCgEliteLogo)?_c('div',{staticClass:"logos__divider"}):_vm._e(),((_vm.userCompanyLogo && _vm.isElite) && (!_vm.userUsingPhone || _vm.hideCgEliteLogo))?_c('img',{staticClass:"logos__logo",attrs:{"src":_vm.userCompanyLogo,"alt":"Client logo"}}):_vm._e()]],2)}
var TheHeaderUserAreaLogosvue_type_template_id_26a9ad10_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CgElite.vue?vue&type=template&id=095c72a2&
var CgElitevue_type_template_id_095c72a2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 42","fill":"none","height":_vm.height,"width":_vm.width}},[_c('path',{attrs:{"d":"M0.611084 21C0.611084 9.40202 10.0131 0 21.6111 0V0C33.2091 0 42.6111 9.40202 42.6111\n      21V21C42.6111 32.598 33.2091 42 21.6111 42V42C10.0131 42 0.611084 32.598 0.611084 21V21Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.4537 27.529H27.7636V15.3944H15.4537V27.529ZM28.6168 29.1632H14.6506C14.1982 29.1632\n      13.8462 28.8162 13.8462 28.3708V14.6014C13.8462 14.156 14.1982 13.809 14.6506\n      13.809H28.5667C29.0197 13.809 29.3711 14.156 29.3711 14.6014V28.3214C29.4213 28.7667\n      29.0699 29.1632 28.6168 29.1632V29.1632Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.6847 28.9653C21.2317 28.9653 20.8796 28.6176 20.8796 28.1723V14.9484C20.8796 14.5024\n      21.2317 14.1561 21.6847 14.1561C22.1365 14.1561 22.4878 14.5024 22.4878\n      14.9484V28.1723C22.4878 28.5688 22.1365 28.9653 21.6847 28.9653","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.5668 19.3066H14.9512C14.4995 19.3066 14.1475 18.9602 14.1475 18.5142C14.1475 18.0682\n      14.4995 17.7225 14.9512 17.7225H28.5668C29.0199 17.7225 29.3712 18.0682 29.3712\n      18.5142C29.3712 18.9602 29.0199 19.3066 28.5668 19.3066","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.8847 15.3442C21.6846 15.3442 21.5334 15.2947 21.3828 15.1463L17.514 12.0257C17.1619\n      11.7288 17.1117 11.2334 17.4136 10.887C17.7147 10.5393 18.2173 10.4905 18.5687\n      10.7881L22.4375 13.908C22.7895 14.2055 22.8397 14.7003 22.5379 15.048C22.3866 15.2453\n      22.1364 15.3442 21.8847 15.3442","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.4331 15.3442C21.1814 15.3442 20.9807 15.2453 20.8301 15.048C20.5283 14.7003 20.5784\n      14.2055 20.9305 13.908L24.7993 10.7881C25.15 10.4905 25.6539 10.5393 25.9544 10.887C26.2562\n      11.2334 26.206 11.7288 25.854 12.0257L21.935 15.1463C21.7844 15.2947 21.6345 15.3442\n      21.4331 15.3442","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.6345 15.245C21.1814 15.245 20.8301 14.8986 20.8301 14.4526V9.8958C20.8301 9.45048\n      21.1814 9.10345 21.6345 9.10345C22.0862 9.10345 22.4376 9.45048 22.4376\n      9.8958V14.4526C22.4376 14.8491 22.0862 15.245 21.6345 15.245","fill":"white"}})])}
var CgElitevue_type_template_id_095c72a2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CgElite.vue?vue&type=script&lang=ts&


var CgElitevue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CgElite = class CgElite extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

CgElitevue_type_script_lang_ts_decorate([Prop({
  default: 42
})], CgElite.prototype, "width", void 0);

CgElitevue_type_script_lang_ts_decorate([Prop({
  default: 42
})], CgElite.prototype, "height", void 0);

CgElite = CgElitevue_type_script_lang_ts_decorate([vue_class_component_esm], CgElite);
/* harmony default export */ var CgElitevue_type_script_lang_ts_ = (CgElite);
;// CONCATENATED MODULE: ./src/components/icons/CgElite.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CgElitevue_type_script_lang_ts_ = (CgElitevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/CgElite.vue





/* normalize component */
;
var CgElite_component = componentNormalizer_normalizeComponent(
  icons_CgElitevue_type_script_lang_ts_,
  CgElitevue_type_template_id_095c72a2_render,
  CgElitevue_type_template_id_095c72a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_CgElite = (CgElite_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CgEliteLogo.vue?vue&type=template&id=001c4056&
var CgEliteLogovue_type_template_id_001c4056_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 129 37","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M98.9915 27.7467C99.2121 27.7467 99.3945 27.6749 99.5387 27.5313C99.683 27.3878 99.7551\n      27.2062 99.7551 26.9867V9.76C99.7551 9.54044 99.683 9.35889 99.5387 9.21533C99.3945 9.07178\n      99.2121 9 98.9915 9C98.7709 9 98.5885 9.07178 98.4443 9.21533C98.3001 9.35889 98.2279 9.54044\n      98.2279 9.76V26.9867C98.2279 27.2062 98.3001 27.3878 98.4443 27.5313C98.5885 27.6749 98.7709\n      27.7467 98.9915 27.7467ZM94.1046 27.7467C94.3252 27.7467 94.5076 27.6791 94.6519\n      27.544C94.7961 27.4089 94.8682 27.2316 94.8682 27.012C94.8682 26.8093 94.7961 26.632 94.6519\n      26.48C94.5076 26.328 94.3252 26.252 94.1046 26.252H85.6035V19.3613H92.9593C93.1799 19.3613\n      93.3623 19.2938 93.5065 19.1587C93.6507 19.0236 93.7229 18.8462 93.7229 18.6267C93.7229\n      18.4071 93.6507 18.2256 93.5065 18.082C93.3623 17.9384 93.1799 17.8667 92.9593\n      17.8667H85.6035V11.508H94.1046C94.3252 11.508 94.5076 11.4404 94.6519 11.3053C94.7961 11.1702\n      94.8682 10.9929 94.8682 10.7733C94.8682 10.5538 94.7961 10.3722 94.6519 10.2287C94.5076\n      10.0851 94.3252 10.0133 94.1046 10.0133H84.7636C84.543 10.0133 84.3606 10.0851 84.2163\n      10.2287C84.0721 10.3722 84 10.5538 84 10.7733V26.9867C84 27.2062 84.0721 27.3878 84.2163\n      27.5313C84.3606 27.6749 84.543 27.7467 84.7636 27.7467H94.1046ZM105.418 12.6353C105.24\n      12.7958 104.981 12.876 104.642 12.876C104.303 12.876 104.04 12.7958 103.853 12.6353C103.666\n      12.4749 103.573 12.2427 103.573 11.9387V11.6853C103.573 11.3813 103.671 11.1491 103.866\n      10.9887C104.061 10.8282 104.328 10.748 104.667 10.748C105.346 10.748 105.686 11.0604\n      105.686 11.6853V11.9387C105.686 12.2427 105.596 12.4749 105.418 12.6353ZM104.642\n      27.7467C104.863 27.7467 105.045 27.6749 105.189 27.5313C105.333 27.3878 105.406 27.2062\n      105.406 26.9867V15.3333C105.406 15.1138 105.333 14.9322 105.189 14.7887C105.045 14.6451\n      104.863 14.5733 104.642 14.5733C104.421 14.5733 104.239 14.6451 104.095 14.7887C103.951\n      14.9322 103.878 15.1138 103.878 15.3333V26.9867C103.878 27.2062 103.951 27.3878 104.095\n      27.5313C104.239 27.6749 104.421 27.7467 104.642 27.7467ZM114.11 27.506C113.839 27.6664\n      113.516 27.7467 113.143 27.7467C112.685 27.7467 112.278 27.7044 111.921 27.62C111.565 27.5356\n      111.221 27.2822 110.891 26.86C110.56 26.4378 110.394 25.7622 110.394\n      24.8333V16.2707H108.536C108.333 16.2707 108.159 16.2031 108.014 16.068C107.87 15.9329 107.798\n      15.764 107.798 15.5613C107.798 15.3587 107.87 15.1898 108.014 15.0547C108.159 14.9196 108.333\n      14.852 108.536 14.852H110.394V12.04C110.394 11.8204 110.466 11.6389 110.611 11.4953C110.755\n      11.3518 110.937 11.28 111.158 11.28C111.378 11.28 111.561 11.3518 111.705 11.4953C111.849\n      11.6389 111.921 11.8204 111.921 12.04V14.852H114.467C114.653 14.852 114.819 14.928 114.963\n      15.08C115.107 15.232 115.179 15.4009 115.179 15.5867C115.179 15.7893 115.111 15.954 114.976\n      16.0807C114.84 16.2073 114.67 16.2707 114.467 16.2707H111.921V24.7573C111.921 25.3991 112.04\n      25.834 112.278 26.062C112.515 26.29 112.829 26.404 113.219 26.404C113.321 26.404 113.449\n      26.3829 113.601 26.3407C113.754 26.2984 113.873 26.2773 113.958 26.2773C114.11 26.2773\n      114.242 26.3407 114.352 26.4673C114.462 26.594 114.518 26.7418 114.518 26.9107C114.518\n      27.1471 114.382 27.3456 114.11 27.506ZM123.782 28C124.699 28 125.568 27.7889 126.391\n      27.3667C127.214 26.9444 127.897 26.404 128.44 25.7453C128.61 25.5764 128.695 25.3991 128.695\n      25.2133C128.695 25.0444 128.627 24.8924 128.491 24.7573C128.355 24.6222 128.202 24.5547\n      128.033 24.5547C127.863 24.5547 127.685 24.6307 127.498 24.7827C127.108 25.3062 126.59\n      25.7369 125.946 26.0747C125.301 26.4124 124.571 26.5813 123.757 26.5813C122.705 26.5813\n      121.793 26.3491 121.021 25.8847C120.249 25.4202 119.655 24.7869 119.239 23.9847C118.823\n      23.1824 118.615 22.2747 118.615 21.2613H128.236C128.44 21.2613 128.618 21.1896 128.771\n      21.046C128.924 20.9024 129 20.7293 129 20.5267C128.983 19.2769 128.695 18.196 128.135\n      17.284C127.575 16.372 126.849 15.6796 125.958 15.2067C125.068 14.7338 124.113 14.4973 123.095\n      14.4973C122.06 14.4973 121.084 14.7718 120.168 15.3207C119.252 15.8696 118.518 16.6633\n      117.966 17.702C117.415 18.7407 117.139 19.9524 117.139 21.3373C117.139 22.6547 117.419\n      23.8158 117.979 24.8207C118.539 25.8256 119.32 26.6067 120.321 27.164C121.322 27.7213 122.476\n      28 123.782 28ZM118.743 19.8933H127.422V19.6907C127.337 18.9307 127.083 18.2678 126.658\n      17.702C126.234 17.1362 125.704 16.7056 125.068 16.41C124.431 16.1144 123.774 15.9667 123.095\n      15.9667C122.111 15.9667 121.199 16.3044 120.359 16.98C119.519 17.6556 118.98 18.6267 118.743\n      19.8933Z","fill":"#16181F"}}),_c('rect',{attrs:{"y":"2","width":"78","height":"34","rx":"17","fill":"#16181F"}}),_c('path',{attrs:{"d":"M46.1793 28C47.6752 28 49.0861 27.675 50.412 27.025C50.667 26.9083 50.8625 26.7417 50.9984\n      26.525C51.1344 26.3083 51.2024 26.0667 51.2024 25.8C51.2024 25.4333 51.0749 25.0917 50.82\n      24.775C50.514 24.4083 50.14 24.225 49.698 24.225C49.4601 24.225 49.1881 24.2917 48.8821\n      24.425C48.1172 24.8083 47.2162 25 46.1793 25C44.4284 25 43.0133 24.4917 41.9339\n      23.475C40.8545 22.4583 40.3148 20.9667 40.3148 19C40.3148 17.85 40.5527 16.8292 41.0287\n      15.9375C41.5047 15.0458 42.1846 14.3542 43.0685 13.8625C43.9525 13.3708 44.9894 13.125\n      46.1793 13.125C47.1482 13.125 48.0492 13.3167 48.8821 13.7C49.1711 13.85 49.4601 13.925\n      49.749 13.925C50.174 13.925 50.5225 13.75 50.7945 13.4C51.0494 13.0667 51.1769 12.725\n      51.1769 12.375C51.1769 11.7917 50.9135 11.3667 50.3865 11.1C49.0946 10.45 47.6922 10.125\n      46.1793 10.125C44.4284 10.125 42.8561 10.5042 41.4622 11.2625C40.0683 12.0208 38.9761\n      13.075 38.1857 14.425C37.3952 15.775 37 17.3 37 19C37 20.9167 37.4165 22.55 38.2494\n      23.9C39.0823 25.25 40.1958 26.2708 41.5897 26.9625C42.9835 27.6542 44.5134 28 46.1793 28Z","fill":"white"}}),_c('path',{attrs:{"d":"M61.7275 28C63.7163 28 65.5437 27.4917 67.2095 26.475C67.7365 26.1583 68 25.7083 68\n      25.125V19.825C68 19.3917 67.8555 19.0292 67.5665 18.7375C67.2775 18.4458 66.9121 18.3 66.4701\n      18.3H62.2884C61.8464 18.3 61.4767 18.4417 61.1792 18.725C60.8818 19.0083 60.733 19.3667\n      60.733 19.8C60.733 20.2333 60.8818 20.5917 61.1792 20.875C61.4767 21.1583 61.8464 21.3\n      62.2884 21.3H64.6852V24.55C64.2773 24.6833 63.8013 24.7917 63.2573 24.875C62.7134 24.9583\n      62.2034 25 61.7275 25C60.6395 25 59.6366 24.7292 58.7187 24.1875C57.8007 23.6458 57.0741\n      22.9167 56.5386 22C56.0031 21.0833 55.7354 20.0833 55.7354 19C55.7354 17.9167 56.0031 16.9167\n      56.5386 16C57.0741 15.0833 57.8007 14.3542 58.7187 13.8125C59.6366 13.2708 60.6395 13 61.7275\n      13C62.7134 13 63.6653 13.1917 64.5832 13.575C64.8892 13.7083 65.1697 13.775 65.4247\n      13.775C65.8326 13.775 66.1769 13.6208 66.4573 13.3125C66.7378 13.0042 66.8781 12.6417 66.8781\n      12.225C66.8781 11.975 66.8143 11.7417 66.6868 11.525C66.5593 11.3083 66.3681 11.1333 66.1131\n      11C64.8722 10.3333 63.4103 10 61.7275 10C60.0446 10 58.4892 10.4042 57.0613 11.2125C55.6334\n      12.0208 54.503 13.1125 53.6701 14.4875C52.8371 15.8625 52.4207 17.3667 52.4207 19C52.4207\n      20.6333 52.8371 22.1375 53.6701 23.5125C54.503 24.8875 55.6334 25.9792 57.0613\n      26.7875C58.4892 27.5958 60.0446 28 61.7275 28Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.6392 26.047H26.1919V13.5031H13.6392V26.047ZM27.0619 27.7363H12.8203C12.359 27.7363 12\n      27.3776 12 26.9172V12.6833C12 12.223 12.359 11.8643 12.8203 11.8643H27.0108C27.4728 11.8643\n      27.8311 12.223 27.8311 12.6833V26.8661C27.8822 27.3264 27.524 27.7363 27.0619 27.7363Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.9931 27.5318C19.5311 27.5318 19.1721 27.1724 19.1721 26.7121V13.0422C19.1721 12.5812\n      19.5311 12.2231 19.9931 12.2231C20.4537 12.2231 20.812 12.5812 20.812 13.0422V26.7121C20.812\n      27.122 20.4537 27.5318 19.9931 27.5318Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.0108 17.5471H13.1267C12.6661 17.5471 12.3071 17.1891 12.3071 16.728C12.3071 16.267\n      12.6661 15.9097 13.1267 15.9097H27.0108C27.4728 15.9097 27.8311 16.267 27.8311\n      16.728C27.8311 17.1891 27.4728 17.5471 27.0108 17.5471Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.197 13.4511C19.993 13.4511 19.8388 13.4 19.6852 13.2466L15.7401 10.0207C15.3811 9.71383\n      15.3299 9.20165 15.6377 8.84361C15.9448 8.48419 16.4573 8.43373 16.8156 8.74131L20.7607\n      11.9665C21.1197 12.274 21.1709 12.7855 20.8631 13.1449C20.7088 13.3489 20.4536 13.4511 20.197\n      13.4511Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.7365 13.4511C19.4799 13.4511 19.2751 13.3489 19.1216 13.1449C18.8138 12.7855 18.865\n      12.274 19.224 11.9665L23.1691 8.74131C23.5267 8.43373 24.0406 8.48419 24.347 8.84361C24.6547\n      9.20165 24.6036 9.71383 24.2446 10.0207L20.2483 13.2466C20.0947 13.4 19.9419 13.4511 19.7365\n      13.4511Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.9419 13.3487C19.4799 13.3487 19.1216 12.9906 19.1216 12.5296V7.81907C19.1216 7.35873\n      19.4799 7 19.9419 7C20.4025 7 20.7608 7.35873 20.7608 7.81907V12.5296C20.7608 12.9395\n      20.4025 13.3487 19.9419 13.3487Z","fill":"white"}})])}
var CgEliteLogovue_type_template_id_001c4056_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CgEliteLogo.vue?vue&type=script&lang=ts&


var CgEliteLogovue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CgEliteLogo = class CgEliteLogo extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

CgEliteLogovue_type_script_lang_ts_decorate([Prop({
  default: 129
})], CgEliteLogo.prototype, "width", void 0);

CgEliteLogovue_type_script_lang_ts_decorate([Prop({
  default: 36
})], CgEliteLogo.prototype, "height", void 0);

CgEliteLogo = CgEliteLogovue_type_script_lang_ts_decorate([vue_class_component_esm], CgEliteLogo);
/* harmony default export */ var CgEliteLogovue_type_script_lang_ts_ = (CgEliteLogo);
;// CONCATENATED MODULE: ./src/components/icons/CgEliteLogo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CgEliteLogovue_type_script_lang_ts_ = (CgEliteLogovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/CgEliteLogo.vue





/* normalize component */
;
var CgEliteLogo_component = componentNormalizer_normalizeComponent(
  icons_CgEliteLogovue_type_script_lang_ts_,
  CgEliteLogovue_type_template_id_001c4056_render,
  CgEliteLogovue_type_template_id_001c4056_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_CgEliteLogo = (CgEliteLogo_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CorporateGiftLogo.vue?vue&type=template&id=946412a2&
var CorporateGiftLogovue_type_template_id_946412a2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 295 29","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"clip-path":"url(#clip0_1305_1436)"}},[_c('path',{attrs:{"d":"M46.4714 18.2806C47.1095 17.381 45.6125 16.4814 45.0481 17.308C44.5327 17.9645 43.7965\n        18.548 43.0358 18.937C42.1033 19.399 41.0971 19.6421 40.1892 19.6421C36.8026 19.6421\n        33.9314 16.8218 33.9314 13.1262C33.9314 9.60073 36.0664 7.48547 39.0849 7.02352C41.2444\n        6.78039 43.183 7.04783 44.8518 8.79839C45.5389 9.52779 46.8641 8.53094 46.1279\n        7.70429C44.1892 5.68629 41.6861 4.98121 38.8149 5.37022C35.0357 5.95374 32.1646 9.11446\n        32.1646 13.1018C32.1646 17.9159 35.9437 21.3197 40.1401 21.3197C41.318 21.3197 42.6432\n        20.9793 43.8211 20.4444C44.8763 19.9339 45.8088 19.2045 46.4714 18.2806Z","fill":"black"}}),_c('path',{attrs:{"d":"M56.4345 21.3197C60.6063 21.3197 64.2873 18.1104 64.2873 13.0532C64.2873 9.06583 61.367\n        5.95374 57.5879 5.37022C56.729 5.27296 55.8946 5.24865 54.9866 5.37022C51.0848 5.97805\n        48.4835 9.23603 48.4835 13.0532C48.4835 18.2076 52.0173 21.3197 56.4345 21.3197ZM55.232\n        6.99921C55.9191 6.90195 56.6308 6.90195 57.367 6.99921C60.3854 7.48547 62.4713 9.98974\n        62.4713 13.1262C62.4713 17.2108 59.7474 19.6421 56.4345 19.6421C52.9743 19.6421 50.324\n        17.1135 50.324 13.1262C50.324 9.81955 52.2627 7.46116 55.232 6.99921Z","fill":"black"}}),_c('path',{attrs:{"d":"M69.5172 7.19371H74.4743C77.321 7.19371 79.0142 8.79839 79.0388 10.7921C79.0878 12.6156\n        77.6891 14.0987 74.4743 14.0987H69.5172V7.19371ZM74.278 15.6304L79.2351 20.955C80.0449\n        21.7817 81.3946 20.7119 80.4621 19.788L76.4866 15.5332C79.505 15.0226 80.8547 13.2477\n        80.8547 10.7921C80.8547 7.94742 78.6952 5.56472 74.4498 5.56472H68.6338C68.0939 5.56472\n        67.7258 5.90511 67.7258 6.41569V20.3715C67.7258 21.4656 69.5172 21.4656 69.5172\n        20.3472V15.6304H74.278Z","fill":"black"}}),_c('path',{attrs:{"d":"M85.891 7.14509H90.3818C93.2285 7.14509 94.8236 9.16309 94.8481 11.1568C94.8972 13.0046\n        93.5475 14.901 90.2837 14.901H85.891V7.14509ZM90.2837 16.4814C94.5782 16.4814 96.5905\n        14.0744 96.5905 11.1568C96.5905 8.36075 94.6027 5.56472 90.3573 5.56472H85.0321C84.5413\n        5.56472 84.1241 5.90511 84.1241 6.41569V20.4201C84.1241 21.4899 85.891 21.5142 85.891\n        20.3958V16.4814H90.2837Z","fill":"black"}}),_c('path',{attrs:{"d":"M106.815 21.3197C110.987 21.3197 114.668 18.1104 114.668 13.0532C114.668 9.06583 111.748\n        5.95374 107.968 5.37022C107.11 5.27296 106.275 5.24865 105.367 5.37022C101.465 5.97805\n        98.8641 9.23603 98.8641 13.0532C98.8641 18.2076 102.398 21.3197 106.815 21.3197ZM105.613\n        6.99921C106.3 6.90195 107.011 6.90195 107.748 6.99921C110.766 7.48547 112.852 9.98974\n        112.852 13.1262C112.852 17.2108 110.128 19.6421 106.815 19.6421C103.355 19.6421 100.705\n        17.1135 100.705 13.1262C100.705 9.81955 102.643 7.46116 105.613 6.99921Z","fill":"black"}}),_c('path',{attrs:{"d":"M119.898 7.19371H124.855C127.702 7.19371 129.395 8.79839 129.419 10.7921C129.468 12.6156\n        128.07 14.0987 124.855 14.0987H119.898V7.19371ZM124.659 15.6304L129.616 20.955C130.425\n        21.7817 131.775 20.7119 130.843 19.788L126.867 15.5332C129.886 15.0226 131.235 13.2477\n        131.235 10.7921C131.235 7.94742 129.076 5.56472 124.83 5.56472H119.014C118.474 5.56472\n        118.106 5.90511 118.106 6.41569V20.3715C118.106 21.4656 119.898 21.4656 119.898\n        20.3472V15.6304H124.659Z","fill":"black"}}),_c('path',{attrs:{"d":"M144.493 15.4359H136.762L140.64 7.77723L144.493 15.4359ZM145.253 16.9676L147.167\n        20.7362C147.634 21.6844 149.45 21.0766 148.812 20.0311L141.425 5.63766C141.253 5.32159\n        140.959 5.17571 140.64 5.17571C140.321 5.17571 139.977 5.32159 139.83 5.63766L132.419\n        20.1041C131.977 21.0766 133.597 21.7087 134.038 20.8091L136.026 16.9676H145.253Z","fill":"black"}}),_c('path',{attrs:{"d":"M148.006 5.56472C146.852 5.56472 146.852 7.24234 148.006 7.24234H153.454V20.4444C153.454\n        21.0523 153.92 21.344 154.337 21.344C154.754 21.344 155.27 21.0523 155.27 20.4444C155.27\n        16.0681 155.245 11.6187 155.245 7.24234H160.718C161.92 7.24234 161.92 5.56472 160.718\n        5.56472H148.006Z","fill":"black"}}),_c('path',{attrs:{"d":"M165.5 14.1716H174.727C175.757 14.1716 175.708 12.6156 174.727\n        12.6156H165.5V7.14509H175.193C176.224 7.14509 176.273 5.58904 175.217\n        5.58904H164.862C164.174 5.58904 163.733 6.0753 163.733 6.63451V19.9825C163.733 20.566\n        164.174 21.0523 164.862 21.0523H175.193C176.371 21.0523 176.224 19.4476 175.193\n        19.4476H165.5V14.1716Z","fill":"black"}}),_c('path',{attrs:{"d":"M199.392 17.5512V13.4909C199.392 12.956 199.171 12.5913 198.46 12.5913H193.257C192.226\n        12.5913 192.104 14.1959 193.257 14.1959H197.674V17.4296C196.595 18.8641 194.705 19.6421\n        192.889 19.6178C189.723 19.5449 186.926 16.6759 186.877 13.2477C186.877 10.0627 189.233\n        7.70429 191.932 7.07215C193.772 6.61019 196.055 7.1694 197.429 8.74976C198.19 9.62504\n        199.441 8.458 198.705 7.60704C197.355 6.05099 195.073 5.32159 192.938 5.32159C192.496\n        5.32159 192.03 5.3459 191.662 5.39453C187.907 6.09962 185.11 9.47916 185.11\n        13.1748C185.012 17.77 188.644 21.2468 192.864 21.2711C195.245 21.2954 197.674 20.2499\n        199.122 18.3535C199.343 18.1347 199.392 17.8186 199.392 17.5512Z","fill":"black"}}),_c('path',{attrs:{"d":"M203.247 20.4444C203.247 21.6115 205.087 21.5629 205.087 20.4444V5.90511C205.087\n        4.71376 203.247 4.68945 203.247 5.90511V20.4444Z","fill":"black"}}),_c('path',{attrs:{"d":"M208.835 20.4444C208.835 21.6358 210.602 21.6358 210.602 20.4201V14.7308H219.559C220.565\n        14.7308 220.516 13.2234 219.559 13.2234H210.602V7.12077H220.026C221.056 7.12077 221.056\n        5.58904 220.026 5.58904H209.915C209.326 5.58904 208.835 6.0753 208.835 6.63451V20.4444Z","fill":"black"}}),_c('path',{attrs:{"d":"M223.171 5.56472C222.018 5.56472 222.018 7.24234 223.171 7.24234H228.619V20.4444C228.619\n        21.0523 229.085 21.344 229.503 21.344C229.92 21.344 230.435 21.0523 230.435\n        20.4444C230.435 16.0681 230.411 11.6187 230.411 7.24234H235.883C237.085 7.24234 237.085\n        5.56472 235.883 5.56472H223.171Z","fill":"black"}}),_c('path',{attrs:{"d":"M238.407 19.0343C237.769 19.0343 237.303 19.4476 237.303 20.0554C237.303 20.6633 237.769\n        21.0766 238.407 21.0766C239.045 21.0766 239.463 20.6633 239.463 20.0554C239.463 19.4476\n        239.045 19.0343 238.407 19.0343Z","fill":"black"}}),_c('path',{attrs:{"d":"M255.748 18.2805C256.386 17.3809 254.889 16.4813 254.325 17.308C253.809 17.9645 253.073\n        18.548 252.312 18.937C251.38 19.3989 250.374 19.6421 249.466 19.6421C246.079 19.6421\n        243.208 16.8217 243.208 13.1261C243.208 9.60069 245.343 7.48544 248.361 7.02349C250.521\n        6.78036 252.46 7.0478 254.128 8.79836C254.816 9.52775 256.141 8.53091 255.404\n        7.70426C253.466 5.68626 250.963 4.98117 248.092 5.37019C244.312 5.9537 241.441 9.11443\n        241.441 13.1018C241.441 17.9158 245.22 21.3197 249.417 21.3197C250.595 21.3197 251.92\n        20.9793 253.098 20.4444C254.153 19.9338 255.085 19.2044 255.748 18.2805Z","fill":"#A7A9AC"}}),_c('path',{attrs:{"d":"M265.711 21.3197C269.883 21.3197 273.564 18.1103 273.564 13.0532C273.564 9.0658 270.644\n        5.9537 266.864 5.37019C266.006 5.27293 265.171 5.24862 264.263 5.37019C260.361 5.97802\n        257.76 9.236 257.76 13.0532C257.76 18.2076 261.294 21.3197 265.711 21.3197ZM264.509\n        6.99918C265.196 6.90192 265.907 6.90192 266.644 6.99918C269.662 7.48544 271.748 9.98971\n        271.748 13.1261C271.748 17.2107 269.024 19.6421 265.711 19.6421C262.251 19.6421 259.601\n        17.1135 259.601 13.1261C259.601 9.81951 261.539 7.46113 264.509 6.99918Z","fill":"#A7A9AC"}}),_c('path',{attrs:{"d":"M284.708 15.1927L278.72 5.9537C278.229 5.07843 277.051 5.34587 277.051\n        6.39134V20.3958C277.051 21.5628 278.843 21.5628 278.843 20.3958V9.35756L283.849\n        17.0892C284.217 17.7943 285.15 17.7943 285.542 17.0892L290.549 9.33325V20.3958C290.549\n        21.5628 292.34 21.5628 292.34 20.3958C292.34 14.9267 292.34 11.8604 292.34\n        6.39134C292.34 5.37019 291.211 5.07843 290.647 5.9537L284.708 15.1927Z","fill":"#A7A9AC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.93863 22.7214H16.7846V8.0869H1.93863V22.7214ZM17.8136 24.6923H0.970151C0.424543\n        24.6923 0 24.2738 0 23.7367V7.13051C0 6.59345 0.424543 6.17493 0.970151\n        6.17493H17.7531C18.2995 6.17493 18.7233 6.59345 18.7233 7.13051V23.677C18.7838 24.2141\n        18.3601 24.6923 17.8136 24.6923Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.45339 24.4537C8.90697 24.4537 8.48242 24.0344 8.48242 23.4974V7.54918C8.48242 7.01131\n        8.90697 6.5936 9.45339 6.5936C9.99818 6.5936 10.4219 7.01131 10.4219\n        7.54918V23.4974C10.4219 23.9755 9.99818 24.4537 9.45339 24.4537Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.7532 12.805H1.33261C0.787824 12.805 0.363281 12.3873 0.363281 11.8494C0.363281\n        11.3115 0.787824 10.8946 1.33261 10.8946H17.7532C18.2996 10.8946 18.7233 11.3115 18.7233\n        11.8494C18.7233 12.3873 18.2996 12.805 17.7532 12.805Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.69459 8.0265C9.45328 8.0265 9.27086 7.96683 9.08927 7.78781L4.42338 4.02434C3.99884\n        3.6663 3.93831 3.06875 4.30232 2.65104C4.66551 2.23171 5.27165 2.17284 5.69538\n        2.53169L10.3613 6.29435C10.7858 6.6532 10.8463 7.24994 10.4823 7.66927C10.2999 7.90715\n        9.99807 8.0265 9.69459 8.0265Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.14988 8.0265C8.8464 8.0265 8.60428 7.90715 8.42268 7.66927C8.05867 7.24994 8.1192\n        6.6532 8.54374 6.29435L13.2096 2.53169C13.6325 2.17284 14.2403 2.23171 14.6027\n        2.65104C14.9667 3.06875 14.9062 3.6663 14.4816 4.02434L9.7552 7.78781C9.57361 7.96683\n        9.39283 8.0265 9.14988 8.0265Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.39276 7.90678C8.84633 7.90678 8.42261 7.48907 8.42261 6.9512V1.45558C8.42261 0.918522\n        8.84633 0.5 9.39276 0.5C9.93755 0.5 10.3613 0.918522 10.3613 1.45558V6.9512C10.3613\n        7.4294 9.93755 7.90678 9.39276 7.90678Z","fill":"black"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1305_1436"}},[_c('rect',{attrs:{"width":"294.254","height":"28","fill":"white","transform":"translate(0 0.5)"}})])])])}
var CorporateGiftLogovue_type_template_id_946412a2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/CorporateGiftLogo.vue?vue&type=script&lang=ts&


var CorporateGiftLogovue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let CorporateGiftLogo = class CorporateGiftLogo extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

CorporateGiftLogovue_type_script_lang_ts_decorate([Prop({
  default: 295
})], CorporateGiftLogo.prototype, "width", void 0);

CorporateGiftLogovue_type_script_lang_ts_decorate([Prop({
  default: 29
})], CorporateGiftLogo.prototype, "height", void 0);

CorporateGiftLogo = CorporateGiftLogovue_type_script_lang_ts_decorate([vue_class_component_esm], CorporateGiftLogo);
/* harmony default export */ var CorporateGiftLogovue_type_script_lang_ts_ = (CorporateGiftLogo);
;// CONCATENATED MODULE: ./src/components/icons/CorporateGiftLogo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CorporateGiftLogovue_type_script_lang_ts_ = (CorporateGiftLogovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/CorporateGiftLogo.vue





/* normalize component */
;
var CorporateGiftLogo_component = componentNormalizer_normalizeComponent(
  icons_CorporateGiftLogovue_type_script_lang_ts_,
  CorporateGiftLogovue_type_template_id_946412a2_render,
  CorporateGiftLogovue_type_template_id_946412a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_CorporateGiftLogo = (CorporateGiftLogo_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaLogos.vue?vue&type=script&lang=ts&


var TheHeaderUserAreaLogosvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TheHeaderUserAreaLogos = class TheHeaderUserAreaLogos extends mixins(userDeviceWidth, subdomainInfo) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "isElite", void 0);

    _defineProperty(this, "userCompanyLogo", void 0);

    _defineProperty(this, "domainLogo", void 0);
  }

  get hideCgEliteLogo() {
    return this.$store.state?.header?.headerData?.hideCgEliteLogo ?? false;
  }

};

TheHeaderUserAreaLogosvue_type_script_lang_ts_decorate([Prop({
  default: false
})], TheHeaderUserAreaLogos.prototype, "isElite", void 0);

TheHeaderUserAreaLogosvue_type_script_lang_ts_decorate([Prop({
  default: null
})], TheHeaderUserAreaLogos.prototype, "userCompanyLogo", void 0);

TheHeaderUserAreaLogosvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: null
})], TheHeaderUserAreaLogos.prototype, "domainLogo", void 0);

TheHeaderUserAreaLogos = TheHeaderUserAreaLogosvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CgElite: icons_CgElite,
    CgEliteLogo: icons_CgEliteLogo,
    CorporateGiftLogo: icons_CorporateGiftLogo
  }
})], TheHeaderUserAreaLogos);
/* harmony default export */ var TheHeaderUserAreaLogosvue_type_script_lang_ts_ = (TheHeaderUserAreaLogos);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaLogos.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderUserAreaLogosvue_type_script_lang_ts_ = (TheHeaderUserAreaLogosvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaLogos.vue?vue&type=style&index=0&id=26a9ad10&lang=scss&scoped=true&
var TheHeaderUserAreaLogosvue_type_style_index_0_id_26a9ad10_lang_scss_scoped_true_ = __webpack_require__(3725);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaLogos.vue?vue&type=style&index=0&id=26a9ad10&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaLogos.vue



;


/* normalize component */

var TheHeaderUserAreaLogos_component = componentNormalizer_normalizeComponent(
  components_TheHeaderUserAreaLogosvue_type_script_lang_ts_,
  TheHeaderUserAreaLogosvue_type_template_id_26a9ad10_scoped_true_render,
  TheHeaderUserAreaLogosvue_type_template_id_26a9ad10_scoped_true_staticRenderFns,
  false,
  null,
  "26a9ad10",
  null
  
)

/* harmony default export */ var components_TheHeaderUserAreaLogos = (TheHeaderUserAreaLogos_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfo.vue?vue&type=template&id=76769543&scoped=true&
var TheHeaderUserAreaInfovue_type_template_id_76769543_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-user-area__menus"},[(!_vm.hideFavoritesIcon)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({
      content: 'Favorites',
      container: false,
      classes: 'header-user-area__tooltip',
      trigger: 'hover',
      offset: 6,
      autoHide: false,
    }),expression:"{\n      content: 'Favorites',\n      container: false,\n      classes: 'header-user-area__tooltip',\n      trigger: 'hover',\n      offset: 6,\n      autoHide: false,\n    }",modifiers:{"bottom":true}}],staticClass:"icon-wrapper",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.moveUserToFavorites()},"keypress":function($event){return _vm.moveUserToFavorites()}}},[_c('heart-icon')],1):_vm._e(),_c('the-header-user-area-info-menu',_vm._g({},_vm.$listeners)),(!_vm.hideMiniCartIcon)?_c('cart-amount',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({
      content: 'Shopping cart',
      container: false,
      classes: 'header-user-area__tooltip',
      trigger: 'hover',
      offset: 6,
      autoHide: false,
    }),expression:"{\n      content: 'Shopping cart',\n      container: false,\n      classes: 'header-user-area__tooltip',\n      trigger: 'hover',\n      offset: 6,\n      autoHide: false,\n    }",modifiers:{"bottom":true}}],on:{"showCartPanel":function($event){return _vm.$emit('onShowCart')}}}):_vm._e()],1)}
var TheHeaderUserAreaInfovue_type_template_id_76769543_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=template&id=aca20a9a&scoped=true&
var TheHeaderUserAreaInfoMenuvue_type_template_id_aca20a9a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-user-info"},[(!_vm.userIsLoggedIn)?[_c('div',{staticClass:"the-user-info__button-wrapper",attrs:{"aria-label":"button"},on:{"click":function($event){return _vm.$emit('loginRequired')},"keypress":function($event){return _vm.$emit('loginRequired')}}},[_c('user-icon'),_vm._v(" My account ")],1)]:_c('v-popover',{attrs:{"placement":"top-start","trigger":"hover click","boundaries-element":"body"}},[(_vm.userName)?[_c('div',{staticClass:"the-user-info__user-name-first-letter",style:(("--background-color: " + (_vm.getColorByUserName())))},[_vm._v(" "+_vm._s(_vm.userName[0])+" ")]),_vm._v(" Hi, "+_vm._s(_vm.userName)+" "),_c('chevron-down-icon')]:[_c('user-icon'),_vm._v(" My account "),_c('chevron-down-icon')],_c('user-menu',{attrs:{"slot":"popover"},slot:"popover"})],2)],2)}
var TheHeaderUserAreaInfoMenuvue_type_template_id_aca20a9a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=script&lang=ts&


var TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let TheHeaderUserAreaInfoMenu = class TheHeaderUserAreaInfoMenu extends mixins(userIsLoggedIn) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "userColors", ['#928869', '#007E76', '#07703A', '#214268', '#65446D', '#9E040A', '#42B77A', '#D7CCA5', '#4678B3', '#AD84B7', '#FF5A60', '#EB8989', '#ECD884', '#9DB0C6', '#C1A3C9', '#A5DEC0', '#EBAE9E', '#67B7B4', '#222325', '#A7DAD8', '#EDCFC3', '#95979D']);
  }

  get userName() {
    return this.$store.state.header.headerData.customerName || null;
  }

  getColorByUserName() {
    const {
      userColors,
      userName
    } = this;
    const userFirstLetterNumber = userName?.charCodeAt(0) || 0;
    const randomIndexNumber = Math.floor(Math.abs(Math.cos(userFirstLetterNumber)) * userColors.length);
    return userColors[randomIndexNumber];
  }

};
TheHeaderUserAreaInfoMenu = TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    UserIcon: icons_User,
    ChevronDownIcon: icons_ChevronDown,
    UserMenu: components_UserMenu
  }
})], TheHeaderUserAreaInfoMenu);
/* harmony default export */ var TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_ = (TheHeaderUserAreaInfoMenu);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_ = (TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=style&index=0&id=aca20a9a&lang=scss&scoped=true&
var TheHeaderUserAreaInfoMenuvue_type_style_index_0_id_aca20a9a_lang_scss_scoped_true_ = __webpack_require__(9538);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=style&index=0&id=aca20a9a&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=style&index=1&lang=scss&
var TheHeaderUserAreaInfoMenuvue_type_style_index_1_lang_scss_ = __webpack_require__(1962);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfoMenu.vue?vue&type=style&index=1&lang=scss&

;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfoMenu.vue



;



/* normalize component */

var TheHeaderUserAreaInfoMenu_component = componentNormalizer_normalizeComponent(
  components_TheHeaderUserAreaInfoMenuvue_type_script_lang_ts_,
  TheHeaderUserAreaInfoMenuvue_type_template_id_aca20a9a_scoped_true_render,
  TheHeaderUserAreaInfoMenuvue_type_template_id_aca20a9a_scoped_true_staticRenderFns,
  false,
  null,
  "aca20a9a",
  null
  
)

/* harmony default export */ var components_TheHeaderUserAreaInfoMenu = (TheHeaderUserAreaInfoMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfo.vue?vue&type=script&lang=ts&
var TheHeaderUserAreaInfovue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TheHeaderUserAreaInfo = class TheHeaderUserAreaInfo extends mixins(userIsLoggedIn) {
  get hideFavoritesIcon() {
    return this.$store.state.header?.hideFavoritesIcon ?? false;
  }

  get hideMiniCartIcon() {
    return this.$store.state.header?.hideMiniCartIcon ?? false;
  }

  moveUserToFavorites() {
    const {
      userIsLoggedIn
    } = this;
    const {
      accountUrl
    } = takeGlobalOptions();

    if (userIsLoggedIn) {
      window.location.href = `${accountUrl}/my-favorites`;
    } else {
      this.$emit('showLoginPanel', {
        redirect: `${accountUrl}/my-favorites`
      });
    }
  }

};
TheHeaderUserAreaInfo = TheHeaderUserAreaInfovue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheHeaderUserAreaInfoMenu: components_TheHeaderUserAreaInfoMenu,
    HeartIcon: icons_Heart,
    CartAmount: components_CartAmount
  }
})], TheHeaderUserAreaInfo);
/* harmony default export */ var TheHeaderUserAreaInfovue_type_script_lang_ts_ = (TheHeaderUserAreaInfo);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderUserAreaInfovue_type_script_lang_ts_ = (TheHeaderUserAreaInfovue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfo.vue?vue&type=style&index=0&lang=scss&
var TheHeaderUserAreaInfovue_type_style_index_0_lang_scss_ = __webpack_require__(500);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfo.vue?vue&type=style&index=0&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserAreaInfo.vue?vue&type=style&index=1&id=76769543&lang=scss&scoped=true&
var TheHeaderUserAreaInfovue_type_style_index_1_id_76769543_lang_scss_scoped_true_ = __webpack_require__(8962);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfo.vue?vue&type=style&index=1&id=76769543&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderUserAreaInfo.vue



;



/* normalize component */

var TheHeaderUserAreaInfo_component = componentNormalizer_normalizeComponent(
  components_TheHeaderUserAreaInfovue_type_script_lang_ts_,
  TheHeaderUserAreaInfovue_type_template_id_76769543_scoped_true_render,
  TheHeaderUserAreaInfovue_type_template_id_76769543_scoped_true_staticRenderFns,
  false,
  null,
  "76769543",
  null
  
)

/* harmony default export */ var components_TheHeaderUserAreaInfo = (TheHeaderUserAreaInfo_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserArea.vue?vue&type=script&lang=ts&


var TheHeaderUserAreavue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};













let TheHeaderUserArea = class TheHeaderUserArea extends mixins(userIsCgElite, userDeviceWidth) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "domainLogo", void 0);

    _defineProperty(this, "showMobileNavigation", false);

    _defineProperty(this, "showMobileNavigationPanel", false);

    _defineProperty(this, "mobileNavigationPanelData", null);
  }

  get userCompanyLogo() {
    return this.$store.state.header?.headerData?.logoUrl || null;
  }

  get hideSearchInput() {
    const {
      hideSearchInput,
      headerData
    } = this.$store.state.header ?? {};
    const {
      hideSearch
    } = headerData.menus ?? {};
    return hideSearchInput || hideSearch || false;
  }

  handleNavigationPanelData(data) {
    this.showMobileNavigationPanel = true;
    this.mobileNavigationPanelData = data;
  }

};

TheHeaderUserAreavue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: null
})], TheHeaderUserArea.prototype, "domainLogo", void 0);

TheHeaderUserArea = TheHeaderUserAreavue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CartAmount: components_CartAmount,
    PhoneIcon: icons_Phone,
    CloseIcon: icons_Close,
    HeaderSearch: components_HeaderSearch,
    HamburgerMenuIcon: icons_HamburgerMenu,
    TheHeaderUserAreaInfo: components_TheHeaderUserAreaInfo,
    TheHeaderUserAreaLogos: components_TheHeaderUserAreaLogos,
    TheHeaderMobileNavigation: components_TheHeaderMobileNavigation,
    TheHeaderMobileNavigationPanel: components_TheHeaderMobileNavigationPanel
  }
})], TheHeaderUserArea);
/* harmony default export */ var TheHeaderUserAreavue_type_script_lang_ts_ = (TheHeaderUserArea);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserArea.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderUserAreavue_type_script_lang_ts_ = (TheHeaderUserAreavue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderUserArea.vue?vue&type=style&index=0&id=e443521a&lang=scss&scoped=true&
var TheHeaderUserAreavue_type_style_index_0_id_e443521a_lang_scss_scoped_true_ = __webpack_require__(4902);
;// CONCATENATED MODULE: ./src/components/TheHeaderUserArea.vue?vue&type=style&index=0&id=e443521a&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderUserArea.vue



;


/* normalize component */

var TheHeaderUserArea_component = componentNormalizer_normalizeComponent(
  components_TheHeaderUserAreavue_type_script_lang_ts_,
  TheHeaderUserAreavue_type_template_id_e443521a_scoped_true_render,
  TheHeaderUserAreavue_type_template_id_e443521a_scoped_true_staticRenderFns,
  false,
  null,
  "e443521a",
  null
  
)

/* harmony default export */ var components_TheHeaderUserArea = (TheHeaderUserArea_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMenus.vue?vue&type=template&id=32e54ce2&scoped=true&
var TheHeaderMenusvue_type_template_id_32e54ce2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header-menus"},[_c('div',{staticClass:"the-header-menus__content"},[(!_vm.hideWhatWeOfferMenus)?_c('the-header-menus-what-we-offer'):_vm._e(),(!_vm.hideWhatWeOfferMenus)?_c('the-header-menus-resources'):_vm._e(),(!_vm.hideWhatWeOfferMenus)?_c('the-header-menus-link',{attrs:{"path":"/pricing"}},[_vm._v(" Pricing ")]):_vm._e(),(!_vm.hideDefaultDropdowns)?_c('the-header-menus-shop-products'):_vm._e(),(!_vm.hideDefaultDropdowns)?_c('the-header-menus-shop-by'):_vm._e(),(_vm.userCompanyMenu.length)?_c('the-user-company-menu',{attrs:{"items":_vm.userCompanyMenu}}):_vm._e(),(!_vm.hideDefaultDropdowns && _vm.showShopHolidaysLink)?_c('the-header-menus-link',{staticStyle:{"padding-top":"5px"},attrs:{"path":"/occasions/holiday-2024/","color":"#42B77A","hover-color":"#219358","alternative-hover":true,"fontWeight":700},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('holiday-icon',{attrs:{"height":24}})]},proxy:true}],null,false,503430770)},[_vm._v(" Shop Holiday ")]):_vm._e(),(!_vm.hideDefaultDropdowns && !_vm.hasExternalDomain)?_c('the-header-menus-let-them'):_vm._e()],1),(_vm.userUsingTablet && !_vm.hideSearch)?_c('header-search'):_vm._e()],1)}
var TheHeaderMenusvue_type_template_id_32e54ce2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLink.vue?vue&type=template&id=5e1a33fc&scoped=true&
var TheHeaderMenusLinkvue_type_template_id_5e1a33fc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{
    'active-page': _vm.isPageActive,
    'alternative-hover': _vm.alternativeHover,
  },style:(("\n    --text-color: " + _vm.color + ";\n    --hover-color: " + _vm.hoverColor + ";\n    --font-weight: " + _vm.fontWeight + ";\n    --active-color: " + _vm.activeColor + ";\n  ")),attrs:{"href":_vm.storeUrl + _vm.path},on:{"click":_vm.onLinkClick}},[_vm._t("default"),_vm._t("suffix")],2)}
var TheHeaderMenusLinkvue_type_template_id_5e1a33fc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLink.vue?vue&type=script&lang=ts&


var TheHeaderMenusLinkvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TheHeaderMenusLink = class TheHeaderMenusLink extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "path", void 0);

    _defineProperty(this, "color", void 0);

    _defineProperty(this, "hoverColor", void 0);

    _defineProperty(this, "activeColor", void 0);

    _defineProperty(this, "alternativeHover", void 0);

    _defineProperty(this, "fontWeight", void 0);

    _defineProperty(this, "storeUrl", null);
  }

  get isPageActive() {
    const {
      pathname
    } = window.location;
    return pathname.includes(this.path);
  }

  mounted() {
    const {
      storeUrl
    } = takeGlobalOptions();
    this.storeUrl = storeUrl;
  }

  onLinkClick() {
    const defaultSlotText = this.$slots.default?.[0]?.text?.trim() ?? '';
    navigationClick({
      item: defaultSlotText
    });
  }

};

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheHeaderMenusLink.prototype, "path", void 0);

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: '#000'
})], TheHeaderMenusLink.prototype, "color", void 0);

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: '#000'
})], TheHeaderMenusLink.prototype, "hoverColor", void 0);

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: '#000'
})], TheHeaderMenusLink.prototype, "activeColor", void 0);

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: false
})], TheHeaderMenusLink.prototype, "alternativeHover", void 0);

TheHeaderMenusLinkvue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: 400
})], TheHeaderMenusLink.prototype, "fontWeight", void 0);

TheHeaderMenusLink = TheHeaderMenusLinkvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderMenusLink);
/* harmony default export */ var TheHeaderMenusLinkvue_type_script_lang_ts_ = (TheHeaderMenusLink);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLink.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusLinkvue_type_script_lang_ts_ = (TheHeaderMenusLinkvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLink.vue?vue&type=style&index=0&id=5e1a33fc&lang=scss&scoped=true&
var TheHeaderMenusLinkvue_type_style_index_0_id_5e1a33fc_lang_scss_scoped_true_ = __webpack_require__(1030);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLink.vue?vue&type=style&index=0&id=5e1a33fc&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLink.vue



;


/* normalize component */

var TheHeaderMenusLink_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusLinkvue_type_script_lang_ts_,
  TheHeaderMenusLinkvue_type_template_id_5e1a33fc_scoped_true_render,
  TheHeaderMenusLinkvue_type_template_id_5e1a33fc_scoped_true_staticRenderFns,
  false,
  null,
  "5e1a33fc",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusLink = (TheHeaderMenusLink_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProducts.vue?vue&type=template&id=8011836a&scoped=true&
var TheHeaderMenusShopProductsvue_type_template_id_8011836a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-header-menus-dropdown',{staticClass:"header-menu-shop-products-dropdown",class:{ 'header-menu-shop-products-dropdown--cg-elite': _vm.userIsCgElite },scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"header-menu-shop-products"},[_c('div',{staticClass:"header-menu-shop-products__products"},_vm._l((_vm.shopProductsMenus),function(category,index){return _c('the-header-menus-shop-product-item',{key:index,attrs:{"category":category},on:{"set-category-image":function (val) { return (_vm.categoryImage = val); }}})}),1),_c('div',{staticClass:"header-menu-shop-products__category-photo"},[(_vm.categoryImage)?_c('img',{attrs:{"src":_vm.categoryImage,"alt":"Category image"}}):_vm._e()])])]},proxy:true}])},[_c('div',{staticClass:"header-menu-shop-products__activator"},[(!_vm.userIsCgElite)?_c('cg-elite',{staticStyle:{"margin-top":"-3px"},attrs:{"width":24,"height":24}}):_vm._e(),_vm._v(" Shop Products ")],1)])}
var TheHeaderMenusShopProductsvue_type_template_id_8011836a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue?vue&type=template&id=17da9ad8&scoped=true&
var TheHeaderMenusShopProductItemvue_type_template_id_17da9ad8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"category-list",on:{"mouseover":function($event){return _vm.setCategoryImage()},"focus":function($event){return _vm.setCategoryImage()}}},[_c('li',[_c('a',{staticClass:"category-list__main",attrs:{"href":_vm.mainCategoryPath},on:{"click":function($event){return _vm.onMainCategoryClick(_vm.category.title)}}},[_vm._v(" "+_vm._s(_vm.category.title)+" ")])]),_vm._l((_vm.subCategories),function(subCategory,index){return _c('li',{key:index},[_c('a',{staticClass:"category-list__sub",attrs:{"href":subCategory.path},on:{"click":function($event){return _vm.onSubCategoryClick(_vm.category.title, subCategory.title)}}},[_vm._v(" "+_vm._s(subCategory.title)+" ")])])})],2)}
var TheHeaderMenusShopProductItemvue_type_template_id_17da9ad8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue?vue&type=script&lang=ts&


var TheHeaderMenusShopProductItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}; // prettier-ignore





let TheHeaderMenusShopProductItem = class TheHeaderMenusShopProductItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "category", void 0);
  }

  get mainCategoryPath() {
    const {
      storeUrl
    } = takeGlobalOptions();
    const {
      path
    } = this.category;
    return path ? `${storeUrl}${path}` : undefined;
  }

  get subCategories() {
    const {
      children
    } = this.category;
    return children.filter(child => child.title.toLowerCase() !== 'hover_image') ?? [];
  }

  get categoryImage() {
    const {
      children
    } = this.category;
    const hoverImage = children.filter(child => child.title.toLowerCase() === 'hover_image');
    return hoverImage.length ? hoverImage[0].path : null;
  }

  setCategoryImage() {
    return this.categoryImage || null;
  }

  onMainCategoryClick(title) {
    navigationClick({
      itemCategory: 'shop products',
      itemSubCategory: title,
      item: title
    });
  }

  onSubCategoryClick(mainCategory, subCategory) {
    navigationClick({
      itemCategory: 'shop products',
      itemSubCategory: mainCategory,
      item: subCategory
    });
  }

};

TheHeaderMenusShopProductItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheHeaderMenusShopProductItem.prototype, "category", void 0);

TheHeaderMenusShopProductItemvue_type_script_lang_ts_decorate([Emit()], TheHeaderMenusShopProductItem.prototype, "setCategoryImage", null);

TheHeaderMenusShopProductItem = TheHeaderMenusShopProductItemvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderMenusShopProductItem);
/* harmony default export */ var TheHeaderMenusShopProductItemvue_type_script_lang_ts_ = (TheHeaderMenusShopProductItem);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusShopProductItemvue_type_script_lang_ts_ = (TheHeaderMenusShopProductItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue?vue&type=style&index=0&id=17da9ad8&lang=scss&scoped=true&
var TheHeaderMenusShopProductItemvue_type_style_index_0_id_17da9ad8_lang_scss_scoped_true_ = __webpack_require__(5379);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue?vue&type=style&index=0&id=17da9ad8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProductItem.vue



;


/* normalize component */

var TheHeaderMenusShopProductItem_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusShopProductItemvue_type_script_lang_ts_,
  TheHeaderMenusShopProductItemvue_type_template_id_17da9ad8_scoped_true_render,
  TheHeaderMenusShopProductItemvue_type_template_id_17da9ad8_scoped_true_staticRenderFns,
  false,
  null,
  "17da9ad8",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusShopProductItem = (TheHeaderMenusShopProductItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProducts.vue?vue&type=script&lang=ts&


var TheHeaderMenusShopProductsvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TheHeaderMenusShopProducts = class TheHeaderMenusShopProducts extends mixins(shopProducts, userIsCgElite) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "categoryImage", null);
  }

  onChildChanged(val) {
    if (val.length) {
      const {
        children
      } = val[0];
      const hoverImage = children.filter(child => child.title.toLowerCase() === 'hover_image');
      this.categoryImage = hoverImage[0]?.path || null;
    }
  }

};

TheHeaderMenusShopProductsvue_type_script_lang_ts_decorate([Watch('shopProductsMenus')], TheHeaderMenusShopProducts.prototype, "onChildChanged", null);

TheHeaderMenusShopProducts = TheHeaderMenusShopProductsvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    CgElite: icons_CgElite,
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    TheHeaderMenusShopProductItem: desktopMenus_TheHeaderMenusShopProductItem
  }
})], TheHeaderMenusShopProducts);
/* harmony default export */ var TheHeaderMenusShopProductsvue_type_script_lang_ts_ = (TheHeaderMenusShopProducts);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProducts.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusShopProductsvue_type_script_lang_ts_ = (TheHeaderMenusShopProductsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopProducts.vue?vue&type=style&index=0&id=8011836a&lang=scss&scoped=true&
var TheHeaderMenusShopProductsvue_type_style_index_0_id_8011836a_lang_scss_scoped_true_ = __webpack_require__(6319);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProducts.vue?vue&type=style&index=0&id=8011836a&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopProducts.vue



;


/* normalize component */

var TheHeaderMenusShopProducts_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusShopProductsvue_type_script_lang_ts_,
  TheHeaderMenusShopProductsvue_type_template_id_8011836a_scoped_true_render,
  TheHeaderMenusShopProductsvue_type_template_id_8011836a_scoped_true_staticRenderFns,
  false,
  null,
  "8011836a",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusShopProducts = (TheHeaderMenusShopProducts_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopBy.vue?vue&type=template&id=191fd462&scoped=true&
var TheHeaderMenusShopByvue_type_template_id_191fd462_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-header-menus-dropdown',{staticClass:"header-menu-shop-by-dropdown",scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"header-menu-shop-by"},_vm._l((_vm.shopByMenus),function(item,index){return _c('the-header-menus-shop-by-item',{key:index,attrs:{"item":item}})}),1)]},proxy:true}])},[_vm._v(" Shop By ")])}
var TheHeaderMenusShopByvue_type_template_id_191fd462_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopByItem.vue?vue&type=template&id=7e808742&scoped=true&
var TheHeaderMenusShopByItemvue_type_template_id_7e808742_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"category-list"},[_c('li',{staticClass:"category-list__main"},[(_vm.item.path)?_c('a',{attrs:{"href":_vm.item.path},on:{"click":function($event){return _vm.onMainCategoryClick(_vm.item.title)}}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]):[_vm._v(" "+_vm._s(_vm.item.title)+" ")]],2),_vm._l((_vm.itemChildren),function(child,index){return _c('li',{key:index},[_c('a',{staticClass:"category-list__sub",attrs:{"href":child.path},on:{"click":function($event){return _vm.onSubCategoryClick(_vm.item.title, child.title)}}},[_vm._v(" "+_vm._s(child.title)+" ")])])})],2)}
var TheHeaderMenusShopByItemvue_type_template_id_7e808742_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopByItem.vue?vue&type=script&lang=ts&


var TheHeaderMenusShopByItemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}; // prettier-ignore




let TheHeaderMenusShopByItem = class TheHeaderMenusShopByItem extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "item", void 0);
  }

  get itemChildren() {
    return this.item.children ?? [];
  }

  onMainCategoryClick(title) {
    navigationClick({
      itemCategory: 'shop by',
      itemSubCategory: title,
      item: title
    });
  }

  onSubCategoryClick(mainCategory, subCategory) {
    navigationClick({
      itemCategory: 'shop by',
      itemSubCategory: mainCategory,
      item: subCategory
    });
  }

};

TheHeaderMenusShopByItemvue_type_script_lang_ts_decorate([Prop({
  required: true
})], TheHeaderMenusShopByItem.prototype, "item", void 0);

TheHeaderMenusShopByItem = TheHeaderMenusShopByItemvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderMenusShopByItem);
/* harmony default export */ var TheHeaderMenusShopByItemvue_type_script_lang_ts_ = (TheHeaderMenusShopByItem);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopByItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusShopByItemvue_type_script_lang_ts_ = (TheHeaderMenusShopByItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopByItem.vue?vue&type=style&index=0&id=7e808742&lang=scss&scoped=true&
var TheHeaderMenusShopByItemvue_type_style_index_0_id_7e808742_lang_scss_scoped_true_ = __webpack_require__(5015);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopByItem.vue?vue&type=style&index=0&id=7e808742&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopByItem.vue



;


/* normalize component */

var TheHeaderMenusShopByItem_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusShopByItemvue_type_script_lang_ts_,
  TheHeaderMenusShopByItemvue_type_template_id_7e808742_scoped_true_render,
  TheHeaderMenusShopByItemvue_type_template_id_7e808742_scoped_true_staticRenderFns,
  false,
  null,
  "7e808742",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusShopByItem = (TheHeaderMenusShopByItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopBy.vue?vue&type=script&lang=ts&
var TheHeaderMenusShopByvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TheHeaderMenusShopBy = class TheHeaderMenusShopBy extends mixins(shopBy) {};
TheHeaderMenusShopBy = TheHeaderMenusShopByvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    TheHeaderMenusShopByItem: desktopMenus_TheHeaderMenusShopByItem
  }
})], TheHeaderMenusShopBy);
/* harmony default export */ var TheHeaderMenusShopByvue_type_script_lang_ts_ = (TheHeaderMenusShopBy);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopBy.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusShopByvue_type_script_lang_ts_ = (TheHeaderMenusShopByvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusShopBy.vue?vue&type=style&index=0&id=191fd462&lang=scss&scoped=true&
var TheHeaderMenusShopByvue_type_style_index_0_id_191fd462_lang_scss_scoped_true_ = __webpack_require__(797);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopBy.vue?vue&type=style&index=0&id=191fd462&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusShopBy.vue



;


/* normalize component */

var TheHeaderMenusShopBy_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusShopByvue_type_script_lang_ts_,
  TheHeaderMenusShopByvue_type_template_id_191fd462_scoped_true_render,
  TheHeaderMenusShopByvue_type_template_id_191fd462_scoped_true_staticRenderFns,
  false,
  null,
  "191fd462",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusShopBy = (TheHeaderMenusShopBy_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThem.vue?vue&type=template&id=c4968fb6&scoped=true&
var TheHeaderMenusLetThemvue_type_template_id_c4968fb6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-header-menus-dropdown',{staticClass:"header-menu-shop-by-dropdown",scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('the-header-menus-let-them-content')],1)]},proxy:true}])},[_vm._v(" Let Them Choose! ")])}
var TheHeaderMenusLetThemvue_type_template_id_c4968fb6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=template&id=3b4f149e&scoped=true&
var TheHeaderMenusLetThemContentvue_type_template_id_3b4f149e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"let-them-block"},[_c('h2',{staticClass:"let-them-block__headline"},[_vm._v(" Select a collection of gift options, let your recipients choose! ")]),_vm._m(0),_c('div',{staticClass:"let-them-block__main-block"},[_c('ul',_vm._l((_vm.collectionsNav),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.navigateTo(item.url)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navigateTo(item.url)}}},[_c('div',[_c('img',{attrs:{"src":_vm.cdn + item.image,"alt":item.text}}),_c('h3',[_vm._v(_vm._s(item.text))]),_c('span',{domProps:{"innerHTML":_vm._s(item.desc)}})])])}),0),_c('hr'),_c('div',[_c('div',{staticClass:"how-works-block",on:{"click":function($event){return _vm.navigateTo(_vm.storeUrl + '/egift-collections/?show=howWorks')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.navigateTo(_vm.storeUrl + '/egift-collections/?show=howWorks')}}},[_c('h6',[_vm._v("HOW IT WORKS?")]),_c('img',{attrs:{"src":_vm.cdn + '/let_them_video_nav.png',"alt":"how it works"}})])])])])}
var TheHeaderMenusLetThemContentvue_type_template_id_3b4f149e_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"let-them-block__text"},[_c('strong',[_vm._v("Bonus:")]),_vm._v(" You don't need their street address ")])}]


;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=template&id=3b4f149e&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=script&lang=ts&
var TheHeaderMenusLetThemContentvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}; // prettier-ignore




let TheHeaderMenusLetThemContent = class TheHeaderMenusLetThemContent extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  get cdn() {
    return "https://cfstage.corporategift.com";
  }

  get storeUrl() {
    const {
      storeUrl
    } = takeGlobalOptions();
    return storeUrl;
  }

  get collectionsNav() {
    const {
      accountUrl
    } = takeGlobalOptions();
    return [{
      text: 'CURATED COLLECTIONS',
      image: '/current_collections_nav_icon.svg',
      url: `${this.storeUrl}/egift-collections/`,
      desc: '(by occasion)'
    }, {
      text: 'BRANDED COLLECTIONS',
      image: '/branded_collections_nav_icon.svg',
      url: `${this.storeUrl}/egift-collections/?collection_tag=19`,
      desc: 'Send a collection of gift options <br> customized with your logo'
    }, {
      text: 'CREATE YOUR OWN',
      image: '/create_your_own_nav_icon.svg',
      url: `${accountUrl}/my-campaigns/create/name/`,
      desc: 'Choose from thousands of <br> gift options'
    }];
  }

  navigateTo(url) {
    window.location.href = url;
  }

};
TheHeaderMenusLetThemContent = TheHeaderMenusLetThemContentvue_type_script_lang_ts_decorate([vue_class_component_esm], TheHeaderMenusLetThemContent);
/* harmony default export */ var TheHeaderMenusLetThemContentvue_type_script_lang_ts_ = (TheHeaderMenusLetThemContent);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusLetThemContentvue_type_script_lang_ts_ = (TheHeaderMenusLetThemContentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=style&index=0&id=3b4f149e&lang=scss&scoped=true&
var TheHeaderMenusLetThemContentvue_type_style_index_0_id_3b4f149e_lang_scss_scoped_true_ = __webpack_require__(1322);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue?vue&type=style&index=0&id=3b4f149e&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThemContent.vue



;


/* normalize component */

var TheHeaderMenusLetThemContent_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusLetThemContentvue_type_script_lang_ts_,
  TheHeaderMenusLetThemContentvue_type_template_id_3b4f149e_scoped_true_render,
  TheHeaderMenusLetThemContentvue_type_template_id_3b4f149e_scoped_true_staticRenderFns,
  false,
  null,
  "3b4f149e",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusLetThemContent = (TheHeaderMenusLetThemContent_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThem.vue?vue&type=script&lang=ts&
var TheHeaderMenusLetThemvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TheHeaderMenusLetThemvue_type_script_lang_ts_TheHeaderMenusShopBy = class TheHeaderMenusShopBy extends mixins(shopBy) {};
TheHeaderMenusLetThemvue_type_script_lang_ts_TheHeaderMenusShopBy = TheHeaderMenusLetThemvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    TheHeaderMenusLetThemContent: desktopMenus_TheHeaderMenusLetThemContent
  }
})], TheHeaderMenusLetThemvue_type_script_lang_ts_TheHeaderMenusShopBy);
/* harmony default export */ var TheHeaderMenusLetThemvue_type_script_lang_ts_ = (TheHeaderMenusLetThemvue_type_script_lang_ts_TheHeaderMenusShopBy);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusLetThemvue_type_script_lang_ts_ = (TheHeaderMenusLetThemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusLetThem.vue?vue&type=style&index=0&id=c4968fb6&lang=scss&scoped=true&
var TheHeaderMenusLetThemvue_type_style_index_0_id_c4968fb6_lang_scss_scoped_true_ = __webpack_require__(8792);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThem.vue?vue&type=style&index=0&id=c4968fb6&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusLetThem.vue



;


/* normalize component */

var TheHeaderMenusLetThem_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusLetThemvue_type_script_lang_ts_,
  TheHeaderMenusLetThemvue_type_template_id_c4968fb6_scoped_true_render,
  TheHeaderMenusLetThemvue_type_template_id_c4968fb6_scoped_true_staticRenderFns,
  false,
  null,
  "c4968fb6",
  null
  
)

/* harmony default export */ var TheHeaderMenusLetThem = (TheHeaderMenusLetThem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheUserCompanyMenu.vue?vue&type=template&id=5702c6c8&scoped=true&
var TheUserCompanyMenuvue_type_template_id_5702c6c8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-user-company-menu"},[_c('div',{staticClass:"the-user-company-menu__text",attrs:{"tabindex":"0"}},[_vm._v(" Shop "+_vm._s(_vm.companyName)+" ")]),_c('div',{staticClass:"the-user-company-menu__content"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.url}},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)])])}
var TheUserCompanyMenuvue_type_template_id_5702c6c8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheUserCompanyMenu.vue?vue&type=script&lang=ts&


var TheUserCompanyMenuvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TheUserCompanyMenu = class TheUserCompanyMenu extends mixins(companyName) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "items", void 0);
  }

};

TheUserCompanyMenuvue_type_script_lang_ts_decorate([Prop({
  default: () => [],
  type: Array
})], TheUserCompanyMenu.prototype, "items", void 0);

TheUserCompanyMenu = TheUserCompanyMenuvue_type_script_lang_ts_decorate([vue_class_component_esm], TheUserCompanyMenu);
/* harmony default export */ var TheUserCompanyMenuvue_type_script_lang_ts_ = (TheUserCompanyMenu);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheUserCompanyMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheUserCompanyMenuvue_type_script_lang_ts_ = (TheUserCompanyMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheUserCompanyMenu.vue?vue&type=style&index=0&id=5702c6c8&lang=scss&scoped=true&
var TheUserCompanyMenuvue_type_style_index_0_id_5702c6c8_lang_scss_scoped_true_ = __webpack_require__(8624);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheUserCompanyMenu.vue?vue&type=style&index=0&id=5702c6c8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheUserCompanyMenu.vue



;


/* normalize component */

var TheUserCompanyMenu_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheUserCompanyMenuvue_type_script_lang_ts_,
  TheUserCompanyMenuvue_type_template_id_5702c6c8_scoped_true_render,
  TheUserCompanyMenuvue_type_template_id_5702c6c8_scoped_true_staticRenderFns,
  false,
  null,
  "5702c6c8",
  null
  
)

/* harmony default export */ var desktopMenus_TheUserCompanyMenu = (TheUserCompanyMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue?vue&type=template&id=1ba7cacc&scoped=true&
var TheHeaderMenusWhatWeOffervue_type_template_id_1ba7cacc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-header-menus-dropdown',{staticClass:"header-menu-what-we-offer-dropdown",scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"header-menus-what-we-offer__wrapper"},[_c('div',{staticClass:"header-menus-what-we-offer__column"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.shopCustomize,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Shop, customize & ideate")]},proxy:true},{key:"icon",fn:function(){return [_c('shop-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.streamlineGifting,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Streamline gifting")]},proxy:true},{key:"icon",fn:function(){return [_c('streamline-icon')]},proxy:true}])})],1),_c('div',{staticClass:"header-menus-what-we-offer__column"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.enrageRecipient,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Engage recipients")]},proxy:true},{key:"icon",fn:function(){return [_c('engage-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.storeAndManageMerchandise,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Store & manage merchandise")]},proxy:true},{key:"icon",fn:function(){return [_c('store-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.secureData,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Secure data")]},proxy:true},{key:"icon",fn:function(){return [_c('secure-data-icon')]},proxy:true}])})],1),_c('div',{staticClass:"header-menus-what-we-offer__column"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.enterpriseSolutions,"navigationTitle":"What we offer"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Enterprise solutions")]},proxy:true},{key:"icon",fn:function(){return [_c('enterprise-icon')]},proxy:true}])}),_c('div',{staticClass:"header-menus-what-we-offer__latest-article-wrapper"},[_c('latest-article')],1)],1)])]},proxy:true}])},[_vm._v(" What we offer ")])}
var TheHeaderMenusWhatWeOffervue_type_template_id_1ba7cacc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue?vue&type=script&lang=ts&
var TheHeaderMenusWhatWeOffervue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





 // icons







let TheHeaderMenusWhatWeOffer = class TheHeaderMenusWhatWeOffer extends mixins(whatWeOffer) {};
TheHeaderMenusWhatWeOffer = TheHeaderMenusWhatWeOffervue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    WhatWeOfferItem: desktopMenus_WhatWeOfferItem,
    SecureDataIcon: whatWeOffer_SecureDataIcon,
    EnterpriseIcon: whatWeOffer_EnterpriseIcon,
    LatestArticle: desktopMenus_LatestArticle,
    StreamlineIcon: whatWeOffer_StreamlineIcon,
    EngageIcon: whatWeOffer_EngageIcon,
    StoreIcon: StoreIcon,
    ShopIcon: whatWeOffer_ShopIcon
  }
})], TheHeaderMenusWhatWeOffer);
/* harmony default export */ var TheHeaderMenusWhatWeOffervue_type_script_lang_ts_ = (TheHeaderMenusWhatWeOffer);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusWhatWeOffervue_type_script_lang_ts_ = (TheHeaderMenusWhatWeOffervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue?vue&type=style&index=0&id=1ba7cacc&lang=scss&scoped=true&
var TheHeaderMenusWhatWeOffervue_type_style_index_0_id_1ba7cacc_lang_scss_scoped_true_ = __webpack_require__(1201);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue?vue&type=style&index=0&id=1ba7cacc&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusWhatWeOffer.vue



;


/* normalize component */

var TheHeaderMenusWhatWeOffer_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusWhatWeOffervue_type_script_lang_ts_,
  TheHeaderMenusWhatWeOffervue_type_template_id_1ba7cacc_scoped_true_render,
  TheHeaderMenusWhatWeOffervue_type_template_id_1ba7cacc_scoped_true_staticRenderFns,
  false,
  null,
  "1ba7cacc",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusWhatWeOffer = (TheHeaderMenusWhatWeOffer_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusResources.vue?vue&type=template&id=4769c506&scoped=true&
var TheHeaderMenusResourcesvue_type_template_id_4769c506_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-header-menus-dropdown',{staticClass:"header-menu-resources-dropdown",scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"header-menu-resources"},[_c('div',{staticClass:"header-menu-resources__stories-and-articles"},[_c('div',[_c('customer-stories',{attrs:{"maxItems":3}}),_c('div',{staticClass:"header-menu-resources__divider"}),_c('div',{staticClass:"header-menu-resources__articles-column"},[_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.articlesAndInspiration,"navigationTitle":"Resources"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Articles & inspiration")]},proxy:true},{key:"icon",fn:function(){return [_c('articles-and-solution-icon')]},proxy:true}])}),_c('what-we-offer-item',{attrs:{"solutionsItems":_vm.learnSolutions,"navigationTitle":"Resources"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Learn")]},proxy:true},{key:"icon",fn:function(){return [_c('learn-icon')]},proxy:true}])})],1)],1)]),_c('div',{staticClass:"header-menu-resources__latest-article"},[_c('latest-article')],1)])]},proxy:true}])},[_vm._v(" Resources ")])}
var TheHeaderMenusResourcesvue_type_template_id_4769c506_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusResources.vue?vue&type=script&lang=ts&
var TheHeaderMenusResourcesvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






 // icons



let TheHeaderMenusResources = class TheHeaderMenusResources extends mixins(resources) {};
TheHeaderMenusResources = TheHeaderMenusResourcesvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    ArticlesAndSolutionIcon: whatWeOffer_ArticlesAndSolutionIcon,
    TheHeaderMenusDropdown: desktopMenus_TheHeaderMenusDropdown,
    CustomerStories: desktopMenus_CustomerStories,
    WhatWeOfferItem: desktopMenus_WhatWeOfferItem,
    LatestArticle: desktopMenus_LatestArticle,
    LearnIcon: whatWeOffer_LearnIcon
  }
})], TheHeaderMenusResources);
/* harmony default export */ var TheHeaderMenusResourcesvue_type_script_lang_ts_ = (TheHeaderMenusResources);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusResources.vue?vue&type=script&lang=ts&
 /* harmony default export */ var desktopMenus_TheHeaderMenusResourcesvue_type_script_lang_ts_ = (TheHeaderMenusResourcesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/desktopMenus/TheHeaderMenusResources.vue?vue&type=style&index=0&id=4769c506&lang=scss&scoped=true&
var TheHeaderMenusResourcesvue_type_style_index_0_id_4769c506_lang_scss_scoped_true_ = __webpack_require__(1590);
;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusResources.vue?vue&type=style&index=0&id=4769c506&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/desktopMenus/TheHeaderMenusResources.vue



;


/* normalize component */

var TheHeaderMenusResources_component = componentNormalizer_normalizeComponent(
  desktopMenus_TheHeaderMenusResourcesvue_type_script_lang_ts_,
  TheHeaderMenusResourcesvue_type_template_id_4769c506_scoped_true_render,
  TheHeaderMenusResourcesvue_type_template_id_4769c506_scoped_true_staticRenderFns,
  false,
  null,
  "4769c506",
  null
  
)

/* harmony default export */ var desktopMenus_TheHeaderMenusResources = (TheHeaderMenusResources_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Holiday.vue?vue&type=template&id=ba6c2dda&
var Holidayvue_type_template_id_ba6c2dda_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 28","fill":"none","width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.0411 14.5718L17.9999 17.1602C14.7818 18.9792 10.5145 19.4689 6.73633 18.6993L16.0409\n      14.5719L16.0411 14.5718Z","fill":"#219358"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.08594 6.94652L10.1641 2.81909L11.3533 4.42801L7.08594 6.94652Z","fill":"#219358"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.66693 9.18514L6.87687 8.90538C6.52712 8.76542 6.2472 8.62561 5.89746 8.48566L6.1074\n      8.2059L11.774 4.98779L14.3625 8.48567C14.0827 8.62563 13.7328 8.76543 13.453 8.90538L16.1115\n      12.4732L6.66709 9.18516L6.66693 9.18514ZM10.9345 8.34571C11.3542 8.34571 11.7041 8.69546\n      11.7041 9.11532C11.7041 9.53503 11.3544 9.88493 10.9345 9.88493C10.5148 9.88493 10.1649\n      9.53518 10.1649 9.11532C10.1649 8.69561 10.5147 8.34571 10.9345 8.34571Z","fill":"#219358"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.2015 13.3826L15.6911 14.0123L5.68719 18.4894C4.42786 18.1397 3.30866 17.7198 2.3291\n      17.1602L5.05752 13.3825C4.70778 13.2425 4.28792 13.0327 3.93817 12.8228L6.24688\n      9.74463L15.9012 13.1027C15.6214 13.1727 15.4115 13.3127 15.2015 13.3825L15.2015\n      13.3826ZM11.9833 13.3826C12.543 13.3826 12.9628 13.8023 12.9628 14.2921C12.9628 14.7818\n      12.543 15.2015 11.9833 15.2015C11.4937 15.2015 11.0739 14.7818 11.0739 14.2921C11.0739\n      13.8024 11.4936 13.3826 11.9833 13.3826ZM8.97515 11.6336C9.18509 11.6336 9.39487 11.7736\n      9.39487 12.0533C9.39487 12.2633 9.18493 12.4731 8.97515 12.4731C8.69539 12.4731 8.48547\n      12.2631 8.48547 12.0533C8.48547 11.7736 8.6954 11.6336 8.97515 11.6336Z","fill":"#219358"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.1233 19.2593V20.9383C12.1233 21.568 11.6336 21.9877 11.0739 21.9877H9.18512C8.62543\n      21.9877 8.13574 21.568 8.13574 20.9383V19.2593C9.46489 19.3992 10.7942 19.3992 12.1234\n      19.2593H12.1233Z","fill":"#219358"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 7.5C4 7.77622 3.7761 8 3.5 8C3.22378 8 3 7.77623 3 7.5C3 7.22391 3.22377 7 3.5 7C3.77609\n      7 4 7.2239 4 7.5Z","fill":"#9E040A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 10.5001C4 10.7761 3.77607 11 3.5 11C3.22375 11 3 10.7761 3 10.5001C3 10.2239 3.22376 10\n      3.5 10C3.77608 10 4 10.2239 4 10.5001Z","fill":"#9E040A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 13.9999C2 14.5522 1.55236 15 1.0001 15C0.447835 15 0 14.5522 0 13.9999C0 13.4476 0.44783\n      13 1.0001 13C1.55236 13 2 13.4476 2 13.9999Z","fill":"#9E040A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 5.5C17 5.77608 16.7762 6 16.5 6C16.2239 6 16 5.7761 16 5.5C16 5.2239 16.2239 5 16.5\n      5C16.7762 5 17 5.2239 17 5.5Z","fill":"#9E040A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 9.5C17 9.77625 16.7761 10 16.4999 10C16.2239 10 16 9.77624 16 9.5C16 9.22392 16.2239 9\n      16.4999 9C16.7761 9 17 9.22393 17 9.5Z","fill":"#9E040A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.1636 0L10.4433 0.909436H11.4227L10.6533 1.46913L10.9331 2.30871L10.1636 1.74901L9.39399\n      2.30871L9.6739 1.46913L8.9043 0.909436H9.8837L10.1636 0Z","fill":"#9E040A"}})])}
var Holidayvue_type_template_id_ba6c2dda_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/icons/Holiday.vue?vue&type=script&lang=ts&


var Holidayvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let Holiday = class Holiday extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "height", void 0);
  }

};

Holidayvue_type_script_lang_ts_decorate([Prop({
  default: 18
})], Holiday.prototype, "width", void 0);

Holidayvue_type_script_lang_ts_decorate([Prop({
  default: 28
})], Holiday.prototype, "height", void 0);

Holiday = Holidayvue_type_script_lang_ts_decorate([vue_class_component_esm], Holiday);
/* harmony default export */ var Holidayvue_type_script_lang_ts_ = (Holiday);
;// CONCATENATED MODULE: ./src/components/icons/Holiday.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Holidayvue_type_script_lang_ts_ = (Holidayvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/icons/Holiday.vue





/* normalize component */
;
var Holiday_component = componentNormalizer_normalizeComponent(
  icons_Holidayvue_type_script_lang_ts_,
  Holidayvue_type_template_id_ba6c2dda_render,
  Holidayvue_type_template_id_ba6c2dda_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Holiday = (Holiday_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMenus.vue?vue&type=script&lang=ts&
var TheHeaderMenusvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















let TheHeaderMenus = class TheHeaderMenus extends mixins(showShopHolidaysLink, userDeviceWidth, userCompanyMenu, userIsCgElite, subdomainInfo) {
  get hideDefaultDropdowns() {
    return this.$store.state.header.headerData?.menus?.hideMenu ?? false;
  }

  get hideSearch() {
    return this.$store.state.header.headerData?.menus?.hideSearch ?? false;
  }

  get hideWhatWeOfferMenus() {
    const {
      userIsCgElite,
      hideDefaultDropdowns,
      hasExternalDomain
    } = this;
    return userIsCgElite || hideDefaultDropdowns || hasExternalDomain;
  }

};
TheHeaderMenus = TheHeaderMenusvue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    HolidayIcon: icons_Holiday,
    HeaderSearch: components_HeaderSearch,
    TheUserCompanyMenu: desktopMenus_TheUserCompanyMenu,
    TheHeaderMenusLink: desktopMenus_TheHeaderMenusLink,
    TheHeaderMenusShopBy: desktopMenus_TheHeaderMenusShopBy,
    TheHeaderMenusLetThem: TheHeaderMenusLetThem,
    TheHeaderMenusResources: desktopMenus_TheHeaderMenusResources,
    TheHeaderMenusWhatWeOffer: desktopMenus_TheHeaderMenusWhatWeOffer,
    TheHeaderMenusShopProducts: desktopMenus_TheHeaderMenusShopProducts
  }
})], TheHeaderMenus);
/* harmony default export */ var TheHeaderMenusvue_type_script_lang_ts_ = (TheHeaderMenus);
;// CONCATENATED MODULE: ./src/components/TheHeaderMenus.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeaderMenusvue_type_script_lang_ts_ = (TheHeaderMenusvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeaderMenus.vue?vue&type=style&index=0&id=32e54ce2&lang=scss&scoped=true&
var TheHeaderMenusvue_type_style_index_0_id_32e54ce2_lang_scss_scoped_true_ = __webpack_require__(473);
;// CONCATENATED MODULE: ./src/components/TheHeaderMenus.vue?vue&type=style&index=0&id=32e54ce2&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeaderMenus.vue



;


/* normalize component */

var TheHeaderMenus_component = componentNormalizer_normalizeComponent(
  components_TheHeaderMenusvue_type_script_lang_ts_,
  TheHeaderMenusvue_type_template_id_32e54ce2_scoped_true_render,
  TheHeaderMenusvue_type_template_id_32e54ce2_scoped_true_staticRenderFns,
  false,
  null,
  "32e54ce2",
  null
  
)

/* harmony default export */ var components_TheHeaderMenus = (TheHeaderMenus_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41[0].rules[0].use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeader.vue?vue&type=script&lang=ts&


var TheHeadervue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}; // prettier-ignore











let TheHeader = class TheHeader extends mixins(userDeviceWidth, mixins_userIsInAccountModule, subdomainInfo) {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "left", void 0);

    _defineProperty(this, "fixed", void 0);

    _defineProperty(this, "hideOnScroll", void 0);

    _defineProperty(this, "navigation", void 0);

    _defineProperty(this, "domainLogo", void 0);

    _defineProperty(this, "scrollThreshold", 300);

    _defineProperty(this, "previousScroll", 0);

    _defineProperty(this, "currentScroll", 0);

    _defineProperty(this, "isScrollingUp", false);

    _defineProperty(this, "isActive", true);

    _defineProperty(this, "currentThreshold", 0);

    _defineProperty(this, "savedScroll", 0);

    _defineProperty(this, "headerHeight", 188);
  }

  // showCart = false;
  get showCart() {
    const value = this.$store.state.header.showCart || false;
    return value;
  }

  set showCart(val) {
    this.$store.commit('header/setShowCart', val);
  }

  get hideHeaderDropdowns() {
    return this.$store.state.header.hideHeaderDropdowns;
  }

  get hideHeaderTopInfo() {
    // prettier-ignore
    return this.$store.state?.header?.hideHeaderTopInfo || this.$store.state?.header?.headerData?.hideTopStrip || false;
  }

  get showHeaderMenus() {
    const {
      userUsingPhone,
      hideHeaderDropdowns
    } = this;
    if (hideHeaderDropdowns) return false;
    return !userUsingPhone;
  }

  get hideHeader() {
    const {
      hideOnScroll,
      isActive,
      userUsingPhone
    } = this;

    if (userUsingPhone || !hideOnScroll) {
      return false;
    }

    return !isActive;
  }

  get userHasFreeTrial() {
    const freeTrailData = this.$store.state?.header?.headerData?.eliteTrial;
    return freeTrailData !== null && freeTrailData.daysLeft > 0;
  }

  get currentRouteName() {
    // @ts-ignore
    return this?.$route?.name ?? null;
  }

  onIsScrollingUp() {
    this.savedScroll = this.savedScroll || this.currentScroll;
  }

  onIsActive() {
    this.savedScroll = 0;
  }

  onShowCart(val) {
    this.$emit('update:showCart', val);
  }

  onRouteChange() {
    this.isActive = true;
    this.isScrollingUp = true;
    this.previousScroll = 0;
    this.currentScroll = 0;
    this.currentThreshold = 0;
    this.savedScroll = 0;
  }

  onHideHeader(val) {
    this.$emit('update:hideHeader', val);
  }

  created() {
    const {
      navigation,
      hasExternalDomain
    } = this;

    if (navigation) {
      this.$store.commit('header/setCmsHeader', navigation?.headerData?.data?.attributes);
      this.$store.dispatch('header/setNavigationCustomerStories', navigation?.customerStories);
      this.$store.dispatch('header/setNavigationWhatWeOffer', navigation?.whatWeOffer);
      this.$store.dispatch('header/setNavigationResources', navigation?.resources);
      this.$store.dispatch('header/setNavigationShopBy', navigation?.shopBy);
      this.$store.dispatch('header/setNavigationShopProducts', navigation?.shopProducts);
    } else {
      this.$store.dispatch('header/loadCMSNavigationData');
    }

    this.$store.dispatch('headerAuth/getToken').then(token => {
      const cartToken = localStorage.getItem('cartToken');

      if (token || cartToken || hasExternalDomain) {
        this.$store.dispatch('header/loadHeader');
      }
    });
  }

  mounted() {
    if (typeof window !== 'undefined' && this.hideOnScroll) {
      window.addEventListener('scroll', this.onScroll, {
        passive: true
      });
    }
  }

  beforeDestroy() {
    if (this.hideOnScroll) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll() {
    if (!this.hideOnScroll) {
      return;
    }

    this.previousScroll = this.currentScroll;
    this.currentScroll = window.pageYOffset;
    this.isScrollingUp = this.currentScroll < this.previousScroll;
    this.currentThreshold = Math.abs(this.currentScroll - this.scrollThreshold);
    this.headerHeight = this.$el.querySelector('header')?.offsetHeight || 188;
    this.$nextTick(() => {
      if (Math.abs(this.currentScroll - this.savedScroll) > this.scrollThreshold) {
        this.thresholdMet();
      }
    });
  }

  thresholdMet() {
    if (this.hideOnScroll) {
      this.isActive = this.isScrollingUp || this.currentScroll < this.scrollThreshold;
    }

    if (this.currentThreshold < this.scrollThreshold) {
      return;
    }

    this.savedScroll = this.currentScroll;
  }

};

TheHeadervue_type_script_lang_ts_decorate([Prop({
  default: 0
})], TheHeader.prototype, "left", void 0);

TheHeadervue_type_script_lang_ts_decorate([Prop({
  default: false
})], TheHeader.prototype, "fixed", void 0);

TheHeadervue_type_script_lang_ts_decorate([Prop({
  default: true
})], TheHeader.prototype, "hideOnScroll", void 0);

TheHeadervue_type_script_lang_ts_decorate([Prop({
  required: false
})], TheHeader.prototype, "navigation", void 0);

TheHeadervue_type_script_lang_ts_decorate([Prop({
  required: false,
  default: null
})], TheHeader.prototype, "domainLogo", void 0);

TheHeadervue_type_script_lang_ts_decorate([Watch('isScrollingUp')], TheHeader.prototype, "onIsScrollingUp", null);

TheHeadervue_type_script_lang_ts_decorate([Watch('isActive')], TheHeader.prototype, "onIsActive", null);

TheHeadervue_type_script_lang_ts_decorate([Watch('showCart')], TheHeader.prototype, "onShowCart", null);

TheHeadervue_type_script_lang_ts_decorate([Watch('currentRouteName')], TheHeader.prototype, "onRouteChange", null);

TheHeadervue_type_script_lang_ts_decorate([Watch('hideHeader')], TheHeader.prototype, "onHideHeader", null);

TheHeader = TheHeadervue_type_script_lang_ts_decorate([vue_class_component_esm({
  components: {
    TheCartPanel: cart_TheCartPanel,
    TheHeaderInfo: components_TheHeaderInfo,
    TheHeaderMenus: components_TheHeaderMenus,
    TheHeaderUserArea: components_TheHeaderUserArea,
    HeaderFreeTrailStrip: components_TheHeaderFreeTrailStrip
  }
})], TheHeader);
/* harmony default export */ var TheHeadervue_type_script_lang_ts_ = (TheHeader);
;// CONCATENATED MODULE: ./src/components/TheHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_TheHeadervue_type_script_lang_ts_ = (TheHeadervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeader.vue?vue&type=style&index=0&lang=scss&
var TheHeadervue_type_style_index_0_lang_scss_ = __webpack_require__(4747);
;// CONCATENATED MODULE: ./src/components/TheHeader.vue?vue&type=style&index=0&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22[0].rules[0].use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22[0].rules[0].use[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TheHeader.vue?vue&type=style&index=1&id=46832b98&lang=scss&scoped=true&
var TheHeadervue_type_style_index_1_id_46832b98_lang_scss_scoped_true_ = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/TheHeader.vue?vue&type=style&index=1&id=46832b98&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TheHeader.vue



;



/* normalize component */

var TheHeader_component = componentNormalizer_normalizeComponent(
  components_TheHeadervue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "46832b98",
  null
  
)

/* harmony default export */ var components_TheHeader = (TheHeader_component.exports);
;// CONCATENATED MODULE: ./src/cg-header.ts





const CgHeader = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  install(Vue, {
    store,
    headerIndex = 6,
    ...rest
  }) {
    Vue.prototype.$globalOptions = rest;
    Vue.use(v_tooltip_esm, {
      disposeTimeout: 500,
      popover: {
        defaultBaseClass: 'header-tooltip header-popover',
        defaultInnerClass: 'header-tooltip-inner header-popover-inner'
      }
    });
    const style = document.createElement('style');
    style.textContent = `* { --header-z-index: ${headerIndex}; }`;
    document.head.appendChild(style);

    if (store) {
      store.registerModule('headerAuth', AuthModule);
      store.registerModule('header', HeaderModule);
    } else {
      throw new Error('Please provide vuex store');
    }

    Vue.component('CgHeader', components_TheHeader);
  }

};
/* harmony default export */ var cg_header = (CgHeader);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (cg_header);


}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=cg-header.common.js.map